
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired34b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired34b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9DGpR", function(module, exports) {

$parcel$export(module.exports, "Map", function () { return Map; });
$parcel$export(module.exports, "List", function () { return List; });
$parcel$export(module.exports, "Set", function () { return Set; });
/**
 * @license
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';
/**
 * True if `maybeIndexed` is a Collection.Indexed, or any of its subclasses.
 *
 * ```js
 * import { isIndexed, Map, List, Stack, Set } from 'immutable';
 *
 * isIndexed([]); // false
 * isIndexed({}); // false
 * isIndexed(Map()); // false
 * isIndexed(List()); // true
 * isIndexed(Stack()); // true
 * isIndexed(Set()); // false
 * ```
 */ function isIndexed(maybeIndexed) {
    return Boolean(maybeIndexed && // @ts-expect-error: maybeIndexed is typed as `{}`, need to change in 6.0 to `maybeIndexed && typeof maybeIndexed === 'object' && IS_INDEXED_SYMBOL in maybeIndexed`
    maybeIndexed[IS_INDEXED_SYMBOL]);
}
var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';
/**
 * True if `maybeKeyed` is a Collection.Keyed, or any of its subclasses.
 *
 * ```js
 * import { isKeyed, Map, List, Stack } from 'immutable';
 *
 * isKeyed([]); // false
 * isKeyed({}); // false
 * isKeyed(Map()); // true
 * isKeyed(List()); // false
 * isKeyed(Stack()); // false
 * ```
 */ function isKeyed(maybeKeyed) {
    return Boolean(maybeKeyed && // @ts-expect-error: maybeKeyed is typed as `{}`, need to change in 6.0 to `maybeKeyed && typeof maybeKeyed === 'object' && IS_KEYED_SYMBOL in maybeKeyed`
    maybeKeyed[IS_KEYED_SYMBOL]);
}
/**
 * True if `maybeAssociative` is either a Keyed or Indexed Collection.
 *
 * ```js
 * import { isAssociative, Map, List, Stack, Set } from 'immutable';
 *
 * isAssociative([]); // false
 * isAssociative({}); // false
 * isAssociative(Map()); // true
 * isAssociative(List()); // true
 * isAssociative(Stack()); // true
 * isAssociative(Set()); // false
 * ```
 */ function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
// Note: value is unchanged to not break immutable-devtools.
var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';
/**
 * True if `maybeCollection` is a Collection, or any of its subclasses.
 *
 * ```js
 * import { isCollection, Map, List, Stack } from 'immutable';
 *
 * isCollection([]); // false
 * isCollection({}); // false
 * isCollection(Map()); // true
 * isCollection(List()); // true
 * isCollection(Stack()); // true
 * ```
 */ function isCollection(maybeCollection) {
    return Boolean(maybeCollection && // @ts-expect-error: maybeCollection is typed as `{}`, need to change in 6.0 to `maybeCollection && typeof maybeCollection === 'object' && IS_COLLECTION_SYMBOL in maybeCollection`
    maybeCollection[IS_COLLECTION_SYMBOL]);
}
var Collection = function Collection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
// TODO Symbol is widely available in modern JavaScript environments, clean this
var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
// @ts-expect-error: properties are not supported in buble
var Iterator = function Iterator(next) {
    // @ts-expect-error: properties are not supported in buble
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return '[Iterator]';
};
// @ts-expect-error: static properties are not supported in buble
Iterator.KEYS = ITERATE_KEYS;
// @ts-expect-error: static properties are not supported in buble
Iterator.VALUES = ITERATE_VALUES;
// @ts-expect-error: static properties are not supported in buble
Iterator.ENTRIES = ITERATE_ENTRIES;
// @ts-expect-error: properties are not supported in buble
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
// @ts-expect-error don't know how to type this
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === ITERATE_KEYS ? k : type === ITERATE_VALUES ? v : [
        k,
        v
    ];
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        // @ts-expect-error ensure value is not undefined
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return !!(maybeIterator && // @ts-expect-error: maybeIterator is typed as `{}`
    typeof maybeIterator.next === 'function');
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && // @ts-expect-error: maybeIterator is typed as `{}`
    (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || // @ts-expect-error: maybeIterator is typed as `{}`
    iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') return iteratorFn;
}
function isEntriesIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    // @ts-expect-error: maybeIterator is typed as `{}`
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function isKeysIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    // @ts-expect-error: maybeIterator is typed as `{}`
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
// Used for setting prototype methods that IE8 chokes on.
var DELETE = 'delete';
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
    return {
        value: false
    };
}
function SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    // @ts-expect-error size should exists on Collection
    if (iter.size === undefined) // @ts-expect-error size should exists on Collection, __iterate does exist on Collection
    iter.size = iter.__iterate(returnTrue);
    // @ts-expect-error size should exists on Collection
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';
/**
 * True if `maybeRecord` is a Record.
 */ function isRecord(maybeRecord) {
    return Boolean(maybeRecord && // @ts-expect-error: maybeRecord is typed as `{}`, need to change in 6.0 to `maybeRecord && typeof maybeRecord === 'object' && IS_RECORD_SYMBOL in maybeRecord`
    maybeRecord[IS_RECORD_SYMBOL]);
}
/**
 * True if `maybeImmutable` is an Immutable Collection or Record.
 *
 * Note: Still returns true even if the collections is within a `withMutations()`.
 *
 * ```js
 * import { isImmutable, Map, List, Stack } from 'immutable';
 * isImmutable([]); // false
 * isImmutable({}); // false
 * isImmutable(Map()); // true
 * isImmutable(List()); // true
 * isImmutable(Stack()); // true
 * isImmutable(Map().asMutable()); // true
 * ```
 */ function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';
function isOrdered(maybeOrdered) {
    return Boolean(maybeOrdered && // @ts-expect-error: maybeOrdered is typed as `{}`, need to change in 6.0 to `maybeOrdered && typeof maybeOrdered === 'object' && IS_ORDERED_SYMBOL in maybeOrdered`
    maybeOrdered[IS_ORDERED_SYMBOL]);
}
var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';
/**
 * True if `maybeSeq` is a Seq.
 */ function isSeq(maybeSeq) {
    return Boolean(maybeSeq && // @ts-expect-error: maybeSeq is typed as `{}`, need to change in 6.0 to `maybeSeq && typeof maybeSeq === 'object' && MAYBE_SEQ_SYMBOL in maybeSeq`
    maybeSeq[IS_SEQ_SYMBOL]);
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    if (Array.isArray(value) || typeof value === 'string') return true;
    // @ts-expect-error "Type 'unknown' is not assignable to type 'boolean'" : convert to Boolean
    return value && typeof value === 'object' && // @ts-expect-error check that `'length' in value &&`
    Number.isInteger(value.length) && // @ts-expect-error check that `'length' in value &&`
    value.length >= 0 && // @ts-expect-error check that `'length' in value &&`
    (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    // @ts-expect-error check that `'length' in value &&`
    value.hasOwnProperty(value.length - 1));
}
var Seq = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString('Seq [', ']');
    };
    return IndexedSeq;
}(Seq);
var SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
Seq.prototype[IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
var CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
// # pragma Helper functions
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of [k, v] entries, or keyed object: ' + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError('Expected Array or collection object of values: ' + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return isEntriesIterable(value) ? seq.fromEntrySeq() : isKeysIterable(value) ? seq.toSetSeq() : seq;
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of values, or keyed object: ' + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
function asImmutable() {
    return this.__ensureOwner();
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
// TODO remove in v6 as Math.imul is widely available now: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var defaultValueOf = Object.prototype.valueOf;
function hash(o) {
    // eslint-disable-next-line eqeqeq
    if (o == null) return hashNullish(o);
    // @ts-expect-error don't care about object beeing typed as `{}` here
    if (typeof o.hashCode === 'function') // Drop any high bits from accidentally long hash codes.
    // @ts-expect-error don't care about object beeing typed as `{}` here
    return smi(o.hashCode(o));
    var v = valueOf(o);
    // eslint-disable-next-line eqeqeq
    if (v == null) return hashNullish(v);
    switch(typeof v){
        case 'boolean':
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case 'number':
            return hashNumber(v);
        case 'string':
            return v.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(v) : hashString(v);
        case 'object':
        case 'function':
            return hashJSObj(v);
        case 'symbol':
            return hashSymbol(v);
        default:
            if (typeof v.toString === 'function') return hashString(v.toString());
            throw new Error('Value type ' + typeof v + ' cannot be hashed.');
    }
}
function hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return smi(hash);
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
// Per-process seed for the secondary collision hash. Never exposed nor
// serialized, so the public `hash()` stays deterministic. An odd base in
// [3, 2^20) keeps `base * h` exact as a double (no `Math.imul`).
var COLLISION_HASH_BASE = (Math.random() * 0x100000 | 1) % 0x100000 || 0x9e37;
// Secondary hash to index entries within a `HashCollisionNode`, where every key
// shares the same primary `hash()`. Using a different, seeded base scatters
// crafted collision families (e.g. "Aa"/"BB", which only collide under base 31)
// that an attacker cannot precompute without the seed. It only narrows
// candidates — `is()` still decides equality — so non-string keys can safely
// fall back to the (here constant) primary hash and a linear scan.
function hashCollisionKey(key) {
    if (typeof key !== 'string') return hash(key);
    var hashed = 0;
    for(var ii = 0; ii < key.length; ii++)hashed = COLLISION_HASH_BASE * hashed + key.charCodeAt(ii) | 0;
    return hashed;
}
function hashSymbol(sym) {
    var hashed = symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = nextHash();
    symbolMap[sym] = hashed;
    return hashed;
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        // @ts-expect-error weakMap is defined
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    // @ts-expect-error used for old code, will be removed
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        // @ts-expect-error used for old code, will be removed
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = nextHash();
    if (usingWeakMap) // @ts-expect-error weakMap is defined
    weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, // eslint-disable-next-line prefer-rest-params
            arguments);
        };
        // @ts-expect-error used for old code, will be removed
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    // @ts-expect-error used for old code, will be removed
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    // @ts-expect-error used for old code, will be removed
    obj[UID_HASH_KEY] = hashed;
    else throw new Error('Unable to set a non-enumerable property on object.');
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
// TODO remove this as widely available https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, '@', {});
        return true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
// TODO remove this method as only used if `canDefineProperty` is false
function getIENodeHash(node) {
    // @ts-expect-error don't care
    if (node && node.nodeType > 0) // @ts-expect-error don't care
    switch(node.nodeType){
        case 1:
            // @ts-expect-error don't care
            return node.uniqueID;
        case 9:
            // @ts-expect-error don't care
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function valueOf(obj) {
    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function' ? obj.valueOf(obj) : obj;
}
function nextHash() {
    var nextHash = ++_objHashUID;
    if (_objHashUID & 0x40000000) _objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
// TODO using WeakMap should be true everywhere now that WeakMap is widely supported: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakMap
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var symbolMap = Object.create(null);
var _objHashUID = 0;
// TODO remove string as Symbol is now widely supported: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol
var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
var ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, // `__iterator` is an arrow function, so `this` is not the reversed
            // sequence here — read `reversedSequence.size` explicitly.
            useKeys ? entry[0] : reverse ? reversedSequence.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    }).asImmutable();
}
function partitionFactory(collection, predicate, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    // begin or end can not be resolved if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (typeof originalSize === 'undefined' && (begin < 0 || end < 0)) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
var ConcatSeq = /*@__PURE__*/ function(Seq) {
    function ConcatSeq(iterables) {
        this._wrappedIterables = iterables.flatMap(function(iterable) {
            if (iterable._wrappedIterables) return iterable._wrappedIterables;
            return [
                iterable
            ];
        });
        this.size = this._wrappedIterables.reduce(function(sum, iterable) {
            if (sum !== undefined) {
                var size = iterable.size;
                if (size !== undefined) return sum + size;
            }
        }, 0);
        this[IS_KEYED_SYMBOL] = this._wrappedIterables[0][IS_KEYED_SYMBOL];
        this[IS_INDEXED_SYMBOL] = this._wrappedIterables[0][IS_INDEXED_SYMBOL];
        this[IS_ORDERED_SYMBOL] = this._wrappedIterables[0][IS_ORDERED_SYMBOL];
    }
    if (Seq) ConcatSeq.__proto__ = Seq;
    ConcatSeq.prototype = Object.create(Seq && Seq.prototype);
    ConcatSeq.prototype.constructor = ConcatSeq;
    ConcatSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (this._wrappedIterables.length === 0) return;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterableIndex = 0;
        var useKeys = isKeyed(this);
        var iteratorType = useKeys ? ITERATE_ENTRIES : ITERATE_VALUES;
        var currentIterator = this._wrappedIterables[iterableIndex].__iterator(iteratorType, reverse);
        var keepGoing = true;
        var index = 0;
        while(keepGoing){
            var next = currentIterator.next();
            while(next.done){
                iterableIndex++;
                if (iterableIndex === this._wrappedIterables.length) return index;
                currentIterator = this._wrappedIterables[iterableIndex].__iterator(iteratorType, reverse);
                next = currentIterator.next();
            }
            var fnResult = useKeys ? fn(next.value[1], next.value[0], this) : fn(next.value, index, this);
            keepGoing = fnResult !== false;
            index++;
        }
        return index;
    };
    ConcatSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        var this$1$1 = this;
        if (this._wrappedIterables.length === 0) return new Iterator(iteratorDone);
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterableIndex = 0;
        var currentIterator = this._wrappedIterables[iterableIndex].__iterator(type, reverse);
        return new Iterator(function() {
            var next = currentIterator.next();
            while(next.done){
                iterableIndex++;
                if (iterableIndex === this$1$1._wrappedIterables.length) return next;
                currentIterator = this$1$1._wrappedIterables[iterableIndex].__iterator(type, reverse);
                next = currentIterator.next();
            }
            return next;
        });
    };
    return ConcatSeq;
}(Seq);
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    return new ConcatSeq(iters);
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
/**
 * True if `maybeValue` is a JavaScript Object which has *both* `equals()`
 * and `hashCode()` methods.
 *
 * Any two instances of *value objects* can be compared for value equality with
 * `Immutable.is()` and can be used as keys in a `Map` or members in a `Set`.
 */ function isValueObject(maybeValue) {
    return Boolean(maybeValue && // @ts-expect-error: maybeValue is typed as `{}`
    typeof maybeValue.equals === 'function' && // @ts-expect-error: maybeValue is typed as `{}`
    typeof maybeValue.hashCode === 'function');
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn(// @ts-expect-error Index signature for type string is missing in type V[]
    collection, [
        key
    ], notSetValue, updater);
}
function merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== 'function') throw new TypeError('Invalid merger function: ' + merger);
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return isRecord(collection) ? collection // Record is empty and will not be updated: return the same instance
     : collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
var toString = Object.prototype.toString;
function isPlainObject(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || typeof value !== 'object' || toString.call(value) !== '[object Object]') return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return typeof value === 'object' && (isImmutable(value) || Array.isArray(value) || isPlainObject(value));
}
function isProtoKey(key) {
    return typeof key === 'string' && (key === '__proto__' || key === 'constructor');
}
// http://jsperf.com/copy-array-inline
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)// @ts-expect-error We may want to guard for undefined values with `if (arr[ii + offset] !== undefined`, but ths should not happen by design
    newArr[ii] = arr[ii + offset];
    return newArr;
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from){
        if (isProtoKey(key)) continue;
        if (hasOwnProperty.call(from, key)) to[key] = from[key];
    }
    return to;
}
function merge(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot merge into non-data-structure value: ' + collection);
    if (isImmutable(collection)) return typeof merger === 'function' && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        if (isProtoKey(key)) return;
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) && areMergeable(oldValue, newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = Seq(oldDataStructure);
    var newSeq = Seq(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return isIndexed(oldSeq) === isIndexed(newSeq) && isKeyed(oldSeq) === isKeyed(newSeq);
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
/**
 * Returns a copy of the collection with the value at the key path set to the
 * provided value.
 *
 * A functional alternative to `collection.setIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function setIn$1(collection, keyPath, value) {
    return updateIn(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn$1(keyPath, notSetValue, updater) {
    return updateIn(this, keyPath, notSetValue, updater);
}
function wasAltered() {
    return this.__altered;
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';
/**
 * True if `maybeMap` is a Map.
 *
 * Also true for OrderedMaps.
 */ function isMap(maybeMap) {
    return Boolean(maybeMap && // @ts-expect-error: maybeMap is typed as `{}`, need to change in 6.0 to `maybeMap && typeof maybeMap === 'object' && IS_MAP_SYMBOL in maybeMap`
    maybeMap[IS_MAP_SYMBOL]);
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
}
var Map = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.prototype.toString = function toString() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
Map.isMap = isMap;
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn$1;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
/**
 * Trie leaf gathering entries whose keys all share the same 32-bit `hash()`.
 * The trie routes by hash, so colliding keys cannot be separated and land here
 * in a flat `entries` array, disambiguated by `is()`.
 *
 * To guard against hash-flooding DoS (CWE-407), large buckets build a secondary
 * index keyed by a per-process seeded hash (`hashCollisionKey`). `is()` still
 * decides equality, so the index can only ever narrow candidates, never lose a key.
 */ var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
    // Lazy `{ [secondaryHash]: number[] }`, built only past
    // MIN_HASH_COLLISION_INDEX_SIZE so small buckets keep their linear path.
    this._index = undefined;
};
// Returns the position of `key` in `this.entries`, or -1. Uses the secondary
// index when present; builds it only when `buildIndex` is true (reads and
// transient inserts, where the node is reused so the O(n) build amortizes).
// Persistent inserts already pay an O(n) copy, so a throwaway index is skipped.
HashCollisionNode.prototype._positionOf = function _positionOf(key, buildIndex) {
    var entries = this.entries;
    var index = this._index;
    if (index === undefined && buildIndex && entries.length >= MIN_HASH_COLLISION_INDEX_SIZE) index = this._buildIndex();
    if (index !== undefined) {
        var positions = index[hashCollisionKey(key)];
        if (positions !== undefined) for(var jj = 0; jj < positions.length; jj++){
            var ii = positions[jj];
            if (is(key, entries[ii][0])) return ii;
        }
        return -1;
    }
    for(var ii$1 = 0, len = entries.length; ii$1 < len; ii$1++){
        if (is(key, entries[ii$1][0])) return ii$1;
    }
    return -1;
};
// Builds and memoizes the secondary index. A plain object, not `Map` — which
// in this module resolves to the *Immutable* Map, not the native one.
HashCollisionNode.prototype._buildIndex = function _buildIndex() {
    var index = Object.create(null);
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        var secondaryHash = hashCollisionKey(entries[ii][0]);
        var positions = index[secondaryHash];
        if (positions !== undefined) positions.push(ii);
        else index[secondaryHash] = [
            ii
        ];
    }
    this._index = index;
    return index;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var idx = this._positionOf(key, true);
    return idx === -1 ? notSetValue : this.entries[idx][1];
};
HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var len = entries.length;
    var isEditable = ownerID && ownerID === this.ownerID;
    var foundIdx = this._positionOf(key, isEditable);
    var idx = foundIdx === -1 ? len : foundIdx;
    var exists = foundIdx !== -1;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
            idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            // The swap-pop reshuffles positions; drop the stale index (rebuilt lazily).
            if (isEditable) this._index = undefined;
        } else // Same key, same position: the index stays valid.
        newEntries[idx] = [
            key,
            value
        ];
    } else {
        newEntries.push([
            key,
            value
        ]);
        // Keep the index in sync on the transient insert path. Persistent inserts
        // return a fresh node below whose index rebuilds lazily, so skip them.
        if (isEditable && this._index !== undefined) {
            var secondaryHash = hashCollisionKey(key);
            var positions = this._index[secondaryHash];
            if (positions !== undefined) positions.push(len);
            else this._index[secondaryHash] = [
                len
            ];
        }
    }
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef();
        var didAlter = MakeRef();
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
// Above this many colliding entries, a `HashCollisionNode` builds a seeded
// secondary index instead of scanning linearly. Kept small so the rare,
// naturally-occurring collision buckets stay overhead-free, while adversarial
// hash-flooding (thousands of keys sharing one hash) degrades gracefully.
var MIN_HASH_COLLISION_INDEX_SIZE = 16;
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== 'string') return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError('Invalid keyPath: expected Ordered Collection or Array: ' + keyPath);
}
/**
 * Converts a value to a string, adding quotes if a string was provided.
 */ function quoteString(value) {
    try {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
/**
 * Returns true if the key is defined in the provided collection.
 *
 * A functional alternative to `collection.has(key)` which will also work with
 * plain Objects and Arrays as an alternative for
 * `collection.hasOwnProperty(key)`.
 */ function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === 'function' ? collection.get(key) : collection[key];
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        // @ts-expect-error weird "remove" here,
        if (!collection.remove) throw new TypeError('Cannot update immutable value without .remove() method: ' + collection);
        // @ts-expect-error weird "remove" here,
        return collection.remove(key);
    }
    // @ts-expect-error assert that key is a string, a number or a symbol here
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) // @ts-expect-error assert that key is a number here
    collectionCopy.splice(key, 1);
    else // @ts-expect-error assert that key is a string, a number or a symbol here
    delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (isProtoKey(key)) return collection;
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        // @ts-expect-error weird "set" here,
        if (!collection.set) throw new TypeError('Cannot update immutable value without .set() method: ' + collection);
        // @ts-expect-error weird "set" here,
        return collection.set(key, value);
    }
    // @ts-expect-error mix of key and string here. Probably need a more fine type here
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    // @ts-expect-error mix of key and string here. Probably need a more fine type here
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        // handle the fact that `notSetValue` is optional here, in that case `updater` is the updater function
        // @ts-expect-error updater is a function here
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), // @ts-expect-error type issues with Record and mixed types
    collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    // @ts-expect-error mixed return type
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        // @ts-expect-error mixed type with optional value
        var newValue = updater(existingValue);
        // @ts-expect-error mixed type
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError('Cannot update within non-data-structure value in path [' + Array.from(keyPath).slice(0, i).map(quoteString) + ']: ' + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), // @ts-expect-error mixed type
    nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
/**
 * Returns a copy of the collection with the value at the key path removed.
 *
 * A functional alternative to `collection.removeIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function removeIn(collection, keyPath) {
    return updateIn(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';
/**
 * True if `maybeList` is a List.
 */ function isList(maybeList) {
    return Boolean(maybeList && // @ts-expect-error: maybeList is typed as `{}`, need to change in 6.0 to `maybeList && typeof maybeList === 'object' && IS_LIST_SYMBOL in maybeList`
    maybeList[IS_LIST_SYMBOL]);
}
var List = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = emptyList();
        if (value === undefined || value === null) // eslint-disable-next-line no-constructor-return
        return empty;
        if (isList(value)) // eslint-disable-next-line no-constructor-return
        return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) // eslint-disable-next-line no-constructor-return
        return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) // eslint-disable-next-line no-constructor-return
        return makeList(0, size, SHIFT, undefined, new VNode(iter.toArray()));
        // eslint-disable-next-line no-constructor-return
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    List.prototype.shuffle = function shuffle(random) {
        if (random === void 0) random = Math.random;
        return this.withMutations(function(mutable) {
            // implementation of the Fisher-Yates shuffle: https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
            var current = mutable.size;
            var destination;
            var tmp;
            while(current){
                destination = Math.floor(random() * current--);
                tmp = mutable.get(destination);
                mutable.set(destination, mutable.get(current));
                mutable.set(current, tmp);
            }
        });
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== 'string' && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
List.isList = isList;
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn$1;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
    return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
/**
 * A node in the List's 32-wide trie. At inner levels `array` holds child
 * `VNode`s; at the leaf level it holds the List's values. Missing slots are
 * `undefined` array holes.
 *
 * @template T
 */ var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if ((index & (1 << level + SHIFT) - 1) === 0 || this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level + SHIFT : SIZE) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
/**
 * @param {number} origin
 * @param {number} capacity
 * @param {number} level
 * @param {VNode | undefined} [root] The trie root, or `undefined` when every
 *   in-range value lives in the tail (or is a virtual `undefined`).
 * @param {VNode | undefined} [tail]
 * @param {OwnerID} [ownerID]
 * @param {number} [hash]
 */ function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
function emptyList() {
    return makeList(0, 0, SHIFT);
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef();
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
/**
 * Returns the leaf `VNode` holding `rawIndex`, or `undefined` when no node is
 * allocated for it (an all-`undefined` region).
 *
 * @param {List} list
 * @param {number} rawIndex
 * @returns {VNode | undefined}
 */ function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
/**
 * Validates requested bounds before int32 coercion in setListBounds().
 * Throws when origin/capacity would exceed the trie's safe range.
 */ function validateListBoundsRequest(list, begin, end) {
    var requestedOrigin = list._origin + (begin === undefined ? 0 : begin);
    var requestedCapacity = end === undefined ? list._capacity : end < 0 ? list._capacity + end : list._origin + end;
    // Keep origin/capacity within the trie's safe signed 32-bit range.
    if (Number.isFinite(requestedCapacity) && requestedCapacity > MAX_LIST_SIZE || Number.isFinite(requestedOrigin) && requestedOrigin < -MAX_LIST_SIZE || Number.isFinite(requestedCapacity) && Number.isFinite(requestedOrigin) && requestedCapacity - requestedOrigin > MAX_LIST_SIZE) throw new RangeError('Invalid List size: a List cannot hold more than ' + MAX_LIST_SIZE + ' (2 ** 30) values.');
}
function setListBounds(list, begin, end) {
    // Validate full-precision bounds before int32 coercion.
    validateListBoundsRequest(list, begin, end);
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        // Shift origin into non-negative space as trie height grows.
        offsetShift += levelCapacity(newLevel);
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= levelCapacity(newLevel + SHIFT)){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = undefined;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
// The largest number of values a List can hold. Above this the 32-bit trie math
// in setListBounds() stays in the safe signed 32-bit range.
var MAX_LIST_SIZE = Math.pow(2, 30); // 1073741824
/**
 * Computes 2 ** exp for the trie level-raising loops in setListBounds().
 * Use the cheap bitwise operator shift whenever possible, otherwise fall back to exponentiation.
 * This is necessary because bitwise operators in JavaScript only work on 32-bit signed integers, so for exp >= 31, we need to use exponentiation to avoid overflow.
 */ function levelCapacity(exp) {
    return exp < 31 ? 1 << exp : Math.pow(2, exp);
}
/**
 * True if `maybeOrderedMap` is an OrderedMap.
 */ function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
var OrderedMap = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';
/**
 * True if `maybeStack` is a Stack.
 */ function isStack(maybeStack) {
    return Boolean(maybeStack && // @ts-expect-error: maybeStack is typed as `{}`, need to change in 6.0 to `maybeStack && typeof maybeStack === 'object' && MAYBE_STACK_SYMBOL in maybeStack`
    maybeStack[IS_STACK_SYMBOL]);
}
var Stack = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
Stack.isStack = isStack;
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    // @ts-expect-error Migrate to CollectionImpl in v6
    assertNotInfinite(collection.size);
    // @ts-expect-error Migrate to CollectionImpl in v6
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else // `reduction` has already been seeded here (either with the provided
        // initial value or with the first iterated value), so it is never the
        // `undefined` placeholder — only a `V` or a `R`.
        reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return !predicate.apply(this, args);
    };
}
function neg(predicate) {
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return -predicate.apply(this, args);
    };
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || // @ts-expect-error size should exists on Collection
    a.size !== undefined && b.size !== undefined && a.size !== b.size || // @ts-expect-error __hash exists on Collection
    a.__hash !== undefined && // @ts-expect-error __hash exists on Collection
    b.__hash !== undefined && // @ts-expect-error __hash exists on Collection
    a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || // @ts-expect-error Range extends Collection, which implements [Symbol.iterator], so it is valid
    isOrdered(a) !== isOrdered(b)) return false;
    // @ts-expect-error size should exists on Collection
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    // @ts-expect-error Range extends Collection, which implements [Symbol.iterator], so it is valid
    if (isOrdered(a)) {
        var entries = a.entries();
        // @ts-expect-error need to cast as boolean
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        // @ts-expect-error size should exists on Collection
        if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = // @ts-expect-error b is Range | Repeat | Collection<unknown, unknown> as it may have been flipped, and __iterate is valid
    b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && // @ts-expect-error size should exists on Collection
    a.size === bSize;
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (step === void 0) step = 1;
        if (!(this instanceof Range)) // eslint-disable-next-line no-constructor-return
        return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        invariant(start !== undefined, 'You must define a start value when using Range');
        invariant(end !== undefined, 'You must define an end value when using Range');
        step = Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) // eslint-disable-next-line no-constructor-return
            return EMPTY_RANGE;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        return this.size === 0 ? 'Range []' : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? ' by ' + this._step : '') + " ]";
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';
/**
 * True if `maybeSet` is a Set.
 *
 * Also true for OrderedSets.
 */ function isSet(maybeSet) {
    return Boolean(maybeSet && // @ts-expect-error: maybeSet is typed as `{}`,  need to change in 6.0 to `maybeSeq && typeof maybeSet === 'object' && MAYBE_SET_SYMBOL in maybeSet`
    maybeSet[IS_SET_SYMBOL]);
}
var Set = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === 'string') set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
Set.isSet = isSet;
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
    return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns the value at the provided key path starting at the provided
 * collection, or notSetValue if the key path is not defined.
 *
 * A functional alternative to `collection.getIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        // @ts-expect-error keyPath[i++] can not be undefined by design
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
/**
 * Returns true if the key path is defined in the provided collection.
 *
 * A functional alternative to `collection.hasIn(keypath)` which will also
 * work with plain Objects and Arrays.
 */ function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        if (isProtoKey(k)) return;
        object[k] = v;
    });
    return object;
}
function toJS(value) {
    if (!value || typeof value !== 'object') return value;
    if (!isCollection(value)) {
        if (!isDataStructure(value)) return value;
        // @ts-expect-error until Seq has been migrated to TypeScript
        value = Seq(value);
    }
    if (isKeyed(value)) {
        var result$1 = {};
        // @ts-expect-error `__iterate` exists on all Keyed collections but method is not defined in the type
        value.__iterate(function(v, k) {
            if (isProtoKey(k)) return;
            result$1[k] = toJS(v);
        });
        return result$1;
    }
    var result = [];
    // @ts-expect-error value "should" be a non-keyed collection, but we may need to assert for stricter types
    value.__iterate(function(v) {
        result.push(toJS(v));
    });
    return result;
}
function hashCollection(collection) {
    // @ts-expect-error Migrate to CollectionImpl in v6
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    // @ts-expect-error Migrate to CollectionImpl in v6
    collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    // @ts-expect-error Migrate to CollectionImpl in v6
    return murmurHashOfSize(collection.size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
/**
 * Contributes additional methods to a constructor
 */ function mixin(ctor, // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
methods) {
    var keyCopier = function(key) {
        // @ts-expect-error how to handle symbol ?
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return '[Collection]';
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;
        this.__iterate(function(v) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find(returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ': ' + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.find(function(_, key) {
            return key === index;
        }, undefined, NOT_SET) !== NOT_SET);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);
// #pragma Helper functions
function defaultZipper() {
    return arrCopy(arguments);
}
/**
 * True if `maybeOrderedSet` is an OrderedSet.
 */ function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
var OrderedSet = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString('OrderedSet {', '}');
    };
    return OrderedSet;
}(Set);
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
/**
 * Describes which item in a pair should be placed first when sorting
 */ var PairSorting = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function throwOnInvalidDefaultValues(defaultValues) {
    if (isRecord(defaultValues)) throw new Error('Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.');
    if (isImmutable(defaultValues)) throw new Error('Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.');
    if (defaultValues === null || typeof defaultValues !== 'object') throw new Error('Can not call `Record` with a non-object as default values. Use a plain javascript object instead.');
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
                typeof console === 'object' && console.warn && console.warn('Cannot define ' + recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    // eslint-disable-next-line no-constructor-return
    return RecordType;
};
Record.prototype.toString = function toString() {
    var str = recordName(this) + ' { ';
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
    }
    return str + ' }';
};
Record.prototype.equals = function equals(other) {
    return this === other || isRecord(other) && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn$1;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record.constructor.displayName || record.constructor.name || 'Record';
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO enable eslint here
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) // eslint-disable-next-line no-constructor-return
        return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) // eslint-disable-next-line no-constructor-return
            return EMPTY_REPEAT;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (this.size !== 0 && is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (this.size !== 0 && is(this._value, searchValue)) return this.size - 1;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(this, other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, '', converter && converter.length > 2 ? [] : undefined, {
        '': value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== 'string' && !isImmutable(value) && (isArrayLike(value) || hasIterator(value) || isPlainObject(value))) {
        if (~stack.indexOf(value)) throw new TypeError('Cannot convert circular structure to Immutable');
        stack.push(value);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        keyPath && key !== '' && keyPath.push(key);
        var converted = converter.call(parentValue, key, Seq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- TODO enable eslint here
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}
var version = "5.1.9";
/* eslint-disable import/order */ // Note: Iterable is deprecated
var Iterable = Collection;

});

let $1f5a16020b51a07b$var$taskIdCounter = 1, $1f5a16020b51a07b$var$isCallbackScheduled = false, $1f5a16020b51a07b$var$isPerformingWork = false, $1f5a16020b51a07b$var$taskQueue = [], $1f5a16020b51a07b$var$currentTask = null, $1f5a16020b51a07b$var$shouldYieldToHost = null, $1f5a16020b51a07b$var$yieldInterval = 5, $1f5a16020b51a07b$var$deadline = 0, $1f5a16020b51a07b$var$maxYieldInterval = 300, $1f5a16020b51a07b$var$maxDeadline = 0, $1f5a16020b51a07b$var$scheduleCallback = null, $1f5a16020b51a07b$var$scheduledCallback = null;
const $1f5a16020b51a07b$var$maxSigned31BitInt = 1073741823;
function $1f5a16020b51a07b$var$setupScheduler() {
    const channel = new MessageChannel(), port1 = channel.port1, port = channel.port2;
    if (typeof port1.unref === "function") port1.unref();
    if (typeof port.unref === "function") port.unref();
    $1f5a16020b51a07b$var$scheduleCallback = ()=>port.postMessage(null);
    port1.onmessage = ()=>{
        if ($1f5a16020b51a07b$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $1f5a16020b51a07b$var$deadline = currentTime + $1f5a16020b51a07b$var$yieldInterval;
            $1f5a16020b51a07b$var$maxDeadline = currentTime + $1f5a16020b51a07b$var$maxYieldInterval;
            try {
                const hasMoreWork = $1f5a16020b51a07b$var$scheduledCallback(currentTime);
                if (!hasMoreWork) $1f5a16020b51a07b$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $1f5a16020b51a07b$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $1f5a16020b51a07b$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $1f5a16020b51a07b$var$maxDeadline;
            } else return false;
        };
    } else $1f5a16020b51a07b$var$shouldYieldToHost = ()=>performance.now() >= $1f5a16020b51a07b$var$deadline;
}
function $1f5a16020b51a07b$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $1f5a16020b51a07b$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$1f5a16020b51a07b$var$scheduleCallback) $1f5a16020b51a07b$var$setupScheduler();
    let startTime = performance.now(), timeout = $1f5a16020b51a07b$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $1f5a16020b51a07b$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $1f5a16020b51a07b$var$enqueue($1f5a16020b51a07b$var$taskQueue, newTask);
    if (!$1f5a16020b51a07b$var$isCallbackScheduled && !$1f5a16020b51a07b$var$isPerformingWork) {
        $1f5a16020b51a07b$var$isCallbackScheduled = true;
        $1f5a16020b51a07b$var$scheduledCallback = $1f5a16020b51a07b$var$flushWork;
        $1f5a16020b51a07b$var$scheduleCallback();
    }
    return newTask;
}
function $1f5a16020b51a07b$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $1f5a16020b51a07b$var$flushWork(initialTime) {
    $1f5a16020b51a07b$var$isCallbackScheduled = false;
    $1f5a16020b51a07b$var$isPerformingWork = true;
    try {
        return $1f5a16020b51a07b$var$workLoop(initialTime);
    } finally{
        $1f5a16020b51a07b$var$currentTask = null;
        $1f5a16020b51a07b$var$isPerformingWork = false;
    }
}
function $1f5a16020b51a07b$var$workLoop(initialTime) {
    let currentTime = initialTime;
    $1f5a16020b51a07b$var$currentTask = $1f5a16020b51a07b$var$taskQueue[0] || null;
    while($1f5a16020b51a07b$var$currentTask !== null){
        if ($1f5a16020b51a07b$var$currentTask.expirationTime > currentTime && $1f5a16020b51a07b$var$shouldYieldToHost()) break;
        const callback = $1f5a16020b51a07b$var$currentTask.fn;
        if (callback !== null) {
            $1f5a16020b51a07b$var$currentTask.fn = null;
            const didUserCallbackTimeout = $1f5a16020b51a07b$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($1f5a16020b51a07b$var$currentTask === $1f5a16020b51a07b$var$taskQueue[0]) $1f5a16020b51a07b$var$taskQueue.shift();
        } else $1f5a16020b51a07b$var$taskQueue.shift();
        $1f5a16020b51a07b$var$currentTask = $1f5a16020b51a07b$var$taskQueue[0] || null;
    }
    return $1f5a16020b51a07b$var$currentTask !== null;
}
const $1f5a16020b51a07b$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined,
    effects: undefined,
    done: false,
    getContextId () {
        return $1f5a16020b51a07b$var$getContextId(this.context.count);
    },
    getNextContextId () {
        return $1f5a16020b51a07b$var$getContextId(this.context.count++);
    }
};
function $1f5a16020b51a07b$var$getContextId(count) {
    const num = String(count), len = num.length - 1;
    return $1f5a16020b51a07b$export$2cb4986bed338027.context.id + (len ? String.fromCharCode(96 + len) : "") + num;
}
function $1f5a16020b51a07b$var$setHydrateContext(context) {
    $1f5a16020b51a07b$export$2cb4986bed338027.context = context;
}
function $1f5a16020b51a07b$var$nextHydrateContext() {
    return {
        ...$1f5a16020b51a07b$export$2cb4986bed338027.context,
        id: $1f5a16020b51a07b$export$2cb4986bed338027.getNextContextId(),
        count: 0
    };
}
const $1f5a16020b51a07b$var$IS_DEV = false;
const $1f5a16020b51a07b$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $1f5a16020b51a07b$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $1f5a16020b51a07b$var$SUPPORTS_PROXY = typeof Proxy === "function";
const $1f5a16020b51a07b$export$17a675b7c02a7b1d = Symbol("solid-track");
const $1f5a16020b51a07b$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $1f5a16020b51a07b$var$signalOptions = {
    equals: $1f5a16020b51a07b$export$34b67c27f2ca7498
};
let $1f5a16020b51a07b$var$ERROR = null;
let $1f5a16020b51a07b$var$runEffects = $1f5a16020b51a07b$var$runQueue;
const $1f5a16020b51a07b$var$STALE = 1;
const $1f5a16020b51a07b$var$PENDING = 2;
const $1f5a16020b51a07b$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $1f5a16020b51a07b$var$NO_INIT = {};
var $1f5a16020b51a07b$var$Owner = null;
let $1f5a16020b51a07b$var$Transition = null;
let $1f5a16020b51a07b$var$Scheduler = null;
let $1f5a16020b51a07b$var$ExternalSourceConfig = null;
let $1f5a16020b51a07b$var$Listener = null;
let $1f5a16020b51a07b$var$Updates = null;
let $1f5a16020b51a07b$var$Effects = null;
let $1f5a16020b51a07b$var$ExecCount = 0;
function $1f5a16020b51a07b$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $1f5a16020b51a07b$var$Listener, owner = $1f5a16020b51a07b$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $1f5a16020b51a07b$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$1f5a16020b51a07b$export$363ebc4b78b8f807(()=>$1f5a16020b51a07b$var$cleanNode(root)));
    $1f5a16020b51a07b$var$Owner = root;
    $1f5a16020b51a07b$var$Listener = null;
    try {
        return $1f5a16020b51a07b$var$runUpdates(updateFn, true);
    } finally{
        $1f5a16020b51a07b$var$Listener = listener;
        $1f5a16020b51a07b$var$Owner = owner;
    }
}
function $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $1f5a16020b51a07b$var$signalOptions, options) : $1f5a16020b51a07b$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $1f5a16020b51a07b$var$writeSignal(s, value);
    };
    return [
        $1f5a16020b51a07b$var$readSignal.bind(s),
        setter
    ];
}
function $1f5a16020b51a07b$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, true, $1f5a16020b51a07b$var$STALE);
    if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$Updates.push(c);
    else $1f5a16020b51a07b$var$updateComputation(c);
}
function $1f5a16020b51a07b$export$314dade334ae905d(fn, value, options) {
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, false, $1f5a16020b51a07b$var$STALE);
    if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$Updates.push(c);
    else $1f5a16020b51a07b$var$updateComputation(c);
}
function $1f5a16020b51a07b$export$7ea7134f704deda4(fn, value, options) {
    $1f5a16020b51a07b$var$runEffects = $1f5a16020b51a07b$var$runUserEffects;
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, false, $1f5a16020b51a07b$var$STALE), s = $1f5a16020b51a07b$var$SuspenseContext && $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $1f5a16020b51a07b$var$Effects ? $1f5a16020b51a07b$var$Effects.push(c) : $1f5a16020b51a07b$var$updateComputation(c);
}
function $1f5a16020b51a07b$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $1f5a16020b51a07b$var$createComputation(()=>{
        fn ? fn() : $1f5a16020b51a07b$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $1f5a16020b51a07b$var$SuspenseContext && $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $1f5a16020b51a07b$var$updateComputation(c);
    };
}
function $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $1f5a16020b51a07b$var$signalOptions, options) : $1f5a16020b51a07b$var$signalOptions;
    const c = $1f5a16020b51a07b$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
        c.tState = $1f5a16020b51a07b$var$STALE;
        $1f5a16020b51a07b$var$Updates.push(c);
    } else $1f5a16020b51a07b$var$updateComputation(c);
    return $1f5a16020b51a07b$var$readSignal.bind(c);
}
function $1f5a16020b51a07b$var$isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function $1f5a16020b51a07b$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (typeof pFetcher === "function") {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    } else {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    }
    let pr = null, initP = $1f5a16020b51a07b$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($1f5a16020b51a07b$var$Owner) $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>{
        for (const c of contexts.keys())c.decrement();
        contexts.clear();
        if ($1f5a16020b51a07b$var$Transition && pr) $1f5a16020b51a07b$var$Transition.promises.delete(pr);
        pr = null;
    });
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context) {
        id = $1f5a16020b51a07b$export$2cb4986bed338027.getNextContextId();
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($1f5a16020b51a07b$export$2cb4986bed338027.load && $1f5a16020b51a07b$export$2cb4986bed338027.has(id)) initP = $1f5a16020b51a07b$export$2cb4986bed338027.load(id);
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $1f5a16020b51a07b$var$NO_INIT;
            if ($1f5a16020b51a07b$var$Transition && p && loadedUnderTransition) {
                $1f5a16020b51a07b$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $1f5a16020b51a07b$var$runUpdates(()=>{
                    $1f5a16020b51a07b$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $1f5a16020b51a07b$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $1f5a16020b51a07b$var$SuspenseContext && $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($1f5a16020b51a07b$var$Listener && !$1f5a16020b51a07b$var$Listener.user && c) $1f5a16020b51a07b$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $1f5a16020b51a07b$var$Transition && loadedUnderTransition) $1f5a16020b51a07b$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $1f5a16020b51a07b$export$363ebc4b78b8f807(value));
            return;
        }
        if ($1f5a16020b51a07b$var$Transition && pr) $1f5a16020b51a07b$var$Transition.promises.delete(pr);
        let error;
        const p = initP !== $1f5a16020b51a07b$var$NO_INIT ? initP : $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
            try {
                return fetcher(lookup, {
                    value: value(),
                    refetching: refetching
                });
            } catch (fetcherError) {
                error = fetcherError;
            }
        });
        if (error !== undefined) {
            loadEnd(pr, undefined, $1f5a16020b51a07b$var$castError(error), lookup);
            return;
        } else if (!$1f5a16020b51a07b$var$isPromise(p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        if ("v" in p) {
            if (p.s === 1) loadEnd(pr, p.v, undefined, lookup);
            else loadEnd(pr, undefined, $1f5a16020b51a07b$var$castError(p.v), lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $1f5a16020b51a07b$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $1f5a16020b51a07b$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    let owner = $1f5a16020b51a07b$var$Owner;
    if (dynamic) $1f5a16020b51a07b$export$234a23cdc77e6a3d(()=>(owner = $1f5a16020b51a07b$var$Owner, load(false)));
    else load(false);
    return [
        read,
        {
            refetch: (info)=>$1f5a16020b51a07b$export$c14f3e3abbc7d6b5(owner, ()=>load(info)),
            mutate: setValue
        }
    ];
}
function $1f5a16020b51a07b$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $1f5a16020b51a07b$var$createComputation(()=>{
        if (!t || !t.fn) t = $1f5a16020b51a07b$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value, options);
    $1f5a16020b51a07b$var$updateComputation(node);
    setDeferred(()=>$1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value);
    return deferred;
}
function $1f5a16020b51a07b$export$595d22ed68ca2841(source, fn = $1f5a16020b51a07b$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $1f5a16020b51a07b$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) c.tState = $1f5a16020b51a07b$var$STALE;
            else c.state = $1f5a16020b51a07b$var$STALE;
            if (c.pure) $1f5a16020b51a07b$var$Updates.push(c);
            else $1f5a16020b51a07b$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $1f5a16020b51a07b$var$STALE);
    $1f5a16020b51a07b$var$updateComputation(node);
    return (key)=>{
        const listener = $1f5a16020b51a07b$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $1f5a16020b51a07b$export$712ea50be43a7858(fn) {
    return $1f5a16020b51a07b$var$runUpdates(fn, false);
}
function $1f5a16020b51a07b$export$363ebc4b78b8f807(fn) {
    if (!$1f5a16020b51a07b$var$ExternalSourceConfig && $1f5a16020b51a07b$var$Listener === null) return fn();
    const listener = $1f5a16020b51a07b$var$Listener;
    $1f5a16020b51a07b$var$Listener = null;
    try {
        if ($1f5a16020b51a07b$var$ExternalSourceConfig) return $1f5a16020b51a07b$var$ExternalSourceConfig.untrack(fn);
        return fn();
    } finally{
        $1f5a16020b51a07b$var$Listener = listener;
    }
}
function $1f5a16020b51a07b$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return prevValue;
        }
        const result = $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $1f5a16020b51a07b$export$1e848a9e87980bd5(fn) {
    $1f5a16020b51a07b$export$7ea7134f704deda4(()=>$1f5a16020b51a07b$export$363ebc4b78b8f807(fn));
}
function $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(fn) {
    if ($1f5a16020b51a07b$var$Owner === null) ;
    else if ($1f5a16020b51a07b$var$Owner.cleanups === null) $1f5a16020b51a07b$var$Owner.cleanups = [
        fn
    ];
    else $1f5a16020b51a07b$var$Owner.cleanups.push(fn);
    return fn;
}
function $1f5a16020b51a07b$export$3dede90624df3ba9(fn, handler) {
    $1f5a16020b51a07b$var$ERROR || ($1f5a16020b51a07b$var$ERROR = Symbol("error"));
    $1f5a16020b51a07b$var$Owner = $1f5a16020b51a07b$var$createComputation(undefined, undefined, true);
    $1f5a16020b51a07b$var$Owner.context = {
        ...$1f5a16020b51a07b$var$Owner.context,
        [$1f5a16020b51a07b$var$ERROR]: [
            handler
        ]
    };
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$Transition.sources.add($1f5a16020b51a07b$var$Owner);
    try {
        return fn();
    } catch (err) {
        $1f5a16020b51a07b$var$handleError(err);
    } finally{
        $1f5a16020b51a07b$var$Owner = $1f5a16020b51a07b$var$Owner.owner;
    }
}
function $1f5a16020b51a07b$export$12abb5141c6fdc9c() {
    return $1f5a16020b51a07b$var$Listener;
}
function $1f5a16020b51a07b$export$5f4ed0d56c2c0edf() {
    return $1f5a16020b51a07b$var$Owner;
}
function $1f5a16020b51a07b$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $1f5a16020b51a07b$var$Owner;
    const prevListener = $1f5a16020b51a07b$var$Listener;
    $1f5a16020b51a07b$var$Owner = o;
    $1f5a16020b51a07b$var$Listener = null;
    try {
        return $1f5a16020b51a07b$var$runUpdates(fn, true);
    } catch (err) {
        $1f5a16020b51a07b$var$handleError(err);
    } finally{
        $1f5a16020b51a07b$var$Owner = prev;
        $1f5a16020b51a07b$var$Listener = prevListener;
    }
}
function $1f5a16020b51a07b$export$45e8540700504e87(scheduler = $1f5a16020b51a07b$export$4b5e076b3a2fbe0a) {
    $1f5a16020b51a07b$var$Scheduler = scheduler;
}
function $1f5a16020b51a07b$export$7568632d0d33d16d(fn) {
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
        fn();
        return $1f5a16020b51a07b$var$Transition.done;
    }
    const l = $1f5a16020b51a07b$var$Listener;
    const o = $1f5a16020b51a07b$var$Owner;
    return Promise.resolve().then(()=>{
        $1f5a16020b51a07b$var$Listener = l;
        $1f5a16020b51a07b$var$Owner = o;
        let t;
        if ($1f5a16020b51a07b$var$Scheduler || $1f5a16020b51a07b$var$SuspenseContext) {
            t = $1f5a16020b51a07b$var$Transition || ($1f5a16020b51a07b$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $1f5a16020b51a07b$var$runUpdates(fn, false);
        $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = null;
        return t ? t.done : undefined;
    });
}
const [$1f5a16020b51a07b$var$transPending, $1f5a16020b51a07b$var$setTransPending] = /*@__PURE__*/ $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(false);
function $1f5a16020b51a07b$export$7b286972b8d8ccbf() {
    return [
        $1f5a16020b51a07b$var$transPending,
        $1f5a16020b51a07b$export$7568632d0d33d16d
    ];
}
function $1f5a16020b51a07b$var$resumeEffects(e) {
    $1f5a16020b51a07b$var$Effects.push.apply($1f5a16020b51a07b$var$Effects, e);
    e.length = 0;
}
function $1f5a16020b51a07b$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $1f5a16020b51a07b$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $1f5a16020b51a07b$export$fae74005e78b1a27(context) {
    let value;
    return $1f5a16020b51a07b$var$Owner && $1f5a16020b51a07b$var$Owner.context && (value = $1f5a16020b51a07b$var$Owner.context[context.id]) !== undefined ? value : context.defaultValue;
}
function $1f5a16020b51a07b$export$bacb5cc5a11aef16(fn) {
    const children = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(fn);
    const memo = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>$1f5a16020b51a07b$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $1f5a16020b51a07b$var$SuspenseContext;
function $1f5a16020b51a07b$var$getSuspenseContext() {
    return $1f5a16020b51a07b$var$SuspenseContext || ($1f5a16020b51a07b$var$SuspenseContext = $1f5a16020b51a07b$export$fd42f52fd3ae1109());
}
function $1f5a16020b51a07b$export$315ab94ce87a624f(factory, untrack = (fn)=>fn()) {
    if ($1f5a16020b51a07b$var$ExternalSourceConfig) {
        const { factory: oldFactory, untrack: oldUntrack } = $1f5a16020b51a07b$var$ExternalSourceConfig;
        $1f5a16020b51a07b$var$ExternalSourceConfig = {
            factory: (fn, trigger)=>{
                const oldSource = oldFactory(fn, trigger);
                const source = factory((x)=>oldSource.track(x), trigger);
                return {
                    track: (x)=>source.track(x),
                    dispose () {
                        source.dispose();
                        oldSource.dispose();
                    }
                };
            },
            untrack: (fn)=>oldUntrack(()=>untrack(fn))
        };
    } else $1f5a16020b51a07b$var$ExternalSourceConfig = {
        factory: factory,
        untrack: untrack
    };
}
function $1f5a16020b51a07b$var$readSignal() {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $1f5a16020b51a07b$var$STALE) $1f5a16020b51a07b$var$updateComputation(this);
        else {
            const updates = $1f5a16020b51a07b$var$Updates;
            $1f5a16020b51a07b$var$Updates = null;
            $1f5a16020b51a07b$var$runUpdates(()=>$1f5a16020b51a07b$var$lookUpstream(this), false);
            $1f5a16020b51a07b$var$Updates = updates;
        }
    }
    if ($1f5a16020b51a07b$var$Listener) {
        const observers = this.observers;
        if (!observers || observers[observers.length - 1] !== $1f5a16020b51a07b$var$Listener) {
            const sSlot = observers ? observers.length : 0;
            if (!$1f5a16020b51a07b$var$Listener.sources) {
                $1f5a16020b51a07b$var$Listener.sources = [
                    this
                ];
                $1f5a16020b51a07b$var$Listener.sourceSlots = [
                    sSlot
                ];
            } else {
                $1f5a16020b51a07b$var$Listener.sources.push(this);
                $1f5a16020b51a07b$var$Listener.sourceSlots.push(sSlot);
            }
            if (!observers) {
                this.observers = [
                    $1f5a16020b51a07b$var$Listener
                ];
                this.observerSlots = [
                    $1f5a16020b51a07b$var$Listener.sources.length - 1
                ];
            } else {
                observers.push($1f5a16020b51a07b$var$Listener);
                this.observerSlots.push($1f5a16020b51a07b$var$Listener.sources.length - 1);
            }
        }
    }
    if (runningTransition && $1f5a16020b51a07b$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $1f5a16020b51a07b$var$writeSignal(node, value, isComp) {
    let current = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($1f5a16020b51a07b$var$Transition) {
            const TransitionRunning = $1f5a16020b51a07b$var$Transition.running;
            if (TransitionRunning || !isComp && $1f5a16020b51a07b$var$Transition.sources.has(node)) {
                $1f5a16020b51a07b$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $1f5a16020b51a07b$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
                if (TransitionRunning && $1f5a16020b51a07b$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $1f5a16020b51a07b$var$Updates.push(o);
                    else $1f5a16020b51a07b$var$Effects.push(o);
                    if (o.observers) $1f5a16020b51a07b$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $1f5a16020b51a07b$var$STALE;
                else o.tState = $1f5a16020b51a07b$var$STALE;
            }
            if ($1f5a16020b51a07b$var$Updates.length > 10e5) {
                $1f5a16020b51a07b$var$Updates = [];
                $1f5a16020b51a07b$var$IS_DEV;
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $1f5a16020b51a07b$var$updateComputation(node) {
    if (!node.fn) return;
    $1f5a16020b51a07b$var$cleanNode(node);
    const time = $1f5a16020b51a07b$var$ExecCount;
    $1f5a16020b51a07b$var$runComputation(node, $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($1f5a16020b51a07b$var$Transition && !$1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $1f5a16020b51a07b$var$runUpdates(()=>{
            $1f5a16020b51a07b$var$Transition && ($1f5a16020b51a07b$var$Transition.running = true);
            $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = node;
            $1f5a16020b51a07b$var$runComputation(node, node.tValue, time);
            $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = null;
        }, false);
    });
}
function $1f5a16020b51a07b$var$runComputation(node, value, time) {
    let nextValue;
    const owner = $1f5a16020b51a07b$var$Owner, listener = $1f5a16020b51a07b$var$Listener;
    $1f5a16020b51a07b$var$Listener = $1f5a16020b51a07b$var$Owner = node;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
                node.tState = $1f5a16020b51a07b$var$STALE;
                node.tOwned && node.tOwned.forEach($1f5a16020b51a07b$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $1f5a16020b51a07b$var$STALE;
                node.owned && node.owned.forEach($1f5a16020b51a07b$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $1f5a16020b51a07b$var$handleError(err);
    } finally{
        $1f5a16020b51a07b$var$Listener = listener;
        $1f5a16020b51a07b$var$Owner = owner;
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $1f5a16020b51a07b$var$writeSignal(node, nextValue, true);
        else if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && node.pure) {
            if (!$1f5a16020b51a07b$var$Transition.sources.has(node)) node.value = nextValue;
            $1f5a16020b51a07b$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $1f5a16020b51a07b$var$createComputation(fn, init, pure, state = $1f5a16020b51a07b$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $1f5a16020b51a07b$var$Owner,
        context: $1f5a16020b51a07b$var$Owner ? $1f5a16020b51a07b$var$Owner.context : null,
        pure: pure
    };
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($1f5a16020b51a07b$var$Owner === null) ;
    else if ($1f5a16020b51a07b$var$Owner !== $1f5a16020b51a07b$var$UNOWNED) {
        if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && $1f5a16020b51a07b$var$Owner.pure) {
            if (!$1f5a16020b51a07b$var$Owner.tOwned) $1f5a16020b51a07b$var$Owner.tOwned = [
                c
            ];
            else $1f5a16020b51a07b$var$Owner.tOwned.push(c);
        } else if (!$1f5a16020b51a07b$var$Owner.owned) $1f5a16020b51a07b$var$Owner.owned = [
            c
        ];
        else $1f5a16020b51a07b$var$Owner.owned.push(c);
    }
    if ($1f5a16020b51a07b$var$ExternalSourceConfig && c.fn) {
        const sourceFn = c.fn;
        const [track, trigger] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $1f5a16020b51a07b$var$ExternalSourceConfig.factory(sourceFn, trigger);
        $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        let inTransition;
        let trackedOrdinary = false;
        const triggerInTransition = ()=>$1f5a16020b51a07b$export$7568632d0d33d16d(trigger).then(()=>{
                if (inTransition) {
                    inTransition.dispose();
                    inTransition = undefined;
                    if (!trackedOrdinary) trigger();
                }
            });
        c.fn = (x)=>{
            track();
            if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) {
                if (!inTransition) inTransition = $1f5a16020b51a07b$var$ExternalSourceConfig.factory(sourceFn, triggerInTransition);
                return inTransition.track(x);
            }
            trackedOrdinary = true;
            return ordinary.track(x);
        };
    }
    return c;
}
function $1f5a16020b51a07b$var$runTop(node) {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $1f5a16020b51a07b$var$PENDING) return $1f5a16020b51a07b$var$lookUpstream(node);
    if (node.suspense && $1f5a16020b51a07b$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $1f5a16020b51a07b$var$ExecCount)){
        if (runningTransition && $1f5a16020b51a07b$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($1f5a16020b51a07b$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $1f5a16020b51a07b$var$STALE) $1f5a16020b51a07b$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $1f5a16020b51a07b$var$PENDING) {
            const updates = $1f5a16020b51a07b$var$Updates;
            $1f5a16020b51a07b$var$Updates = null;
            $1f5a16020b51a07b$var$runUpdates(()=>$1f5a16020b51a07b$var$lookUpstream(node, ancestors[0]), false);
            $1f5a16020b51a07b$var$Updates = updates;
        }
    }
}
function $1f5a16020b51a07b$var$runUpdates(fn, init) {
    if ($1f5a16020b51a07b$var$Updates) return fn();
    let wait = false;
    if (!init) $1f5a16020b51a07b$var$Updates = [];
    if ($1f5a16020b51a07b$var$Effects) wait = true;
    else $1f5a16020b51a07b$var$Effects = [];
    $1f5a16020b51a07b$var$ExecCount++;
    try {
        const res = fn();
        $1f5a16020b51a07b$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $1f5a16020b51a07b$var$Effects = null;
        $1f5a16020b51a07b$var$Updates = null;
        $1f5a16020b51a07b$var$handleError(err);
    }
}
function $1f5a16020b51a07b$var$completeUpdates(wait) {
    if ($1f5a16020b51a07b$var$Updates) {
        if ($1f5a16020b51a07b$var$Scheduler && $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) $1f5a16020b51a07b$var$scheduleQueue($1f5a16020b51a07b$var$Updates);
        else $1f5a16020b51a07b$var$runQueue($1f5a16020b51a07b$var$Updates);
        $1f5a16020b51a07b$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($1f5a16020b51a07b$var$Transition) {
        if (!$1f5a16020b51a07b$var$Transition.promises.size && !$1f5a16020b51a07b$var$Transition.queue.size) {
            const sources = $1f5a16020b51a07b$var$Transition.sources;
            const disposed = $1f5a16020b51a07b$var$Transition.disposed;
            $1f5a16020b51a07b$var$Effects.push.apply($1f5a16020b51a07b$var$Effects, $1f5a16020b51a07b$var$Transition.effects);
            res = $1f5a16020b51a07b$var$Transition.resolve;
            for (const e of $1f5a16020b51a07b$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $1f5a16020b51a07b$var$Transition = null;
            $1f5a16020b51a07b$var$runUpdates(()=>{
                for (const d of disposed)$1f5a16020b51a07b$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$1f5a16020b51a07b$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $1f5a16020b51a07b$var$setTransPending(false);
            }, false);
        } else if ($1f5a16020b51a07b$var$Transition.running) {
            $1f5a16020b51a07b$var$Transition.running = false;
            $1f5a16020b51a07b$var$Transition.effects.push.apply($1f5a16020b51a07b$var$Transition.effects, $1f5a16020b51a07b$var$Effects);
            $1f5a16020b51a07b$var$Effects = null;
            $1f5a16020b51a07b$var$setTransPending(true);
            return;
        }
    }
    const e = $1f5a16020b51a07b$var$Effects;
    $1f5a16020b51a07b$var$Effects = null;
    if (e.length) $1f5a16020b51a07b$var$runUpdates(()=>$1f5a16020b51a07b$var$runEffects(e), false);
    if (res) res();
}
function $1f5a16020b51a07b$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$1f5a16020b51a07b$var$runTop(queue[i]);
}
function $1f5a16020b51a07b$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $1f5a16020b51a07b$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $1f5a16020b51a07b$var$Scheduler(()=>{
                tasks.delete(item);
                $1f5a16020b51a07b$var$runUpdates(()=>{
                    $1f5a16020b51a07b$var$Transition.running = true;
                    $1f5a16020b51a07b$var$runTop(item);
                }, false);
                $1f5a16020b51a07b$var$Transition && ($1f5a16020b51a07b$var$Transition.running = false);
            });
        }
    }
}
function $1f5a16020b51a07b$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $1f5a16020b51a07b$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context) {
        if ($1f5a16020b51a07b$export$2cb4986bed338027.count) {
            $1f5a16020b51a07b$export$2cb4986bed338027.effects || ($1f5a16020b51a07b$export$2cb4986bed338027.effects = []);
            $1f5a16020b51a07b$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        }
        $1f5a16020b51a07b$var$setHydrateContext();
    }
    if ($1f5a16020b51a07b$export$2cb4986bed338027.effects && ($1f5a16020b51a07b$export$2cb4986bed338027.done || !$1f5a16020b51a07b$export$2cb4986bed338027.count)) {
        queue = [
            ...$1f5a16020b51a07b$export$2cb4986bed338027.effects,
            ...queue
        ];
        userLength += $1f5a16020b51a07b$export$2cb4986bed338027.effects.length;
        delete $1f5a16020b51a07b$export$2cb4986bed338027.effects;
    }
    for(i = 0; i < userLength; i++)$1f5a16020b51a07b$var$runTop(queue[i]);
}
function $1f5a16020b51a07b$var$lookUpstream(node, ignore) {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $1f5a16020b51a07b$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $1f5a16020b51a07b$var$ExecCount)) $1f5a16020b51a07b$var$runTop(source);
            } else if (state === $1f5a16020b51a07b$var$PENDING) $1f5a16020b51a07b$var$lookUpstream(source, ignore);
        }
    }
}
function $1f5a16020b51a07b$var$markDownstream(node) {
    const runningTransition = $1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $1f5a16020b51a07b$var$PENDING;
            else o.state = $1f5a16020b51a07b$var$PENDING;
            if (o.pure) $1f5a16020b51a07b$var$Updates.push(o);
            else $1f5a16020b51a07b$var$Effects.push(o);
            o.observers && $1f5a16020b51a07b$var$markDownstream(o);
        }
    }
}
function $1f5a16020b51a07b$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if (node.tOwned) {
        for(i = node.tOwned.length - 1; i >= 0; i--)$1f5a16020b51a07b$var$cleanNode(node.tOwned[i]);
        delete node.tOwned;
    }
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running && node.pure) $1f5a16020b51a07b$var$reset(node, true);
    else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$1f5a16020b51a07b$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($1f5a16020b51a07b$var$Transition && $1f5a16020b51a07b$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $1f5a16020b51a07b$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $1f5a16020b51a07b$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$1f5a16020b51a07b$var$reset(node.owned[i]);
}
function $1f5a16020b51a07b$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $1f5a16020b51a07b$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $1f5a16020b51a07b$var$handleError(e, owner && owner.owner || null);
    }
}
function $1f5a16020b51a07b$var$handleError(err, owner = $1f5a16020b51a07b$var$Owner) {
    const fns = $1f5a16020b51a07b$var$ERROR && owner && owner.context && owner.context[$1f5a16020b51a07b$var$ERROR];
    const error = $1f5a16020b51a07b$var$castError(err);
    if (!fns) throw error;
    if ($1f5a16020b51a07b$var$Effects) $1f5a16020b51a07b$var$Effects.push({
        fn () {
            $1f5a16020b51a07b$var$runErrors(error, fns, owner);
        },
        state: $1f5a16020b51a07b$var$STALE
    });
    else $1f5a16020b51a07b$var$runErrors(error, fns, owner);
}
function $1f5a16020b51a07b$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $1f5a16020b51a07b$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $1f5a16020b51a07b$var$resolveChildren(children[i]);
            if (Array.isArray(result)) {
                if (result.length < 32768) results.push.apply(results, result);
                else for(let j = 0; j < result.length; j++)results.push(result[j]);
            } else results.push(result);
        }
        return results;
    }
    return children;
}
function $1f5a16020b51a07b$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $1f5a16020b51a07b$export$314dade334ae905d(()=>res = $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
                $1f5a16020b51a07b$var$Owner.context = {
                    ...$1f5a16020b51a07b$var$Owner.context,
                    [id]: props.value
                };
                return $1f5a16020b51a07b$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $1f5a16020b51a07b$export$2288787135a8f66e(fn) {
    $1f5a16020b51a07b$var$ERROR || ($1f5a16020b51a07b$var$ERROR = Symbol("error"));
    if ($1f5a16020b51a07b$var$Owner === null) ;
    else if ($1f5a16020b51a07b$var$Owner.context === null || !$1f5a16020b51a07b$var$Owner.context[$1f5a16020b51a07b$var$ERROR]) {
        $1f5a16020b51a07b$var$Owner.context = {
            ...$1f5a16020b51a07b$var$Owner.context,
            [$1f5a16020b51a07b$var$ERROR]: [
                fn
            ]
        };
        $1f5a16020b51a07b$var$mutateContext($1f5a16020b51a07b$var$Owner, $1f5a16020b51a07b$var$ERROR, [
            fn
        ]);
    } else $1f5a16020b51a07b$var$Owner.context[$1f5a16020b51a07b$var$ERROR].push(fn);
}
function $1f5a16020b51a07b$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $1f5a16020b51a07b$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $1f5a16020b51a07b$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $1f5a16020b51a07b$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $1f5a16020b51a07b$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                $1f5a16020b51a07b$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($1f5a16020b51a07b$export$5f4ed0d56c2c0edf()) $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $1f5a16020b51a07b$export$6788812c4e6611e6(producer, initalValue) {
    const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(initalValue, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $1f5a16020b51a07b$var$FALLBACK = Symbol("fallback");
function $1f5a16020b51a07b$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $1f5a16020b51a07b$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>$1f5a16020b51a07b$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], newLen = newItems.length, i, j;
        newItems[$1f5a16020b51a07b$export$17a675b7c02a7b1d];
        return $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
            let newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $1f5a16020b51a07b$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $1f5a16020b51a07b$var$FALLBACK
                    ];
                    mapped[0] = $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $1f5a16020b51a07b$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $1f5a16020b51a07b$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $1f5a16020b51a07b$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>$1f5a16020b51a07b$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [], newLen = newItems.length;
        newItems[$1f5a16020b51a07b$export$17a675b7c02a7b1d];
        return $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
            if (newLen === 0) {
                if (len !== 0) {
                    $1f5a16020b51a07b$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $1f5a16020b51a07b$var$FALLBACK
                    ];
                    mapped[0] = $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $1f5a16020b51a07b$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newLen; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $1f5a16020b51a07b$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newLen;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $1f5a16020b51a07b$var$hydrationEnabled = false;
function $1f5a16020b51a07b$export$849801d35d2160c9() {
    $1f5a16020b51a07b$var$hydrationEnabled = true;
}
function $1f5a16020b51a07b$export$60e54eaca7e7fb38(Comp, props) {
    if ($1f5a16020b51a07b$var$hydrationEnabled) {
        if ($1f5a16020b51a07b$export$2cb4986bed338027.context) {
            const c = $1f5a16020b51a07b$export$2cb4986bed338027.context;
            $1f5a16020b51a07b$var$setHydrateContext($1f5a16020b51a07b$var$nextHydrateContext());
            const r = $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $1f5a16020b51a07b$var$setHydrateContext(c);
            return r;
        }
    }
    return $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $1f5a16020b51a07b$var$trueFn() {
    return true;
}
const $1f5a16020b51a07b$var$propTraps = {
    get (_, property, receiver) {
        if (property === $1f5a16020b51a07b$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $1f5a16020b51a07b$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $1f5a16020b51a07b$var$trueFn,
    deleteProperty: $1f5a16020b51a07b$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $1f5a16020b51a07b$var$trueFn,
            deleteProperty: $1f5a16020b51a07b$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $1f5a16020b51a07b$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $1f5a16020b51a07b$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $1f5a16020b51a07b$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $1f5a16020b51a07b$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if ($1f5a16020b51a07b$var$SUPPORTS_PROXY && proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $1f5a16020b51a07b$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $1f5a16020b51a07b$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($1f5a16020b51a07b$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $1f5a16020b51a07b$var$propTraps);
    const sourcesMap = {};
    const defined = Object.create(null);
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = sourceKeys.length - 1; i >= 0; i--){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined[key]) defined[key] = desc.get ? {
                enumerable: true,
                configurable: true,
                get: $1f5a16020b51a07b$var$resolveSources.bind(sourcesMap[key] = [
                    desc.get.bind(source)
                ])
            } : desc.value !== undefined ? desc : undefined;
            else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                }
            }
        }
    }
    const target = {};
    const definedKeys = Object.keys(defined);
    for(let i = definedKeys.length - 1; i >= 0; i--){
        const key = definedKeys[i], desc = defined[key];
        if (desc && desc.get) Object.defineProperty(target, key, desc);
        else target[key] = desc ? desc.value : undefined;
    }
    return target;
}
function $1f5a16020b51a07b$export$45029c61b0073d87(props, ...keys) {
    const len = keys.length;
    if ($1f5a16020b51a07b$var$SUPPORTS_PROXY && $1f5a16020b51a07b$export$5cd89106e2f6c2c5 in props) {
        const blocked = len > 1 ? keys.flat() : keys[0];
        const claimed = new Set();
        const res = keys.map((k)=>{
            const owned = k.filter((property)=>!claimed.has(property) && (claimed.add(property), true));
            return new Proxy({
                get (property) {
                    return owned.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return owned.includes(property) && property in props;
                },
                keys () {
                    return owned.filter((property)=>property in props);
                }
            }, $1f5a16020b51a07b$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.includes(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.includes(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.includes(k));
            }
        }, $1f5a16020b51a07b$var$propTraps));
        return res;
    }
    const objects = [];
    for(let i = 0; i <= len; i++)objects[i] = {};
    for (const propName of Object.getOwnPropertyNames(props)){
        let keyIndex = len;
        for(let i = 0; i < keys.length; i++)if (keys[i].includes(propName)) {
            keyIndex = i;
            break;
        }
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        isDefaultDesc ? objects[keyIndex][propName] = desc.value : Object.defineProperty(objects[keyIndex], propName, desc);
    }
    return objects;
}
function $1f5a16020b51a07b$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const load = ()=>{
        if (!p) {
            const cur = p = fn();
            cur.then((mod)=>{
                comp = ()=>mod.default;
            }, ()=>{
                if (p === cur) p = undefined;
            });
        }
        return p;
    };
    const wrap = (props)=>{
        const ctx = $1f5a16020b51a07b$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5();
            $1f5a16020b51a07b$export$2cb4986bed338027.count || ($1f5a16020b51a07b$export$2cb4986bed338027.count = 0);
            $1f5a16020b51a07b$export$2cb4986bed338027.count++;
            load().then((mod)=>{
                !$1f5a16020b51a07b$export$2cb4986bed338027.done && $1f5a16020b51a07b$var$setHydrateContext(ctx);
                $1f5a16020b51a07b$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $1f5a16020b51a07b$var$setHydrateContext();
            }, (err)=>{
                !$1f5a16020b51a07b$export$2cb4986bed338027.done && $1f5a16020b51a07b$var$setHydrateContext(ctx);
                $1f5a16020b51a07b$export$2cb4986bed338027.count--;
                set(()=>()=>{
                        throw err;
                    });
                $1f5a16020b51a07b$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $1f5a16020b51a07b$export$edd172c6c83c39cc(()=>load().then((mod)=>mod.default));
            comp = s;
            $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>comp = undefined);
        }
        let Comp;
        return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>(Comp = comp?.()) ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>{
                $1f5a16020b51a07b$var$IS_DEV;
                if (!ctx || $1f5a16020b51a07b$export$2cb4986bed338027.done) return Comp(props);
                const c = $1f5a16020b51a07b$export$2cb4986bed338027.context;
                $1f5a16020b51a07b$var$setHydrateContext(ctx);
                const r = Comp(props);
                $1f5a16020b51a07b$var$setHydrateContext(c);
                return r;
            }) : "");
    };
    wrap.preload = ()=>load();
    return wrap;
}
let $1f5a16020b51a07b$var$counter = 0;
function $1f5a16020b51a07b$export$33208d63bc845a83() {
    const ctx = $1f5a16020b51a07b$export$2cb4986bed338027.context;
    return ctx ? $1f5a16020b51a07b$export$2cb4986bed338027.getNextContextId() : `cl-${$1f5a16020b51a07b$var$counter++}`;
}
const $1f5a16020b51a07b$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $1f5a16020b51a07b$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa($1f5a16020b51a07b$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $1f5a16020b51a07b$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa($1f5a16020b51a07b$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $1f5a16020b51a07b$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const conditionValue = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, undefined);
    const condition = keyed ? conditionValue : $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
        equals: (a, b)=>!a === !b
    });
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$1f5a16020b51a07b$export$363ebc4b78b8f807(condition)) throw $1f5a16020b51a07b$var$narrowedError("Show");
                    return conditionValue();
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $1f5a16020b51a07b$export$b5d5cf8927ab7262(props) {
    const chs = $1f5a16020b51a07b$export$bacb5cc5a11aef16(()=>props.children);
    const switchFunc = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        const ch = chs();
        const mps = Array.isArray(ch) ? ch : [
            ch
        ];
        let func = ()=>undefined;
        for(let i = 0; i < mps.length; i++){
            const index = i;
            const mp = mps[i];
            const prevFunc = func;
            const conditionValue = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>prevFunc() ? undefined : mp.when, undefined, undefined);
            const condition = mp.keyed ? conditionValue : $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
                equals: (a, b)=>!a === !b
            });
            func = ()=>prevFunc() || (condition() ? [
                    index,
                    conditionValue,
                    mp
                ] : undefined);
        }
        return func;
    });
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        const sel = switchFunc()();
        if (!sel) return props.fallback;
        const [index, conditionValue, mp] = sel;
        const child = mp.children;
        const fn = typeof child === "function" && child.length > 0;
        return fn ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>child(mp.keyed ? conditionValue() : ()=>{
                if ($1f5a16020b51a07b$export$363ebc4b78b8f807(switchFunc)()?.[0] !== index) throw $1f5a16020b51a07b$var$narrowedError("Match");
                return conditionValue();
            })) : child;
    }, undefined, undefined);
}
function $1f5a16020b51a07b$export$f421feb8fad20413(props) {
    return props;
}
let $1f5a16020b51a07b$var$Errors;
function $1f5a16020b51a07b$export$4eaee74ee7a14dca() {
    $1f5a16020b51a07b$var$Errors && [
        ...$1f5a16020b51a07b$var$Errors
    ].forEach((fn)=>fn());
}
function $1f5a16020b51a07b$export$e926676385687eaf(props) {
    let err;
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context && $1f5a16020b51a07b$export$2cb4986bed338027.load) err = $1f5a16020b51a07b$export$2cb4986bed338027.load($1f5a16020b51a07b$export$2cb4986bed338027.getContextId());
    const [errored, setErrored] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(err, undefined);
    $1f5a16020b51a07b$var$Errors || ($1f5a16020b51a07b$var$Errors = new Set());
    $1f5a16020b51a07b$var$Errors.add(setErrored);
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>$1f5a16020b51a07b$var$Errors.delete(setErrored));
    return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $1f5a16020b51a07b$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $1f5a16020b51a07b$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $1f5a16020b51a07b$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $1f5a16020b51a07b$var$SuspenseListContext = /* #__PURE__ */ $1f5a16020b51a07b$export$fd42f52fd3ae1109();
function $1f5a16020b51a07b$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseListContext);
    const [registry, setRegistry] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $1f5a16020b51a07b$export$60e54eaca7e7fb38($1f5a16020b51a07b$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $1f5a16020b51a07b$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $1f5a16020b51a07b$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(false), SuspenseContext = $1f5a16020b51a07b$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $1f5a16020b51a07b$export$5f4ed0d56c2c0edf();
    if ($1f5a16020b51a07b$export$2cb4986bed338027.context && $1f5a16020b51a07b$export$2cb4986bed338027.load) {
        const key = $1f5a16020b51a07b$export$2cb4986bed338027.getContextId();
        let ref = $1f5a16020b51a07b$export$2cb4986bed338027.load(key);
        if (ref) {
            if (typeof ref !== "object" || ref.s !== 1) p = ref;
            else $1f5a16020b51a07b$export$2cb4986bed338027.gather(key);
        }
        if (p && p !== "$$f") {
            const [s, set] = $1f5a16020b51a07b$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then(()=>{
                if ($1f5a16020b51a07b$export$2cb4986bed338027.done) return set();
                $1f5a16020b51a07b$export$2cb4986bed338027.gather(key);
                $1f5a16020b51a07b$var$setHydrateContext(ctx);
                set();
                $1f5a16020b51a07b$var$setHydrateContext();
            }, (err)=>{
                error = err;
                set();
            });
        }
    }
    const listContext = $1f5a16020b51a07b$export$fae74005e78b1a27($1f5a16020b51a07b$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $1f5a16020b51a07b$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $1f5a16020b51a07b$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $1f5a16020b51a07b$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $1f5a16020b51a07b$var$setHydrateContext();
                const rendered = $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $1f5a16020b51a07b$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $1f5a16020b51a07b$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $1f5a16020b51a07b$var$setHydrateContext({
                                id: ctx.id + "F",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $1f5a16020b51a07b$export$404582bc18fe4d9e = undefined;


const $fb40d00dea10da1a$var$booleans = [
    "allowfullscreen",
    "async",
    "alpha",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected",
    "adauctionheaders",
    "browsingtopics",
    "credentialless",
    "defaultchecked",
    "defaultmuted",
    "defaultselected",
    "defer",
    "disablepictureinpicture",
    "disableremoteplayback",
    "preservespitch",
    "shadowrootclonable",
    "shadowrootcustomelementregistry",
    "shadowrootdelegatesfocus",
    "shadowrootserializable",
    "sharedstoragewritable"
];
const $fb40d00dea10da1a$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "noValidate",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    "adAuctionHeaders",
    "allowFullscreen",
    "browsingTopics",
    "defaultChecked",
    "defaultMuted",
    "defaultSelected",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "preservesPitch",
    "shadowRootClonable",
    "shadowRootCustomElementRegistry",
    "shadowRootDelegatesFocus",
    "shadowRootSerializable",
    "sharedStorageWritable",
    ...$fb40d00dea10da1a$var$booleans
]);
const $fb40d00dea10da1a$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $fb40d00dea10da1a$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $fb40d00dea10da1a$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    novalidate: {
        $: "noValidate",
        FORM: 1
    },
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    },
    adauctionheaders: {
        $: "adAuctionHeaders",
        IFRAME: 1
    },
    allowfullscreen: {
        $: "allowFullscreen",
        IFRAME: 1
    },
    browsingtopics: {
        $: "browsingTopics",
        IMG: 1
    },
    defaultchecked: {
        $: "defaultChecked",
        INPUT: 1
    },
    defaultmuted: {
        $: "defaultMuted",
        AUDIO: 1,
        VIDEO: 1
    },
    defaultselected: {
        $: "defaultSelected",
        OPTION: 1
    },
    disablepictureinpicture: {
        $: "disablePictureInPicture",
        VIDEO: 1
    },
    disableremoteplayback: {
        $: "disableRemotePlayback",
        AUDIO: 1,
        VIDEO: 1
    },
    preservespitch: {
        $: "preservesPitch",
        AUDIO: 1,
        VIDEO: 1
    },
    shadowrootclonable: {
        $: "shadowRootClonable",
        TEMPLATE: 1
    },
    shadowrootdelegatesfocus: {
        $: "shadowRootDelegatesFocus",
        TEMPLATE: 1
    },
    shadowrootserializable: {
        $: "shadowRootSerializable",
        TEMPLATE: 1
    },
    sharedstoragewritable: {
        $: "sharedStorageWritable",
        IFRAME: 1,
        IMG: 1
    }
});
function $fb40d00dea10da1a$export$72dcdd3761a309a9(prop, tagName) {
    const a = $fb40d00dea10da1a$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $fb40d00dea10da1a$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $fb40d00dea10da1a$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $fb40d00dea10da1a$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $fb40d00dea10da1a$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "webview",
    "isindex",
    "listing",
    "multicol",
    "nextid",
    "noindex",
    "search"
]);
const $fb40d00dea10da1a$export$7c73462e0d25e514 = (fn)=>(0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>fn());
function $fb40d00dea10da1a$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $fb40d00dea10da1a$var$$$EVENTS = "_$DX_DELEGATE";
function $fb40d00dea10da1a$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $1f5a16020b51a07b$export$882461b6382ed46c)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $fb40d00dea10da1a$export$21a5ca8aa77d35ff(element, code(), !init && element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $fb40d00dea10da1a$export$ce69bd05624d0c48(html, isImportNode, isSVG, isMathML) {
    let node;
    const create = ()=>{
        const t = isMathML ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : isMathML ? t.firstChild : t.content.firstChild;
    };
    const fn = isImportNode ? ()=>(0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $fb40d00dea10da1a$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$fb40d00dea10da1a$var$$$EVENTS] || (document1[$fb40d00dea10da1a$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $fb40d00dea10da1a$var$eventHandler);
        }
    }
}
function $fb40d00dea10da1a$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$fb40d00dea10da1a$var$$$EVENTS]) {
        for (let name of document1[$fb40d00dea10da1a$var$$$EVENTS].keys())document1.removeEventListener(name, $fb40d00dea10da1a$var$eventHandler);
        delete document1[$fb40d00dea10da1a$var$$$EVENTS];
    }
}
function $fb40d00dea10da1a$export$a41c68a4eb5ff164(node, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    if ((name === "value" || name === "defaultValue") && (node.nodeName === "INPUT" || node.nodeName === "TEXTAREA")) node[name] = value ?? "";
    else node[name] = value;
}
function $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $fb40d00dea10da1a$export$75900142c9e21800(node, namespace, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $fb40d00dea10da1a$export$248913d9a30bef7a(node, name, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    value ? node.setAttribute(name, "") : node.removeAttribute(name);
}
function $fb40d00dea10da1a$export$2913c0c0b5623090(node, value) {
    if ($fb40d00dea10da1a$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $fb40d00dea10da1a$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler, typeof handler !== "function" && handler);
}
function $fb40d00dea10da1a$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $fb40d00dea10da1a$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $fb40d00dea10da1a$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $fb40d00dea10da1a$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $fb40d00dea10da1a$export$36a7c0615a5a1a31(node, name, value) {
    value != null ? node.style.setProperty(name, value) : node.style.removeProperty(name);
}
function $fb40d00dea10da1a$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>prevProps.children = $fb40d00dea10da1a$var$insertExpression(node, props.children, prevProps.children));
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>typeof props.ref === "function" && $fb40d00dea10da1a$export$1f96ae73734a86cc(props.ref, node));
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>$fb40d00dea10da1a$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $fb40d00dea10da1a$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $fb40d00dea10da1a$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>fn(element, arg));
}
function $fb40d00dea10da1a$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $fb40d00dea10da1a$var$insertExpression(parent, accessor, initial, marker);
    (0, $1f5a16020b51a07b$export$314dade334ae905d)((current)=>$fb40d00dea10da1a$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $fb40d00dea10da1a$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $fb40d00dea10da1a$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef, props);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $fb40d00dea10da1a$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $fb40d00dea10da1a$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef, props);
    }
}
function $fb40d00dea10da1a$var$hydrate$1(code, element, options = {}) {
    if (globalThis._$HY.done) return $fb40d00dea10da1a$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).completed = globalThis._$HY.completed;
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).events = globalThis._$HY.events;
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).load = (id)=>globalThis._$HY.r[id];
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).has = (id)=>id in globalThis._$HY.r;
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).gather = (root)=>$fb40d00dea10da1a$var$gatherHydratable(element, root);
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry = new Map();
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).context = {
        id: options.renderId || "",
        count: 0
    };
    try {
        $fb40d00dea10da1a$var$gatherHydratable(element, options.renderId);
        return $fb40d00dea10da1a$export$b3890eb0ae9dca99(code, element, [
            ...element.childNodes
        ], options);
    } finally{
        (0, $1f5a16020b51a07b$export$2cb4986bed338027).context = null;
    }
}
function $fb40d00dea10da1a$export$4109ed81edd7716d(template) {
    let node, key, hydrating = $fb40d00dea10da1a$var$isHydrating();
    if (!hydrating || !(node = (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.get(key = $fb40d00dea10da1a$export$a5a9dff0691837de()))) return template();
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).completed) (0, $1f5a16020b51a07b$export$2cb4986bed338027).completed.add(node);
    (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.delete(key);
    return node;
}
function $fb40d00dea10da1a$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $fb40d00dea10da1a$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ($fb40d00dea10da1a$var$isHydrating(start)) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "$") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $fb40d00dea10da1a$export$6fef5763b6d3688d() {
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).events && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $1f5a16020b51a07b$export$2cb4986bed338027);
            if (!events) return;
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                events.shift();
                $fb40d00dea10da1a$var$eventHandler(e);
            }
            if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).done) {
                (0, $1f5a16020b51a07b$export$2cb4986bed338027).events = _$HY.events = null;
                (0, $1f5a16020b51a07b$export$2cb4986bed338027).completed = _$HY.completed = null;
            }
        });
        (0, $1f5a16020b51a07b$export$2cb4986bed338027).events.queued = true;
    }
}
function $fb40d00dea10da1a$var$isHydrating(node) {
    return !!(0, $1f5a16020b51a07b$export$2cb4986bed338027).context && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).done && (!node || node.isConnected);
}
function $fb40d00dea10da1a$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $fb40d00dea10da1a$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $fb40d00dea10da1a$var$assignProp(node, prop, value, prev, isSVG, skipRef, props) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $fb40d00dea10da1a$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $fb40d00dea10da1a$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev, typeof prev !== "function" && prev);
        value && node.addEventListener(e, value, typeof value !== "function" && value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $fb40d00dea10da1a$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $fb40d00dea10da1a$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $fb40d00dea10da1a$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if (prop.slice(0, 5) === "bool:") $fb40d00dea10da1a$export$248913d9a30bef7a(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $fb40d00dea10da1a$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $fb40d00dea10da1a$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $fb40d00dea10da1a$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-") || "is" in props)) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if ($fb40d00dea10da1a$var$isHydrating(node)) return value;
        if (prop === "class" || prop === "className") $fb40d00dea10da1a$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$fb40d00dea10da1a$var$toPropertyName(prop)] = value;
        else if ((prop === "value" || prop === "defaultValue") && (node.nodeName === "INPUT" || node.nodeName === "TEXTAREA")) node[propAlias || prop] = value ?? "";
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $fb40d00dea10da1a$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $fb40d00dea10da1a$export$75900142c9e21800(node, ns, prop, value);
        else $fb40d00dea10da1a$export$9fec4d97f1922e0b(node, $fb40d00dea10da1a$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $fb40d00dea10da1a$var$eventHandler(e) {
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).registry && (0, $1f5a16020b51a07b$export$2cb4986bed338027).events) {
        if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).events.find(([el, ev])=>ev === e)) return;
    }
    let node = e.target;
    const key = `$$${e.type}`;
    const oriTarget = e.target;
    const oriCurrentTarget = e.currentTarget;
    const retarget = (value)=>Object.defineProperty(e, "target", {
            configurable: true,
            value: value
        });
    const handleNode = ()=>{
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node.host && typeof node.host !== "string" && !node.host._$host && node.contains(e.target) && retarget(node.host);
        return true;
    };
    const walkUpTree = ()=>{
        while(handleNode() && (node = node._$host || node.parentNode || node.host));
    };
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $1f5a16020b51a07b$export$2cb4986bed338027).registry && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).done) (0, $1f5a16020b51a07b$export$2cb4986bed338027).done = _$HY.done = true;
    try {
        if (e.composedPath) {
            const path = e.composedPath();
            retarget(path[0]);
            for(let i = 0; i < path.length - 2; i++){
                node = path[i];
                if (!handleNode()) break;
                if (node._$host) {
                    node = node._$host;
                    walkUpTree();
                    break;
                }
                if (node.parentNode === oriCurrentTarget) break;
            }
        } else walkUpTree();
        retarget(oriTarget);
    } finally{
        e = node = null;
    }
}
function $fb40d00dea10da1a$var$insertExpression(parent, value, current, marker, unwrapArray) {
    const hydrating = $fb40d00dea10da1a$var$isHydrating(parent);
    if (hydrating) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if (hydrating) return current;
        if (t === "number") {
            value = value.toString();
            if (value === current) return current;
        }
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data !== value && (node.data = value);
            else node = document.createTextNode(value);
            current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if (hydrating) return current;
        current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $fb40d00dea10da1a$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($fb40d00dea10da1a$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>current = $fb40d00dea10da1a$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if (hydrating) {
            if (!array.length) return current;
            if (marker === undefined) return current = [
                ...parent.childNodes
            ];
            let node = array[0];
            if (node.parentNode !== parent) return current;
            const nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $fb40d00dea10da1a$var$appendNodes(parent, array, marker);
            else $fb40d00dea10da1a$var$reconcileArrays(parent, current, array);
        } else {
            current && $fb40d00dea10da1a$var$cleanChildren(parent);
            $fb40d00dea10da1a$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if (hydrating && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $fb40d00dea10da1a$var$cleanChildren(parent, current, marker, value);
            $fb40d00dea10da1a$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function $fb40d00dea10da1a$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[normalized.length], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $fb40d00dea10da1a$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $fb40d00dea10da1a$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $fb40d00dea10da1a$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $fb40d00dea10da1a$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $fb40d00dea10da1a$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.has(key)) (0, $1f5a16020b51a07b$export$2cb4986bed338027).registry.set(key, node);
    }
}
function $fb40d00dea10da1a$export$a5a9dff0691837de() {
    return (0, $1f5a16020b51a07b$export$2cb4986bed338027).getNextContextId();
}
function $fb40d00dea10da1a$export$36143b7c9c07dd39(props) {
    return (0, $1f5a16020b51a07b$export$2cb4986bed338027).context ? undefined : props.children;
}
function $fb40d00dea10da1a$export$da8cca6e5dfa3577(props) {
    return props.children;
}
const $fb40d00dea10da1a$export$c8eca95e306f7116 = ()=>undefined;
const $fb40d00dea10da1a$export$5df49ba75ba1c1f9 = Symbol();
function $fb40d00dea10da1a$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $1f5a16020b51a07b$export$2cb4986bed338027).context && (parent.innerHTML = content);
}
function $fb40d00dea10da1a$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $fb40d00dea10da1a$export$80e7718417253a51(fn, options) {
    $fb40d00dea10da1a$var$throwInBrowser($fb40d00dea10da1a$export$80e7718417253a51);
}
function $fb40d00dea10da1a$export$f3aefc4196cd5f3e(fn, options) {
    $fb40d00dea10da1a$var$throwInBrowser($fb40d00dea10da1a$export$f3aefc4196cd5f3e);
}
function $fb40d00dea10da1a$export$97f86213fef5749d(fn, options) {
    $fb40d00dea10da1a$var$throwInBrowser($fb40d00dea10da1a$export$97f86213fef5749d);
}
function $fb40d00dea10da1a$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $fb40d00dea10da1a$export$1844beb7faeb4553(name, props, children, needsId) {}
function $fb40d00dea10da1a$export$e92e0c287593a882(value) {}
function $fb40d00dea10da1a$export$9e97f11b9d683d7a(value) {}
function $fb40d00dea10da1a$export$9ab8bdc1e27e51e1(key, value) {}
function $fb40d00dea10da1a$export$7e66a08c0b8ab2aa() {}
function $fb40d00dea10da1a$export$755e9f954b4fd36e(node) {}
function $fb40d00dea10da1a$export$4e7f196112fea3c5(html) {}
function $fb40d00dea10da1a$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $fb40d00dea10da1a$export$6acf61af03e62db = false;
const $fb40d00dea10da1a$export$40edfb7eeb78c4e8 = false;
const $fb40d00dea10da1a$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $fb40d00dea10da1a$var$createElement(tagName, isSVG = false, is) {
    return isSVG ? document.createElementNS($fb40d00dea10da1a$var$SVG_NAMESPACE, tagName) : document.createElement(tagName, {
        is: is
    });
}
const $fb40d00dea10da1a$export$fa8d919ba61d84db = (...args)=>{
    (0, $1f5a16020b51a07b$export$849801d35d2160c9)();
    return $fb40d00dea10da1a$var$hydrate$1(...args);
};
function $fb40d00dea10da1a$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $1f5a16020b51a07b$export$5f4ed0d56c2c0edf)();
    let content;
    let hydrating = !!(0, $1f5a16020b51a07b$export$2cb4986bed338027).context;
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (hydrating) (0, $1f5a16020b51a07b$export$5f4ed0d56c2c0edf)().user = hydrating = false;
        content || (content = (0, $1f5a16020b51a07b$export$c14f3e3abbc7d6b5)(owner, ()=>(0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
            const cleanup = ()=>setClean(true);
            (0, $1f5a16020b51a07b$export$882461b6382ed46c)((dispose)=>$fb40d00dea10da1a$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(cleanup);
        } else {
            const container = $fb40d00dea10da1a$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $fb40d00dea10da1a$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>el.contains(container) && el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $fb40d00dea10da1a$export$9a3ff77bac07eb26(component, props) {
    const cached = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(component);
    return (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                return (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>component(props));
            case "string":
                const isSvg = $fb40d00dea10da1a$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $1f5a16020b51a07b$export$2cb4986bed338027).context ? $fb40d00dea10da1a$export$4109ed81edd7716d() : $fb40d00dea10da1a$var$createElement(component, isSvg, (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>props.is));
                $fb40d00dea10da1a$export$3ae0fd4797ed47c8(el, props, isSvg);
                return el;
        }
    });
}
function $fb40d00dea10da1a$export$e18282e419e46834(props) {
    const [, others] = (0, $1f5a16020b51a07b$export$45029c61b0073d87)(props, [
        "component"
    ]);
    return $fb40d00dea10da1a$export$9a3ff77bac07eb26(()=>props.component, others);
}




var $9DGpR = parcelRequire("9DGpR");

var $9DGpR = parcelRequire("9DGpR");

class $d31846142152482d$export$3bb977b3ba9d3b59 {
    constructor(initialName){
        this.parent = null;
        const [name, setName] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(initialName);
        this.name = name;
        this.setName = setName;
    }
    removeFromParent() {
        if (this.parent) {
            this.parent.setEntries((entries)=>entries.delete(this.name()));
            this.parent = null;
        }
    }
    moveTo(destEntry) {
        this.removeFromParent();
        destEntry.add(this);
    }
}
class $d31846142152482d$export$5230a91395080b61 extends $d31846142152482d$export$3bb977b3ba9d3b59 {
    constructor(name){
        super(name);
        const [entries, setEntries] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((0, $9DGpR.Map)());
        this.entries = entries;
        this.setEntries = setEntries;
        this.totalSize = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
            let totalSize = 0;
            for (const [, entry] of this.entries())totalSize += entry.totalSize();
            return totalSize;
        });
    }
    add(entry) {
        this.setEntries((entries)=>entries.set(entry.name(), entry));
        entry.parent = this;
    }
    addInputFiles(inputFiles, onEntry) {
        for (const inputFile of inputFiles){
            const path = (0, $9DGpR.List)((inputFile.webkitRelativePath || inputFile.name).replaceAll('\\', '/').split('/'));
            // traverse path, creating directories on the way
            let directory = this;
            for(let i = 0; i + 1 < path.size; ++i){
                const nextDirectory = directory.entries().get(path.get(i));
                if (nextDirectory == null) {
                    const newDirectory = new $d31846142152482d$export$51c46da272110b9a(path.get(i));
                    onEntry?.(newDirectory);
                    directory.add(newDirectory);
                    directory = newDirectory;
                } else if (!(nextDirectory instanceof $d31846142152482d$export$51c46da272110b9a)) throw {
                    error: 'path_not_directory',
                    path: path.slice(0, i + 1)
                };
                else directory = nextDirectory;
            }
            // create file
            if (directory.entries().has(path.last())) throw {
                error: 'file_exists',
                path: path
            };
            const entry = new $d31846142152482d$export$af701efb7ddbdf6b(path.last(), {
                size: inputFile.size,
                blob: inputFile
            });
            onEntry?.(entry);
            directory.add(entry);
        }
    }
    async addInputFileSystemEntry(fileSystemEntry, onEntry) {
        const name = fileSystemEntry.name;
        if (fileSystemEntry.isDirectory) {
            const entry = new $d31846142152482d$export$51c46da272110b9a(name);
            onEntry?.(entry);
            this.add(entry);
            const directoryReader = fileSystemEntry.createReader();
            for(;;){
                const subEntries = await new Promise((resolve, reject)=>directoryReader.readEntries(resolve, reject));
                if (subEntries.length <= 0) break;
                for (const subEntry of subEntries)await entry.addInputFileSystemEntry(subEntry, onEntry);
            }
        } else if (fileSystemEntry.isFile) {
            const file = await new Promise((resolve, reject)=>fileSystemEntry.file(resolve, reject));
            const entry = new $d31846142152482d$export$af701efb7ddbdf6b(name, {
                size: file.size,
                blob: file
            });
            onEntry?.(entry);
            this.add(entry);
        }
    }
    async addInputDataTransferItems(items, onEntry) {
        for (const item of items){
            const entry = item.getAsEntry?.() ?? item.webkitGetAsEntry?.();
            if (entry) await this.addInputFileSystemEntry(entry, onEntry);
        }
    }
}
class $d31846142152482d$export$51c46da272110b9a extends $d31846142152482d$export$5230a91395080b61 {
    constructor(name){
        super(name);
    }
    clone() {
        const clonedEntry = new $d31846142152482d$export$51c46da272110b9a(this.name());
        clonedEntry.setEntries(this.entries().map((subentry)=>{
            const clonedSubentry = subentry.clone();
            clonedSubentry.parent = clonedEntry;
            return clonedSubentry;
        }));
        return clonedEntry; // appease type checker; OK because this class is final
    }
}
class $d31846142152482d$export$af701efb7ddbdf6b extends $d31846142152482d$export$3bb977b3ba9d3b59 {
    constructor(name, init){
        super(name);
        this.size = init.size;
        this.blob = init.blob;
        const [mode, setMode] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(init.mode ?? 0);
        this.mode = mode;
        this.setMode = setMode;
        this.chunks = init.chunks ?? undefined;
        this.offset = init.offset;
    }
    totalSize() {
        return this.size;
    }
    clone() {
        return new $d31846142152482d$export$af701efb7ddbdf6b(this.name(), {
            size: this.size,
            blob: this.blob,
            mode: this.mode(),
            chunks: this.chunks,
            offset: this.offset
        }); // appease type checker; OK because this class is final
    }
}
var $d31846142152482d$export$e019a04e95b2bad = /*#__PURE__*/ function(FileEntryMode) {
    FileEntryMode[FileEntryMode["Executable"] = 1] = "Executable";
    FileEntryMode[FileEntryMode["Fuck"] = 2] = "Fuck";
    return FileEntryMode;
}({});
class $d31846142152482d$export$19b7813f051eae extends $d31846142152482d$export$3bb977b3ba9d3b59 {
    constructor(name, link){
        super(name);
        this.link = link;
    }
    totalSize() {
        return 0;
    }
    clone() {
        return new $d31846142152482d$export$19b7813f051eae(this.name(), this.link); // appease type checker; OK because this class is final
    }
}


const $f710aae7717efd0b$export$c5411f1b08998578 = (buf)=>[
        ...new Uint8Array(buf)
    ].map((b)=>b.toString(16).padStart(2, '0')).join('');


const $fe57e090ef2afef2$var$chunkSize = 1024;
const $fe57e090ef2afef2$var$textEncoder = new TextEncoder();
const $fe57e090ef2afef2$var$textDecoder = new TextDecoder();
const $fe57e090ef2afef2$var$indexMagic = $fe57e090ef2afef2$var$textEncoder.encode("KCAI");
var $fe57e090ef2afef2$var$EntryType = /*#__PURE__*/ function(EntryType) {
    EntryType[EntryType["Directory"] = 0] = "Directory";
    EntryType[EntryType["File"] = 1] = "File";
    EntryType[EntryType["Symlink"] = 2] = "Symlink";
    return EntryType;
}($fe57e090ef2afef2$var$EntryType || {});
var $fe57e090ef2afef2$export$53ba34a64bd6362a = /*#__PURE__*/ function(ChunkingAlgorithm) {
    ChunkingAlgorithm[ChunkingAlgorithm["None"] = 0] = "None";
    ChunkingAlgorithm[ChunkingAlgorithm["Gear17"] = 1] = "Gear17";
    return ChunkingAlgorithm;
}({});
var $fe57e090ef2afef2$export$dea40e325ea0b38b = /*#__PURE__*/ function(CompressionAlgorithm) {
    CompressionAlgorithm[CompressionAlgorithm["None"] = 0] = "None";
    CompressionAlgorithm[CompressionAlgorithm["Zstd"] = 1] = "Zstd";
    return CompressionAlgorithm;
}({});
var $fe57e090ef2afef2$var$EntryFileModes = /*#__PURE__*/ function(EntryFileModes) {
    EntryFileModes[EntryFileModes["Executable"] = 1] = "Executable";
    return EntryFileModes;
}($fe57e090ef2afef2$var$EntryFileModes || {});
const $fe57e090ef2afef2$export$81c6440f04a67fe0 = (root)=>(0, $9DGpR.Set)().withMutations((chunks)=>{
        function collectEntryChunks(entry) {
            if (entry instanceof (0, $d31846142152482d$export$51c46da272110b9a)) collectEntriesChunks(entry.entries());
            if (entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b)) {
                if (entry.chunks) for (const chunk of entry.chunks)chunks = chunks.add((0, $f710aae7717efd0b$export$c5411f1b08998578)(chunk.hash));
            }
        }
        function collectEntriesChunks(entries) {
            for (const [_entryName, entry] of entries)collectEntryChunks(entry);
        }
        collectEntriesChunks(root.entries());
    });
class $fe57e090ef2afef2$var$ArchiveBuilder {
    constructor(chunkingAlgorithm, compressionAlgorithm, baseChunkSet){
        this.indexChunks = (0, $9DGpR.List)();
        this.indexChunkView = null;
        this.indexChunkArray = null;
        this.indexChunkPosition = 0;
        this.filesBlobs = [];
        this.chunkingAlgorithm = chunkingAlgorithm;
        this.compressionAlgorithm = compressionAlgorithm;
        this.baseChunkSet = baseChunkSet;
        this.writeNumber(this.chunkingAlgorithm);
        this.writeNumber(this.compressionAlgorithm);
    }
    checkSpace() {
        if (this.indexChunks.isEmpty() || this.indexChunkPosition >= $fe57e090ef2afef2$var$chunkSize) {
            const buffer = new ArrayBuffer($fe57e090ef2afef2$var$chunkSize);
            this.indexChunks = this.indexChunks.push(buffer);
            this.indexChunkView = new DataView(buffer);
            this.indexChunkArray = new Uint8Array(buffer);
            this.indexChunkPosition = 0;
        }
    }
    writeByte(byte) {
        this.checkSpace();
        this.indexChunkView.setUint8(this.indexChunkPosition++, byte);
    }
    writeUint8Array(bytes, start = 0, end = bytes.byteLength) {
        while(start < end){
            this.checkSpace();
            const size = Math.min(end - start, $fe57e090ef2afef2$var$chunkSize - this.indexChunkPosition);
            this.indexChunkArray.set(bytes.slice(start, start + size), this.indexChunkPosition);
            this.indexChunkPosition += size;
            start += size;
        }
    }
    writeNumber(n) {
        do {
            let b = n & 0x7F;
            n >>= 7;
            if (n > 0) b |= 0x80;
            this.writeByte(b);
        }while (n > 0);
    }
    writeNumberWithSameSizeAs(n, ref) {
        do {
            let b = n & 0x7F;
            n >>= 7;
            ref >>= 7;
            if (n > 0 || ref > 0) b |= 0x80;
            this.writeByte(b);
        }while (n > 0 || ref > 0);
    }
    async writeEntries(entries) {
        this.writeNumber(entries.size);
        for (const [encodedName, entry] of entries.entrySeq().map(([name, entry])=>[
                $fe57e090ef2afef2$var$textEncoder.encode(name),
                entry
            ]).sort($fe57e090ef2afef2$export$2c68bf7bc3012321)){
            this.writeNumber(encodedName.byteLength);
            this.writeUint8Array(encodedName);
            await this.writeEntry(entry);
        }
    }
    async writeEntry(entry) {
        if (entry instanceof (0, $d31846142152482d$export$51c46da272110b9a)) {
            this.writeNumber(0);
            await this.writeEntries(entry.entries());
        } else if (entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b)) {
            this.writeNumber(1);
            this.writeNumber(entry.size);
            this.writeNumber(entry.mode());
            if (this.chunkingAlgorithm != 0) {
                // create chunks if needed
                if (entry.size > 0 && (entry.chunks?.length ?? 0) <= 0 && entry.blob) {
                    const chunks = [];
                    for await (const chunk of $fe57e090ef2afef2$export$19d907f5008a0f2(entry.blob))chunks.push({
                        ...chunk,
                        compressedSize: 0
                    });
                    entry.chunks = chunks;
                }
                this.writeNumber(entry.chunks?.length ?? 0);
                if (entry.chunks) for(let i = 0; i < entry.chunks.length; ++i){
                    const chunk = entry.chunks[i];
                    this.writeUint8Array(new Uint8Array(chunk.hash));
                    // skip chunk if presented in base chunk set
                    if (this.baseChunkSet && this.baseChunkSet.has((0, $f710aae7717efd0b$export$c5411f1b08998578)(chunk.hash))) this.writeNumber(0);
                    else {
                        this.writeNumber(chunk.size);
                        if (this.compressionAlgorithm != 0) this.writeNumberWithSameSizeAs(chunk.compressedSize, chunk.size);
                    }
                }
            }
            if (entry.blob) {
                if (this.chunkingAlgorithm != 0 && entry.chunks) {
                    let offset = 0;
                    for(let i = 0; i < entry.chunks.length;){
                        let j;
                        let size = 0;
                        for(j = i; j < entry.chunks.length && !(this.baseChunkSet && this.baseChunkSet.has((0, $f710aae7717efd0b$export$c5411f1b08998578)(entry.chunks[j].hash))); ++j)size += entry.chunks[j].size;
                        if (i >= j) {
                            offset += entry.chunks[i++].size;
                            continue;
                        }
                        this.filesBlobs.push(entry.blob.slice(offset, offset + size));
                        offset += size;
                        i = j;
                    }
                } else this.filesBlobs.push(entry.blob);
            }
        } else if (entry instanceof (0, $d31846142152482d$export$19b7813f051eae)) {
            this.writeNumber(2);
            const encodedLink = $fe57e090ef2afef2$var$textEncoder.encode(entry.link);
            this.writeNumber(encodedLink.byteLength);
            this.writeUint8Array(encodedLink);
        }
    }
    async finalize() {
        let chunks = this.indexChunks;
        if (!this.indexChunks.isEmpty() && this.indexChunkPosition < $fe57e090ef2afef2$var$chunkSize) chunks = chunks.set(chunks.size - 1, chunks.last().slice(0, this.indexChunkPosition));
        // prepend chunk with index size
        {
            const buffer = new ArrayBuffer($fe57e090ef2afef2$var$chunkSize);
            this.indexChunkView = new DataView(buffer);
            this.indexChunkArray = new Uint8Array(buffer);
            this.indexChunkPosition = 0;
            let indexSize = 0;
            for (const chunk of chunks)indexSize += chunk.byteLength;
            this.writeNumber(indexSize);
            chunks = chunks.insert(0, buffer.slice(0, this.indexChunkPosition));
        }
        // calculate index hash
        const indexHash = await crypto.subtle.digest('SHA-256', await new Blob(chunks.toArray()).arrayBuffer());
        // prepend chunk with magic and hash
        {
            const buffer = new ArrayBuffer($fe57e090ef2afef2$var$chunkSize);
            this.indexChunkView = new DataView(buffer);
            this.indexChunkArray = new Uint8Array(buffer);
            this.indexChunkPosition = 0;
            this.writeUint8Array($fe57e090ef2afef2$var$indexMagic);
            this.writeUint8Array(new Uint8Array(indexHash));
            chunks = chunks.insert(0, buffer.slice(0, this.indexChunkPosition));
        }
        return new Blob([
            ...chunks.toArray(),
            ...this.filesBlobs
        ]);
    }
}
const $fe57e090ef2afef2$export$e8e171792b146fcc = async (root, chunkingAlgorithm = 1, compressionAlgorithm = 0, baseChunkSet)=>{
    const builder = new $fe57e090ef2afef2$var$ArchiveBuilder(chunkingAlgorithm, compressionAlgorithm, baseChunkSet);
    await builder.writeEntries(root.entries());
    return builder.finalize();
};
class $fe57e090ef2afef2$export$5edc3959ad1c0771 {
    constructor(reader){
        this.chunkOffset = 0;
        this.chunkSize = 0;
        this.fileEntries = [];
        this.totalReadSize = 0;
        this.totalFilesSize = 0;
        this.reader = reader;
    }
    async readIndex(entryCallback) {
        // check magic
        for(let i = 0; i < $fe57e090ef2afef2$var$indexMagic.byteLength; ++i){
            if (await this.readByte() != $fe57e090ef2afef2$var$indexMagic.at(i)) throw 'wrong_magic';
        }
        // read hash
        const indexHash = await this.readArray(32);
        const indexOffset = this.totalReadSize;
        // read size
        const indexSize = await this.readNumber();
        const indexOffset2 = this.totalReadSize;
        // get encoded size directly from chunk, hack, but must be OK
        const indexSizeData = this.chunk.slice(indexOffset, indexOffset2);
        // check hash
        const indexData = await this.readArray(indexSize);
        {
            const indexAndSizeData = await new Blob([
                indexSizeData,
                indexData
            ]).arrayBuffer();
            const indexDataHash = new Uint8Array(await crypto.subtle.digest('SHA-256', indexAndSizeData));
            for(let i = 0; i < 32; ++i)if (indexHash.at(i) != indexDataHash.at(i)) throw 'wrong_index_hash';
        }
        // set up reading from index
        await this.putChunk(indexData);
        this.totalReadSize -= indexData.byteLength;
        // read header
        this.chunkingAlgorithm = await this.readNumber();
        this.compressionAlgorithm = await this.readNumber();
        // read entries
        const entry = new (0, $d31846142152482d$export$51c46da272110b9a)('');
        entry.setEntries(await this.readEntries(entryCallback));
        // check position
        if (indexOffset2 + indexSize != this.totalReadSize) throw 'wrong_index_size';
        // fix file offsets
        for (const fileEntry of this.fileEntries)fileEntry.offset += this.totalReadSize;
        return entry;
    }
    // returns data stream
    // the stream must be consumed before reading anything else
    readDataStream(size) {
        return async function*(self) {
            let position = 0;
            while(position < size){
                if (self.chunkOffset >= self.chunkSize) await self.readChunk();
                const toReadSize = Math.min(size - position, self.chunkSize - self.chunkOffset);
                const chunkSlice = self.chunk.slice(self.chunkOffset, self.chunkOffset + toReadSize);
                self.chunkOffset += toReadSize;
                position += toReadSize;
                yield chunkSlice;
            }
        }(this);
    }
    async readEntries(entryCallback) {
        let entries = (0, $9DGpR.Map)();
        const entriesCount = await this.readNumber();
        if (entriesCount >= 0x100000) throw 'too_many_entries';
        for(let i = 0; i < entriesCount; ++i){
            const name = $fe57e090ef2afef2$var$textDecoder.decode(await this.readArray(await this.readNumber()));
            const entry = await this.readEntry(name, entryCallback);
            entries = entries.set(name, entry);
        }
        return entries;
    }
    async readEntry(name, entryCallback) {
        switch(await this.readNumber()){
            case 0:
                {
                    const entry = new (0, $d31846142152482d$export$51c46da272110b9a)(name);
                    entry.setEntries(await this.readEntries(entryCallback?.(entry)));
                    return entry;
                }
            case 1:
                {
                    const size = await this.readNumber();
                    const mode = await this.readNumber();
                    const chunks = [];
                    if (this.chunkingAlgorithm != 0) {
                        const chunksCount = await this.readNumber();
                        for(let i = 0; i < chunksCount; ++i){
                            const hash = await this.readArray(32);
                            const size = await this.readNumber();
                            let compressedSize = 0;
                            if (size > 0 && this.compressionAlgorithm != 0) compressedSize = await this.readNumber();
                            chunks.push({
                                hash: hash,
                                size: size,
                                compressedSize: compressedSize
                            });
                        }
                    }
                    const entry = new (0, $d31846142152482d$export$af701efb7ddbdf6b)(name, {
                        size: size,
                        mode: mode,
                        chunks: chunks,
                        offset: this.totalFilesSize
                    });
                    this.totalFilesSize += size;
                    this.fileEntries.push(entry);
                    entryCallback?.(entry);
                    return entry;
                }
            case 2:
                {
                    const link = $fe57e090ef2afef2$var$textDecoder.decode(await this.readArray(await this.readNumber()));
                    const entry = new (0, $d31846142152482d$export$19b7813f051eae)(name, link);
                    entryCallback?.(entry);
                    return entry;
                }
            default:
                throw 'invalid_entry';
        }
    }
    async readNumber() {
        let n = 0, b, offset = 0;
        do {
            b = await this.readByte();
            n |= (b & 0x7F) << offset;
            offset += 7;
        }while (b & 0x80);
        return n;
    }
    async readByte() {
        if (this.chunkOffset >= this.chunkSize) await this.readChunk();
        ++this.totalReadSize;
        return this.chunk.at(this.chunkOffset++);
    }
    async readArray(size) {
        const result = new Uint8Array(size);
        let readSize = 0;
        while(readSize < size){
            if (this.chunkOffset >= this.chunkSize) await this.readChunk();
            const toReadSize = Math.min(size - readSize, this.chunkSize - this.chunkOffset);
            result.set(this.chunk.slice(this.chunkOffset, this.chunkOffset + toReadSize), readSize);
            readSize += toReadSize;
            this.chunkOffset += toReadSize;
        }
        this.totalReadSize += readSize;
        return result;
    }
    async putChunk(chunk) {
        const chunks = [];
        chunks.push(chunk);
        if (this.chunk) chunks.push(this.chunk.slice(this.chunkOffset));
        this.chunk = new Uint8Array(await new Blob(chunks).arrayBuffer());
        this.chunkOffset = 0;
        this.chunkSize = this.chunk.byteLength;
    }
    async readChunk() {
        const { value: value, done: done } = await this.reader.read();
        if (done || value.byteLength <= 0) throw 'archive_ended';
        this.chunk = value instanceof ArrayBuffer ? new Uint8Array(value) : value;
        this.chunkOffset = 0;
        this.chunkSize = this.chunk.byteLength;
    }
}
const $fe57e090ef2afef2$export$b6eb13e118c144bd = async (url)=>{
    const response = await fetch(url, {
        mode: 'cors'
    });
    if (response.status !== 200) throw 'archive_fetch_failed';
    const reader = response.body.getReader();
    const archiveReader = new $fe57e090ef2afef2$export$5edc3959ad1c0771(reader);
    return await archiveReader.readIndex();
};
const $fe57e090ef2afef2$export$f2f515e9682afce7 = (root)=>{
    const indexEntries = (entries)=>entries.map(indexEntry).toObject();
    const indexEntry = (entry)=>{
        if (entry instanceof (0, $d31846142152482d$export$51c46da272110b9a)) return {
            e: indexEntries(entry.entries())
        };
        if (entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b)) return {
            b: entry.offset,
            s: entry.size
        };
        if (entry instanceof (0, $d31846142152482d$export$19b7813f051eae)) return {
            l: entry.link
        };
        throw 'invalid_entry';
    };
    return {
        e: indexEntries(root.entries())
    };
};
const $fe57e090ef2afef2$export$2c68bf7bc3012321 = ([a], [b])=>{
    for(let i = 0; i < a.byteLength && i < b.byteLength; ++i){
        if (a.at(i) < b.at(i)) return -1;
        if (a.at(i) > b.at(i)) return 1;
    }
    if (a.byteLength < b.byteLength) return -1;
    if (a.byteLength > b.byteLength) return 1;
    return 0;
};
// dumped from C++ generator
const $fe57e090ef2afef2$var$gear17Table = new Uint32Array([
    0xd091bb5c,
    0x22ae9ef6,
    0xe7e1faee,
    0xd5c31f79,
    0x2082352c,
    0xf807b7df,
    0xe9d30005,
    0x3895afe1,
    0xa1e24bba,
    0x4ee4092b,
    0x18f86863,
    0x8c16a625,
    0x474ba8c4,
    0x3039cd1a,
    0x8c006d5f,
    0xfe2d7810,
    0xf51f2ae7,
    0xff1816e4,
    0xf702ef59,
    0xf7badafa,
    0x285954a1,
    0xb9d09511,
    0xf878c4b3,
    0xfb2a0137,
    0xf508e4aa,
    0x1c1fe652,
    0x7c419418,
    0xcc50aa59,
    0xccdf2e5c,
    0x4c0a1f3b,
    0x2452a9dc,
    0x01397d8d,
    0x6bf88c31,
    0x1cca797a,
    0xea6da4ae,
    0xa3c78807,
    0xcace1969,
    0xe0e0d4ad,
    0xf5a14bab,
    0x80f00988,
    0xa7de9f4c,
    0xcc450cba,
    0x0924668f,
    0x5c7dc380,
    0xd96089c5,
    0x3640ac4c,
    0xef1a2e6d,
    0xae6d9426,
    0xadc1965b,
    0x6613ba46,
    0xc1fb41c2,
    0xbd9b0ecd,
    0xbe3dedfc,
    0x7989c8ee,
    0x6468fd6e,
    0x6c0df032,
    0xa7cd6634,
    0x2c826d8b,
    0x2bd2e412,
    0x4d4a2dbe,
    0xb4bf6fa7,
    0xcc1a8959,
    0x08263282,
    0x51097330,
    0x46e46cb0,
    0xdf577ec2,
    0x0bd1e364,
    0x262c5564,
    0x18dda0c9,
    0xfe7b45d9,
    0xd2ce21c9,
    0xd268409a,
    0xb1e049e1,
    0x200bfa47,
    0x512d6e73,
    0xc3851eee,
    0xf341c081,
    0x7d973e48,
    0x08d17554,
    0xa9e20d28,
    0x70518ce6,
    0x203ac303,
    0x61add0ab,
    0x35d0430c,
    0xc3f8e892,
    0x0d1c8509,
    0xcb92388e,
    0x095436bf,
    0x2fd6e208,
    0x68a29af9,
    0x7d61330b,
    0x753ec6fc,
    0x7211efea,
    0x7cd15133,
    0xa574c4ff,
    0xcb41f198,
    0xb598eef6,
    0xebbe7347,
    0xc1332568,
    0xceba5a70,
    0x46a99459,
    0xb4ad9f11,
    0xae00feaa,
    0x00b8b573,
    0xa7b480b6,
    0xb5f0b06c,
    0x29a0ec27,
    0xa4daa010,
    0x1e76a1c5,
    0x74be9133,
    0x7f94c950,
    0xc61f6ed6,
    0xf5b1c7a1,
    0x92e195f8,
    0x572384d4,
    0xe0732c88,
    0x95d41b68,
    0xcee496c3,
    0x394bbd52,
    0x048cd47c,
    0xc05309be,
    0xd23d2d63,
    0x414de9c5,
    0xd2229f23,
    0x818666a3,
    0xf0a8b109,
    0xb2f6b127,
    0x69a48341,
    0xe4123c56,
    0x6c548c8f,
    0xf5941f61,
    0x94b993aa,
    0x8c165134,
    0x2876763c,
    0x237ce42e,
    0xc300d11b,
    0x263821ca,
    0x3aeb8202,
    0x41ec0f84,
    0xcf4ac36d,
    0xd7393ee6,
    0xfd0fc06a,
    0x4118a30a,
    0x551b54a4,
    0xd074f86f,
    0x4cc1c54a,
    0x3e57a703,
    0x03774cda,
    0xede43895,
    0x379ce627,
    0x59988939,
    0xe8490ddc,
    0x325410e1,
    0xd9352f6a,
    0x4047080a,
    0xf47c081d,
    0x9db51a85,
    0xc765d71f,
    0x79297527,
    0xfcca2773,
    0x5a065b97,
    0x114dee4f,
    0xd4b12f5f,
    0xcb29360a,
    0x95d3de16,
    0x983162a8,
    0x8cbaafb3,
    0xbb98b27f,
    0xeacd3439,
    0xb1fac842,
    0x492cbef1,
    0xae08ab78,
    0xc1d7dfd0,
    0x646f1d40,
    0xc0f463c4,
    0x8fc23a81,
    0x6164e623,
    0x3543f2bc,
    0x915cc253,
    0x8701d0df,
    0x136b2fdd,
    0x677a359e,
    0x0dcfacd0,
    0x5a4ea31e,
    0x87e25935,
    0x97c34e42,
    0xc77780f0,
    0x5b396fba,
    0xef1b52e6,
    0xf7080941,
    0x2141888b,
    0x278946b0,
    0x919e6d64,
    0x6518b459,
    0x7829fc22,
    0x6325d30e,
    0x030c0399,
    0xba19b463,
    0x564dab75,
    0x63794f97,
    0x2984c787,
    0xed702bbe,
    0xcb563b4d,
    0x6fa56696,
    0x4fabc9ed,
    0xdcd87a48,
    0x874df295,
    0x9ecfe9f0,
    0x2a67f49f,
    0x1e9aa4e1,
    0x9a1b7d08,
    0x78d22934,
    0x43521602,
    0x5718a361,
    0xa771ba44,
    0x87a3b97c,
    0xb0705c82,
    0xb7526048,
    0xbf86dcd7,
    0xfd066ea4,
    0x7356b1bb,
    0xb872426d,
    0x1575515d,
    0xe99eadb3,
    0x3a9e3c0f,
    0x8168599c,
    0xe9d07a32,
    0x8eeab382,
    0x27023ee8,
    0x80d10fac,
    0xd368bdc2,
    0x7664b5a7,
    0x89d0cf46,
    0x8bed7368,
    0xff02af49,
    0x7294e430,
    0x14034fbb,
    0xdabd4cc4,
    0x71535cf8,
    0x9aaeea20,
    0x1b4d989d,
    0x7fa09780,
    0xf63ef3d2,
    0xfadc6788,
    0x012fb568,
    0x08c904fa,
    0xc660883f,
    0xfa1cce2a,
    0xd13ac8b8,
    0x5cf9c9b3,
    0xde62c6bd,
    0xadf500ad,
    0x159d967e,
    0x58a2c06c,
    0x665827cb,
    0xdb1aa208
]);
const $fe57e090ef2afef2$var$maxChunkSize = 1048576;
async function* $fe57e090ef2afef2$export$19d907f5008a0f2(blob) {
    const reader = blob.stream().getReader();
    let hash = 0;
    let chunkStart = 0, chunkSize = 0;
    for(;;){
        const { value: value } = await reader.read();
        if (!value) break;
        for(let i = 0; i < value.byteLength; ++i){
            hash = (hash << 1) + $fe57e090ef2afef2$var$gear17Table.at(value.at(i));
            ++chunkSize;
            if ((hash & 0xFFFF8000) == 0 || chunkSize >= $fe57e090ef2afef2$var$maxChunkSize) {
                hash = 0;
                const chunkEnd = chunkStart + chunkSize;
                yield {
                    size: chunkSize,
                    hash: await crypto.subtle.digest('SHA-256', await blob.slice(chunkStart, chunkEnd).arrayBuffer())
                };
                chunkStart = chunkEnd;
                chunkSize = 0;
            }
        }
    }
    if (chunkSize > 0) {
        const chunkEnd = chunkStart + chunkSize;
        yield {
            size: chunkSize,
            hash: await crypto.subtle.digest('SHA-256', await blob.slice(chunkStart, chunkEnd).arrayBuffer())
        };
    }
}




/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $b969c16b4c88520f$export$86fcbb09edb4aebc {
    constructor(config){
        this.config = config;
    }
}


/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $5f60293fda0c9f94$export$f2e832acab1bdd79 extends Error {
    constructor(request, response, message){
        super(message);
        this.name = 'ApiError';
        this.url = response.url;
        this.status = response.status;
        this.statusText = response.statusText;
        this.body = response.body;
        this.request = request;
    }
}


/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $5980322372564663$export$d7f5e52d091a66db extends Error {
    constructor(message){
        super(message);
        this.name = 'CancelError';
    }
    get isCancelled() {
        return true;
    }
}
class $5980322372564663$export$551a058e9626aa5a {
    #isResolved;
    #isRejected;
    #isCancelled;
    #cancelHandlers;
    #promise;
    #resolve;
    #reject;
    constructor(executor){
        this.#isResolved = false;
        this.#isRejected = false;
        this.#isCancelled = false;
        this.#cancelHandlers = [];
        this.#promise = new Promise((resolve, reject)=>{
            this.#resolve = resolve;
            this.#reject = reject;
            const onResolve = (value)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isResolved = true;
                if (this.#resolve) this.#resolve(value);
            };
            const onReject = (reason)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isRejected = true;
                if (this.#reject) this.#reject(reason);
            };
            const onCancel = (cancelHandler)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#cancelHandlers.push(cancelHandler);
            };
            Object.defineProperty(onCancel, 'isResolved', {
                get: ()=>this.#isResolved
            });
            Object.defineProperty(onCancel, 'isRejected', {
                get: ()=>this.#isRejected
            });
            Object.defineProperty(onCancel, 'isCancelled', {
                get: ()=>this.#isCancelled
            });
            return executor(onResolve, onReject, onCancel);
        });
    }
    get [Symbol.toStringTag]() {
        return "Cancellable Promise";
    }
    then(onFulfilled, onRejected) {
        return this.#promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this.#promise.catch(onRejected);
    }
    finally(onFinally) {
        return this.#promise.finally(onFinally);
    }
    cancel() {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
        this.#isCancelled = true;
        if (this.#cancelHandlers.length) try {
            for (const cancelHandler of this.#cancelHandlers)cancelHandler();
        } catch (error) {
            console.warn('Cancellation threw an error', error);
            return;
        }
        this.#cancelHandlers.length = 0;
        if (this.#reject) this.#reject(new $5980322372564663$export$d7f5e52d091a66db('Request aborted'));
    }
    get isCancelled() {
        return this.#isCancelled;
    }
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d4ecdbf520e63dca$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $072d6411afeed5be$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
const $072d6411afeed5be$export$4e62c701997796c1 = (value)=>{
    return value !== undefined && value !== null;
};
const $072d6411afeed5be$export$844ec244b1367d54 = (value)=>{
    return typeof value === 'string';
};
const $072d6411afeed5be$export$991095b57f274a5f = (value)=>{
    return $072d6411afeed5be$export$844ec244b1367d54(value) && value !== '';
};
const $072d6411afeed5be$export$5bcd6e94ed871c88 = (value)=>{
    return typeof value === 'object' && typeof value.type === 'string' && typeof value.stream === 'function' && typeof value.arrayBuffer === 'function' && typeof value.constructor === 'function' && typeof value.constructor.name === 'string' && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
const $072d6411afeed5be$export$67a42df2b7ab73bc = (value)=>{
    return value instanceof FormData;
};
const $072d6411afeed5be$export$b3b2de96497acc47 = (str)=>{
    try {
        return btoa(str);
    } catch (err) {
        // @ts-ignore
        return $072d6411afeed5be$require$Buffer.from(str).toString('base64');
    }
};
const $072d6411afeed5be$export$18380b9f669996bd = (params)=>{
    const qs = [];
    const append = (key, value)=>{
        qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    };
    const process = (key, value)=>{
        if ($072d6411afeed5be$export$4e62c701997796c1(value)) {
            if (Array.isArray(value)) value.forEach((v)=>{
                process(key, v);
            });
            else if (typeof value === 'object') Object.entries(value).forEach(([k, v])=>{
                process(`${key}[${k}]`, v);
            });
            else append(key, value);
        }
    };
    Object.entries(params).forEach(([key, value])=>{
        process(key, value);
    });
    if (qs.length > 0) return `?${qs.join('&')}`;
    return '';
};
const $072d6411afeed5be$var$getUrl = (config, options)=>{
    const encoder = config.ENCODE_PATH || encodeURI;
    const path = options.url.replace('{api-version}', config.VERSION).replace(/{(.*?)}/g, (substring, group)=>{
        if (options.path?.hasOwnProperty(group)) return encoder(String(options.path[group]));
        return substring;
    });
    const url = `${config.BASE}${path}`;
    if (options.query) return `${url}${$072d6411afeed5be$export$18380b9f669996bd(options.query)}`;
    return url;
};
const $072d6411afeed5be$export$9643fd7297feaaf5 = (options)=>{
    if (options.formData) {
        const formData = new FormData();
        const process = (key, value)=>{
            if ($072d6411afeed5be$export$844ec244b1367d54(value) || $072d6411afeed5be$export$5bcd6e94ed871c88(value)) formData.append(key, value);
            else formData.append(key, JSON.stringify(value));
        };
        Object.entries(options.formData).filter(([_, value])=>$072d6411afeed5be$export$4e62c701997796c1(value)).forEach(([key, value])=>{
            if (Array.isArray(value)) value.forEach((v)=>process(key, v));
            else process(key, value);
        });
        return formData;
    }
    return undefined;
};
const $072d6411afeed5be$export$f7ad0328861e2f03 = async (options, resolver)=>{
    if (typeof resolver === 'function') return resolver(options);
    return resolver;
};
const $072d6411afeed5be$export$6a9b8dd1339b1a17 = async (config, options)=>{
    const [token, username, password, additionalHeaders] = await Promise.all([
        $072d6411afeed5be$export$f7ad0328861e2f03(options, config.TOKEN),
        $072d6411afeed5be$export$f7ad0328861e2f03(options, config.USERNAME),
        $072d6411afeed5be$export$f7ad0328861e2f03(options, config.PASSWORD),
        $072d6411afeed5be$export$f7ad0328861e2f03(options, config.HEADERS)
    ]);
    const headers = Object.entries({
        Accept: 'application/json',
        ...additionalHeaders,
        ...options.headers
    }).filter(([_, value])=>$072d6411afeed5be$export$4e62c701997796c1(value)).reduce((headers, [key, value])=>({
            ...headers,
            [key]: String(value)
        }), {});
    if ($072d6411afeed5be$export$991095b57f274a5f(token)) headers['Authorization'] = `Bearer ${token}`;
    if ($072d6411afeed5be$export$991095b57f274a5f(username) && $072d6411afeed5be$export$991095b57f274a5f(password)) {
        const credentials = $072d6411afeed5be$export$b3b2de96497acc47(`${username}:${password}`);
        headers['Authorization'] = `Basic ${credentials}`;
    }
    if (options.body !== undefined) {
        if (options.mediaType) headers['Content-Type'] = options.mediaType;
        else if ($072d6411afeed5be$export$5bcd6e94ed871c88(options.body)) headers['Content-Type'] = options.body.type || 'application/octet-stream';
        else if ($072d6411afeed5be$export$844ec244b1367d54(options.body)) headers['Content-Type'] = 'text/plain';
        else if (!$072d6411afeed5be$export$67a42df2b7ab73bc(options.body)) headers['Content-Type'] = 'application/json';
    }
    return new Headers(headers);
};
const $072d6411afeed5be$export$55bce18df99af758 = (options)=>{
    if (options.body !== undefined) {
        if (options.mediaType?.includes('/json')) return JSON.stringify(options.body);
        else if ($072d6411afeed5be$export$844ec244b1367d54(options.body) || $072d6411afeed5be$export$5bcd6e94ed871c88(options.body) || $072d6411afeed5be$export$67a42df2b7ab73bc(options.body)) return options.body;
        else return JSON.stringify(options.body);
    }
    return undefined;
};
const $072d6411afeed5be$export$d5a1e65f8aa21b51 = async (config, options, url, body, formData, headers, onCancel)=>{
    const controller = new AbortController();
    const request = {
        headers: headers,
        body: body ?? formData,
        method: options.method,
        signal: controller.signal
    };
    if (config.WITH_CREDENTIALS) request.credentials = config.CREDENTIALS;
    onCancel(()=>controller.abort());
    return await fetch(url, request);
};
const $072d6411afeed5be$export$67c14f05e310b1da = (response, responseHeader)=>{
    if (responseHeader) {
        const content = response.headers.get(responseHeader);
        if ($072d6411afeed5be$export$844ec244b1367d54(content)) return content;
    }
    return undefined;
};
const $072d6411afeed5be$export$c852f9270b343ec4 = async (response)=>{
    if (response.status !== 204) try {
        const contentType = response.headers.get('Content-Type');
        if (contentType) {
            const jsonTypes = [
                'application/json',
                'application/problem+json'
            ];
            const isJSON = jsonTypes.some((type)=>contentType.toLowerCase().startsWith(type));
            if (isJSON) return await response.json();
            else return await response.text();
        }
    } catch (error) {
        console.error(error);
    }
    return undefined;
};
const $072d6411afeed5be$export$31bf08a141e671fd = (options, result)=>{
    const errors = {
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        500: 'Internal Server Error',
        502: 'Bad Gateway',
        503: 'Service Unavailable',
        ...options.errors
    };
    const error = errors[result.status];
    if (error) throw new (0, $5f60293fda0c9f94$export$f2e832acab1bdd79)(options, result, error);
    if (!result.ok) {
        const errorStatus = result.status ?? 'unknown';
        const errorStatusText = result.statusText ?? 'unknown';
        const errorBody = (()=>{
            try {
                return JSON.stringify(result.body, null, 2);
            } catch (e) {
                return undefined;
            }
        })();
        throw new (0, $5f60293fda0c9f94$export$f2e832acab1bdd79)(options, result, `Generic Error: status: ${errorStatus}; status text: ${errorStatusText}; body: ${errorBody}`);
    }
};
const $072d6411afeed5be$export$b5fe3f66a567bec0 = (config, options)=>{
    return new (0, $5980322372564663$export$551a058e9626aa5a)(async (resolve, reject, onCancel)=>{
        try {
            const url = $072d6411afeed5be$var$getUrl(config, options);
            const formData = $072d6411afeed5be$export$9643fd7297feaaf5(options);
            const body = $072d6411afeed5be$export$55bce18df99af758(options);
            const headers = await $072d6411afeed5be$export$6a9b8dd1339b1a17(config, options);
            if (!onCancel.isCancelled) {
                const response = await $072d6411afeed5be$export$d5a1e65f8aa21b51(config, options, url, body, formData, headers, onCancel);
                const responseBody = await $072d6411afeed5be$export$c852f9270b343ec4(response);
                const responseHeader = $072d6411afeed5be$export$67c14f05e310b1da(response, options.responseHeader);
                const result = {
                    url: url,
                    ok: response.ok,
                    status: response.status,
                    statusText: response.statusText,
                    body: responseHeader ?? responseBody
                };
                $072d6411afeed5be$export$31bf08a141e671fd(options, result);
                resolve(result.body);
            }
        } catch (error) {
            reject(error);
        }
    });
};


class $97de999fc63e4066$export$c023751389b69af4 extends (0, $b969c16b4c88520f$export$86fcbb09edb4aebc) {
    constructor(config){
        super(config);
    }
    /**
   * Request method
   * @param options The request options from the service
   * @returns CancelablePromise<T>
   * @throws ApiError
   */ request(options) {
        return (0, $072d6411afeed5be$export$b5fe3f66a567bec0)(this.config, options);
    }
}


/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $28c684d4f69b9dc0$export$8cfb666925489864 {
    constructor(httpRequest){
        this.httpRequest = httpRequest;
    }
    /**
   * Authenticate with email and password
   * @returns string
   * @throws ApiError
   */ postAuthPassword({ requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/password',
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``
            }
        });
    }
    /**
   * Start authentication with external provider
   * @returns ExternalAuthLocation
   * @throws ApiError
   */ postAuthExternalStart({ provider: provider, intent: intent }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/external/start',
            query: {
                'provider': provider,
                'intent': intent
            },
            errors: {
                400: `Invalid \`intent\` or \`provider\``
            }
        });
    }
    /**
   * Finish authentication with external provider
   * @returns CredentialInfo
   * @throws ApiError
   */ postAuthExternalFinish({ token: token, code: code }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/external/finish',
            query: {
                'token': token,
                'code': code
            },
            errors: {
                400: `Invalid \`code\` or \`token\``
            }
        });
    }
    /**
   * Get auth session info
   * @returns SessionInfo
   * @throws ApiError
   */ getAuthSession() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/auth/session'
        });
    }
    /**
   * Clear auth session
   * @returns any
   * @throws ApiError
   */ postAuthClear() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/clear'
        });
    }
    /**
   * Auth user
   * @returns string
   * @throws ApiError
   */ postUsersAuth({ token: token }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/auth',
            query: {
                'token': token
            },
            errors: {
                400: `Invalid \`token\``
            }
        });
    }
    /**
   * Register new user
   * @returns string
   * @throws ApiError
   */ postUsersRegister({ token: token }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/register',
            query: {
                'token': token
            },
            errors: {
                400: `Invalid \`token\``
            }
        });
    }
    /**
   * Get current user info
   * @returns UserInfo
   * @throws ApiError
   */ getUsersMe() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/me'
        });
    }
    /**
   * Delete current user
   * @returns void
   * @throws ApiError
   */ deleteUsersMe() {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/me'
        });
    }
    /**
   * Patch current user info
   * @returns void
   * @throws ApiError
   */ patchUsersMe({ requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/users/me',
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``
            }
        });
    }
    /**
   * Get current user sessions
   * @returns UserSessionInfo
   * @throws ApiError
   */ getUsersMeSessions() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/me/sessions'
        });
    }
    /**
   * Create new current user session
   * @returns NewUserSession
   * @throws ApiError
   */ postUsersMeSessions({ requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/me/sessions',
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``
            }
        });
    }
    /**
   * Delete current user session
   * @returns void
   * @throws ApiError
   */ deleteUsersMeSessions({ session: session }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/me/sessions/{session}',
            path: {
                'session': session
            },
            errors: {
                404: `\`session\` not found`
            }
        });
    }
    /**
   * Get current user credentials
   * @returns UserCredentialInfo
   * @throws ApiError
   */ getUsersMeCredentials() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/me/credentials'
        });
    }
    /**
   * Link new credential to user
   * @returns string
   * @throws ApiError
   */ postUsersMeCredentials({ token: token }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/me/credentials',
            query: {
                'token': token
            },
            errors: {
                400: `Invalid \`token\``
            }
        });
    }
    /**
   * Unlink credential from user
   * @returns void
   * @throws ApiError
   */ deleteUsersMeCredentials({ provider: provider, name: name }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/me/credentials',
            query: {
                'provider': provider,
                'name': name
            },
            errors: {
                400: `Invalid \`name\` or \`provider\``
            }
        });
    }
    /**
   * Patch credential of user
   * @returns void
   * @throws ApiError
   */ patchUsersMeCredentials({ provider: provider, name: name, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/users/me/credentials',
            query: {
                'provider': provider,
                'name': name
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\` or \`name\` or \`provider\``
            }
        });
    }
    /**
   * Get current user deploy credentials
   * @returns DeployCredentialInfo
   * @throws ApiError
   */ getUsersMeDeployCredentials() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/me/deploy-credentials'
        });
    }
    /**
   * Add deploy credential to user
   * @returns string
   * @throws ApiError
   */ postUsersMeDeployCredentials({ requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/me/deploy-credentials',
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``
            }
        });
    }
    /**
   * Delete deploy credential from user
   * @returns void
   * @throws ApiError
   */ deleteUsersMeDeployCredentials({ deployCredential: deployCredential }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/me/deploy-credentials/{deploy-credential}',
            path: {
                'deploy-credential': deployCredential
            },
            errors: {
                404: `\`deploy-credential\` not found`
            }
        });
    }
    /**
   * Get available sites from deploy credential
   * @returns DeployCredentialAvailableSite
   * @throws ApiError
   */ getUsersMeDeployCredentialsAvailableSites({ deployCredential: deployCredential }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/me/deploy-credentials/{deploy-credential}/available-sites',
            path: {
                'deploy-credential': deployCredential
            },
            errors: {
                404: `\`deploy-credential\` not found`
            }
        });
    }
    /**
   * List projects user has access to
   * @returns ProjectInfo
   * @throws ApiError
   */ getUsersMeProjects() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/me/projects'
        });
    }
    /**
   * Create new project
   * @returns string
   * @throws ApiError
   */ postProjects({ requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects',
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``
            }
        });
    }
    /**
   * Get project info
   * @returns ProjectInfo
   * @throws ApiError
   */ getProjects({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Delete project
   * @returns void
   * @throws ApiError
   */ deleteProjects({ project: project }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/projects/{project}',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Patch project info
   * @returns void
   * @throws ApiError
   */ patchProjects({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/projects/{project}',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get project description
   * @returns ContentMarkdown
   * @throws ApiError
   */ getProjectsDescription({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/description',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Put project description
   * @returns void
   * @throws ApiError
   */ putProjectsDescription({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/projects/{project}/description',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get project image
   * @returns ContentImage
   * @throws ApiError
   */ getProjectsImage({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/image',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Put project image
   * @returns void
   * @throws ApiError
   */ putProjectsImage({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/projects/{project}/image',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get project star status
   * @returns boolean
   * @throws ApiError
   */ getProjectsStar({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/star',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Star or unstar project
   * @returns void
   * @throws ApiError
   */ putProjectsStar({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/projects/{project}/star',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get project quotas
   * @returns ProjectQuotasInfo
   * @throws ApiError
   */ getProjectsQuotas({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/quotas',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get project branches
   * @returns BranchInfo
   * @throws ApiError
   */ getProjectsBranches({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/branches',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Create new branch
   * @returns string
   * @throws ApiError
   */ postProjectsBranches({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/branches',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Delete branch
   * @returns void
   * @throws ApiError
   */ deleteProjectsBranches({ project: project, branch: branch }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/projects/{project}/branches/{branch}',
            path: {
                'project': project,
                'branch': branch
            },
            errors: {
                404: `\`project\` or \`branch\` not found`
            }
        });
    }
    /**
   * Patch branch info
   * @returns void
   * @throws ApiError
   */ patchProjectsBranches({ project: project, branch: branch, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/projects/{project}/branches/{branch}',
            path: {
                'project': project,
                'branch': branch
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` or \`branch\` not found`
            }
        });
    }
    /**
   * Get branch versions
   * @returns BranchVersionInfo
   * @throws ApiError
   */ getProjectsBranchesVersions({ project: project, branch: branch, before: before, count: count }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/branches/{branch}/versions',
            path: {
                'project': project,
                'branch': branch
            },
            query: {
                'before': before,
                'count': count
            },
            errors: {
                400: `Invalid \`count\` or \`before\``,
                404: `\`project\` or \`branch\` not found`
            }
        });
    }
    /**
   * Publish version to branch
   * @returns void
   * @throws ApiError
   */ postProjectsBranchesVersions({ project: project, branch: branch, version: version }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/branches/{branch}/versions/{version}',
            path: {
                'project': project,
                'branch': branch,
                'version': version
            },
            errors: {
                404: `\`project\` or \`branch\` or \`version\` not found`
            }
        });
    }
    /**
   * Get project versions
   * @returns VersionInfo
   * @throws ApiError
   */ getProjectsVersions({ project: project, before: before, count: count }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/versions',
            path: {
                'project': project
            },
            query: {
                'before': before,
                'count': count
            },
            errors: {
                400: `Invalid \`count\` or \`before\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Create new version
   * @returns string
   * @throws ApiError
   */ postProjectsVersions({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/versions',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get version
   * Get version metadata
   * @returns VersionInfo
   * @throws ApiError
   */ getProjectsVersions1({ project: project, version: version }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/versions/{version}',
            path: {
                'project': project,
                'version': version
            },
            errors: {
                404: `\`project\` or \`version\` not found`
            }
        });
    }
    /**
   * Delete version
   * @returns void
   * @throws ApiError
   */ deleteProjectsVersions({ project: project, version: version }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/projects/{project}/versions/{version}',
            path: {
                'project': project,
                'version': version
            },
            errors: {
                404: `\`project\` or \`version\` not found`
            }
        });
    }
    /**
   * Patch version
   * Patch version metadata
   * @returns void
   * @throws ApiError
   */ patchProjectsVersions({ project: project, version: version, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/projects/{project}/versions/{version}',
            path: {
                'project': project,
                'version': version
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` or \`version\` not found`
            }
        });
    }
    /**
   * Get branches of version
   * @returns VersionBranchInfo
   * @throws ApiError
   */ getProjectsVersionsBranches({ project: project, version: version, before: before, count: count }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/versions/{version}/branches',
            path: {
                'project': project,
                'version': version
            },
            query: {
                'before': before,
                'count': count
            },
            errors: {
                400: `Invalid \`count\` or \`before\``,
                404: `\`project\` or \`version\` not found`
            }
        });
    }
    /**
   * Get packages of version
   * @returns PackageInfo
   * @throws ApiError
   */ getProjectsVersionsPackages({ project: project, version: version }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/versions/{version}/packages',
            path: {
                'project': project,
                'version': version
            },
            errors: {
                404: `\`project\` or \`version\` not found`
            }
        });
    }
    /**
   * Deploy version
   * @returns string
   * @throws ApiError
   */ postProjectsVersionsDeploy({ project: project, version: version, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/versions/{version}/deploy',
            path: {
                'project': project,
                'version': version
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` or \`version\` not found`
            }
        });
    }
    /**
   * Get project packages
   * @returns PackageInfo
   * @throws ApiError
   */ getProjectsPackages({ project: project, before: before, count: count }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/packages',
            path: {
                'project': project
            },
            query: {
                'before': before,
                'count': count
            },
            errors: {
                400: `Invalid \`count\` or \`before\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Create new package
   * Initializes new package for upload. Package becomes fully created and visible only after finalization.
   * @returns NewPackage
   * @throws ApiError
   */ postProjectsPackages({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/packages',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get package info
   * @returns PackageInfo
   * @throws ApiError
   */ getProjectsPackages1({ project: project, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/packages/{package}',
            path: {
                'project': project,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Delete package
   * Delete package
   * @returns void
   * @throws ApiError
   */ deleteProjectsPackages({ project: project, _package: _package }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/projects/{project}/packages/{package}',
            path: {
                'project': project,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Patch package info
   * @returns void
   * @throws ApiError
   */ patchProjectsPackages({ project: project, _package: _package, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/projects/{project}/packages/{package}',
            path: {
                'project': project,
                'package': _package
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Download package
   * @returns string
   * @throws ApiError
   */ getProjectsPackagesDownload({ project: project, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/packages/{package}/download',
            path: {
                'project': project,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Finalize package
   * Finalize package, so it can be included in versions. Finalized package is immutable.
   * @returns void
   * @throws ApiError
   */ putProjectsPackagesFinalize({ project: project, _package: _package, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/projects/{project}/packages/{package}/finalize',
            path: {
                'project': project,
                'package': _package
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Resolve patch package
   * Resolve patch package, returning full package.
   * @returns string
   * @throws ApiError
   */ postProjectsPackagesResolve({ project: project, _package: _package }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/packages/{package}/resolve',
            path: {
                'project': project,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Get package space url
   * Get space url allowing to play web games
   * @returns string
   * @throws ApiError
   */ getProjectsPackagesSpace({ project: project, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/packages/{package}/space',
            path: {
                'project': project,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Get package torrent url
   * Get package torrent url
   * @returns string
   * @throws ApiError
   */ getProjectsPackagesTorrent({ project: project, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/packages/{package}/torrent',
            path: {
                'project': project,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`package\` not found`
            }
        });
    }
    /**
   * Get project users
   * @returns ProjectUserInfo
   * @throws ApiError
   */ getProjectsUsers({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/users',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Set user participation in project
   * @returns void
   * @throws ApiError
   */ putProjectsUsers({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/projects/{project}/users',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Leave project
   * @returns void
   * @throws ApiError
   */ postProjectsUsersLeave({ project: project }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/users/leave',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Get project invites
   * @returns ProjectInviteInfo
   * @throws ApiError
   */ getProjectsInvites({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/invites',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Add project invite
   * @returns ProjectInviteInfo
   * @throws ApiError
   */ postProjectsInvites({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/invites',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Delete project invite
   * @returns void
   * @throws ApiError
   */ deleteProjectsInvites({ project: project, invite: invite }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/projects/{project}/invites/{invite}',
            path: {
                'project': project,
                'invite': invite
            },
            errors: {
                404: `\`project\` or \`invite\` not found`
            }
        });
    }
    /**
   * Get project deploy sites
   * @returns DeploySiteInfo
   * @throws ApiError
   */ getProjectsDeploySites({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/projects/{project}/deploy-sites',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Create new deploy site for project
   * @returns string
   * @throws ApiError
   */ postProjectsDeploySites({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/deploy-sites',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Delete deploy site
   * @returns void
   * @throws ApiError
   */ deleteProjectsDeploySites({ project: project, deploySite: deploySite }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/projects/{project}/deploy-sites/{deploy_site}',
            path: {
                'project': project,
                'deploy_site': deploySite
            },
            errors: {
                404: `\`project\` or \`deploy_site\` not found`
            }
        });
    }
    /**
   * Upload new content image
   * @returns NewContentImage
   * @throws ApiError
   */ postProjectsContentImages({ project: project, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/projects/{project}/content/images',
            path: {
                'project': project
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Finalize content image
   * Finalize uploaded content image
   * @returns ContentImage
   * @throws ApiError
   */ putProjectsContentImagesFinalize({ project: project, contentImage: contentImage, requestBody: requestBody }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/projects/{project}/content/images/{content_image}/finalize',
            path: {
                'project': project,
                'content_image': contentImage
            },
            body: requestBody,
            mediaType: 'application/json;charset=utf-8',
            errors: {
                400: `Invalid \`body\``,
                404: `\`project\` or \`content_image\` not found`
            }
        });
    }
    /**
   * Get store project info
   * @returns StoreProjectInfo
   * @throws ApiError
   */ getStoreProjects({ project: project }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/store/projects/{project}',
            path: {
                'project': project
            },
            errors: {
                404: `\`project\` not found`
            }
        });
    }
    /**
   * Download store project's package
   * @returns string
   * @throws ApiError
   */ getStoreProjectsBranchesPackagesDownload({ project: project, branch: branch, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/store/projects/{project}/branches/{branch}/packages/{package}/download',
            path: {
                'project': project,
                'branch': branch,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`branch\` or \`package\` not found`
            }
        });
    }
    /**
   * Get store package space url
   * Get space url allowing to play web games
   * @returns string
   * @throws ApiError
   */ getStoreProjectsBranchesPackagesSpace({ project: project, branch: branch, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/store/projects/{project}/branches/{branch}/packages/{package}/space',
            path: {
                'project': project,
                'branch': branch,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`branch\` or \`package\` not found`
            }
        });
    }
    /**
   * Get store package torrent url
   * Get store package torrent url
   * @returns string
   * @throws ApiError
   */ getStoreProjectsBranchesPackagesTorrent({ project: project, branch: branch, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/store/projects/{project}/branches/{branch}/packages/{package}/torrent',
            path: {
                'project': project,
                'branch': branch,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`branch\` or \`package\` not found`
            }
        });
    }
    /**
   * Get store sitemap
   * @returns any
   * @throws ApiError
   */ getStoreSitemapXml() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/store/sitemap.xml'
        });
    }
    /**
   * Get the answer to the ultimate question of life, the universe, and everything
   * @returns string
   * @throws ApiError
   */ postJobs() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/jobs'
        });
    }
    /**
   * Get invite info
   * @returns ProjectInviteJoinInfo
   * @throws ApiError
   */ getInvites({ token: token }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/invites',
            query: {
                'token': token
            },
            errors: {
                400: `Invalid \`token\``
            }
        });
    }
    /**
   * Join invite
   * @returns string
   * @throws ApiError
   */ postInvites({ token: token }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/invites',
            query: {
                'token': token
            },
            errors: {
                400: `Invalid \`token\``
            }
        });
    }
    /**
   * Get project's branch's versions' package access
   * @returns boolean
   * @throws ApiError
   */ getInternalAccessProjectsBranchesVersionsPackages({ project: project, branch: branch, version: version, _package: _package }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/access/projects/{project}/branches/{branch}/versions/{version}/packages/{package}',
            path: {
                'project': project,
                'branch': branch,
                'version': version,
                'package': _package
            },
            errors: {
                404: `\`project\` or \`branch\` or \`version\` or \`package\` not found`
            }
        });
    }
    /**
   * @returns void
   * @throws ApiError
   */ postAdminMaintenanceOptimizeContentImages() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/maintenance/optimize-content-images'
        });
    }
}


class $f08ff9bf1882a38d$export$bf71da7aebe9ddc1 {
    constructor(config, HttpRequest = (0, $97de999fc63e4066$export$c023751389b69af4)){
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://api.kavykhi.cloud',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH
        });
        this.default = new (0, $28c684d4f69b9dc0$export$8cfb666925489864)(this.request);
    }
}





/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ const $75f13146de7971c6$export$3bbbb17165d6e0ef = {
    BASE: 'https://api.kavykhi.cloud',
    VERSION: '0.0.1',
    WITH_CREDENTIALS: false,
    CREDENTIALS: 'include',
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: undefined,
    ENCODE_PATH: undefined
};





const $1ded0b9f0137d849$var$config = {
    appName: 'Kavykhi Cloud',
    appOrigin: 'https://kavykhi.cloud',
    apiUrl: 'https://kavykhi.cloud/api',
    storageBaseUrl: 'https://kavykhi.cloud/storage/',
    authProviders: [
        'steam',
        'github',
        'gitlab',
        'itch',
        'twitch',
        'discord',
        'google'
    ],
    socialLinks: [],
    abuseEmail: 'abuse@kavykhi.cloud',
    webrtcIceServers: [],
    supportTorrentDownloads: true
};
var $1ded0b9f0137d849$export$2e2bcd8739ae039 = $1ded0b9f0137d849$var$config;




/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $f3d5a22901917d2b$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $f3d5a22901917d2b$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $f3d5a22901917d2b$export$803cd8101b6c182b = /*#__PURE__*/ $f3d5a22901917d2b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f3d5a22901917d2b$export$27b07d8a310ed8b5[0], side + "-" + $f3d5a22901917d2b$export$27b07d8a310ed8b5[1]), []);
const $f3d5a22901917d2b$export$96ec731ed4dcb222 = Math.min;
const $f3d5a22901917d2b$export$8960430cfd85939f = Math.max;
const $f3d5a22901917d2b$export$2077e0241d6afd3c = Math.round;
const $f3d5a22901917d2b$export$a3fe094919f356fd = Math.floor;
const $f3d5a22901917d2b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f3d5a22901917d2b$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f3d5a22901917d2b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f3d5a22901917d2b$export$8960430cfd85939f(start, $f3d5a22901917d2b$export$96ec731ed4dcb222(value, end));
}
function $f3d5a22901917d2b$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $f3d5a22901917d2b$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $f3d5a22901917d2b$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $f3d5a22901917d2b$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $f3d5a22901917d2b$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $f3d5a22901917d2b$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $f3d5a22901917d2b$export$2b57e0052a6d6d4c(placement) {
    return $f3d5a22901917d2b$export$8a000a963141ac32($f3d5a22901917d2b$export$f28e8f882010718a(placement));
}
function $f3d5a22901917d2b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f3d5a22901917d2b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f3d5a22901917d2b$export$2b57e0052a6d6d4c(placement);
    const length = $f3d5a22901917d2b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f3d5a22901917d2b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f3d5a22901917d2b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f3d5a22901917d2b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f3d5a22901917d2b$export$9c5e28bad23365fa(placement);
    return [
        $f3d5a22901917d2b$export$2b182c584985588b(placement),
        oppositePlacement,
        $f3d5a22901917d2b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f3d5a22901917d2b$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $f3d5a22901917d2b$var$lrPlacement = [
    'left',
    'right'
];
const $f3d5a22901917d2b$var$rlPlacement = [
    'right',
    'left'
];
const $f3d5a22901917d2b$var$tbPlacement = [
    'top',
    'bottom'
];
const $f3d5a22901917d2b$var$btPlacement = [
    'bottom',
    'top'
];
function $f3d5a22901917d2b$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $f3d5a22901917d2b$var$rlPlacement : $f3d5a22901917d2b$var$lrPlacement;
            return isStart ? $f3d5a22901917d2b$var$lrPlacement : $f3d5a22901917d2b$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $f3d5a22901917d2b$var$tbPlacement : $f3d5a22901917d2b$var$btPlacement;
        default:
            return [];
    }
}
function $f3d5a22901917d2b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f3d5a22901917d2b$export$f0989780f32bfcda(placement);
    let list = $f3d5a22901917d2b$var$getSideList($f3d5a22901917d2b$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f3d5a22901917d2b$export$2b182c584985588b));
    }
    return list;
}
function $f3d5a22901917d2b$export$9c5e28bad23365fa(placement) {
    const side = $f3d5a22901917d2b$export$3c915306cb7fc97a(placement);
    return $f3d5a22901917d2b$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $f3d5a22901917d2b$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $f3d5a22901917d2b$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $f3d5a22901917d2b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f3d5a22901917d2b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $9154911abd72ae9f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f3d5a22901917d2b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f3d5a22901917d2b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9154911abd72ae9f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $9154911abd72ae9f$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9154911abd72ae9f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $9154911abd72ae9f$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9154911abd72ae9f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $9154911abd72ae9f$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9154911abd72ae9f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9154911abd72ae9f$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f3d5a22901917d2b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f3d5a22901917d2b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9154911abd72ae9f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f3d5a22901917d2b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9154911abd72ae9f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f3d5a22901917d2b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f3d5a22901917d2b$export$803cd8101b6c182b) ? $9154911abd72ae9f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $f3d5a22901917d2b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9154911abd72ae9f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f3d5a22901917d2b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f3d5a22901917d2b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $f3d5a22901917d2b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f3d5a22901917d2b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $f3d5a22901917d2b$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $f3d5a22901917d2b$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9154911abd72ae9f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9154911abd72ae9f$var$isAnySideFullyClipped(overflow) {
    return (0, $f3d5a22901917d2b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9154911abd72ae9f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9154911abd72ae9f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9154911abd72ae9f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9154911abd72ae9f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9154911abd72ae9f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9154911abd72ae9f$var$getBoundingRect(rects) {
    const minX = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9154911abd72ae9f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)($9154911abd72ae9f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9154911abd72ae9f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $9154911abd72ae9f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)($9154911abd72ae9f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f3d5a22901917d2b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $9154911abd72ae9f$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9154911abd72ae9f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $9154911abd72ae9f$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9154911abd72ae9f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9154911abd72ae9f$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9154911abd72ae9f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f3d5a22901917d2b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $f3d5a22901917d2b$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9154911abd72ae9f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f3d5a22901917d2b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $9154911abd72ae9f$var$originSides.has((0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9154911abd72ae9f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $f3d5a22901917d2b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f3d5a22901917d2b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f3d5a22901917d2b$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $f3d5a22901917d2b$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $dd40b91ca1c84530$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $dd40b91ca1c84530$export$651544f548703224(node) {
    if ($dd40b91ca1c84530$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $dd40b91ca1c84530$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $dd40b91ca1c84530$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($dd40b91ca1c84530$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $dd40b91ca1c84530$export$8ee0fc9ee280b4ee(value) {
    if (!$dd40b91ca1c84530$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).Node;
}
function $dd40b91ca1c84530$export$45a5e7f76e0caa8d(value) {
    if (!$dd40b91ca1c84530$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).Element;
}
function $dd40b91ca1c84530$export$1b3bfaa9684536aa(value) {
    if (!$dd40b91ca1c84530$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).HTMLElement;
}
function $dd40b91ca1c84530$export$af51f0f06c0f328a(value) {
    if (!$dd40b91ca1c84530$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $dd40b91ca1c84530$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $dd40b91ca1c84530$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $dd40b91ca1c84530$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $dd40b91ca1c84530$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($dd40b91ca1c84530$export$651544f548703224(element));
}
function $dd40b91ca1c84530$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $dd40b91ca1c84530$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $dd40b91ca1c84530$var$containRe = /paint|layout|strict|content/;
const $dd40b91ca1c84530$var$isNotNone = (value)=>!!value && value !== 'none';
let $dd40b91ca1c84530$var$isWebKitValue;
function $dd40b91ca1c84530$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $dd40b91ca1c84530$export$45a5e7f76e0caa8d(elementOrCss) ? $dd40b91ca1c84530$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $dd40b91ca1c84530$var$isNotNone(css.transform) || $dd40b91ca1c84530$var$isNotNone(css.translate) || $dd40b91ca1c84530$var$isNotNone(css.scale) || $dd40b91ca1c84530$var$isNotNone(css.rotate) || $dd40b91ca1c84530$var$isNotNone(css.perspective) || !$dd40b91ca1c84530$export$78551043582a6a98() && ($dd40b91ca1c84530$var$isNotNone(css.backdropFilter) || $dd40b91ca1c84530$var$isNotNone(css.filter)) || $dd40b91ca1c84530$var$willChangeRe.test(css.willChange || '') || $dd40b91ca1c84530$var$containRe.test(css.contain || '');
}
function $dd40b91ca1c84530$export$940d8225183e1404(element) {
    let currentNode = $dd40b91ca1c84530$export$4e12058fc4d51d56(element);
    while($dd40b91ca1c84530$export$1b3bfaa9684536aa(currentNode) && !$dd40b91ca1c84530$export$d1162fb0b6d4cd51(currentNode)){
        if ($dd40b91ca1c84530$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($dd40b91ca1c84530$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $dd40b91ca1c84530$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $dd40b91ca1c84530$export$78551043582a6a98() {
    if ($dd40b91ca1c84530$var$isWebKitValue == null) $dd40b91ca1c84530$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $dd40b91ca1c84530$var$isWebKitValue;
}
function $dd40b91ca1c84530$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($dd40b91ca1c84530$export$651544f548703224(node));
}
function $dd40b91ca1c84530$export$3735103072e4a80(element) {
    return $dd40b91ca1c84530$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $dd40b91ca1c84530$export$dc8fc79fa2800137(element) {
    if ($dd40b91ca1c84530$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $dd40b91ca1c84530$export$4e12058fc4d51d56(node) {
    if ($dd40b91ca1c84530$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $dd40b91ca1c84530$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $dd40b91ca1c84530$export$e495491855dc5418(node);
    return $dd40b91ca1c84530$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $dd40b91ca1c84530$export$7cd01a57c8ca906c(node) {
    const parentNode = $dd40b91ca1c84530$export$4e12058fc4d51d56(node);
    if ($dd40b91ca1c84530$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($dd40b91ca1c84530$export$1b3bfaa9684536aa(parentNode) && $dd40b91ca1c84530$export$989e911fa9af580a(parentNode)) return parentNode;
    return $dd40b91ca1c84530$export$7cd01a57c8ca906c(parentNode);
}
function $dd40b91ca1c84530$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $dd40b91ca1c84530$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $dd40b91ca1c84530$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $dd40b91ca1c84530$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $dd40b91ca1c84530$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $dd40b91ca1c84530$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $dd40b91ca1c84530$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $dd40b91ca1c84530$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $5cf54089b7e75f55$var$getCssDimensions(element) {
    const css = (0, $dd40b91ca1c84530$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $5cf54089b7e75f55$var$unwrapElement(element) {
    return !(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $5cf54089b7e75f55$var$getScale(element) {
    const domElement = $5cf54089b7e75f55$var$unwrapElement(element);
    if (!(0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(domElement)) return (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $5cf54089b7e75f55$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f3d5a22901917d2b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $5cf54089b7e75f55$var$noOffsets = /*#__PURE__*/ (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
function $5cf54089b7e75f55$var$getVisualOffsets(element) {
    const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
    if (!(0, $dd40b91ca1c84530$export$78551043582a6a98)() || !win.visualViewport) return $5cf54089b7e75f55$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $5cf54089b7e75f55$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
}
function $5cf54089b7e75f55$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $5cf54089b7e75f55$var$unwrapElement(element);
    let scale = (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(offsetParent)) scale = $5cf54089b7e75f55$var$getScale(offsetParent);
        } else scale = $5cf54089b7e75f55$var$getScale(element);
    }
    const visualOffsets = $5cf54089b7e75f55$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $5cf54089b7e75f55$var$getVisualOffsets(domElement) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $dd40b91ca1c84530$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $5cf54089b7e75f55$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $dd40b91ca1c84530$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $dd40b91ca1c84530$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $5cf54089b7e75f55$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $5cf54089b7e75f55$var$getBoundingClientRect((0, $dd40b91ca1c84530$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $5cf54089b7e75f55$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $5cf54089b7e75f55$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $5cf54089b7e75f55$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $dd40b91ca1c84530$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $dd40b91ca1c84530$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f3d5a22901917d2b$export$a397704b5e280835)(1);
    const offsets = (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $dd40b91ca1c84530$export$651544f548703224)(offsetParent) !== 'body' || (0, $dd40b91ca1c84530$export$989e911fa9af580a)(documentElement)) scroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $5cf54089b7e75f55$var$getBoundingClientRect(offsetParent);
            scale = $5cf54089b7e75f55$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $5cf54089b7e75f55$var$getHTMLOffset(documentElement, scroll) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $5cf54089b7e75f55$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $5cf54089b7e75f55$var$getDocumentRect(html) {
    const scroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $5cf54089b7e75f55$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $dd40b91ca1c84530$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $f3d5a22901917d2b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $5cf54089b7e75f55$var$SCROLLBAR_MAX = 25;
function $5cf54089b7e75f55$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
    const html = (0, $dd40b91ca1c84530$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $dd40b91ca1c84530$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $5cf54089b7e75f55$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $5cf54089b7e75f55$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $5cf54089b7e75f55$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $5cf54089b7e75f55$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $5cf54089b7e75f55$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $5cf54089b7e75f55$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $5cf54089b7e75f55$var$getDocumentRect((0, $dd40b91ca1c84530$export$e495491855dc5418)(element));
    else if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $5cf54089b7e75f55$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $5cf54089b7e75f55$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $f3d5a22901917d2b$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $5cf54089b7e75f55$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $dd40b91ca1c84530$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(el) && (0, $dd40b91ca1c84530$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(currentNode) && !(0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $dd40b91ca1c84530$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $dd40b91ca1c84530$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $5cf54089b7e75f55$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $dd40b91ca1c84530$export$89e651af02346cd4)(element) ? [] : $5cf54089b7e75f55$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $5cf54089b7e75f55$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(rect.top, top);
        right = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $5cf54089b7e75f55$var$getDimensions(element) {
    const { width: width, height: height } = $5cf54089b7e75f55$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $5cf54089b7e75f55$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $dd40b91ca1c84530$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $5cf54089b7e75f55$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $dd40b91ca1c84530$export$651544f548703224)(offsetParent) !== 'body' || (0, $dd40b91ca1c84530$export$989e911fa9af580a)(documentElement)) scroll = (0, $dd40b91ca1c84530$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $5cf54089b7e75f55$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $5cf54089b7e75f55$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $5cf54089b7e75f55$var$getHTMLOffset(documentElement, scroll) : (0, $f3d5a22901917d2b$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $5cf54089b7e75f55$var$isStaticPositioned(element) {
    return (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).position === 'static';
}
function $5cf54089b7e75f55$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element) || (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $dd40b91ca1c84530$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $5cf54089b7e75f55$var$getOffsetParent(element, polyfill) {
    const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
    if ((0, $dd40b91ca1c84530$export$89e651af02346cd4)(element)) return win;
    if (!(0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$5cf54089b7e75f55$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $5cf54089b7e75f55$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $dd40b91ca1c84530$export$71535ffaa902797f)(offsetParent) && $5cf54089b7e75f55$var$isStaticPositioned(offsetParent))offsetParent = $5cf54089b7e75f55$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(offsetParent) && $5cf54089b7e75f55$var$isStaticPositioned(offsetParent) && !(0, $dd40b91ca1c84530$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $dd40b91ca1c84530$export$940d8225183e1404)(element) || win;
}
const $5cf54089b7e75f55$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $5cf54089b7e75f55$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $5cf54089b7e75f55$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $5cf54089b7e75f55$var$isRTL(element) {
    return (0, $dd40b91ca1c84530$export$3735103072e4a80)(element).direction === 'rtl';
}
const $5cf54089b7e75f55$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $5cf54089b7e75f55$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $dd40b91ca1c84530$export$e495491855dc5418,
    getClippingRect: $5cf54089b7e75f55$var$getClippingRect,
    getOffsetParent: $5cf54089b7e75f55$var$getOffsetParent,
    getElementRects: $5cf54089b7e75f55$var$getElementRects,
    getClientRects: $5cf54089b7e75f55$var$getClientRects,
    getDimensions: $5cf54089b7e75f55$var$getDimensions,
    getScale: $5cf54089b7e75f55$var$getScale,
    isElement: $dd40b91ca1c84530$export$45a5e7f76e0caa8d,
    isRTL: $5cf54089b7e75f55$var$isRTL
};
function $5cf54089b7e75f55$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $5cf54089b7e75f55$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $dd40b91ca1c84530$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f3d5a22901917d2b$export$8960430cfd85939f)(0, (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$5cf54089b7e75f55$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $5cf54089b7e75f55$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $5cf54089b7e75f55$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $dd40b91ca1c84530$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $dd40b91ca1c84530$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $5cf54089b7e75f55$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $5cf54089b7e75f55$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $5cf54089b7e75f55$var$getBoundingClientRect(reference);
        if (prevRefRect && !$5cf54089b7e75f55$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $5cf54089b7e75f55$export$37b6bde19b108ecc = (0, $9154911abd72ae9f$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $5cf54089b7e75f55$export$cc800923e997bb8 = (0, $9154911abd72ae9f$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $5cf54089b7e75f55$export$91fb6ecbd551914 = (0, $9154911abd72ae9f$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $5cf54089b7e75f55$export$fba63a578e423eb = (0, $9154911abd72ae9f$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $5cf54089b7e75f55$export$8a83211c878a3f1f = (0, $9154911abd72ae9f$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $5cf54089b7e75f55$export$346677f925de839c = (0, $9154911abd72ae9f$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $5cf54089b7e75f55$export$fe8985bb6374093c = (0, $9154911abd72ae9f$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $5cf54089b7e75f55$export$f2120bbfa5450bd2 = (0, $9154911abd72ae9f$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $5cf54089b7e75f55$export$18c8ad048e32c7d5 = (0, $9154911abd72ae9f$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $5cf54089b7e75f55$export$7bf07e38f3dc4b69 = (0, $9154911abd72ae9f$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $5cf54089b7e75f55$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$5cf54089b7e75f55$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9154911abd72ae9f$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};





/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $7b28c9bd65463003$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $7b28c9bd65463003$var$candidateSelector = /* #__PURE__ */ $7b28c9bd65463003$var$candidateSelectors.join(',');
var $7b28c9bd65463003$var$NoElement = typeof Element === 'undefined';
var $7b28c9bd65463003$var$matches = $7b28c9bd65463003$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $7b28c9bd65463003$var$getRootNode = !$7b28c9bd65463003$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $7b28c9bd65463003$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $7b28c9bd65463003$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $7b28c9bd65463003$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $7b28c9bd65463003$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($7b28c9bd65463003$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($7b28c9bd65463003$var$candidateSelector));
    if (includeContainer && $7b28c9bd65463003$var$matches.call(el, $7b28c9bd65463003$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $7b28c9bd65463003$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($7b28c9bd65463003$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $7b28c9bd65463003$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $7b28c9bd65463003$var$matches.call(element, $7b28c9bd65463003$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$7b28c9bd65463003$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $7b28c9bd65463003$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $7b28c9bd65463003$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $7b28c9bd65463003$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $7b28c9bd65463003$var$isContentEditable(node)) && !$7b28c9bd65463003$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $7b28c9bd65463003$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $7b28c9bd65463003$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$7b28c9bd65463003$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $7b28c9bd65463003$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $7b28c9bd65463003$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $7b28c9bd65463003$var$isHiddenInput = function isHiddenInput(node) {
    return $7b28c9bd65463003$var$isInput(node) && node.type === 'hidden';
};
var $7b28c9bd65463003$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $7b28c9bd65463003$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $7b28c9bd65463003$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $7b28c9bd65463003$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $7b28c9bd65463003$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $7b28c9bd65463003$var$isRadio = function isRadio(node) {
    return $7b28c9bd65463003$var$isInput(node) && node.type === 'radio';
};
var $7b28c9bd65463003$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $7b28c9bd65463003$var$isRadio(node) && !$7b28c9bd65463003$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $7b28c9bd65463003$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $7b28c9bd65463003$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $7b28c9bd65463003$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $7b28c9bd65463003$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $7b28c9bd65463003$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $7b28c9bd65463003$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($7b28c9bd65463003$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $7b28c9bd65463003$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $7b28c9bd65463003$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($7b28c9bd65463003$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $7b28c9bd65463003$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $7b28c9bd65463003$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $7b28c9bd65463003$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $7b28c9bd65463003$var$isHiddenInput(node) || $7b28c9bd65463003$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $7b28c9bd65463003$var$isDetailsWithSummary(node) || $7b28c9bd65463003$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($7b28c9bd65463003$var$isNonTabbableRadio(node) || $7b28c9bd65463003$export$a4672efddb4181b8(node) < 0 || !$7b28c9bd65463003$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $7b28c9bd65463003$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $7b28c9bd65463003$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $7b28c9bd65463003$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $7b28c9bd65463003$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($7b28c9bd65463003$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $7b28c9bd65463003$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $7b28c9bd65463003$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $7b28c9bd65463003$var$isShadowRootTabbable
    });
    else candidates = $7b28c9bd65463003$var$getCandidates(container, options.includeContainer, $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $7b28c9bd65463003$var$_sortByOrder(candidates);
};
var $7b28c9bd65463003$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $7b28c9bd65463003$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $7b28c9bd65463003$var$getCandidates(container, options.includeContainer, $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $7b28c9bd65463003$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($7b28c9bd65463003$var$matches.call(node, $7b28c9bd65463003$var$candidateSelector) === false) return false;
    return $7b28c9bd65463003$var$isNodeMatchingSelectorTabbable(options, node);
};
var $7b28c9bd65463003$var$focusableCandidateSelector = /* #__PURE__ */ $7b28c9bd65463003$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $7b28c9bd65463003$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($7b28c9bd65463003$var$matches.call(node, $7b28c9bd65463003$var$focusableCandidateSelector) === false) return false;
    return $7b28c9bd65463003$var$isNodeMatchingSelectorFocusable(options, node);
};


//#region src/utils/constants.ts
const $26f76e96d3e6d732$export$9e5f44173e64f162 = "data-floating-ui-focusable";
const $26f76e96d3e6d732$export$7f8ddf7c7c20b3cd = "active";
const $26f76e96d3e6d732$export$b4171a6734a65d42 = "selected";
const $26f76e96d3e6d732$export$71cec2538cb2c617 = "ArrowLeft";
const $26f76e96d3e6d732$export$2329c99376c9d0a4 = "ArrowRight";
const $26f76e96d3e6d732$export$3466f893ebf79586 = "ArrowUp";
const $26f76e96d3e6d732$export$3a6d5c9ae78a2c08 = "ArrowDown";
/**
* Builds one of the `data-floating-ui-*` attribute names the components tag
* their elements with.
*/ function $26f76e96d3e6d732$export$8743009a87fcb00f(name) {
    return `data-floating-ui-${name}`;
}
//#endregion
//#region src/utils/platform.ts
function $26f76e96d3e6d732$export$9bb611d729802a56() {
    const uaData = navigator.userAgentData;
    if (uaData?.platform) return uaData.platform;
    return navigator.platform;
}
function $26f76e96d3e6d732$export$61196ced6d74a310() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map(({ brand: brand, version: version })=>`${brand}/${version}`).join(" ");
    return navigator.userAgent;
}
function $26f76e96d3e6d732$export$e7c866399fa523f5() {
    return /apple/i.test(navigator.vendor);
}
function $26f76e96d3e6d732$export$db202ddc8be9136() {
    const re = /android/i;
    return re.test($26f76e96d3e6d732$export$9bb611d729802a56()) || re.test($26f76e96d3e6d732$export$61196ced6d74a310());
}
function $26f76e96d3e6d732$export$ef35774e6d314e91() {
    return $26f76e96d3e6d732$export$9bb611d729802a56().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $26f76e96d3e6d732$export$df995fae86a55f06() {
    return $26f76e96d3e6d732$export$61196ced6d74a310().includes("jsdom/");
}
//#endregion
//#region src/utils/event.ts
function $26f76e96d3e6d732$export$d66501df72047452(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $26f76e96d3e6d732$export$a07804094c3ecf2d(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($26f76e96d3e6d732$export$db202ddc8be9136() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $26f76e96d3e6d732$export$56c0d5a1e737357d(event) {
    if ($26f76e96d3e6d732$export$df995fae86a55f06()) return false;
    return !$26f76e96d3e6d732$export$db202ddc8be9136() && event.width === 0 && event.height === 0 || $26f76e96d3e6d732$export$db202ddc8be9136() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $26f76e96d3e6d732$export$3a1a48c8f6ef640e(pointerType, strict) {
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", void 0);
    return values.includes(pointerType);
}
//#endregion
//#region src/utils/composite.ts
function $26f76e96d3e6d732$export$342063e11d6c3cad(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $26f76e96d3e6d732$export$ebd11618f299a286(items, index) {
    return index < 0 || index >= items().length;
}
function $26f76e96d3e6d732$export$c4ce752e73470fba(items, disabledIndices) {
    return $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
        disabledIndices: disabledIndices
    });
}
function $26f76e96d3e6d732$export$96f57966bedc81b4(items, disabledIndices) {
    return $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
        decrement: true,
        startingIndex: items().length,
        disabledIndices: disabledIndices
    });
}
function $26f76e96d3e6d732$export$e7094788287c5e9b(items, { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = {}) {
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= items().length - 1 && $26f76e96d3e6d732$export$35e795649ee09318(items, index, disabledIndices));
    return index;
}
function $26f76e96d3e6d732$export$a9c23c6ac3fc3eca(items, { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false }) {
    let nextIndex = prevIndex;
    if (event.key === "ArrowUp") {
        if (stop) $26f76e96d3e6d732$export$d66501df72047452(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($26f76e96d3e6d732$export$ebd11618f299a286(items, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === "ArrowDown") {
        if (stop) $26f76e96d3e6d732$export$d66501df72047452(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($26f76e96d3e6d732$export$ebd11618f299a286(items, nextIndex)) nextIndex = prevIndex;
    }
    if (orientation === "both") {
        const prevRow = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? "ArrowLeft" : "ArrowRight")) {
            if (stop) $26f76e96d3e6d732$export$d66501df72047452(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $26f76e96d3e6d732$export$342063e11d6c3cad(nextIndex, cols, prevRow)) nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($26f76e96d3e6d732$export$342063e11d6c3cad(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? "ArrowRight" : "ArrowLeft")) {
            if (stop) $26f76e96d3e6d732$export$d66501df72047452(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $26f76e96d3e6d732$export$342063e11d6c3cad(nextIndex, cols, prevRow)) nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($26f76e96d3e6d732$export$342063e11d6c3cad(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $f3d5a22901917d2b$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($26f76e96d3e6d732$export$ebd11618f299a286(items, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? "ArrowRight" : "ArrowLeft") ? maxIndex : $26f76e96d3e6d732$export$e7094788287c5e9b(items, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $26f76e96d3e6d732$export$25ce5a424b770e84(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach(({ width: width, height: height }, index)=>{
        if (width > cols) {
            if (0, $1f5a16020b51a07b$export$404582bc18fe4d9e) throw new Error(`[Floating UI]: Invalid grid - item width at index ${index} is greater than grid columns`);
        }
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $26f76e96d3e6d732$export$efccba1c4a2ef57b(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tr":
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
        default:
            return firstCellIndex;
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $26f76e96d3e6d732$export$971d5caa766a69d7(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $26f76e96d3e6d732$export$35e795649ee09318(items, index, disabledIndices) {
    if (typeof disabledIndices === "function") return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = items()[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
//#endregion
//#region src/utils/element.ts
/**
* The focused element, following shadow roots down to the innermost one.
*/ function $26f76e96d3e6d732$export$2d1720544b23b823(doc) {
    let active = doc.activeElement;
    while(active?.shadowRoot?.activeElement != null)active = active.shadowRoot.activeElement;
    return active;
}
/**
* Like `Node.contains`, but able to cross shadow boundaries.
*/ function $26f76e96d3e6d732$export$ffb5f4729a158638(parent, child) {
    if (!parent || !child) return false;
    if (parent.contains(child)) return true;
    if (!(0, $dd40b91ca1c84530$export$af51f0f06c0f328a)(child.getRootNode())) return false;
    let next = child;
    while(next){
        if (parent === next) return true;
        next = (0, $dd40b91ca1c84530$export$af51f0f06c0f328a)(next) ? next.host : next.parentNode;
    }
    return false;
}
/**
* The innermost element an event started from, looking through shadow roots.
*/ function $26f76e96d3e6d732$export$39b482c5e57630a8(event) {
    return event.composedPath()[0] ?? event.target;
}
function $26f76e96d3e6d732$export$71511d61b312f219(event, node) {
    if (node == null) return false;
    return event.composedPath().includes(node);
}
function $26f76e96d3e6d732$export$90a7f3efeed30595(element) {
    return element.matches("html,body");
}
function $26f76e96d3e6d732$export$953cecd6e717a553(node) {
    const owner = node?.ownerDocument;
    return owner?.defaultView ? owner : document;
}
function $26f76e96d3e6d732$export$8b22cf2602fb60ce(element) {
    return (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(element) && element.matches("input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])");
}
function $26f76e96d3e6d732$export$4a5767248b18ef41(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $26f76e96d3e6d732$export$8b22cf2602fb60ce(element);
}
function $26f76e96d3e6d732$export$d141bba7fdc215a3(element) {
    if (!element || $26f76e96d3e6d732$export$df995fae86a55f06()) return true;
    try {
        return element.matches(":focus-visible");
    } catch  {
        return true;
    }
}
/**
* The element the floating props were spread onto. When the floating element
* is only a positioning wrapper, focus belongs on the child that carries the
* event handlers and aria props.
*/ function $26f76e96d3e6d732$export$dda1d9f60106f0e9(floatingElement) {
    if (!floatingElement) return null;
    if (floatingElement.hasAttribute("data-floating-ui-focusable")) return floatingElement;
    return floatingElement.querySelector(`[data-floating-ui-focusable]`) ?? floatingElement;
}
//#endregion
//#region src/utils/schedule.ts
let $26f76e96d3e6d732$var$rafId = 0;
/**
* Focuses an element on the next frame, so it runs after the DOM settles.
*/ function $26f76e96d3e6d732$export$4368d992c4eafac0(el, options = {}) {
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    if (cancelPrevious) cancelAnimationFrame($26f76e96d3e6d732$var$rafId);
    const exec = ()=>{
        el?.focus({
            preventScroll: preventScroll
        });
    };
    if (sync) exec();
    else $26f76e96d3e6d732$var$rafId = requestAnimationFrame(exec);
}
/**
* Clears a pending timeout and returns the id to store back, so callers can
* keep the id in a plain `let`.
*/ function $26f76e96d3e6d732$export$3b14a55fb2447963(id) {
    if (id !== -1) clearTimeout(id);
    return -1;
}
//#endregion
//#region src/utils/nodes.ts
function $26f76e96d3e6d732$export$882b5998b3b9117c(nodes, id, onlyOpenChildren = true) {
    return nodes.filter((node)=>node.parentId === id && (!onlyOpenChildren || node.context?.open)).flatMap((child)=>[
            child,
            ...$26f76e96d3e6d732$export$882b5998b3b9117c(nodes, child.id, onlyOpenChildren)
        ]);
}
function $26f76e96d3e6d732$export$2408f22a0fab9ae5(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        $26f76e96d3e6d732$export$882b5998b3b9117c(nodes, nodeId).forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $26f76e96d3e6d732$export$db3b6bfb95261072(nodes, id) {
    let allAncestors = [];
    let currentParentId = nodes.find((node)=>node.id === id)?.parentId;
    while(currentParentId){
        const parentId = currentParentId;
        const currentNode = nodes.find((node)=>node.id === parentId);
        currentParentId = currentNode?.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
//#endregion
//#region src/utils/tabbable.ts
function $26f76e96d3e6d732$export$407448d2b89b1813() {
    return {
        getShadowRoot: true,
        displayCheck: typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    };
}
function $26f76e96d3e6d732$var$getTabbableIn(container, dir) {
    const list = (0, $7b28c9bd65463003$export$17100aea90429aa7)(container, $26f76e96d3e6d732$export$407448d2b89b1813());
    if (list.length === 0) return;
    const active = $26f76e96d3e6d732$export$2d1720544b23b823($26f76e96d3e6d732$export$953cecd6e717a553(container));
    const index = list.findIndex((element)=>element === active);
    if (index === -1) return dir === 1 ? list[0] : list[list.length - 1];
    return list[index + dir];
}
function $26f76e96d3e6d732$var$tabbableOrReference(referenceElement, dir) {
    const next = $26f76e96d3e6d732$var$getTabbableIn($26f76e96d3e6d732$export$953cecd6e717a553(referenceElement).body, dir);
    if (next) return next;
    return referenceElement instanceof HTMLElement ? referenceElement : null;
}
function $26f76e96d3e6d732$export$43caf9889c228507(referenceElement) {
    return $26f76e96d3e6d732$var$tabbableOrReference(referenceElement, 1);
}
function $26f76e96d3e6d732$export$23f2a1d2818174ef(referenceElement) {
    return $26f76e96d3e6d732$var$tabbableOrReference(referenceElement, -1);
}
function $26f76e96d3e6d732$export$ae1af26003f05816(event, container) {
    const containerElement = container ?? event.currentTarget;
    const relatedTarget = event.relatedTarget;
    if (!(containerElement instanceof Element)) return true;
    if (!(relatedTarget instanceof Element)) return true;
    return !$26f76e96d3e6d732$export$ffb5f4729a158638(containerElement, relatedTarget);
}
function $26f76e96d3e6d732$export$625550452a3fa3ec(container) {
    for (const element of (0, $7b28c9bd65463003$export$17100aea90429aa7)(container, $26f76e96d3e6d732$export$407448d2b89b1813())){
        if (element instanceof HTMLElement) element.dataset.tabindex = element.getAttribute("tabindex") ?? "";
        element.setAttribute("tabindex", "-1");
    }
}
function $26f76e96d3e6d732$export$7ccc53e8f1e7dfc5(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    for (const element of elements){
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    }
}








//#region src/hooks/useMergeRefs.ts
/**
* Merges several callback refs into one, for when a single element has to be
* handed to more than one consumer.
*/ function $ba2e53669058e2bf$export$74665b213cb5c4cf(refs) {
    return (node)=>{
        for (const ref of refs)ref?.(node);
    };
}
//#endregion
//#region src/components/FloatingList.tsx
function $ba2e53669058e2bf$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $ba2e53669058e2bf$var$FloatingListContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)({
    register: ()=>{},
    unregister: ()=>{},
    setLabel: ()=>{},
    map: /* @__PURE__ */ new Map()
});
/**
* Collects the items rendered inside it, in DOM order, and hands them to the
* navigation hooks. The items register themselves with `useListItem`, so
* conditional and reordered lists stay correct without an index prop.
*/ function $ba2e53669058e2bf$export$ffe15b0e64951704(props) {
    const [nodes, setNodes] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(/* @__PURE__ */ new Set(), {
        equals: false
    });
    const [labels, setLabels] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(/* @__PURE__ */ new Map(), {
        equals: false
    });
    function register(node) {
        setNodes((previous)=>{
            previous.add(node);
            return previous;
        });
    }
    function unregister(node) {
        setNodes((previous)=>{
            previous.delete(node);
            return previous;
        });
        setLabels((previous)=>{
            previous.delete(node);
            return previous;
        });
    }
    function setLabel(node, label) {
        setLabels((previous)=>{
            previous.set(node, label);
            return previous;
        });
    }
    const sorted = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>Array.from(nodes()).sort($ba2e53669058e2bf$var$sortByDocumentPosition));
    const map = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const result = /* @__PURE__ */ new Map();
        sorted().forEach((node, index)=>{
            result.set(node, index);
        });
        return result;
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        props.onElementsChange?.(sorted().map((node)=>node instanceof HTMLElement ? node : null));
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const currentLabels = labels();
        props.onLabelsChange?.(sorted().map((node)=>currentLabels.get(node) ?? null));
    });
    const context = {
        register: register,
        unregister: unregister,
        setLabel: setLabel,
        get map () {
            return map();
        }
    };
    return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FloatingListContext.Provider, {
        value: context
    }, props.children);
}
/**
* Registers a list item and reports its index (DOM position) in the
* surrounding `FloatingList`.
*/ function $ba2e53669058e2bf$export$dcdc7ff5149f7d1a(props = {}) {
    const listContext = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($ba2e53669058e2bf$var$FloatingListContext);
    const [element, setElement] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    function ref(node) {
        if (node === element()) return;
        setElement(node);
        if (node) {
            listContext.register(node);
            (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
                listContext.unregister(node);
            });
        }
    }
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const node = element();
        if (node) listContext.setLabel(node, props.label === void 0 ? node.textContent : props.label);
    });
    const index = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const node = element();
        return node === null ? -1 : listContext.map.get(node) ?? -1;
    });
    return {
        ref: ref,
        get index () {
            return index();
        }
    };
}
//#endregion
//#region src/components/Composite.tsx
function $ba2e53669058e2bf$var$renderJsx(render, computedProps) {
    if (render) return render(computedProps);
    return /*#__PURE__*/ React.createElement("div", computedProps);
}
const $ba2e53669058e2bf$var$CompositeContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)({
    activeIndex: 0,
    onNavigate: ()=>{}
});
/**
* The corner to measure a grid move from: the edge closest to the direction of
* travel, preferring top and left, so a move never lands on the same item.
*/ function $ba2e53669058e2bf$var$cornerForKey$1(key, horizontalEndKey) {
    if (key === "ArrowDown") return "bl";
    return key === horizontalEndKey ? "tr" : "tl";
}
const $ba2e53669058e2bf$var$horizontalKeys = [
    (0, $26f76e96d3e6d732$export$71cec2538cb2c617),
    (0, $26f76e96d3e6d732$export$2329c99376c9d0a4)
];
const $ba2e53669058e2bf$var$verticalKeys = [
    (0, $26f76e96d3e6d732$export$3466f893ebf79586),
    (0, $26f76e96d3e6d732$export$3a6d5c9ae78a2c08)
];
const $ba2e53669058e2bf$var$allKeys = [
    ...$ba2e53669058e2bf$var$horizontalKeys,
    ...$ba2e53669058e2bf$var$verticalKeys
];
/**
* Creates a single tab stop whose items are navigated by arrow keys, which
* provides list navigation outside of floating element contexts. A menubar is
* an example of a composite, with each reference element being an item.
*/ function $ba2e53669058e2bf$export$43586241d9db0c6d(props) {
    const [local, domProps] = (0, $1f5a16020b51a07b$export$45029c61b0073d87)(props, [
        "render",
        "orientation",
        "loop",
        "rtl",
        "cols",
        "disabledIndices",
        "activeIndex",
        "onNavigate",
        "itemSizes",
        "dense",
        "onKeyDown"
    ]);
    const orientation = ()=>local.orientation ?? "both";
    const loop = ()=>local.loop ?? true;
    const rtl = ()=>local.rtl ?? false;
    const cols = ()=>local.cols ?? 1;
    const dense = ()=>local.dense ?? false;
    const [internalActiveIndex, setInternalActiveIndex] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    const activeIndex = ()=>local.activeIndex ?? internalActiveIndex();
    function onNavigate(index) {
        if (local.onNavigate) local.onNavigate(index);
        else setInternalActiveIndex(index);
    }
    const [items, setItems] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)([]);
    function handleKeyDown(event) {
        if (!$ba2e53669058e2bf$var$allKeys.includes(event.key)) return;
        const disabledIndices = local.disabledIndices;
        const currentActiveIndex = activeIndex();
        const currentCols = cols();
        const currentRtl = rtl();
        const currentOrientation = orientation();
        const isGrid = currentCols > 1;
        let nextIndex = currentActiveIndex;
        const minIndex = (0, $26f76e96d3e6d732$export$c4ce752e73470fba)(items, disabledIndices);
        const maxIndex = (0, $26f76e96d3e6d732$export$96f57966bedc81b4)(items, disabledIndices);
        const horizontalEndKey = currentRtl ? (0, $26f76e96d3e6d732$export$71cec2538cb2c617) : (0, $26f76e96d3e6d732$export$2329c99376c9d0a4);
        const horizontalStartKey = currentRtl ? (0, $26f76e96d3e6d732$export$2329c99376c9d0a4) : (0, $26f76e96d3e6d732$export$71cec2538cb2c617);
        if (isGrid) {
            const sizes = local.itemSizes ?? Array.from({
                length: items().length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            const cellMap = (0, $26f76e96d3e6d732$export$25ce5a424b770e84)(sizes, currentCols, dense());
            const explicitDisabledIndices = typeof disabledIndices === "function" ? void 0 : disabledIndices;
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $26f76e96d3e6d732$export$35e795649ee09318)(items, index, disabledIndices));
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $26f76e96d3e6d732$export$35e795649ee09318)(items, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $26f76e96d3e6d732$export$a9c23c6ac3fc3eca)(()=>cellMap.map((itemIndex)=>itemIndex ? items()[itemIndex] ?? null : null), {
                event: event,
                orientation: currentOrientation,
                loop: loop(),
                rtl: currentRtl,
                cols: currentCols,
                disabledIndices: (0, $26f76e96d3e6d732$export$971d5caa766a69d7)([
                    ...explicitDisabledIndices ?? items().map((_, index)=>(0, $26f76e96d3e6d732$export$35e795649ee09318)(items, index, disabledIndices) ? index : void 0),
                    void 0
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $26f76e96d3e6d732$export$efccba1c4a2ef57b)(currentActiveIndex > maxIndex ? minIndex : currentActiveIndex, sizes, cellMap, currentCols, $ba2e53669058e2bf$var$cornerForKey$1(event.key, horizontalEndKey))
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                (0, $26f76e96d3e6d732$export$3a6d5c9ae78a2c08)
            ],
            both: [
                horizontalEndKey,
                (0, $26f76e96d3e6d732$export$3a6d5c9ae78a2c08)
            ]
        }[currentOrientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                (0, $26f76e96d3e6d732$export$3466f893ebf79586)
            ],
            both: [
                horizontalStartKey,
                (0, $26f76e96d3e6d732$export$3466f893ebf79586)
            ]
        }[currentOrientation];
        const preventedKeys = isGrid ? $ba2e53669058e2bf$var$allKeys : ({
            horizontal: $ba2e53669058e2bf$var$horizontalKeys,
            vertical: $ba2e53669058e2bf$var$verticalKeys,
            both: $ba2e53669058e2bf$var$allKeys
        })[currentOrientation];
        if (nextIndex === currentActiveIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop() && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop() && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $26f76e96d3e6d732$export$e7094788287c5e9b)(items, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== currentActiveIndex && !(0, $26f76e96d3e6d732$export$ebd11618f299a286)(items, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            items()[nextIndex]?.focus();
        }
    }
    const context = {
        get activeIndex () {
            return activeIndex();
        },
        onNavigate: onNavigate
    };
    const ariaOrientation = ()=>{
        const value = orientation();
        return value === "both" ? void 0 : value;
    };
    const computedProps = (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(domProps, {
        get "aria-orientation" () {
            return ariaOrientation();
        },
        onKeyDown (event) {
            local.onKeyDown?.(event);
            handleKeyDown(event);
        }
    });
    return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$CompositeContext.Provider, {
        value: context
    }, /*#__PURE__*/ React.createElement($ba2e53669058e2bf$export$ffe15b0e64951704, {
        onElementsChange: (value)=>{
            setItems(value);
        }
    }, $ba2e53669058e2bf$var$renderJsx(local.render, computedProps)));
}
function $ba2e53669058e2bf$export$ef1ef7a3a43ace8e(props) {
    const [local, domProps] = (0, $1f5a16020b51a07b$export$45029c61b0073d87)(props, [
        "render",
        "ref",
        "onFocus"
    ]);
    const compositeContext = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($ba2e53669058e2bf$var$CompositeContext);
    const listItem = $ba2e53669058e2bf$export$dcdc7ff5149f7d1a();
    const mergedRef = $ba2e53669058e2bf$export$74665b213cb5c4cf([
        listItem.ref,
        local.ref
    ]);
    const isActive = ()=>compositeContext.activeIndex === listItem.index;
    const computedProps = (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(domProps, {
        ref: mergedRef,
        get tabindex () {
            return isActive() ? 0 : -1;
        },
        get "data-active" () {
            return isActive() ? "" : void 0;
        },
        onFocus (event) {
            local.onFocus?.(event);
            compositeContext.onNavigate(listItem.index);
        }
    });
    return $ba2e53669058e2bf$var$renderJsx(local.render, computedProps);
}
//#endregion
//#region src/components/FloatingArrow.tsx
/**
* Splits a placement such as `bottom-end` into its side and alignment.
*/ function $ba2e53669058e2bf$var$splitPlacement(placement) {
    const [side, alignment] = placement.split("-");
    return {
        side: side === "top" || side === "right" || side === "bottom" ? side : "left",
        alignment: alignment === "start" || alignment === "end" ? alignment : void 0
    };
}
/**
* Renders a pointing arrow triangle.
*/ function $ba2e53669058e2bf$export$33511391554732bc(props) {
    const [local, rest] = (0, $1f5a16020b51a07b$export$45029c61b0073d87)(props, [
        "context",
        "width",
        "height",
        "tipRadius",
        "strokeWidth",
        "staticOffset",
        "stroke",
        "d",
        "style"
    ]);
    const width = ()=>local.width ?? 14;
    const height = ()=>local.height ?? 7;
    const tipRadius = ()=>local.tipRadius ?? 0;
    const strokeWidth = ()=>local.strokeWidth ?? 0;
    const clipPathId = (0, $1f5a16020b51a07b$export$33208d63bc845a83)();
    const [isRTL, setIsRTL] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        const floating = local.context.elements.floating;
        if (!floating) return;
        if ((0, $dd40b91ca1c84530$export$3735103072e4a80)(floating).direction === "rtl") setIsRTL(true);
    });
    const side = ()=>$ba2e53669058e2bf$var$splitPlacement(local.context.placement).side;
    const alignment = ()=>$ba2e53669058e2bf$var$splitPlacement(local.context.placement).alignment;
    const isVerticalSide = ()=>side() === "top" || side() === "bottom";
    const isCustomShape = ()=>!!local.d;
    const computedStaticOffset = ()=>{
        const shift = local.context.middlewareData.shift;
        if (isVerticalSide() && shift?.x || !isVerticalSide() && shift?.y) return null;
        return local.staticOffset;
    };
    const computedStrokeWidth = ()=>strokeWidth() * 2;
    const dValue = ()=>{
        if (local.d) return local.d;
        const svgX = width() / 2 * (tipRadius() / -8 + 1);
        const svgY = height() / 2 * tipRadius() / 4;
        return `M0,0 H${width()} L${width() - svgX},${height() - svgY} Q${width() / 2},${height()} ${svgX},${height() - svgY} Z`;
    };
    const arrowStyle = ()=>{
        const offset = computedStaticOffset();
        const yOffsetProp = offset && alignment() === "end" ? "bottom" : "top";
        let xOffsetProp = offset && alignment() === "end" ? "right" : "left";
        if (offset && isRTL()) xOffsetProp = alignment() === "end" ? "left" : "right";
        const arrow = local.context.middlewareData.arrow;
        const arrowX = arrow?.x == null ? "" : offset ?? arrow.x;
        const arrowY = arrow?.y == null ? "" : offset ?? arrow.y;
        const custom = isCustomShape();
        const rotation = {
            top: custom ? "rotate(180deg)" : "",
            left: custom ? "rotate(90deg)" : "rotate(-90deg)",
            bottom: custom ? "" : "rotate(180deg)",
            right: custom ? "rotate(-90deg)" : "rotate(90deg)"
        }[side()];
        const { transform: userTransform, ...restStyle } = typeof local.style === "object" ? local.style : {};
        return {
            position: "absolute",
            "pointer-events": "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side()]: isVerticalSide() || isCustomShape() ? "100%" : `calc(100% - ${computedStrokeWidth() / 2}px)`,
            transform: [
                rotation,
                userTransform
            ].filter(Boolean).join(" "),
            ...restStyle
        };
    };
    return /*#__PURE__*/ React.createElement((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
        when: local.context.elements.floating
    }, /*#__PURE__*/ React.createElement("svg", {
        ...rest,
        "aria-hidden": "true",
        width: isCustomShape() ? width() : width() + computedStrokeWidth(),
        height: width(),
        viewBox: `0 0 ${width()} ${height() > width() ? height() : width()}`,
        style: arrowStyle()
    }, /*#__PURE__*/ React.createElement((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
        when: computedStrokeWidth() > 0
    }, /*#__PURE__*/ React.createElement("path", {
        "clip-path": `url(#${clipPathId})`,
        fill: "none",
        stroke: local.stroke,
        "stroke-width": computedStrokeWidth() + (local.d ? 0 : 1),
        d: dValue()
    })), /*#__PURE__*/ React.createElement("path", {
        stroke: computedStrokeWidth() && !local.d ? rest.fill : "none",
        d: dValue()
    }), /*#__PURE__*/ React.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ React.createElement("rect", {
        x: -computedStrokeWidth() / 2,
        y: computedStrokeWidth() / 2 * (isCustomShape() ? -1 : 1),
        width: width() + computedStrokeWidth(),
        height: width()
    }))));
}
//#endregion
//#region src/utils/createEventEmitter.ts
function $ba2e53669058e2bf$var$createEventEmitter() {
    const map = /* @__PURE__ */ new Map();
    return {
        emit (event, data) {
            for (const listener of map.get(event) ?? [])listener(data);
        },
        on (event, listener) {
            let listeners = map.get(event);
            if (!listeners) {
                listeners = /* @__PURE__ */ new Set();
                map.set(event, listeners);
            }
            listeners.add(listener);
        },
        off (event, listener) {
            map.get(event)?.delete(listener);
        }
    };
}
//#endregion
//#region src/components/FloatingTree.tsx
const $ba2e53669058e2bf$var$FloatingNodeContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)(null);
const $ba2e53669058e2bf$var$FloatingTreeContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)(null);
/**
* Returns the parent node id for nested floating elements, if available.
* Returns `null` for top-level floating elements.
*/ function $ba2e53669058e2bf$export$165209eae06d3488() {
    return (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($ba2e53669058e2bf$var$FloatingNodeContext)?.id ?? null;
}
/**
* Returns the nearest floating tree context, if available.
*/ function $ba2e53669058e2bf$export$db0c2a7c7a2a4f69() {
    return (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($ba2e53669058e2bf$var$FloatingTreeContext);
}
/**
* Registers a node into the `FloatingTree`, returning its id.
*/ function $ba2e53669058e2bf$export$9b136e0e758a42f4(customParentId) {
    const id = (0, $1f5a16020b51a07b$export$33208d63bc845a83)();
    const tree = $ba2e53669058e2bf$export$db0c2a7c7a2a4f69();
    const contextParentId = $ba2e53669058e2bf$export$165209eae06d3488();
    const node = {
        id: id,
        parentId: customParentId ?? contextParentId
    };
    tree?.addNode(node);
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        tree?.removeNode(node);
    });
    return id;
}
/**
* Provides parent node context for nested floating elements.
*/ function $ba2e53669058e2bf$export$ca00a83b5b253862(props) {
    const context = {
        get id () {
            return props.id;
        },
        parentId: $ba2e53669058e2bf$export$165209eae06d3488()
    };
    return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FloatingNodeContext.Provider, {
        value: context
    }, props.children);
}
/**
* Provides context for nested floating elements when they are not children of
* each other on the DOM. It is necessary for:
* - The `bubbles` option in the `useDismiss()` hook
* - Nested virtual list navigation
* - Nested floating elements that each open on hover
* - Custom communication between parent and child floating elements
*/ function $ba2e53669058e2bf$export$587b60129641c4c8(props) {
    const [nodes, setNodes] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)([]);
    const context = {
        nodes: nodes,
        events: $ba2e53669058e2bf$var$createEventEmitter(),
        addNode (node) {
            setNodes((previous)=>[
                    ...previous,
                    node
                ]);
        },
        removeNode (node) {
            setNodes((previous)=>previous.filter((n)=>n !== node));
        }
    };
    return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FloatingTreeContext.Provider, {
        value: context
    }, props.children);
}
//#endregion
//#region src/utils/reactivity.ts
/**
* Runs `effect` whenever its reactive reads change, and registers whatever
* teardown it returns against that run.
*/ function $ba2e53669058e2bf$var$createCleanupEffect(effect) {
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const cleanup = effect();
        if (cleanup) (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(cleanup);
    });
}
/**
* Presents a computed props object as a live one. Every trap recomputes, so a
* reactive read inside `compute` is tracked by whoever spreads the result onto
* an element, and props that come and go are picked up as well as props whose
* value changes.
*/ function $ba2e53669058e2bf$var$lazyProps(compute) {
    return new Proxy({}, {
        get (_target, key) {
            return typeof key === "string" ? compute()[key] : void 0;
        },
        has (_target, key) {
            return key in compute();
        },
        ownKeys () {
            return Reflect.ownKeys(compute());
        },
        getOwnPropertyDescriptor (_target, key) {
            const resolved = compute();
            if (typeof key !== "string" || !(key in resolved)) return;
            return {
                configurable: true,
                enumerable: true,
                value: resolved[key],
                writable: true
            };
        }
    });
}
//#endregion
//#region src/hooks/useHover.ts
const $ba2e53669058e2bf$var$safePolygonIdentifier = (0, $26f76e96d3e6d732$export$8743009a87fcb00f)("safe-polygon");
function $ba2e53669058e2bf$var$isStyledElement(element) {
    return element instanceof HTMLElement || element instanceof SVGElement;
}
function $ba2e53669058e2bf$export$621ec2f31bd1c7ec(value, prop, pointerType) {
    if (pointerType && !(0, $26f76e96d3e6d732$export$3a1a48c8f6ef640e)(pointerType)) return 0;
    if (typeof value === "number") return value;
    if (typeof value === "function") {
        const result = value();
        if (typeof result === "number") return result;
        return result[prop];
    }
    return value?.[prop];
}
function $ba2e53669058e2bf$var$getRestMs(value) {
    if (typeof value === "function") return value();
    return value;
}
/**
* Opens the floating element while hovering over the reference element, like
* CSS `:hover`.
*/ function $ba2e53669058e2bf$export$ae780daf29e6d456(context, props = {}) {
    const enabled = ()=>props.enabled !== false;
    const delay = ()=>props.delay ?? 0;
    const handleClose = ()=>props.handleClose ?? null;
    const mouseOnly = ()=>props.mouseOnly ?? false;
    const restMs = ()=>props.restMs ?? 0;
    const move = ()=>props.move ?? true;
    const tree = $ba2e53669058e2bf$export$db0c2a7c7a2a4f69();
    const parentId = $ba2e53669058e2bf$export$165209eae06d3488();
    let pointerType;
    let timeoutId = -1;
    let restTimeoutId = -1;
    let mouseMoveHandler;
    let blockMouseMove = true;
    let performedPointerEventsMutation = false;
    let unbindMouseMove = ()=>{};
    let restTimeoutPending = false;
    function isHoverOpen() {
        const type = context.data.openEvent?.type;
        return !!type?.includes("mouse") && type !== "mousedown";
    }
    function isClickLikeOpenEvent() {
        return context.data.openEvent ? [
            "click",
            "mousedown"
        ].includes(context.data.openEvent.type) : false;
    }
    function cleanupMouseMoveHandler() {
        unbindMouseMove();
        mouseMoveHandler = void 0;
    }
    function clearPointerEvents() {
        if (performedPointerEventsMutation) {
            const body = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(context.elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($ba2e53669058e2bf$var$safePolygonIdentifier);
            performedPointerEventsMutation = false;
        }
    }
    function closeWithDelay(event, runElseBranch = true, reason = "hover") {
        const closeDelay = $ba2e53669058e2bf$export$621ec2f31bd1c7ec(delay(), "close", pointerType);
        if (closeDelay && !mouseMoveHandler) {
            timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
            timeoutId = window.setTimeout(()=>{
                context.onOpenChange(false, event, reason);
            }, closeDelay);
        } else if (runElseBranch) {
            timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
            context.onOpenChange(false, event, reason);
        }
    }
    /**
	* Keeps the live getters of the floating context while adding the fields
	* `handleClose` expects, so a handler such as `safePolygon` keeps reading
	* current values.
	*/ function createHandleCloseContext(event, onClose) {
        const floatingContext = context.data.floatingContext;
        if (!floatingContext) return null;
        return {
            x: event.clientX,
            y: event.clientY,
            tree: tree,
            onClose: onClose,
            get placement () {
                return floatingContext.placement;
            },
            get strategy () {
                return floatingContext.strategy;
            },
            get middlewareData () {
                return floatingContext.middlewareData;
            },
            get isPositioned () {
                return floatingContext.isPositioned;
            },
            get floatingStyles () {
                return floatingContext.floatingStyles;
            },
            get open () {
                return floatingContext.open;
            },
            update () {
                floatingContext.update();
            },
            onOpenChange (open, openEvent, reason) {
                floatingContext.onOpenChange(open, openEvent, reason);
            },
            events: floatingContext.events,
            data: floatingContext.data,
            nodeId: floatingContext.nodeId,
            floatingId: floatingContext.floatingId,
            refs: floatingContext.refs,
            elements: floatingContext.elements
        };
    }
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        const events = context.events;
        function onOpenChange({ open: open }) {
            if (!open) {
                timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
                restTimeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(restTimeoutId);
                blockMouseMove = true;
                restTimeoutPending = false;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        if (!handleClose()) return;
        if (!context.open) return;
        function onLeave(event) {
            if (isHoverOpen()) context.onOpenChange(false, event, "hover");
        }
        const html = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(context.elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        const domReference = context.elements.domReference;
        const floating = context.elements.floating;
        const open = context.open;
        function onReferenceMouseEnter(event) {
            timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
            blockMouseMove = false;
            if (mouseOnly() && !(0, $26f76e96d3e6d732$export$3a1a48c8f6ef640e)(pointerType) || $ba2e53669058e2bf$var$getRestMs(restMs()) > 0 && !$ba2e53669058e2bf$export$621ec2f31bd1c7ec(delay(), "open")) return;
            const openDelay = $ba2e53669058e2bf$export$621ec2f31bd1c7ec(delay(), "open", pointerType);
            if (openDelay) timeoutId = window.setTimeout(()=>{
                if (!context.open) context.onOpenChange(true, event, "hover");
            }, openDelay);
            else if (!open) context.onOpenChange(true, event, "hover");
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMove();
            const doc = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(context.elements.floating);
            restTimeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(restTimeoutId);
            restTimeoutPending = false;
            const currentHandleClose = handleClose();
            if (currentHandleClose) {
                const handleCloseContext = createHandleCloseContext(event, ()=>{
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event, true, "safe-polygon");
                });
                if (handleCloseContext) {
                    if (!open) timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
                    const handler = currentHandleClose(handleCloseContext);
                    mouseMoveHandler = handler;
                    doc.addEventListener("mousemove", handler);
                    unbindMouseMove = ()=>{
                        doc.removeEventListener("mousemove", handler);
                    };
                    return;
                }
            }
            const relatedTarget = event.relatedTarget instanceof Element ? event.relatedTarget : null;
            if (pointerType !== "touch" || !(0, $26f76e96d3e6d732$export$ffb5f4729a158638)(context.elements.floating, relatedTarget)) closeWithDelay(event);
        }
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            const handleCloseContext = createHandleCloseContext(event, ()=>{
                clearPointerEvents();
                cleanupMouseMoveHandler();
                if (!isClickLikeOpenEvent()) closeWithDelay(event);
            });
            if (!handleCloseContext) return;
            handleClose()?.(handleCloseContext)(event);
        }
        function onFloatingMouseEnter() {
            timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ($ba2e53669058e2bf$var$isStyledElement(domReference)) {
            const reference = domReference;
            const shouldMove = move();
            if (open) reference.addEventListener("mouseleave", onScrollMouseLeave);
            if (shouldMove) reference.addEventListener("mousemove", onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener("mouseenter", onReferenceMouseEnter);
            reference.addEventListener("mouseleave", onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener("mouseleave", onScrollMouseLeave);
                floating.addEventListener("mouseenter", onFloatingMouseEnter);
                floating.addEventListener("mouseleave", onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener("mouseleave", onScrollMouseLeave);
                if (shouldMove) reference.removeEventListener("mousemove", onReferenceMouseEnter);
                reference.removeEventListener("mouseenter", onReferenceMouseEnter);
                reference.removeEventListener("mouseleave", onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener("mouseleave", onScrollMouseLeave);
                    floating.removeEventListener("mouseenter", onFloatingMouseEnter);
                    floating.removeEventListener("mouseleave", onFloatingMouseLeave);
                }
            };
        }
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        if (context.open && handleClose()?.options?.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutation = true;
            const floatingEl = context.elements.floating;
            const domReference = context.elements.domReference;
            if ($ba2e53669058e2bf$var$isStyledElement(domReference) && floatingEl) {
                const body = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(floatingEl).body;
                body.setAttribute($ba2e53669058e2bf$var$safePolygonIdentifier, "");
                const parentFloating = tree?.nodes().find((node)=>node.id === parentId)?.context?.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                floatingEl.style.pointerEvents = "auto";
                domReference.style.pointerEvents = "auto";
                return ()=>{
                    body.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                    domReference.style.pointerEvents = "";
                };
            }
        }
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!context.open) {
            pointerType = void 0;
            restTimeoutPending = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    });
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        cleanupMouseMoveHandler();
        timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
        restTimeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(restTimeoutId);
        clearPointerEvents();
    });
    function setPointerType(event) {
        pointerType = event.pointerType;
    }
    const reference = {
        onPointerDown: setPointerType,
        onPointerEnter: setPointerType,
        onMouseMove (event) {
            function handleMouseMove() {
                if (!blockMouseMove && !context.open) context.onOpenChange(true, event, "hover");
            }
            if (mouseOnly() && !(0, $26f76e96d3e6d732$export$3a1a48c8f6ef640e)(pointerType)) return;
            if (context.open || $ba2e53669058e2bf$var$getRestMs(restMs()) === 0) return;
            if (restTimeoutPending && event.movementX ** 2 + event.movementY ** 2 < 2) return;
            restTimeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(restTimeoutId);
            if (pointerType === "touch") handleMouseMove();
            else {
                restTimeoutPending = true;
                restTimeoutId = window.setTimeout(handleMouseMove, $ba2e53669058e2bf$var$getRestMs(restMs()));
            }
        }
    };
    return {
        get reference () {
            return enabled() ? reference : void 0;
        }
    };
}
//#endregion
//#region src/components/FloatingDelayGroup.tsx
const $ba2e53669058e2bf$var$NOOP = ()=>{};
const $ba2e53669058e2bf$var$FloatingDelayGroupContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    isInstantPhase: false,
    setCurrentId: $ba2e53669058e2bf$var$NOOP,
    setState: $ba2e53669058e2bf$var$NOOP
});
/**
* Reads the surrounding `FloatingDelayGroup` context directly. Most callers
* want the return value of `useDelayGroup()` instead.
*/ function $ba2e53669058e2bf$export$e2411914b150383d() {
    return (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($ba2e53669058e2bf$var$FloatingDelayGroupContext);
}
/**
* Provides context for a group of floating elements that should share a
* `delay`.
*/ function $ba2e53669058e2bf$export$718279509ff1e241(props) {
    const [delay, setDelay] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(props.delay);
    const [currentId, setCurrentIdSignal] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const [isInstantPhase, setIsInstantPhase] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    let initialCurrentId = null;
    function setState(state) {
        if ("delay" in state) setDelay(()=>state.delay);
        if ("currentId" in state) setCurrentIdSignal(state.currentId ?? null);
        if ("isInstantPhase" in state) setIsInstantPhase(!!state.isInstantPhase);
    }
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const id = currentId();
        if (id) {
            if (initialCurrentId === null) initialCurrentId = id;
            else if (!isInstantPhase()) setIsInstantPhase(true);
        } else {
            if (isInstantPhase()) setIsInstantPhase(false);
            initialCurrentId = null;
        }
    });
    const context = {
        get delay () {
            return delay();
        },
        get initialDelay () {
            return props.delay;
        },
        get timeoutMs () {
            return props.timeoutMs ?? 0;
        },
        get currentId () {
            return currentId();
        },
        get isInstantPhase () {
            return isInstantPhase();
        },
        setCurrentId (id) {
            setCurrentIdSignal(()=>id);
        },
        setState: setState
    };
    return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FloatingDelayGroupContext.Provider, {
        value: context
    }, props.children);
}
/**
* Enables grouping when called inside a component that is a child of a
* `FloatingDelayGroup`.
*/ function $ba2e53669058e2bf$export$560fc8be89c8b4a8(context, options = {}) {
    const enabled = ()=>options.enabled !== false;
    const id = ()=>options.id ?? context.floatingId;
    const groupContext = $ba2e53669058e2bf$export$e2411914b150383d();
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!enabled()) return;
        if (!groupContext.currentId) return;
        groupContext.setState({
            delay: {
                open: 1,
                close: $ba2e53669058e2bf$export$621ec2f31bd1c7ec(groupContext.initialDelay, "close")
            }
        });
        if (groupContext.currentId !== id()) context.onOpenChange(false);
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        function unset() {
            context.onOpenChange(false);
            groupContext.setState({
                delay: groupContext.initialDelay,
                currentId: null
            });
        }
        if (!enabled()) return;
        if (!groupContext.currentId) return;
        if (!context.open && groupContext.currentId === id()) {
            if (groupContext.timeoutMs) {
                const timeout = window.setTimeout(unset, groupContext.timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!enabled()) return;
        if (groupContext.setCurrentId === $ba2e53669058e2bf$var$NOOP || !context.open) return;
        groupContext.setCurrentId(id());
    });
    return groupContext;
}
//#endregion
//#region src/utils/markOthers.ts
const $ba2e53669058e2bf$var$counters = {
    inert: /* @__PURE__ */ new WeakMap(),
    "aria-hidden": /* @__PURE__ */ new WeakMap(),
    none: /* @__PURE__ */ new WeakMap()
};
function $ba2e53669058e2bf$var$getCounterMap(control) {
    if (control === "inert") return $ba2e53669058e2bf$var$counters.inert;
    if (control === "aria-hidden") return $ba2e53669058e2bf$var$counters["aria-hidden"];
    return $ba2e53669058e2bf$var$counters.none;
}
let $ba2e53669058e2bf$var$uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
let $ba2e53669058e2bf$var$markerCounter = /* @__PURE__ */ new WeakMap();
let $ba2e53669058e2bf$var$lockCount$1 = 0;
const $ba2e53669058e2bf$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
function $ba2e53669058e2bf$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $dd40b91ca1c84530$export$af51f0f06c0f328a)(node) ? node.host : $ba2e53669058e2bf$var$unwrapHost(node.parentNode);
}
const $ba2e53669058e2bf$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $ba2e53669058e2bf$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $ba2e53669058e2bf$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    let controlAttribute = null;
    if (inert) controlAttribute = "inert";
    else if (ariaHidden) controlAttribute = "aria-hidden";
    const avoidElements = $ba2e53669058e2bf$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = /* @__PURE__ */ new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        for (const node of Array.from(parent.children)){
            if ((0, $dd40b91ca1c84530$export$651544f548703224)(node) === "script") continue;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterMap = $ba2e53669058e2bf$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) ?? 0) + 1;
                const markerValue = ($ba2e53669058e2bf$var$markerCounter.get(node) ?? 0) + 1;
                counterMap.set(node, counterValue);
                $ba2e53669058e2bf$var$markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $ba2e53669058e2bf$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === "inert" ? "" : "true");
            }
        }
    }
    for (const element of avoidElements)keep(element);
    deep(body);
    elementsToKeep.clear();
    $ba2e53669058e2bf$var$lockCount$1++;
    return ()=>{
        for (const element of hiddenElements){
            const counterMap = $ba2e53669058e2bf$var$getCounterMap(controlAttribute);
            const counterValue = (counterMap.get(element) ?? 0) - 1;
            const markerValue = ($ba2e53669058e2bf$var$markerCounter.get(element) ?? 0) - 1;
            counterMap.set(element, counterValue);
            $ba2e53669058e2bf$var$markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$ba2e53669058e2bf$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $ba2e53669058e2bf$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        }
        $ba2e53669058e2bf$var$lockCount$1--;
        if (!$ba2e53669058e2bf$var$lockCount$1) {
            $ba2e53669058e2bf$var$counters.inert = /* @__PURE__ */ new WeakMap();
            $ba2e53669058e2bf$var$counters["aria-hidden"] = /* @__PURE__ */ new WeakMap();
            $ba2e53669058e2bf$var$counters.none = /* @__PURE__ */ new WeakMap();
            $ba2e53669058e2bf$var$uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
            $ba2e53669058e2bf$var$markerCounter = /* @__PURE__ */ new WeakMap();
        }
    };
}
function $ba2e53669058e2bf$var$markOthers(avoidElements, ariaHidden = false, inert = false) {
    const body = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(avoidElements[0] ?? null).body;
    return $ba2e53669058e2bf$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live],[role=\"status\"],output"))), body, ariaHidden, inert);
}
//#endregion
//#region src/components/FocusGuard.tsx
const $ba2e53669058e2bf$var$HIDDEN_STYLES = {
    border: "0",
    "clip-path": "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "fixed",
    "white-space": "nowrap",
    width: "1px",
    top: "0",
    left: "0"
};
function $ba2e53669058e2bf$var$FocusGuard(props) {
    const [role, setRole] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        if ((0, $26f76e96d3e6d732$export$e7c866399fa523f5)()) setRole("button");
    });
    return /*#__PURE__*/ React.createElement("span", {
        ...props,
        tabindex: 0,
        role: role(),
        "aria-hidden": role() ? void 0 : "true",
        [(0, $26f76e96d3e6d732$export$8743009a87fcb00f)("focus-guard")]: "",
        style: $ba2e53669058e2bf$var$HIDDEN_STYLES
    });
}
//#endregion
//#region src/components/FloatingPortal.tsx
const $ba2e53669058e2bf$var$HIDDEN_OWNER_STYLES = {
    "clip-path": "inset(50%)",
    position: "fixed",
    top: "0",
    left: "0"
};
function $ba2e53669058e2bf$var$createFocusGuards() {
    const [beforeInside, setBeforeInside] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const [afterInside, setAfterInside] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const [beforeOutside, setBeforeOutside] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const [afterOutside, setAfterOutside] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    return {
        beforeInside: beforeInside,
        afterInside: afterInside,
        beforeOutside: beforeOutside,
        afterOutside: afterOutside,
        setBeforeInside (element) {
            setBeforeInside(element);
        },
        setAfterInside (element) {
            setAfterInside(element);
        },
        setBeforeOutside (element) {
            setBeforeOutside(element);
        },
        setAfterOutside (element) {
            setAfterOutside(element);
        }
    };
}
const $ba2e53669058e2bf$var$PortalContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)(null);
const $ba2e53669058e2bf$var$attr = (0, $26f76e96d3e6d732$export$8743009a87fcb00f)("portal");
/**
* A portal root may be given directly or through an accessor, which defers the
* lookup until the node exists.
*/ function $ba2e53669058e2bf$var$resolveRoot(root) {
    if (root == null) return null;
    return typeof root === "function" ? root() : root;
}
function $ba2e53669058e2bf$export$ac107512f3c5cca6(props = {}) {
    const uniqueId = (0, $1f5a16020b51a07b$export$33208d63bc845a83)();
    const portalContext = $ba2e53669058e2bf$var$usePortalContext();
    const [portalNode, setPortalNode] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    let created = null;
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        portalNode()?.remove();
        created = null;
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (created) return;
        const id = props.id;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($ba2e53669058e2bf$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        created = subRoot;
        setPortalNode(subRoot);
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const root = props.root;
        if (root === null) return;
        if (created) return;
        const id = props.id;
        let container = $ba2e53669058e2bf$var$resolveRoot(root) ?? portalContext?.portalNode ?? document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($ba2e53669058e2bf$var$attr, "");
        container = idWrapper ?? container;
        container.appendChild(subRoot);
        created = subRoot;
        setPortalNode(subRoot);
    });
    return portalNode;
}
/**
* Portals the floating element into a given container element, by default
* outside of the app root and into the body. This ensures the floating element
* can appear outside any parent container that causes clipping (such as
* `overflow: hidden`) while retaining its location in the component tree.
*/ function $ba2e53669058e2bf$export$31fa5d718fa2ac09(props) {
    const preserveTabOrder = ()=>props.preserveTabOrder ?? true;
    const portalNode = $ba2e53669058e2bf$export$ac107512f3c5cca6({
        get id () {
            return props.id;
        },
        get root () {
            return props.root;
        }
    });
    const [focusManagerState, setFocusManagerState] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const guards = $ba2e53669058e2bf$var$createFocusGuards();
    const shouldRenderGuards = ()=>{
        const state = focusManagerState();
        return !!state && !state.modal && state.open && preserveTabOrder() && (props.root != null || portalNode() != null);
    };
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        const node = portalNode();
        if (!node || !preserveTabOrder() || focusManagerState()?.modal) return;
        function onFocus(event) {
            if (node && (0, $26f76e96d3e6d732$export$ae1af26003f05816)(event)) (event.type === "focusin" ? (0, $26f76e96d3e6d732$export$7ccc53e8f1e7dfc5) : (0, $26f76e96d3e6d732$export$625550452a3fa3ec))(node);
        }
        node.addEventListener("focusin", onFocus, true);
        node.addEventListener("focusout", onFocus, true);
        return ()=>{
            node.removeEventListener("focusin", onFocus, true);
            node.removeEventListener("focusout", onFocus, true);
        };
    });
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        const node = portalNode();
        if (!node) return;
        if (focusManagerState()?.open) return;
        (0, $26f76e96d3e6d732$export$7ccc53e8f1e7dfc5)(node);
    });
    const context = {
        get preserveTabOrder () {
            return preserveTabOrder();
        },
        get portalNode () {
            return portalNode();
        },
        setFocusManagerState: setFocusManagerState,
        guards: guards
    };
    return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$PortalContext.Provider, {
        value: context
    }, /*#__PURE__*/ React.createElement((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
        when: shouldRenderGuards() && portalNode()
    }, (node)=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FocusGuard, {
            "data-type": "outside",
            ref: (element)=>{
                guards.setBeforeOutside(element);
            },
            onFocus: (event)=>{
                if ((0, $26f76e96d3e6d732$export$ae1af26003f05816)(event, node())) guards.beforeInside()?.focus();
                else {
                    const domReference = focusManagerState()?.domReference ?? null;
                    (0, $26f76e96d3e6d732$export$23f2a1d2818174ef)(domReference)?.focus();
                }
            }
        }), /*#__PURE__*/ React.createElement("span", {
            "aria-owns": node().id,
            style: $ba2e53669058e2bf$var$HIDDEN_OWNER_STYLES
        }))), /*#__PURE__*/ React.createElement((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
        when: portalNode()
    }, (node)=>/*#__PURE__*/ React.createElement((0, $fb40d00dea10da1a$export$602eac185826482c), {
            mount: node()
        }, props.children)), /*#__PURE__*/ React.createElement((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
        when: shouldRenderGuards() && portalNode()
    }, (node)=>/*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FocusGuard, {
            "data-type": "outside",
            ref: (element)=>{
                guards.setAfterOutside(element);
            },
            onFocus: (event)=>{
                if ((0, $26f76e96d3e6d732$export$ae1af26003f05816)(event, node())) guards.afterInside()?.focus();
                else {
                    const state = focusManagerState();
                    const domReference = state?.domReference ?? null;
                    (0, $26f76e96d3e6d732$export$43caf9889c228507)(domReference)?.focus();
                    if (state?.closeOnFocusOut) state.onOpenChange(false, event, "focus-out");
                }
            }
        })));
}
function $ba2e53669058e2bf$var$usePortalContext() {
    return (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($ba2e53669058e2bf$var$PortalContext);
}
//#endregion
//#region src/components/FloatingFocusManager.tsx
function $ba2e53669058e2bf$var$isFocusableElement(element) {
    return element instanceof HTMLElement || element instanceof SVGElement;
}
const $ba2e53669058e2bf$var$LIST_LIMIT = 20;
let $ba2e53669058e2bf$var$previouslyFocusedElements = [];
function $ba2e53669058e2bf$var$clearDisconnectedPreviouslyFocusedElements() {
    $ba2e53669058e2bf$var$previouslyFocusedElements = $ba2e53669058e2bf$var$previouslyFocusedElements.filter((elementRef)=>elementRef.deref()?.isConnected);
}
function $ba2e53669058e2bf$var$addPreviouslyFocusedElement(element) {
    $ba2e53669058e2bf$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $dd40b91ca1c84530$export$651544f548703224)(element) !== "body") {
        $ba2e53669058e2bf$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($ba2e53669058e2bf$var$previouslyFocusedElements.length > $ba2e53669058e2bf$var$LIST_LIMIT) $ba2e53669058e2bf$var$previouslyFocusedElements = $ba2e53669058e2bf$var$previouslyFocusedElements.slice(-20);
    }
}
function $ba2e53669058e2bf$var$getPreviouslyFocusedElement() {
    $ba2e53669058e2bf$var$clearDisconnectedPreviouslyFocusedElements();
    return $ba2e53669058e2bf$var$previouslyFocusedElements.at(-1)?.deref();
}
function $ba2e53669058e2bf$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $26f76e96d3e6d732$export$407448d2b89b1813)();
    if ((0, $7b28c9bd65463003$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $7b28c9bd65463003$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
function $ba2e53669058e2bf$var$handleTabIndex(floatingFocusElement, order) {
    if (!order.includes("floating") && !floatingFocusElement.getAttribute("role")?.includes("dialog")) return;
    const options = (0, $26f76e96d3e6d732$export$407448d2b89b1813)();
    const tabbableContent = (0, $7b28c9bd65463003$export$ecc6d1fcdff4f700)(floatingFocusElement, options).filter((element)=>{
        const dataTabIndex = element.getAttribute("data-tabindex") ?? "";
        return (0, $7b28c9bd65463003$export$bebd5a1431fec25d)(element, options) || element.hasAttribute("data-tabindex") && !dataTabIndex.startsWith("-");
    });
    const tabIndex = floatingFocusElement.getAttribute("tabindex");
    if (order.includes("floating") || tabbableContent.length === 0) {
        if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
    } else if (tabIndex !== "-1" || floatingFocusElement.hasAttribute("data-tabindex") && floatingFocusElement.getAttribute("data-tabindex") !== "-1") {
        floatingFocusElement.setAttribute("tabindex", "-1");
        floatingFocusElement.setAttribute("data-tabindex", "-1");
    }
}
function $ba2e53669058e2bf$var$VisuallyHiddenDismiss(props) {
    return /*#__PURE__*/ React.createElement("button", {
        ...props,
        type: "button",
        tabindex: -1,
        style: $ba2e53669058e2bf$var$HIDDEN_STYLES
    });
}
/**
* Provides focus management for the floating element.
*/ function $ba2e53669058e2bf$export$8aeee49171ded61a(props) {
    const context = props.context;
    const disabled = ()=>props.disabled ?? false;
    const order = ()=>props.order ?? [
            "content"
        ];
    const initialFocus = ()=>props.initialFocus ?? 0;
    const returnFocus = ()=>props.returnFocus ?? true;
    const restoreFocus = ()=>props.restoreFocus ?? false;
    const modal = ()=>props.modal ?? true;
    const visuallyHiddenDismiss = ()=>props.visuallyHiddenDismiss ?? false;
    const closeOnFocusOut = ()=>props.closeOnFocusOut ?? true;
    const outsideElementsInert = ()=>props.outsideElementsInert ?? false;
    const getInsideElements = ()=>props.getInsideElements?.() ?? [];
    const getNodeId = ()=>context.data.floatingContext?.nodeId;
    const ignoreInitialFocus = ()=>{
        const value = initialFocus();
        return typeof value === "number" && value < 0;
    };
    const isUntrappedTypeableCombobox = ()=>(0, $26f76e96d3e6d732$export$4a5767248b18ef41)(context.elements.domReference) && ignoreInitialFocus();
    const inertSupported = $ba2e53669058e2bf$var$supportsInert();
    const guards = ()=>inertSupported ? props.guards ?? true : true;
    const useInert = ()=>!guards() || inertSupported && outsideElementsInert();
    const tree = $ba2e53669058e2bf$export$db0c2a7c7a2a4f69();
    const portalContext = $ba2e53669058e2bf$var$usePortalContext();
    let startDismissButton = null;
    let endDismissButton = null;
    let beforeGuard = null;
    let afterGuard = null;
    let preventReturnFocus = false;
    let isPointerDown = false;
    let tabbableIndex = -1;
    let blurTimeoutId = -1;
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = ()=>(0, $26f76e96d3e6d732$export$dda1d9f60106f0e9)(context.elements.floating);
    function getTabbableContent(container = floatingFocusElement()) {
        return container ? (0, $7b28c9bd65463003$export$17100aea90429aa7)(container, (0, $26f76e96d3e6d732$export$407448d2b89b1813)()) : [];
    }
    function getTabbableElements(container) {
        const content = getTabbableContent(container);
        const focusElement = floatingFocusElement();
        const domReference = context.elements.domReference;
        const elements = [];
        for (const type of order())if (type === "reference" && $ba2e53669058e2bf$var$isFocusableElement(domReference)) elements.push(domReference);
        else if (type === "floating" && focusElement) elements.push(focusElement);
        else elements.push(...content);
        return elements;
    }
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (disabled()) return;
        if (!modal()) return;
        const focusElement = floatingFocusElement();
        const domReference = context.elements.domReference;
        function onKeyDown(event) {
            if (event.key !== "Tab") return;
            if ((0, $26f76e96d3e6d732$export$ffb5f4729a158638)(focusElement, (0, $26f76e96d3e6d732$export$2d1720544b23b823)((0, $26f76e96d3e6d732$export$953cecd6e717a553)(focusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox()) (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
            const els = getTabbableElements();
            const target = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
            const currentOrder = order();
            if (currentOrder[0] === "reference" && target === domReference) {
                (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                if (event.shiftKey) (0, $26f76e96d3e6d732$export$4368d992c4eafac0)(els[els.length - 1]);
                else (0, $26f76e96d3e6d732$export$4368d992c4eafac0)(els[1]);
            }
            if (currentOrder[1] === "floating" && target === focusElement && event.shiftKey) {
                (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                (0, $26f76e96d3e6d732$export$4368d992c4eafac0)(els[0]);
            }
        }
        const doc = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(focusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (disabled()) return;
        const floating = context.elements.floating;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
            const nextIndex = getTabbableContent().findIndex((element)=>element === target);
            if (nextIndex !== -1) tabbableIndex = nextIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (disabled()) return;
        if (!closeOnFocusOut()) return;
        const floating = context.elements.floating;
        const domReference = context.elements.domReference;
        function handlePointerDown() {
            isPointerDown = true;
            setTimeout(()=>{
                isPointerDown = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget instanceof Element ? event.relatedTarget : null;
            const currentTarget = event.currentTarget;
            const eventTarget = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
            const target = eventTarget instanceof Element ? eventTarget : null;
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const focusElement = floatingFocusElement();
                const movedToUnrelatedNode = !((0, $26f76e96d3e6d732$export$ffb5f4729a158638)(domReference, relatedTarget) || (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(floating, relatedTarget) || (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(relatedTarget, floating) || (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(portalContext?.portalNode, relatedTarget) || relatedTarget?.hasAttribute((0, $26f76e96d3e6d732$export$8743009a87fcb00f)("focus-guard")) === true || tree !== null && ((0, $26f76e96d3e6d732$export$882b5998b3b9117c)(tree.nodes(), nodeId).some((node)=>(0, $26f76e96d3e6d732$export$ffb5f4729a158638)(node.context?.elements.floating, relatedTarget) || (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(node.context?.elements.domReference, relatedTarget)) || (0, $26f76e96d3e6d732$export$db3b6bfb95261072)(tree.nodes(), nodeId).some((node)=>node.context?.elements.floating === relatedTarget || (0, $26f76e96d3e6d732$export$dda1d9f60106f0e9)(node.context?.elements.floating) === relatedTarget || node.context?.elements.domReference === relatedTarget)));
                if (currentTarget === domReference && focusElement) $ba2e53669058e2bf$var$handleTabIndex(focusElement, order());
                if (restoreFocus() && currentTarget !== domReference && !target?.isConnected && (0, $26f76e96d3e6d732$export$2d1720544b23b823)((0, $26f76e96d3e6d732$export$953cecd6e717a553)(focusElement)) === (0, $26f76e96d3e6d732$export$953cecd6e717a553)(focusElement).body) {
                    if ((0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(focusElement)) focusElement.focus();
                    const content = getTabbableContent();
                    const fallback = content.length > 0 ? content[content.length - 1] : focusElement;
                    const nodeToFocus = tabbableIndex >= 0 && tabbableIndex < content.length ? content[tabbableIndex] : fallback;
                    if ((0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                if (context.data.insideTree) {
                    context.data.insideTree = false;
                    return;
                }
                if ((isUntrappedTypeableCombobox() ? true : !modal()) && relatedTarget && movedToUnrelatedNode && !isPointerDown && relatedTarget !== $ba2e53669058e2bf$var$getPreviouslyFocusedElement()) {
                    preventReturnFocus = true;
                    context.onOpenChange(false, event, "focus-out");
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideTree() {
            blurTimeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(blurTimeoutId);
            context.data.insideTree = true;
            blurTimeoutId = window.setTimeout(()=>{
                context.data.insideTree = false;
            });
        }
        if (floating && (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener("focusout", markInsideTree, true);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener("focusout", markInsideTree, true);
            };
        }
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (disabled()) return;
        const floating = context.elements.floating;
        if (!floating) return;
        const domReference = context.elements.domReference;
        const portalNodes = Array.from(portalContext?.portalNode?.querySelectorAll(`[${(0, $26f76e96d3e6d732$export$8743009a87fcb00f)("portal")}]`) ?? []);
        const insideElements = [
            floating,
            (tree ? (0, $26f76e96d3e6d732$export$db3b6bfb95261072)(tree.nodes(), getNodeId()) : []).find((node)=>(0, $26f76e96d3e6d732$export$4a5767248b18ef41)(node.context?.elements.domReference ?? null))?.context?.elements.domReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButton,
            endDismissButton,
            beforeGuard,
            afterGuard,
            portalContext?.guards.beforeOutside(),
            portalContext?.guards.afterOutside(),
            order().includes("reference") || isUntrappedTypeableCombobox() ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal() || isUntrappedTypeableCombobox() ? $ba2e53669058e2bf$var$markOthers(insideElements, !useInert(), useInert()) : $ba2e53669058e2bf$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const focusElement = floatingFocusElement();
        if (disabled() || !(0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(focusElement)) return;
        const open = context.open;
        const doc = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(focusElement);
        const previouslyFocusedElement = (0, $26f76e96d3e6d732$export$2d1720544b23b823)(doc);
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(focusElement);
            const initialFocusValue = initialFocus();
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue()) ?? focusElement;
            const focusAlreadyInsideFloatingEl = (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(focusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus() && !focusAlreadyInsideFloatingEl && open) (0, $26f76e96d3e6d732$export$4368d992c4eafac0)(elToFocus, {
                preventScroll: elToFocus === focusElement
            });
        });
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        const focusElement = floatingFocusElement();
        if (disabled() || !focusElement) return;
        const floating = context.elements.floating;
        const domReference = context.elements.domReference;
        const events = context.events;
        const doc = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(focusElement);
        $ba2e53669058e2bf$var$addPreviouslyFocusedElement((0, $26f76e96d3e6d732$export$2d1720544b23b823)(doc));
        function onOpenChange(payload) {
            const { reason: reason, event: event, nested: nested } = payload;
            if (event && reason && [
                "hover",
                "safe-polygon"
            ].includes(reason) && event.type === "mouseleave") preventReturnFocus = true;
            if (reason !== "outside-press" || !event) return;
            const isVirtual = event instanceof PointerEvent && (0, $26f76e96d3e6d732$export$56c0d5a1e737357d)(event) || event instanceof MouseEvent && (0, $26f76e96d3e6d732$export$a07804094c3ecf2d)(event);
            if (nested) preventReturnFocus = false;
            else if (isVirtual) preventReturnFocus = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement("div").focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                preventReturnFocus = !isPreventScrollSupported;
            }
        }
        events.on("openchange", onOpenChange);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, {
            border: "0",
            clipPath: "inset(50%)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: "0",
            position: "fixed",
            whiteSpace: "nowrap",
            width: "1px",
            top: "0",
            left: "0"
        });
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        function getReturnElement() {
            const value = returnFocus();
            if (typeof value === "boolean") {
                const el = domReference ?? $ba2e53669058e2bf$var$getPreviouslyFocusedElement();
                return el?.isConnected ? el : fallbackEl;
            }
            return value() ?? fallbackEl;
        }
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $26f76e96d3e6d732$export$2d1720544b23b823)(doc);
            const isFocusInsideFloatingTree = (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(floating, activeEl) || tree && (0, $26f76e96d3e6d732$export$882b5998b3b9117c)(tree.nodes(), getNodeId(), false).some((node)=>(0, $26f76e96d3e6d732$export$ffb5f4729a158638)(node.context?.elements.floating, activeEl));
            const returnElement = getReturnElement();
            const shouldReturnFocus = returnFocus();
            queueMicrotask(()=>{
                const tabbableReturnElement = $ba2e53669058e2bf$var$getFirstTabbableElement(returnElement);
                if (shouldReturnFocus && !preventReturnFocus && (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(tabbableReturnElement) && (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    });
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        queueMicrotask(()=>{
            preventReturnFocus = false;
        });
    });
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        queueMicrotask($ba2e53669058e2bf$var$clearDisconnectedPreviouslyFocusedElements);
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (disabled()) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal(),
            closeOnFocusOut: closeOnFocusOut(),
            open: context.open,
            onOpenChange: (open, event, reason)=>{
                context.onOpenChange(open, event, reason);
            },
            domReference: context.elements.domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const focusElement = floatingFocusElement();
        if (disabled()) return;
        if (!focusElement) return;
        $ba2e53669058e2bf$var$handleTabIndex(focusElement, order());
    });
    function renderDismissButton(location) {
        if (disabled() || !visuallyHiddenDismiss() || !modal()) return null;
        const label = visuallyHiddenDismiss();
        return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$VisuallyHiddenDismiss, {
            ref: (element)=>{
                if (location === "start") startDismissButton = element;
                else endDismissButton = element;
            },
            onClick: (event)=>{
                context.onOpenChange(false, event);
            }
        }, typeof label === "string" ? label : "Dismiss");
    }
    const shouldRenderGuards = ()=>!disabled() && guards() && (modal() ? !isUntrappedTypeableCombobox() : true) && (isInsidePortal || modal());
    return /*#__PURE__*/ React.createElement(React.Fragment, null, shouldRenderGuards() && /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FocusGuard, {
        "data-type": "inside",
        ref: (element)=>{
            beforeGuard = element;
            if (portalContext) portalContext.guards.setBeforeInside(element);
        },
        onFocus: (event)=>{
            if (modal()) {
                const els = getTabbableElements();
                (0, $26f76e96d3e6d732$export$4368d992c4eafac0)(order()[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext?.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocus = false;
                if ((0, $26f76e96d3e6d732$export$ae1af26003f05816)(event, portalContext.portalNode)) (0, $26f76e96d3e6d732$export$43caf9889c228507)(context.elements.domReference)?.focus();
                else portalContext.guards.beforeOutside()?.focus();
            }
        }
    }), !isUntrappedTypeableCombobox() && renderDismissButton("start"), props.children, renderDismissButton("end"), shouldRenderGuards() && /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$FocusGuard, {
        "data-type": "inside",
        ref: (element)=>{
            afterGuard = element;
            if (portalContext) portalContext.guards.setAfterInside(element);
        },
        onFocus: (event)=>{
            if (modal()) (0, $26f76e96d3e6d732$export$4368d992c4eafac0)(getTabbableElements()[0]);
            else if (portalContext?.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut()) preventReturnFocus = true;
                if ((0, $26f76e96d3e6d732$export$ae1af26003f05816)(event, portalContext.portalNode)) (0, $26f76e96d3e6d732$export$23f2a1d2818174ef)(context.elements.domReference)?.focus();
                else portalContext.guards.afterOutside()?.focus();
            }
        }
    }));
}
//#endregion
//#region src/components/FloatingOverlay.tsx
let $ba2e53669058e2bf$var$lockCount = 0;
const $ba2e53669058e2bf$var$scrollbarProperty = "--floating-ui-scrollbar-width";
function $ba2e53669058e2bf$var$enableScrollLock() {
    const platform = (0, $26f76e96d3e6d732$export$9bb611d729802a56)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || platform === "MacIntel" && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    const paddingProp = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? Number.parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? Number.parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    bodyStyle.setProperty($ba2e53669058e2bf$var$scrollbarProperty, `${scrollbarWidth}px`);
    if (scrollbarWidth) bodyStyle[paddingProp] = `${scrollbarWidth}px`;
    if (isIOS) {
        const offsetLeft = window.visualViewport?.offsetLeft ?? 0;
        const offsetTop = window.visualViewport?.offsetTop ?? 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: `${-(scrollY - Math.floor(offsetTop))}px`,
            left: `${-(scrollX - Math.floor(offsetLeft))}px`,
            right: "0"
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        bodyStyle.removeProperty($ba2e53669058e2bf$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $ba2e53669058e2bf$var$cleanupScrollLock = ()=>{};
/**
* Provides base styling for a fixed overlay element to dim content or block
* pointer events behind a floating element. It is a regular `<div>`, so it can
* be styled with any CSS solution.
*/ function $ba2e53669058e2bf$export$a35954495955337b(props) {
    const [local, rest] = (0, $1f5a16020b51a07b$export$45029c61b0073d87)(props, [
        "lockScroll",
        "style"
    ]);
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        if (!local.lockScroll) return;
        $ba2e53669058e2bf$var$lockCount++;
        if ($ba2e53669058e2bf$var$lockCount === 1) $ba2e53669058e2bf$var$cleanupScrollLock = $ba2e53669058e2bf$var$enableScrollLock();
        (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
            $ba2e53669058e2bf$var$lockCount--;
            if ($ba2e53669058e2bf$var$lockCount === 0) $ba2e53669058e2bf$var$cleanupScrollLock();
        });
    });
    const style = ()=>({
            position: "fixed",
            overflow: "auto",
            top: "0",
            right: "0",
            bottom: "0",
            left: "0",
            ...typeof local.style === "object" ? local.style : {}
        });
    return /*#__PURE__*/ React.createElement("div", {
        ...rest,
        style: style()
    });
}
//#endregion
//#region src/components/NextFloatingDelayGroup.tsx
const $ba2e53669058e2bf$var$NextFloatingDelayGroupContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)({
    hasProvider: false,
    timeoutMs: 0,
    initialDelay: 0,
    delay: ()=>0,
    setDelay: ()=>{},
    state: {
        timeoutId: -1,
        currentId: null,
        current: null
    }
});
/**
* Experimental next version of `FloatingDelayGroup`, to become the default in
* the future. Provides context for a group of floating elements that should
* share a `delay`.
*/ function $ba2e53669058e2bf$export$e766ee16075bdf6b(props) {
    const [delay, setDelay] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(props.delay);
    const context = {
        hasProvider: true,
        get timeoutMs () {
            return props.timeoutMs ?? 0;
        },
        get initialDelay () {
            return props.delay;
        },
        delay: delay,
        setDelay (value) {
            setDelay(()=>value);
        },
        state: {
            timeoutId: -1,
            currentId: null,
            current: null
        }
    };
    return /*#__PURE__*/ React.createElement($ba2e53669058e2bf$var$NextFloatingDelayGroupContext.Provider, {
        value: context
    }, props.children);
}
/**
* Enables grouping when called inside a component that is a child of a
* `NextFloatingDelayGroup`.
*/ function $ba2e53669058e2bf$export$f86f270cee1e809c(context, options = {}) {
    const enabled = ()=>options.enabled !== false;
    const groupContext = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($ba2e53669058e2bf$var$NextFloatingDelayGroupContext);
    const state = groupContext.state;
    const [isInstantPhase, setIsInstantPhase] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        function unset() {
            setIsInstantPhase(false);
            state.current?.setIsInstantPhase(false);
            state.currentId = null;
            state.current = null;
            groupContext.setDelay(groupContext.initialDelay);
        }
        if (!enabled()) return;
        if (!state.currentId) return;
        if (!context.open && state.currentId === context.floatingId) {
            setIsInstantPhase(false);
            if (groupContext.timeoutMs) {
                state.timeoutId = window.setTimeout(unset, groupContext.timeoutMs);
                return ()=>{
                    state.timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(state.timeoutId);
                };
            }
            unset();
        }
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!enabled()) return;
        if (!context.open) return;
        const prevContext = state.current;
        const prevId = state.currentId;
        state.current = {
            onOpenChange: (open)=>{
                context.onOpenChange(open);
            },
            setIsInstantPhase: (value)=>{
                setIsInstantPhase(value);
            }
        };
        state.currentId = context.floatingId;
        groupContext.setDelay({
            open: 0,
            close: $ba2e53669058e2bf$export$621ec2f31bd1c7ec(groupContext.initialDelay, "close")
        });
        if (prevId !== null && prevId !== context.floatingId) {
            state.timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(state.timeoutId);
            setIsInstantPhase(true);
            prevContext?.setIsInstantPhase(true);
            prevContext?.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext?.setIsInstantPhase(false);
        }
    });
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        state.current = null;
    });
    return {
        hasProvider: groupContext.hasProvider,
        get delay () {
            return groupContext.delay();
        },
        get isInstantPhase () {
            return isInstantPhase();
        }
    };
}
//#endregion
//#region src/hooks/useClick.ts
function $ba2e53669058e2bf$var$isButtonTarget(event) {
    return (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === "BUTTON";
}
function $ba2e53669058e2bf$var$isAnchorTarget(event) {
    return (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === "A";
}
function $ba2e53669058e2bf$var$isSpaceIgnored(element) {
    return (0, $26f76e96d3e6d732$export$8b22cf2602fb60ce)(element);
}
/**
* Opens or closes the floating element when clicking the reference element.
*/ function $ba2e53669058e2bf$export$98524f11226063fc(context, props = {}) {
    const eventOption = ()=>props.event ?? "click";
    const toggle = ()=>props.toggle ?? true;
    const ignoreMouse = ()=>props.ignoreMouse ?? false;
    const keyboardHandlers = ()=>props.keyboardHandlers ?? true;
    const stickIfOpen = ()=>props.stickIfOpen ?? true;
    let pointerType;
    let didKeyDown = false;
    const reference = {
        onPointerDown (event) {
            pointerType = event.pointerType;
        },
        onMouseDown (event) {
            if (event.button !== 0) return;
            if (eventOption() === "click") return;
            if ((0, $26f76e96d3e6d732$export$3a1a48c8f6ef640e)(pointerType, true) && ignoreMouse()) return;
            if (context.open && toggle() && (context.data.openEvent && stickIfOpen() ? context.data.openEvent.type === "mousedown" : true)) context.onOpenChange(false, event, "click");
            else {
                event.preventDefault();
                context.onOpenChange(true, event, "click");
            }
        },
        onClick (event) {
            if (eventOption() === "mousedown" && pointerType) {
                pointerType = void 0;
                return;
            }
            if ((0, $26f76e96d3e6d732$export$3a1a48c8f6ef640e)(pointerType, true) && ignoreMouse()) return;
            if (context.open && toggle() && (context.data.openEvent && stickIfOpen() ? context.data.openEvent.type === "click" : true)) context.onOpenChange(false, event, "click");
            else context.onOpenChange(true, event, "click");
        },
        onKeyDown (event) {
            pointerType = void 0;
            if (event.defaultPrevented || !keyboardHandlers() || $ba2e53669058e2bf$var$isButtonTarget(event)) return;
            if (event.key === " " && !$ba2e53669058e2bf$var$isSpaceIgnored(context.elements.domReference)) {
                event.preventDefault();
                didKeyDown = true;
            }
            if ($ba2e53669058e2bf$var$isAnchorTarget(event)) return;
            if (event.key === "Enter") context.onOpenChange(!(context.open && toggle()), event, "click");
        },
        onKeyUp (event) {
            if (event.defaultPrevented || !keyboardHandlers() || $ba2e53669058e2bf$var$isButtonTarget(event) || $ba2e53669058e2bf$var$isSpaceIgnored(context.elements.domReference)) return;
            if (event.key === " " && didKeyDown) {
                didKeyDown = false;
                context.onOpenChange(!(context.open && toggle()), event, "click");
            }
        }
    };
    return {
        get reference () {
            return props.enabled === false ? void 0 : reference;
        }
    };
}
//#endregion
//#region src/hooks/useClientPoint.ts
function $ba2e53669058e2bf$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement ?? void 0,
        getBoundingClientRect () {
            const domRect = domElement?.getBoundingClientRect() ?? {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(data.contextData.openEvent?.type ?? "") && data.pointerType !== "touch";
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX ?? 0;
            y -= offsetY ?? 0;
            let width = 0;
            let height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                if (isXAxis && data.x != null) x = data.x;
                if (isYAxis && data.y != null) y = data.y;
            } else {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x,
                toJSON: ()=>({})
            };
        }
    };
}
function $ba2e53669058e2bf$var$isMouseBasedEvent(event) {
    return event instanceof MouseEvent;
}
/**
* Positions the floating element relative to a client point (in the viewport),
* such as the mouse position. By default, it follows the mouse cursor.
*/ function $ba2e53669058e2bf$export$7fe170a73a621816(context, props = {}) {
    const enabled = ()=>props.enabled !== false;
    const axis = ()=>props.axis ?? "both";
    const x = ()=>props.x ?? null;
    const y = ()=>props.y ?? null;
    let initial = false;
    let cleanupListener = null;
    const [pointerType, setPointerType] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const [reattach, setReattach] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    function setReference(nextX, nextY) {
        if (initial) return;
        if (context.data.openEvent && !$ba2e53669058e2bf$var$isMouseBasedEvent(context.data.openEvent)) return;
        context.refs.setPositionReference($ba2e53669058e2bf$var$createVirtualElement(context.elements.domReference, {
            x: nextX,
            y: nextY,
            axis: axis(),
            contextData: context.data,
            pointerType: pointerType()
        }));
    }
    function handleReferenceEnterOrMove(event) {
        if (x() != null || y() != null) return;
        if (!context.open) setReference(event.clientX, event.clientY);
        else if (!cleanupListener) setReattach((value)=>value + 1);
    }
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        reattach();
        const floating = context.elements.floating;
        if (!((0, $26f76e96d3e6d732$export$3a1a48c8f6ef640e)(pointerType()) ? floating : context.open) || !enabled() || x() != null || y() != null) return;
        const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const eventTarget = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
            const target = eventTarget instanceof Element ? eventTarget : null;
            if ((0, $26f76e96d3e6d732$export$ffb5f4729a158638)(floating, target)) {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListener = null;
            } else setReference(event.clientX, event.clientY);
        }
        if (!context.data.openEvent || $ba2e53669058e2bf$var$isMouseBasedEvent(context.data.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListener = null;
            };
            cleanupListener = cleanup;
            return cleanup;
        }
        context.refs.setPositionReference(context.elements.domReference);
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (enabled() && !context.elements.floating) initial = false;
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!enabled() && context.open) initial = true;
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (enabled() && (x() != null || y() != null)) {
            initial = false;
            setReference(x(), y());
        }
    });
    function setPointerTypeFromEvent(event) {
        setPointerType(event.pointerType);
    }
    const reference = {
        onPointerDown: setPointerTypeFromEvent,
        onPointerEnter: setPointerTypeFromEvent,
        onMouseMove: handleReferenceEnterOrMove,
        onMouseEnter: handleReferenceEnterOrMove
    };
    return {
        get reference () {
            return enabled() ? reference : void 0;
        }
    };
}
//#endregion
//#region src/hooks/useDismiss.ts
const $ba2e53669058e2bf$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $ba2e53669058e2bf$var$captureHandlerKeys = {
    pointerdown: "oncapture:pointerdown",
    mousedown: "oncapture:mousedown",
    click: "oncapture:click"
};
function $ba2e53669058e2bf$export$8772f90ea49c204(normalizable) {
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : normalizable?.escapeKey ?? false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : normalizable?.outsidePress ?? true
    };
}
/**
* Closes the floating element when a dismissal is requested, by default when
* the user presses the `escape` key or outside of the floating element.
*/ function $ba2e53669058e2bf$export$fcdf1ba5fafc089b(context, props = {}) {
    const enabled = ()=>props.enabled !== false;
    const escapeKey = ()=>props.escapeKey ?? true;
    const outsidePress = ()=>props.outsidePress ?? true;
    const outsidePressEvent = ()=>props.outsidePressEvent ?? "pointerdown";
    const referencePress = ()=>props.referencePress ?? false;
    const referencePressEvent = ()=>props.referencePressEvent ?? "pointerdown";
    const ancestorScroll = ()=>props.ancestorScroll ?? false;
    const bubbles = ()=>$ba2e53669058e2bf$export$8772f90ea49c204(props.bubbles);
    const capture = ()=>$ba2e53669058e2bf$export$8772f90ea49c204(props.capture);
    const tree = $ba2e53669058e2bf$export$db0c2a7c7a2a4f69();
    let endedOrStartedInside = false;
    let isComposing = false;
    function closeOnEscapeKeyDown(event) {
        if (!context.open || !enabled() || !escapeKey() || event.key !== "Escape") return;
        if (isComposing) return;
        const nodeId = context.data.floatingContext?.nodeId;
        const children = tree ? (0, $26f76e96d3e6d732$export$882b5998b3b9117c)(tree.nodes(), nodeId) : [];
        if (!bubbles().escapeKey) {
            event.stopPropagation();
            if (children.length > 0) {
                if (!children.every((child)=>!child.context?.open || child.context.data.escapeKeyBubbles)) return;
            }
        }
        context.onOpenChange(false, event, "escape-key");
    }
    function closeOnEscapeKeyDownCapture(event) {
        const target = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
        const callback = ()=>{
            closeOnEscapeKeyDown(event);
            target?.removeEventListener("keydown", callback);
        };
        target?.addEventListener("keydown", callback);
    }
    function closeOnPressOutside(event) {
        const insideTree = context.data.insideTree;
        context.data.insideTree = false;
        const wasInside = endedOrStartedInside;
        endedOrStartedInside = false;
        if (outsidePressEvent() === "click" && wasInside) return;
        if (insideTree) return;
        const currentOutsidePress = outsidePress();
        if (typeof currentOutsidePress === "function" && !currentOutsidePress(event)) return;
        const floating = context.elements.floating;
        const target = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
        const inertSelector = `[${(0, $26f76e96d3e6d732$export$8743009a87fcb00f)("inert")}]`;
        const markers = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $dd40b91ca1c84530$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(nextParent) || !(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        if (markers.length && (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(target) && !(0, $26f76e96d3e6d732$export$90a7f3efeed30595)(target) && !(0, $26f76e96d3e6d732$export$ffb5f4729a158638)(target, floating) && Array.from(markers).every((marker)=>!(0, $26f76e96d3e6d732$export$ffb5f4729a158638)(targetRootAncestor, marker))) return;
        if ((0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(target) && floating) {
            const lastTraversableNode = (0, $dd40b91ca1c84530$export$d1162fb0b6d4cd51)(target);
            const style = (0, $dd40b91ca1c84530$export$3735103072e4a80)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === "rtl";
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = context.data.floatingContext?.nodeId;
        const targetIsInsideChildren = tree && (0, $26f76e96d3e6d732$export$882b5998b3b9117c)(tree.nodes(), nodeId).some((node)=>(0, $26f76e96d3e6d732$export$71511d61b312f219)(event, node.context?.elements.floating));
        if ((0, $26f76e96d3e6d732$export$71511d61b312f219)(event, floating) || (0, $26f76e96d3e6d732$export$71511d61b312f219)(event, context.elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $26f76e96d3e6d732$export$882b5998b3b9117c)(tree.nodes(), nodeId) : [];
        if (children.length > 0) {
            if (!children.every((child)=>!child.context?.open || child.context.data.outsidePressBubbles)) return;
        }
        context.onOpenChange(false, event, "outside-press");
    }
    function closeOnPressOutsideCapture(event) {
        const pressEvent = outsidePressEvent();
        const target = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
        const callback = ()=>{
            closeOnPressOutside(event);
            target?.removeEventListener(pressEvent, callback);
        };
        target?.addEventListener(pressEvent, callback);
    }
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!context.open || !enabled()) return;
        context.data.escapeKeyBubbles = bubbles().escapeKey;
        context.data.outsidePressBubbles = bubbles().outsidePress;
        let compositionTimeout = -1;
        function onScroll(event) {
            context.onOpenChange(false, event, "ancestor-scroll");
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposing = true;
        }
        function handleCompositionEnd() {
            compositionTimeout = window.setTimeout(()=>{
                isComposing = false;
            }, (0, $dd40b91ca1c84530$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $26f76e96d3e6d732$export$953cecd6e717a553)(context.elements.floating);
        const useEscapeKey = escapeKey();
        const escapeKeyCapture = capture().escapeKey;
        const outsidePressCapture = capture().outsidePress;
        const currentOutsidePress = outsidePress();
        const pressEvent = outsidePressEvent();
        if (useEscapeKey) {
            doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener("compositionstart", handleCompositionStart);
            doc.addEventListener("compositionend", handleCompositionEnd);
        }
        if (currentOutsidePress) doc.addEventListener(pressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll()) {
            if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(context.elements.domReference)) ancestors = (0, $dd40b91ca1c84530$export$3b57c1601291186b)(context.elements.domReference);
            if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(context.elements.floating)) ancestors = ancestors.concat((0, $dd40b91ca1c84530$export$3b57c1601291186b)(context.elements.floating));
            const reference = context.elements.reference;
            if (reference && !(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(reference) && reference.contextElement) ancestors = ancestors.concat((0, $dd40b91ca1c84530$export$3b57c1601291186b)(reference.contextElement));
        }
        ancestors = ancestors.filter((ancestor)=>ancestor !== doc.defaultView?.visualViewport);
        for (const ancestor of ancestors)ancestor.addEventListener("scroll", onScroll);
        return ()=>{
            if (useEscapeKey) {
                doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener("compositionstart", handleCompositionStart);
                doc.removeEventListener("compositionend", handleCompositionEnd);
            }
            if (currentOutsidePress) doc.removeEventListener(pressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            for (const ancestor of ancestors)ancestor.removeEventListener("scroll", onScroll);
            window.clearTimeout(compositionTimeout);
        };
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)((0, $1f5a16020b51a07b$export$af631764ddc44097)([
        outsidePress,
        outsidePressEvent
    ], ()=>{
        context.data.insideTree = false;
    }));
    function referenceProps() {
        const pressEvent = referencePressEvent();
        return {
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress() && {
                [$ba2e53669058e2bf$var$bubbleHandlerKeys[pressEvent]]: (event)=>{
                    context.onOpenChange(false, event, "reference-press");
                },
                ...pressEvent !== "click" && {
                    onClick (event) {
                        context.onOpenChange(false, event, "reference-press");
                    }
                }
            }
        };
    }
    function setMouseDownOrUpInside(event) {
        if (event.button !== 0) return;
        endedOrStartedInside = true;
    }
    function floatingProps() {
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [$ba2e53669058e2bf$var$captureHandlerKeys[outsidePressEvent()]]: ()=>{
                context.data.insideTree = true;
            }
        };
    }
    const reference = $ba2e53669058e2bf$var$lazyProps(referenceProps);
    const floating = $ba2e53669058e2bf$var$lazyProps(floatingProps);
    return {
        get reference () {
            return enabled() ? reference : void 0;
        },
        get floating () {
            return enabled() ? floating : void 0;
        }
    };
}
//#endregion
//#region src/utils/log.ts
const $ba2e53669058e2bf$var$devMessageSet = (0, $1f5a16020b51a07b$export$404582bc18fe4d9e) ? /* @__PURE__ */ new Set() : void 0;
function $ba2e53669058e2bf$var$warn(...messages) {
    const message = `Floating UI: ${messages.join(" ")}`;
    if ($ba2e53669058e2bf$var$devMessageSet && !$ba2e53669058e2bf$var$devMessageSet.has(message)) {
        $ba2e53669058e2bf$var$devMessageSet.add(message);
        console.warn(message);
    }
}
function $ba2e53669058e2bf$var$error(...messages) {
    const message = `Floating UI: ${messages.join(" ")}`;
    if ($ba2e53669058e2bf$var$devMessageSet && !$ba2e53669058e2bf$var$devMessageSet.has(message)) {
        $ba2e53669058e2bf$var$devMessageSet.add(message);
        console.error(message);
    }
}
//#endregion
//#region src/hooks/useFloatingRootContext.ts
/**
* Creates the shared context an external floating element needs when its
* position is managed elsewhere, so interaction hooks can still be attached.
*/ function $ba2e53669058e2bf$export$1df81146f8ad8e4c(options) {
    const floatingId = (0, $1f5a16020b51a07b$export$33208d63bc845a83)();
    const data = {};
    const events = $ba2e53669058e2bf$var$createEventEmitter();
    const nested = $ba2e53669058e2bf$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    function onOpenChange(open, event, reason) {
        (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(()=>{
            data.openEvent = open ? event : void 0;
            events.emit("openchange", {
                open: open,
                event: event,
                reason: reason,
                nested: nested
            });
            options.onOpenChange?.(open, event, reason);
        });
    }
    return {
        data: data,
        get open () {
            return options.open ?? false;
        },
        onOpenChange: onOpenChange,
        elements: {
            get reference () {
                const domReference = options.elements.reference;
                if ((0, $1f5a16020b51a07b$export$404582bc18fe4d9e) && domReference && !(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(domReference)) $ba2e53669058e2bf$var$error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
                return positionReference() ?? domReference ?? null;
            },
            get floating () {
                return options.elements.floating ?? null;
            },
            get domReference () {
                return options.elements.reference ?? null;
            }
        },
        events: events,
        floatingId: floatingId,
        refs: {
            setPositionReference (node) {
                setPositionReference(()=>node);
            }
        }
    };
}
//#endregion
//#region src/utils/dpr.ts
function $ba2e53669058e2bf$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const ratio = (element.ownerDocument.defaultView ?? window).devicePixelRatio;
    return ratio > 0 ? ratio : 1;
}
function $ba2e53669058e2bf$var$roundByDPR(element, value) {
    const dpr = $ba2e53669058e2bf$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
//#endregion
//#region src/hooks/usePosition.ts
/**
* Positions a floating element against a reference element. This is the
* SolidJS counterpart of `useFloating` from `@floating-ui/react-dom`; the
* exported `useFloating` builds the interaction context on top of it.
*/ function $ba2e53669058e2bf$export$8169801eda3f797f(options = {}) {
    const placement = ()=>options.placement ?? "bottom";
    const strategy = ()=>options.strategy ?? "absolute";
    const transform = ()=>options.transform ?? true;
    const [x, setX] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    const [y, setY] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    const [currentPlacement, setCurrentPlacement] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(placement());
    const [currentStrategy, setCurrentStrategy] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(strategy());
    const [middlewareData, setMiddlewareData] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({}, {
        equals: false
    });
    const [isPositioned, setIsPositioned] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    const [internalReference, setInternalReference] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const [internalFloating, setInternalFloating] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const referenceEl = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>options.elements?.reference ?? internalReference());
    const floatingEl = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>options.elements?.floating ?? internalFloating());
    function setReference(node) {
        if (node !== (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(internalReference)) setInternalReference(()=>node);
    }
    function setFloating(node) {
        if (node !== (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(internalFloating)) setInternalFloating(node);
    }
    let disposed = false;
    function currentConfig() {
        const config = {
            placement: placement(),
            strategy: strategy(),
            middleware: options.middleware
        };
        if (options.platform) config.platform = options.platform;
        return config;
    }
    function update(config = currentConfig()) {
        const reference = (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(referenceEl);
        const floating = (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(floatingEl);
        if (!reference || !floating) return;
        const positioned = options.open !== false;
        (0, $5cf54089b7e75f55$export$48a53dcb22e581d0)(reference, floating, config).then((data)=>{
            if (disposed) return;
            (0, $1f5a16020b51a07b$export$712ea50be43a7858)(()=>{
                setX(data.x);
                setY(data.y);
                setCurrentPlacement(data.placement);
                setCurrentStrategy(data.strategy);
                setMiddlewareData(data.middlewareData);
                setIsPositioned(positioned);
            });
        }).catch((reason)=>{
            $ba2e53669058e2bf$var$error("`computePosition` failed:", String(reason));
        });
    }
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (options.open === false && isPositioned()) setIsPositioned(false);
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        disposed = false;
        return ()=>{
            disposed = true;
        };
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        const reference = referenceEl();
        const floating = floatingEl();
        const config = currentConfig();
        if (reference && floating) {
            if (options.whileElementsMounted) return options.whileElementsMounted(reference, floating, ()=>{
                update();
            });
            update(config);
        }
    });
    const floatingStyles = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const initialStyles = {
            position: strategy(),
            left: "0",
            top: "0"
        };
        const floating = floatingEl();
        if (!floating) return initialStyles;
        const roundedX = $ba2e53669058e2bf$var$roundByDPR(floating, x());
        const roundedY = $ba2e53669058e2bf$var$roundByDPR(floating, y());
        if (transform()) return {
            ...initialStyles,
            transform: `translate(${roundedX}px, ${roundedY}px)`
        };
        return {
            position: strategy(),
            left: `${roundedX}px`,
            top: `${roundedY}px`
        };
    });
    return {
        get x () {
            return x();
        },
        get y () {
            return y();
        },
        get placement () {
            return currentPlacement();
        },
        get strategy () {
            return currentStrategy();
        },
        get middlewareData () {
            return middlewareData();
        },
        get isPositioned () {
            return isPositioned();
        },
        get floatingStyles () {
            return floatingStyles();
        },
        update: update,
        refs: {
            setReference: setReference,
            setFloating: setFloating
        },
        elements: {
            get reference () {
                return referenceEl();
            },
            get floating () {
                return floatingEl();
            }
        }
    };
}
//#endregion
//#region src/hooks/useFloating.ts
/**
* Provides data to position a floating element and context to add interactions.
*/ function $ba2e53669058e2bf$export$4e02a5c1d08bac65(options = {}) {
    const internalRootContext = $ba2e53669058e2bf$export$1df81146f8ad8e4c({
        get open () {
            return options.open;
        },
        get onOpenChange () {
            return options.onOpenChange;
        },
        elements: {
            get reference () {
                return options.elements?.reference ?? null;
            },
            get floating () {
                return options.elements?.floating ?? null;
            }
        }
    });
    const rootContext = options.rootContext ?? internalRootContext;
    const [internalDomReference, setInternalDomReference] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const [positionReference, setPositionReferenceSignal] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const domReference = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>rootContext.elements.domReference ?? internalDomReference());
    const tree = $ba2e53669058e2bf$export$db0c2a7c7a2a4f69();
    const position = $ba2e53669058e2bf$export$8169801eda3f797f({
        get placement () {
            return options.placement;
        },
        get strategy () {
            return options.strategy;
        },
        get middleware () {
            return options.middleware;
        },
        get platform () {
            return options.platform;
        },
        get transform () {
            return options.transform;
        },
        get open () {
            return options.open;
        },
        get whileElementsMounted () {
            return options.whileElementsMounted;
        },
        elements: {
            get reference () {
                return positionReference() ?? rootContext.elements.reference;
            },
            get floating () {
                return rootContext.elements.floating;
            }
        }
    });
    function setPositionReference(node) {
        const computedPositionReference = (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        setPositionReferenceSignal(()=>computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }
    function setReference(node) {
        if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(node) || node === null) setInternalDomReference(()=>node);
        const current = position.elements.reference;
        if ((0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(current) || current === null || node !== null && !(0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }
    const refs = {
        setReference: setReference,
        setFloating (node) {
            position.refs.setFloating(node);
        },
        setPositionReference: setPositionReference
    };
    const elements = {
        get reference () {
            return position.elements.reference;
        },
        get floating () {
            return position.elements.floating;
        },
        get domReference () {
            return domReference();
        }
    };
    const context = {
        get x () {
            return position.x;
        },
        get y () {
            return position.y;
        },
        get placement () {
            return position.placement;
        },
        get strategy () {
            return position.strategy;
        },
        get middlewareData () {
            return position.middlewareData;
        },
        get isPositioned () {
            return position.isPositioned;
        },
        get floatingStyles () {
            return position.floatingStyles;
        },
        update () {
            position.update();
        },
        get open () {
            return rootContext.open;
        },
        onOpenChange (open, event, reason) {
            rootContext.onOpenChange(open, event, reason);
        },
        events: rootContext.events,
        data: rootContext.data,
        floatingId: rootContext.floatingId,
        get nodeId () {
            return options.nodeId;
        },
        refs: refs,
        elements: elements
    };
    rootContext.data.floatingContext = context;
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const node = tree?.nodes().find((n)=>n.id === options.nodeId);
        if (node) node.context = context;
    });
    return {
        get x () {
            return position.x;
        },
        get y () {
            return position.y;
        },
        get placement () {
            return position.placement;
        },
        get strategy () {
            return position.strategy;
        },
        get middlewareData () {
            return position.middlewareData;
        },
        get isPositioned () {
            return position.isPositioned;
        },
        get floatingStyles () {
            return position.floatingStyles;
        },
        update () {
            position.update();
        },
        context: context,
        refs: refs,
        elements: elements
    };
}
//#endregion
//#region src/hooks/useFocus.ts
function $ba2e53669058e2bf$var$isMacSafari() {
    return (0, $26f76e96d3e6d732$export$ef35774e6d314e91)() && (0, $26f76e96d3e6d732$export$e7c866399fa523f5)();
}
/**
* Opens the floating element while the reference element has focus, like CSS
* `:focus`.
*/ function $ba2e53669058e2bf$export$f8168d8dd8fd66e6(context, props = {}) {
    const enabled = ()=>props.enabled !== false;
    const visibleOnly = ()=>props.visibleOnly ?? true;
    let blockFocus = false;
    let timeoutId = -1;
    let keyboardModality = true;
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        const domReference = context.elements.domReference;
        const open = context.open;
        const win = (0, $dd40b91ca1c84530$export$38b2d434cce3ea22)(domReference);
        function onBlur() {
            if (!open && (0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(domReference) && domReference === (0, $26f76e96d3e6d732$export$2d1720544b23b823)((0, $26f76e96d3e6d732$export$953cecd6e717a553)(domReference))) blockFocus = true;
        }
        function onKeyDown() {
            keyboardModality = true;
        }
        function onPointerDown() {
            keyboardModality = false;
        }
        win.addEventListener("blur", onBlur);
        if ($ba2e53669058e2bf$var$isMacSafari()) {
            win.addEventListener("keydown", onKeyDown, true);
            win.addEventListener("pointerdown", onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener("blur", onBlur);
            if ($ba2e53669058e2bf$var$isMacSafari()) {
                win.removeEventListener("keydown", onKeyDown, true);
                win.removeEventListener("pointerdown", onPointerDown, true);
            }
        };
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        const events = context.events;
        function onOpenChange({ reason: reason }) {
            if (reason === "reference-press" || reason === "escape-key") blockFocus = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    });
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
    });
    const reference = {
        onMouseLeave () {
            blockFocus = false;
        },
        onFocusIn (event) {
            if (blockFocus) return;
            const target = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
            if (visibleOnly() && (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(target)) {
                if ($ba2e53669058e2bf$var$isMacSafari() && !event.relatedTarget) {
                    if (!keyboardModality && !(0, $26f76e96d3e6d732$export$8b22cf2602fb60ce)(target)) return;
                } else if (!(0, $26f76e96d3e6d732$export$d141bba7fdc215a3)(target)) return;
            }
            context.onOpenChange(true, event, "focus");
        },
        onFocusOut (event) {
            blockFocus = false;
            const relatedTarget = event.relatedTarget;
            const movedToFocusGuard = (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute((0, $26f76e96d3e6d732$export$8743009a87fcb00f)("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
            timeoutId = window.setTimeout(()=>{
                const domReference = context.elements.domReference;
                const activeEl = (0, $26f76e96d3e6d732$export$2d1720544b23b823)(domReference ? domReference.ownerDocument : document);
                if (!relatedTarget && activeEl === domReference) return;
                if ((0, $26f76e96d3e6d732$export$ffb5f4729a158638)(context.data.floatingContext?.elements.floating, activeEl) || (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(domReference, activeEl) || movedToFocusGuard) return;
                context.onOpenChange(false, event, "focus");
            });
        }
    };
    return {
        get reference () {
            return enabled() ? reference : void 0;
        }
    };
}
//#endregion
//#region src/hooks/useInteractions.ts
function $ba2e53669058e2bf$var$isHandler(value) {
    return typeof value === "function";
}
function $ba2e53669058e2bf$var$computeMerged(userProps, propsList, elementKey) {
    const map = /* @__PURE__ */ new Map();
    const isItem = elementKey === "item";
    const acc = {};
    if (elementKey === "floating") {
        acc.tabindex = -1;
        acc[0, $26f76e96d3e6d732$export$9e5f44173e64f162] = "";
    }
    if (userProps) for (const [key, value] of Object.entries(userProps)){
        if (isItem && (key === "active" || key === "selected")) continue;
        acc[key] = value;
    }
    const resolved = propsList.map((value)=>{
        const propsOrGetProps = value ? value[elementKey] : null;
        if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
        return propsOrGetProps;
    });
    resolved.push(userProps);
    for (const props of resolved){
        if (!props) continue;
        for (const [key, value] of Object.entries(props)){
            if (isItem && (key === "active" || key === "selected")) continue;
            if (key.startsWith("on")) {
                let handlers = map.get(key);
                if (!handlers) {
                    handlers = [];
                    map.set(key, handlers);
                }
                if ($ba2e53669058e2bf$var$isHandler(value)) {
                    handlers.push(value);
                    acc[key] = (...args)=>map.get(key)?.map((fn)=>fn(...args)).find((val)=>val !== void 0);
                }
            } else acc[key] = value;
        }
    }
    return acc;
}
/**
* The merged props are read lazily so that every getter a hook contributes
* stays reactive when the object is spread onto an element.
*/ function $ba2e53669058e2bf$var$lazyMerge(userProps, propsList, elementKey) {
    return $ba2e53669058e2bf$var$lazyProps(()=>$ba2e53669058e2bf$var$computeMerged(userProps, propsList, elementKey));
}
/**
* Merges an array of interaction hooks' props into prop getters, allowing
* event handler functions to be composed together without overwriting one
* another.
*/ function $ba2e53669058e2bf$export$a519f7794e446ddd(propsList = []) {
    return {
        getReferenceProps: (userProps)=>$ba2e53669058e2bf$var$lazyMerge(userProps, propsList, "reference"),
        getFloatingProps: (userProps)=>$ba2e53669058e2bf$var$lazyMerge(userProps, propsList, "floating"),
        getItemProps: (userProps)=>$ba2e53669058e2bf$var$lazyMerge(userProps, propsList, "item")
    };
}
//#endregion
//#region src/hooks/useListNavigation.ts
const $ba2e53669058e2bf$var$ESCAPE = "Escape";
/**
* The element a delegated handler is attached to.
*/ function $ba2e53669058e2bf$var$currentTargetElement(event) {
    return event.currentTarget instanceof HTMLElement ? event.currentTarget : null;
}
function $ba2e53669058e2bf$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        case "both":
        case void 0:
        default:
            return vertical || horizontal;
    }
}
/**
* The corner to measure a grid move from: the edge closest to the direction of
* travel, preferring top and left, so a move never lands on the same item.
*/ function $ba2e53669058e2bf$var$cornerForKey(key, horizontalEndKey) {
    if (key === "ArrowDown") return "bl";
    return key === horizontalEndKey ? "tr" : "tl";
}
function $ba2e53669058e2bf$var$isMainOrientationKey(key, orientation) {
    return $ba2e53669058e2bf$var$doSwitch(orientation, key === "ArrowUp" || key === "ArrowDown", key === "ArrowLeft" || key === "ArrowRight");
}
function $ba2e53669058e2bf$var$isMainOrientationToEndKey(key, orientation, rtl) {
    return $ba2e53669058e2bf$var$doSwitch(orientation, key === "ArrowDown", rtl ? key === "ArrowLeft" : key === "ArrowRight") || key === "Enter" || key === " " || key === "";
}
function $ba2e53669058e2bf$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    return $ba2e53669058e2bf$var$doSwitch(orientation, rtl ? key === (0, $26f76e96d3e6d732$export$71cec2538cb2c617) : key === (0, $26f76e96d3e6d732$export$2329c99376c9d0a4), key === (0, $26f76e96d3e6d732$export$3a6d5c9ae78a2c08));
}
function $ba2e53669058e2bf$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === (0, $26f76e96d3e6d732$export$2329c99376c9d0a4) : key === (0, $26f76e96d3e6d732$export$71cec2538cb2c617);
    const horizontal = key === (0, $26f76e96d3e6d732$export$3466f893ebf79586);
    if (orientation === "both" || orientation === "horizontal" && cols && cols > 1) return key === $ba2e53669058e2bf$var$ESCAPE;
    return $ba2e53669058e2bf$var$doSwitch(orientation, vertical, horizontal);
}
/**
* Adds arrow key-based navigation of a list of items, either using real DOM
* focus or virtual focus.
*/ function $ba2e53669058e2bf$export$b5d22cac4ad33f40(context, props) {
    const enabled = ()=>props.enabled !== false;
    const selectedIndex = ()=>props.selectedIndex ?? null;
    const allowEscape = ()=>props.allowEscape ?? false;
    const loop = ()=>props.loop ?? false;
    const nested = ()=>props.nested ?? false;
    const rtl = ()=>props.rtl ?? false;
    const virtual = ()=>props.virtual ?? false;
    const focusItemOnOpen = ()=>props.focusItemOnOpen ?? "auto";
    const focusItemOnHover = ()=>props.focusItemOnHover ?? true;
    const openOnArrowKeyDown = ()=>props.openOnArrowKeyDown ?? true;
    const orientation = ()=>props.orientation ?? "vertical";
    const cols = ()=>props.cols ?? 1;
    const scrollItemIntoView = ()=>props.scrollItemIntoView ?? true;
    const dense = ()=>props.dense ?? false;
    if (0, $1f5a16020b51a07b$export$404582bc18fe4d9e) {
        if (allowEscape()) {
            if (!loop()) $ba2e53669058e2bf$var$warn("`useListNavigation` looping must be enabled to allow escaping.");
            if (!virtual()) $ba2e53669058e2bf$var$warn("`useListNavigation` must be virtual to allow escaping.");
        }
        if (orientation() === "vertical" && cols() > 1) $ba2e53669058e2bf$var$warn("In grid list navigation mode (`cols` > 1), the `orientation` should", "be either \"horizontal\" or \"both\".");
    }
    const floatingFocusElement = ()=>(0, $26f76e96d3e6d732$export$dda1d9f60106f0e9)(context.elements.floating);
    const parentId = $ba2e53669058e2bf$export$165209eae06d3488();
    const tree = $ba2e53669058e2bf$export$db0c2a7c7a2a4f69();
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        context.data.orientation = orientation();
    });
    const typeableComboboxReference = ()=>(0, $26f76e96d3e6d732$export$4a5767248b18ef41)(context.elements.domReference);
    let currentFocusItemOnOpen = focusItemOnOpen();
    let index = selectedIndex() ?? -1;
    let key = null;
    let isPointerModality = true;
    let previousMounted = !!context.elements.floating;
    let previousOpen = context.open;
    let forceSyncFocus = false;
    let forceScrollIntoView = false;
    const [activeId, setActiveId] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const [virtualId, setVirtualId] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    function onNavigate() {
        props.onNavigate?.(index === -1 ? null : index);
    }
    let previousOnNavigate = onNavigate;
    function focusItem() {
        const items = props.items;
        function runFocus(item) {
            if (virtual()) {
                if (item.id.endsWith("-fui-option")) item.id = `${context.floatingId}-${Math.random().toString(16).slice(2, 10)}`;
                setActiveId(item.id);
                tree?.events.emit("virtualfocus", item);
                props.onVirtualItemChange?.(item);
            } else (0, $26f76e96d3e6d732$export$4368d992c4eafac0)(item, {
                sync: forceSyncFocus,
                preventScroll: true
            });
        }
        const initialItem = items()[index];
        const shouldForceScrollIntoView = forceScrollIntoView;
        if (initialItem) runFocus(initialItem);
        (forceSyncFocus ? (callback)=>{
            callback();
        } : requestAnimationFrame)(()=>{
            const waitedItem = items()[index] ?? initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoView();
            if (scrollIntoViewOptions && (shouldForceScrollIntoView || !isPointerModality)) waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    }
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!enabled()) return;
        const currentSelectedIndex = selectedIndex();
        if (context.open && context.elements.floating) {
            if (currentFocusItemOnOpen && currentSelectedIndex != null) {
                forceScrollIntoView = true;
                index = currentSelectedIndex;
                onNavigate();
            }
        } else if (previousMounted) {
            index = -1;
            previousOnNavigate();
        }
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!enabled()) return;
        if (!context.open) return;
        if (!context.elements.floating) return;
        const activeIndex = props.activeIndex;
        if (activeIndex == null) {
            forceSyncFocus = false;
            if (selectedIndex() != null) return;
            if (previousMounted) {
                index = -1;
                focusItem();
            }
            if ((!previousOpen || !previousMounted) && currentFocusItemOnOpen && (key != null || currentFocusItemOnOpen === true)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (props.items()[0] == null) {
                        if (runs < 2) (runs ? requestAnimationFrame : queueMicrotask)(waitForListPopulated);
                        runs++;
                    } else {
                        index = key == null || $ba2e53669058e2bf$var$isMainOrientationToEndKey(key, orientation(), rtl()) || nested() ? (0, $26f76e96d3e6d732$export$c4ce752e73470fba)(props.items, props.disabledIndices) : (0, $26f76e96d3e6d732$export$96f57966bedc81b4)(props.items, props.disabledIndices);
                        key = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $26f76e96d3e6d732$export$ebd11618f299a286)(props.items, activeIndex)) {
            index = activeIndex;
            focusItem();
            forceScrollIntoView = false;
        }
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!enabled() || context.elements.floating || !tree || virtual() || !previousMounted) return;
        const nodes = tree.nodes();
        const parent = nodes.find((node)=>node.id === parentId)?.context?.elements.floating;
        const activeEl = (0, $26f76e96d3e6d732$export$2d1720544b23b823)((0, $26f76e96d3e6d732$export$953cecd6e717a553)(context.elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModality) parent.focus({
            preventScroll: true
        });
    });
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        if (!tree) return;
        if (!virtual()) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            props.onVirtualItemChange?.(item);
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        previousOnNavigate = onNavigate;
        previousOpen = context.open;
        previousMounted = !!context.elements.floating;
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (!context.open) {
            key = null;
            currentFocusItemOnOpen = focusItemOnOpen();
        }
    });
    function syncCurrentTarget(currentTarget) {
        if (!context.open) return;
        const nextIndex = props.items().indexOf(currentTarget);
        if (nextIndex !== -1 && index !== nextIndex) {
            index = nextIndex;
            onNavigate();
        }
    }
    const item = {
        onFocusIn (event) {
            forceSyncFocus = true;
            syncCurrentTarget($ba2e53669058e2bf$var$currentTargetElement(event));
        },
        onClick (event) {
            $ba2e53669058e2bf$var$currentTargetElement(event)?.focus({
                preventScroll: true
            });
        },
        onMouseMove (event) {
            forceSyncFocus = true;
            forceScrollIntoView = false;
            if (focusItemOnHover()) syncCurrentTarget($ba2e53669058e2bf$var$currentTargetElement(event));
        },
        onPointerLeave (event) {
            if (!isPointerModality || event.pointerType === "touch") return;
            forceSyncFocus = true;
            if (!focusItemOnHover()) return;
            index = -1;
            onNavigate();
            if (!virtual()) floatingFocusElement()?.focus({
                preventScroll: true
            });
        }
    };
    function getParentOrientation() {
        return props.parentOrientation ?? tree?.nodes().find((node)=>node.id === parentId)?.context?.data.orientation;
    }
    function commonOnKeyDown(event) {
        isPointerModality = false;
        forceSyncFocus = true;
        if (event.isComposing) return;
        if (!context.open && event.currentTarget === floatingFocusElement()) return;
        const items = props.items;
        const disabledIndices = props.disabledIndices;
        const currentOrientation = orientation();
        const currentRtl = rtl();
        const currentCols = cols();
        if (nested() && $ba2e53669058e2bf$var$isCrossOrientationCloseKey(event.key, currentOrientation, currentRtl, currentCols)) {
            if (!$ba2e53669058e2bf$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
            context.onOpenChange(false, event, "list-navigation");
            if ((0, $dd40b91ca1c84530$export$1b3bfaa9684536aa)(context.elements.domReference)) {
                if (virtual()) tree?.events.emit("virtualfocus", context.elements.domReference);
                else context.elements.domReference.focus();
            }
            return;
        }
        const currentIndex = index;
        const minIndex = (0, $26f76e96d3e6d732$export$c4ce752e73470fba)(items, disabledIndices);
        const maxIndex = (0, $26f76e96d3e6d732$export$96f57966bedc81b4)(items, disabledIndices);
        if (!typeableComboboxReference()) {
            if (event.key === "Home") {
                (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                index = minIndex;
                onNavigate();
            }
            if (event.key === "End") {
                (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                index = maxIndex;
                onNavigate();
            }
        }
        if (currentCols > 1) {
            const sizes = props.itemSizes ?? Array.from({
                length: items().length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            const cellMap = (0, $26f76e96d3e6d732$export$25ce5a424b770e84)(sizes, currentCols, dense());
            const explicitDisabledIndices = typeof disabledIndices === "function" ? void 0 : disabledIndices;
            const minGridIndex = cellMap.findIndex((cellIndex)=>cellIndex != null && !(0, $26f76e96d3e6d732$export$35e795649ee09318)(items, cellIndex, disabledIndices));
            const maxGridIndex = cellMap.reduce((foundIndex, cellItemIndex, cellIndex)=>cellItemIndex != null && !(0, $26f76e96d3e6d732$export$35e795649ee09318)(items, cellItemIndex, disabledIndices) ? cellIndex : foundIndex, -1);
            const nextIndex = cellMap[(0, $26f76e96d3e6d732$export$a9c23c6ac3fc3eca)(()=>cellMap.map((itemIndex)=>itemIndex == null ? null : items()[itemIndex]), {
                event: event,
                orientation: currentOrientation,
                loop: loop(),
                rtl: currentRtl,
                cols: currentCols,
                disabledIndices: (0, $26f76e96d3e6d732$export$971d5caa766a69d7)([
                    ...explicitDisabledIndices ?? items().map((_, itemIndex)=>(0, $26f76e96d3e6d732$export$35e795649ee09318)(items, itemIndex, disabledIndices) ? itemIndex : void 0),
                    void 0
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $26f76e96d3e6d732$export$efccba1c4a2ef57b)(index > maxIndex ? minIndex : index, sizes, cellMap, currentCols, $ba2e53669058e2bf$var$cornerForKey(event.key, currentRtl ? (0, $26f76e96d3e6d732$export$71cec2538cb2c617) : (0, $26f76e96d3e6d732$export$2329c99376c9d0a4))),
                stopEvent: true
            })];
            if (nextIndex != null) {
                index = nextIndex;
                onNavigate();
            }
            if (currentOrientation === "both") return;
        }
        if ($ba2e53669058e2bf$var$isMainOrientationKey(event.key, currentOrientation)) {
            (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
            const currentTarget = $ba2e53669058e2bf$var$currentTargetElement(event);
            if (context.open && !virtual() && currentTarget !== null && (0, $26f76e96d3e6d732$export$2d1720544b23b823)(currentTarget.ownerDocument) === currentTarget) {
                index = $ba2e53669058e2bf$var$isMainOrientationToEndKey(event.key, currentOrientation, currentRtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($ba2e53669058e2bf$var$isMainOrientationToEndKey(event.key, currentOrientation, currentRtl)) {
                if (loop()) {
                    if (currentIndex < maxIndex) index = (0, $26f76e96d3e6d732$export$e7094788287c5e9b)(items, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                    else if (allowEscape() && currentIndex !== items().length) index = -1;
                    else index = minIndex;
                } else index = Math.min(maxIndex, (0, $26f76e96d3e6d732$export$e7094788287c5e9b)(items, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop()) {
                if (currentIndex > minIndex) index = (0, $26f76e96d3e6d732$export$e7094788287c5e9b)(items, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                else if (allowEscape() && currentIndex !== -1) index = items().length;
                else index = maxIndex;
            } else index = Math.max(minIndex, (0, $26f76e96d3e6d732$export$e7094788287c5e9b)(items, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $26f76e96d3e6d732$export$ebd11618f299a286)(items, index)) index = -1;
            onNavigate();
        }
    }
    function ariaActiveDescendantProp() {
        return virtual() && context.open && props.activeIndex != null ? {
            "aria-activedescendant": virtualId() ?? activeId()
        } : {};
    }
    function floatingProps() {
        const currentOrientation = orientation();
        return {
            "aria-orientation": currentOrientation === "both" ? void 0 : currentOrientation,
            ...typeableComboboxReference() ? {} : ariaActiveDescendantProp(),
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModality = true;
            }
        };
    }
    function checkVirtualMouse(event) {
        if (focusItemOnOpen() === "auto" && (0, $26f76e96d3e6d732$export$a07804094c3ecf2d)(event)) currentFocusItemOnOpen = true;
    }
    function checkVirtualPointer(event) {
        currentFocusItemOnOpen = focusItemOnOpen();
        if (focusItemOnOpen() === "auto" && (0, $26f76e96d3e6d732$export$56c0d5a1e737357d)(event)) currentFocusItemOnOpen = true;
    }
    function referenceProps() {
        return {
            ...ariaActiveDescendantProp(),
            onKeyDown (event) {
                isPointerModality = false;
                const items = props.items;
                const currentOrientation = orientation();
                const currentRtl = rtl();
                const isArrowKey = event.key.startsWith("Arrow");
                const isHomeOrEndKey = [
                    "Home",
                    "End"
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $ba2e53669058e2bf$var$isCrossOrientationOpenKey(event.key, currentOrientation, currentRtl);
                const isCrossCloseKey = $ba2e53669058e2bf$var$isCrossOrientationCloseKey(event.key, currentOrientation, currentRtl, cols());
                const isParentCrossOpenKey = $ba2e53669058e2bf$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), currentRtl);
                const isMainKey = $ba2e53669058e2bf$var$isMainOrientationKey(event.key, currentOrientation);
                const isSelectionKey = event.key === "Enter" || event.key.trim() === "";
                const isNavigationKey = (nested() ? isParentCrossOpenKey : isMainKey) || isSelectionKey;
                if (virtual() && context.open) {
                    const rootNode = tree?.nodes().find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $26f76e96d3e6d732$export$2408f22a0fab9ae5)(tree.nodes(), rootNode.id) : null;
                    if (isMoveKey && deepestNode && props.onVirtualItemChange) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            const isCurrentTarget = deepestNode.context?.elements.domReference === event.currentTarget;
                            let dispatchItem = null;
                            if (isCrossCloseKey && !isCurrentTarget) dispatchItem = deepestNode.context?.elements.domReference;
                            else if (isCrossOpenKey) dispatchItem = items().find((listItem)=>listItem?.id === activeId());
                            if (dispatchItem) {
                                (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(void 0);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                                deepestNode.context.elements.domReference?.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    commonOnKeyDown(event);
                    return;
                }
                if (!context.open && !openOnArrowKeyDown() && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $ba2e53669058e2bf$var$isMainOrientationKey(event.key, getParentOrientation());
                    key = nested() && isParentMainKey ? null : event.key;
                }
                if (nested()) {
                    if (isParentCrossOpenKey) {
                        (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                        if (context.open) {
                            index = (0, $26f76e96d3e6d732$export$c4ce752e73470fba)(items, props.disabledIndices);
                            onNavigate();
                        } else context.onOpenChange(true, event, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    const currentSelectedIndex = selectedIndex();
                    if (currentSelectedIndex != null) index = currentSelectedIndex;
                    (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
                    if (!context.open && openOnArrowKeyDown()) context.onOpenChange(true, event, "list-navigation");
                    else commonOnKeyDown(event);
                    if (context.open) onNavigate();
                }
            },
            onFocusIn () {
                if (context.open && !virtual()) {
                    index = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }
    const reference = $ba2e53669058e2bf$var$lazyProps(referenceProps);
    const floating = $ba2e53669058e2bf$var$lazyProps(floatingProps);
    return {
        get reference () {
            return enabled() ? reference : void 0;
        },
        get floating () {
            return enabled() ? floating : void 0;
        },
        get item () {
            return enabled() ? item : void 0;
        }
    };
}
//#endregion
//#region src/hooks/useRole.ts
/**
* Anything the component-role map does not rewrite is already an ARIA role.
*/ function $ba2e53669058e2bf$var$isAriaRole(role) {
    return role !== "select" && role !== "label" && role !== "combobox";
}
const $ba2e53669058e2bf$var$componentRoleToAriaRoleMap = /* @__PURE__ */ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
* Adds base screen reader props to the reference and floating elements for a
* given floating element `role`.
*/ function $ba2e53669058e2bf$export$f66572793fa256a1(context, props = {}) {
    const role = ()=>props.role ?? "dialog";
    const defaultReferenceId = (0, $1f5a16020b51a07b$export$33208d63bc845a83)();
    const referenceId = ()=>{
        const id = context.elements.domReference?.id;
        return id === void 0 || id === "" ? defaultReferenceId : id;
    };
    const floatingId = ()=>{
        const id = (0, $26f76e96d3e6d732$export$dda1d9f60106f0e9)(context.elements.floating)?.id;
        return id === void 0 || id === "" ? context.floatingId : id;
    };
    const ariaRole = ()=>{
        const current = role();
        const mapped = $ba2e53669058e2bf$var$componentRoleToAriaRoleMap.get(current);
        if (mapped !== void 0) return mapped;
        return $ba2e53669058e2bf$var$isAriaRole(current) ? current : false;
    };
    const isNested = $ba2e53669058e2bf$export$165209eae06d3488() != null;
    function referenceProps() {
        const currentRole = role();
        const currentAriaRole = ariaRole();
        if (currentAriaRole === "tooltip" || currentRole === "label") return {
            [`aria-${currentRole === "label" ? "labelledby" : "describedby"}`]: context.open ? floatingId() : void 0
        };
        return {
            "aria-expanded": context.open ? "true" : "false",
            "aria-haspopup": currentAriaRole === "alertdialog" ? "dialog" : currentAriaRole,
            "aria-controls": context.open ? floatingId() : void 0,
            ...currentAriaRole === "listbox" && {
                role: "combobox"
            },
            ...currentAriaRole === "menu" && {
                id: referenceId()
            },
            ...currentAriaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...currentRole === "select" && {
                "aria-autocomplete": "none"
            },
            ...currentRole === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }
    function floatingProps() {
        const currentRole = role();
        const currentAriaRole = ariaRole();
        const base = {
            id: floatingId(),
            ...currentAriaRole && {
                role: currentAriaRole
            }
        };
        if (currentAriaRole === "tooltip" || currentRole === "label") return base;
        return {
            ...base,
            ...currentAriaRole === "menu" && {
                "aria-labelledby": referenceId()
            }
        };
    }
    function item({ active: active, selected: selected }) {
        const commonProps = {
            role: "option",
            ...active && {
                id: `${floatingId()}-fui-option`
            }
        };
        switch(role()){
            case "select":
            case "combobox":
                return {
                    ...commonProps,
                    "aria-selected": selected
                };
            default:
                return {};
        }
    }
    const enabled = ()=>props.enabled !== false;
    const reference = $ba2e53669058e2bf$var$lazyProps(referenceProps);
    const floating = $ba2e53669058e2bf$var$lazyProps(floatingProps);
    return {
        get reference () {
            return enabled() ? reference : void 0;
        },
        get floating () {
            return enabled() ? floating : void 0;
        },
        get item () {
            return enabled() ? item : void 0;
        }
    };
}
//#endregion
//#region src/hooks/useTransition.ts
function $ba2e53669058e2bf$var$camelCaseToKebabCase(str) {
    return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
}
/**
* The side half of a placement such as `bottom-end`.
*/ function $ba2e53669058e2bf$var$toSide$1(placement) {
    const [side] = placement.split("-");
    return side === "top" || side === "right" || side === "bottom" ? side : "left";
}
function $ba2e53669058e2bf$var$resolveStyles(value, args) {
    return typeof value === "function" ? value(args) : value;
}
function $ba2e53669058e2bf$var$createDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(open));
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (open()) {
            setIsMounted(true);
            return;
        }
        if ((0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(isMounted)) {
            const timeout = setTimeout(()=>{
                setIsMounted(false);
            }, durationMs());
            (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
                clearTimeout(timeout);
            });
        }
    });
    return isMounted;
}
/**
* Provides a status string to apply CSS transitions to a floating element,
* correctly handling placement-aware transitions.
*/ function $ba2e53669058e2bf$export$b2ef21706733f7e5(context, props = {}) {
    const duration = ()=>props.duration ?? 250;
    const closeDuration = ()=>{
        const value = duration();
        return (typeof value === "number" ? value : value.close) ?? 0;
    };
    const [status, setStatus] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)("unmounted");
    const isMounted = $ba2e53669058e2bf$var$createDelayUnmount(()=>context.open, closeDuration);
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (!isMounted() && (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(status) === "close") setStatus("unmounted");
    });
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (!context.elements.floating) return;
        if (context.open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
                cancelAnimationFrame(frame);
            });
            return;
        }
        setStatus("close");
    });
    return {
        get isMounted () {
            return isMounted();
        },
        get status () {
            return status();
        }
    };
}
/**
* Provides styles to apply CSS transitions to a floating element, correctly
* handling placement-aware transitions. Wrapper around `useTransitionStatus`.
*/ function $ba2e53669058e2bf$export$769fba13884bc2f4(context, props = {}) {
    const initialOption = ()=>props.initial ?? {
            opacity: 0
        };
    const duration = ()=>props.duration ?? 250;
    const openDuration = ()=>{
        const value = duration();
        return (typeof value === "number" ? value : value.open) ?? 0;
    };
    const closeDuration = ()=>{
        const value = duration();
        return (typeof value === "number" ? value : value.close) ?? 0;
    };
    const fnArgs = ()=>{
        const placement = context.placement;
        return {
            side: $ba2e53669058e2bf$var$toSide$1(placement),
            placement: placement
        };
    };
    const [styles, setStyles] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({
        ...$ba2e53669058e2bf$var$resolveStyles(props.common, (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(fnArgs)),
        ...$ba2e53669058e2bf$var$resolveStyles((0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(initialOption), (0, $1f5a16020b51a07b$export$363ebc4b78b8f807)(fnArgs))
    });
    const transition = $ba2e53669058e2bf$export$b2ef21706733f7e5(context, {
        get duration () {
            return props.duration;
        }
    });
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        const args = fnArgs();
        const status = transition.status;
        const initialStyles = $ba2e53669058e2bf$var$resolveStyles(initialOption(), args) ?? {};
        const closeStyles = $ba2e53669058e2bf$var$resolveStyles(props.close, args);
        const commonStyles = $ba2e53669058e2bf$var$resolveStyles(props.common, args);
        const openStyles = $ba2e53669058e2bf$var$resolveStyles(props.open, args) ?? Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((current)=>({
                "transition-property": current["transition-property"],
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            "transition-property": Object.keys(openStyles).map($ba2e53669058e2bf$var$camelCaseToKebabCase).join(","),
            "transition-duration": `${openDuration()}ms`,
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const nextStyles = closeStyles ?? initialStyles;
            setStyles({
                "transition-property": Object.keys(nextStyles).map($ba2e53669058e2bf$var$camelCaseToKebabCase).join(","),
                "transition-duration": `${closeDuration()}ms`,
                ...commonStyles,
                ...nextStyles
            });
        }
    });
    return {
        get isMounted () {
            return transition.isMounted;
        },
        get styles () {
            return styles();
        }
    };
}
//#endregion
//#region src/hooks/useTypeahead.ts
/**
* Provides a matching callback that can be used to focus an item as the user
* types, often used in tandem with `useListNavigation()`.
*/ function $ba2e53669058e2bf$export$d8d674d50b73ba93(context, props) {
    const enabled = ()=>props.enabled !== false;
    const resetMs = ()=>props.resetMs ?? 750;
    const ignoreKeys = ()=>props.ignoreKeys ?? [];
    const selectedIndex = ()=>props.selectedIndex ?? null;
    let timeoutId = -1;
    let typedString = "";
    let prevIndex = selectedIndex() ?? props.activeIndex ?? -1;
    let matchIndex = null;
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        if (context.open) {
            timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
            matchIndex = null;
            typedString = "";
        }
    });
    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>{
        const nextIndex = selectedIndex() ?? props.activeIndex ?? -1;
        if (context.open && typedString === "") prevIndex = nextIndex;
    });
    function setTypingChange(value) {
        if (context.data.typing !== value) {
            context.data.typing = value;
            props.onTypingChange?.(value);
        }
    }
    function onKeyDown(event) {
        function getMatchingIndex(list, orderedList, searchString) {
            const findMatch = props.findMatch;
            const str = findMatch ? findMatch(orderedList, searchString) : orderedList.find((text)=>text?.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase()) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = props.labels();
        if (typedString.length > 0 && typedString[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, typedString) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
        }
        if (ignoreKeys().includes(event.key) || event.key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey) return;
        if (context.open && event.key !== " ") {
            (0, $26f76e96d3e6d732$export$d66501df72047452)(event);
            setTypingChange(true);
        }
        if (listContent.every((text)=>text ? text[0]?.toLocaleLowerCase() !== text[1]?.toLocaleLowerCase() : true) && typedString === event.key) {
            typedString = "";
            prevIndex = matchIndex;
        }
        typedString += event.key;
        timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
        timeoutId = window.setTimeout(()=>{
            typedString = "";
            prevIndex = matchIndex;
            setTypingChange(false);
        }, resetMs());
        const startIndex = (prevIndex ?? 0) + 1;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice(startIndex),
            ...listContent.slice(0, startIndex)
        ], typedString);
        if (index !== -1) {
            props.onMatch?.(index);
            matchIndex = index;
        } else if (event.key !== " ") {
            typedString = "";
            setTypingChange(false);
        }
    }
    const reference = {
        onKeyDown: onKeyDown
    };
    const floating = {
        onKeyDown: onKeyDown,
        onKeyUp (event) {
            if (event.key === " ") setTypingChange(false);
        }
    };
    return {
        get reference () {
            return enabled() ? reference : void 0;
        },
        get floating () {
            return enabled() ? floating : void 0;
        }
    };
}
//#endregion
//#region src/inner.ts
function $ba2e53669058e2bf$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
* Positions the floating element such that an inner element inside of it is
* anchored to the reference element.
*/ const $ba2e53669058e2bf$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { items: items, onOverflowChange: onOverflowChange, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollElement: scrollElement, ...detectOverflowOptions } = (0, $f3d5a22901917d2b$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, platform: platform, elements: { floating: floating } } = state;
            const item = items()[index];
            const scrollEl = scrollElement?.() ?? floating;
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (0, $1f5a16020b51a07b$export$404582bc18fe4d9e) {
                if (!state.placement.startsWith("bottom")) $ba2e53669058e2bf$var$warn("`placement` side must be \"bottom\" when using the `inner`", "middleware.");
            }
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $5cf54089b7e75f55$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await platform.detectOverflow($ba2e53669058e2bf$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = (0, $f3d5a22901917d2b$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = (scrollEl.scrollHeight > scrollEl.clientHeight ? (value)=>value : (0, $f3d5a22901917d2b$export$2077e0241d6afd3c))((0, $f3d5a22901917d2b$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $f3d5a22901917d2b$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = `${maxHeight}px`;
            scrollEl.scrollTop = diffY;
            if (onFallbackChange) onFallbackChange(scrollEl.offsetHeight < item.offsetHeight * (0, $f3d5a22901917d2b$export$96ec731ed4dcb222)(minItemsVisible, items().length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold);
            if (onOverflowChange) onOverflowChange(await platform.detectOverflow($ba2e53669058e2bf$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions));
            return {
                y: nextY
            };
        }
    });
/**
* Changes the `inner` middleware's `offset` upon a `wheel` event to expand the
* floating element's height, revealing more list items.
*/ function $ba2e53669058e2bf$export$3d74b0dda7cc82ff(context, props) {
    const enabled = ()=>props.enabled !== false;
    let controlledScrolling = false;
    let prevScrollTop = null;
    $ba2e53669058e2bf$var$createCleanupEffect(()=>{
        if (!enabled()) return;
        const el = props.scrollElement?.() ?? context.elements.floating;
        function onWheel(event) {
            const currentOverflow = props.overflow();
            if (event.ctrlKey || !el || currentOverflow == null) return;
            const dY = event.deltaY;
            const isAtTop = currentOverflow.top >= -0.5;
            const isAtBottom = currentOverflow.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                event.preventDefault();
                props.onChange((d)=>d + Math[method](dY, remainingScroll * sign));
            } else if (/firefox/i.test((0, $26f76e96d3e6d732$export$61196ced6d74a310)())) el.scrollTop += dY;
        }
        if (context.open && el) {
            el.addEventListener("wheel", onWheel);
            requestAnimationFrame(()=>{
                prevScrollTop = el.scrollTop;
            });
            return ()=>{
                prevScrollTop = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    });
    const floating = {
        onKeyDown () {
            controlledScrolling = true;
        },
        onWheel () {
            controlledScrolling = false;
        },
        onPointerMove () {
            controlledScrolling = false;
        },
        onScroll () {
            const el = props.scrollElement?.() ?? context.elements.floating;
            const currentOverflow = props.overflow();
            if (!currentOverflow || !el || !controlledScrolling) return;
            if (prevScrollTop !== null) {
                const scrollDiff = el.scrollTop - prevScrollTop;
                if (currentOverflow.bottom < -0.5 && scrollDiff < -1 || currentOverflow.top < -0.5 && scrollDiff > 1) props.onChange((d)=>d + scrollDiff);
            }
            requestAnimationFrame(()=>{
                prevScrollTop = el.scrollTop;
            });
        }
    };
    return {
        get floating () {
            return enabled() ? floating : void 0;
        }
    };
}
//#endregion
//#region src/safePolygon.ts
function $ba2e53669058e2bf$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] ?? [
            0,
            0
        ];
        const [xj, yj] = polygon[j] ?? [
            0,
            0
        ];
        if (yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi) isInside = !isInside;
    }
    return isInside;
}
function $ba2e53669058e2bf$var$isPointInsideRect(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
* The side half of a placement such as `bottom-end`.
*/ function $ba2e53669058e2bf$var$toSide(placement) {
    const [side] = placement.split("-");
    return side === "top" || side === "right" || side === "bottom" ? side : "left";
}
/**
* The two cursor points the triangle starts from. When the floating element is
* larger than the reference they straddle the cursor; otherwise both sit to
* the side the cursor left from, so the triangle points that way.
*/ function $ba2e53669058e2bf$var$cursorSpread(isFloatingLarger, leaveFromEnd, origin, buffer) {
    if (isFloatingLarger) return [
        origin + buffer / 2,
        origin - buffer / 2
    ];
    const shifted = leaveFromEnd ? origin + buffer * 4 : origin - buffer * 4;
    return [
        shifted,
        shifted
    ];
}
/**
* The floating element's own two corners on the side facing the reference.
* The corner the cursor left from is pulled in by the buffer, and so is the
* opposite one when the floating element is the larger of the two.
*/ function $ba2e53669058e2bf$var$nearEdges(leaveFromEnd, isFloatingLarger, bufferedEdge, plainEdge) {
    const fallback = isFloatingLarger ? bufferedEdge : plainEdge;
    return leaveFromEnd ? [
        bufferedEdge,
        fallback
    ] : [
        fallback,
        bufferedEdge
    ];
}
/**
* Generates a safe polygon area that the user can traverse without closing the
* floating element once leaving the reference element.
*/ function $ba2e53669058e2bf$export$7484214ab62358d2(options = {}) {
    const { buffer: buffer = .5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId = -1;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance === "undefined" ? 0 : performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const speed = Math.sqrt(deltaX * deltaX + deltaY * deltaY) / elapsedTime;
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = ({ x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree })=>function onMouseMove(event) {
            function close() {
                timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
                onClose();
            }
            timeoutId = (0, $26f76e96d3e6d732$export$3b14a55fb2447963)(timeoutId);
            if (!elements.domReference || !elements.floating) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const eventTarget = (0, $26f76e96d3e6d732$export$39b482c5e57630a8)(event);
            const target = eventTarget instanceof Element ? eventTarget : null;
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(elements.floating, target);
            const isOverReferenceEl = (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = $ba2e53669058e2bf$var$toSide(placement);
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $ba2e53669058e2bf$var$isPointInsideRect(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            if (isLeave && (0, $dd40b91ca1c84530$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $26f76e96d3e6d732$export$ffb5f4729a158638)(elements.floating, event.relatedTarget)) return;
            if (tree && (0, $26f76e96d3e6d732$export$882b5998b3b9117c)(tree.nodes(), nodeId).length) return;
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) {
                close();
                return;
            }
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
            }
            function getPolygon() {
                switch(side){
                    case "top":
                        {
                            const [oneX, twoX] = $ba2e53669058e2bf$var$cursorSpread(isFloatingWider, cursorLeaveFromRight, x, buffer);
                            const cursorY = y + buffer + 1;
                            const [leftY, rightY] = $ba2e53669058e2bf$var$nearEdges(cursorLeaveFromRight, isFloatingWider, rect.bottom - buffer, rect.top);
                            return [
                                [
                                    oneX,
                                    cursorY
                                ],
                                [
                                    twoX,
                                    cursorY
                                ],
                                [
                                    rect.left,
                                    leftY
                                ],
                                [
                                    rect.right,
                                    rightY
                                ]
                            ];
                        }
                    case "bottom":
                        {
                            const [oneX, twoX] = $ba2e53669058e2bf$var$cursorSpread(isFloatingWider, cursorLeaveFromRight, x, buffer);
                            const cursorY = y - buffer;
                            const [leftY, rightY] = $ba2e53669058e2bf$var$nearEdges(cursorLeaveFromRight, isFloatingWider, rect.top + buffer, rect.bottom);
                            return [
                                [
                                    oneX,
                                    cursorY
                                ],
                                [
                                    twoX,
                                    cursorY
                                ],
                                [
                                    rect.left,
                                    leftY
                                ],
                                [
                                    rect.right,
                                    rightY
                                ]
                            ];
                        }
                    case "left":
                        {
                            const [oneY, twoY] = $ba2e53669058e2bf$var$cursorSpread(isFloatingTaller, cursorLeaveFromBottom, y, buffer);
                            const cursorX = x + buffer + 1;
                            const [topX, bottomX] = $ba2e53669058e2bf$var$nearEdges(cursorLeaveFromBottom, isFloatingTaller, rect.right - buffer, rect.left);
                            return [
                                [
                                    topX,
                                    rect.top
                                ],
                                [
                                    bottomX,
                                    rect.bottom
                                ],
                                [
                                    cursorX,
                                    oneY
                                ],
                                [
                                    cursorX,
                                    twoY
                                ]
                            ];
                        }
                    default:
                        {
                            const [oneY, twoY] = $ba2e53669058e2bf$var$cursorSpread(isFloatingTaller, cursorLeaveFromBottom, y, buffer);
                            const cursorX = x - buffer;
                            const [topX, bottomX] = $ba2e53669058e2bf$var$nearEdges(cursorLeaveFromBottom, isFloatingTaller, rect.left + buffer, rect.right);
                            return [
                                [
                                    cursorX,
                                    oneY
                                ],
                                [
                                    cursorX,
                                    twoY
                                ],
                                [
                                    topX,
                                    rect.top
                                ],
                                [
                                    bottomX,
                                    rect.bottom
                                ]
                            ];
                        }
                }
            }
            if ($ba2e53669058e2bf$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) {
                close();
                return;
            }
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                if (cursorSpeed !== null && cursorSpeed < .1) {
                    close();
                    return;
                }
            }
            if (!$ba2e53669058e2bf$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon())) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    fn.options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}
//#endregion
//#region src/arrow.ts
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element. Wraps the core `arrow` middleware
* to allow a ref as the element.
*/ function $ba2e53669058e2bf$export$f2120bbfa5450bd2(options) {
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (typeof element === "function") {
                const resolved = element();
                if (resolved != null) return (0, $5cf54089b7e75f55$export$f2120bbfa5450bd2)({
                    element: resolved,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $5cf54089b7e75f55$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
}


var $e19c4daa2d9c3184$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<button class=button>`), $e19c4daa2d9c3184$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><button class="button title">`), $e19c4daa2d9c3184$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<dialog aria-role=menu style=right:unset;bottom:unset>`), $e19c4daa2d9c3184$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<button aria-role=menuitem>`), $e19c4daa2d9c3184$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $e19c4daa2d9c3184$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<dialog>`), $e19c4daa2d9c3184$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=dialogs>`), $e19c4daa2d9c3184$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span>`);
const $e19c4daa2d9c3184$export$b93bde5f3bd53abe = ()=>{
    let value = undefined;
    let waiters = [];
    return [
        (request)=>new Promise((resolve)=>{
                if (value !== undefined) resolve(value);
                else {
                    waiters.push(()=>resolve(value));
                    request?.();
                }
            }),
        (newValue)=>{
            value = newValue;
            const w = waiters;
            waiters = [];
            for(let i = 0; i < w.length; ++i)w[i]();
        }
    ];
};
const $e19c4daa2d9c3184$export$245149afd82cd08f = (resourcesCount)=>{
    let takenCount = 0;
    const waiters = [];
    return async ()=>{
        let freed = false;
        const free = ()=>{
            if (freed) return;
            freed = true;
            if (waiters.length > 0) waiters.splice(0, 1)[0]();
            else --takenCount;
        };
        if (takenCount < resourcesCount) ++takenCount;
        else await new Promise((resolve)=>{
            waiters.push(resolve);
        });
        return free;
    };
};
const $e19c4daa2d9c3184$export$353f5b6fc5456de1 = (props)=>(()=>{
        var _el$ = $e19c4daa2d9c3184$var$_tmpl$();
        _el$.$$click = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            props.onClick?.();
        };
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>props.children);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
            var _v$ = !!props.danger, _v$2 = !!props.light, _v$3 = props.type ?? 'button', _v$4 = props.autofocus, _v$5 = props.disabled, _v$6 = props.title;
            _v$ !== _p$.e && _el$.classList.toggle("danger", _p$.e = _v$);
            _v$2 !== _p$.t && _el$.classList.toggle("light", _p$.t = _v$2);
            _v$3 !== _p$.a && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "type", _p$.a = _v$3);
            _v$4 !== _p$.o && (_el$.autofocus = _p$.o = _v$4);
            _v$5 !== _p$.i && (_el$.disabled = _p$.i = _v$5);
            _v$6 !== _p$.n && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "title", _p$.n = _v$6);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined,
            o: undefined,
            i: undefined,
            n: undefined
        });
        return _el$;
    })();
const $e19c4daa2d9c3184$export$931cbfb6bfb85fc = (props)=>{
    const [buttonRef, setButtonRef] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const [menuVisible, setMenuVisible] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    return (()=>{
        var _el$2 = $e19c4daa2d9c3184$var$_tmpl$2(), _el$3 = _el$2.firstChild;
        (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(setButtonRef, _el$2);
        _el$3.$$click = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            setMenuVisible(true);
        };
        (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$3, "aria-haspopup", true);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>props.title, null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($e19c4daa2d9c3184$export$8b29a4b6778bf7f, {
            inline: true,
            solid: true,
            "caret-down": true,
            weak: true
        }), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($e19c4daa2d9c3184$export$8dc6765e8be191c7, {
            get items () {
                return props.items;
            },
            get fallback () {
                return props.fallback;
            },
            baseRef: buttonRef,
            get onSelect () {
                return props.onSelect;
            },
            get menuClassList () {
                return props.menuClassList;
            },
            get alignEnd () {
                return props.alignEnd;
            },
            menuVisible: menuVisible,
            setMenuVisible: setMenuVisible
        }), null);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
            var _v$7 = {
                dropdown: true,
                ...props.classList ?? {}
            }, _v$8 = !!menuVisible(), _v$9 = props.disabled;
            _p$.e = (0, $fb40d00dea10da1a$export$11c615ce16f87241)(_el$2, _v$7, _p$.e);
            _v$8 !== _p$.t && _el$3.classList.toggle("active", _p$.t = _v$8);
            _v$9 !== _p$.a && (_el$3.disabled = _p$.a = _v$9);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined
        });
        return _el$2;
    })();
};
const $e19c4daa2d9c3184$export$8dc6765e8be191c7 = (props)=>{
    const [menuRef, setMenuRef] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const [availableSize, setAvailableSize] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({});
    const position = (0, $ba2e53669058e2bf$export$4e02a5c1d08bac65)({
        placement: props.alignEnd ? 'bottom-end' : 'bottom-start',
        whileElementsMounted: (0, $5cf54089b7e75f55$export$deee3a793edee05f),
        middleware: [
            (0, $5cf54089b7e75f55$export$fba63a578e423eb)(),
            (0, $5cf54089b7e75f55$export$8a83211c878a3f1f)(),
            (0, $5cf54089b7e75f55$export$346677f925de839c)({
                apply: ({ availableWidth: availableWidth, availableHeight: availableHeight, elements: elements })=>{
                    setAvailableSize({
                        width: `${availableWidth}px`,
                        height: `${availableHeight}px`
                    });
                }
            })
        ]
    });
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        position.refs.setReference(props.baseRef() ?? null);
    });
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        position.refs.setFloating(menuRef() ?? null);
    });
    let opened = false;
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (props.menuVisible()) {
            if (!opened) {
                opened = true;
                menuRef()?.showModal();
            }
        } else if (opened) {
            opened = false;
            menuRef()?.close();
        }
    });
    const onSelect = (item, e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (props.onSelect?.(item.key) !== true) props.setMenuVisible(false);
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$602eac185826482c), {
        get children () {
            var _el$4 = $e19c4daa2d9c3184$var$_tmpl$3();
            _el$4.addEventListener("close", ()=>props.setMenuVisible(false));
            _el$4.$$click = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                props.setMenuVisible(false);
            };
            (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(setMenuRef, _el$4);
            (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$4, "aria-modal", true);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                    get each () {
                        return props.items;
                    },
                    get fallback () {
                        return props.fallback;
                    },
                    children: (item)=>(()=>{
                            var _el$5 = $e19c4daa2d9c3184$var$_tmpl$4();
                            _el$5.$$click = onSelect;
                            _el$5.$$clickData = item;
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>item.icon, null);
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (()=>{
                                var _c$ = (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>typeof item.title == 'string');
                                return ()=>_c$() ? (()=>{
                                        var _el$6 = $e19c4daa2d9c3184$var$_tmpl$5();
                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>item.title);
                                        return _el$6;
                                    })() : item.title;
                            })(), null);
                            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$5.classList.toggle("danger", !!item.danger));
                            return _el$5;
                        })()
                }));
            (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                var _v$0 = {
                    dropdown_menu: true,
                    ...props.menuClassList ?? {}
                }, _v$1 = position.strategy, _v$10 = `${position.x ?? 0}px`, _v$11 = `${position.y ?? 0}px`, _v$12 = availableSize()?.width, _v$13 = availableSize()?.height, _v$14 = props.menuVisible() ? 'visible' : 'collapse';
                _p$.e = (0, $fb40d00dea10da1a$export$11c615ce16f87241)(_el$4, _v$0, _p$.e);
                _v$1 !== _p$.t && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$4, "position", _p$.t = _v$1);
                _v$10 !== _p$.a && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$4, "left", _p$.a = _v$10);
                _v$11 !== _p$.o && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$4, "top", _p$.o = _v$11);
                _v$12 !== _p$.i && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$4, "max-width", _p$.i = _v$12);
                _v$13 !== _p$.n && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$4, "max-height", _p$.n = _v$13);
                _v$14 !== _p$.s && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$4, "visibility", _p$.s = _v$14);
                return _p$;
            }, {
                e: undefined,
                t: undefined,
                a: undefined,
                o: undefined,
                i: undefined,
                n: undefined,
                s: undefined
            });
            return _el$4;
        }
    });
};
const [$e19c4daa2d9c3184$var$dialogs, $e19c4daa2d9c3184$var$setDialogs] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)([]);
const $e19c4daa2d9c3184$export$7838a3ea3d544efa = (C, props)=>{
    return new Promise((resolve, reject)=>$e19c4daa2d9c3184$var$setDialogs((dialogs)=>{
            const close = ()=>{
                $e19c4daa2d9c3184$var$setDialogs((dialogs)=>{
                    for(let i = 0; i < dialogs.length; ++i){
                        if (dialogs[i] == self) return dialogs.toSpliced(i, 1);
                    }
                    return dialogs;
                });
            };
            const onResolve = (value)=>{
                close();
                resolve(value);
            };
            const onReject = (reason)=>{
                close();
                reject(reason);
            };
            const Wrapper = (props)=>{
                let ref;
                (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
                    ref.showModal();
                });
                const onKeyDown = (e)=>{
                    if (e.key == 'Enter') {
                        if (props.onDefaultAction) {
                            e.preventDefault();
                            props.onDefaultAction();
                        }
                    }
                };
                return (()=>{
                    var _el$7 = $e19c4daa2d9c3184$var$_tmpl$6();
                    var _ref$ = ref;
                    typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$7) : ref = _el$7;
                    (0, $fb40d00dea10da1a$export$3ae0fd4797ed47c8)(_el$7, (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(props, {
                        "onKeyDown": onKeyDown,
                        "onClose": ()=>onResolve()
                    }), false, false);
                    return _el$7;
                })();
            };
            const self = ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(C, (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)({
                    dialog: Wrapper,
                    resolve: onResolve,
                    reject: onReject
                }, props));
            return [
                ...dialogs,
                self
            ];
        }));
};
const $e19c4daa2d9c3184$export$c55ecd8d9a40564 = ()=>(()=>{
        var _el$8 = $e19c4daa2d9c3184$var$_tmpl$7();
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
            get each () {
                return $e19c4daa2d9c3184$var$dialogs();
            },
            children: (dialog)=>dialog()
        }));
        return _el$8;
    })();
const $e19c4daa2d9c3184$export$8b29a4b6778bf7f = (props)=>(()=>{
        var _el$9 = $e19c4daa2d9c3184$var$_tmpl$8();
        (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$9, "aria-hidden", true);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_$p)=>(0, $fb40d00dea10da1a$export$11c615ce16f87241)(_el$9, {
                icon: true,
                ...Object.fromEntries(Object.keys(props).map((key)=>[
                        {
                            inline: true,
                            weak: true,
                            ok: true,
                            error: true,
                            item_start: true,
                            'fa-2xl': true
                        }[key] ? key : `fa-${key}`,
                        props[key]
                    ]))
            }, _$p));
        return _el$9;
    })();
const $e19c4daa2d9c3184$export$d5503927a7d116d = (props)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
        get when () {
            return props.actions[0];
        },
        keyed: true,
        get fallback () {
            return props.fallback;
        },
        children: (firstAction)=>[
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($e19c4daa2d9c3184$export$353f5b6fc5456de1, {
                    get onClick () {
                        return firstAction.onAction;
                    },
                    get danger () {
                        return firstAction.danger;
                    },
                    get children () {
                        return [
                            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>firstAction.icon),
                            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>firstAction.title)
                        ];
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return props.actions.length > 1;
                    },
                    get children () {
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($e19c4daa2d9c3184$export$931cbfb6bfb85fc, {
                            title: "",
                            get items () {
                                return props.actions.slice(1).map(({ title: title, icon: icon, onAction: onAction, danger: danger })=>({
                                        key: onAction,
                                        title: title,
                                        icon: icon,
                                        danger: danger
                                    }));
                            },
                            onSelect: (onAction)=>onAction(),
                            alignEnd: true
                        });
                    }
                })
            ]
    });
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);


const $77ea5bac57ec8af2$export$a0fd8390cfe8ae69 = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)();
const $77ea5bac57ec8af2$export$87091915187a1a85 = (props)=>{
    const [status, setStatus] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)('processing');
    const [authToken, setAuthToken] = (0, $e19c4daa2d9c3184$export$b93bde5f3bd53abe)();
    const [authRequired, setAuthRequired] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    const api = new (0, $f08ff9bf1882a38d$export$bf71da7aebe9ddc1)({
        BASE: (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).apiUrl,
        TOKEN: async ()=>await authToken(()=>{
                setAuthRequired(true);
            })
    }).default;
    const tokenlessApi = new (0, $f08ff9bf1882a38d$export$bf71da7aebe9ddc1)({
        BASE: (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).apiUrl
    }).default;
    const [session, { refetch: refetchSession }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        try {
            return await tokenlessApi.getAuthSession();
        } catch (e) {
            return null;
        }
    });
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (session.state === 'ready') {
            const sessionResult = session();
            if (sessionResult?.userInfo) {
                setAuthToken(sessionResult.authToken);
                setStatus('authenticated');
            } else setStatus('not_authenticated');
        } else if (session.state === 'errored') setStatus('error');
    });
    const startAuth = async (provider, intent)=>{
        try {
            const { url: url, postParams: postParams, token: token } = await tokenlessApi.postAuthExternalStart({
                provider: provider,
                intent: intent
            });
            localStorage.setItem('external_auth_token', token);
            localStorage.setItem('auth_redirect_url', `${window.location.pathname}${window.location.search}`);
            if (Array.isArray(postParams) && postParams.length > 0) {
                const form = document.createElement('form');
                form.style.display = 'none';
                document.body.appendChild(form);
                form.action = url;
                form.method = 'POST';
                for (const param of postParams){
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = param[0];
                    input.value = param[1];
                    form.appendChild(input);
                }
                form.submit();
            } else window.location.href = url;
        } catch (e) {
            setStatus('error');
        }
    };
    const finishAuth = async (provider)=>{
        // read and clear remembered parameters
        const externalAuthToken = localStorage.getItem('external_auth_token');
        localStorage.removeItem('external_auth_token');
        const authRedirectUrl = localStorage.getItem('auth_redirect_url');
        localStorage.removeItem('auth_redirect_url');
        // get code and state depending on provider
        let code = null;
        let state = null;
        let error;
        switch(provider){
            case 'github':
            case 'gitlab':
            case 'twitch':
            case 'discord':
            case 'google':
                {
                    const params = new URLSearchParams(window.location.search);
                    code = params.get('code');
                    state = params.get('state');
                }
                break;
            case 'steam':
                {
                    const params = new URLSearchParams(window.location.search);
                    code = JSON.stringify(Object.fromEntries(params));
                    state = params.get('state');
                }
                break;
            case 'itch':
                {
                    const params = new URLSearchParams(window.location.hash.slice(1));
                    code = params.get('access_token');
                    state = params.get('state');
                }
                break;
            default:
                error = 'unsupported_provider';
                break;
        }
        // clear parameters from URL
        window.history.replaceState(null, '', window.location.pathname);
        // handle error if needed
        if (error) return {
            intent: 'error',
            nextUrl: authRedirectUrl,
            error: error
        };
        // handle bad params
        if (!code || !state || !externalAuthToken || state !== externalAuthToken) return {
            intent: 'error',
            nextUrl: authRedirectUrl,
            error: 'wrong_finish_auth_params'
        };
        // finish auth
        const credentialInfo = await tokenlessApi.postAuthExternalFinish({
            token: state,
            code: code
        });
        if (credentialInfo.hasUser) {
            if (credentialInfo.authAllowed) {
                await tokenlessApi.postUsersAuth({
                    token: credentialInfo.token
                });
                refetchSession();
                return {
                    intent: 'login',
                    nextUrl: authRedirectUrl
                };
            } else return {
                intent: 'error',
                nextUrl: authRedirectUrl,
                error: 'auth_not_allowed'
            };
        } else switch(credentialInfo.intent){
            case 'register':
                await tokenlessApi.postUsersRegister({
                    token: credentialInfo.token
                });
                refetchSession();
                return {
                    intent: 'register',
                    nextUrl: authRedirectUrl
                };
            case 'link':
                await api.postUsersMeCredentials({
                    token: credentialInfo.token
                });
                refetchSession();
                return {
                    intent: 'link',
                    nextUrl: authRedirectUrl
                };
            default:
                return {
                    intent: 'error',
                    nextUrl: authRedirectUrl,
                    error: 'unknown_intent'
                };
        }
    };
    const cancelAuth = async ()=>{
        await api.postAuthClear();
        window.location.href = '/';
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($77ea5bac57ec8af2$export$a0fd8390cfe8ae69.Provider, {
        get value () {
            return {
                status: status,
                authToken: authToken,
                providers: (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).authProviders,
                startAuth: startAuth,
                finishAuth: finishAuth,
                cancelAuth: cancelAuth,
                api: api,
                tokenlessApi: tokenlessApi,
                session: session,
                refetchSession: refetchSession,
                authRequired: authRequired
            };
        },
        get children () {
            return props.children;
        }
    });
};






const $d542c09ca8fd8013$export$e702be3367c4e877 = (jobsTokens)=>new Promise((resolve, reject)=>{
        const jobs = jobsTokens.map((_jobToken)=>(0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({}));
        let finishedCount = 0;
        const eventSource = new EventSource(`${(0, $1ded0b9f0137d849$export$2e2bcd8739ae039).apiUrl}/jobs?${new URLSearchParams(jobsTokens.map((jobToken)=>[
                'tokens',
                jobToken
            ]))}`);
        eventSource.addEventListener('open', (e)=>{
            resolve(jobs.map((job)=>job[0]));
        });
        eventSource.addEventListener('error', (e)=>{
            reject(e);
        });
        eventSource.addEventListener('job_updated', (e)=>{
            const data = JSON.parse(e.data);
            switch(data.type){
                case 'output':
                    jobs[data.job][1]((job)=>({
                            ...job,
                            output: data.output
                        }));
                    break;
                case 'progress':
                    jobs[data.job][1]((job)=>({
                            ...job,
                            progress: data.progress
                        }));
                    break;
            }
            if (data.type == 'output' && ++finishedCount == jobs.length) eventSource.close();
        });
    });
class $d542c09ca8fd8013$export$ba4b5e9e211cc848 {
    add(jobToken) {
        const signal = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({});
        this.jobs.push({
            signal: signal,
            token: jobToken,
            finished: false
        });
        this.update();
        return signal[0];
    }
    update() {
        if (this.eventSource) this.eventSource.close();
        this.eventSource = new EventSource(`${(0, $1ded0b9f0137d849$export$2e2bcd8739ae039).apiUrl}/jobs?${new URLSearchParams(this.jobs.map((job)=>[
                'tokens',
                job.token
            ]))}`);
        const jobs = this.jobs; // so this version of jobs is captured in closure
        this.eventSource.addEventListener('job_updated', (e)=>{
            const data = JSON.parse(e.data);
            switch(data.type){
                case 'output':
                    jobs[data.job].signal[1]((job)=>({
                            ...job,
                            output: data.output
                        }));
                    break;
                case 'progress':
                    jobs[data.job].signal[1]((job)=>({
                            ...job,
                            progress: data.progress
                        }));
                    break;
            }
            if (data.type == 'output' && !jobs[data.job].finished) {
                jobs[data.job].finished = true;
                if (++this.finishedCount == jobs.length && this.eventSource) {
                    this.eventSource.close();
                    this.eventSource = undefined;
                }
            }
        });
    }
    constructor(){
        this.jobs = [];
        this.finishedCount = 0;
    }
}




const $30026173677b80c4$export$ecd60d42f6b10f45 = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)();
const $30026173677b80c4$export$316129f71809f34b = (props)=>{
    const callLocalApi = async (method, body = {})=>{
        const response = await fetch(`http://127.0.0.1:17303/?${new URLSearchParams({
            method: method
        })}`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'content-type': 'application/json'
            }
        });
        const responseBody = await response.json();
        if (response.ok) return responseBody;
        else throw responseBody;
    };
    const [version, { refetch: refreshConnected }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        try {
            return await callLocalApi('version');
        } catch (e) {}
    });
    const connected = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>version() != null);
    const [workspaces] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(connected, async (connected)=>{
        if (!connected) return [];
        return await callLocalApi('workspace_list');
    });
    const [workdirs, { refetch: refreshWorkdirs }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(connected, async (connected)=>{
        if (!connected) return [];
        return await callLocalApi('workdir_list');
    });
    const [transition, { refetch: refreshTransition }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(connected, async ()=>{
        if (!connected) return null;
        const transition = await callLocalApi('transition_status');
        if (transition) setTimeout(refreshTransition, 1000);
        return transition;
    });
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($30026173677b80c4$export$ecd60d42f6b10f45.Provider, {
        value: {
            callLocalApi: callLocalApi,
            connected: connected,
            refreshConnected: refreshConnected,
            workspaces: workspaces,
            workdirs: workdirs,
            refreshWorkdirs: refreshWorkdirs,
            transition: transition,
            refreshTransition: refreshTransition
        },
        get children () {
            return props.children;
        }
    });
};





var $c39c8727de0f5841$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span dir=auto>`);
const $c39c8727de0f5841$export$51216bcc3983e55d = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)();
const $c39c8727de0f5841$export$dc45bdc734ce6f1e = (props)=>{
    // detect lang initially from local storage, or browser language
    let initialLang = localStorage.getItem('lang') ?? window.navigator.language;
    // hackish try to simplify language if not found in dicts
    if (initialLang && !props.dicts[initialLang]) initialLang = initialLang.substring(0, 2);
    // fallback to en if needed
    if (!initialLang || !props.dicts[initialLang]) initialLang = props.defaultLang;
    // signal for current language
    const [lang, setLang] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(initialLang);
    // dict for current language
    const dict = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>props.dicts[lang()]);
    const getText = (id, dict)=>dict[id] ?? (dict.fallback ? getText(id, props.dicts[dict.fallback]) : null);
    const t = (id)=>getText(id, dict());
    // update current language in local storage
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        localStorage.setItem('lang', lang());
        document.documentElement.lang = lang();
        document.documentElement.dir = t('dir');
    });
    const langCollator = Intl.Collator('und');
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($c39c8727de0f5841$export$51216bcc3983e55d.Provider, {
        get value () {
            return {
                lang: lang,
                setLang: setLang,
                langs: new Map(Object.entries(props.dicts).map(([lang, langInfo])=>[
                        lang,
                        langInfo.languageName
                    ]).toSorted(([_lang1, langName1], [_lang2, langName2])=>langCollator.compare(langName1, langName2))),
                dicts: props.dicts,
                t: t
            };
        },
        get children () {
            return props.children;
        }
    });
};
const $c39c8727de0f5841$export$41d20194bebed95c = ()=>{
    const { lang: currentLang, langs: langs, setLang: setLang } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($c39c8727de0f5841$export$51216bcc3983e55d);
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
        get title () {
            return [
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                    solid: true,
                    globe: true,
                    weak: true,
                    inline: true
                }),
                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>currentLang().toUpperCase())
            ];
        },
        get items () {
            return Array.from(langs.entries()).map(([lang, langName])=>({
                    key: lang,
                    title: (()=>{
                        var _el$ = $c39c8727de0f5841$var$_tmpl$();
                        (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "lang", lang);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, langName);
                        return _el$;
                    })(),
                    icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        regular: true,
                        get ["circle-dot"] () {
                            return lang == currentLang();
                        },
                        get circle () {
                            return lang != currentLang();
                        },
                        inline: true
                    })
                }));
        },
        onSelect: setLang
    });
};




var $9DGpR = parcelRequire("9DGpR");

// This module is generated by `script/`.
/* eslint-disable no-control-regex, no-misleading-character-class, no-useless-escape */ const $1c6af9668b6bfd8b$export$17b0f4d84dbfeedf = /[\0-\x1F!-,\.\/:-@\[-\^`\{-\xA9\xAB-\xB4\xB6-\xB9\xBB-\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482\u0530\u0557\u0558\u055A-\u055F\u0589-\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05EB-\u05EE\u05F3-\u060F\u061B-\u061F\u066A-\u066D\u06D4\u06DD\u06DE\u06E9\u06FD\u06FE\u0700-\u070F\u074B\u074C\u07B2-\u07BF\u07F6-\u07F9\u07FB\u07FC\u07FE\u07FF\u082E-\u083F\u085C-\u085F\u086B-\u089F\u08B5\u08C8-\u08D2\u08E2\u0964\u0965\u0970\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09F2-\u09FB\u09FD\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF0-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B70\u0B72-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BF0-\u0BFF\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C7F\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D4F-\u0D53\u0D58-\u0D5E\u0D64\u0D65\u0D70-\u0D79\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF4-\u0E00\u0E3B-\u0E3F\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F17\u0F1A-\u0F1F\u0F2A-\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F48\u0F6D-\u0F70\u0F85\u0F98\u0FBD-\u0FC5\u0FC7-\u0FFF\u104A-\u104F\u109E\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u1360-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u170D\u1715-\u171F\u1735-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17D4-\u17D6\u17D8-\u17DB\u17DE\u17DF\u17EA-\u180A\u180E\u180F\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DA-\u19FF\u1A1C-\u1A1F\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1AAF\u1AC1-\u1AFF\u1B4C-\u1B4F\u1B5A-\u1B6A\u1B74-\u1B7F\u1BF4-\u1BFF\u1C38-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CCF\u1CD3\u1CFB-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u203E\u2041-\u2053\u2055-\u2070\u2072-\u207E\u2080-\u208F\u209D-\u20CF\u20F1-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F-\u215F\u2189-\u24B5\u24EA-\u2BFF\u2C2F\u2C5F\u2CE5-\u2CEA\u2CF4-\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E00-\u2E2E\u2E30-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u3040\u3097\u3098\u309B\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u319F\u31C0-\u31EF\u3200-\u33FF\u4DC0-\u4DFF\u9FFD-\u9FFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA673\uA67E\uA6F2-\uA716\uA720\uA721\uA789\uA78A\uA7C0\uA7C1\uA7CB-\uA7F4\uA828-\uA82B\uA82D-\uA83F\uA874-\uA87F\uA8C6-\uA8CF\uA8DA-\uA8DF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA954-\uA95F\uA97D-\uA97F\uA9C1-\uA9CE\uA9DA-\uA9DF\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAAC3-\uAADA\uAADE\uAADF\uAAF0\uAAF1\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABEB\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFDFF\uFE10-\uFE1F\uFE30-\uFE32\uFE35-\uFE4C\uFE50-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF3E\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD3F\uDD75-\uDDFC\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEE1-\uDEFF\uDF20-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56-\uDC5F\uDC77-\uDC7F\uDC9F-\uDCDF\uDCF3\uDCF6-\uDCFF\uDD16-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBD\uDDC0-\uDDFF\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE40-\uDE5F\uDE7D-\uDE7F\uDE9D-\uDEBF\uDEC8\uDEE7-\uDEFF\uDF36-\uDF3F\uDF56-\uDF5F\uDF73-\uDF7F\uDF92-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCFF\uDD28-\uDD2F\uDD3A-\uDE7F\uDEAA\uDEAD-\uDEAF\uDEB2-\uDEFF\uDF1D-\uDF26\uDF28-\uDF2F\uDF51-\uDFAF\uDFC5-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC47-\uDC65\uDC70-\uDC7E\uDCBB-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD40-\uDD43\uDD48-\uDD4F\uDD74\uDD75\uDD77-\uDD7F\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDFF\uDE12\uDE38-\uDE3D\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC4B-\uDC4F\uDC5A-\uDC5D\uDC62-\uDC7F\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDC1-\uDDD7\uDDDE-\uDDFF\uDE41-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF3A-\uDFFF]|\uD806[\uDC3B-\uDC9F\uDCEA-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD44-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE2\uDDE5-\uDDFF\uDE3F-\uDE46\uDE48-\uDE4F\uDE9A-\uDE9C\uDE9E-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC41-\uDC4F\uDC5A-\uDC71\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF7-\uDFAF\uDFB1-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD824-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83D\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDECF\uDEEE\uDEEF\uDEF5-\uDEFF\uDF37-\uDF3F\uDF44-\uDF4F\uDF5A-\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE80-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE2\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82C[\uDD1F-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDC9C\uDC9F-\uDFFF]|\uD834[\uDC00-\uDD64\uDD6A-\uDD6C\uDD73-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDE41\uDE45-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDEBF\uDEFA-\uDFFF]|\uD83A[\uDCC5-\uDCCF\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDD2F\uDD4A-\uDD4F\uDD6A-\uDD6F\uDD8A-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEDE-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]/g;


const $d6b3baa16b2246dc$var$own = Object.hasOwnProperty;
class $d6b3baa16b2246dc$export$2e2bcd8739ae039 {
    /**
   * Create a new slug class.
   */ constructor(){
        /** @type {Record<string, number>} */ // eslint-disable-next-line no-unused-expressions
        this.occurrences;
        this.reset();
    }
    /**
   * Generate a unique slug.
  *
  * Tracks previously generated slugs: repeated calls with the same value
  * will result in different slugs.
  * Use the `slug` function to get same slugs.
   *
   * @param  {string} value
   *   String of text to slugify
   * @param  {boolean} [maintainCase=false]
   *   Keep the current case, otherwise make all lowercase
   * @return {string}
   *   A unique slug string
   */ slug(value, maintainCase) {
        const self = this;
        let result = $d6b3baa16b2246dc$export$74643d1fe038be1a(value, maintainCase === true);
        const originalSlug = result;
        while($d6b3baa16b2246dc$var$own.call(self.occurrences, result)){
            self.occurrences[originalSlug]++;
            result = originalSlug + '-' + self.occurrences[originalSlug];
        }
        self.occurrences[result] = 0;
        return result;
    }
    /**
   * Reset - Forget all previous slugs
   *
   * @return void
   */ reset() {
        this.occurrences = Object.create(null);
    }
}
function $d6b3baa16b2246dc$export$74643d1fe038be1a(value, maintainCase) {
    if (typeof value !== 'string') return '';
    if (!maintainCase) value = value.toLowerCase();
    return value.replace((0, $1c6af9668b6bfd8b$export$17b0f4d84dbfeedf), '').replace(/ /g, '-');
}


/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $bc9bb30833cd7339$var$emptyOptions = {};
function $bc9bb30833cd7339$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $bc9bb30833cd7339$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $bc9bb30833cd7339$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $bc9bb30833cd7339$var$one(value, includeImageAlt, includeHtml) {
    if ($bc9bb30833cd7339$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $bc9bb30833cd7339$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $bc9bb30833cd7339$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $bc9bb30833cd7339$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $bc9bb30833cd7339$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $bc9bb30833cd7339$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* global document */ const $fc957543935d2fbb$var$element = document.createElement('i');
function $fc957543935d2fbb$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $fc957543935d2fbb$var$element.innerHTML = characterReference;
    const character = $fc957543935d2fbb$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $e3feb7cc014b834a$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $e3feb7cc014b834a$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $e3feb7cc014b834a$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $52b483885337c95b$var$hasOwnProperty = {}.hasOwnProperty;
function $52b483885337c95b$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$52b483885337c95b$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $52b483885337c95b$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $52b483885337c95b$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$52b483885337c95b$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $52b483885337c95b$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $52b483885337c95b$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $e3feb7cc014b834a$export$869882364835d202)(existing, 0, 0, before);
}
function $52b483885337c95b$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$52b483885337c95b$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $52b483885337c95b$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $52b483885337c95b$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $a0fd163adf8dda52$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $e522570f90f30bf2$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $e522570f90f30bf2$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $e522570f90f30bf2$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $b372f6f49f82b482$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $d11f122b7c6f306c$export$d65d6b62c24d5436 = $d11f122b7c6f306c$var$regexCheck(/[A-Za-z]/);
const $d11f122b7c6f306c$export$75c76db11865a9f4 = $d11f122b7c6f306c$var$regexCheck(/[\dA-Za-z]/);
const $d11f122b7c6f306c$export$4397998b34fe597d = $d11f122b7c6f306c$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $d11f122b7c6f306c$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $d11f122b7c6f306c$export$ca8b5b1a6c320e6e = $d11f122b7c6f306c$var$regexCheck(/\d/);
const $d11f122b7c6f306c$export$eca2752363989806 = $d11f122b7c6f306c$var$regexCheck(/[\dA-Fa-f]/);
const $d11f122b7c6f306c$export$35794a7d1db99380 = $d11f122b7c6f306c$var$regexCheck(/[!-/:-@[-`{-~]/);
function $d11f122b7c6f306c$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $d11f122b7c6f306c$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $d11f122b7c6f306c$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $d11f122b7c6f306c$export$aa04114dd888a7a0 = $d11f122b7c6f306c$var$regexCheck(/\p{P}|\p{S}/u);
const $d11f122b7c6f306c$export$a0ff789c034ffdf4 = $d11f122b7c6f306c$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $d11f122b7c6f306c$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $754f1136e796451a$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $e522570f90f30bf2$export$c564cdbbe6da493)($754f1136e796451a$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $754f1136e796451a$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $92e34c948cdfd9ae$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $92e34c948cdfd9ae$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $92e34c948cdfd9ae$var$protocolSource = /^https?$/i;
function $92e34c948cdfd9ae$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $52b483885337c95b$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(head, body);
        head = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($92e34c948cdfd9ae$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $e522570f90f30bf2$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $b372f6f49f82b482$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $754f1136e796451a$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $92e34c948cdfd9ae$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $754f1136e796451a$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $92e34c948cdfd9ae$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$92e34c948cdfd9ae$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $a0fd163adf8dda52$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $fc957543935d2fbb$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $754f1136e796451a$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $92e34c948cdfd9ae$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $754f1136e796451a$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $db7e7aa13f3b4797$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Infinity;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
function $db7e7aa13f3b4797$export$536f81b5300b4a28(effects, ok, nok, type, min, max) {
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if (max > 0 && (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return after(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) && size < max) {
            effects.consume(code);
            size++;
            return prefix;
        }
        effects.exit(type);
        return after(code);
    }
    /** @type {State} */ function after(code) {
        return size >= min ? ok(code) : nok(code);
    }
}



const $575312b6fb3e0205$export$a7db06668cad9adb = {
    tokenize: $575312b6fb3e0205$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $575312b6fb3e0205$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 *
 * Port of `edit_map.rs` from `markdown-rs`:
 * <https://github.com/wooorm/markdown-rs/blob/1506572f/src/util/edit_map.rs>.
 *
 * Deal with several changes in events, batching them together.
 *
 * Preferably, changes should be kept to a minimum.
 * Sometimes, it’s needed to change the list of events, because parsing can be
 * messy, and it helps to expose a cleaner interface of events to the compiler
 * and other users.
 * It can also help to merge many adjacent similar events.
 * And, in other cases, it’s needed to parse subcontent: pass some events
 * through another tokenizer and inject the result.
 */ class $b61fc3070a41fd42$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   *
   * @returns
   *   New instance.
   */ constructor(){
        /**
     * Changes by index, so `add` does not need to scan `map` (which is
     * quadratic for documents with many edits at different places).
     *
     * @type {Map<number, Change>}
     */ this.index = new Map();
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   *   Index at which to apply the edit.
   * @param {number} remove
   *   Count of items to remove at the index.
   * @param {Array<Event>} add
   *   Items to add at the index.
   * @returns {undefined}
   *   Nothing.
   */ add(index, remove, add) {
        $b61fc3070a41fd42$var$addImplementation(this, index, remove, add, false);
    }
    /**
   * Create an edit: but insert `add` before existing additions, instead of
   * after them.
   *
   * @param {number} index
   *   Index at which to apply the edit.
   * @param {number} remove
   *   Count of items to remove at the index.
   * @param {Array<Event>} add
   *   Items to add at the index.
   * @returns {undefined}
   *   Nothing.
   */ addBefore(index, remove, add) {
        $b61fc3070a41fd42$var$addImplementation(this, index, remove, add, true);
    }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   *   List of events to apply the edits to.
   * @returns {undefined}
   *   Nothing.
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
        this.index.clear();
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 *   Edit map to apply to.
 * @param {number} at
 *   Index at which to apply the edit.
 * @param {number} remove
 *   Count of items to remove at the index.
 * @param {Array<Event>} add
 *   Items to add at the index.
 * @param {boolean} before
 *   Insert `add` before existing additions at `at`, instead of after them.
 * @returns {undefined}
 *   Nothing.
 */ function $b61fc3070a41fd42$var$addImplementation(editMap, at, remove, add, before) {
    if (remove === 0 && add.length === 0) return;
    const existing = editMap.index.get(at);
    if (existing) {
        existing[1] += remove;
        if (before) {
            add.push(...existing[2]);
            existing[2] = add;
        } else existing[2].push(...add);
        return;
    }
    /** @type {Change} */ const change = [
        at,
        remove,
        add
    ];
    editMap.map.push(change);
    editMap.index.set(at, change);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


const $4d5bd4f9ad84e466$export$5a7bfc01df82fcd1 = {
    tokenize: $4d5bd4f9ad84e466$var$initializeDocument
};
/** @type {Construct} */ const $4d5bd4f9ad84e466$var$containerConstruct = {
    tokenize: $4d5bd4f9ad84e466$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $4d5bd4f9ad84e466$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            const editMap = new (0, $b61fc3070a41fd42$export$9348908dd4518b4a)();
            // Inject the exits earlier (they’re still also at the end).
            editMap.add(indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            editMap.add(indexBeforeExits, index - indexBeforeExits, []);
            editMap.consume(self.events);
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($4d5bd4f9ad84e466$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($4d5bd4f9ad84e466$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            const editMap = new (0, $b61fc3070a41fd42$export$9348908dd4518b4a)();
            // Inject the exits earlier (they’re still also at the end).
            editMap.add(indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            editMap.add(indexBeforeExits, index - indexBeforeExits, []);
            editMap.consume(self.events);
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $4d5bd4f9ad84e466$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $a1b9554aac941323$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $a1b9554aac941323$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a1b9554aac941323$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $c6b46d943c2875c1$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $c6b46d943c2875c1$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $c6b46d943c2875c1$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $c6b46d943c2875c1$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $c6b46d943c2875c1$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $c6b46d943c2875c1$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $c6b46d943c2875c1$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $efc051307d0a57bb$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $c6b46d943c2875c1$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $efc051307d0a57bb$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $e3feb7cc014b834a$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $efc051307d0a57bb$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $b8d6046da21696ea$export$a7db06668cad9adb = {
    resolve: $b8d6046da21696ea$var$resolveContent,
    tokenize: $b8d6046da21696ea$var$tokenizeContent
};
/** @type {Construct} */ const $b8d6046da21696ea$var$continuationConstruct = {
    partial: true,
    tokenize: $b8d6046da21696ea$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $b8d6046da21696ea$var$resolveContent(events) {
    (0, $efc051307d0a57bb$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b8d6046da21696ea$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return effects.check($b8d6046da21696ea$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b8d6046da21696ea$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $cfb9d176029f3441$export$ccc7b0636abaffc3 = {
    tokenize: $cfb9d176029f3441$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $cfb9d176029f3441$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $a1b9554aac941323$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $b8d6046da21696ea$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ 
const $90bb2e5239bd4891$export$50397835cbfdbc24 = {
    resolveAll: $90bb2e5239bd4891$var$createResolver()
};
const $90bb2e5239bd4891$export$22b082955e083ec3 = $90bb2e5239bd4891$var$initializeFactory('string');
const $90bb2e5239bd4891$export$6f093cfa640b7166 = $90bb2e5239bd4891$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $90bb2e5239bd4891$var$initializeFactory(field) {
    return {
        resolveAll: $90bb2e5239bd4891$var$createResolver(field === 'text' ? $90bb2e5239bd4891$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $90bb2e5239bd4891$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $90bb2e5239bd4891$var$resolveAllLineSuffixes(events, context) {
    const editMap = new (0, $b61fc3070a41fd42$export$9348908dd4518b4a)();
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else editMap.add(eventIndex, 0, [
                [
                    'enter',
                    token,
                    context
                ],
                [
                    'exit',
                    token,
                    context
                ]
            ]);
        }
        eventIndex++;
    }
    editMap.consume(events);
    return events;
}


var $6363f03b1b76d577$exports = {};

$parcel$export($6363f03b1b76d577$exports, "document", function () { return $6363f03b1b76d577$export$5a7bfc01df82fcd1; });
$parcel$export($6363f03b1b76d577$exports, "contentInitial", function () { return $6363f03b1b76d577$export$5a2181fb44b58173; });
$parcel$export($6363f03b1b76d577$exports, "flowInitial", function () { return $6363f03b1b76d577$export$cf8bead395eff824; });
$parcel$export($6363f03b1b76d577$exports, "flow", function () { return $6363f03b1b76d577$export$ccc7b0636abaffc3; });
$parcel$export($6363f03b1b76d577$exports, "string", function () { return $6363f03b1b76d577$export$22b082955e083ec3; });
$parcel$export($6363f03b1b76d577$exports, "text", function () { return $6363f03b1b76d577$export$6f093cfa640b7166; });
$parcel$export($6363f03b1b76d577$exports, "insideSpan", function () { return $6363f03b1b76d577$export$d44f260a3f9b69f5; });
$parcel$export($6363f03b1b76d577$exports, "attentionMarkers", function () { return $6363f03b1b76d577$export$b9c0b60d74426aea; });
$parcel$export($6363f03b1b76d577$exports, "disable", function () { return $6363f03b1b76d577$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $a28c56bcd12af494$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) || (0, $d11f122b7c6f306c$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $d11f122b7c6f306c$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $4d2b06c615019ada$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $b66283addf3a1993$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $b66283addf3a1993$var$resolveAllAttention,
    tokenize: $b66283addf3a1993$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $b66283addf3a1993$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {Array<Event>} */ let nextEvents;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        let open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            const use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $b66283addf3a1993$var$movePoint(start, -use);
            $b66283addf3a1993$var$movePoint(end, use);
            const openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            const closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            const text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            const group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(nextEvents, (0, $4d2b06c615019ada$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            /** @type {number} */ let offset = 0;
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            }
            (0, $e3feb7cc014b834a$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b66283addf3a1993$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $a28c56bcd12af494$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $a28c56bcd12af494$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        // Note: `*` and `_` are in `attentionMarkers` through core.
        // They are excluded here as the loosening is meant for markers registered
        // by *other* constructs (such as GFM strikethrough’s `~`).
        const open = !after || after === 2 && before || attentionMarkers.includes(code) && code !== 42 && code !== 95;
        const close = !before || before === 2 && after || attentionMarkers.includes(previous) && previous !== 42 && previous !== 95;
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $b66283addf3a1993$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $2b124003a87b580e$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $2b124003a87b580e$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2b124003a87b580e$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $d11f122b7c6f306c$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $d11f122b7c6f306c$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $878013b2d13d288d$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $878013b2d13d288d$var$tokenizeBlockQuoteContinuation
    },
    exit: $878013b2d13d288d$var$exit,
    name: 'blockQuote',
    tokenize: $878013b2d13d288d$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $878013b2d13d288d$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $878013b2d13d288d$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($878013b2d13d288d$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $878013b2d13d288d$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $d450d3ff44899be5$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $d450d3ff44899be5$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d450d3ff44899be5$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $d11f122b7c6f306c$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $d18f156d725104f4$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $d18f156d725104f4$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d18f156d725104f4$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $d11f122b7c6f306c$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $d11f122b7c6f306c$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $d11f122b7c6f306c$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $d11f122b7c6f306c$export$75c76db11865a9f4) && !(0, $fc957543935d2fbb$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $0b7d9ee53f9e5583$export$7d8c30d56c4bea0b = {
    partial: true,
    tokenize: $0b7d9ee53f9e5583$var$tokenizeNonLazyContinuation
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0b7d9ee53f9e5583$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return after;
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}


const $b771e12cb4f3dd7c$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $b771e12cb4f3dd7c$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b771e12cb4f3dd7c$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check((0, $0b7d9ee53f9e5583$export$7d8c30d56c4bea0b), atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return effects.check((0, $0b7d9ee53f9e5583$export$7d8c30d56c4bea0b), atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $1e92a85728bbd057$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $1e92a85728bbd057$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $1e92a85728bbd057$var$furtherStart = {
    partial: true,
    tokenize: $1e92a85728bbd057$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1e92a85728bbd057$var$tokenizeCodeIndented(effects, ok, nok) {
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        return (0, $db7e7aa13f3b4797$export$536f81b5300b4a28)(effects, atBreak, nok, "linePrefix", 4, 4)(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return effects.attempt($1e92a85728bbd057$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1e92a85728bbd057$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        return (0, $db7e7aa13f3b4797$export$536f81b5300b4a28)(effects, ok, onNotEnoughPrefix, "linePrefix", 4, 4)(code);
    }
    /**
   * After not enough of a prefix.
   *
   * A following line ending is another (potentially blank) line to try,
   * anything else means this isn’t a continuation.
   *
   * ```markdown
   * > |     aaa
   *
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function onNotEnoughPrefix(code) {
        return (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $7cf347faa41cfe1b$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $7cf347faa41cfe1b$var$previous,
    resolve: $7cf347faa41cfe1b$var$resolveCodeText,
    tokenize: $7cf347faa41cfe1b$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $7cf347faa41cfe1b$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $7cf347faa41cfe1b$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7cf347faa41cfe1b$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $65d67f8325660a4a$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $d11f122b7c6f306c$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $d11f122b7c6f306c$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $f9400577ccb592bb$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $0810baba2a43bc32$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $bcb93d954741944c$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $c1dadaf772ea9f35$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $c1dadaf772ea9f35$var$tokenizeDefinition
};
/** @type {Construct} */ const $c1dadaf772ea9f35$var$titleBefore = {
    partial: true,
    tokenize: $c1dadaf772ea9f35$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c1dadaf772ea9f35$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $f9400577ccb592bb$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) ? (0, $bcb93d954741944c$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $65d67f8325660a4a$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($c1dadaf772ea9f35$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $c1dadaf772ea9f35$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) ? (0, $bcb93d954741944c$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $0810baba2a43bc32$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $1f2e011a27508b88$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $1f2e011a27508b88$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1f2e011a27508b88$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $9bccb275bc1e1ca9$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $9bccb275bc1e1ca9$var$resolveHeadingAtx,
    tokenize: $9bccb275bc1e1ca9$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $9bccb275bc1e1ca9$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        const content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        const text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $e3feb7cc014b834a$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9bccb275bc1e1ca9$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $6dcd72fa0d876ee4$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $6dcd72fa0d876ee4$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];




const $eb9c78cc54159eea$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $eb9c78cc54159eea$var$resolveToHtmlFlow,
    tokenize: $eb9c78cc54159eea$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $eb9c78cc54159eea$var$blankLineBefore = {
    partial: true,
    tokenize: $eb9c78cc54159eea$var$tokenizeBlankLineBefore
};
/** @type {Resolver} */ function $eb9c78cc54159eea$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $eb9c78cc54159eea$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $6dcd72fa0d876ee4$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $6dcd72fa0d876ee4$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($eb9c78cc54159eea$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check((0, $0b7d9ee53f9e5583$export$7d8c30d56c4bea0b), continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $6dcd72fa0d876ee4$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $eb9c78cc54159eea$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $a1b9554aac941323$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $10202dc09f925a14$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $10202dc09f925a14$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $10202dc09f925a14$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 







const $889bc2612de7f581$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $889bc2612de7f581$var$resolveAllLabelEnd,
    resolveTo: $889bc2612de7f581$var$resolveToLabelEnd,
    tokenize: $889bc2612de7f581$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $889bc2612de7f581$var$resourceConstruct = {
    tokenize: $889bc2612de7f581$var$tokenizeResource
};
/** @type {Construct} */ const $889bc2612de7f581$var$referenceFullConstruct = {
    tokenize: $889bc2612de7f581$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $889bc2612de7f581$var$referenceCollapsedConstruct = {
    tokenize: $889bc2612de7f581$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $889bc2612de7f581$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $e3feb7cc014b834a$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $889bc2612de7f581$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        const token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(media, (0, $4d2b06c615019ada$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $e3feb7cc014b834a$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $889bc2612de7f581$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    const labelStarts = self._labelStarts;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    if (labelStarts) {
        // Discard ones that failed to close,
        // they’re not needed anymore.
        while(labelStarts.length > 0 && labelStarts[labelStarts.length - 1]._balanced)labelStarts.pop();
        labelStart = labelStarts[labelStarts.length - 1];
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $b372f6f49f82b482$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($889bc2612de7f581$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($889bc2612de7f581$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($889bc2612de7f581$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        // This label start is now used up: discard it so it’s never found again.
        labelStarts.pop();
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $889bc2612de7f581$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) ? (0, $bcb93d954741944c$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $65d67f8325660a4a$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) ? (0, $bcb93d954741944c$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $0810baba2a43bc32$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) ? (0, $bcb93d954741944c$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $889bc2612de7f581$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $f9400577ccb592bb$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $b372f6f49f82b482$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $889bc2612de7f581$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   Token,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $2c159faf359363fc$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $889bc2612de7f581$export$470a5dafbbf62654).resolveAll,
    tokenize: $2c159faf359363fc$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2c159faf359363fc$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    /** @type {Token} */ let labelImage;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            labelImage = effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 6 */ if (code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        self._labelStarts = self._labelStarts || [];
        self._labelStarts.push(labelImage);
        return ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   Token,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $fb33723eaf82550b$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $889bc2612de7f581$export$470a5dafbbf62654).resolveAll,
    tokenize: $fb33723eaf82550b$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $fb33723eaf82550b$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    /** @type {Token} */ let labelLink;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        labelLink = effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 6 */ if (code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        self._labelStarts = self._labelStarts || [];
        self._labelStarts.push(labelLink);
        return ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $24bdae25fba20deb$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $24bdae25fba20deb$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $24bdae25fba20deb$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $d565f3e87d1faaa4$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $d565f3e87d1faaa4$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d565f3e87d1faaa4$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $de3a927a75073d3e$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $de3a927a75073d3e$var$tokenizeListContinuation
    },
    exit: $de3a927a75073d3e$var$tokenizeListEnd,
    name: 'list',
    tokenize: $de3a927a75073d3e$var$tokenizeListStart
};
/** @type {Construct} */ const $de3a927a75073d3e$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $de3a927a75073d3e$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $de3a927a75073d3e$var$indentConstruct = {
    partial: true,
    tokenize: $de3a927a75073d3e$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $de3a927a75073d3e$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $d11f122b7c6f306c$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $d565f3e87d1faaa4$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $d11f122b7c6f306c$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $a1b9554aac941323$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($de3a927a75073d3e$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $de3a927a75073d3e$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $a1b9554aac941323$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($de3a927a75073d3e$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, effects.attempt($de3a927a75073d3e$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $de3a927a75073d3e$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $de3a927a75073d3e$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $de3a927a75073d3e$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $9508a4b976bb64c0$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $9508a4b976bb64c0$var$resolveToSetextUnderline,
    tokenize: $9508a4b976bb64c0$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $9508a4b976bb64c0$var$resolveToSetextUnderline(events, context) {
    const editMap = new (0, $b61fc3070a41fd42$export$9348908dd4518b4a)();
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        editMap.add(index, 1, []);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        editMap.add(text, 0, [
            [
                'enter',
                heading,
                context
            ]
        ]);
        editMap.add(definition + 1, 0, [
            [
                'exit',
                events[content][1],
                context
            ]
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    editMap.add(events.length, 0, [
        [
            'exit',
            heading,
            context
        ]
    ]);
    editMap.consume(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9508a4b976bb64c0$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code) ? (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $6363f03b1b76d577$export$5a7bfc01df82fcd1 = {
    [42]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [43]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [45]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [48]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [49]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [50]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [51]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [52]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [53]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [54]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [55]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [56]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [57]: (0, $de3a927a75073d3e$export$8837f4fc672e936d),
    [62]: (0, $878013b2d13d288d$export$200dcd0a5903c968)
};
const $6363f03b1b76d577$export$5a2181fb44b58173 = {
    [91]: (0, $c1dadaf772ea9f35$export$69f215ed977cdb73)
};
const $6363f03b1b76d577$export$cf8bead395eff824 = {
    [-2]: (0, $1e92a85728bbd057$export$47910b7ab28d1853),
    [-1]: (0, $1e92a85728bbd057$export$47910b7ab28d1853),
    [32]: (0, $1e92a85728bbd057$export$47910b7ab28d1853)
};
const $6363f03b1b76d577$export$ccc7b0636abaffc3 = {
    [35]: (0, $9bccb275bc1e1ca9$export$3871e9deb360695c),
    [42]: (0, $d565f3e87d1faaa4$export$ba7b13e047416c03),
    [45]: [
        (0, $9508a4b976bb64c0$export$e104e2de391dfde9),
        (0, $d565f3e87d1faaa4$export$ba7b13e047416c03)
    ],
    [60]: (0, $eb9c78cc54159eea$export$476ac411cb7d0d8f),
    [61]: (0, $9508a4b976bb64c0$export$e104e2de391dfde9),
    [95]: (0, $d565f3e87d1faaa4$export$ba7b13e047416c03),
    [96]: (0, $b771e12cb4f3dd7c$export$c23e4921f8d87e7c),
    [126]: (0, $b771e12cb4f3dd7c$export$c23e4921f8d87e7c)
};
const $6363f03b1b76d577$export$22b082955e083ec3 = {
    [38]: (0, $d18f156d725104f4$export$e31905600aaf3d8e),
    [92]: (0, $d450d3ff44899be5$export$2005478564e78d96)
};
const $6363f03b1b76d577$export$6f093cfa640b7166 = {
    [-5]: (0, $24bdae25fba20deb$export$8e62e0ad51c97b2),
    [-4]: (0, $24bdae25fba20deb$export$8e62e0ad51c97b2),
    [-3]: (0, $24bdae25fba20deb$export$8e62e0ad51c97b2),
    [33]: (0, $2c159faf359363fc$export$3d754936e25aa5f5),
    [38]: (0, $d18f156d725104f4$export$e31905600aaf3d8e),
    [42]: (0, $b66283addf3a1993$export$45b92471da762af7),
    [60]: [
        (0, $2b124003a87b580e$export$17ddf85e4c916ad6),
        (0, $10202dc09f925a14$export$398af27f284914fe)
    ],
    [91]: (0, $fb33723eaf82550b$export$5c0cee0701a3b584),
    [92]: [
        (0, $1f2e011a27508b88$export$86c573ab9e06f418),
        (0, $d450d3ff44899be5$export$2005478564e78d96)
    ],
    [93]: (0, $889bc2612de7f581$export$470a5dafbbf62654),
    [95]: (0, $b66283addf3a1993$export$45b92471da762af7),
    [96]: (0, $7cf347faa41cfe1b$export$d24f93e715f9df88)
};
const $6363f03b1b76d577$export$d44f260a3f9b69f5 = {
    null: [
        (0, $b66283addf3a1993$export$45b92471da762af7),
        (0, $90bb2e5239bd4891$export$50397835cbfdbc24)
    ]
};
const $6363f03b1b76d577$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $6363f03b1b76d577$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $aa0e0d9a5f7c154e$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $e3feb7cc014b834a$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $4d2b06c615019ada$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $aa0e0d9a5f7c154e$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $aa0e0d9a5f7c154e$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                const chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $e3feb7cc014b834a$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $aa0e0d9a5f7c154e$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $aa0e0d9a5f7c154e$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $004443d4774e2bcf$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $52b483885337c95b$export$86a865d89ef3c690)([
        $6363f03b1b76d577$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $575312b6fb3e0205$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $4d5bd4f9ad84e466$export$5a7bfc01df82fcd1)),
        flow: create((0, $cfb9d176029f3441$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $90bb2e5239bd4891$export$22b082955e083ec3)),
        text: create((0, $90bb2e5239bd4891$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $aa0e0d9a5f7c154e$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $58f1b4d78a249b1d$export$bd0e6e1378a871d7(events) {
    while(!(0, $efc051307d0a57bb$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $86f0cf9812ed383a$var$search = /[\0\t\n\r]/g;
function $86f0cf9812ed383a$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        /** @type {Array<Chunk>} */ const chunks = [];
        let startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $86f0cf9812ed383a$var$search.lastIndex = startPosition;
            const match = $86f0cf9812ed383a$var$search.exec(value);
            const endPosition = match && match.index !== undefined ? match.index : value.length;
            const code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        {
                            const next = Math.ceil(column / 4) * 4;
                            chunks.push(-2);
                            while(column++ < next)chunks.push(-1);
                            break;
                        }
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $a1d2e9bb417846bb$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $92e34c948cdfd9ae$export$ef7acd7185315e22)(options)((0, $58f1b4d78a249b1d$export$bd0e6e1378a871d7)((0, $004443d4774e2bcf$export$98e6a39c04603d36)(options).document().write((0, $86f0cf9812ed383a$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $d302d146b9cc3062$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $d302d146b9cc3062$export$a0fb664af7d0cc44(value) {
    return value.replace($d302d146b9cc3062$var$characterEscapeOrReference, $d302d146b9cc3062$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $d302d146b9cc3062$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $a0fd163adf8dda52$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $fc957543935d2fbb$export$289b6a6320f709b4)($2) || $0;
}




/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $280fd4c52f3b9900$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $280fd4c52f3b9900$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $280fd4c52f3b9900$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $280fd4c52f3b9900$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $280fd4c52f3b9900$var$point(point) {
    return $280fd4c52f3b9900$var$index(point && point.line) + ':' + $280fd4c52f3b9900$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $280fd4c52f3b9900$var$position(pos) {
    return $280fd4c52f3b9900$var$point(pos && pos.start) + '-' + $280fd4c52f3b9900$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $280fd4c52f3b9900$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


const $619c8c599176fa38$var$own = {}.hasOwnProperty;
function $619c8c599176fa38$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $619c8c599176fa38$var$compiler(options)((0, $58f1b4d78a249b1d$export$bd0e6e1378a871d7)((0, $004443d4774e2bcf$export$98e6a39c04603d36)(options).document().write((0, $86f0cf9812ed383a$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $619c8c599176fa38$var$compiler(options) {
    /** @type {Config} */ const config = {
        afterExit: [],
        beforeEnter: [],
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $619c8c599176fa38$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: [],
            position: undefined
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        /** @type {Array<Event>} */ const prepared = [];
        let index = -1;
        // Add `listItem` tokens and infer spread.
        // Each list is prepared while it is last in `prepared`, so nothing shifts.
        while(++index < events.length){
            prepared.push(events[index]);
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(prepared.length - 1);
                else {
                    const tail = listStack.pop();
                    prepareList(prepared, tail);
                }
            }
        }
        events = prepared;
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if (events[index][0] === 'enter' && config.beforeEnter.length > 0) callListeners(config.beforeEnter, {
                ...context,
                sliceSerialize: events[index][2].sliceSerialize
            }, events[index][1]);
            if ($619c8c599176fa38$var$own.call(handler, events[index][1].type)) // Note: spread first, V8 has optimizations for object shape cloning.
            handler[events[index][1].type].call({
                ...context,
                sliceSerialize: events[index][2].sliceSerialize
            }, events[index][1]);
            if (events[index][0] === 'exit' && config.afterExit.length > 0) callListeners(config.afterExit, {
                ...context,
                sliceSerialize: events[index][2].sliceSerialize
            }, events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $619c8c599176fa38$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $619c8c599176fa38$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $619c8c599176fa38$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Handle>} listeners
   *   Listeners.
   * @param {CompileContext} context
   *   Context.
   * @param {Token} token
   *   Token.
   * @returns {undefined}
   *   Nothing.
   */ function callListeners(listeners, context, token) {
        let index = -1;
        while(++index < listeners.length)listeners[index].call(context, token);
    }
    /**
   * @param {Array<Event>} events
   *   Events, ending with the list to prepare.
   * @param {number} start
   *   Index of the list enter.
   * @returns {undefined}
   */ function prepareList(events, start) {
        const end = events.length - 1;
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        /**
     * `listItem` events to insert before the event at `at`, in walk order.
     * Merged in after the walk, as inserting while walking would shift the
     * rest of the list once per item.
     * @type {Array<{at: number, event: Event}>}
     */ const insertions = [];
        while(++index <= end){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    insertions.push({
                        at: lineIndex || index,
                        event: [
                            'exit',
                            listItem,
                            event[2]
                        ]
                    });
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    insertions.push({
                        at: index,
                        event: [
                            'enter',
                            item,
                            event[2]
                        ]
                    });
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        // The list is at the end of `events`: take it off, then push it back with
        // the insertions merged in.
        // Nothing follows the list, so nothing shifts.
        const listEvents = events.splice(start);
        let insertion = 0;
        index = -1;
        while(++index < listEvents.length){
            while(insertion < insertions.length && insertions[insertion].at === start + index)events.push(insertions[insertion++].event);
            events.push(listEvents[index]);
        }
        events[start][1]._spread = listSpread;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $619c8c599176fa38$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $280fd4c52f3b9900$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $619c8c599176fa38$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $619c8c599176fa38$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $bc9bb30833cd7339$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $619c8c599176fa38$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $619c8c599176fa38$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $619c8c599176fa38$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $d302d146b9cc3062$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $a0fd163adf8dda52$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $fc957543935d2fbb$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $619c8c599176fa38$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    // Each node factory pre-declares `position` as undefined as the trailing
    // property. enter() patches it to a real value, but the property already
    // exists, so V8 sees a single hidden class for each node type from
    // construction through the rest of the pipeline. Without the pre-declare,
    // each node took a hidden-class transition when enter() added position.
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: [],
            position: undefined
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: '',
            position: undefined
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: '',
            position: undefined
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: '',
            position: undefined
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: [],
            position: undefined
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: [],
            position: undefined
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break',
            position: undefined
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: '',
            position: undefined
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null,
            position: undefined
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: [],
            position: undefined
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: [],
            position: undefined
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: [],
            position: undefined
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: [],
            position: undefined
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: [],
            position: undefined
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: '',
            position: undefined
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak',
            position: undefined
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $619c8c599176fa38$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $619c8c599176fa38$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $619c8c599176fa38$var$configure(combined, value);
        else $619c8c599176fa38$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $619c8c599176fa38$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($619c8c599176fa38$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'afterExit':
        case 'beforeEnter':
            {
                const right = extension[key];
                if (right) combined[key].push(right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $619c8c599176fa38$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $280fd4c52f3b9900$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $280fd4c52f3b9900$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $280fd4c52f3b9900$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


/**
 * @import {Extension as FromMarkdownExtension} from 'mdast-util-from-markdown'
 * @import {Options} from 'mdast-util-gfm'
 * @import {Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 */ /**
 * @import {RegExpMatchObject, ReplaceFunction} from 'mdast-util-find-and-replace'
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, Transform as FromMarkdownTransform} from 'mdast-util-from-markdown'
 * @import {ConstructName, Options as ToMarkdownExtension} from 'mdast-util-to-markdown'
 * @import {Link, PhrasingContent} from 'mdast'
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $b7b7ee3bc823ee79$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


function $b7e708ea4e32a5f1$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $b7e708ea4e32a5f1$export$411ce8e5a71e3069() {}
function $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49() {}
function $b7e708ea4e32a5f1$export$565e9d9bd6b6e0d4() {}



/**
 * @import {Nodes, Parents, PhrasingContent, Root, Text} from 'mdast'
 * @import {BuildVisitor, Test, VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $1b27249849d15ff4$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new TypeError('Expected a string');
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $dd30add2cf7b4620$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $dd30add2cf7b4620$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$dd30add2cf7b4620$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $dd30add2cf7b4620$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $dd30add2cf7b4620$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $dd30add2cf7b4620$var$ok;
    if (typeof test === 'function') return $dd30add2cf7b4620$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $dd30add2cf7b4620$var$anyFactory(test) : // narrows to `Array`.
    $dd30add2cf7b4620$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $dd30add2cf7b4620$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $dd30add2cf7b4620$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $dd30add2cf7b4620$export$9c68d69a4c5bbcf9(tests[index]);
    return $dd30add2cf7b4620$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $dd30add2cf7b4620$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $dd30add2cf7b4620$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $dd30add2cf7b4620$var$typeFactory(check) {
    return $dd30add2cf7b4620$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $dd30add2cf7b4620$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($dd30add2cf7b4620$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $dd30add2cf7b4620$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $dd30add2cf7b4620$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $fdbde7832f324644$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $c66ab40a891247e7$var$empty = [];
const $c66ab40a891247e7$export$f4d8133c446fe484 = true;
const $c66ab40a891247e7$export$7f100f842f565dc9 = false;
const $c66ab40a891247e7$export$8773f85c2fb2c116 = 'skip';
function $c66ab40a891247e7$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $dd30add2cf7b4620$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $fdbde7832f324644$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $c66ab40a891247e7$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $c66ab40a891247e7$var$toResult(visitor(node, parents));
                if (result[0] === $c66ab40a891247e7$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $c66ab40a891247e7$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $c66ab40a891247e7$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $c66ab40a891247e7$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $c66ab40a891247e7$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $c66ab40a891247e7$var$empty : [
        value
    ];
}


/**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $aa5ab15bc7dfb929$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $aa5ab15bc7dfb929$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$aa5ab15bc7dfb929$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $aa5ab15bc7dfb929$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $aa5ab15bc7dfb929$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $aa5ab15bc7dfb929$var$ok;
    if (typeof test === 'function') return $aa5ab15bc7dfb929$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $aa5ab15bc7dfb929$var$anyFactory(test) : // narrows to `Array`.
    $aa5ab15bc7dfb929$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $aa5ab15bc7dfb929$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $aa5ab15bc7dfb929$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $aa5ab15bc7dfb929$export$9c68d69a4c5bbcf9(tests[index]);
    return $aa5ab15bc7dfb929$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $aa5ab15bc7dfb929$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $aa5ab15bc7dfb929$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $aa5ab15bc7dfb929$var$typeFactory(check) {
    return $aa5ab15bc7dfb929$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $aa5ab15bc7dfb929$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($aa5ab15bc7dfb929$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $aa5ab15bc7dfb929$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $aa5ab15bc7dfb929$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


function $13331076c3a37a5c$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $aa5ab15bc7dfb929$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $13331076c3a37a5c$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $c66ab40a891247e7$export$70008a21eb6de899)(tree, 'text', visitor);
    /**
   * Visit a text node, and handle it if it is not in an ignored parent.
   *
   * @type {BuildVisitor<Root, 'text'>}
   */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node to search in.
   * @param {Array<Parents>} parents
   *   Ancestors of `node`.
   * @returns {VisitorResult}
   *   Where to continue visiting.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === 'string') value = value.length > 0 ? {
                type: 'text',
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) add({
                    type: 'text',
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) for (const child of value)add(child);
                else if (value) add(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) add({
                type: 'text',
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
        /**
     * Add a node.
     *
     * @param {PhrasingContent} child
     *   Node to add.
     * @returns {undefined}
     *   Nothing.
     */ function add(child) {
            const previous = nodes[nodes.length - 1];
            if (previous && previous.type === 'text' && child.type === 'text') previous.value += child.value;
            else nodes.push(child);
        }
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $13331076c3a37a5c$var$toPairs(tupleOrList) {
    if (!Array.isArray(tupleOrList)) throw new TypeError('Expected find and replace tuple or list of tuples');
    /** @type {Pairs} */ const result = [];
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $13331076c3a37a5c$var$toExpression(tuple[0]),
            $13331076c3a37a5c$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Pattern to find.
 * @returns {RegExp}
 *   Global expression.
 */ function $13331076c3a37a5c$var$toExpression(find) {
    return typeof find === 'string' ? new RegExp((0, $1b27249849d15ff4$export$2e2bcd8739ae039)(find), 'g') : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Thing to replace with.
 * @returns {ReplaceFunction}
 *   Function that returns that thing.
 */ function $13331076c3a37a5c$var$toFunction(replace) {
    return typeof replace === 'function' ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $ae420235886a412d$var$inConstruct = 'phrasing';
/** @type {Array<ConstructName>} */ const $ae420235886a412d$var$notInConstruct = [
    'autolink',
    'link',
    'image',
    'label'
];
function $ae420235886a412d$export$b6afdfff2163546f() {
    return {
        transforms: [
            $ae420235886a412d$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $ae420235886a412d$var$enterLiteralAutolink,
            literalAutolinkEmail: $ae420235886a412d$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $ae420235886a412d$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $ae420235886a412d$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $ae420235886a412d$var$exitLiteralAutolink,
            literalAutolinkEmail: $ae420235886a412d$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $ae420235886a412d$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $ae420235886a412d$var$exitLiteralAutolinkWww
        }
    };
}
function $ae420235886a412d$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: '@',
                before: '[+\\-.\\w]',
                after: '[\\-.\\w]',
                inConstruct: $ae420235886a412d$var$inConstruct,
                notInConstruct: $ae420235886a412d$var$notInConstruct
            },
            {
                character: '.',
                before: '[Ww]',
                after: '[\\-.\\w]',
                inConstruct: $ae420235886a412d$var$inConstruct,
                notInConstruct: $ae420235886a412d$var$notInConstruct
            },
            {
                character: ':',
                before: '[ps]',
                after: '\\/',
                inConstruct: $ae420235886a412d$var$inConstruct,
                notInConstruct: $ae420235886a412d$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae420235886a412d$var$enterLiteralAutolink(token) {
    this.enter({
        type: 'link',
        title: null,
        url: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae420235886a412d$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae420235886a412d$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae420235886a412d$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49)(node.type === 'link');
    node.url = 'http://' + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae420235886a412d$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $ae420235886a412d$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $ae420235886a412d$var$transformGfmAutolinkLiterals(tree) {
    (0, $13331076c3a37a5c$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $ae420235886a412d$var$findUrl
        ],
        [
            /(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu,
            $ae420235886a412d$var$findEmail
        ]
    ], {
        ignore: [
            'link',
            'linkReference'
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $ae420235886a412d$var$findUrl(_, protocol, domain, path, match) {
    let prefix = '';
    // Not an expected previous character.
    if (!$ae420235886a412d$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = '';
        prefix = 'http://';
    }
    if (!$ae420235886a412d$var$isCorrectDomain(domain)) return false;
    const parts = $ae420235886a412d$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: 'link',
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: 'text',
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: 'text',
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $ae420235886a412d$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$ae420235886a412d$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: 'link',
        title: null,
        url: 'mailto:' + atext + '@' + label,
        children: [
            {
                type: 'text',
                value: atext + '@' + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $ae420235886a412d$var$isCorrectDomain(domain) {
    const parts = domain.split('.');
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $ae420235886a412d$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(')');
    const openingParens = (0, $b7b7ee3bc823ee79$export$fa42eaa97a352e23)(url, '(');
    let closingParens = (0, $b7b7ee3bc823ee79$export$fa42eaa97a352e23)(url, ')');
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(')');
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $ae420235886a412d$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $d11f122b7c6f306c$export$a0ff789c034ffdf4)(code) || (0, $d11f122b7c6f306c$export$aa04114dd888a7a0)(code)) && // If it’s an email, the previous character should not be a slash.
    (!email || code !== 47);
}


/**
 * @import {
 *   CompileContext,
 *   Extension as FromMarkdownExtension,
 *   Handle as FromMarkdownHandle
 * } from 'mdast-util-from-markdown'
 * @import {ToMarkdownOptions} from 'mdast-util-gfm-footnote'
 * @import {
 *   Handle as ToMarkdownHandle,
 *   Map,
 *   Options as ToMarkdownExtension
 * } from 'mdast-util-to-markdown'
 * @import {FootnoteDefinition, FootnoteReference} from 'mdast'
 */ 

$14e3c07398258ed1$var$footnoteReference.peek = $14e3c07398258ed1$var$footnoteReferencePeek;
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$enterFootnoteCall(token) {
    this.enter({
        type: 'footnoteReference',
        identifier: '',
        label: ''
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$enterFootnoteDefinition(token) {
    this.enter({
        type: 'footnoteDefinition',
        identifier: '',
        label: '',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49)(node.type === 'footnoteReference');
    node.identifier = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49)(node.type === 'footnoteDefinition');
    node.identifier = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    node.label = label;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $14e3c07398258ed1$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/** @type {ToMarkdownHandle} */ function $14e3c07398258ed1$var$footnoteReferencePeek() {
    return '[';
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $14e3c07398258ed1$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move('[^');
    const exit = state.enter('footnoteReference');
    const subexit = state.enter('reference');
    value += tracker.move(state.safe(state.associationId(node), {
        after: ']',
        before: value
    }));
    subexit();
    exit();
    value += tracker.move(']');
    return value;
}
function $14e3c07398258ed1$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteCallString: $14e3c07398258ed1$var$enterFootnoteCallString,
            gfmFootnoteCall: $14e3c07398258ed1$var$enterFootnoteCall,
            gfmFootnoteDefinitionLabelString: $14e3c07398258ed1$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $14e3c07398258ed1$var$enterFootnoteDefinition
        },
        exit: {
            gfmFootnoteCallString: $14e3c07398258ed1$var$exitFootnoteCallString,
            gfmFootnoteCall: $14e3c07398258ed1$var$exitFootnoteCall,
            gfmFootnoteDefinitionLabelString: $14e3c07398258ed1$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteDefinition: $14e3c07398258ed1$var$exitFootnoteDefinition
        }
    };
}
function $14e3c07398258ed1$export$3727766a73a6c09f(options) {
    // To do: next major: change default.
    let firstLineBlank = false;
    if (options && options.firstLineBlank) firstLineBlank = true;
    return {
        handlers: {
            footnoteDefinition: footnoteDefinition,
            footnoteReference: $14e3c07398258ed1$var$footnoteReference
        },
        // This is on by default already.
        unsafe: [
            {
                character: '[',
                inConstruct: [
                    'label',
                    'phrasing',
                    'reference'
                ]
            }
        ]
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */ function footnoteDefinition(node, _, state, info) {
        const tracker = state.createTracker(info);
        let value = tracker.move('[^');
        const exit = state.enter('footnoteDefinition');
        const subexit = state.enter('label');
        value += tracker.move(state.safe(state.associationId(node), {
            before: value,
            after: ']'
        }));
        subexit();
        value += tracker.move(']:');
        if (node.children && node.children.length > 0) {
            tracker.shift(4);
            value += tracker.move((firstLineBlank ? '\n' : ' ') + state.indentLines(state.containerFlow(node, tracker.current()), firstLineBlank ? $14e3c07398258ed1$var$mapAll : $14e3c07398258ed1$var$mapExceptFirst));
        }
        exit();
        return value;
    }
}
/** @type {Map} */ function $14e3c07398258ed1$var$mapExceptFirst(line, index, blank) {
    return index === 0 ? line : $14e3c07398258ed1$var$mapAll(line, index, blank);
}
/** @type {Map} */ function $14e3c07398258ed1$var$mapAll(line, index, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Delete} from 'mdast'
 * @import {
 *   CompileContext,
 *   Extension as FromMarkdownExtension,
 *   Handle as FromMarkdownHandle
 * } from 'mdast-util-from-markdown'
 * @import {
 *   Attention,
 *   ConstructName,
 *   Handle as ToMarkdownHandle,
 *   Options as ToMarkdownExtension
 * } from 'mdast-util-to-markdown'
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $4b2149ec6bb2aa91$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$4b2149ec6bb2aa91$var$handleDelete.attention = $4b2149ec6bb2aa91$var$attentionDelete;
$4b2149ec6bb2aa91$var$handleDelete.peek = $4b2149ec6bb2aa91$var$peekDelete;
function $4b2149ec6bb2aa91$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $4b2149ec6bb2aa91$var$enterStrikethrough
        },
        exit: {
            strikethrough: $4b2149ec6bb2aa91$var$exitStrikethrough
        }
    };
}
function $4b2149ec6bb2aa91$export$1632835bd2c84956() {
    return {
        handlers: {
            delete: $4b2149ec6bb2aa91$var$handleDelete
        },
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $4b2149ec6bb2aa91$var$constructsWithoutStrikethrough
            }
        ]
    };
}
/**
 * Enter strikethrough.
 *
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4b2149ec6bb2aa91$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: [],
        position: undefined
    }, token);
}
/**
 * Exit strikethrough.
 *
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4b2149ec6bb2aa91$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * Serialize a delete node.
 *
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 *   Node to serialize.
 */ function $4b2149ec6bb2aa91$var$handleDelete(node, _, state, info) {
    // To do: next major: empty this function, like emphasis and strong handlers,
    // this is no longer needed.
    const tracker = state.createTracker(info);
    const sequence = state.stack.includes('strikethrough') ? '~' : '~~';
    const exit = state.enter('strikethrough');
    let value = tracker.move(sequence);
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: '~'
    });
    value += tracker.move(sequence);
    exit();
    return value;
}
/**
 * Serialize a delete node as attention.
 *
 * @type {Attention}
 */ function $4b2149ec6bb2aa91$var$attentionDelete() {
    return {
        construct: 'strikethrough',
        markers: [
            '~'
        ],
        sizes: [
            2,
            1
        ]
    };
}
/**
 * Peek the first character of a delete node.
 *
 * @type {ToMarkdownHandle}
 */ function $4b2149ec6bb2aa91$var$peekDelete() {
    return '~';
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $ee3593332bd8700a$var$defaultStringLength(value) {
    return value.length;
}
function $ee3593332bd8700a$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $ee3593332bd8700a$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $ee3593332bd8700a$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $ee3593332bd8700a$var$toAlignment(align[columnIndex]);
    else {
        const code = $ee3593332bd8700a$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === '') && (settings.delimiterStart !== false || columnIndex)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $ee3593332bd8700a$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $ee3593332bd8700a$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * Serialize a blockquote node.
 *
 * @param {Blockquote} node
 *   Node to serialize.
 * @param {Parents | undefined} _
 *   Parent node.
 * @param {State} state
 *   Info passed around.
 * @param {Info} info
 *   Info on surrounding context.
 * @returns {string}
 *   Serialized markdown.
 */ function $208370220e6c0d9f$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $208370220e6c0d9f$var$map);
    exit();
    return value;
}
/**
 * Indent lines w/ blockquote markers.
 *
 * @type {Map}
 */ function $208370220e6c0d9f$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * Check if a pattern is in scope based on the current stack of constructs.
 *
 * @param {Array<ConstructName>} stack
 *   Current stack of constructs.
 * @param {Unsafe} pattern
 *   Pattern to check.
 * @returns {boolean}
 *   Whether the pattern is in scope.
 */ function $fd8729166a59a0c8$export$78221a09424368d(stack, pattern) {
    return $fd8729166a59a0c8$var$listInScope(stack, pattern.inConstruct, true) && !$fd8729166a59a0c8$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * Check if any of the constructs in the list are present in the stack.
 *
 * @param {Array<ConstructName>} stack
 *   Current stack of constructs.
 * @param {Unsafe['inConstruct']} list
 *   List of constructs to check for in the stack.
 * @param {boolean} none
 *   Value to return if the list is empty or not provided.
 * @returns {boolean}
 *   Whether any of the constructs in the list are present in the stack.
 */ function $fd8729166a59a0c8$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $1c7dc10908f7b218$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        // If we can’t put unconditional eols in this construct (setext headings,
        // tables), use a space instead.
        if (pattern.character === '\n' && !pattern.before && !pattern.after && (0, $fd8729166a59a0c8$export$78221a09424368d)(state.stack, pattern)) return /[\t ]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ /**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $1ec43c670966e128$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * Checks if a code block can be formatted as an indented code block.
 *
 * @param {Code} node
 *   Node to check.
 * @param {State} state
 *   Info passed around.
 * @returns {boolean}
 *   Whether the code can be formatted as an indented code block.
 */ function $1c967ca5d4c68636$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^\n\r ]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\n\r]|$)|(?:^|[\n\r])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred fence option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['fence'], null | undefined>}
 *   Preferred fence marker.
 */ function $75a887aa13fae7f1$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $ae9596198c520d70$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $75a887aa13fae7f1$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    if ((0, $1c967ca5d4c68636$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $ae9596198c520d70$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $1ec43c670966e128$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: ' ',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: '\n',
            encode: [
                '`'
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/**
 * Indent lines w/ code indent.
 *
 * @type {Map}
 */ function $ae9596198c520d70$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred quote option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['quote'], null | undefined>}
 *   Preferred quote.
 */ function $41f624a88973c261$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $3fd79b772b49f507$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $41f624a88973c261$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : '\n',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {AttentionInfo, Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred emphasis option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 *   Preferred emphasis marker.
 */ function $50bd50ecea8ff7ce$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


$2d0bdd047db1c10b$export$bef81ba411953b51.attention = $2d0bdd047db1c10b$var$attention;
$2d0bdd047db1c10b$export$bef81ba411953b51.peek = $2d0bdd047db1c10b$var$peek;
function $2d0bdd047db1c10b$export$bef81ba411953b51(node, _, state, info) {
    const exit = state.enter('phrasing');
    const value = state.containerPhrasing({
        type: 'root',
        children: [
            node
        ]
    }, info);
    exit();
    return value;
}
/**
 * Serialize an emphasis node as attention.
 *
 * @param {Emphasis} _
 *   Node to serialize.
 * @param {State} state
 *   Info passed around.
 * @returns {AttentionInfo}
 *   Info on how to serialize the node.
 */ function $2d0bdd047db1c10b$var$attention(_, state) {
    const marker = (0, $50bd50ecea8ff7ce$export$f967eb786dea04e7)(state);
    return {
        construct: 'emphasis',
        markers: marker === '*' ? [
            '*',
            '_'
        ] : [
            '_',
            '*'
        ],
        sizes: [
            1
        ]
    };
}
/**
 * Peek at this node.
 *
 * @param {Emphasis} _
 *   Node to serialize.
 * @param {Parents | undefined} _1
 *   Parent node.
 * @param {State} state
 *   Info passed around.
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $2d0bdd047db1c10b$var$peek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ /**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $fa82489729b3449c$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
function $a50be6f0b1830cb7$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $c66ab40a891247e7$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



function $fd0b93a1588ffa6a$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $a50be6f0b1830cb7$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $c66ab40a891247e7$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $bc9bb30833cd7339$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $199531ea000db40b$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $fd0b93a1588ffa6a$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: '\n',
            after: '\n'
        });
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, {
        before: '# ',
        after: '\n',
        ...tracker.current()
    });
    const head = value.charCodeAt(0);
    if (head === 9 /* `\t` */  || head === 32 /* ` ` */ ) // To do: what effect has the character reference on tracking?
    value = (0, $fa82489729b3449c$export$5810cf1e579e9d5b)(head) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $7036d6b7c8db1634$export$c0bb0b647f701bb5.peek = $7036d6b7c8db1634$var$htmlPeek;
function $7036d6b7c8db1634$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * Peek at this node.
 *
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $7036d6b7c8db1634$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 
$a46aa55a01bd5705$export$5c452ff88e35e47d.peek = $a46aa55a01bd5705$var$imagePeek;
function $a46aa55a01bd5705$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $41f624a88973c261$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * Peek at this node.
 *
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $a46aa55a01bd5705$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ $4ba5fdf85737364d$export$f281796f6bc3b8db.peek = $4ba5fdf85737364d$var$imageReferencePeek;
function $4ba5fdf85737364d$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(alt + '][');
    subexit();
    // Hide that we’re in phrasing as things like attention or code cannot form
    // in references.
    // Character escapes and references *do* work.
    // It is important to know about other constructs, such as table cells.
    const stack = state.stack;
    state.stack = stack.filter(function(d) {
        return d !== 'phrasing';
    });
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * Peek at this node.
 *
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $4ba5fdf85737364d$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $58c38f342713f9c6$export$91b9bee19a0d8569.peek = $58c38f342713f9c6$var$inlineCodePeek;
function $58c38f342713f9c6$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^\n\r ]/.test(value) && (/^[\n\r ]/.test(value) && /[\n\r ]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * Peek at this node.
 *
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $58c38f342713f9c6$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 
/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $cd18572544362449$export$74cae3045e3179ed(node, state) {
    const raw = (0, $bc9bb30833cd7339$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][+\-.a-z]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$3edfc89f7d1e2abc$export$9c30223ca0a664fb.peek = $3edfc89f7d1e2abc$var$linkPeek;
function $3edfc89f7d1e2abc$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $41f624a88973c261$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    if ((0, $cd18572544362449$export$74cae3045e3179ed)(node, state)) {
        // Hide that we’re in phrasing as things like attention or code cannot form
        // in autolinks.
        // Character escapes also don’t work (nor character references),
        // but that is a different matter, which `safe.js` handles for `autolink`.
        // It is important to know about other constructs, such as table cells.
        const stack = state.stack;
        state.stack = stack.filter(function(d) {
            return d !== 'phrasing';
        });
        const exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    const exit = state.enter('link');
    let subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: '](',
        ...tracker.current()
    }));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: '>',
            ...tracker.current()
        }));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? ' ' : ')',
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * Peek at this node.
 *
 * @param {Link} node
 *   Node to peek at.
 * @param {Parents | undefined} _
 *   Parent node.
 * @param {State} state
 *   Info passed around.
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $3edfc89f7d1e2abc$var$linkPeek(node, _, state) {
    return (0, $cd18572544362449$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ $559051d9468a184b$export$e6c469b1b7b2bc6a.peek = $559051d9468a184b$var$linkReferencePeek;
function $559051d9468a184b$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, {
        before: value,
        after: ']',
        ...tracker.current()
    });
    value += tracker.move(text + '][');
    subexit();
    // Hide that we’re in phrasing as things like attention or code cannot form
    // in references.
    // Character escapes and references *do* work.
    // It is important to know about other constructs, such as table cells.
    const stack = state.stack;
    state.stack = stack.filter(function(d) {
        return d !== 'phrasing';
    });
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: ']',
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * Peek at this node.
 *
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $559051d9468a184b$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred list bullet option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['bullet'], null | undefined>}
 *   Preferred list bullet.
 */ function $c42f735cf45be2c7$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $31186be1a35f5828$export$e6803bf0889262a1(state) {
    const bullet = (0, $c42f735cf45be2c7$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred ordered list bullet option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 *   Preferred ordered list bullet.
 */ function $8165a283ffe1bfd3$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred rule option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['rule'], null | undefined>}
 *   Preferred rule marker.
 */ function $f8475990a908ccae$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $109feb8864e171b3$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $8165a283ffe1bfd3$export$98d522b78eddc19b)(state) : (0, $c42f735cf45be2c7$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $31186be1a35f5828$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $f8475990a908ccae$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred list item indent option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 *   Preferred list item indent.
 */ function $67469432f99ae244$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $e0f09afb239a1374$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $67469432f99ae244$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $c42f735cf45be2c7$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /**
   * Indent lines of the list item.
   *
   * @type {Map}
   */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * Serialize a paragraph node.
 *
 * @param {Paragraph} node
 *   Node to serialize.
 * @param {Parents | undefined} _
 *   Parent node.
 * @param {State} state
 *   Info passed around.
 * @param {Info} info
 *   Info on surrounding context.
 * @returns {string}
 *   Serialized markdown.
 */ function $20866ef1c959e2be$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $6c557fb010b7a34e$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $6c557fb010b7a34e$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$6c557fb010b7a34e$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $6c557fb010b7a34e$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $6c557fb010b7a34e$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $6c557fb010b7a34e$var$ok;
    if (typeof test === 'function') return $6c557fb010b7a34e$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $6c557fb010b7a34e$var$anyFactory(test) : // narrows to `Array`.
    $6c557fb010b7a34e$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $6c557fb010b7a34e$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $6c557fb010b7a34e$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $6c557fb010b7a34e$export$9c68d69a4c5bbcf9(tests[index]);
    return $6c557fb010b7a34e$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $6c557fb010b7a34e$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $6c557fb010b7a34e$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $6c557fb010b7a34e$var$typeFactory(check) {
    return $6c557fb010b7a34e$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $6c557fb010b7a34e$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($6c557fb010b7a34e$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $6c557fb010b7a34e$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $6c557fb010b7a34e$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


const $cfb8c788a34c646c$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $6c557fb010b7a34e$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $026a73c96840b09c$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $cfb8c788a34c646c$export$444c9dec66a6f08c)(d);
    });
    if (!hasPhrasing) return state.containerFlow(node, info);
    const exit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    exit();
    return value;
}


/**
 * @import {AttentionInfo, Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred strong option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['strong'], null | undefined>}
 *   Preferred strong marker.
 */ function $4faf7cd1e21bba8c$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}


$14745d21792abc32$export$59ae2c325a998f89.attention = $14745d21792abc32$var$attention;
$14745d21792abc32$export$59ae2c325a998f89.peek = $14745d21792abc32$var$peek;
function $14745d21792abc32$export$59ae2c325a998f89(node, _, state, info) {
    const exit = state.enter('phrasing');
    const value = state.containerPhrasing({
        type: 'root',
        children: [
            node
        ]
    }, info);
    exit();
    return value;
}
/**
 * Serialize a strong node as attention.
 *
 * @param {Strong} _
 *   Node to serialize.
 * @param {State} state
 *   Info passed around.
 * @returns {AttentionInfo}
 *   Info on how to serialize the node.
 */ function $14745d21792abc32$var$attention(_, state) {
    const marker = (0, $4faf7cd1e21bba8c$export$b7ce17905d66a6c3)(state);
    return {
        construct: 'strong',
        markers: marker === '*' ? [
            '*',
            '_'
        ] : [
            '_',
            '*'
        ],
        sizes: [
            2
        ]
    };
}
/**
 * Peek at this node.
 *
 * @param {Strong} _
 *   Node to serialize.
 * @param {Parents | undefined} _1
 *   Parent node.
 * @param {State} state
 *   Info passed around.
 * @returns {string}
 *   Start of the serialized markdown.
 */ function $14745d21792abc32$var$peek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * Serialize a text node.
 *
 * @param {Text} node
 *   Node to serialize.
 * @param {Parents | undefined} parent
 *   Parent node.
 * @param {State} state
 *   Info passed around.
 * @param {Info} info
 *   Info on surrounding context.
 * @returns {string}
 *   Serialized markdown.
 */ function $e648522db25f73a6$export$6f093cfa640b7166(node, parent, state, info) {
    /* c8 ignore next -- parent always passed */ const siblings = parent ? parent.children : [];
    const index = siblings.indexOf(node);
    return state.safe(node.value, {
        ...info,
        afterNode: siblings[index + 1],
        beforeNode: siblings[index - 1]
    });
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * Checks the preferred rule repetition option.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 *   Preferred rule repetition.
 */ function $891fd5b892408f17$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $f6462c8e8534ff43$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $f8475990a908ccae$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $891fd5b892408f17$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $274591dfb456c565$export$8f34ce051745d39e = {
    blockquote: $208370220e6c0d9f$export$67dc04e652a298ca,
    break: (0, $1c7dc10908f7b218$export$371da9dd35aba193),
    code: $ae9596198c520d70$export$6565f9f03506010b,
    definition: $3fd79b772b49f507$export$69f215ed977cdb73,
    emphasis: $2d0bdd047db1c10b$export$bef81ba411953b51,
    hardBreak: $1c7dc10908f7b218$export$371da9dd35aba193,
    heading: $199531ea000db40b$export$46e4a324ac90507f,
    html: $7036d6b7c8db1634$export$c0bb0b647f701bb5,
    image: $a46aa55a01bd5705$export$5c452ff88e35e47d,
    imageReference: $4ba5fdf85737364d$export$f281796f6bc3b8db,
    inlineCode: $58c38f342713f9c6$export$91b9bee19a0d8569,
    link: $3edfc89f7d1e2abc$export$9c30223ca0a664fb,
    linkReference: $559051d9468a184b$export$e6c469b1b7b2bc6a,
    list: $109feb8864e171b3$export$8837f4fc672e936d,
    listItem: $e0f09afb239a1374$export$76c7e83ecc9cdf05,
    paragraph: $20866ef1c959e2be$export$9c206ddddb32a9b,
    root: $026a73c96840b09c$export$e8e78c978b129247,
    strong: $14745d21792abc32$export$59ae2c325a998f89,
    text: $e648522db25f73a6$export$6f093cfa640b7166,
    thematicBreak: $f6462c8e8534ff43$export$ba7b13e047416c03
};


function $59758d12a47d69be$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $59758d12a47d69be$var$enterTable,
            tableData: $59758d12a47d69be$var$enterCell,
            tableHeader: $59758d12a47d69be$var$enterCell,
            tableRow: $59758d12a47d69be$var$enterRow
        },
        exit: {
            codeText: $59758d12a47d69be$var$exitCodeText,
            table: $59758d12a47d69be$var$exitTable,
            tableData: $59758d12a47d69be$var$exit,
            tableHeader: $59758d12a47d69be$var$exit,
            tableRow: $59758d12a47d69be$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $59758d12a47d69be$var$enterTable(token) {
    const align = token._align;
    (0, $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $59758d12a47d69be$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $59758d12a47d69be$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $59758d12a47d69be$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $59758d12a47d69be$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $59758d12a47d69be$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $59758d12a47d69be$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $59758d12a47d69be$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $59758d12a47d69be$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $ee3593332bd8700a$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $274591dfb456c565$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $def88fbb37579e2f$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $def88fbb37579e2f$var$exitCheck,
            taskListCheckValueUnchecked: $def88fbb37579e2f$var$exitCheck,
            paragraph: $def88fbb37579e2f$var$exitParagraphWithTaskListItem
        }
    };
}
function $def88fbb37579e2f$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $def88fbb37579e2f$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $def88fbb37579e2f$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $def88fbb37579e2f$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $b7e708ea4e32a5f1$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $def88fbb37579e2f$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $274591dfb456c565$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $ded245d0babdd0d0$export$95adae814eb7433e() {
    return [
        (0, $ae420235886a412d$export$b6afdfff2163546f)(),
        (0, $14e3c07398258ed1$export$c9d5ad4bdf6ff801)(),
        (0, $4b2149ec6bb2aa91$export$34d64e709dd0b9bb)(),
        (0, $59758d12a47d69be$export$8bd0ec8ecf6adb7d)(),
        (0, $def88fbb37579e2f$export$a427a608608b215f)()
    ];
}
function $ded245d0babdd0d0$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $ae420235886a412d$export$d3ace9096b01c39d)(),
            (0, $14e3c07398258ed1$export$3727766a73a6c09f)(options),
            (0, $4b2149ec6bb2aa91$export$1632835bd2c84956)(),
            (0, $59758d12a47d69be$export$dafcad76ea6e0045)(options),
            (0, $def88fbb37579e2f$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @import {Code, ConstructRecord, Event, Extension, Previous, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 
const $269276152a54547b$var$wwwPrefix = {
    tokenize: $269276152a54547b$var$tokenizeWwwPrefix,
    partial: true
};
const $269276152a54547b$var$domain = {
    tokenize: $269276152a54547b$var$tokenizeDomain,
    partial: true
};
const $269276152a54547b$var$path = {
    tokenize: $269276152a54547b$var$tokenizePath,
    partial: true
};
const $269276152a54547b$var$trail = {
    tokenize: $269276152a54547b$var$tokenizeTrail,
    partial: true
};
const $269276152a54547b$var$emailDomainDotTrail = {
    tokenize: $269276152a54547b$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $269276152a54547b$var$wwwAutolink = {
    name: 'wwwAutolink',
    tokenize: $269276152a54547b$var$tokenizeWwwAutolink,
    previous: $269276152a54547b$var$previousWww
};
const $269276152a54547b$var$protocolAutolink = {
    name: 'protocolAutolink',
    tokenize: $269276152a54547b$var$tokenizeProtocolAutolink,
    previous: $269276152a54547b$var$previousProtocol
};
const $269276152a54547b$var$emailAutolink = {
    name: 'emailAutolink',
    tokenize: $269276152a54547b$var$tokenizeEmailAutolink,
    previous: $269276152a54547b$var$previousEmail
};
/** @type {ConstructRecord} */ const $269276152a54547b$var$text = {};
function $269276152a54547b$export$608123d9b549151() {
    return {
        text: $269276152a54547b$var$text
    };
}
/** @type {Code} */ let $269276152a54547b$var$code = 48;
// Add alphanumerics.
while($269276152a54547b$var$code < 123){
    $269276152a54547b$var$text[$269276152a54547b$var$code] = $269276152a54547b$var$emailAutolink;
    $269276152a54547b$var$code++;
    if ($269276152a54547b$var$code === 58) $269276152a54547b$var$code = 65;
    else if ($269276152a54547b$var$code === 91) $269276152a54547b$var$code = 97;
}
$269276152a54547b$var$text[43] = $269276152a54547b$var$emailAutolink;
$269276152a54547b$var$text[45] = $269276152a54547b$var$emailAutolink;
$269276152a54547b$var$text[46] = $269276152a54547b$var$emailAutolink;
$269276152a54547b$var$text[95] = $269276152a54547b$var$emailAutolink;
$269276152a54547b$var$text[72] = [
    $269276152a54547b$var$emailAutolink,
    $269276152a54547b$var$protocolAutolink
];
$269276152a54547b$var$text[104] = [
    $269276152a54547b$var$emailAutolink,
    $269276152a54547b$var$protocolAutolink
];
$269276152a54547b$var$text[87] = [
    $269276152a54547b$var$emailAutolink,
    $269276152a54547b$var$wwwAutolink
];
$269276152a54547b$var$text[119] = [
    $269276152a54547b$var$emailAutolink,
    $269276152a54547b$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$269276152a54547b$var$gfmAtext(code) || !$269276152a54547b$var$previousEmail.call(self, self.previous) || $269276152a54547b$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkEmail');
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($269276152a54547b$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($269276152a54547b$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit('literalAutolinkEmail');
            effects.exit('literalAutolink');
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$269276152a54547b$var$previousWww.call(self, self.previous) || $269276152a54547b$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter('literalAutolink');
        effects.enter('literalAutolinkWww');
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($269276152a54547b$var$wwwPrefix, effects.attempt($269276152a54547b$var$domain, effects.attempt($269276152a54547b$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit('literalAutolinkWww');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = '';
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $269276152a54547b$var$previousProtocol.call(self, self.previous) && !$269276152a54547b$var$previousUnbalanced(self.events)) {
            effects.enter('literalAutolink');
            effects.enter('literalAutolinkHttp');
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === 'http' || protocol === 'https') {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $d11f122b7c6f306c$export$67dbf494fc8394df)(code) || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) || (0, $d11f122b7c6f306c$export$a0ff789c034ffdf4)(code) || (0, $d11f122b7c6f306c$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($269276152a54547b$var$domain, effects.attempt($269276152a54547b$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit('literalAutolinkHttp');
        effects.exit('literalAutolink');
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($269276152a54547b$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) || (0, $d11f122b7c6f306c$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $d11f122b7c6f306c$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($269276152a54547b$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) || (0, $d11f122b7c6f306c$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharacterReferenceStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) || (0, $d11f122b7c6f306c$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code) || (0, $d11f122b7c6f306c$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code) ? trailCharacterReferenceInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharacterReferenceInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharacterReferenceInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $269276152a54547b$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $269276152a54547b$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $269276152a54547b$var$previousProtocol(code) {
    return !(0, $d11f122b7c6f306c$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $269276152a54547b$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $269276152a54547b$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $269276152a54547b$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $d11f122b7c6f306c$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $269276152a54547b$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === 'labelLink' || token.type === 'labelImage') && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @import {CompileContext, Handle, HtmlExtension, Token} from 'micromark-util-types'
 */ 
function $5e8901276d0e4183$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $5e8901276d0e4183$var$literalAutolinkEmail,
            literalAutolinkHttp: $5e8901276d0e4183$var$literalAutolinkHttp,
            literalAutolinkWww: $5e8901276d0e4183$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $5e8901276d0e4183$var$literalAutolinkWww(token) {
    $5e8901276d0e4183$var$anchorFromToken.call(this, token, 'http://');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $5e8901276d0e4183$var$literalAutolinkEmail(token) {
    $5e8901276d0e4183$var$anchorFromToken.call(this, token, 'mailto:');
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $5e8901276d0e4183$var$literalAutolinkHttp(token) {
    $5e8901276d0e4183$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $5e8901276d0e4183$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $754f1136e796451a$export$d130a2d684099e5a)((protocol || '') + url) + '">');
    this.raw(this.encode(url));
    this.tag('</a>');
}


/**
 * @import {Event, Exiter, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 



const $ce64008e2a1d5a9f$var$indent = {
    tokenize: $ce64008e2a1d5a9f$var$tokenizeIndent,
    partial: true
};
function $ce64008e2a1d5a9f$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                name: 'gfmFootnoteDefinition',
                tokenize: $ce64008e2a1d5a9f$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $ce64008e2a1d5a9f$var$tokenizeDefinitionContinuation
                },
                exit: $ce64008e2a1d5a9f$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                name: 'gfmFootnoteCall',
                tokenize: $ce64008e2a1d5a9f$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                name: 'gfmPotentialFootnoteCall',
                add: 'after',
                tokenize: $ce64008e2a1d5a9f$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $ce64008e2a1d5a9f$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce64008e2a1d5a9f$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === 'gfmFootnoteCall' || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $ce64008e2a1d5a9f$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === 'enter') {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = 'gfmFootnoteCallLabelMarker';
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: 'gfmFootnoteCall',
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: 'gfmFootnoteCallMarker',
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: 'gfmFootnoteCallString',
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: 'string',
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            'enter',
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            'enter',
            marker,
            context
        ],
        [
            'exit',
            marker,
            context
        ],
        // Everything in between.
        [
            'enter',
            string,
            context
        ],
        [
            'enter',
            chunk,
            context
        ],
        [
            'exit',
            chunk,
            context
        ],
        [
            'exit',
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            'exit',
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce64008e2a1d5a9f$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteCall');
        effects.enter('gfmFootnoteCallLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallLabelMarker');
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter('gfmFootnoteCallMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteCallMarker');
        effects.enter('gfmFootnoteCallString');
        effects.enter('chunkString').contentType = 'string';
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteCallString');
            if (!defined.includes((0, $b372f6f49f82b482$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter('gfmFootnoteCallLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteCallLabelMarker');
            effects.exit('gfmFootnoteCall');
            return ok;
        }
        if (!(0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce64008e2a1d5a9f$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('gfmFootnoteDefinition')._container = true;
        effects.enter('gfmFootnoteDefinitionLabel');
        effects.enter('gfmFootnoteDefinitionLabelMarker');
        effects.consume(code);
        effects.exit('gfmFootnoteDefinitionLabelMarker');
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter('gfmFootnoteDefinitionMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionMarker');
            effects.enter('gfmFootnoteDefinitionLabelString');
            effects.enter('chunkString').contentType = 'string';
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit('chunkString');
            const token = effects.exit('gfmFootnoteDefinitionLabelString');
            identifier = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter('gfmFootnoteDefinitionLabelMarker');
            effects.consume(code);
            effects.exit('gfmFootnoteDefinitionLabelMarker');
            effects.exit('gfmFootnoteDefinitionLabel');
            return labelAfter;
        }
        if (!(0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, whitespaceAfter, 'gfmFootnoteDefinitionWhitespace');
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce64008e2a1d5a9f$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $a1b9554aac941323$export$d50d28ce3ab2a612), ok, effects.attempt($ce64008e2a1d5a9f$var$indent, ok, nok));
}
/** @type {Exiter} */ function $ce64008e2a1d5a9f$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit('gfmFootnoteDefinition');
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce64008e2a1d5a9f$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, afterPrefix, 'gfmFootnoteDefinitionIndent', 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'gfmFootnoteDefinitionIndent' && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @import {HtmlOptions as Options} from 'micromark-extension-gfm-footnote'
 * @import {HtmlExtension} from 'micromark-util-types'
 */ 

const $561e66b1016b72f2$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $561e66b1016b72f2$var$emptyOptions = {};
function $561e66b1016b72f2$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $561e66b1016b72f2$export$a731a1f6cf81900c(options) {
    const config = options || $561e66b1016b72f2$var$emptyOptions;
    const label = config.label || 'Footnotes';
    const labelTagName = config.labelTagName || 'h2';
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $561e66b1016b72f2$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? 'user-content-' : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData('tightStack');
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData('gfmFootnoteDefinitions');
                const footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                const tightStack = this.getData('tightStack');
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData('gfmFootnoteDefinitions', definitions = {});
                if (!$561e66b1016b72f2$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData('slurpOneLineEnding', true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData('lastWasTag');
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData('gfmFootnoteDefinitionStack');
                if (!footnoteStack) this.setData('gfmFootnoteDefinitionStack', footnoteStack = []);
                footnoteStack.push((0, $b372f6f49f82b482$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume(); // Drop the label.
                this.buffer(); // Get ready for a value.
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData('gfmFootnoteCallOrder');
                let counts = this.getData('gfmFootnoteCallCounts');
                const id = (0, $b372f6f49f82b482$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData('gfmFootnoteCallOrder', calls = []);
                if (!counts) this.setData('gfmFootnoteCallCounts', counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $754f1136e796451a$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + 'fn-' + safeId + '" id="' + clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : '') + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + '</a></sup>');
            },
            null () {
                const calls = this.getData('gfmFootnoteCallOrder') || [];
                const counts = this.getData('gfmFootnoteCallCounts') || {};
                const definitions = this.getData('gfmFootnoteDefinitions') || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? ' ' + labelAttributes : '') + '>');
                    this.raw(this.encode(label));
                    this.tag('</' + labelTagName + '>');
                    this.lineEndingIfNeeded();
                    this.tag('<ol>');
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $754f1136e796451a$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : '') + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === 'string' ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? '<sup>' + referenceIndex + '</sup>' : '') + '</a>');
                    const reference = references.join(' ');
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + 'fn-' + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return ' ' + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag('</li>');
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('</ol>');
                    this.lineEndingIfNeeded();
                    this.tag('</section>');
                }
            }
        }
    };
}


/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 


function $e60d89424986c0d5$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $e3feb7cc014b834a$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $4d2b06c615019ada$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $e3feb7cc014b834a$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $e3feb7cc014b834a$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $a28c56bcd12af494$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $a28c56bcd12af494$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $5bab534794bc677a$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag('<del>');
            }
        },
        exit: {
            strikethrough () {
                this.tag('</del>');
            }
        }
    };
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $401a1b51f4f9ae81$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
        /**
     * Changes by index, so `add` does not scan `map` (quadratic on
     * table-heavy documents).
     *
     * @type {Map<number, Change>}
     */ this.index = new Map();
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   *   Index at which to apply the edit.
   * @param {number} remove
   *   Count of items to remove at the index.
   * @param {Array<Event>} add
   *   Items to add at the index.
   * @returns {undefined}
   *   Nothing.
   */ add(index, remove, add) {
        $401a1b51f4f9ae81$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   *   List of events to apply the edits to.
   * @returns {undefined}
   *   Nothing.
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
        this.index.clear();
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 *   Edit map to apply to.
 * @param {number} at
 *   Index at which to apply the edit.
 * @param {number} remove
 *   Count of items to remove at the index.
 * @param {Array<Event>} add
 *   Items to add at the index.
 * @returns {undefined}
 *   Nothing.
 */ function $401a1b51f4f9ae81$var$addImplementation(editMap, at, remove, add) {
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    const existing = editMap.index.get(at);
    if (existing) {
        existing[1] += remove;
        // To do: before not used by tables, use when moving to micromark.
        // if (before) {
        //   add.push(...existing[2])
        //   existing[2] = add
        // } else {
        existing[2].push(...add);
        // }
        return;
    }
    /** @type {Change} */ const change = [
        at,
        remove,
        add
    ];
    editMap.map.push(change);
    editMap.index.set(at, change);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $106db27c914cc68d$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $dda9cbe83e52246e$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $dda9cbe83e52246e$var$tokenizeTable,
                resolveAll: $dda9cbe83e52246e$var$resolveTable
            }
        }
    };
}
/**
 * Tokenizer for GFM tables.
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $dda9cbe83e52246e$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const { type: type } = self.events[index][1];
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $dda9cbe83e52246e$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $401a1b51f4f9ae81$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $dda9cbe83e52246e$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $dda9cbe83e52246e$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $dda9cbe83e52246e$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $dda9cbe83e52246e$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $dda9cbe83e52246e$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $dda9cbe83e52246e$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $106db27c914cc68d$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 *   Edit map to apply to.
 * @param {Readonly<TokenizeContext>} context
 *   Tokenize context.
 * @param {Readonly<Range>} range
 *   Range of the cell within events.
 * @param {RowKind} rowKind
 *   Type of row.
 * @param {number | undefined} rowEnd
 *   Index of the end of the row, if known.
 * @param {Token | undefined} previousCell
 *   Previous cell token, if any.
 * @returns {Token | undefined}
 *   Current cell token after flushing, if any.
 */ // eslint-disable-next-line max-params
function $dda9cbe83e52246e$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $dda9cbe83e52246e$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $dda9cbe83e52246e$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $dda9cbe83e52246e$var$getPoint(context.events, range[2]);
        const relatedEnd = $dda9cbe83e52246e$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $dda9cbe83e52246e$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 *   Edit map to apply to.
 * @param {Readonly<TokenizeContext>} context
 *   Tokenize context.
 * @param {number} index
 *   Index within the events where the table end should be inserted.
 * @param {Token} table
 *   Table token.
 * @param {Token | undefined} tableBody
 *   Table body token, if any.
 * @returns {undefined}
 *   Nothing.
 */ // eslint-disable-next-line max-params
function $dda9cbe83e52246e$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $dda9cbe83e52246e$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * Get the point (start or end) for a given event in the list of events.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Index of the event to get the point for.
 * @returns {Readonly<Point>}
 *   Start point for enter and end point for exit.
 */ function $dda9cbe83e52246e$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ const $3dee1d0401a646f0$var$alignment = {
    none: '',
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $3dee1d0401a646f0$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag('<table>');
                this.setData('tableAlign', tableAlign);
            },
            tableBody () {
                this.tag('<tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $3dee1d0401a646f0$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag('<td' + align + '>');
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('<thead>');
            },
            tableHeader () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                const align = $3dee1d0401a646f0$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag('<th' + align + '>');
            },
            tableRow () {
                this.setData('tableColumn', 0);
                this.lineEndingIfNeeded();
                this.tag('<tr>');
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData('tableAlign')) value = value.replace(/\\([\\|])/g, $3dee1d0401a646f0$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData('tableAlign');
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData('slurpAllLineEndings');
                this.lineEndingIfNeeded();
                this.tag('</table>');
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag('</tbody>');
            },
            tableData () {
                const tableAlign = this.getData('tableAlign');
                const tableColumn = this.getData('tableColumn');
                if (tableColumn in tableAlign) {
                    this.tag('</td>');
                    this.setData('tableColumn', tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag('</thead>');
            },
            tableHeader () {
                const tableColumn = this.getData('tableColumn');
                this.tag('</th>');
                this.setData('tableColumn', tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData('tableAlign');
                let tableColumn = this.getData('tableColumn');
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag('<td' + $3dee1d0401a646f0$var$alignment[tableAlign[tableColumn]] + '></td>');
                    tableColumn++;
                }
                this.setData('tableColumn', tableColumn);
                this.lineEndingIfNeeded();
                this.tag('</tr>');
            }
        }
    };
}
/**
 * Replace escaped characters in table cells.
 *
 * @param {string} $0
 *   Whole.
 * @param {string} $1
 *   Escaped character (either a backslash or a pipe).
 * @returns {string}
 *   Replacement for the escaped character.
 */ function $3dee1d0401a646f0$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $37b7e177ee181a48$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $37b7e177ee181a48$var$reText = new RegExp('^' + $37b7e177ee181a48$var$reFlow.source, 'i');
function $37b7e177ee181a48$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $37b7e177ee181a48$var$exitHtmlData.call(this, token, $37b7e177ee181a48$var$reFlow);
            },
            htmlTextData (token) {
                $37b7e177ee181a48$var$exitHtmlData.call(this, token, $37b7e177ee181a48$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $37b7e177ee181a48$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, '&lt;$1$2');
    this.raw(this.encode(value));
}


/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 

const $e1fb2d6f375d075c$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $e1fb2d6f375d075c$var$tokenizeTasklistCheck
};
function $e1fb2d6f375d075c$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $e1fb2d6f375d075c$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e1fb2d6f375d075c$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $d11f122b7c6f306c$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $d11f122b7c6f306c$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $d11f122b7c6f306c$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $e1fb2d6f375d075c$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e1fb2d6f375d075c$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $db7e7aa13f3b4797$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @import {HtmlExtension} from 'micromark-util-types'
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $cad407b88e4d7384$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag('/>');
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $115baf83faffd886$export$59ffe8c4d7a4aab2(options) {
    return (0, $52b483885337c95b$export$86a865d89ef3c690)([
        (0, $269276152a54547b$export$608123d9b549151)(),
        (0, $ce64008e2a1d5a9f$export$c82499b6656305df)(),
        (0, $e60d89424986c0d5$export$8bbec8ea1400a00e)(options),
        (0, $dda9cbe83e52246e$export$e36cebda627bf2dd)(),
        (0, $e1fb2d6f375d075c$export$2912e8b2802475ff)()
    ]);
}
function $115baf83faffd886$export$6983b82e6105d62a(options) {
    return (0, $52b483885337c95b$export$eaf8c406dfb0a620)([
        (0, $5e8901276d0e4183$export$999603f1f1c3d2f9)(),
        (0, $561e66b1016b72f2$export$a731a1f6cf81900c)(options),
        (0, $5bab534794bc677a$export$58acedca46108820)(),
        (0, $3dee1d0401a646f0$export$c64626c032567c7f)(),
        (0, $37b7e177ee181a48$export$c9bf87ea36d00682)(),
        (0, $cad407b88e4d7384$export$4b6a13e2af1b08ed)()
    ]);
}





//#region component/renderer.ts
function $96dc340b88bdfa23$var$compileBlockquote(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Blockquote;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileBreak(ctx) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Break;
        }
    });
}
function $96dc340b88bdfa23$var$compileCode(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Code;
        },
        lang: node.lang,
        meta: node.meta,
        children: node.value
    });
}
function $96dc340b88bdfa23$var$compileDefinition(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Definition;
        },
        url: node.url,
        title: node.title,
        identifier: node.identifier,
        label: node.label
    });
}
function $96dc340b88bdfa23$var$compileDelete(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Delete;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileEmphasis(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Emphasis;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileFootnoteDefinition(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.FootnoteDefinition;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        },
        identifier: node.identifier,
        label: node.label
    });
}
function $96dc340b88bdfa23$var$compileFootnoteReference(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.FootnoteReference;
        },
        identifier: node.identifier,
        label: node.label
    });
}
function $96dc340b88bdfa23$var$compileHeading(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Heading;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        },
        id: ctx.slugger.slug($bc9bb30833cd7339$export$f84e8e69fd4488a5(node, {
            includeImageAlt: false
        })),
        depth: node.depth
    });
}
function $96dc340b88bdfa23$var$compileImage(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Image;
        },
        url: node.url,
        title: node.title,
        alt: node.alt
    });
}
function $96dc340b88bdfa23$var$compileImageReference(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.ImageReference;
        },
        identifier: node.identifier,
        label: node.label,
        alt: node.alt,
        referenceType: node.referenceType
    });
}
function $96dc340b88bdfa23$var$compileInlineCode(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.InlineCode;
        },
        children: node.value
    });
}
function $96dc340b88bdfa23$var$compileHTML(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.HTML;
        },
        children: node.value
    });
}
function $96dc340b88bdfa23$var$compileLink(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Link;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        },
        url: node.url,
        title: node.title
    });
}
function $96dc340b88bdfa23$var$compileLinkReference(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.LinkReference;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        },
        referenceType: node.referenceType,
        identifier: node.identifier,
        label: node.label
    });
}
function $96dc340b88bdfa23$var$compileList(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.List;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        },
        ordered: node.ordered,
        spread: node.spread,
        start: node.start
    });
}
function $96dc340b88bdfa23$var$compileListItem(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.ListItem;
        },
        checked: node.checked,
        spread: node.spread,
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileParagraph(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Paragraph;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileRoot(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Root;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileStrong(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Strong;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileTable(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.Table;
        },
        get children () {
            return node.children.map((value, i)=>$96dc340b88bdfa23$var$compileTableRow(ctx, value, i === 0));
        },
        align: node.align
    });
}
function $96dc340b88bdfa23$var$compileTableCell(ctx, node) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.TableCell;
        },
        get children () {
            return $96dc340b88bdfa23$var$renderContent(ctx, node.children);
        }
    });
}
function $96dc340b88bdfa23$var$compileTableRow(ctx, node, isHead) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.TableRow;
        },
        get children () {
            return node.children.map((value)=>$96dc340b88bdfa23$var$compileTableCell(ctx, value));
        },
        isHead: isHead
    });
}
function $96dc340b88bdfa23$var$compileThematicBreak(ctx) {
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
        get component () {
            return ctx.props.builtins.ThematicBreak;
        }
    });
}
function $96dc340b88bdfa23$var$compileNode(ctx, node) {
    const { type: type } = node;
    switch(node.type){
        case "blockquote":
            return $96dc340b88bdfa23$var$compileBlockquote(ctx, node);
        case "break":
            return $96dc340b88bdfa23$var$compileBreak(ctx);
        case "code":
            return $96dc340b88bdfa23$var$compileCode(ctx, node);
        case "definition":
            return $96dc340b88bdfa23$var$compileDefinition(ctx, node);
        case "delete":
            return $96dc340b88bdfa23$var$compileDelete(ctx, node);
        case "emphasis":
            return $96dc340b88bdfa23$var$compileEmphasis(ctx, node);
        case "footnoteDefinition":
            return $96dc340b88bdfa23$var$compileFootnoteDefinition(ctx, node);
        case "footnoteReference":
            return $96dc340b88bdfa23$var$compileFootnoteReference(ctx, node);
        case "heading":
            return $96dc340b88bdfa23$var$compileHeading(ctx, node);
        case "html":
            return $96dc340b88bdfa23$var$compileHTML(ctx, node);
        case "image":
            return $96dc340b88bdfa23$var$compileImage(ctx, node);
        case "imageReference":
            return $96dc340b88bdfa23$var$compileImageReference(ctx, node);
        case "inlineCode":
            return $96dc340b88bdfa23$var$compileInlineCode(ctx, node);
        case "link":
            return $96dc340b88bdfa23$var$compileLink(ctx, node);
        case "linkReference":
            return $96dc340b88bdfa23$var$compileLinkReference(ctx, node);
        case "list":
            return $96dc340b88bdfa23$var$compileList(ctx, node);
        case "listItem":
            return $96dc340b88bdfa23$var$compileListItem(ctx, node);
        case "paragraph":
            return $96dc340b88bdfa23$var$compileParagraph(ctx, node);
        case "root":
            return $96dc340b88bdfa23$var$compileRoot(ctx, node);
        case "strong":
            return $96dc340b88bdfa23$var$compileStrong(ctx, node);
        case "table":
            return $96dc340b88bdfa23$var$compileTable(ctx, node);
        case "tableCell":
            return $96dc340b88bdfa23$var$compileTableCell(ctx, node);
        case "tableRow":
            return $96dc340b88bdfa23$var$compileTableRow(ctx, node, false);
        case "text":
            return node.value;
        case "thematicBreak":
            return $96dc340b88bdfa23$var$compileThematicBreak(ctx);
        case "mdxFlowExpression":
        case "mdxJsxFlowElement":
        case "mdxJsxTextElement":
        case "mdxTextExpression":
        case "mdxjsEsm":
        case "toml":
        case "yaml":
            throw new Error(`<Markdown> does not support "${type}" nodes. Only CommonMark and GFM are supported at runtime; use the compiler for MDX and frontmatter.`);
        default:
            throw new Error(`Unknown mdast node type "${type}".`);
    }
}
function $96dc340b88bdfa23$var$renderContent(ctx, nodes) {
    return nodes.map((node)=>$96dc340b88bdfa23$var$compileNode(ctx, node));
}
//#endregion
//#region component/index.ts
/**
* Renders a Markdown string at runtime, through the same `builtins` the
* compiler targets.
*
* Use this when the source is only known at runtime. When the document is a
* file in your project, prefer the compiler and its bundler plugins: they do
* the parsing at build time and ship no parser to the browser.
*
* Only CommonMark and GFM are supported. MDX expressions and frontmatter are
* not parsed, and rendering a document that contains them throws. Raw HTML is
* passed to the `HTML` builtin as a string rather than being injected into the
* page.
*
* @example
* ```jsx
* <Markdown builtins={{ Blockquote: props => <blockquote>{props.children}</blockquote> }}>
*   {'> Hello'}
* </Markdown>
* ```
*/ function $96dc340b88bdfa23$export$2e2bcd8739ae039(props) {
    const ast = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>(0, $619c8c599176fa38$export$d744d789c09bfde6)(props.children, {
            extensions: [
                (0, $115baf83faffd886$export$59ffe8c4d7a4aab2)()
            ],
            mdastExtensions: [
                (0, $ded245d0babdd0d0$export$95adae814eb7433e)()
            ]
        }));
    return (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>$96dc340b88bdfa23$var$compileNode({
            props: props,
            slugger: new (0, $d6b3baa16b2246dc$export$2e2bcd8739ae039)()
        }, ast()));
}





var $c9ba532eab0ac5a8$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<blockquote>`), $c9ba532eab0ac5a8$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $c9ba532eab0ac5a8$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=code><pre>`), $c9ba532eab0ac5a8$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<s>`), $c9ba532eab0ac5a8$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<em>`), $c9ba532eab0ac5a8$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<img loading=lazy>`, true, false, false), $c9ba532eab0ac5a8$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<code>`), $c9ba532eab0ac5a8$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a>`), $c9ba532eab0ac5a8$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<ol>`), $c9ba532eab0ac5a8$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<ul>`), $c9ba532eab0ac5a8$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<li>`), $c9ba532eab0ac5a8$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p>`), $c9ba532eab0ac5a8$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=markdown dir=auto>`), $c9ba532eab0ac5a8$var$_tmpl$12 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $c9ba532eab0ac5a8$var$_tmpl$13 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<hr>`), $c9ba532eab0ac5a8$var$_tmpl$14 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<textarea dir=auto rows=10>`);
const $c9ba532eab0ac5a8$var$MarkdownRender = (props)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $96dc340b88bdfa23$export$2e2bcd8739ae039), {
        builtins: {
            Blockquote: (p)=>(()=>{
                    var _el$ = $c9ba532eab0ac5a8$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>p.children);
                    return _el$;
                })(),
            Break: ()=>$c9ba532eab0ac5a8$var$_tmpl$2(),
            Code: (p)=>(()=>{
                    var _el$3 = $c9ba532eab0ac5a8$var$_tmpl$3(), _el$4 = _el$3.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>p.children);
                    return _el$3;
                })(),
            Delete: (p)=>(()=>{
                    var _el$5 = $c9ba532eab0ac5a8$var$_tmpl$4();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>p.children);
                    return _el$5;
                })(),
            Emphasis: (p)=>(()=>{
                    var _el$6 = $c9ba532eab0ac5a8$var$_tmpl$5();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>p.children);
                    return _el$6;
                })(),
            Heading: (p)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
                    get component () {
                        return `h${p.depth + (props.level ?? 0)}`;
                    },
                    get children () {
                        return p.children;
                    }
                }),
            Image: (p)=>{
                const info = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
                    const image = props.images().get(p.url);
                    if (!image) return {};
                    const scale = (image.scale || 100) * 0.01;
                    const width = image.width ? image.width / scale : undefined;
                    const height = image.height ? image.height / scale : undefined;
                    return {
                        url: new URL(image.url, (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl).toString(),
                        scale: scale,
                        width: width,
                        height: height
                    };
                });
                return (()=>{
                    var _el$7 = $c9ba532eab0ac5a8$var$_tmpl$6();
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                        var _v$ = `${info().url} ${info().scale}x`, _v$2 = info().width, _v$3 = info().height, _v$4 = p.alt ?? undefined, _v$5 = p.title ?? undefined;
                        _v$ !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$7, "srcset", _p$.e = _v$);
                        _v$2 !== _p$.t && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$7, "width", _p$.t = _v$2);
                        _v$3 !== _p$.a && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$7, "height", _p$.a = _v$3);
                        _v$4 !== _p$.o && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$7, "alt", _p$.o = _v$4);
                        _v$5 !== _p$.i && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$7, "title", _p$.i = _v$5);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined,
                        a: undefined,
                        o: undefined,
                        i: undefined
                    });
                    return _el$7;
                })();
            },
            InlineCode: (p)=>(()=>{
                    var _el$8 = $c9ba532eab0ac5a8$var$_tmpl$7();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>p.children);
                    return _el$8;
                })(),
            Link: (p)=>(()=>{
                    var _el$9 = $c9ba532eab0ac5a8$var$_tmpl$8();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>p.children);
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                        var _v$6 = p.url, _v$7 = p.title ?? undefined, _v$8 = props.ugc ?? true ? 'ugc nofollow' : undefined, _v$9 = props.linkInNewTab ? '_blank' : undefined;
                        _v$6 !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$9, "href", _p$.e = _v$6);
                        _v$7 !== _p$.t && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$9, "title", _p$.t = _v$7);
                        _v$8 !== _p$.a && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$9, "rel", _p$.a = _v$8);
                        _v$9 !== _p$.o && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$9, "target", _p$.o = _v$9);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined,
                        a: undefined,
                        o: undefined
                    });
                    return _el$9;
                })(),
            List: (p)=>p.ordered ? (()=>{
                    var _el$0 = $c9ba532eab0ac5a8$var$_tmpl$9();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>p.children);
                    return _el$0;
                })() : (()=>{
                    var _el$1 = $c9ba532eab0ac5a8$var$_tmpl$0();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, ()=>p.children);
                    return _el$1;
                })(),
            ListItem: (p)=>(()=>{
                    var _el$10 = $c9ba532eab0ac5a8$var$_tmpl$1();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>p.children);
                    return _el$10;
                })(),
            Paragraph: (p)=>(()=>{
                    var _el$11 = $c9ba532eab0ac5a8$var$_tmpl$10();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, ()=>p.children);
                    return _el$11;
                })(),
            Root: (p)=>(()=>{
                    var _el$12 = $c9ba532eab0ac5a8$var$_tmpl$11();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, ()=>p.children);
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$12, "lang", props.lang()));
                    return _el$12;
                })(),
            Strong: (p)=>(()=>{
                    var _el$13 = $c9ba532eab0ac5a8$var$_tmpl$12();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>p.children);
                    return _el$13;
                })(),
            ThematicBreak: ()=>$c9ba532eab0ac5a8$var$_tmpl$13()
        },
        get children () {
            return props.markdown();
        }
    });
const $c9ba532eab0ac5a8$export$d5163f1ce1e6a5f9 = (props)=>{
    const images = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>(0, $9DGpR.Map)((props.markdown()?.images ?? []).map((image)=>[
                image.id,
                image
            ])));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($c9ba532eab0ac5a8$var$MarkdownRender, (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(props, {
        markdown: ()=>props.markdown()?.markdown ?? '',
        lang: ()=>props.markdown()?.lang,
        images: images
    }));
};
const $c9ba532eab0ac5a8$export$9a7d1eba5fa630bb = (props)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $96dc340b88bdfa23$export$2e2bcd8739ae039), {
        builtins: {
            Blockquote: (p)=>[
                    ' ',
                    (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>p.children),
                    ' '
                ],
            Break: ()=>' ',
            Code: (p)=>[
                    ' ',
                    (()=>{
                        var _el$15 = $c9ba532eab0ac5a8$var$_tmpl$7();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, ()=>p.children);
                        return _el$15;
                    })(),
                    ' '
                ],
            Delete: (p)=>(()=>{
                    var _el$16 = $c9ba532eab0ac5a8$var$_tmpl$4();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, ()=>p.children);
                    return _el$16;
                })(),
            Emphasis: (p)=>(()=>{
                    var _el$17 = $c9ba532eab0ac5a8$var$_tmpl$5();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, ()=>p.children);
                    return _el$17;
                })(),
            Heading: (p)=>[
                    ' ',
                    (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>p.children),
                    ' '
                ],
            Image: (p)=>' ',
            InlineCode: (p)=>(()=>{
                    var _el$18 = $c9ba532eab0ac5a8$var$_tmpl$7();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$18, ()=>p.children);
                    return _el$18;
                })(),
            Link: (p)=>p.children,
            List: (p)=>p.children,
            ListItem: (p)=>[
                    ' ',
                    (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>p.children),
                    ' '
                ],
            Paragraph: (p)=>[
                    ' ',
                    (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>p.children),
                    ' '
                ],
            Root: (p)=>(()=>{
                    var _el$19 = $c9ba532eab0ac5a8$var$_tmpl$11();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$19, ()=>p.children);
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                        var _v$0 = props.lang(), _v$1 = props.classList;
                        _v$0 !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$19, "lang", _p$.e = _v$0);
                        _p$.t = (0, $fb40d00dea10da1a$export$11c615ce16f87241)(_el$19, _v$1, _p$.t);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined
                    });
                    return _el$19;
                })(),
            Strong: (p)=>(()=>{
                    var _el$20 = $c9ba532eab0ac5a8$var$_tmpl$12();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, ()=>p.children);
                    return _el$20;
                })(),
            ThematicBreak: ()=>' '
        },
        get children () {
            return props.markdown();
        }
    });
const $c9ba532eab0ac5a8$export$18a9461578883ec4 = (props)=>{
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [markdown, setMarkdown] = props.markdown;
    const [lang, setLang] = props.lang;
    const [images, setImages] = props.images;
    let ref;
    return [
        (()=>{
            var _el$21 = $c9ba532eab0ac5a8$var$_tmpl$14();
            _el$21.addEventListener("paste", async (e)=>{
                // do not unnecessarily intercept paste event
                if (!props.projectId) return;
                if (!e.clipboardData) return;
                {
                    let hasFiles = false;
                    for (const item of e.clipboardData.items)if (item.kind == 'file') {
                        hasFiles = true;
                        break;
                    }
                    if (!hasFiles) return;
                }
                e.preventDefault();
                e.stopPropagation();
                for (const item of e.clipboardData.items){
                    const file = item.getAsFile();
                    if (!file) continue;
                    // convert image to JPEG via canvas
                    const imageBitmap = await createImageBitmap(file);
                    const imageWidth = imageBitmap.width;
                    const imageHeight = imageBitmap.height;
                    const imageScale = Math.floor(window.devicePixelRatio * 100);
                    const canvas = new OffscreenCanvas(imageBitmap.width, imageBitmap.height);
                    const context = canvas.getContext('bitmaprenderer');
                    context.transferFromImageBitmap(imageBitmap);
                    imageBitmap.close();
                    const fileJpeg = await canvas.convertToBlob({
                        type: 'image/jpeg'
                    });
                    // create content image on backend
                    const newContentImage = await api.postProjectsContentImages({
                        project: props.projectId,
                        requestBody: {
                            size: fileJpeg.size,
                            width: imageWidth,
                            height: imageHeight,
                            scale: imageScale
                        }
                    });
                    // add image to images map and markdown
                    setImages((images)=>{
                        const imageId = newContentImage.id;
                        ref.setRangeText(`![image](${imageId})`, ref.selectionStart, ref.selectionEnd, 'end');
                        return images.set(imageId, {
                            id: imageId,
                            width: imageWidth,
                            height: imageHeight,
                            scale: imageScale,
                            url: URL.createObjectURL(fileJpeg)
                        });
                    });
                    setMarkdown(ref.value);
                    // perform upload
                    let partToken;
                    let progress = 0, total = 0;
                    const hash = (0, $f710aae7717efd0b$export$c5411f1b08998578)(await crypto.subtle.digest('SHA-1', await fileJpeg.arrayBuffer()));
                    await new Promise((resolve, reject)=>{
                        const xhr = new XMLHttpRequest();
                        xhr.responseType = 'json';
                        xhr.addEventListener('error', reject);
                        xhr.addEventListener('load', ()=>{
                            if (xhr.status !== 200) return reject(xhr.response);
                            partToken = xhr.response;
                            resolve();
                        });
                        xhr.upload.addEventListener('progress', (e)=>{
                            if (e.lengthComputable) {
                                progress = Number(e.loaded);
                                total = Number(e.total);
                            }
                        });
                        xhr.open('PUT', (()=>{
                            const url = new URL(newContentImage.uploadInfo.uploadUrl, (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
                            url.searchParams.set('part', '0');
                            url.searchParams.set('hash', hash);
                            return url.toString();
                        })(), true);
                        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
                        // no Content-Length header, it's forbidden in browsers
                        xhr.send(fileJpeg);
                    });
                    // finalize image
                    const contentImage = await api.putProjectsContentImagesFinalize({
                        project: props.projectId,
                        contentImage: newContentImage.id,
                        requestBody: {
                            token: newContentImage.uploadInfo.token,
                            parts: [
                                partToken
                            ]
                        }
                    });
                    // replace image URL
                    setImages((images)=>images.update(contentImage.id, (image)=>{
                            URL.revokeObjectURL(image.url);
                            return {
                                ...image,
                                url: contentImage.url
                            };
                        }));
                }
            });
            _el$21.$$input = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                setMarkdown(ref.value);
            };
            var _ref$ = ref;
            typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$21) : ref = _el$21;
            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$21, "lang", lang()));
            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$21.value = markdown());
            return _el$21;
        })(),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($c9ba532eab0ac5a8$var$MarkdownRender, (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(props, {
            markdown: markdown,
            lang: lang,
            images: images
        }))
    ];
};
const $c9ba532eab0ac5a8$export$1302797fed163a3d = (props)=>{
    const info = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const image = props.image;
        if (!image) return {};
        const scale = (image.scale || 100) * 0.01;
        const width = image.width ? image.width / scale : undefined;
        const height = image.height ? image.height / scale : undefined;
        return {
            url: new URL(image.url, (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl).toString(),
            scale: scale,
            width: width,
            height: height
        };
    });
    return (()=>{
        var _el$22 = $c9ba532eab0ac5a8$var$_tmpl$6();
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
            var _v$10 = `${info().url} ${info().scale}x`, _v$11 = info().width, _v$12 = info().height;
            _v$10 !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$22, "srcset", _p$.e = _v$10);
            _v$11 !== _p$.t && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$22, "width", _p$.t = _v$11);
            _v$12 !== _p$.a && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$22, "height", _p$.a = _v$12);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined
        });
        return _el$22;
    })();
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "input"
]);




const $c900760615f37aa7$export$77c015370703bac0 = '/';
const $c900760615f37aa7$export$d7c176430feb555b = '/projects';
const $c900760615f37aa7$export$d9c91539b7b67f34 = (projectId)=>`${$c900760615f37aa7$export$d7c176430feb555b}/${encodeURIComponent(projectId)}`;
const $c900760615f37aa7$export$5be20f864ea0a7 = (projectId, branchId)=>`${$c900760615f37aa7$export$d9c91539b7b67f34(projectId)}/branches/${encodeURIComponent(branchId)}`;
const $c900760615f37aa7$export$18639e2046d399f4 = ({ projectId: projectId, branchId: branchId, versionId: versionId })=>`${branchId ? $c900760615f37aa7$export$5be20f864ea0a7(projectId, branchId) : $c900760615f37aa7$export$d9c91539b7b67f34(projectId)}/versions/${encodeURIComponent(versionId)}`;
const $c900760615f37aa7$export$2950deb3882ada89 = ({ projectId: projectId, branchId: branchId, versionId: versionId, packageId: packageId })=>`${versionId ? $c900760615f37aa7$export$18639e2046d399f4({
        projectId: projectId,
        branchId: branchId,
        versionId: versionId
    }) : $c900760615f37aa7$export$d9c91539b7b67f34(projectId)}/packages/${encodeURIComponent(packageId)}`;
const $c900760615f37aa7$export$9f23a95bf3723838 = ({ projectId: projectId, branchId: branchId, versionId: versionId, packageId: packageId })=>`${$c900760615f37aa7$export$2950deb3882ada89({
        projectId: projectId,
        branchId: branchId,
        versionId: versionId,
        packageId: packageId
    })}/play`;
const $c900760615f37aa7$export$84bf59898a10bb0e = (projectId)=>`${$c900760615f37aa7$export$d9c91539b7b67f34(projectId)}/manage`;
const $c900760615f37aa7$export$cb696d453077c584 = '/store';
const $c900760615f37aa7$export$4934a533ea20858c = (projectId)=>`${$c900760615f37aa7$export$cb696d453077c584}/${encodeURIComponent(projectId)}`;
const $c900760615f37aa7$export$cc14ff07bdae6b09 = ({ projectId: projectId, branchId: branchId, packageId: packageId })=>`${$c900760615f37aa7$export$4934a533ea20858c(projectId)}/${branchId}/${packageId}/play`;
const $c900760615f37aa7$export$eb19b69c8e69ef41 = '/me';
const $c900760615f37aa7$export$da49eb7703ea1c9c = '/local';
const $c900760615f37aa7$export$f6efd19c9704d3b1 = (token)=>`/invite?token=${encodeURIComponent(token)}`;
const $c900760615f37aa7$export$71079348ad5e9a97 = (lang)=>`/docs/${encodeURIComponent(lang)}/`;







var $50cc9f46f1065e3e$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $50cc9f46f1065e3e$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p>`), $50cc9f46f1065e3e$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $50cc9f46f1065e3e$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $50cc9f46f1065e3e$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<input type=text readonly>`), $50cc9f46f1065e3e$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=note>`), $50cc9f46f1065e3e$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class=input><div class=label></div><div class=input><input type=text>`);
const $50cc9f46f1065e3e$export$d91f9afde8dd3417 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui small dialog_ok",
        get onDefaultAction () {
            return props.resolve;
        },
        get children () {
            return [
                (()=>{
                    var _el$ = $50cc9f46f1065e3e$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>props.header);
                    return _el$;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return props.message;
                    },
                    get children () {
                        var _el$2 = $50cc9f46f1065e3e$var$_tmpl$2();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>props.message);
                        return _el$2;
                    }
                }),
                (()=>{
                    var _el$3 = $50cc9f46f1065e3e$var$_tmpl$3(), _el$4 = _el$3.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        autofocus: true,
                        onClick: ()=>props.resolve(),
                        get children () {
                            return props.ok ?? t('ok');
                        }
                    }));
                    return _el$3;
                })()
            ];
        }
    });
};
const $50cc9f46f1065e3e$export$84a13477b53beb51 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui small dialog_ok_copy",
        get onDefaultAction () {
            return props.resolve;
        },
        get children () {
            return [
                (()=>{
                    var _el$5 = $50cc9f46f1065e3e$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>props.header);
                    return _el$5;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return props.message;
                    },
                    get children () {
                        var _el$6 = $50cc9f46f1065e3e$var$_tmpl$4();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>props.message);
                        return _el$6;
                    }
                }),
                (()=>{
                    var _el$7 = $50cc9f46f1065e3e$var$_tmpl$5();
                    _el$7.$$click = (e)=>e.currentTarget.select();
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$7.value = props.text);
                    return _el$7;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                    onClick: ()=>navigator.clipboard.writeText(props.text),
                    get title () {
                        return t('copy');
                    },
                    get children () {
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            regular: true,
                            copy: true,
                            weak: true
                        });
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return props.note;
                    },
                    get children () {
                        var _el$8 = $50cc9f46f1065e3e$var$_tmpl$6();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>props.note);
                        return _el$8;
                    }
                }),
                (()=>{
                    var _el$9 = $50cc9f46f1065e3e$var$_tmpl$3(), _el$0 = _el$9.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        autofocus: true,
                        onClick: ()=>props.resolve(),
                        get children () {
                            return props.ok ?? t('ok');
                        }
                    }));
                    return _el$9;
                })()
            ];
        }
    });
};
const $50cc9f46f1065e3e$export$2cc85109a937009e = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui small dialog_confirm",
        onDefaultAction: ()=>{
            if ((props.focus ?? 'ok') == 'ok') props.resolve(true);
        },
        get children () {
            return [
                (()=>{
                    var _el$1 = $50cc9f46f1065e3e$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, ()=>props.header);
                    return _el$1;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return props.message;
                    },
                    get children () {
                        var _el$10 = $50cc9f46f1065e3e$var$_tmpl$2();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>props.message);
                        return _el$10;
                    }
                }),
                (()=>{
                    var _el$11 = $50cc9f46f1065e3e$var$_tmpl$3(), _el$12 = _el$11.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        get autofocus () {
                            return (props.focus ?? 'ok') == 'ok';
                        },
                        onClick: ()=>props.resolve(true),
                        get danger () {
                            return props.danger;
                        },
                        get children () {
                            return props.ok ?? t('ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        get autofocus () {
                            return props.focus == 'cancel';
                        },
                        onClick: ()=>props.resolve(false),
                        get children () {
                            return props.cancel ?? t('cancel');
                        }
                    }), null);
                    return _el$11;
                })()
            ];
        }
    });
};
const $50cc9f46f1065e3e$export$a551a871839880f9 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    let refTextBox;
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        if (props.value != null) refTextBox.value = props.value;
    });
    const resolve = ()=>{
        props.resolve(refTextBox.value);
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui small dialog_prompt",
        onDefaultAction: resolve,
        get children () {
            return [
                (()=>{
                    var _el$13 = $50cc9f46f1065e3e$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>props.header);
                    return _el$13;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return props.message;
                    },
                    get children () {
                        var _el$14 = $50cc9f46f1065e3e$var$_tmpl$4();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, ()=>props.message);
                        return _el$14;
                    }
                }),
                (()=>{
                    var _el$15 = $50cc9f46f1065e3e$var$_tmpl$7(), _el$16 = _el$15.firstChild, _el$17 = _el$16.nextSibling, _el$18 = _el$17.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, ()=>props.label);
                    var _ref$ = refTextBox;
                    typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$18) : refTextBox = _el$18;
                    return _el$15;
                })(),
                (()=>{
                    var _el$19 = $50cc9f46f1065e3e$var$_tmpl$3(), _el$20 = _el$19.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        type: "submit",
                        onClick: resolve,
                        get children () {
                            return props.ok ?? t('ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(undefined),
                        get children () {
                            return props.cancel ?? t('cancel');
                        }
                    }), null);
                    return _el$19;
                })()
            ];
        }
    });
};
const $50cc9f46f1065e3e$export$412ca83d4373e030 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        if (props.progress() === true) props.resolve(true);
    });
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui dialog_progress",
        onDefaultAction: ()=>props.resolve(false),
        get children () {
            return [
                (()=>{
                    var _el$21 = $50cc9f46f1065e3e$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$21, ()=>props.header);
                    return _el$21;
                })(),
                (()=>{
                    var _el$22 = $50cc9f46f1065e3e$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$22, ()=>props.message);
                    return _el$22;
                })(),
                (()=>{
                    var _el$23 = $50cc9f46f1065e3e$var$_tmpl$3(), _el$24 = _el$23.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$24, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(false),
                        get children () {
                            return props.cancel ?? t('cancel');
                        }
                    }));
                    return _el$23;
                })()
            ];
        }
    });
};
const $50cc9f46f1065e3e$export$51cf5ecd26e8f6e1 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui dialog_error",
        onDefaultAction: ()=>props.resolve(true),
        get children () {
            return [
                (()=>{
                    var _el$25 = $50cc9f46f1065e3e$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$25, ()=>props.header ?? t('error_dialog.header'));
                    return _el$25;
                })(),
                (()=>{
                    var _el$26 = $50cc9f46f1065e3e$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$26, (()=>{
                        var _c$ = (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!props.messageFunc);
                        return ()=>_c$() ? props.messageFunc(props.error) : props.message ?? t('error_dialog.messageFunc')(props.error);
                    })());
                    return _el$26;
                })(),
                (()=>{
                    var _el$27 = $50cc9f46f1065e3e$var$_tmpl$3(), _el$28 = _el$27.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$28, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                        get when () {
                            return props.showRetry;
                        },
                        get children () {
                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                onClick: ()=>props.resolve(true),
                                get children () {
                                    return props.retry ?? t('retry');
                                }
                            });
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$28, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(false),
                        get children () {
                            return props.ok ?? t('ok');
                        }
                    }), null);
                    return _el$27;
                })()
            ];
        }
    });
};
const $50cc9f46f1065e3e$export$7bee16e1df2fc42f = async (scope, props = {})=>{
    for(;;)try {
        return await scope();
    } catch (error) {
        console.log(error);
        if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)($50cc9f46f1065e3e$export$51cf5ecd26e8f6e1, {
            ...props,
            error: String(error)
        })) break;
    }
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);





var $90a968331396b18a$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $90a968331396b18a$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><div class=label></div><div class=input>`), $90a968331396b18a$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`);
const $90a968331396b18a$export$d9cbda9e2d7f4908 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { session: session } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { callLocalApi: callLocalApi, workspaces: workspaces, workdirs: workdirs } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $30026173677b80c4$export$ecd60d42f6b10f45));
    const [selectedWorkspace, setSelectedWorkspace] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(async ()=>{
        const userId = session()?.userInfo?.id;
        if (!userId) return;
        const workspaceId = Number.parseInt(localStorage.getItem('last_install_workspace_id') ?? '-1');
        const workspacesList = workspaces() ?? [];
        const workspace = workspacesList[workspaceId] ?? workspacesList[0];
        if (selectedWorkspace()) return;
        setSelectedWorkspace(workspace);
    });
    const [selectedWorkdir, setSelectedWorkdir] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const workdirTitle = (workdir)=>workdir ? `${workdir.project_title} - ${workdir.branch_title} - ${workdir.version_title} - ${workdir.package_title}` : t('packages.install_dialog.workdir.value.new');
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui big install_package",
        get children () {
            return [
                (()=>{
                    var _el$ = $90a968331396b18a$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('packages.install_dialog.header'));
                    return _el$;
                })(),
                (()=>{
                    var _el$2 = $90a968331396b18a$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>t('packages.install_dialog.workdir.label'));
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                        get items () {
                            return [
                                {
                                    key: undefined,
                                    title: t('packages.install_dialog.workdir.value.new')
                                },
                                ...(workdirs() ?? []).map((workdir)=>({
                                        key: workdir,
                                        title: workdirTitle(workdir)
                                    }))
                            ];
                        },
                        get title () {
                            return workdirTitle(selectedWorkdir());
                        },
                        onSelect: setSelectedWorkdir
                    }));
                    return _el$2;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return !selectedWorkdir();
                    },
                    get children () {
                        var _el$5 = $90a968331396b18a$var$_tmpl$2(), _el$6 = _el$5.firstChild, _el$7 = _el$6.nextSibling;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t('packages.install_dialog.workspace.label'));
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                            get items () {
                                return (workspaces() ?? []).map((workspace)=>({
                                        key: workspace,
                                        title: workspace.local_path
                                    }));
                            },
                            get title () {
                                return selectedWorkspace()?.local_path ?? t('packages.install_dialog.workspace.placeholder');
                            },
                            onSelect: setSelectedWorkspace
                        }));
                        return _el$5;
                    }
                }),
                (()=>{
                    var _el$8 = $90a968331396b18a$var$_tmpl$3(), _el$9 = _el$8.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>{
                            const selectedWorkdirValue = selectedWorkdir();
                            const selectedWorkspaceValue = selectedWorkspace();
                            if (!selectedWorkdirValue && selectedWorkspaceValue) localStorage.setItem('last_install_workspace_id', selectedWorkspaceValue.id.toString());
                            props.resolve({
                                workdir: selectedWorkdirValue,
                                workspace: selectedWorkspaceValue
                            });
                        },
                        get disabled () {
                            return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!!selectedWorkdir())() && !selectedWorkspace();
                        },
                        get children () {
                            return t('packages.install_dialog.ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(),
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$8;
                })()
            ];
        }
    });
};






var $9DGpR = parcelRequire("9DGpR");

var $bcd7d00b4653a471$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a>`);
const $bcd7d00b4653a471$export$6211eac7eca08002 = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)();
const $bcd7d00b4653a471$export$55185c17a0fcbe46 = (props)=>{
    const [location, setLocation] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(window.location, {
        equals: false
    });
    const path = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>location().pathname.slice(1).split('/').map(decodeURIComponent));
    const [hierarchy, setHierarchy] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((0, $9DGpR.List)());
    const navigate = (path, options)=>{
        if (new URL(path, window.location.href).href == window.location.href) return;
        if (options?.replace) window.history.replaceState(null, '', path);
        else window.history.pushState(null, '', path);
        if (options?.reload) window.location.reload();
        setLocation(window.location);
    };
    window.addEventListener('popstate', (e)=>{
        setLocation(window.location);
    });
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($bcd7d00b4653a471$export$6211eac7eca08002.Provider, {
        value: {
            path: path,
            level: 0,
            hierarchy: hierarchy,
            setHierarchy: setHierarchy,
            navigate: navigate
        },
        get children () {
            return props.children;
        }
    });
};
const $bcd7d00b4653a471$export$ce35e825083c5f92 = ()=>{
    const context = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($bcd7d00b4653a471$export$6211eac7eca08002);
    return (path)=>{
        const pathPieces = context.path();
        if (path === '') return context.level == pathPieces.length || context.level < pathPieces.length && pathPieces[context.level] == '';
        return context.level < pathPieces.length && (!path || pathPieces[context.level] == path);
    };
};
const $bcd7d00b4653a471$export$3565eb3d00ca5a74 = (props)=>{
    const context = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($bcd7d00b4653a471$export$6211eac7eca08002);
    const routingMatch = $bcd7d00b4653a471$export$ce35e825083c5f92();
    const rec = (i)=>{
        if (i >= props.routes.length) return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
            get component () {
                return props.fallback;
            }
        });
        const route = props.routes[i];
        const match = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>routingMatch(route.path));
        return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>(0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!match())() ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($bcd7d00b4653a471$export$6211eac7eca08002.Provider, {
                get value () {
                    return {
                        path: context.path,
                        level: context.level + 1,
                        hierarchy: context.hierarchy,
                        setHierarchy: context.setHierarchy,
                        navigate: context.navigate
                    };
                },
                get children () {
                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
                        get component () {
                            return route.component;
                        },
                        get route () {
                            return context.path()[context.level];
                        }
                    });
                }
            }) : rec(i + 1));
    };
    return rec(0);
};
const $bcd7d00b4653a471$export$2b3a76f83deeece4 = ()=>{
    const context = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($bcd7d00b4653a471$export$6211eac7eca08002);
    return (path, options)=>context.navigate(path, options);
};
const $bcd7d00b4653a471$export$a6c7ac8248d6e38a = (props)=>{
    const navigate = $bcd7d00b4653a471$export$2b3a76f83deeece4();
    const onClick = (e)=>{
        e.preventDefault();
        navigate(e.currentTarget.href);
    };
    return (()=>{
        var _el$ = $bcd7d00b4653a471$var$_tmpl$();
        _el$.$$click = onClick;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>props.children);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
            var _v$ = props.href, _v$2 = props.class;
            _v$ !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "href", _p$.e = _v$);
            _v$2 !== _p$.t && (0, $fb40d00dea10da1a$export$2913c0c0b5623090)(_el$, _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        return _el$;
    })();
};
const $bcd7d00b4653a471$export$e2e9b8b5e72b52f3 = (props)=>{
    const context = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($bcd7d00b4653a471$export$6211eac7eca08002);
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        context.setHierarchy((hierarchy)=>hierarchy.push({
                title: ()=>props.title,
                breadcrumb: props.breadcrumb,
                breadcrumbRoot: props.breadcrumbRoot,
                uiClass: props.uiClass,
                sidelinks: props.sidelinks
            }));
    });
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        context.setHierarchy((hierarchy)=>hierarchy.pop());
    });
    return null;
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);


const $4cadc02efe646f32$export$a41f7b788abf9c93 = (props)=>{
    const { api: api, session: session } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { connected: connected, callLocalApi: callLocalApi, workdirs: workdirs, refreshWorkdirs: refreshWorkdirs, transition: transition, refreshTransition: refreshTransition } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $30026173677b80c4$export$ecd60d42f6b10f45));
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const navigate = (0, $bcd7d00b4653a471$export$2b3a76f83deeece4)();
    const findSingleWorkdir = (pred)=>(0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
            const workdirsList = workdirs();
            if (workdirsList == null) return;
            let singleWorkdir;
            for (const workdir of workdirsList)if (pred(workdir)) {
                if (singleWorkdir) return;
                singleWorkdir = workdir;
            }
            return singleWorkdir;
        });
    const launchWorkdir = findSingleWorkdir((workdir)=>props.project.id == workdir.project_id && props.pkg.id == workdir.package_id);
    const updateWorkdir = findSingleWorkdir((workdir)=>!!props.branch?.id && props.project.id == workdir.project_id && props.branch.id == workdir.branch_id);
    const actions = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const actions = [];
        if (props.pkg.tags.indexOf('os:web') >= 0) actions.push({
            title: t('packages.play'),
            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                solid: true,
                play: true,
                weak: true,
                inline: true
            }),
            onAction: ()=>{
                navigate((0, $c900760615f37aa7$export$9f23a95bf3723838)({
                    projectId: props.project.id,
                    branchId: props.branch?.id,
                    versionId: props.version?.id,
                    packageId: props.pkg.id
                }));
            }
        });
        if (connected()) {
            const launchWorkdirInfo = launchWorkdir();
            if (launchWorkdirInfo) {
                // if this workdir is actually transitioning now
                const transitionStatus = transition();
                if (transitionStatus?.workdir?.id == launchWorkdirInfo.id) actions.push({
                    title: `${(transitionStatus.done / transitionStatus.total * 100).toFixed(0)}%`,
                    icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        solid: true,
                        download: true,
                        weak: true,
                        inline: true
                    }),
                    onAction: ()=>{}
                });
                else actions.push({
                    title: t('packages.launch'),
                    icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        solid: true,
                        play: true,
                        weak: true,
                        inline: true
                    }),
                    onAction: ()=>{}
                });
            }
            if (updateWorkdir()) actions.push({
                title: t('packages.update'),
                icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                    solid: true,
                    rotate: true,
                    weak: true,
                    inline: true
                }),
                onAction: ()=>{}
            });
            actions.push({
                title: t('packages.install'),
                icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                    solid: true,
                    "cloud-arrow-down": true,
                    weak: true,
                    inline: true
                }),
                onAction: ()=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                        const result = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $90a968331396b18a$export$d9cbda9e2d7f4908), {
                            project: props.project,
                            branch: props.branch,
                            version: props.version,
                            pkg: props.pkg
                        });
                        if (!result) return;
                        const packageInfo = await api.getProjectsPackages1({
                            project: props.project.id,
                            _package: props.pkg.id
                        });
                        const packageUrl = new URL(await api.getProjectsPackagesDownload({
                            project: props.project.id,
                            _package: props.pkg.id
                        }), (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
                        let workdirId = result.workdir?.id;
                        if (!workdirId) workdirId = await callLocalApi('workdir_add', {
                            workspace: result.workspace.id,
                            name: props.project.id
                        });
                        await callLocalApi('workdir_transition', {
                            id: workdirId,
                            package_url: packageUrl,
                            project_id: props.project.id,
                            branch_id: props.branch?.id,
                            version_id: props.version?.id,
                            package_id: props.pkg.id,
                            project_title: props.project.title,
                            branch_title: props.branch?.title,
                            version_title: props.version?.title,
                            package_title: props.pkg.title,
                            package_size: packageInfo.size,
                            package_entrypoint: packageInfo.entrypoint
                        });
                        refreshWorkdirs();
                        refreshTransition();
                    })
            });
        }
        actions.push({
            title: t('packages.download_zip'),
            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                solid: true,
                "file-zipper": true,
                weak: true,
                inline: true
            }),
            onAction: ()=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                    const url = new URL(await api.getProjectsPackagesDownload({
                        project: props.project.id,
                        _package: props.pkg.id
                    }), (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
                    url.searchParams.set('filter', 'zip');
                    const link = document.createElement('a');
                    link.href = url.toString();
                    link.download = `${props.project.title} ${props.pkg.title}.zip`;
                    link.click();
                })
        });
        if ((0, $1ded0b9f0137d849$export$2e2bcd8739ae039).supportTorrentDownloads) actions.push({
            title: t('packages.download_torrent'),
            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                solid: true,
                magnet: true,
                weak: true,
                inline: true
            }),
            onAction: ()=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                    const url = new URL(await api.getProjectsPackagesTorrent({
                        project: props.project.id,
                        _package: props.pkg.id
                    }), (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
                    const link = document.createElement('a');
                    link.href = url.toString();
                    link.download = `${props.project.title} ${props.pkg.title}.torrent`;
                    link.click();
                })
        });
        return actions;
    });
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$d5503927a7d116d), {
        get actions () {
            return actions();
        }
    });
};



// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ class $f3842ea939e9c33f$var$LuxonError extends Error {
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$InvalidDateTimeError extends $f3842ea939e9c33f$var$LuxonError {
    constructor(reason){
        super(`Invalid DateTime: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$InvalidIntervalError extends $f3842ea939e9c33f$var$LuxonError {
    constructor(reason){
        super(`Invalid Interval: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$InvalidDurationError extends $f3842ea939e9c33f$var$LuxonError {
    constructor(reason){
        super(`Invalid Duration: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$ConflictingSpecificationError extends $f3842ea939e9c33f$var$LuxonError {
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$InvalidUnitError extends $f3842ea939e9c33f$var$LuxonError {
    constructor(unit){
        super(`Invalid unit ${unit}`);
    }
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$InvalidArgumentError extends $f3842ea939e9c33f$var$LuxonError {
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$ZoneIsAbstractError extends $f3842ea939e9c33f$var$LuxonError {
    constructor(){
        super("Zone is an abstract class");
    }
}
/**
 * @private
 */ const $f3842ea939e9c33f$var$n = "numeric", $f3842ea939e9c33f$var$s = "short", $f3842ea939e9c33f$var$l = "long";
const $f3842ea939e9c33f$var$DATE_SHORT = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$n,
    day: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATE_MED = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$s,
    day: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATE_MED_WITH_WEEKDAY = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$s,
    day: $f3842ea939e9c33f$var$n,
    weekday: $f3842ea939e9c33f$var$s
};
const $f3842ea939e9c33f$var$DATE_FULL = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$l,
    day: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATE_HUGE = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$l,
    day: $f3842ea939e9c33f$var$n,
    weekday: $f3842ea939e9c33f$var$l
};
const $f3842ea939e9c33f$var$TIME_SIMPLE = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$TIME_WITH_SECONDS = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$TIME_WITH_SHORT_OFFSET = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n,
    timeZoneName: $f3842ea939e9c33f$var$s
};
const $f3842ea939e9c33f$var$TIME_WITH_LONG_OFFSET = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n,
    timeZoneName: $f3842ea939e9c33f$var$l
};
const $f3842ea939e9c33f$var$TIME_24_SIMPLE = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    hourCycle: "h23"
};
const $f3842ea939e9c33f$var$TIME_24_WITH_SECONDS = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n,
    hourCycle: "h23"
};
const $f3842ea939e9c33f$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n,
    hourCycle: "h23",
    timeZoneName: $f3842ea939e9c33f$var$s
};
const $f3842ea939e9c33f$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n,
    hourCycle: "h23",
    timeZoneName: $f3842ea939e9c33f$var$l
};
const $f3842ea939e9c33f$var$DATETIME_SHORT = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$n,
    day: $f3842ea939e9c33f$var$n,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$n,
    day: $f3842ea939e9c33f$var$n,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATETIME_MED = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$s,
    day: $f3842ea939e9c33f$var$n,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATETIME_MED_WITH_SECONDS = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$s,
    day: $f3842ea939e9c33f$var$n,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$s,
    day: $f3842ea939e9c33f$var$n,
    weekday: $f3842ea939e9c33f$var$s,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n
};
const $f3842ea939e9c33f$var$DATETIME_FULL = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$l,
    day: $f3842ea939e9c33f$var$n,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    timeZoneName: $f3842ea939e9c33f$var$s
};
const $f3842ea939e9c33f$var$DATETIME_FULL_WITH_SECONDS = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$l,
    day: $f3842ea939e9c33f$var$n,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n,
    timeZoneName: $f3842ea939e9c33f$var$s
};
const $f3842ea939e9c33f$var$DATETIME_HUGE = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$l,
    day: $f3842ea939e9c33f$var$n,
    weekday: $f3842ea939e9c33f$var$l,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    timeZoneName: $f3842ea939e9c33f$var$l
};
const $f3842ea939e9c33f$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $f3842ea939e9c33f$var$n,
    month: $f3842ea939e9c33f$var$l,
    day: $f3842ea939e9c33f$var$n,
    weekday: $f3842ea939e9c33f$var$l,
    hour: $f3842ea939e9c33f$var$n,
    minute: $f3842ea939e9c33f$var$n,
    second: $f3842ea939e9c33f$var$n,
    timeZoneName: $f3842ea939e9c33f$var$l
};
/**
 * @interface
 */ class $f3842ea939e9c33f$export$96f93b933c2401c7 {
    /**
   * The type of zone
   * @abstract
   * @type {string}
   */ get type() {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
    /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */ get name() {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
    /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */ get ianaName() {
        return this.name;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */ get isUniversal() {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, opts) {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
    /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
    /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
    /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ get isValid() {
        throw new $f3842ea939e9c33f$var$ZoneIsAbstractError();
    }
}
let $f3842ea939e9c33f$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ class $f3842ea939e9c33f$export$e517f35950cc518a extends $f3842ea939e9c33f$export$96f93b933c2401c7 {
    /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */ static get instance() {
        if ($f3842ea939e9c33f$var$singleton$1 === null) $f3842ea939e9c33f$var$singleton$1 = new $f3842ea939e9c33f$export$e517f35950cc518a();
        return $f3842ea939e9c33f$var$singleton$1;
    }
    /** @override **/ get type() {
        return "system";
    }
    /** @override **/ get name() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName(ts, { format: format, locale: locale }) {
        return $f3842ea939e9c33f$var$parseZoneInfo(ts, format, locale);
    }
    /** @override **/ formatOffset(ts, format) {
        return $f3842ea939e9c33f$var$formatOffset(this.offset(ts), format);
    }
    /** @override **/ offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "system";
    }
    /** @override **/ get isValid() {
        return true;
    }
}
const $f3842ea939e9c33f$var$dtfCache = new Map();
function $f3842ea939e9c33f$var$makeDTF(zoneName) {
    let dtf = $f3842ea939e9c33f$var$dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        $f3842ea939e9c33f$var$dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
const $f3842ea939e9c33f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $f3842ea939e9c33f$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $f3842ea939e9c33f$var$partsOffset(dtf, date) {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for(let i = 0; i < formatted.length; i++){
        const { type: type, value: value } = formatted[i];
        const pos = $f3842ea939e9c33f$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$f3842ea939e9c33f$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
const $f3842ea939e9c33f$var$ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ class $f3842ea939e9c33f$export$1204b37d5bf67239 extends $f3842ea939e9c33f$export$96f93b933c2401c7 {
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ static create(name) {
        let zone = $f3842ea939e9c33f$var$ianaZoneCache.get(name);
        if (zone === undefined) $f3842ea939e9c33f$var$ianaZoneCache.set(name, zone = new $f3842ea939e9c33f$export$1204b37d5bf67239(name));
        return zone;
    }
    /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCache() {
        $f3842ea939e9c33f$var$ianaZoneCache.clear();
        $f3842ea939e9c33f$var$dtfCache.clear();
    }
    /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ static isValidSpecifier(s) {
        return this.isValidZone(s);
    }
    /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ static isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(name){
        super();
        /** @private **/ this.zoneName = name;
        /** @private **/ this.valid = $f3842ea939e9c33f$export$1204b37d5bf67239.isValidZone(name);
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ get type() {
        return "iana";
    }
    /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */ get name() {
        return this.zoneName;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return false;
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, { format: format, locale: locale }) {
        return $f3842ea939e9c33f$var$parseZoneInfo(ts, format, locale, this.name);
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return $f3842ea939e9c33f$var$formatOffset(this.offset(ts), format);
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        if (!this.valid) return NaN;
        const date = new Date(ts);
        if (isNaN(date)) return NaN;
        const dtf = $f3842ea939e9c33f$var$makeDTF(this.name);
        let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? $f3842ea939e9c33f$var$partsOffset(dtf, date) : $f3842ea939e9c33f$var$hackyOffset(dtf, date);
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        const adjustedHour = hour === 24 ? 0 : hour;
        const asUTC = $f3842ea939e9c33f$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        let asTS = +date;
        const over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    }
    /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    }
    /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return this.valid;
    }
}
// todo - remap caching
let $f3842ea939e9c33f$var$intlLFCache = {};
function $f3842ea939e9c33f$var$getCachedLF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $f3842ea939e9c33f$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $f3842ea939e9c33f$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
const $f3842ea939e9c33f$var$intlDTCache = new Map();
function $f3842ea939e9c33f$var$getCachedDTF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $f3842ea939e9c33f$var$intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $f3842ea939e9c33f$var$intlDTCache.set(key, dtf);
    }
    return dtf;
}
const $f3842ea939e9c33f$var$intlNumCache = new Map();
function $f3842ea939e9c33f$var$getCachedINF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let inf = $f3842ea939e9c33f$var$intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        $f3842ea939e9c33f$var$intlNumCache.set(key, inf);
    }
    return inf;
}
const $f3842ea939e9c33f$var$intlRelCache = new Map();
function $f3842ea939e9c33f$var$getCachedRTF(locString, opts = {}) {
    const { base: base, ...cacheKeyOpts } = opts; // exclude `base` from the options
    const key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    let inf = $f3842ea939e9c33f$var$intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $f3842ea939e9c33f$var$intlRelCache.set(key, inf);
    }
    return inf;
}
let $f3842ea939e9c33f$var$sysLocaleCache = null;
function $f3842ea939e9c33f$var$systemLocale() {
    if ($f3842ea939e9c33f$var$sysLocaleCache) return $f3842ea939e9c33f$var$sysLocaleCache;
    else {
        $f3842ea939e9c33f$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $f3842ea939e9c33f$var$sysLocaleCache;
    }
}
const $f3842ea939e9c33f$var$intlResolvedOptionsCache = new Map();
function $f3842ea939e9c33f$var$getCachedIntResolvedOptions(locString) {
    let opts = $f3842ea939e9c33f$var$intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        $f3842ea939e9c33f$var$intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
const $f3842ea939e9c33f$var$weekInfoCache = new Map();
function $f3842ea939e9c33f$var$getCachedWeekInfo(locString) {
    let data = $f3842ea939e9c33f$var$weekInfoCache.get(locString);
    if (!data) {
        const locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = {
            ...$f3842ea939e9c33f$var$fallbackWeekSettings,
            ...data
        };
        $f3842ea939e9c33f$var$weekInfoCache.set(locString, data);
    }
    return data;
}
function $f3842ea939e9c33f$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    const xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    const uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        let options;
        let selectedStr;
        try {
            options = $f3842ea939e9c33f$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            const smaller = localeStr.substring(0, uIndex);
            options = $f3842ea939e9c33f$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        const { numberingSystem: numberingSystem, calendar: calendar } = options;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $f3842ea939e9c33f$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += `-ca-${outputCalendar}`;
        if (numberingSystem) localeStr += `-nu-${numberingSystem}`;
        return localeStr;
    } else return localeStr;
}
function $f3842ea939e9c33f$var$mapMonths(f) {
    const ms = [];
    for(let i = 1; i <= 12; i++){
        const dt = $f3842ea939e9c33f$export$82f9ebd9adeba146.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $f3842ea939e9c33f$var$mapWeekdays(f) {
    const ms = [];
    for(let i = 1; i <= 7; i++){
        const dt = $f3842ea939e9c33f$export$82f9ebd9adeba146.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $f3842ea939e9c33f$var$listStuff(loc, length, englishFn, intlFn) {
    const mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $f3842ea939e9c33f$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $f3842ea939e9c33f$var$getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$PolyNumberFormatter {
    constructor(intl, forceSimple, opts){
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        const { padTo: padTo, floor: floor, ...otherOpts } = opts;
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            const intlOpts = {
                useGrouping: false,
                ...opts
            };
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $f3842ea939e9c33f$var$getCachedINF(intl, intlOpts);
        }
    }
    format(i) {
        if (this.inf) {
            const fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            const fixed = this.floor ? Math.floor(i) : $f3842ea939e9c33f$var$roundTo(i, 3);
            return $f3842ea939e9c33f$var$padStart(fixed, this.padTo);
        }
    }
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$PolyDateFormatter {
    constructor(dt, intl, opts){
        this.opts = opts;
        this.originalZone = undefined;
        let z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            const gmtOffset = -1 * (dt.offset / 60);
            const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
            if (dt.offset !== 0 && $f3842ea939e9c33f$export$1204b37d5bf67239.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        const intlOpts = {
            ...this.opts
        };
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $f3842ea939e9c33f$var$getCachedDTF(intl, intlOpts);
    }
    format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(({ value: value })=>value).join("");
        return this.dtf.format(this.dt.toJSDate());
    }
    formatToParts() {
        const parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map((part)=>{
            if (part.type === "timeZoneName") {
                const offsetName = this.originalZone.offsetName(this.dt.ts, {
                    locale: this.dt.locale,
                    format: this.opts.timeZoneName
                });
                return {
                    ...part,
                    value: offsetName
                };
            } else return part;
        });
        return parts;
    }
    resolvedOptions() {
        return this.dtf.resolvedOptions();
    }
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$PolyRelFormatter {
    constructor(intl, isEnglish, opts){
        this.opts = {
            style: "long",
            ...opts
        };
        if (!isEnglish && $f3842ea939e9c33f$var$hasRelative()) this.rtf = $f3842ea939e9c33f$var$getCachedRTF(intl, opts);
    }
    format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $f3842ea939e9c33f$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
    formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    }
}
const $f3842ea939e9c33f$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ class $f3842ea939e9c33f$var$Locale {
    static fromOpts(opts) {
        return $f3842ea939e9c33f$var$Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    }
    static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
        const specifiedLocale = locale || $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        const localeR = specifiedLocale || (defaultToEN ? "en-US" : $f3842ea939e9c33f$var$systemLocale());
        const numberingSystemR = numberingSystem || $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultNumberingSystem;
        const outputCalendarR = outputCalendar || $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultOutputCalendar;
        const weekSettingsR = $f3842ea939e9c33f$var$validateWeekSettings(weekSettings) || $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultWeekSettings;
        return new $f3842ea939e9c33f$var$Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    }
    static resetCache() {
        $f3842ea939e9c33f$var$sysLocaleCache = null;
        $f3842ea939e9c33f$var$intlDTCache.clear();
        $f3842ea939e9c33f$var$intlNumCache.clear();
        $f3842ea939e9c33f$var$intlRelCache.clear();
        $f3842ea939e9c33f$var$intlResolvedOptionsCache.clear();
        $f3842ea939e9c33f$var$weekInfoCache.clear();
    }
    static fromObject({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar, weekSettings: weekSettings } = {}) {
        return $f3842ea939e9c33f$var$Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    }
    constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale){
        const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = $f3842ea939e9c33f$var$parseLocaleString(locale);
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $f3842ea939e9c33f$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    get fastNumbers() {
        if (this.fastNumbersCached == null) this.fastNumbersCached = $f3842ea939e9c33f$var$supportsFastNumbers(this);
        return this.fastNumbersCached;
    }
    listingMode() {
        const isActuallyEn = this.isEnglish();
        const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    }
    clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return $f3842ea939e9c33f$var$Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $f3842ea939e9c33f$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
    redefaultToEN(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: true
        });
    }
    redefaultToSystem(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: false
        });
    }
    months(length, format = false) {
        return $f3842ea939e9c33f$var$listStuff(this, length, $f3842ea939e9c33f$var$months, ()=>{
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            const intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.monthsCache[formatStr][length]) {
                const mapper = !monthSpecialCase ? (dt)=>this.extract(dt, intl, "month") : (dt)=>this.dtFormatter(dt, intl).format();
                this.monthsCache[formatStr][length] = $f3842ea939e9c33f$var$mapMonths(mapper);
            }
            return this.monthsCache[formatStr][length];
        });
    }
    weekdays(length, format = false) {
        return $f3842ea939e9c33f$var$listStuff(this, length, $f3842ea939e9c33f$var$weekdays, ()=>{
            const intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.weekdaysCache[formatStr][length]) this.weekdaysCache[formatStr][length] = $f3842ea939e9c33f$var$mapWeekdays((dt)=>this.extract(dt, intl, "weekday"));
            return this.weekdaysCache[formatStr][length];
        });
    }
    meridiems() {
        return $f3842ea939e9c33f$var$listStuff(this, undefined, ()=>$f3842ea939e9c33f$var$meridiems, ()=>{
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!this.meridiemCache) {
                const intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                this.meridiemCache = [
                    $f3842ea939e9c33f$export$82f9ebd9adeba146.utc(2016, 11, 13, 9),
                    $f3842ea939e9c33f$export$82f9ebd9adeba146.utc(2016, 11, 13, 19)
                ].map((dt)=>this.extract(dt, intl, "dayperiod"));
            }
            return this.meridiemCache;
        });
    }
    eras(length) {
        return $f3842ea939e9c33f$var$listStuff(this, length, $f3842ea939e9c33f$var$eras, ()=>{
            const intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!this.eraCache[length]) this.eraCache[length] = [
                $f3842ea939e9c33f$export$82f9ebd9adeba146.utc(-40, 1, 1),
                $f3842ea939e9c33f$export$82f9ebd9adeba146.utc(2017, 1, 1)
            ].map((dt)=>this.extract(dt, intl, "era"));
            return this.eraCache[length];
        });
    }
    extract(dt, intlOpts, field) {
        const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m)=>m.type.toLowerCase() === field);
        return matching ? matching.value : null;
    }
    numberFormatter(opts = {}) {
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $f3842ea939e9c33f$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    }
    dtFormatter(dt, intlOpts = {}) {
        return new $f3842ea939e9c33f$var$PolyDateFormatter(dt, this.intl, intlOpts);
    }
    relFormatter(opts = {}) {
        return new $f3842ea939e9c33f$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    }
    listFormatter(opts = {}) {
        return $f3842ea939e9c33f$var$getCachedLF(this.intl, opts);
    }
    isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $f3842ea939e9c33f$var$getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    }
    getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$f3842ea939e9c33f$var$hasLocaleWeekInfo()) return $f3842ea939e9c33f$var$fallbackWeekSettings;
        else return $f3842ea939e9c33f$var$getCachedWeekInfo(this.locale);
    }
    getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    }
    getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    }
    getWeekendDays() {
        return this.getWeekSettings().weekend;
    }
    equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    }
    toString() {
        return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
    }
}
let $f3842ea939e9c33f$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ class $f3842ea939e9c33f$export$c89026e47e943b6f extends $f3842ea939e9c33f$export$96f93b933c2401c7 {
    /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */ static get utcInstance() {
        if ($f3842ea939e9c33f$var$singleton === null) $f3842ea939e9c33f$var$singleton = new $f3842ea939e9c33f$export$c89026e47e943b6f(0);
        return $f3842ea939e9c33f$var$singleton;
    }
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ static instance(offset) {
        return offset === 0 ? $f3842ea939e9c33f$export$c89026e47e943b6f.utcInstance : new $f3842ea939e9c33f$export$c89026e47e943b6f(offset);
    }
    /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ static parseSpecifier(s) {
        if (s) {
            const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new $f3842ea939e9c33f$export$c89026e47e943b6f($f3842ea939e9c33f$var$signedOffset(r[1], r[2]));
        }
        return null;
    }
    constructor(offset){
        super();
        /** @private **/ this.fixed = offset;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ get type() {
        return "fixed";
    }
    /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */ get name() {
        return this.fixed === 0 ? "UTC" : `UTC${$f3842ea939e9c33f$var$formatOffset(this.fixed, "narrow")}`;
    }
    /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */ get ianaName() {
        if (this.fixed === 0) return "Etc/UTC";
        else return `Etc/GMT${$f3842ea939e9c33f$var$formatOffset(-this.fixed, "narrow")}`;
    }
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ offsetName() {
        return this.name;
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return $f3842ea939e9c33f$var$formatOffset(this.fixed, format);
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return true;
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ offset() {
        return this.fixed;
    }
    /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }
    /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return true;
    }
}
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ class $f3842ea939e9c33f$export$c3134ced9da93bf6 extends $f3842ea939e9c33f$export$96f93b933c2401c7 {
    constructor(zoneName){
        super();
        /**  @private */ this.zoneName = zoneName;
    }
    /** @override **/ get type() {
        return "invalid";
    }
    /** @override **/ get name() {
        return this.zoneName;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName() {
        return null;
    }
    /** @override **/ formatOffset() {
        return "";
    }
    /** @override **/ offset() {
        return NaN;
    }
    /** @override **/ equals() {
        return false;
    }
    /** @override **/ get isValid() {
        return false;
    }
}
/**
 * @private
 */ function $f3842ea939e9c33f$var$normalizeZone(input, defaultZone) {
    if ($f3842ea939e9c33f$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $f3842ea939e9c33f$export$96f93b933c2401c7) return input;
    else if ($f3842ea939e9c33f$var$isString(input)) {
        const lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $f3842ea939e9c33f$export$e517f35950cc518a.instance;
        else if (lowered === "utc" || lowered === "gmt") return $f3842ea939e9c33f$export$c89026e47e943b6f.utcInstance;
        else return $f3842ea939e9c33f$export$c89026e47e943b6f.parseSpecifier(lowered) || $f3842ea939e9c33f$export$1204b37d5bf67239.create(input);
    } else if ($f3842ea939e9c33f$var$isNumber(input)) return $f3842ea939e9c33f$export$c89026e47e943b6f.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $f3842ea939e9c33f$export$c3134ced9da93bf6(input);
}
const $f3842ea939e9c33f$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
const $f3842ea939e9c33f$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
const $f3842ea939e9c33f$var$hanidecChars = $f3842ea939e9c33f$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $f3842ea939e9c33f$var$parseDigits(str) {
    let value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(let i = 0; i < str.length; i++){
            const code = str.charCodeAt(i);
            if (str[i].search($f3842ea939e9c33f$var$numberingSystems.hanidec) !== -1) value += $f3842ea939e9c33f$var$hanidecChars.indexOf(str[i]);
            else for(const key in $f3842ea939e9c33f$var$numberingSystemsUTF16){
                const [min, max] = $f3842ea939e9c33f$var$numberingSystemsUTF16[key];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
const $f3842ea939e9c33f$var$digitRegexCache = new Map();
function $f3842ea939e9c33f$var$resetDigitRegexCache() {
    $f3842ea939e9c33f$var$digitRegexCache.clear();
}
function $f3842ea939e9c33f$var$digitRegex({ numberingSystem: numberingSystem }, append = "") {
    const ns = numberingSystem || "latn";
    let appendCache = $f3842ea939e9c33f$var$digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        $f3842ea939e9c33f$var$digitRegexCache.set(ns, appendCache);
    }
    let regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp(`${$f3842ea939e9c33f$var$numberingSystems[ns]}${append}`);
        appendCache.set(append, regex);
    }
    return regex;
}
let $f3842ea939e9c33f$var$now = ()=>Date.now(), $f3842ea939e9c33f$var$defaultZone = "system", $f3842ea939e9c33f$var$defaultLocale = null, $f3842ea939e9c33f$var$defaultNumberingSystem = null, $f3842ea939e9c33f$var$defaultOutputCalendar = null, $f3842ea939e9c33f$var$twoDigitCutoffYear = 60, $f3842ea939e9c33f$var$throwOnInvalid, $f3842ea939e9c33f$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ class $f3842ea939e9c33f$export$c72f6eaae7b9adff {
    /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */ static get now() {
        return $f3842ea939e9c33f$var$now;
    }
    /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */ static set now(n) {
        $f3842ea939e9c33f$var$now = n;
    }
    /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */ static set defaultZone(zone) {
        $f3842ea939e9c33f$var$defaultZone = zone;
    }
    /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */ static get defaultZone() {
        return $f3842ea939e9c33f$var$normalizeZone($f3842ea939e9c33f$var$defaultZone, $f3842ea939e9c33f$export$e517f35950cc518a.instance);
    }
    /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultLocale() {
        return $f3842ea939e9c33f$var$defaultLocale;
    }
    /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultLocale(locale) {
        $f3842ea939e9c33f$var$defaultLocale = locale;
    }
    /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultNumberingSystem() {
        return $f3842ea939e9c33f$var$defaultNumberingSystem;
    }
    /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultNumberingSystem(numberingSystem) {
        $f3842ea939e9c33f$var$defaultNumberingSystem = numberingSystem;
    }
    /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultOutputCalendar() {
        return $f3842ea939e9c33f$var$defaultOutputCalendar;
    }
    /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultOutputCalendar(outputCalendar) {
        $f3842ea939e9c33f$var$defaultOutputCalendar = outputCalendar;
    }
    /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */ /**
   * @return {WeekSettings|null}
   */ static get defaultWeekSettings() {
        return $f3842ea939e9c33f$var$defaultWeekSettings;
    }
    /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */ static set defaultWeekSettings(weekSettings) {
        $f3842ea939e9c33f$var$defaultWeekSettings = $f3842ea939e9c33f$var$validateWeekSettings(weekSettings);
    }
    /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */ static get twoDigitCutoffYear() {
        return $f3842ea939e9c33f$var$twoDigitCutoffYear;
    }
    /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */ static set twoDigitCutoffYear(cutoffYear) {
        $f3842ea939e9c33f$var$twoDigitCutoffYear = cutoffYear % 100;
    }
    /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static get throwOnInvalid() {
        return $f3842ea939e9c33f$var$throwOnInvalid;
    }
    /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static set throwOnInvalid(t) {
        $f3842ea939e9c33f$var$throwOnInvalid = t;
    }
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCaches() {
        $f3842ea939e9c33f$var$Locale.resetCache();
        $f3842ea939e9c33f$export$1204b37d5bf67239.resetCache();
        $f3842ea939e9c33f$export$82f9ebd9adeba146.resetCache();
        $f3842ea939e9c33f$var$resetDigitRegexCache();
    }
}
class $f3842ea939e9c33f$var$Invalid {
    constructor(reason, explanation){
        this.reason = reason;
        this.explanation = explanation;
    }
    toMessage() {
        if (this.explanation) return `${this.reason}: ${this.explanation}`;
        else return this.reason;
    }
}
const $f3842ea939e9c33f$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $f3842ea939e9c33f$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $f3842ea939e9c33f$var$unitOutOfRange(unit, value) {
    return new $f3842ea939e9c33f$var$Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function $f3842ea939e9c33f$var$dayOfWeek(year, month, day) {
    const d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    const js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $f3842ea939e9c33f$var$computeOrdinal(year, month, day) {
    return day + ($f3842ea939e9c33f$var$isLeapYear(year) ? $f3842ea939e9c33f$var$leapLadder : $f3842ea939e9c33f$var$nonLeapLadder)[month - 1];
}
function $f3842ea939e9c33f$var$uncomputeOrdinal(year, ordinal) {
    const table = $f3842ea939e9c33f$var$isLeapYear(year) ? $f3842ea939e9c33f$var$leapLadder : $f3842ea939e9c33f$var$nonLeapLadder, month0 = table.findIndex((i)=>i < ordinal), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $f3842ea939e9c33f$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $f3842ea939e9c33f$var$gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { year: year, month: month, day: day } = gregObj, ordinal = $f3842ea939e9c33f$var$computeOrdinal(year, month, day), weekday = $f3842ea939e9c33f$var$isoWeekdayToLocal($f3842ea939e9c33f$var$dayOfWeek(year, month, day), startOfWeek);
    let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $f3842ea939e9c33f$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $f3842ea939e9c33f$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return {
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday,
        ...$f3842ea939e9c33f$var$timeObject(gregObj)
    };
}
function $f3842ea939e9c33f$var$weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { weekYear: weekYear, weekNumber: weekNumber, weekday: weekday } = weekData, weekdayOfJan4 = $f3842ea939e9c33f$var$isoWeekdayToLocal($f3842ea939e9c33f$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $f3842ea939e9c33f$var$daysInYear(weekYear);
    let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $f3842ea939e9c33f$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $f3842ea939e9c33f$var$daysInYear(weekYear);
    } else year = weekYear;
    const { month: month, day: day } = $f3842ea939e9c33f$var$uncomputeOrdinal(year, ordinal);
    return {
        year: year,
        month: month,
        day: day,
        ...$f3842ea939e9c33f$var$timeObject(weekData)
    };
}
function $f3842ea939e9c33f$var$gregorianToOrdinal(gregData) {
    const { year: year, month: month, day: day } = gregData;
    const ordinal = $f3842ea939e9c33f$var$computeOrdinal(year, month, day);
    return {
        year: year,
        ordinal: ordinal,
        ...$f3842ea939e9c33f$var$timeObject(gregData)
    };
}
function $f3842ea939e9c33f$var$ordinalToGregorian(ordinalData) {
    const { year: year, ordinal: ordinal } = ordinalData;
    const { month: month, day: day } = $f3842ea939e9c33f$var$uncomputeOrdinal(year, ordinal);
    return {
        year: year,
        month: month,
        day: day,
        ...$f3842ea939e9c33f$var$timeObject(ordinalData)
    };
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $f3842ea939e9c33f$var$usesLocalWeekValues(obj, loc) {
    const hasLocaleWeekData = !$f3842ea939e9c33f$var$isUndefined(obj.localWeekday) || !$f3842ea939e9c33f$var$isUndefined(obj.localWeekNumber) || !$f3842ea939e9c33f$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        const hasIsoWeekData = !$f3842ea939e9c33f$var$isUndefined(obj.weekday) || !$f3842ea939e9c33f$var$isUndefined(obj.weekNumber) || !$f3842ea939e9c33f$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $f3842ea939e9c33f$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$f3842ea939e9c33f$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$f3842ea939e9c33f$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$f3842ea939e9c33f$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $f3842ea939e9c33f$var$hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const validYear = $f3842ea939e9c33f$var$isInteger(obj.weekYear), validWeek = $f3842ea939e9c33f$var$integerBetween(obj.weekNumber, 1, $f3842ea939e9c33f$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $f3842ea939e9c33f$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $f3842ea939e9c33f$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $f3842ea939e9c33f$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $f3842ea939e9c33f$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $f3842ea939e9c33f$var$hasInvalidOrdinalData(obj) {
    const validYear = $f3842ea939e9c33f$var$isInteger(obj.year), validOrdinal = $f3842ea939e9c33f$var$integerBetween(obj.ordinal, 1, $f3842ea939e9c33f$var$daysInYear(obj.year));
    if (!validYear) return $f3842ea939e9c33f$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $f3842ea939e9c33f$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $f3842ea939e9c33f$var$hasInvalidGregorianData(obj) {
    const validYear = $f3842ea939e9c33f$var$isInteger(obj.year), validMonth = $f3842ea939e9c33f$var$integerBetween(obj.month, 1, 12), validDay = $f3842ea939e9c33f$var$integerBetween(obj.day, 1, $f3842ea939e9c33f$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $f3842ea939e9c33f$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $f3842ea939e9c33f$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $f3842ea939e9c33f$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $f3842ea939e9c33f$var$hasInvalidTimeData(obj) {
    const { hour: hour, minute: minute, second: second, millisecond: millisecond } = obj;
    const validHour = $f3842ea939e9c33f$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $f3842ea939e9c33f$var$integerBetween(minute, 0, 59), validSecond = $f3842ea939e9c33f$var$integerBetween(second, 0, 59), validMillisecond = $f3842ea939e9c33f$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $f3842ea939e9c33f$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $f3842ea939e9c33f$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $f3842ea939e9c33f$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $f3842ea939e9c33f$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ /**
 * @private
 */ // TYPES
function $f3842ea939e9c33f$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $f3842ea939e9c33f$var$isNumber(o) {
    return typeof o === "number";
}
function $f3842ea939e9c33f$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $f3842ea939e9c33f$var$isString(o) {
    return typeof o === "string";
}
function $f3842ea939e9c33f$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $f3842ea939e9c33f$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $f3842ea939e9c33f$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $f3842ea939e9c33f$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $f3842ea939e9c33f$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce((best, next)=>{
        const pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $f3842ea939e9c33f$var$pick(obj, keys) {
    return keys.reduce((a, k)=>{
        a[k] = obj[k];
        return a;
    }, {});
}
function $f3842ea939e9c33f$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $f3842ea939e9c33f$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $f3842ea939e9c33f$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$f3842ea939e9c33f$var$integerBetween(settings.firstDay, 1, 7) || !$f3842ea939e9c33f$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v)=>!$f3842ea939e9c33f$var$integerBetween(v, 1, 7))) throw new $f3842ea939e9c33f$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $f3842ea939e9c33f$var$integerBetween(thing, bottom, top) {
    return $f3842ea939e9c33f$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $f3842ea939e9c33f$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $f3842ea939e9c33f$var$padStart(input, n = 2) {
    const isNeg = input < 0;
    let padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $f3842ea939e9c33f$var$parseInteger(string) {
    if ($f3842ea939e9c33f$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $f3842ea939e9c33f$var$parseFloating(string) {
    if ($f3842ea939e9c33f$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $f3842ea939e9c33f$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($f3842ea939e9c33f$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        const f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $f3842ea939e9c33f$var$roundTo(number, digits, rounding = "round") {
    const factor = 10 ** digits;
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError(`Value rounding ${rounding} is out of range`);
    }
}
// DATE BASICS
function $f3842ea939e9c33f$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $f3842ea939e9c33f$var$daysInYear(year) {
    return $f3842ea939e9c33f$var$isLeapYear(year) ? 366 : 365;
}
function $f3842ea939e9c33f$var$daysInMonth(year, month) {
    const modMonth = $f3842ea939e9c33f$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $f3842ea939e9c33f$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $f3842ea939e9c33f$var$objToLocalTS(obj) {
    let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $f3842ea939e9c33f$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    const fwdlw = $f3842ea939e9c33f$var$isoWeekdayToLocal($f3842ea939e9c33f$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $f3842ea939e9c33f$var$weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const weekOffset = $f3842ea939e9c33f$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    const weekOffsetNext = $f3842ea939e9c33f$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($f3842ea939e9c33f$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $f3842ea939e9c33f$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $f3842ea939e9c33f$export$c72f6eaae7b9adff.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $f3842ea939e9c33f$var$parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
    const date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    const modified = {
        timeZoneName: offsetFormat,
        ...intlOpts
    };
    const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m)=>m.type.toLowerCase() === "timezonename");
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $f3842ea939e9c33f$var$signedOffset(offHourStr, offMinuteStr) {
    let offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $f3842ea939e9c33f$var$asNumber(value) {
    const numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new $f3842ea939e9c33f$var$InvalidArgumentError(`Invalid unit value ${value}`);
    return numericValue;
}
function $f3842ea939e9c33f$var$normalizeObject(obj, normalizer) {
    const normalized = {};
    for(const u in obj)if ($f3842ea939e9c33f$var$hasOwnProperty(obj, u)) {
        const v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $f3842ea939e9c33f$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $f3842ea939e9c33f$var$formatOffset(offset, format) {
    const hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return `${sign}${$f3842ea939e9c33f$var$padStart(hours, 2)}:${$f3842ea939e9c33f$var$padStart(minutes, 2)}`;
        case "narrow":
            return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
        case "techie":
            return `${sign}${$f3842ea939e9c33f$var$padStart(hours, 2)}${$f3842ea939e9c33f$var$padStart(minutes, 2)}`;
        default:
            throw new RangeError(`Value format ${format} is out of range for property format`);
    }
}
function $f3842ea939e9c33f$var$timeObject(obj) {
    return $f3842ea939e9c33f$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ const $f3842ea939e9c33f$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $f3842ea939e9c33f$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $f3842ea939e9c33f$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $f3842ea939e9c33f$var$months(length) {
    switch(length){
        case "narrow":
            return [
                ...$f3842ea939e9c33f$var$monthsNarrow
            ];
        case "short":
            return [
                ...$f3842ea939e9c33f$var$monthsShort
            ];
        case "long":
            return [
                ...$f3842ea939e9c33f$var$monthsLong
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
const $f3842ea939e9c33f$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const $f3842ea939e9c33f$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
const $f3842ea939e9c33f$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $f3842ea939e9c33f$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [
                ...$f3842ea939e9c33f$var$weekdaysNarrow
            ];
        case "short":
            return [
                ...$f3842ea939e9c33f$var$weekdaysShort
            ];
        case "long":
            return [
                ...$f3842ea939e9c33f$var$weekdaysLong
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
const $f3842ea939e9c33f$var$meridiems = [
    "AM",
    "PM"
];
const $f3842ea939e9c33f$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
const $f3842ea939e9c33f$var$erasShort = [
    "BC",
    "AD"
];
const $f3842ea939e9c33f$var$erasNarrow = [
    "B",
    "A"
];
function $f3842ea939e9c33f$var$eras(length) {
    switch(length){
        case "narrow":
            return [
                ...$f3842ea939e9c33f$var$erasNarrow
            ];
        case "short":
            return [
                ...$f3842ea939e9c33f$var$erasShort
            ];
        case "long":
            return [
                ...$f3842ea939e9c33f$var$erasLong
            ];
        default:
            return null;
    }
}
function $f3842ea939e9c33f$var$meridiemForDateTime(dt) {
    return $f3842ea939e9c33f$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $f3842ea939e9c33f$var$weekdayForDateTime(dt, length) {
    return $f3842ea939e9c33f$var$weekdays(length)[dt.weekday - 1];
}
function $f3842ea939e9c33f$var$monthForDateTime(dt, length) {
    return $f3842ea939e9c33f$var$months(length)[dt.month - 1];
}
function $f3842ea939e9c33f$var$eraForDateTime(dt, length) {
    return $f3842ea939e9c33f$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $f3842ea939e9c33f$var$formatRelativeTime(unit, count, numeric = "always", narrow = false) {
    const units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    const lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        const isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : `next ${units[unit][0]}`;
            case -1:
                return isDay ? "yesterday" : `last ${units[unit][0]}`;
            case 0:
                return isDay ? "today" : `this ${units[unit][0]}`;
        }
    }
    const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function $f3842ea939e9c33f$var$stringifyTokens(splits, tokenToString) {
    let s = "";
    for (const token of splits)if (token.literal) s += token.val;
    else s += tokenToString(token.val);
    return s;
}
const $f3842ea939e9c33f$var$macroTokenToFormatOpts = {
    D: $f3842ea939e9c33f$var$DATE_SHORT,
    DD: $f3842ea939e9c33f$var$DATE_MED,
    DDD: $f3842ea939e9c33f$var$DATE_FULL,
    DDDD: $f3842ea939e9c33f$var$DATE_HUGE,
    t: $f3842ea939e9c33f$var$TIME_SIMPLE,
    tt: $f3842ea939e9c33f$var$TIME_WITH_SECONDS,
    ttt: $f3842ea939e9c33f$var$TIME_WITH_SHORT_OFFSET,
    tttt: $f3842ea939e9c33f$var$TIME_WITH_LONG_OFFSET,
    T: $f3842ea939e9c33f$var$TIME_24_SIMPLE,
    TT: $f3842ea939e9c33f$var$TIME_24_WITH_SECONDS,
    TTT: $f3842ea939e9c33f$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $f3842ea939e9c33f$var$TIME_24_WITH_LONG_OFFSET,
    f: $f3842ea939e9c33f$var$DATETIME_SHORT,
    ff: $f3842ea939e9c33f$var$DATETIME_MED,
    fff: $f3842ea939e9c33f$var$DATETIME_FULL,
    ffff: $f3842ea939e9c33f$var$DATETIME_HUGE,
    F: $f3842ea939e9c33f$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $f3842ea939e9c33f$var$DATETIME_MED_WITH_SECONDS,
    FFF: $f3842ea939e9c33f$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $f3842ea939e9c33f$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ class $f3842ea939e9c33f$var$Formatter {
    static create(locale, opts = {}) {
        return new $f3842ea939e9c33f$var$Formatter(locale, opts);
    }
    static parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        let current = null, currentFull = "", bracketed = false;
        const splits = [];
        for(let i = 0; i < fmt.length; i++){
            const c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    }
    static macroTokenToFormatOpts(token) {
        return $f3842ea939e9c33f$var$macroTokenToFormatOpts[token];
    }
    constructor(locale, formatOpts){
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        const df = this.systemLoc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
        return df.format();
    }
    dtFormatter(dt, opts = {}) {
        return this.loc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
    }
    formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    }
    formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    }
    formatInterval(interval, opts) {
        const df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    }
    resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    }
    num(n, p = 0, signDisplay) {
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $f3842ea939e9c33f$var$padStart(n, p);
        const opts = {
            ...this.opts
        };
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    }
    formatDateTimeFromString(dt, fmt) {
        const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract)=>this.loc.extract(dt, opts, extract), formatOffset = (opts)=>{
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = ()=>knownEnglish ? $f3842ea939e9c33f$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod"), month = (length, standalone)=>knownEnglish ? $f3842ea939e9c33f$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month"), weekday = (length, standalone)=>knownEnglish ? $f3842ea939e9c33f$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday"), maybeMacro = (token)=>{
            const formatOpts = $f3842ea939e9c33f$var$Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = (length)=>knownEnglish ? $f3842ea939e9c33f$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era"), tokenToString = (token)=>{
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return this.num(dt.second);
                case "ss":
                    return this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return this.num(dt.minute);
                case "mm":
                    return this.num(dt.minute, 2);
                // hours
                case "h":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return this.num(dt.hour);
                case "HH":
                    return this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return this.num(dt.weekYear, 4);
                case "W":
                    return this.num(dt.weekNumber);
                case "WW":
                    return this.num(dt.weekNumber, 2);
                case "n":
                    return this.num(dt.localWeekNumber);
                case "nn":
                    return this.num(dt.localWeekNumber, 2);
                case "ii":
                    return this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return this.num(dt.localWeekYear, 4);
                case "o":
                    return this.num(dt.ordinal);
                case "ooo":
                    return this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return this.num(dt.quarter);
                case "qq":
                    // like 01
                    return this.num(dt.quarter, 2);
                case "X":
                    return this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $f3842ea939e9c33f$var$stringifyTokens($f3842ea939e9c33f$var$Formatter.parseFormat(fmt), tokenToString);
    }
    formatDurationFromString(dur, fmt) {
        const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        const tokenToField = (token)=>{
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = (lildur, info)=>(token)=>{
                const mapped = tokenToField(token);
                if (mapped) {
                    const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    let signDisplay;
                    if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (this.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            }, tokens = $f3842ea939e9c33f$var$Formatter.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal, val: val })=>literal ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t)=>t)), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return $f3842ea939e9c33f$var$stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    }
}
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ const $f3842ea939e9c33f$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $f3842ea939e9c33f$var$combineRegexes(...regexes) {
    const full = regexes.reduce((f, r)=>f + r.source, "");
    return RegExp(`^${full}$`);
}
function $f3842ea939e9c33f$var$combineExtractors(...extractors) {
    return (m)=>extractors.reduce(([mergedVals, mergedZone, cursor], ex)=>{
            const [val, zone, next] = ex(m, cursor);
            return [
                {
                    ...mergedVals,
                    ...val
                },
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
}
function $f3842ea939e9c33f$var$parse(s, ...patterns) {
    if (s == null) return [
        null,
        null
    ];
    for (const [regex, extractor] of patterns){
        const m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $f3842ea939e9c33f$var$simpleParse(...keys) {
    return (match, cursor)=>{
        const ret = {};
        let i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $f3842ea939e9c33f$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
const $f3842ea939e9c33f$var$offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
const $f3842ea939e9c33f$var$isoExtendedZone = `(?:${$f3842ea939e9c33f$var$offsetRegex.source}?(?:\\[(${$f3842ea939e9c33f$var$ianaRegex.source})\\])?)?`;
const $f3842ea939e9c33f$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const $f3842ea939e9c33f$var$isoTimeRegex = RegExp(`${$f3842ea939e9c33f$var$isoTimeBaseRegex.source}${$f3842ea939e9c33f$var$isoExtendedZone}`);
const $f3842ea939e9c33f$var$isoTimeExtensionRegex = RegExp(`(?:[Tt]${$f3842ea939e9c33f$var$isoTimeRegex.source})?`);
const $f3842ea939e9c33f$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const $f3842ea939e9c33f$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const $f3842ea939e9c33f$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const $f3842ea939e9c33f$var$extractISOWeekData = $f3842ea939e9c33f$var$simpleParse("weekYear", "weekNumber", "weekDay");
const $f3842ea939e9c33f$var$extractISOOrdinalData = $f3842ea939e9c33f$var$simpleParse("year", "ordinal");
const $f3842ea939e9c33f$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const $f3842ea939e9c33f$var$sqlTimeRegex = RegExp(`${$f3842ea939e9c33f$var$isoTimeBaseRegex.source} ?(?:${$f3842ea939e9c33f$var$offsetRegex.source}|(${$f3842ea939e9c33f$var$ianaRegex.source}))?`);
const $f3842ea939e9c33f$var$sqlTimeExtensionRegex = RegExp(`(?: ${$f3842ea939e9c33f$var$sqlTimeRegex.source})?`);
function $f3842ea939e9c33f$var$int(match, pos, fallback) {
    const m = match[pos];
    return $f3842ea939e9c33f$var$isUndefined(m) ? fallback : $f3842ea939e9c33f$var$parseInteger(m);
}
function $f3842ea939e9c33f$var$extractISOYmd(match, cursor) {
    const item = {
        year: $f3842ea939e9c33f$var$int(match, cursor),
        month: $f3842ea939e9c33f$var$int(match, cursor + 1, 1),
        day: $f3842ea939e9c33f$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $f3842ea939e9c33f$var$extractISOTime(match, cursor) {
    const item = {
        hours: $f3842ea939e9c33f$var$int(match, cursor, 0),
        minutes: $f3842ea939e9c33f$var$int(match, cursor + 1, 0),
        seconds: $f3842ea939e9c33f$var$int(match, cursor + 2, 0),
        milliseconds: $f3842ea939e9c33f$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $f3842ea939e9c33f$var$extractISOOffset(match, cursor) {
    const local = !match[cursor] && !match[cursor + 1], fullOffset = $f3842ea939e9c33f$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $f3842ea939e9c33f$export$c89026e47e943b6f.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $f3842ea939e9c33f$var$extractIANAZone(match, cursor) {
    const zone = match[cursor] ? $f3842ea939e9c33f$export$1204b37d5bf67239.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
const $f3842ea939e9c33f$var$isoTimeOnly = RegExp(`^T?${$f3842ea939e9c33f$var$isoTimeBaseRegex.source}$`);
// ISO duration parsing
const $f3842ea939e9c33f$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $f3842ea939e9c33f$var$extractISODuration(match) {
    const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match;
    const hasNegativePrefix = s[0] === "-";
    const negativeSeconds = secondStr && secondStr[0] === "-";
    const maybeNegate = (num, force = false)=>num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    return [
        {
            years: maybeNegate($f3842ea939e9c33f$var$parseFloating(yearStr)),
            months: maybeNegate($f3842ea939e9c33f$var$parseFloating(monthStr)),
            weeks: maybeNegate($f3842ea939e9c33f$var$parseFloating(weekStr)),
            days: maybeNegate($f3842ea939e9c33f$var$parseFloating(dayStr)),
            hours: maybeNegate($f3842ea939e9c33f$var$parseFloating(hourStr)),
            minutes: maybeNegate($f3842ea939e9c33f$var$parseFloating(minuteStr)),
            seconds: maybeNegate($f3842ea939e9c33f$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($f3842ea939e9c33f$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const $f3842ea939e9c33f$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $f3842ea939e9c33f$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    const result = {
        year: yearStr.length === 2 ? $f3842ea939e9c33f$var$untruncateYear($f3842ea939e9c33f$var$parseInteger(yearStr)) : $f3842ea939e9c33f$var$parseInteger(yearStr),
        month: $f3842ea939e9c33f$var$monthsShort.indexOf(monthStr) + 1,
        day: $f3842ea939e9c33f$var$parseInteger(dayStr),
        hour: $f3842ea939e9c33f$var$parseInteger(hourStr),
        minute: $f3842ea939e9c33f$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $f3842ea939e9c33f$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $f3842ea939e9c33f$var$weekdaysLong.indexOf(weekdayStr) + 1 : $f3842ea939e9c33f$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
const $f3842ea939e9c33f$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $f3842ea939e9c33f$var$extractRFC2822(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match, result = $f3842ea939e9c33f$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    let offset;
    if (obsOffset) offset = $f3842ea939e9c33f$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $f3842ea939e9c33f$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $f3842ea939e9c33f$export$c89026e47e943b6f(offset)
    ];
}
function $f3842ea939e9c33f$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
const $f3842ea939e9c33f$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $f3842ea939e9c33f$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $f3842ea939e9c33f$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $f3842ea939e9c33f$var$extractRFC1123Or850(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match, result = $f3842ea939e9c33f$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $f3842ea939e9c33f$export$c89026e47e943b6f.utcInstance
    ];
}
function $f3842ea939e9c33f$var$extractASCII(match) {
    const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match, result = $f3842ea939e9c33f$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $f3842ea939e9c33f$export$c89026e47e943b6f.utcInstance
    ];
}
const $f3842ea939e9c33f$var$isoYmdWithTimeExtensionRegex = $f3842ea939e9c33f$var$combineRegexes($f3842ea939e9c33f$var$isoYmdRegex, $f3842ea939e9c33f$var$isoTimeExtensionRegex);
const $f3842ea939e9c33f$var$isoWeekWithTimeExtensionRegex = $f3842ea939e9c33f$var$combineRegexes($f3842ea939e9c33f$var$isoWeekRegex, $f3842ea939e9c33f$var$isoTimeExtensionRegex);
const $f3842ea939e9c33f$var$isoOrdinalWithTimeExtensionRegex = $f3842ea939e9c33f$var$combineRegexes($f3842ea939e9c33f$var$isoOrdinalRegex, $f3842ea939e9c33f$var$isoTimeExtensionRegex);
const $f3842ea939e9c33f$var$isoTimeCombinedRegex = $f3842ea939e9c33f$var$combineRegexes($f3842ea939e9c33f$var$isoTimeRegex);
const $f3842ea939e9c33f$var$extractISOYmdTimeAndOffset = $f3842ea939e9c33f$var$combineExtractors($f3842ea939e9c33f$var$extractISOYmd, $f3842ea939e9c33f$var$extractISOTime, $f3842ea939e9c33f$var$extractISOOffset, $f3842ea939e9c33f$var$extractIANAZone);
const $f3842ea939e9c33f$var$extractISOWeekTimeAndOffset = $f3842ea939e9c33f$var$combineExtractors($f3842ea939e9c33f$var$extractISOWeekData, $f3842ea939e9c33f$var$extractISOTime, $f3842ea939e9c33f$var$extractISOOffset, $f3842ea939e9c33f$var$extractIANAZone);
const $f3842ea939e9c33f$var$extractISOOrdinalDateAndTime = $f3842ea939e9c33f$var$combineExtractors($f3842ea939e9c33f$var$extractISOOrdinalData, $f3842ea939e9c33f$var$extractISOTime, $f3842ea939e9c33f$var$extractISOOffset, $f3842ea939e9c33f$var$extractIANAZone);
const $f3842ea939e9c33f$var$extractISOTimeAndOffset = $f3842ea939e9c33f$var$combineExtractors($f3842ea939e9c33f$var$extractISOTime, $f3842ea939e9c33f$var$extractISOOffset, $f3842ea939e9c33f$var$extractIANAZone);
/*
 * @private
 */ function $f3842ea939e9c33f$var$parseISODate(s) {
    return $f3842ea939e9c33f$var$parse(s, [
        $f3842ea939e9c33f$var$isoYmdWithTimeExtensionRegex,
        $f3842ea939e9c33f$var$extractISOYmdTimeAndOffset
    ], [
        $f3842ea939e9c33f$var$isoWeekWithTimeExtensionRegex,
        $f3842ea939e9c33f$var$extractISOWeekTimeAndOffset
    ], [
        $f3842ea939e9c33f$var$isoOrdinalWithTimeExtensionRegex,
        $f3842ea939e9c33f$var$extractISOOrdinalDateAndTime
    ], [
        $f3842ea939e9c33f$var$isoTimeCombinedRegex,
        $f3842ea939e9c33f$var$extractISOTimeAndOffset
    ]);
}
function $f3842ea939e9c33f$var$parseRFC2822Date(s) {
    return $f3842ea939e9c33f$var$parse($f3842ea939e9c33f$var$preprocessRFC2822(s), [
        $f3842ea939e9c33f$var$rfc2822,
        $f3842ea939e9c33f$var$extractRFC2822
    ]);
}
function $f3842ea939e9c33f$var$parseHTTPDate(s) {
    return $f3842ea939e9c33f$var$parse(s, [
        $f3842ea939e9c33f$var$rfc1123,
        $f3842ea939e9c33f$var$extractRFC1123Or850
    ], [
        $f3842ea939e9c33f$var$rfc850,
        $f3842ea939e9c33f$var$extractRFC1123Or850
    ], [
        $f3842ea939e9c33f$var$ascii,
        $f3842ea939e9c33f$var$extractASCII
    ]);
}
function $f3842ea939e9c33f$var$parseISODuration(s) {
    return $f3842ea939e9c33f$var$parse(s, [
        $f3842ea939e9c33f$var$isoDuration,
        $f3842ea939e9c33f$var$extractISODuration
    ]);
}
const $f3842ea939e9c33f$var$extractISOTimeOnly = $f3842ea939e9c33f$var$combineExtractors($f3842ea939e9c33f$var$extractISOTime);
function $f3842ea939e9c33f$var$parseISOTimeOnly(s) {
    return $f3842ea939e9c33f$var$parse(s, [
        $f3842ea939e9c33f$var$isoTimeOnly,
        $f3842ea939e9c33f$var$extractISOTimeOnly
    ]);
}
const $f3842ea939e9c33f$var$sqlYmdWithTimeExtensionRegex = $f3842ea939e9c33f$var$combineRegexes($f3842ea939e9c33f$var$sqlYmdRegex, $f3842ea939e9c33f$var$sqlTimeExtensionRegex);
const $f3842ea939e9c33f$var$sqlTimeCombinedRegex = $f3842ea939e9c33f$var$combineRegexes($f3842ea939e9c33f$var$sqlTimeRegex);
const $f3842ea939e9c33f$var$extractISOTimeOffsetAndIANAZone = $f3842ea939e9c33f$var$combineExtractors($f3842ea939e9c33f$var$extractISOTime, $f3842ea939e9c33f$var$extractISOOffset, $f3842ea939e9c33f$var$extractIANAZone);
function $f3842ea939e9c33f$var$parseSQL(s) {
    return $f3842ea939e9c33f$var$parse(s, [
        $f3842ea939e9c33f$var$sqlYmdWithTimeExtensionRegex,
        $f3842ea939e9c33f$var$extractISOYmdTimeAndOffset
    ], [
        $f3842ea939e9c33f$var$sqlTimeCombinedRegex,
        $f3842ea939e9c33f$var$extractISOTimeOffsetAndIANAZone
    ]);
}
const $f3842ea939e9c33f$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
const $f3842ea939e9c33f$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $f3842ea939e9c33f$var$casualMatrix = {
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    },
    ...$f3842ea939e9c33f$var$lowOrderMatrix
}, $f3842ea939e9c33f$var$daysInYearAccurate = 365.2425, $f3842ea939e9c33f$var$daysInMonthAccurate = 30.436875, $f3842ea939e9c33f$var$accurateMatrix = {
    years: {
        quarters: 4,
        months: 12,
        weeks: $f3842ea939e9c33f$var$daysInYearAccurate / 7,
        days: $f3842ea939e9c33f$var$daysInYearAccurate,
        hours: $f3842ea939e9c33f$var$daysInYearAccurate * 24,
        minutes: $f3842ea939e9c33f$var$daysInYearAccurate * 1440,
        seconds: $f3842ea939e9c33f$var$daysInYearAccurate * 86400,
        milliseconds: $f3842ea939e9c33f$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $f3842ea939e9c33f$var$daysInYearAccurate / 28,
        days: $f3842ea939e9c33f$var$daysInYearAccurate / 4,
        hours: $f3842ea939e9c33f$var$daysInYearAccurate * 24 / 4,
        minutes: $f3842ea939e9c33f$var$daysInYearAccurate * 1440 / 4,
        seconds: $f3842ea939e9c33f$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $f3842ea939e9c33f$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $f3842ea939e9c33f$var$daysInMonthAccurate / 7,
        days: $f3842ea939e9c33f$var$daysInMonthAccurate,
        hours: $f3842ea939e9c33f$var$daysInMonthAccurate * 24,
        minutes: $f3842ea939e9c33f$var$daysInMonthAccurate * 1440,
        seconds: $f3842ea939e9c33f$var$daysInMonthAccurate * 86400,
        milliseconds: $f3842ea939e9c33f$var$daysInMonthAccurate * 86400000
    },
    ...$f3842ea939e9c33f$var$lowOrderMatrix
};
// units ordered by size
const $f3842ea939e9c33f$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
const $f3842ea939e9c33f$var$reverseUnits = $f3842ea939e9c33f$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $f3842ea939e9c33f$var$clone$1(dur, alts, clear = false) {
    // deep merge for vals
    const conf = {
        values: clear ? alts.values : {
            ...dur.values,
            ...alts.values || {}
        },
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $f3842ea939e9c33f$export$3b11bc38611c5941(conf);
}
function $f3842ea939e9c33f$var$durationToMillis(matrix, vals) {
    let sum = vals.milliseconds ?? 0;
    for (const unit of $f3842ea939e9c33f$var$reverseUnits.slice(1))if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    return sum;
}
// NB: mutates parameters
function $f3842ea939e9c33f$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    const factor = $f3842ea939e9c33f$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $f3842ea939e9c33f$var$orderedUnits$1.reduceRight((previous, current)=>{
        if (!$f3842ea939e9c33f$var$isUndefined(vals[current])) {
            if (previous) {
                const previousVal = vals[previous] * factor;
                const conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                const rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $f3842ea939e9c33f$var$orderedUnits$1.reduce((previous, current)=>{
        if (!$f3842ea939e9c33f$var$isUndefined(vals[current])) {
            if (previous) {
                const fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $f3842ea939e9c33f$var$removeZeroes(vals) {
    const newVals = {};
    for (const [key, value] of Object.entries(vals))if (value !== 0) newVals[key] = value;
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ class $f3842ea939e9c33f$export$3b11bc38611c5941 {
    /**
   * @private
   */ constructor(config){
        const accurate = config.conversionAccuracy === "longterm" || false;
        let matrix = accurate ? $f3842ea939e9c33f$var$accurateMatrix : $f3842ea939e9c33f$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $f3842ea939e9c33f$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ static fromMillis(count, opts) {
        return $f3842ea939e9c33f$export$3b11bc38611c5941.fromObject({
            milliseconds: count
        }, opts);
    }
    /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ static fromObject(obj, opts = {}) {
        if (obj == null || typeof obj !== "object") throw new $f3842ea939e9c33f$var$InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
        return new $f3842ea939e9c33f$export$3b11bc38611c5941({
            values: $f3842ea939e9c33f$var$normalizeObject(obj, $f3842ea939e9c33f$export$3b11bc38611c5941.normalizeUnit),
            loc: $f3842ea939e9c33f$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    }
    /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ static fromDurationLike(durationLike) {
        if ($f3842ea939e9c33f$var$isNumber(durationLike)) return $f3842ea939e9c33f$export$3b11bc38611c5941.fromMillis(durationLike);
        else if ($f3842ea939e9c33f$export$3b11bc38611c5941.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return $f3842ea939e9c33f$export$3b11bc38611c5941.fromObject(durationLike);
        else throw new $f3842ea939e9c33f$var$InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
    /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ static fromISO(text, opts) {
        const [parsed] = $f3842ea939e9c33f$var$parseISODuration(text);
        if (parsed) return $f3842ea939e9c33f$export$3b11bc38611c5941.fromObject(parsed, opts);
        else return $f3842ea939e9c33f$export$3b11bc38611c5941.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ static fromISOTime(text, opts) {
        const [parsed] = $f3842ea939e9c33f$var$parseISOTimeOnly(text);
        if (parsed) return $f3842ea939e9c33f$export$3b11bc38611c5941.fromObject(parsed, opts);
        else return $f3842ea939e9c33f$export$3b11bc38611c5941.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new $f3842ea939e9c33f$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        const invalid = reason instanceof $f3842ea939e9c33f$var$Invalid ? reason : new $f3842ea939e9c33f$var$Invalid(reason, explanation);
        if ($f3842ea939e9c33f$export$c72f6eaae7b9adff.throwOnInvalid) throw new $f3842ea939e9c33f$var$InvalidDurationError(invalid);
        else return new $f3842ea939e9c33f$export$3b11bc38611c5941({
            invalid: invalid
        });
    }
    /**
   * @private
   */ static normalizeUnit(unit) {
        const normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $f3842ea939e9c33f$var$InvalidUnitError(unit);
        return normalized;
    }
    /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDuration(o) {
        return o && o.isLuxonDuration || false;
    }
    /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        const fmtOpts = {
            ...opts,
            floor: opts.round !== false && opts.floor !== false
        };
        return this.isValid ? $f3842ea939e9c33f$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $f3842ea939e9c33f$var$INVALID$2;
    }
    /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */ toHuman(opts = {}) {
        if (!this.isValid) return $f3842ea939e9c33f$var$INVALID$2;
        const showZeros = opts.showZeros !== false;
        const l = $f3842ea939e9c33f$var$orderedUnits$1.map((unit)=>{
            const val = this.values[unit];
            if ($f3842ea939e9c33f$var$isUndefined(val) || val === 0 && !showZeros) return null;
            return this.loc.numberFormatter({
                style: "unit",
                unitDisplay: "long",
                ...opts,
                unit: unit.slice(0, -1)
            }).format(val);
        }).filter((n)=>n);
        return this.loc.listFormatter({
            type: "conjunction",
            style: opts.listStyle || "narrow",
            ...opts
        }).format(l);
    }
    /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ toObject() {
        if (!this.isValid) return {};
        return {
            ...this.values
        };
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        let s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $f3842ea939e9c33f$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ toISOTime(opts = {}) {
        if (!this.isValid) return null;
        const millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = {
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended",
            ...opts,
            includeOffset: false
        };
        const dateTime = $f3842ea939e9c33f$export$82f9ebd9adeba146.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ toString() {
        return this.toISO();
    }
    /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Duration { values: ${JSON.stringify(this.values)} }`;
        else return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ toMillis() {
        if (!this.isValid) return NaN;
        return $f3842ea939e9c33f$var$durationToMillis(this.matrix, this.values);
    }
    /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromDurationLike(duration), result = {};
        for (const k of $f3842ea939e9c33f$var$orderedUnits$1)if ($f3842ea939e9c33f$var$hasOwnProperty(dur.values, k) || $f3842ea939e9c33f$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: result
        }, true);
    }
    /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromDurationLike(duration);
        return this.plus(dur.negate());
    }
    /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ mapUnits(fn) {
        if (!this.isValid) return this;
        const result = {};
        for (const k of Object.keys(this.values))result[k] = $f3842ea939e9c33f$var$asNumber(fn(this.values[k], k));
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: result
        }, true);
    }
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ get(unit) {
        return this[$f3842ea939e9c33f$export$3b11bc38611c5941.normalizeUnit(unit)];
    }
    /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ set(values) {
        if (!this.isValid) return this;
        const mixed = {
            ...this.values,
            ...$f3842ea939e9c33f$var$normalizeObject(values, $f3842ea939e9c33f$export$3b11bc38611c5941.normalizeUnit)
        };
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: mixed
        });
    }
    /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, conversionAccuracy: conversionAccuracy, matrix: matrix } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        const opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $f3842ea939e9c33f$var$clone$1(this, opts);
    }
    /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    }
    /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ normalize() {
        if (!this.isValid) return this;
        const vals = this.toObject();
        $f3842ea939e9c33f$var$normalizeValues(this.matrix, vals);
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ rescale() {
        if (!this.isValid) return this;
        const vals = $f3842ea939e9c33f$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ shiftTo(...units) {
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map((u)=>$f3842ea939e9c33f$export$3b11bc38611c5941.normalizeUnit(u));
        const built = {}, accumulated = {}, vals = this.toObject();
        let lastUnit;
        for (const k of $f3842ea939e9c33f$var$orderedUnits$1){
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                let own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(const ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($f3842ea939e9c33f$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                const i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($f3842ea939e9c33f$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(const key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $f3842ea939e9c33f$var$normalizeValues(this.matrix, built);
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: built
        }, true);
    }
    /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    }
    /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ negate() {
        if (!this.isValid) return this;
        const negated = {};
        for (const k of Object.keys(this.values))negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: negated
        }, true);
    }
    /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */ removeZeros() {
        if (!this.isValid) return this;
        const vals = $f3842ea939e9c33f$var$removeZeroes(this.values);
        return $f3842ea939e9c33f$var$clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Get the years.
   * @type {number}
   */ get years() {
        return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
   * Get the quarters.
   * @type {number}
   */ get quarters() {
        return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
   * Get the months.
   * @type {number}
   */ get months() {
        return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
   * Get the weeks
   * @type {number}
   */ get weeks() {
        return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
   * Get the days.
   * @type {number}
   */ get days() {
        return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
   * Get the hours.
   * @type {number}
   */ get hours() {
        return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
   * Get the minutes.
   * @type {number}
   */ get minutes() {
        return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
   * Get the seconds.
   * @return {number}
   */ get seconds() {
        return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
   * Get the milliseconds.
   * @return {number}
   */ get milliseconds() {
        return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for (const u of $f3842ea939e9c33f$var$orderedUnits$1){
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    }
}
const $f3842ea939e9c33f$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $f3842ea939e9c33f$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $f3842ea939e9c33f$export$e659c2681d58d45b.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $f3842ea939e9c33f$export$e659c2681d58d45b.invalid("missing or invalid end");
    else if (end < start) return $f3842ea939e9c33f$export$e659c2681d58d45b.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ class $f3842ea939e9c33f$export$e659c2681d58d45b {
    /**
   * @private
   */ constructor(config){
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new $f3842ea939e9c33f$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        const invalid = reason instanceof $f3842ea939e9c33f$var$Invalid ? reason : new $f3842ea939e9c33f$var$Invalid(reason, explanation);
        if ($f3842ea939e9c33f$export$c72f6eaae7b9adff.throwOnInvalid) throw new $f3842ea939e9c33f$var$InvalidIntervalError(invalid);
        else return new $f3842ea939e9c33f$export$e659c2681d58d45b({
            invalid: invalid
        });
    }
    /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ static fromDateTimes(start, end) {
        const builtStart = $f3842ea939e9c33f$var$friendlyDateTime(start), builtEnd = $f3842ea939e9c33f$var$friendlyDateTime(end);
        const validateError = $f3842ea939e9c33f$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new $f3842ea939e9c33f$export$e659c2681d58d45b({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    }
    /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static after(start, duration) {
        const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromDurationLike(duration), dt = $f3842ea939e9c33f$var$friendlyDateTime(start);
        return $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(dt, dt.plus(dur));
    }
    /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static before(end, duration) {
        const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromDurationLike(duration), dt = $f3842ea939e9c33f$var$friendlyDateTime(end);
        return $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(dt.minus(dur), dt);
    }
    /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ static fromISO(text, opts) {
        const [s, e] = (text || "").split("/", 2);
        if (s && e) {
            let start, startIsValid;
            try {
                start = $f3842ea939e9c33f$export$82f9ebd9adeba146.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            let end, endIsValid;
            try {
                end = $f3842ea939e9c33f$export$82f9ebd9adeba146.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(start, end);
            if (startIsValid) {
                const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromISO(e, opts);
                if (dur.isValid) return $f3842ea939e9c33f$export$e659c2681d58d45b.after(start, dur);
            } else if (endIsValid) {
                const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromISO(s, opts);
                if (dur.isValid) return $f3842ea939e9c33f$export$e659c2681d58d45b.before(end, dur);
            }
        }
        return $f3842ea939e9c33f$export$e659c2681d58d45b.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isInterval(o) {
        return o && o.isLuxonInterval || false;
    }
    /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ get start() {
        return this.isValid ? this.s : null;
    }
    /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */ get end() {
        return this.isValid ? this.e : null;
    }
    /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */ get lastDateTime() {
        return this.isValid ? this.e ? this.e.minus(1) : null : null;
    }
    /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */ get isValid() {
        return this.invalidReason === null;
    }
    /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ length(unit = "milliseconds") {
        return this.isValid ? this.toDuration(...[
            unit
        ]).get(unit) : NaN;
    }
    /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ count(unit = "milliseconds", opts) {
        if (!this.isValid) return NaN;
        const start = this.start.startOf(unit, opts);
        let end;
        if (opts?.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    }
    /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    }
    /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    }
    /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    }
    /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    }
    /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    }
    /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ set({ start: start, end: end } = {}) {
        if (!this.isValid) return this;
        return $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(start || this.s, end || this.e);
    }
    /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ splitAt(...dateTimes) {
        if (!this.isValid) return [];
        const sorted = dateTimes.map($f3842ea939e9c33f$var$friendlyDateTime).filter((d)=>this.contains(d)).sort((a, b)=>a.toMillis() - b.toMillis()), results = [];
        let { s: s } = this, i = 0;
        while(s < this.e){
            const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push($f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    }
    /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ splitBy(duration) {
        const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        let { s: s } = this, idx = 1, next;
        const results = [];
        while(s < this.e){
            const added = this.start.plus(dur.mapUnits((x)=>x * idx));
            next = +added > +this.e ? this.e : added;
            results.push($f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    }
    /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    }
    /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ overlaps(other) {
        return this.e > other.s && this.s < other.e;
    }
    /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    }
    /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    }
    /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    }
    /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    }
    /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ intersection(other) {
        if (!this.isValid) return this;
        const s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(s, e);
    }
    /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ union(other) {
        if (!this.isValid) return this;
        const s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(s, e);
    }
    /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */ static merge(intervals) {
        const [found, final] = intervals.sort((a, b)=>a.s - b.s).reduce(([sofar, current], item)=>{
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]);
        if (final) found.push(final);
        return found;
    }
    /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static xor(intervals) {
        let start = null, currentCount = 0;
        const results = [], ends = intervals.map((i)=>[
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b)=>a.time - b.time);
        for (const i of arr){
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push($f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return $f3842ea939e9c33f$export$e659c2681d58d45b.merge(results);
    }
    /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ difference(...intervals) {
        return $f3842ea939e9c33f$export$e659c2681d58d45b.xor([
            this
        ].concat(intervals)).map((i)=>this.intersection(i)).filter((i)=>i && !i.isEmpty());
    }
    /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ toString() {
        if (!this.isValid) return $f3842ea939e9c33f$var$INVALID$1;
        return `[${this.s.toISO()} \u{2013} ${this.e.toISO()})`;
    }
    /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
        else return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ toLocaleString(formatOpts = $f3842ea939e9c33f$var$DATE_SHORT, opts = {}) {
        return this.isValid ? $f3842ea939e9c33f$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $f3842ea939e9c33f$var$INVALID$1;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISO(opts) {
        if (!this.isValid) return $f3842ea939e9c33f$var$INVALID$1;
        return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ toISODate() {
        if (!this.isValid) return $f3842ea939e9c33f$var$INVALID$1;
        return `${this.s.toISODate()}/${this.e.toISODate()}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISOTime(opts) {
        if (!this.isValid) return $f3842ea939e9c33f$var$INVALID$1;
        return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
    }
    /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ toFormat(dateFormat, { separator: separator = " \u2013 " } = {}) {
        if (!this.isValid) return $f3842ea939e9c33f$var$INVALID$1;
        return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
    }
    /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ toDuration(unit, opts) {
        if (!this.isValid) return $f3842ea939e9c33f$export$3b11bc38611c5941.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    }
    /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ mapEndpoints(mapFn) {
        return $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(mapFn(this.s), mapFn(this.e));
    }
}
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ class $f3842ea939e9c33f$export$c4868e4a24d48fad {
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ static hasDST(zone = $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone) {
        const proto = $f3842ea939e9c33f$export$82f9ebd9adeba146.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    }
    /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ static isValidIANAZone(zone) {
        return $f3842ea939e9c33f$export$1204b37d5bf67239.isValidZone(zone);
    }
    /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ static normalizeZone(input) {
        return $f3842ea939e9c33f$var$normalizeZone(input, $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone);
    }
    /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ static getStartOfWeek({ locale: locale = null, locObj: locObj = null } = {}) {
        return (locObj || $f3842ea939e9c33f$var$Locale.create(locale)).getStartOfWeek();
    }
    /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ static getMinimumDaysInFirstWeek({ locale: locale = null, locObj: locObj = null } = {}) {
        return (locObj || $f3842ea939e9c33f$var$Locale.create(locale)).getMinDaysInFirstWeek();
    }
    /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ static getWeekendWeekdays({ locale: locale = null, locObj: locObj = null } = {}) {
        // copy the array, because we cache it internally
        return (locObj || $f3842ea939e9c33f$var$Locale.create(locale)).getWeekendDays().slice();
    }
    /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ static months(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || $f3842ea939e9c33f$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    }
    /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ static monthsFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || $f3842ea939e9c33f$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    }
    /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ static weekdays(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || $f3842ea939e9c33f$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    }
    /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ static weekdaysFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || $f3842ea939e9c33f$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    }
    /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ static meridiems({ locale: locale = null } = {}) {
        return $f3842ea939e9c33f$var$Locale.create(locale).meridiems();
    }
    /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ static eras(length = "short", { locale: locale = null } = {}) {
        return $f3842ea939e9c33f$var$Locale.create(locale, null, "gregory").eras(length);
    }
    /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ static features() {
        return {
            relative: $f3842ea939e9c33f$var$hasRelative(),
            localeWeek: $f3842ea939e9c33f$var$hasLocaleWeekInfo()
        };
    }
}
function $f3842ea939e9c33f$var$dayDiff(earlier, later) {
    const utcDayStart = (dt)=>dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($f3842ea939e9c33f$export$3b11bc38611c5941.fromMillis(ms).as("days"));
}
function $f3842ea939e9c33f$var$highOrderDiffs(cursor, later, units) {
    const differs = [
        [
            "years",
            (a, b)=>b.year - a.year
        ],
        [
            "quarters",
            (a, b)=>b.quarter - a.quarter + (b.year - a.year) * 4
        ],
        [
            "months",
            (a, b)=>b.month - a.month + (b.year - a.year) * 12
        ],
        [
            "weeks",
            (a, b)=>{
                const days = $f3842ea939e9c33f$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $f3842ea939e9c33f$var$dayDiff
        ]
    ];
    const results = {};
    const earlier = cursor;
    let lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for (const [unit, differ] of differs)if (units.indexOf(unit) >= 0) {
        lowestOrder = unit;
        results[unit] = differ(cursor, later);
        highWater = earlier.plus(results);
        if (highWater > later) {
            // we overshot the end point, backtrack cursor by 1
            results[unit]--;
            cursor = earlier.plus(results);
            // if we are still overshooting now, we need to backtrack again
            // this happens in certain situations when diffing times in different zones,
            // because this calculation ignores time zones
            if (cursor > later) {
                // keep the "overshot by 1" around as highWater
                highWater = cursor;
                // backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
            }
        } else cursor = highWater;
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $f3842ea939e9c33f$var$diff(earlier, later, units, opts) {
    let [cursor, results, highWater, lowestOrder] = $f3842ea939e9c33f$var$highOrderDiffs(earlier, later, units);
    const remainingMillis = later - cursor;
    const lowerOrderUnits = units.filter((u)=>[
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0);
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) highWater = cursor.plus({
            [lowestOrder]: 1
        });
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    const duration = $f3842ea939e9c33f$export$3b11bc38611c5941.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) return $f3842ea939e9c33f$export$3b11bc38611c5941.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
    else return duration;
}
const $f3842ea939e9c33f$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $f3842ea939e9c33f$var$intUnit(regex, post = (i)=>i) {
    return {
        regex: regex,
        deser: ([s])=>post($f3842ea939e9c33f$var$parseDigits(s))
    };
}
const $f3842ea939e9c33f$var$NBSP = String.fromCharCode(160);
const $f3842ea939e9c33f$var$spaceOrNBSP = `[ ${$f3842ea939e9c33f$var$NBSP}]`;
const $f3842ea939e9c33f$var$spaceOrNBSPRegExp = new RegExp($f3842ea939e9c33f$var$spaceOrNBSP, "g");
function $f3842ea939e9c33f$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($f3842ea939e9c33f$var$spaceOrNBSPRegExp, $f3842ea939e9c33f$var$spaceOrNBSP);
}
function $f3842ea939e9c33f$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($f3842ea939e9c33f$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $f3842ea939e9c33f$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($f3842ea939e9c33f$var$fixListRegex).join("|")),
        deser: ([s])=>strings.findIndex((i)=>$f3842ea939e9c33f$var$stripInsensitivities(s) === $f3842ea939e9c33f$var$stripInsensitivities(i)) + startIndex
    };
}
function $f3842ea939e9c33f$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: ([, h, m])=>$f3842ea939e9c33f$var$signedOffset(h, m),
        groups: groups
    };
}
function $f3842ea939e9c33f$var$simple(regex) {
    return {
        regex: regex,
        deser: ([s])=>s
    };
}
function $f3842ea939e9c33f$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $f3842ea939e9c33f$var$unitForToken(token, loc) {
    const one = $f3842ea939e9c33f$var$digitRegex(loc), two = $f3842ea939e9c33f$var$digitRegex(loc, "{2}"), three = $f3842ea939e9c33f$var$digitRegex(loc, "{3}"), four = $f3842ea939e9c33f$var$digitRegex(loc, "{4}"), six = $f3842ea939e9c33f$var$digitRegex(loc, "{6}"), oneOrTwo = $f3842ea939e9c33f$var$digitRegex(loc, "{1,2}"), oneToThree = $f3842ea939e9c33f$var$digitRegex(loc, "{1,3}"), oneToSix = $f3842ea939e9c33f$var$digitRegex(loc, "{1,6}"), oneToNine = $f3842ea939e9c33f$var$digitRegex(loc, "{1,9}"), twoToFour = $f3842ea939e9c33f$var$digitRegex(loc, "{2,4}"), fourToSix = $f3842ea939e9c33f$var$digitRegex(loc, "{4,6}"), literal = (t)=>({
            regex: RegExp($f3842ea939e9c33f$var$escapeToken(t.val)),
            deser: ([s])=>s,
            literal: true
        }), unitate = (t)=>{
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $f3842ea939e9c33f$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $f3842ea939e9c33f$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $f3842ea939e9c33f$var$intUnit(oneToSix);
            case "yy":
                return $f3842ea939e9c33f$var$intUnit(twoToFour, $f3842ea939e9c33f$var$untruncateYear);
            case "yyyy":
                return $f3842ea939e9c33f$var$intUnit(four);
            case "yyyyy":
                return $f3842ea939e9c33f$var$intUnit(fourToSix);
            case "yyyyyy":
                return $f3842ea939e9c33f$var$intUnit(six);
            // months
            case "M":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "MM":
                return $f3842ea939e9c33f$var$intUnit(two);
            case "MMM":
                return $f3842ea939e9c33f$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $f3842ea939e9c33f$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "LL":
                return $f3842ea939e9c33f$var$intUnit(two);
            case "LLL":
                return $f3842ea939e9c33f$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $f3842ea939e9c33f$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "dd":
                return $f3842ea939e9c33f$var$intUnit(two);
            // ordinals
            case "o":
                return $f3842ea939e9c33f$var$intUnit(oneToThree);
            case "ooo":
                return $f3842ea939e9c33f$var$intUnit(three);
            // time
            case "HH":
                return $f3842ea939e9c33f$var$intUnit(two);
            case "H":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "hh":
                return $f3842ea939e9c33f$var$intUnit(two);
            case "h":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "mm":
                return $f3842ea939e9c33f$var$intUnit(two);
            case "m":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "q":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "qq":
                return $f3842ea939e9c33f$var$intUnit(two);
            case "s":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "ss":
                return $f3842ea939e9c33f$var$intUnit(two);
            case "S":
                return $f3842ea939e9c33f$var$intUnit(oneToThree);
            case "SSS":
                return $f3842ea939e9c33f$var$intUnit(three);
            case "u":
                return $f3842ea939e9c33f$var$simple(oneToNine);
            case "uu":
                return $f3842ea939e9c33f$var$simple(oneOrTwo);
            case "uuu":
                return $f3842ea939e9c33f$var$intUnit(one);
            // meridiem
            case "a":
                return $f3842ea939e9c33f$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $f3842ea939e9c33f$var$intUnit(four);
            case "kk":
                return $f3842ea939e9c33f$var$intUnit(twoToFour, $f3842ea939e9c33f$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $f3842ea939e9c33f$var$intUnit(oneOrTwo);
            case "WW":
                return $f3842ea939e9c33f$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $f3842ea939e9c33f$var$intUnit(one);
            case "EEE":
                return $f3842ea939e9c33f$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $f3842ea939e9c33f$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $f3842ea939e9c33f$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $f3842ea939e9c33f$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $f3842ea939e9c33f$var$offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
            case "ZZZ":
                return $f3842ea939e9c33f$var$offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $f3842ea939e9c33f$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $f3842ea939e9c33f$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    const unit = unitate(token) || {
        invalidReason: $f3842ea939e9c33f$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
const $f3842ea939e9c33f$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $f3842ea939e9c33f$var$tokenForPart(part, formatOpts, resolvedOpts) {
    const { type: type, value: value } = part;
    if (type === "literal") {
        const isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    const style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    let actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    let val = $f3842ea939e9c33f$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $f3842ea939e9c33f$var$buildRegex(units) {
    const re = units.map((u)=>u.regex).reduce((f, r)=>`${f}(${r.source})`, "");
    return [
        `^${re}$`,
        units
    ];
}
function $f3842ea939e9c33f$var$match(input, regex, handlers) {
    const matches = input.match(regex);
    if (matches) {
        const all = {};
        let matchIndex = 1;
        for(const i in handlers)if ($f3842ea939e9c33f$var$hasOwnProperty(handlers, i)) {
            const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $f3842ea939e9c33f$var$dateTimeFromMatches(matches) {
    const toField = (token)=>{
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    let zone = null;
    let specificOffset;
    if (!$f3842ea939e9c33f$var$isUndefined(matches.z)) zone = $f3842ea939e9c33f$export$1204b37d5bf67239.create(matches.z);
    if (!$f3842ea939e9c33f$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $f3842ea939e9c33f$export$c89026e47e943b6f(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$f3842ea939e9c33f$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$f3842ea939e9c33f$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$f3842ea939e9c33f$var$isUndefined(matches.u)) matches.S = $f3842ea939e9c33f$var$parseMillis(matches.u);
    const vals = Object.keys(matches).reduce((r, k)=>{
        const f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
let $f3842ea939e9c33f$var$dummyDateTimeCache = null;
function $f3842ea939e9c33f$var$getDummyDateTime() {
    if (!$f3842ea939e9c33f$var$dummyDateTimeCache) $f3842ea939e9c33f$var$dummyDateTimeCache = $f3842ea939e9c33f$export$82f9ebd9adeba146.fromMillis(1555555555555);
    return $f3842ea939e9c33f$var$dummyDateTimeCache;
}
function $f3842ea939e9c33f$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    const formatOpts = $f3842ea939e9c33f$var$Formatter.macroTokenToFormatOpts(token.val);
    const tokens = $f3842ea939e9c33f$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $f3842ea939e9c33f$var$expandMacroTokens(tokens, locale) {
    return Array.prototype.concat(...tokens.map((t)=>$f3842ea939e9c33f$var$maybeExpandMacroToken(t, locale)));
}
/**
 * @private
 */ class $f3842ea939e9c33f$var$TokenParser {
    constructor(locale, format){
        this.locale = locale;
        this.format = format;
        this.tokens = $f3842ea939e9c33f$var$expandMacroTokens($f3842ea939e9c33f$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map((t)=>$f3842ea939e9c33f$var$unitForToken(t, locale));
        this.disqualifyingUnit = this.units.find((t)=>t.invalidReason);
        if (!this.disqualifyingUnit) {
            const [regexString, handlers] = $f3842ea939e9c33f$var$buildRegex(this.units);
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            const [rawMatches, matches] = $f3842ea939e9c33f$var$match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? $f3842ea939e9c33f$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ];
            if ($f3842ea939e9c33f$var$hasOwnProperty(matches, "a") && $f3842ea939e9c33f$var$hasOwnProperty(matches, "H")) throw new $f3842ea939e9c33f$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    }
    get isValid() {
        return !this.disqualifyingUnit;
    }
    get invalidReason() {
        return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
    }
}
function $f3842ea939e9c33f$var$explainFromTokens(locale, input, format) {
    const parser = new $f3842ea939e9c33f$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $f3842ea939e9c33f$var$parseFromTokens(locale, input, format) {
    const { result: result, zone: zone, specificOffset: specificOffset, invalidReason: invalidReason } = $f3842ea939e9c33f$var$explainFromTokens(locale, input, format);
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $f3842ea939e9c33f$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    const formatter = $f3842ea939e9c33f$var$Formatter.create(locale, formatOpts);
    const df = formatter.dtFormatter($f3842ea939e9c33f$var$getDummyDateTime());
    const parts = df.formatToParts();
    const resolvedOpts = df.resolvedOptions();
    return parts.map((p)=>$f3842ea939e9c33f$var$tokenForPart(p, formatOpts, resolvedOpts));
}
const $f3842ea939e9c33f$var$INVALID = "Invalid DateTime";
const $f3842ea939e9c33f$var$MAX_DATE = 8.64e15;
function $f3842ea939e9c33f$var$unsupportedZone(zone) {
    return new $f3842ea939e9c33f$var$Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $f3842ea939e9c33f$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $f3842ea939e9c33f$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $f3842ea939e9c33f$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $f3842ea939e9c33f$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $f3842ea939e9c33f$var$clone(inst, alts) {
    const current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $f3842ea939e9c33f$export$82f9ebd9adeba146({
        ...current,
        ...alts,
        old: current
    });
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $f3842ea939e9c33f$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    const o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    const o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $f3842ea939e9c33f$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    const d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $f3842ea939e9c33f$var$objToTS(obj, offset, zone) {
    return $f3842ea939e9c33f$var$fixOffset($f3842ea939e9c33f$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $f3842ea939e9c33f$var$adjustTime(inst, dur) {
    const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
        ...inst.c,
        year: year,
        month: month,
        day: Math.min(inst.c.day, $f3842ea939e9c33f$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }, millisToAdd = $f3842ea939e9c33f$export$3b11bc38611c5941.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $f3842ea939e9c33f$var$objToLocalTS(c);
    let [ts, o] = $f3842ea939e9c33f$var$fixOffset(localTS, oPre, inst.zone);
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $f3842ea939e9c33f$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    const { setZone: setZone, zone: zone } = opts;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        const interpretationZone = parsedZone || zone, inst = $f3842ea939e9c33f$export$82f9ebd9adeba146.fromObject(parsed, {
            ...opts,
            zone: interpretationZone,
            specificOffset: specificOffset
        });
        return setZone ? inst : inst.setZone(zone);
    } else return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid(new $f3842ea939e9c33f$var$Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $f3842ea939e9c33f$var$toTechFormat(dt, format, allowZ = true) {
    return dt.isValid ? $f3842ea939e9c33f$var$Formatter.create($f3842ea939e9c33f$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $f3842ea939e9c33f$var$toISODate(o, extended, precision) {
    const longFormat = o.c.year > 9999 || o.c.year < 0;
    let c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $f3842ea939e9c33f$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += $f3842ea939e9c33f$var$padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += $f3842ea939e9c33f$var$padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += $f3842ea939e9c33f$var$padStart(o.c.day);
    return c;
}
function $f3842ea939e9c33f$var$toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += $f3842ea939e9c33f$var$padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += $f3842ea939e9c33f$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += $f3842ea939e9c33f$var$padStart(o.c.second);
                }
            } else {
                c += $f3842ea939e9c33f$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += $f3842ea939e9c33f$var$padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += $f3842ea939e9c33f$var$padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $f3842ea939e9c33f$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $f3842ea939e9c33f$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $f3842ea939e9c33f$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $f3842ea939e9c33f$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
const $f3842ea939e9c33f$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $f3842ea939e9c33f$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $f3842ea939e9c33f$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
const $f3842ea939e9c33f$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $f3842ea939e9c33f$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $f3842ea939e9c33f$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $f3842ea939e9c33f$var$normalizeUnit(unit) {
    const normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $f3842ea939e9c33f$var$InvalidUnitError(unit);
    return normalized;
}
function $f3842ea939e9c33f$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $f3842ea939e9c33f$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function $f3842ea939e9c33f$var$guessOffsetForZone(zone) {
    if ($f3842ea939e9c33f$var$zoneOffsetTs === undefined) $f3842ea939e9c33f$var$zoneOffsetTs = $f3842ea939e9c33f$export$c72f6eaae7b9adff.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset($f3842ea939e9c33f$var$zoneOffsetTs);
    const zoneName = zone.name;
    let offsetGuess = $f3842ea939e9c33f$var$zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset($f3842ea939e9c33f$var$zoneOffsetTs);
        $f3842ea939e9c33f$var$zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $f3842ea939e9c33f$var$quickDT(obj, opts) {
    const zone = $f3842ea939e9c33f$var$normalizeZone(opts.zone, $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone);
    if (!zone.isValid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid($f3842ea939e9c33f$var$unsupportedZone(zone));
    const loc = $f3842ea939e9c33f$var$Locale.fromObject(opts);
    let ts, o;
    // assume we have the higher-order units
    if (!$f3842ea939e9c33f$var$isUndefined(obj.year)) {
        for (const u of $f3842ea939e9c33f$var$orderedUnits)if ($f3842ea939e9c33f$var$isUndefined(obj[u])) obj[u] = $f3842ea939e9c33f$var$defaultUnitValues[u];
        const invalid = $f3842ea939e9c33f$var$hasInvalidGregorianData(obj) || $f3842ea939e9c33f$var$hasInvalidTimeData(obj);
        if (invalid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid(invalid);
        const offsetProvis = $f3842ea939e9c33f$var$guessOffsetForZone(zone);
        [ts, o] = $f3842ea939e9c33f$var$objToTS(obj, offsetProvis, zone);
    } else ts = $f3842ea939e9c33f$export$c72f6eaae7b9adff.now();
    return new $f3842ea939e9c33f$export$82f9ebd9adeba146({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $f3842ea939e9c33f$var$diffRelative(start, end, opts) {
    const round = $f3842ea939e9c33f$var$isUndefined(opts.round) ? true : opts.round, rounding = $f3842ea939e9c33f$var$isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = (c, unit)=>{
        c = $f3842ea939e9c33f$var$roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        const formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = (unit)=>{
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for (const unit of opts.units){
        const count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $f3842ea939e9c33f$var$lastOpts(argList) {
    let opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ let $f3842ea939e9c33f$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ const $f3842ea939e9c33f$var$zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ class $f3842ea939e9c33f$export$82f9ebd9adeba146 {
    /**
   * @access private
   */ constructor(config){
        const zone = config.zone || $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone;
        let invalid = config.invalid || (Number.isNaN(config.ts) ? new $f3842ea939e9c33f$var$Invalid("invalid input") : null) || (!zone.isValid ? $f3842ea939e9c33f$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $f3842ea939e9c33f$var$isUndefined(config.ts) ? $f3842ea939e9c33f$export$c72f6eaae7b9adff.now() : config.ts;
        let c = null, o = null;
        if (!invalid) {
            const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) [c, o] = [
                config.old.c,
                config.old.o
            ];
            else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                const ot = $f3842ea939e9c33f$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $f3842ea939e9c33f$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $f3842ea939e9c33f$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $f3842ea939e9c33f$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ static now() {
        return new $f3842ea939e9c33f$export$82f9ebd9adeba146({});
    }
    /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ static local() {
        const [opts, args] = $f3842ea939e9c33f$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        return $f3842ea939e9c33f$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ static utc() {
        const [opts, args] = $f3842ea939e9c33f$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        opts.zone = $f3842ea939e9c33f$export$c89026e47e943b6f.utcInstance;
        return $f3842ea939e9c33f$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ static fromJSDate(date, options = {}) {
        const ts = $f3842ea939e9c33f$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid("invalid input");
        const zoneToUse = $f3842ea939e9c33f$var$normalizeZone(options.zone, $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone);
        if (!zoneToUse.isValid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid($f3842ea939e9c33f$var$unsupportedZone(zoneToUse));
        return new $f3842ea939e9c33f$export$82f9ebd9adeba146({
            ts: ts,
            zone: zoneToUse,
            loc: $f3842ea939e9c33f$var$Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromMillis(milliseconds, options = {}) {
        if (!$f3842ea939e9c33f$var$isNumber(milliseconds)) throw new $f3842ea939e9c33f$var$InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
        else if (milliseconds < -$f3842ea939e9c33f$var$MAX_DATE || milliseconds > $f3842ea939e9c33f$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid("Timestamp out of range");
        else return new $f3842ea939e9c33f$export$82f9ebd9adeba146({
            ts: milliseconds,
            zone: $f3842ea939e9c33f$var$normalizeZone(options.zone, $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone),
            loc: $f3842ea939e9c33f$var$Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromSeconds(seconds, options = {}) {
        if (!$f3842ea939e9c33f$var$isNumber(seconds)) throw new $f3842ea939e9c33f$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new $f3842ea939e9c33f$export$82f9ebd9adeba146({
            ts: seconds * 1000,
            zone: $f3842ea939e9c33f$var$normalizeZone(options.zone, $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone),
            loc: $f3842ea939e9c33f$var$Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ static fromObject(obj, opts = {}) {
        obj = obj || {};
        const zoneToUse = $f3842ea939e9c33f$var$normalizeZone(opts.zone, $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone);
        if (!zoneToUse.isValid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid($f3842ea939e9c33f$var$unsupportedZone(zoneToUse));
        const loc = $f3842ea939e9c33f$var$Locale.fromObject(opts);
        const normalized = $f3842ea939e9c33f$var$normalizeObject(obj, $f3842ea939e9c33f$var$normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek: minDaysInFirstWeek, startOfWeek: startOfWeek } = $f3842ea939e9c33f$var$usesLocalWeekValues(normalized, loc);
        const tsNow = $f3842ea939e9c33f$export$c72f6eaae7b9adff.now(), offsetProvis = !$f3842ea939e9c33f$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$f3842ea939e9c33f$var$isUndefined(normalized.ordinal), containsGregorYear = !$f3842ea939e9c33f$var$isUndefined(normalized.year), containsGregorMD = !$f3842ea939e9c33f$var$isUndefined(normalized.month) || !$f3842ea939e9c33f$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $f3842ea939e9c33f$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $f3842ea939e9c33f$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        let units, defaultValues, objNow = $f3842ea939e9c33f$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $f3842ea939e9c33f$var$orderedWeekUnits;
            defaultValues = $f3842ea939e9c33f$var$defaultWeekUnitValues;
            objNow = $f3842ea939e9c33f$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $f3842ea939e9c33f$var$orderedOrdinalUnits;
            defaultValues = $f3842ea939e9c33f$var$defaultOrdinalUnitValues;
            objNow = $f3842ea939e9c33f$var$gregorianToOrdinal(objNow);
        } else {
            units = $f3842ea939e9c33f$var$orderedUnits;
            defaultValues = $f3842ea939e9c33f$var$defaultUnitValues;
        }
        // set default values for missing stuff
        let foundFirst = false;
        for (const u of units){
            const v = normalized[u];
            if (!$f3842ea939e9c33f$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        const higherOrderInvalid = useWeekData ? $f3842ea939e9c33f$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $f3842ea939e9c33f$var$hasInvalidOrdinalData(normalized) : $f3842ea939e9c33f$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $f3842ea939e9c33f$var$hasInvalidTimeData(normalized);
        if (invalid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid(invalid);
        // compute the actual time
        const gregorian = useWeekData ? $f3842ea939e9c33f$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $f3842ea939e9c33f$var$ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = $f3842ea939e9c33f$var$objToTS(gregorian, offsetProvis, zoneToUse), inst = new $f3842ea939e9c33f$export$82f9ebd9adeba146({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
        if (!inst.isValid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid(inst.invalid);
        return inst;
    }
    /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ static fromISO(text, opts = {}) {
        const [vals, parsedZone] = $f3842ea939e9c33f$var$parseISODate(text);
        return $f3842ea939e9c33f$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    }
    /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ static fromRFC2822(text, opts = {}) {
        const [vals, parsedZone] = $f3842ea939e9c33f$var$parseRFC2822Date(text);
        return $f3842ea939e9c33f$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    }
    /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ static fromHTTP(text, opts = {}) {
        const [vals, parsedZone] = $f3842ea939e9c33f$var$parseHTTPDate(text);
        return $f3842ea939e9c33f$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    }
    /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromFormat(text, fmt, opts = {}) {
        if ($f3842ea939e9c33f$var$isUndefined(text) || $f3842ea939e9c33f$var$isUndefined(fmt)) throw new $f3842ea939e9c33f$var$InvalidArgumentError("fromFormat requires an input string and a format");
        const { locale: locale = null, numberingSystem: numberingSystem = null } = opts, localeToUse = $f3842ea939e9c33f$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), [vals, parsedZone, specificOffset, invalid] = $f3842ea939e9c33f$var$parseFromTokens(localeToUse, text, fmt);
        if (invalid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid(invalid);
        else return $f3842ea939e9c33f$var$parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
    /**
   * @deprecated use fromFormat instead
   */ static fromString(text, fmt, opts = {}) {
        return $f3842ea939e9c33f$export$82f9ebd9adeba146.fromFormat(text, fmt, opts);
    }
    /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ static fromSQL(text, opts = {}) {
        const [vals, parsedZone] = $f3842ea939e9c33f$var$parseSQL(text);
        return $f3842ea939e9c33f$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    }
    /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new $f3842ea939e9c33f$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        const invalid = reason instanceof $f3842ea939e9c33f$var$Invalid ? reason : new $f3842ea939e9c33f$var$Invalid(reason, explanation);
        if ($f3842ea939e9c33f$export$c72f6eaae7b9adff.throwOnInvalid) throw new $f3842ea939e9c33f$var$InvalidDateTimeError(invalid);
        else return new $f3842ea939e9c33f$export$82f9ebd9adeba146({
            invalid: invalid
        });
    }
    /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    }
    /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ static parseFormatForOpts(formatOpts, localeOpts = {}) {
        const tokenList = $f3842ea939e9c33f$var$formatOptsToTokens(formatOpts, $f3842ea939e9c33f$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map((t)=>t ? t.val : null).join("");
    }
    /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ static expandFormat(fmt, localeOpts = {}) {
        const expanded = $f3842ea939e9c33f$var$expandMacroTokens($f3842ea939e9c33f$var$Formatter.parseFormat(fmt), $f3842ea939e9c33f$var$Locale.fromObject(localeOpts));
        return expanded.map((t)=>t.val).join("");
    }
    static resetCache() {
        $f3842ea939e9c33f$var$zoneOffsetTs = undefined;
        $f3842ea939e9c33f$var$zoneOffsetGuessCache.clear();
    }
    // INFO
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ get(unit) {
        return this[unit];
    }
    /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */ get outputCalendar() {
        return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */ get zone() {
        return this._zone;
    }
    /**
   * Get the name of the time zone.
   * @type {string}
   */ get zoneName() {
        return this.isValid ? this.zone.name : null;
    }
    /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */ get year() {
        return this.isValid ? this.c.year : NaN;
    }
    /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */ get quarter() {
        return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */ get month() {
        return this.isValid ? this.c.month : NaN;
    }
    /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */ get day() {
        return this.isValid ? this.c.day : NaN;
    }
    /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */ get hour() {
        return this.isValid ? this.c.hour : NaN;
    }
    /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */ get minute() {
        return this.isValid ? this.c.minute : NaN;
    }
    /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */ get second() {
        return this.isValid ? this.c.second : NaN;
    }
    /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */ get millisecond() {
        return this.isValid ? this.c.millisecond : NaN;
    }
    /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */ get weekYear() {
        return this.isValid ? $f3842ea939e9c33f$var$possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */ get weekNumber() {
        return this.isValid ? $f3842ea939e9c33f$var$possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */ get weekday() {
        return this.isValid ? $f3842ea939e9c33f$var$possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */ get isWeekend() {
        return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }
    /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */ get localWeekday() {
        return this.isValid ? $f3842ea939e9c33f$var$possiblyCachedLocalWeekData(this).weekday : NaN;
    }
    /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */ get localWeekNumber() {
        return this.isValid ? $f3842ea939e9c33f$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */ get localWeekYear() {
        return this.isValid ? $f3842ea939e9c33f$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
    }
    /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */ get ordinal() {
        return this.isValid ? $f3842ea939e9c33f$var$gregorianToOrdinal(this.c).ordinal : NaN;
    }
    /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */ get monthShort() {
        return this.isValid ? $f3842ea939e9c33f$export$c4868e4a24d48fad.months("short", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */ get monthLong() {
        return this.isValid ? $f3842ea939e9c33f$export$c4868e4a24d48fad.months("long", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */ get weekdayShort() {
        return this.isValid ? $f3842ea939e9c33f$export$c4868e4a24d48fad.weekdays("short", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */ get weekdayLong() {
        return this.isValid ? $f3842ea939e9c33f$export$c4868e4a24d48fad.weekdays("long", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */ get offset() {
        return this.isValid ? +this.o : NaN;
    }
    /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameShort() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "short",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameLong() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "long",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */ get isOffsetFixed() {
        return this.isValid ? this.zone.isUniversal : null;
    }
    /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */ get isInDST() {
        if (this.isOffsetFixed) return false;
        else return this.offset > this.set({
            month: 1,
            day: 1
        }).offset || this.offset > this.set({
            month: 5
        }).offset;
    }
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        const dayMs = 86400000;
        const minuteMs = 60000;
        const localTS = $f3842ea939e9c33f$var$objToLocalTS(this.c);
        const oEarlier = this.zone.offset(localTS - dayMs);
        const oLater = this.zone.offset(localTS + dayMs);
        const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        const o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        const ts1 = localTS - o1 * minuteMs;
        const ts2 = localTS - o2 * minuteMs;
        const c1 = $f3842ea939e9c33f$var$tsToObj(ts1, o1);
        const c2 = $f3842ea939e9c33f$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $f3842ea939e9c33f$var$clone(this, {
                ts: ts1
            }),
            $f3842ea939e9c33f$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    }
    /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ get isInLeapYear() {
        return $f3842ea939e9c33f$var$isLeapYear(this.year);
    }
    /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */ get daysInMonth() {
        return $f3842ea939e9c33f$var$daysInMonth(this.year, this.month);
    }
    /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */ get daysInYear() {
        return this.isValid ? $f3842ea939e9c33f$var$daysInYear(this.year) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */ get weeksInWeekYear() {
        return this.isValid ? $f3842ea939e9c33f$var$weeksInWeekYear(this.weekYear) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */ get weeksInLocalWeekYear() {
        return this.isValid ? $f3842ea939e9c33f$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ resolvedLocaleOptions(opts = {}) {
        const { locale: locale, numberingSystem: numberingSystem, calendar: calendar } = $f3842ea939e9c33f$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    }
    // TRANSFORM
    /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ toUTC(offset = 0, opts = {}) {
        return this.setZone($f3842ea939e9c33f$export$c89026e47e943b6f.instance(offset), opts);
    }
    /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ toLocal() {
        return this.setZone($f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone);
    }
    /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ setZone(zone, { keepLocalTime: keepLocalTime = false, keepCalendarTime: keepCalendarTime = false } = {}) {
        zone = $f3842ea939e9c33f$var$normalizeZone(zone, $f3842ea939e9c33f$export$c72f6eaae7b9adff.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid($f3842ea939e9c33f$var$unsupportedZone(zone));
        else {
            let newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                const offsetGuess = zone.offset(this.ts);
                const asObj = this.toObject();
                [newTS] = $f3842ea939e9c33f$var$objToTS(asObj, offsetGuess, zone);
            }
            return $f3842ea939e9c33f$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    }
    /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $f3842ea939e9c33f$var$clone(this, {
            loc: loc
        });
    }
    /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    }
    /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ set(values) {
        if (!this.isValid) return this;
        const normalized = $f3842ea939e9c33f$var$normalizeObject(values, $f3842ea939e9c33f$var$normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek: minDaysInFirstWeek, startOfWeek: startOfWeek } = $f3842ea939e9c33f$var$usesLocalWeekValues(normalized, this.loc);
        const settingWeekStuff = !$f3842ea939e9c33f$var$isUndefined(normalized.weekYear) || !$f3842ea939e9c33f$var$isUndefined(normalized.weekNumber) || !$f3842ea939e9c33f$var$isUndefined(normalized.weekday), containsOrdinal = !$f3842ea939e9c33f$var$isUndefined(normalized.ordinal), containsGregorYear = !$f3842ea939e9c33f$var$isUndefined(normalized.year), containsGregorMD = !$f3842ea939e9c33f$var$isUndefined(normalized.month) || !$f3842ea939e9c33f$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $f3842ea939e9c33f$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $f3842ea939e9c33f$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        let mixed;
        if (settingWeekStuff) mixed = $f3842ea939e9c33f$var$weekToGregorian({
            ...$f3842ea939e9c33f$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek),
            ...normalized
        }, minDaysInFirstWeek, startOfWeek);
        else if (!$f3842ea939e9c33f$var$isUndefined(normalized.ordinal)) mixed = $f3842ea939e9c33f$var$ordinalToGregorian({
            ...$f3842ea939e9c33f$var$gregorianToOrdinal(this.c),
            ...normalized
        });
        else {
            mixed = {
                ...this.toObject(),
                ...normalized
            };
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($f3842ea939e9c33f$var$isUndefined(normalized.day)) mixed.day = Math.min($f3842ea939e9c33f$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        const [ts, o] = $f3842ea939e9c33f$var$objToTS(mixed, this.o, this.zone);
        return $f3842ea939e9c33f$var$clone(this, {
            ts: ts,
            o: o
        });
    }
    /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromDurationLike(duration);
        return $f3842ea939e9c33f$var$clone(this, $f3842ea939e9c33f$var$adjustTime(this, dur));
    }
    /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = $f3842ea939e9c33f$export$3b11bc38611c5941.fromDurationLike(duration).negate();
        return $f3842ea939e9c33f$var$clone(this, $f3842ea939e9c33f$var$adjustTime(this, dur));
    }
    /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ startOf(unit, { useLocaleWeeks: useLocaleWeeks = false } = {}) {
        if (!this.isValid) return this;
        const o = {}, normalizedUnit = $f3842ea939e9c33f$export$3b11bc38611c5941.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                const startOfWeek = this.loc.getStartOfWeek();
                const { weekday: weekday } = this;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            const q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    }
    /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ endOf(unit, opts) {
        return this.isValid ? this.plus({
            [unit]: 1
        }).startOf(unit, opts).minus(1) : this;
    }
    // OUTPUT
    /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        return this.isValid ? $f3842ea939e9c33f$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $f3842ea939e9c33f$var$INVALID;
    }
    /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ toLocaleString(formatOpts = $f3842ea939e9c33f$var$DATE_SHORT, opts = {}) {
        return this.isValid ? $f3842ea939e9c33f$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $f3842ea939e9c33f$var$INVALID;
    }
    /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ toLocaleParts(opts = {}) {
        return this.isValid ? $f3842ea939e9c33f$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */ toISO({ format: format = "extended", suppressSeconds: suppressSeconds = false, suppressMilliseconds: suppressMilliseconds = false, includeOffset: includeOffset = true, extendedZone: extendedZone = false, precision: precision = "milliseconds" } = {}) {
        if (!this.isValid) return null;
        precision = $f3842ea939e9c33f$var$normalizeUnit(precision);
        const ext = format === "extended";
        let c = $f3842ea939e9c33f$var$toISODate(this, ext, precision);
        if ($f3842ea939e9c33f$var$orderedUnits.indexOf(precision) >= 3) c += "T";
        c += $f3842ea939e9c33f$var$toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */ toISODate({ format: format = "extended", precision: precision = "day" } = {}) {
        if (!this.isValid) return null;
        return $f3842ea939e9c33f$var$toISODate(this, format === "extended", $f3842ea939e9c33f$var$normalizeUnit(precision));
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ toISOWeekDate() {
        return $f3842ea939e9c33f$var$toTechFormat(this, "kkkk-'W'WW-c");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */ toISOTime({ suppressMilliseconds: suppressMilliseconds = false, suppressSeconds: suppressSeconds = false, includeOffset: includeOffset = true, includePrefix: includePrefix = false, extendedZone: extendedZone = false, format: format = "extended", precision: precision = "milliseconds" } = {}) {
        if (!this.isValid) return null;
        precision = $f3842ea939e9c33f$var$normalizeUnit(precision);
        let c = includePrefix && $f3842ea939e9c33f$var$orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + $f3842ea939e9c33f$var$toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    }
    /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ toRFC2822() {
        return $f3842ea939e9c33f$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ toHTTP() {
        return $f3842ea939e9c33f$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */ toSQLDate() {
        if (!this.isValid) return null;
        return $f3842ea939e9c33f$var$toISODate(this, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ toSQLTime({ includeOffset: includeOffset = true, includeZone: includeZone = false, includeOffsetSpace: includeOffsetSpace = true } = {}) {
        let fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $f3842ea939e9c33f$var$toTechFormat(this, fmt, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ toSQL(opts = {}) {
        if (!this.isValid) return null;
        return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
    }
    /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ toString() {
        return this.isValid ? this.toISO() : $f3842ea939e9c33f$var$INVALID;
    }
    /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
        else return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ toMillis() {
        return this.isValid ? this.ts : NaN;
    }
    /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */ toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    }
    /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    }
    /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ toBSON() {
        return this.toJSDate();
    }
    /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ toObject(opts = {}) {
        if (!this.isValid) return {};
        const base = {
            ...this.c
        };
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    }
    /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    }
    // COMPARE
    /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ diff(otherDateTime, unit = "milliseconds", opts = {}) {
        if (!this.isValid || !otherDateTime.isValid) return $f3842ea939e9c33f$export$3b11bc38611c5941.invalid("created by diffing an invalid DateTime");
        const durOpts = {
            locale: this.locale,
            numberingSystem: this.numberingSystem,
            ...opts
        };
        const units = $f3842ea939e9c33f$var$maybeArray(unit).map($f3842ea939e9c33f$export$3b11bc38611c5941.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $f3842ea939e9c33f$var$diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    }
    /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ diffNow(unit = "milliseconds", opts = {}) {
        return this.diff($f3842ea939e9c33f$export$82f9ebd9adeba146.now(), unit, opts);
    }
    /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */ until(otherDateTime) {
        return this.isValid ? $f3842ea939e9c33f$export$e659c2681d58d45b.fromDateTimes(this, otherDateTime) : this;
    }
    /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        const inputMs = otherDateTime.valueOf();
        const adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    }
    /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    }
    /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ toRelative(options = {}) {
        if (!this.isValid) return null;
        const base = options.base || $f3842ea939e9c33f$export$82f9ebd9adeba146.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        let units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        let unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $f3842ea939e9c33f$var$diffRelative(base, this.plus(padding), {
            ...options,
            numeric: "always",
            units: units,
            unit: unit
        });
    }
    /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ toRelativeCalendar(options = {}) {
        if (!this.isValid) return null;
        return $f3842ea939e9c33f$var$diffRelative(options.base || $f3842ea939e9c33f$export$82f9ebd9adeba146.fromObject({}, {
            zone: this.zone
        }), this, {
            ...options,
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        });
    }
    /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ static min(...dateTimes) {
        if (!dateTimes.every($f3842ea939e9c33f$export$82f9ebd9adeba146.isDateTime)) throw new $f3842ea939e9c33f$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $f3842ea939e9c33f$var$bestBy(dateTimes, (i)=>i.valueOf(), Math.min);
    }
    /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ static max(...dateTimes) {
        if (!dateTimes.every($f3842ea939e9c33f$export$82f9ebd9adeba146.isDateTime)) throw new $f3842ea939e9c33f$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $f3842ea939e9c33f$var$bestBy(dateTimes, (i)=>i.valueOf(), Math.max);
    }
    // MISC
    /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ static fromFormatExplain(text, fmt, options = {}) {
        const { locale: locale = null, numberingSystem: numberingSystem = null } = options, localeToUse = $f3842ea939e9c33f$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $f3842ea939e9c33f$var$explainFromTokens(localeToUse, text, fmt);
    }
    /**
   * @deprecated use fromFormatExplain instead
   */ static fromStringExplain(text, fmt, options = {}) {
        return $f3842ea939e9c33f$export$82f9ebd9adeba146.fromFormatExplain(text, fmt, options);
    }
    /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ static buildFormatParser(fmt, options = {}) {
        const { locale: locale = null, numberingSystem: numberingSystem = null } = options, localeToUse = $f3842ea939e9c33f$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $f3842ea939e9c33f$var$TokenParser(localeToUse, fmt);
    }
    /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ static fromFormatParser(text, formatParser, opts = {}) {
        if ($f3842ea939e9c33f$var$isUndefined(text) || $f3842ea939e9c33f$var$isUndefined(formatParser)) throw new $f3842ea939e9c33f$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        const { locale: locale = null, numberingSystem: numberingSystem = null } = opts, localeToUse = $f3842ea939e9c33f$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $f3842ea939e9c33f$var$InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, ` + `but the format parser was created for ${formatParser.locale}`);
        const { result: result, zone: zone, specificOffset: specificOffset, invalidReason: invalidReason } = formatParser.explainFromTokens(text);
        if (invalidReason) return $f3842ea939e9c33f$export$82f9ebd9adeba146.invalid(invalidReason);
        else return $f3842ea939e9c33f$var$parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
    // FORMAT PRESETS
    /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ static get DATE_SHORT() {
        return $f3842ea939e9c33f$var$DATE_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED() {
        return $f3842ea939e9c33f$var$DATE_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED_WITH_WEEKDAY() {
        return $f3842ea939e9c33f$var$DATE_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */ static get DATE_FULL() {
        return $f3842ea939e9c33f$var$DATE_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */ static get DATE_HUGE() {
        return $f3842ea939e9c33f$var$DATE_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_SIMPLE() {
        return $f3842ea939e9c33f$var$TIME_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SECONDS() {
        return $f3842ea939e9c33f$var$TIME_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SHORT_OFFSET() {
        return $f3842ea939e9c33f$var$TIME_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_LONG_OFFSET() {
        return $f3842ea939e9c33f$var$TIME_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */ static get TIME_24_SIMPLE() {
        return $f3842ea939e9c33f$var$TIME_24_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SECONDS() {
        return $f3842ea939e9c33f$var$TIME_24_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SHORT_OFFSET() {
        return $f3842ea939e9c33f$var$TIME_24_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_LONG_OFFSET() {
        return $f3842ea939e9c33f$var$TIME_24_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT() {
        return $f3842ea939e9c33f$var$DATETIME_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT_WITH_SECONDS() {
        return $f3842ea939e9c33f$var$DATETIME_SHORT_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED() {
        return $f3842ea939e9c33f$var$DATETIME_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_SECONDS() {
        return $f3842ea939e9c33f$var$DATETIME_MED_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_WEEKDAY() {
        return $f3842ea939e9c33f$var$DATETIME_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL() {
        return $f3842ea939e9c33f$var$DATETIME_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL_WITH_SECONDS() {
        return $f3842ea939e9c33f$var$DATETIME_FULL_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE() {
        return $f3842ea939e9c33f$var$DATETIME_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE_WITH_SECONDS() {
        return $f3842ea939e9c33f$var$DATETIME_HUGE_WITH_SECONDS;
    }
}
/**
 * @private
 */ function $f3842ea939e9c33f$var$friendlyDateTime(dateTimeish) {
    if ($f3842ea939e9c33f$export$82f9ebd9adeba146.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $f3842ea939e9c33f$var$isNumber(dateTimeish.valueOf())) return $f3842ea939e9c33f$export$82f9ebd9adeba146.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $f3842ea939e9c33f$export$82f9ebd9adeba146.fromObject(dateTimeish);
    else throw new $f3842ea939e9c33f$var$InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
}
const $f3842ea939e9c33f$export$a4ad2735b021c132 = "3.7.2";








var $06e3e498f7096fae$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span>`), $06e3e498f7096fae$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<img referrerpolicy=no-referrer>`), $06e3e498f7096fae$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=empty>`), $06e3e498f7096fae$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=loading>`), $06e3e498f7096fae$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=error>`), $06e3e498f7096fae$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer>`), $06e3e498f7096fae$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $06e3e498f7096fae$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $06e3e498f7096fae$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<ul class=items>`), $06e3e498f7096fae$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<li>`), $06e3e498f7096fae$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="buttons align_end">`), $06e3e498f7096fae$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $06e3e498f7096fae$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a>`), $06e3e498f7096fae$var$_tmpl$12 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=breadcrumbs>`);
const $06e3e498f7096fae$export$b56300d3452a4bc6 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)({
            inline: true,
            brands: true
        }, ()=>({
                [({
                    itch: 'itch-io'
                })[props.provider] ?? props.provider]: true
            }))),
        (()=>{
            var _el$ = $06e3e498f7096fae$var$_tmpl$();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t(`auth.provider.${props.provider}`));
            return _el$;
        })()
    ];
};
const $06e3e498f7096fae$export$b7c56583b614ede0 = [
    'steam',
    'itch'
];
const $06e3e498f7096fae$export$d3ea39a55c5c7a6e = (props)=>{
    switch(props.provider){
        case 'steam':
            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                inline: true,
                brands: true,
                steam: true,
                get ["fa-2xl"] () {
                    return props.big;
                }
            });
        case 'itch':
            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                inline: true,
                brands: true,
                "itch-io": true,
                get ["fa-2xl"] () {
                    return props.big;
                }
            });
        default:
            return null;
    }
};
const $06e3e498f7096fae$export$5d066e7ee5279edb = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return props.icon ?? true;
            },
            get children () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($06e3e498f7096fae$export$d3ea39a55c5c7a6e, {
                    get provider () {
                        return props.provider;
                    }
                });
            }
        }),
        (()=>{
            var _el$2 = $06e3e498f7096fae$var$_tmpl$();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t(`deploy_credential_provider.${props.provider}`));
            return _el$2;
        })()
    ];
};
const $06e3e498f7096fae$export$ef7152bf8efb10e8 = (props)=>(()=>{
        var _el$3 = $06e3e498f7096fae$var$_tmpl$2();
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
            var _v$ = props.class, _v$2 = props.url, _v$3 = props.alt, _v$4 = [
                'gitlab',
                'itch'
            ].indexOf(props.provider) >= 0 ? undefined : "anonymous";
            _v$ !== _p$.e && (0, $fb40d00dea10da1a$export$2913c0c0b5623090)(_el$3, _p$.e = _v$);
            _v$2 !== _p$.t && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$3, "src", _p$.t = _v$2);
            _v$3 !== _p$.a && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$3, "alt", _p$.a = _v$3);
            _v$4 !== _p$.o && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$3, "crossorigin", _p$.o = _v$4);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined,
            o: undefined
        });
        return _el$3;
    })();
const $06e3e498f7096fae$export$bada93f69d30c1d6 = {
    'steam': {
        siteInputPlaceholder: 'https://store.steampowered.com/app/{appId}',
        fromSiteInput: (siteInput)=>{
            const regex = /^https?:\/\/store\.steampowered\.com\/app\/([0-9]+)(?:[/?].*)?$/;
            if (!regex.test(siteInput)) return null;
            return siteInput.replace(regex, (_match, appId)=>appId);
        },
        siteTitle: (site)=>site
    },
    'itch': {
        siteInputPlaceholder: 'https://{dev}.itch.io/{game}',
        fromSiteInput: (siteInput)=>{
            const regex = /^https?:\/\/([^./]+)\.itch\.io\/([^/?]+)(?:[/?].*)?$/;
            if (!regex.test(siteInput)) return null;
            return siteInput.replace(regex, (_match, developer, game)=>`${developer}/${game}`);
        },
        siteTitle: (site)=>{
            const [siteOwner, siteApp] = site.split('/');
            return `${siteOwner}.itch.io/${siteApp}`;
        }
    }
};
const $06e3e498f7096fae$export$5a4839590a83276 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$b5d5cf8927ab7262), {
        get fallback () {
            return props.empty ?? (props.page ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($06e3e498f7096fae$export$a65c2c055de52e1d, {}) : (()=>{
                var _el$4 = $06e3e498f7096fae$var$_tmpl$3();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>t('empty'));
                return _el$4;
            })());
        },
        get children () {
            return [
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                    get when () {
                        return props.resource.loading;
                    },
                    get children () {
                        return props.loading ?? (props.page ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($06e3e498f7096fae$export$a89b8b542bf88e85, {}) : (()=>{
                            var _el$5 = $06e3e498f7096fae$var$_tmpl$4();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>t('loading'));
                            return _el$5;
                        })());
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                    get when () {
                        return props.resource.error;
                    },
                    get children () {
                        return props.error ?? (()=>{
                            var _el$6 = $06e3e498f7096fae$var$_tmpl$5();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t('error'));
                            return _el$6;
                        })();
                    }
                })
            ];
        }
    });
};
const $06e3e498f7096fae$export$68962dbd27cd2e36 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const value = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const value = (0, $f3842ea939e9c33f$export$82f9ebd9adeba146).fromJSDate(props.date);
        switch(props.format ?? 'relative_datetime'){
            case 'date':
                return value.toLocaleString({
                    dateStyle: 'short'
                }, {
                    locale: t('locale')
                });
            case 'datetime':
                return value.toLocaleString({
                    dateStyle: 'short',
                    timeStyle: 'short'
                }, {
                    locale: t('locale')
                });
            case 'relative_date':
                return value.toRelativeCalendar({
                    locale: t('locale')
                });
            case 'relative_datetime':
                return value.toRelative({
                    locale: t('locale')
                });
        }
    });
    return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(value);
};
const $06e3e498f7096fae$export$a89b8b542bf88e85 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return [
        (()=>{
            var _el$7 = $06e3e498f7096fae$var$_tmpl$4();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('loading'));
            return _el$7;
        })(),
        $06e3e498f7096fae$var$_tmpl$6()
    ];
};
const $06e3e498f7096fae$export$a65c2c055de52e1d = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            title: "???",
            breadcrumb: ()=>"???",
            uiClass: "page_not_found"
        }),
        (()=>{
            var _el$9 = $06e3e498f7096fae$var$_tmpl$7();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t('page_not_found.header'));
            return _el$9;
        })(),
        (()=>{
            var _el$0 = $06e3e498f7096fae$var$_tmpl$8();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>t('page_not_found.message'));
            return _el$0;
        })(),
        (()=>{
            var _el$1 = $06e3e498f7096fae$var$_tmpl$8();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, ()=>t('page_not_found.message2'));
            return _el$1;
        })(),
        (()=>{
            var _el$10 = $06e3e498f7096fae$var$_tmpl$9();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                get each () {
                    return t('page_not_found.items');
                },
                children: (item)=>(()=>{
                        var _el$12 = $06e3e498f7096fae$var$_tmpl$0();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, item);
                        return _el$12;
                    })()
            }));
            return _el$10;
        })(),
        $06e3e498f7096fae$var$_tmpl$6()
    ];
};
const $06e3e498f7096fae$export$d968b981b6cbd3b3 = [
    'tester',
    'developer',
    'admin'
];
const $06e3e498f7096fae$export$c1cfb85b5f7f1f1a = {
    tester: 0,
    developer: 1,
    admin: 2
};
const $06e3e498f7096fae$export$50229fa1babb4225 = (a, b)=>a && b ? $06e3e498f7096fae$export$c1cfb85b5f7f1f1a[a] - $06e3e498f7096fae$export$c1cfb85b5f7f1f1a[b] : (a ? 1 : 0) - (b ? 1 : 0);
const $06e3e498f7096fae$export$8e2513724899fb47 = (props)=>{
    const items = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>props.items.filter((action)=>props.project.userPossibleActions.indexOf(action.action) >= 0));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
        get when () {
            return items().length > 0;
        },
        get children () {
            var _el$13 = $06e3e498f7096fae$var$_tmpl$1();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                get items () {
                    return items();
                },
                get title () {
                    return props.title;
                },
                get onSelect () {
                    return props.onSelect;
                }
            }));
            return _el$13;
        }
    });
};
const $06e3e498f7096fae$export$922a44e43c7eb891 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
        light: true,
        danger: true,
        onClick: ()=>(0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$d91f9afde8dd3417), {
                header: t('report_content.dialog.header'),
                message: t('report_content.dialog.message')((()=>{
                    var _el$14 = $06e3e498f7096fae$var$_tmpl$10();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, ()=>(0, $1ded0b9f0137d849$export$2e2bcd8739ae039).abuseEmail);
                    return _el$14;
                })(), (()=>{
                    var _el$15 = $06e3e498f7096fae$var$_tmpl$11();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, ()=>t('report_content.dialog.link'));
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$15, "href", `mailto:${(0, $1ded0b9f0137d849$export$2e2bcd8739ae039).abuseEmail}?subject=${encodeURIComponent(props.subject)}&body=${encodeURIComponent(props.body)}`));
                    return _el$15;
                })())
            }),
        get children () {
            return props.title;
        }
    });
};
const $06e3e498f7096fae$export$2dc68d50d56fbbd = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (()=>{
        var _el$16 = $06e3e498f7096fae$var$_tmpl$12();
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
            get each () {
                return props.breadcrumbs;
            },
            children: (breadcrumb, index)=>index() > 0 ? [
                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        solid: true,
                        get ["chevron-right"] () {
                            return t('dir') == 'ltr';
                        },
                        get ["chevron-left"] () {
                            return t('dir') == 'rtl';
                        },
                        weak: true
                    }),
                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
                        component: breadcrumb
                    })
                ] : (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
                    component: breadcrumb
                })
        }));
        return _el$16;
    })();
};





var $2003477baa50783d$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=tabs><div class=header>`), $2003477baa50783d$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=tab><div>`);
const $2003477baa50783d$export$3e41faf802a29e71 = (props)=>props;
const $2003477baa50783d$export$b2539bed5023c21c = (props)=>{
    const [activeTabIndex, setActiveTabIndex] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    const currentTab = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>props.tabs[activeTabIndex()]);
    return (()=>{
        var _el$ = $2003477baa50783d$var$_tmpl$(), _el$2 = _el$.firstChild;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
            get each () {
                return props.tabs;
            },
            children: (tab, index)=>(()=>{
                    var _el$3 = $2003477baa50783d$var$_tmpl$2(), _el$4 = _el$3.firstChild;
                    _el$3.$$click = ()=>setActiveTabIndex(index());
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>tab.title);
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$3.classList.toggle("active", !!(index() == activeTabIndex())));
                    return _el$3;
                })()
        }));
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $fb40d00dea10da1a$export$e18282e419e46834), {
            get component () {
                return currentTab().component;
            }
        }), null);
        return _el$;
    })();
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);






var $9cb6667deff6c421$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=tags>`), $9cb6667deff6c421$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=empty>`), $9cb6667deff6c421$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div>`), $9cb6667deff6c421$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $9cb6667deff6c421$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $9cb6667deff6c421$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=tags_editor>`), $9cb6667deff6c421$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><header>`), $9cb6667deff6c421$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><input type=checkbox>`);
const $9cb6667deff6c421$export$d13993e02571356d = (()=>{
    const tags = {
        os: {
            options: {
                windows: {
                    icon: {
                        brands: true,
                        windows: true
                    }
                },
                linux: {
                    icon: {
                        brands: true,
                        linux: true
                    }
                },
                macos: {
                    icon: {
                        brands: true,
                        apple: true
                    }
                },
                android: {
                    icon: {
                        brands: true,
                        android: true
                    }
                },
                ios: {
                    icon: {
                        brands: true,
                        apple: true
                    }
                },
                web: {
                    icon: {
                        brands: true,
                        html5: true
                    }
                }
            }
        },
        arch: {
            options: {
                x86: {
                    icon: {
                        solid: true,
                        microchip: true
                    }
                },
                arm: {
                    icon: {
                        solid: true,
                        microchip: true
                    }
                }
            }
        },
        bits: {
            options: {
                '32': {},
                '64': {}
            }
        },
        packaging: {
            options: {
                installer: {
                    icon: {
                        solid: true,
                        'bars-progress': true
                    }
                },
                deb: {
                    icon: {
                        solid: true,
                        'box-archive': true
                    }
                },
                rpm: {
                    icon: {
                        solid: true,
                        'box-archive': true
                    }
                },
                flatpak: {
                    icon: {
                        solid: true,
                        'box-archive': true
                    }
                }
            }
        },
        component: {
            options: {
                client: {
                    icon: {
                        solid: true,
                        laptop: true
                    }
                },
                server: {
                    icon: {
                        solid: true,
                        server: true
                    }
                }
            }
        },
        runtime: {
            options: {
                nodejs: {
                    icon: {
                        brands: true,
                        'node-js': true
                    }
                },
                java: {
                    icon: {
                        brands: true,
                        java: true
                    }
                }
            }
        },
        distro: {
            options: {
                ubuntu: {
                    icon: {
                        brands: true,
                        ubuntu: true
                    }
                },
                fedora: {
                    icon: {
                        brands: true,
                        fedora: true
                    }
                },
                arch: {
                    icon: {
                        brands: true,
                        linux: true
                    }
                },
                nixos: {
                    icon: {
                        brands: true,
                        linux: true
                    }
                }
            },
            requires: 'os:linux'
        }
    };
    let i = 0;
    for(const tag in tags){
        tags[tag].order = i++;
        let j = 0;
        for(const option in tags[tag].options)tags[tag].options[option].order = j++;
    }
    return tags;
})();
const $9cb6667deff6c421$export$9b33fb7751632f7d = (a, b)=>{
    const [tagA, optionA] = a.split(':');
    const [tagB, optionB] = b.split(':');
    const ai = $9cb6667deff6c421$export$d13993e02571356d[tagA].order;
    const bi = $9cb6667deff6c421$export$d13993e02571356d[tagB].order;
    if (ai != bi) return ai - bi;
    return $9cb6667deff6c421$export$d13993e02571356d[tagA].options[optionA].order - $9cb6667deff6c421$export$d13993e02571356d[tagB].options[optionB].order;
};
const $9cb6667deff6c421$export$1552e7ef40a718b1 = (tag)=>{
    const [tagName, tagValue] = tag.split(':');
    return $9cb6667deff6c421$export$d13993e02571356d[tagName].options[tagValue];
};
const $9cb6667deff6c421$export$b72686b556e29ca6 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (()=>{
        var _el$ = $9cb6667deff6c421$var$_tmpl$();
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
            get each () {
                return props.tags.toArray().sort($9cb6667deff6c421$export$9b33fb7751632f7d);
            },
            get fallback () {
                return (()=>{
                    var _el$2 = $9cb6667deff6c421$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('package.tags.empty'));
                    return _el$2;
                })();
            },
            children: (tag)=>{
                const icon = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>$9cb6667deff6c421$export$1552e7ef40a718b1(tag).icon);
                return (()=>{
                    var _el$3 = $9cb6667deff6c421$var$_tmpl$3(), _el$4 = _el$3.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                        get when () {
                            return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!(props.showIcons ?? true))() && icon();
                        },
                        get children () {
                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(icon));
                        }
                    }), _el$4);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>t(`package.tag.${tag}`));
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$3, "title", props.showCodes ? tag : undefined));
                    return _el$3;
                })();
            }
        }), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>props.children, null);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$.classList.toggle("inline", !!props.inline));
        return _el$;
    })();
};
const $9cb6667deff6c421$export$4b94e81825be0936 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const onTagSelect = (key)=>{
        props.setTags((tags)=>tags.has(key) ? tags.delete(key) : tags.add(key));
        return true;
    };
    return props.compact ? (()=>{
        var _el$5 = $9cb6667deff6c421$var$_tmpl$4();
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>Object.entries($9cb6667deff6c421$export$d13993e02571356d).map(([tagName, tagDesc])=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return !tagDesc.requires || props.tags().has(tagDesc.requires);
                    },
                    get children () {
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                            classList: {
                                dropdown_tags: true
                            },
                            get title () {
                                return t(`package.tag.${tagName}`);
                            },
                            get items () {
                                return Object.entries(tagDesc.options).map(([tagOption, tagOptionDesc])=>({
                                        key: `${tagName}:${tagOption}`,
                                        title: (()=>{
                                            var _el$6 = $9cb6667deff6c421$var$_tmpl$5();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return tagOptionDesc.icon;
                                                },
                                                get children () {
                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(()=>tagOptionDesc.icon, {
                                                        inline: true
                                                    }));
                                                }
                                            }), null);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t(`package.tag.${tagName}:${tagOption}`), null);
                                            return _el$6;
                                        })(),
                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)({
                                            item_start: true,
                                            inline: true,
                                            regular: true
                                        }, ()=>({
                                                [props.tags().has(`${tagName}:${tagOption}`) ? 'square-check' : 'square']: true
                                            })))
                                    }));
                            },
                            onSelect: onTagSelect
                        });
                    }
                })));
        return _el$5;
    })() : (()=>{
        var _el$7 = $9cb6667deff6c421$var$_tmpl$6();
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>Object.entries($9cb6667deff6c421$export$d13993e02571356d).map(([tagName, tagDesc])=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return !tagDesc.requires || props.tags().has(tagDesc.requires);
                    },
                    get children () {
                        var _el$8 = $9cb6667deff6c421$var$_tmpl$7(), _el$9 = _el$8.firstChild;
                        (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$9, "title", tagName);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t(`package.tag.${tagName}`));
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>Object.entries(tagDesc.options).map(([tagOption, tagOptionDesc])=>(()=>{
                                    var _el$0 = $9cb6667deff6c421$var$_tmpl$8(), _el$1 = _el$0.firstChild;
                                    (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$0, "title", `${tagName}:${tagOption}`);
                                    _el$1.$$click = ()=>onTagSelect(`${tagName}:${tagOption}`);
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                        get when () {
                                            return tagOptionDesc.icon;
                                        },
                                        get children () {
                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(()=>tagOptionDesc.icon, {
                                                inline: true
                                            }));
                                        }
                                    }), null);
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>t(`package.tag.${tagName}:${tagOption}`), null);
                                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$1.checked = props.tags().has(`${tagName}:${tagOption}`));
                                    return _el$0;
                                })()), null);
                        return _el$8;
                    }
                })));
        return _el$7;
    })();
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);






const $14e578934f51f0ba$export$2c657da244d00bd6 = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)();
const $14e578934f51f0ba$export$d8964aec282183a3 = (props)=>{
    // detect theme initially from local storage
    const [theme, setTheme] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((()=>{
        const theme = localStorage.getItem('theme');
        return theme && Array.from(props.themes).indexOf(theme) >= 0 ? theme : props.defaultTheme;
    })());
    // update current theme in local storage and document class
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        localStorage.setItem('theme', theme());
        for (const classItem of document.body.classList)if (classItem.startsWith('theme-')) document.body.classList.remove(classItem);
        document.body.classList.add(`theme-${theme()}`);
    });
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($14e578934f51f0ba$export$2c657da244d00bd6.Provider, {
        get value () {
            return {
                theme: theme,
                setTheme: setTheme,
                themes: props.themes
            };
        },
        get children () {
            return props.children;
        }
    });
};
const $14e578934f51f0ba$export$17c20d206da56716 = ()=>{
    const { theme: currentTheme, setTheme: setTheme, themes: themes } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($14e578934f51f0ba$export$2c657da244d00bd6);
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
        get title () {
            return [
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                    solid: true,
                    "circle-half-stroke": true,
                    weak: true,
                    inline: true
                }),
                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('theme'))
            ];
        },
        get items () {
            return Array.from(themes).map((theme)=>({
                    key: theme,
                    title: t(`theme.${theme}`),
                    icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        regular: true,
                        get ["circle-dot"] () {
                            return theme == currentTheme();
                        },
                        get circle () {
                            return theme != currentTheme();
                        },
                        inline: true
                    })
                }));
        },
        onSelect: setTheme
    });
};




var $9DGpR = parcelRequire("9DGpR");






var $710e903ece6de316$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=entry draggable=true aria-role=treeitem><code class=name>`), $710e903ece6de316$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $710e903ece6de316$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=drop-area><div>`), $710e903ece6de316$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=entries aria-role=tree>`), $710e903ece6de316$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $710e903ece6de316$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class="button file-upload"><input type=file multiple>`), $710e903ece6de316$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class="button directory-upload"><input type=file directory webkitdirectory multiple>`), $710e903ece6de316$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=size_count>`), $710e903ece6de316$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=size_suffix>`);
const $710e903ece6de316$var$compareByName = (a, b)=>{
    const nameA = a.name();
    const nameB = b.name();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
};
class $710e903ece6de316$var$EntryRegistry {
    get(entryId) {
        return this.allEntries.get(entryId);
    }
    register(entry) {
        entry.id = this.nextEntryId++;
        this.allEntries.set(entry.id, entry);
    }
    unregister(entry) {
        this.allEntries.delete(entry.id);
    }
    constructor(){
        this.allEntries = new Map();
        this.nextEntryId = 0;
    }
}
const $710e903ece6de316$var$EntryContext = (0, $1f5a16020b51a07b$export$fd42f52fd3ae1109)();
const $710e903ece6de316$export$240af65705974100 = (props)=>{
    const parentContext = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($710e903ece6de316$var$EntryContext);
    const entryRegistry = parentContext?.entryRegistry ?? new $710e903ece6de316$var$EntryRegistry();
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$var$EntryContext.Provider, {
        get value () {
            return {
                entryRegistry: entryRegistry,
                editable: props.editable ?? false,
                processAddedEntry: props.processAddedEntry,
                baseChunksIndex: props.baseChunksIndex,
                onContextMenu: props.onContextMenu ?? (()=>{})
            };
        },
        get children () {
            return props.children;
        }
    });
};
const $710e903ece6de316$var$emptySelectedPaths = (0, $9DGpR.Map)();
const $710e903ece6de316$var$modifyPathSelection = (path, modify, selectedPaths)=>{
    // should not be called with empty path
    if (!path.size) return selectedPaths;
    const name = path.first();
    const pathSelection = selectedPaths.get(name);
    const newPathSelection = path.size == 1 ? modify(pathSelection ?? $710e903ece6de316$var$emptySelectedPaths) : $710e903ece6de316$var$modifyPathSelection(path.shift(), modify, pathSelection === undefined || pathSelection == 'selected' ? $710e903ece6de316$var$emptySelectedPaths : pathSelection);
    return newPathSelection != 'selected' && newPathSelection.isEmpty() ? selectedPaths.delete(name) : selectedPaths.set(name, newPathSelection);
};
const $710e903ece6de316$var$singleSelectedPath = (path)=>$710e903ece6de316$var$modifyPathSelection(path, (pathSelection)=>'selected', $710e903ece6de316$var$emptySelectedPaths);
const $710e903ece6de316$var$EntryRow = (props)=>{
    const { entryRegistry: entryRegistry, editable: editable, processAddedEntry: processAddedEntry, onContextMenu: onContextMenu } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($710e903ece6de316$var$EntryContext);
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        entryRegistry.register(props.entry);
    });
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        entryRegistry.unregister(props.entry);
    });
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const [open, setOpen] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    const onMouseDown = (e)=>{
        props.setSelectedPaths((selectedPaths)=>e.ctrlKey ? $710e903ece6de316$var$modifyPathSelection(props.path, (pathSelection)=>pathSelection == 'selected' ? $710e903ece6de316$var$emptySelectedPaths : 'selected', selectedPaths) : $710e903ece6de316$var$singleSelectedPath(props.path));
    };
    const onClick = (e)=>{
        if (props.entry instanceof (0, $d31846142152482d$export$5230a91395080b61)) setOpen((open)=>!open);
    };
    let refName;
    const isParentEntry = (potentialParentEntry)=>{
        for(let entry = props.entry; entry; entry = entry.parent){
            if (entry == potentialParentEntry) return true;
        }
        return false;
    };
    // row as draggable
    const onDragStart = (e)=>{
        if (!editable) {
            e.preventDefault();
            return;
        }
        e.dataTransfer.setData('app/entry', JSON.stringify(props.entry.id));
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setDragImage(refName, 0, 0);
    };
    // row as drop area
    const [dropping, setDropping] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    const onDragEnter = (e)=>{
        e.preventDefault();
        if (!editable) return;
        setDropping((dropping)=>dropping + 1);
    };
    const onDragLeave = (e)=>{
        if (!editable) return;
        setDropping((dropping)=>dropping - 1);
    };
    const onDragOver = (e)=>{
        e.preventDefault();
        if (!editable) return;
        e.dataTransfer.dropEffect = 'none';
        if (!(props.entry instanceof (0, $d31846142152482d$export$5230a91395080b61))) return;
        if (e.dataTransfer.types.includes('app/entry')) e.dataTransfer.dropEffect = 'move';
        else if (e.dataTransfer.types.includes('Files')) e.dataTransfer.dropEffect = 'copy';
    };
    const onDrop = async (e)=>{
        // prevent default drop action like navigating
        e.preventDefault();
        if (!editable) return;
        // reset counter, browsers skip dragleave on drop
        setDropping(0);
        if (!(props.entry instanceof (0, $d31846142152482d$export$5230a91395080b61))) return;
        // drop of entries
        if (e.dataTransfer.types.includes('app/entry')) {
            // get entry
            const entry = entryRegistry.get(JSON.parse(e.dataTransfer.getData('app/entry')));
            if (!entry) return;
            // check for loop
            if (isParentEntry(entry)) return;
            // move entry
            entry.moveTo(props.entry);
            // ensure parent is open
            setOpen(true);
            // select dragged entity
            props.setSelectedPaths($710e903ece6de316$var$singleSelectedPath(props.path.push(entry.name())));
        } else if (e.dataTransfer.types.includes('Files')) {
            await props.entry.addInputDataTransferItems(e.dataTransfer.items, processAddedEntry);
            // ensure parent is open and selected
            setOpen(true);
            props.setSelectedPaths($710e903ece6de316$var$singleSelectedPath(props.path));
        }
    };
    return [
        (()=>{
            var _el$ = $710e903ece6de316$var$_tmpl$(), _el$2 = _el$.firstChild;
            _el$.addEventListener("drop", onDrop);
            _el$.addEventListener("dragover", onDragOver);
            _el$.addEventListener("dragleave", onDragLeave);
            _el$.addEventListener("dragenter", onDragEnter);
            _el$.addEventListener("dragstart", onDragStart);
            _el$.$$contextmenu = onContextMenu;
            _el$.$$contextmenuData = {
                path: props.path,
                entry: props.entry
            };
            _el$.$$click = onClick;
            _el$.$$mousedown = onMouseDown;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                get when () {
                    return props.entrypointPath?.isEmpty();
                },
                get children () {
                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        solid: true,
                        play: true
                    });
                }
            }), _el$2);
            var _ref$ = refName;
            typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$2) : refName = _el$2;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$b5d5cf8927ab7262), {
                get children () {
                    return [
                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                            get when () {
                                return props.entry instanceof (0, $d31846142152482d$export$51c46da272110b9a);
                            },
                            get children () {
                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(()=>({
                                        [dropping() > 0 ? 'folder-plus' : open() ? 'folder-open' : 'folder']: true
                                    }), {
                                    solid: true
                                }));
                            }
                        }),
                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                            get when () {
                                return props.entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b);
                            },
                            get children () {
                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)(()=>({
                                        [props.entry.mode() & (0, $d31846142152482d$export$e019a04e95b2bad).Executable ? 'file-excel' : 'file']: true
                                    }), {
                                    regular: true
                                }));
                            }
                        }),
                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                            get when () {
                                return props.entry instanceof (0, $d31846142152482d$export$19b7813f051eae);
                            },
                            get children () {
                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                    link: true,
                                    solid: true
                                });
                            }
                        })
                    ];
                }
            }), null);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>props.entry.name(), null);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$export$3ea7cc26c4f45db8, {
                get size () {
                    return props.entry.totalSize();
                }
            }), null);
            (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                var _v$ = !!(props.pathSelection == 'selected'), _v$2 = !!(props.entry instanceof (0, $d31846142152482d$export$5230a91395080b61) && dropping() > 0), _v$3 = props.level + 1, _v$4 = props.pathSelection == 'selected' || undefined, _v$5 = props.entry instanceof (0, $d31846142152482d$export$5230a91395080b61) ? open() : undefined, _v$6 = props.level;
                _v$ !== _p$.e && _el$.classList.toggle("selected", _p$.e = _v$);
                _v$2 !== _p$.t && _el$.classList.toggle("dropping", _p$.t = _v$2);
                _v$3 !== _p$.a && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "aria-level", _p$.a = _v$3);
                _v$4 !== _p$.o && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "aria-selected", _p$.o = _v$4);
                _v$5 !== _p$.i && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "aria-expanded", _p$.i = _v$5);
                _v$6 !== _p$.n && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$2, "--tree-level", _p$.n = _v$6);
                return _p$;
            }, {
                e: undefined,
                t: undefined,
                a: undefined,
                o: undefined,
                i: undefined,
                n: undefined
            });
            return _el$;
        })(),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>props.entry instanceof (0, $d31846142152482d$export$5230a91395080b61))() && open();
            },
            get children () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$var$EntriesRows, {
                    get entries () {
                        return props.entry.entries;
                    },
                    get baseEntries () {
                        return props.baseEntry?.entries();
                    },
                    get level () {
                        return props.level + 1;
                    },
                    get path () {
                        return props.path;
                    },
                    get selectedPaths () {
                        return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>props.pathSelection == 'selected')() ? $710e903ece6de316$var$emptySelectedPaths : props.pathSelection;
                    },
                    get setSelectedPaths () {
                        return props.setSelectedPaths;
                    },
                    get entrypointPath () {
                        return props.entrypointPath;
                    }
                });
            }
        })
    ];
};
const $710e903ece6de316$var$EntriesRows = (props)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
        get each () {
            return props.entries().valueSeq().toArray().sort($710e903ece6de316$var$compareByName);
        },
        children: (entry)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$var$EntryRow, {
                entry: entry,
                get baseEntry () {
                    return props.baseEntries?.get(entry.name());
                },
                get level () {
                    return props.level;
                },
                get path () {
                    return props.path.push(entry.name());
                },
                get pathSelection () {
                    return props.selectedPaths.get(entry.name()) ?? $710e903ece6de316$var$emptySelectedPaths;
                },
                get setSelectedPaths () {
                    return props.setSelectedPaths;
                },
                get entrypointPath () {
                    return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>props.entrypointPath?.first() === entry.name())() ? props.entrypointPath.slice(1) : undefined;
                }
            })
    });
const $710e903ece6de316$export$2633c22b7a1b7cb = (props)=>{
    const { entryRegistry: entryRegistry } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)($710e903ece6de316$var$EntryContext);
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const [selectedPaths, setSelectedPaths] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)($710e903ece6de316$var$emptySelectedPaths);
    const processAddedEntry = (entry)=>{
        if (entry instanceof (0, $d31846142152482d$export$51c46da272110b9a)) entry.extra = {
            patchSize: (baseEntry)=>(0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
                    let size = 0;
                    const baseEntryIsContainer = baseEntry instanceof (0, $d31846142152482d$export$5230a91395080b61);
                    for (const [subentryName, subentry] of entry.entries())size += subentry.extra.patchSize(baseEntryIsContainer ? baseEntry.entries().get(subentryName) : undefined)();
                    return size;
                }),
            ready: (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
                for (const [_subentryName, subentry] of entry.entries()){
                    if (!subentry.extra?.ready()) return false;
                }
                return true;
            })
        };
        else if (entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b)) {
            if (entry.chunks || entry.blob) {
                const [ready, setReady] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
                const [chunksResource] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                    if (!entry.chunks) {
                        const chunks = [];
                        for await (const chunk of (0, $fe57e090ef2afef2$export$19d907f5008a0f2)(entry.blob))chunks.push({
                            ...chunk,
                            compressedSize: 0
                        });
                        entry.chunks = chunks;
                    }
                    setReady(true);
                    return entry.chunks;
                });
                entry.extra = {
                    patchSize: ()=>(0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
                            const chunks = chunksResource();
                            if (!chunks) return entry.size;
                            const baseChunksIndex = props.baseChunksIndex;
                            if (!baseChunksIndex) return entry.size;
                            let size = 0;
                            for (const chunk of chunks)if (!baseChunksIndex.has((0, $f710aae7717efd0b$export$c5411f1b08998578)(chunk.hash))) size += chunk.compressedSize || chunk.size;
                            return size;
                        }),
                    ready: ready
                };
            } else entry.extra = {
                patchSize: ()=>()=>entry.size,
                ready: ()=>true
            };
        } else entry.extra = {
            patchSize: ()=>()=>0,
            ready: ()=>true
        };
    };
    // recursively process initial entries
    (()=>{
        const process = (entry)=>{
            if (entry instanceof (0, $d31846142152482d$export$5230a91395080b61)) for (const [_subentryName, subentry] of entry.entries())process(subentry);
            processAddedEntry(entry);
        };
        process(props.root);
    })();
    const onInputFiles = async (e)=>{
        e.preventDefault();
        props.root.addInputFiles(e.target.files, processAddedEntry);
    };
    const [contextMenuEntry, setContextMenuEntry] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const [contextMenuEntryPath, setContextMenuEntryPath] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const [contextEntryRef, setContextEntryRef] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const [contextMenuVisible, setContextMenuVisible] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    const contextMenuItems = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const items = [];
        if (props.editable) {
            const entry = contextMenuEntry();
            if (entry instanceof (0, $d31846142152482d$export$51c46da272110b9a)) items.push({
                key: 'explode_folder',
                title: t('upload_box.entry.explode_folder')
            });
            if (props.setEntrypoint) items.push({
                key: 'set_entrypoint',
                title: t('upload_box.entry.set_entrypoint')
            });
            if (entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b)) {
                const executable = entry.mode() & (0, $d31846142152482d$export$e019a04e95b2bad).Executable;
                items.push({
                    key: 'toggle_executable',
                    title: t(`upload_box.entry.${executable ? 'unmark' : 'mark'}_executable`)
                });
            }
            items.push({
                key: 'remove',
                title: t('upload_box.entry.remove')
            });
        }
        return items;
    });
    const onContextMenu = ({ entry: entry, path: path }, e)=>{
        if (!contextMenuItems().length) return;
        e.preventDefault();
        setContextMenuEntry(entry);
        setContextMenuEntryPath(path);
        setContextEntryRef({
            getBoundingClientRect: ()=>({
                    x: e.clientX,
                    y: e.clientY,
                    width: 0,
                    height: 0,
                    left: e.clientX,
                    top: e.clientY,
                    right: e.clientX,
                    bottom: e.clientY
                }),
            contextElement: e.currentTarget
        });
        setContextMenuVisible(true);
    };
    const onContextMenuSelect = (key)=>{
        const entry = contextMenuEntry();
        const entryPath = contextMenuEntryPath();
        if (!entry) return;
        switch(key){
            case 'explode_folder':
                if (entry instanceof (0, $d31846142152482d$export$51c46da272110b9a)) {
                    const parentEntry = entry.parent;
                    if (parentEntry) {
                        entry.removeFromParent();
                        for (const [_subentryName, subentry] of entry.entries())subentry.moveTo(parentEntry);
                    }
                }
                break;
            case 'set_entrypoint':
                if (entryPath && props.setEntrypoint) props.setEntrypoint(entryPath);
                break;
            case 'toggle_executable':
                if (entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b)) entry.setMode((mode)=>mode ^ (0, $d31846142152482d$export$e019a04e95b2bad).Executable);
                break;
            case 'remove':
                entry.removeFromParent();
                break;
        }
    };
    const [boxDropping, setBoxDropping] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    const [areaDropping, setAreaDropping] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
    const isDropAreaBig = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>props.root.entries().isEmpty());
    return (()=>{
        var _el$3 = $710e903ece6de316$var$_tmpl$5();
        _el$3.addEventListener("drop", (e)=>{
            if (!props.editable) return;
            setBoxDropping(0);
        });
        _el$3.addEventListener("dragover", (e)=>{
            if (!props.editable) return;
            if (e.target == e.currentTarget) e.dataTransfer.dropEffect = 'none';
            e.preventDefault();
        });
        _el$3.addEventListener("dragleave", (e)=>{
            if (!props.editable) return;
            setBoxDropping((dropping)=>dropping - 1);
        });
        _el$3.addEventListener("dragenter", (e)=>{
            if (!props.editable) return;
            setBoxDropping((dropping)=>dropping + 1);
        });
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return props.editable;
            },
            get children () {
                return [
                    (()=>{
                        var _el$4 = $710e903ece6de316$var$_tmpl$2();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$export$2ce187a2c1c8f912, {
                            onChange: onInputFiles,
                            get children () {
                                return t('upload_box.choose_files');
                            }
                        }), null);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$export$289f35bdab14d004, {
                            onChange: onInputFiles,
                            get children () {
                                return t('upload_box.choose_directories');
                            }
                        }), null);
                        return _el$4;
                    })(),
                    (()=>{
                        var _el$5 = $710e903ece6de316$var$_tmpl$3(), _el$6 = _el$5.firstChild;
                        _el$5.addEventListener("drop", async (e)=>{
                            e.preventDefault();
                            setAreaDropping(0);
                            // drop of entries
                            if (e.dataTransfer.types.includes('app/entry')) {
                                // get entry
                                const entry = entryRegistry.get(JSON.parse(e.dataTransfer.getData('app/entry')));
                                if (!entry) return;
                                // move entry
                                entry.moveTo(props.root);
                                // select dragged entity
                                setSelectedPaths($710e903ece6de316$var$singleSelectedPath((0, $9DGpR.List).of(entry.name())));
                            } else if (e.dataTransfer.types.includes('Files')) await props.root.addInputDataTransferItems(e.dataTransfer.items, processAddedEntry);
                        });
                        _el$5.addEventListener("dragover", (e)=>{
                            e.preventDefault();
                            e.dataTransfer.dropEffect = 'none';
                            if (e.dataTransfer.types.includes('app/entry')) e.dataTransfer.dropEffect = 'move';
                            else if (e.dataTransfer.types.includes('Files')) e.dataTransfer.dropEffect = 'copy';
                        });
                        _el$5.addEventListener("dragleave", (e)=>{
                            setAreaDropping((dropping)=>dropping - 1);
                        });
                        _el$5.addEventListener("dragenter", (e)=>{
                            setAreaDropping((dropping)=>dropping + 1);
                        });
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            solid: true,
                            "box-open": true,
                            "fa-2xl": true
                        }), _el$6);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (()=>{
                            var _c$ = (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!boxDropping());
                            return ()=>_c$() ? t('upload_box.drop_area.box_dropping_message') : t('upload_box.drop_area.message');
                        })());
                        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                            var _v$7 = !!isDropAreaBig(), _v$8 = !!(areaDropping() > 0);
                            _v$7 !== _p$.e && _el$5.classList.toggle("big", _p$.e = _v$7);
                            _v$8 !== _p$.t && _el$5.classList.toggle("dropping", _p$.t = _v$8);
                            return _p$;
                        }, {
                            e: undefined,
                            t: undefined
                        });
                        return _el$5;
                    })()
                ];
            }
        }), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$export$240af65705974100, {
            get editable () {
                return props.editable;
            },
            processAddedEntry: processAddedEntry,
            get baseChunksIndex () {
                return props.baseChunksIndex;
            },
            onContextMenu: onContextMenu,
            get children () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return !props.root.entries().isEmpty();
                    },
                    get children () {
                        return [
                            (()=>{
                                var _el$7 = $710e903ece6de316$var$_tmpl$4();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($710e903ece6de316$var$EntriesRows, {
                                    get entries () {
                                        return props.root.entries;
                                    },
                                    get baseEntries () {
                                        return props.baseRoot?.entries();
                                    },
                                    level: 0,
                                    get path () {
                                        return (0, $9DGpR.List)();
                                    },
                                    get selectedPaths () {
                                        return selectedPaths();
                                    },
                                    setSelectedPaths: setSelectedPaths,
                                    get entrypointPath () {
                                        return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!props.entrypoint().isEmpty())() ? undefined : props.entrypoint();
                                    }
                                }));
                                (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                                    var _v$9 = props.editable, _v$0 = !props.editable;
                                    _v$9 !== _p$.e && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$7, "aria-multiselectable", _p$.e = _v$9);
                                    _v$0 !== _p$.t && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$7, "aria-readonly", _p$.t = _v$0);
                                    return _p$;
                                }, {
                                    e: undefined,
                                    t: undefined
                                });
                                return _el$7;
                            })(),
                            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8dc6765e8be191c7), {
                                get items () {
                                    return contextMenuItems();
                                },
                                baseRef: contextEntryRef,
                                menuVisible: contextMenuVisible,
                                setMenuVisible: setContextMenuVisible,
                                onSelect: onContextMenuSelect
                            })
                        ];
                    }
                });
            }
        }), null);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_$p)=>(0, $fb40d00dea10da1a$export$11c615ce16f87241)(_el$3, {
                'upload-box': true,
                ...props.classList ?? {}
            }, _$p));
        return _el$3;
    })();
};
const $710e903ece6de316$export$2ce187a2c1c8f912 = (props)=>{
    let inputRef;
    return (()=>{
        var _el$8 = $710e903ece6de316$var$_tmpl$6(), _el$9 = _el$8.firstChild;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>props.children, _el$9);
        var _ref$2 = inputRef;
        typeof _ref$2 === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$2, _el$9) : inputRef = _el$9;
        (0, $fb40d00dea10da1a$export$3f65cefe8380dbea)(_el$9, "change", props.onChange);
        return _el$8;
    })();
};
const $710e903ece6de316$export$289f35bdab14d004 = (props)=>{
    let inputRef;
    return (()=>{
        var _el$0 = $710e903ece6de316$var$_tmpl$7(), _el$1 = _el$0.firstChild;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>props.children, _el$1);
        var _ref$3 = inputRef;
        typeof _ref$3 === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$3, _el$1) : inputRef = _el$1;
        (0, $fb40d00dea10da1a$export$3f65cefe8380dbea)(_el$1, "change", props.onChange);
        return _el$0;
    })();
};
const $710e903ece6de316$export$3ea7cc26c4f45db8 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const countSuffix = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>$710e903ece6de316$var$prettyDataSizeCountSuffix(props.size));
    return [
        (()=>{
            var _el$10 = $710e903ece6de316$var$_tmpl$8();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>countSuffix()[0]);
            return _el$10;
        })(),
        (()=>{
            var _el$11 = $710e903ece6de316$var$_tmpl$9();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, ()=>t(`datasize.${countSuffix()[1]}`));
            return _el$11;
        })()
    ];
};
const $710e903ece6de316$var$prettyDataSizeCountSuffix = (size)=>{
    if (size < 1000) return [
        size.toFixed(0),
        'B'
    ];
    size /= 1024;
    if (size < 10) return [
        size.toFixed(1),
        'KiB'
    ];
    if (size < 1000) return [
        size.toFixed(0),
        'KiB'
    ];
    size /= 1024;
    if (size < 10) return [
        size.toFixed(1),
        'MiB'
    ];
    if (size < 1000) return [
        size.toFixed(0),
        'MiB'
    ];
    size /= 1024;
    if (size < 10) return [
        size.toFixed(1),
        'GiB'
    ];
    if (size < 1000) return [
        size.toFixed(0),
        'GiB'
    ];
    size /= 1024;
    if (size < 10) return [
        size.toFixed(1),
        'TiB'
    ];
    return [
        size.toFixed(0),
        'TiB'
    ];
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "mousedown",
    "click",
    "contextmenu"
]);









var $1024668015f4bbf6$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<iframe allow="accelerometer; ambient-light-sensor; autoplay; fullscreen; gamepad; geolocation; gyroscope; hid; magnetometer; midi; screen-wake-lock">`), $1024668015f4bbf6$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class=buttons><div class=spacer>`);
const $1024668015f4bbf6$export$f4545b84808b8529 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    let refFrame;
    const onReset = ()=>{
        refFrame.src = props.spaceUrlResource();
    };
    const onFullScreen = ()=>{
        refFrame.requestFullscreen({
            navigationUI: 'hide'
        });
    };
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            get title () {
                return t('packages.play');
            },
            breadcrumb: ()=>t('packages.play'),
            uiClass: "package_play"
        }),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return props.spaceUrlResource();
            },
            get fallback () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                    get resource () {
                        return props.spaceUrlResource;
                    },
                    page: true
                });
            },
            get children () {
                return [
                    (()=>{
                        var _el$ = $1024668015f4bbf6$var$_tmpl$();
                        var _ref$ = refFrame;
                        typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$) : refFrame = _el$;
                        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$, "src", props.spaceUrlResource()));
                        return _el$;
                    })(),
                    (()=>{
                        var _el$2 = $1024668015f4bbf6$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                            onClick: onReset,
                            danger: true,
                            get children () {
                                return [
                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                        "power-off": true,
                                        solid: true,
                                        inline: true,
                                        weak: true
                                    }),
                                    (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('packages.play.reset'))
                                ];
                            }
                        }), _el$4);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                            onClick: onFullScreen,
                            get children () {
                                return [
                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                        display: true,
                                        solid: true,
                                        inline: true,
                                        weak: true
                                    }),
                                    (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('packages.play.fullscreen'))
                                ];
                            }
                        }), null);
                        return _el$2;
                    })()
                ];
            }
        })
    ];
};








var $6b2909ffdda1a1a0$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p>`), $6b2909ffdda1a1a0$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $6b2909ffdda1a1a0$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="sheet small ui auth"><h1></h1><div class=footer>`), $6b2909ffdda1a1a0$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<button class=button>`), $6b2909ffdda1a1a0$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $6b2909ffdda1a1a0$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="sheet ui small auth_progress"><h1></h1><div class=footer>`), $6b2909ffdda1a1a0$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="sheet ui small error"><h1></h1><div class=message></div><div class=footer><div class="buttons align_end">`);
const $6b2909ffdda1a1a0$var$AuthDialog = ()=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { providers: providers, startAuth: startAuth } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [selectedProvider, setSelectedProvider] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const onStartAuth = async (provider)=>{
        if (selectedProvider()) return;
        setSelectedProvider(provider);
        await startAuth(provider, 'register');
    };
    return (()=>{
        var _el$ = $6b2909ffdda1a1a0$var$_tmpl$3(), _el$2 = _el$.firstChild, _el$5 = _el$2.nextSibling;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('auth.dialog.header'));
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return selectedProvider() == null;
            },
            get fallback () {
                return (()=>{
                    var _el$6 = $6b2909ffdda1a1a0$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t('auth.dialog.redirecting_to')(t(`auth.provider.${selectedProvider()}`)));
                    return _el$6;
                })();
            },
            get children () {
                return [
                    (()=>{
                        var _el$3 = $6b2909ffdda1a1a0$var$_tmpl$();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>t('auth.dialog.please_select'));
                        return _el$3;
                    })(),
                    (()=>{
                        var _el$4 = $6b2909ffdda1a1a0$var$_tmpl$2();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                            each: providers,
                            children: (provider)=>(()=>{
                                    var _el$7 = $6b2909ffdda1a1a0$var$_tmpl$4();
                                    _el$7.$$click = onStartAuth;
                                    _el$7.$$clickData = provider;
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$b56300d3452a4bc6), {
                                        provider: provider
                                    }));
                                    return _el$7;
                                })()
                        }));
                        return _el$4;
                    })()
                ];
            }
        }), _el$5);
        return _el$;
    })();
};
const $6b2909ffdda1a1a0$export$c458c52872d01820 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { finishAuth: finishAuth } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const provider = props.route;
    const navigate = (0, $bcd7d00b4653a471$export$2b3a76f83deeece4)();
    const [authError] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        const { intent: intent, nextUrl: nextUrl, error: error } = await finishAuth(provider);
        let actualNextUrl = nextUrl ?? undefined;
        if (error || !nextUrl) switch(intent){
            case 'login':
            case 'register':
                actualNextUrl = '/';
                break;
            case 'link':
                actualNextUrl = '/me';
                break;
        }
        if (error || !actualNextUrl) return {
            nextUrl: actualNextUrl ?? '/',
            error: error
        };
        else navigate(actualNextUrl, {
            replace: true,
            reload: true
        });
    });
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$b5d5cf8927ab7262), {
        get fallback () {
            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($6b2909ffdda1a1a0$var$ProgressSheet, {
                get title () {
                    return t('auth.dialog.progress_header');
                }
            });
        },
        get children () {
            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                get when () {
                    return authError();
                },
                children: (authError)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($6b2909ffdda1a1a0$var$ErrorSheet, {
                        get title () {
                            return t('auth.dialog.error.header');
                        },
                        get message () {
                            return t(`auth.dialog.error.${authError().error}`) ?? t('auth.dialog.error.unknown');
                        },
                        get links () {
                            return [
                                {
                                    title: t('auth.dialog.error.back'),
                                    link: authError().nextUrl
                                }
                            ];
                        }
                    })
            });
        }
    });
};
const $6b2909ffdda1a1a0$export$1ac09da1b8c1fc69 = ()=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { status: status } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$b5d5cf8927ab7262), {
        get children () {
            return [
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                    get when () {
                        return ({
                            not_authenticated: true
                        })[status()];
                    },
                    get children () {
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($6b2909ffdda1a1a0$var$AuthDialog, {});
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                    get when () {
                        return status() == 'error';
                    },
                    get children () {
                        var _el$8 = $6b2909ffdda1a1a0$var$_tmpl$5();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>t('error'));
                        return _el$8;
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                    when: true,
                    get children () {
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($6b2909ffdda1a1a0$var$ProgressSheet, {
                            get title () {
                                return t('auth.dialog.progress_header');
                            }
                        });
                    }
                })
            ];
        }
    });
};
const $6b2909ffdda1a1a0$var$ProgressSheet = (props)=>{
    return (()=>{
        var _el$9 = $6b2909ffdda1a1a0$var$_tmpl$6(), _el$0 = _el$9.firstChild, _el$1 = _el$0.nextSibling;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>props.title);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>props.children, _el$1);
        return _el$9;
    })();
};
const $6b2909ffdda1a1a0$var$ErrorSheet = (props)=>{
    const navigate = (0, $bcd7d00b4653a471$export$2b3a76f83deeece4)();
    return (()=>{
        var _el$10 = $6b2909ffdda1a1a0$var$_tmpl$7(), _el$11 = _el$10.firstChild, _el$12 = _el$11.nextSibling, _el$13 = _el$12.nextSibling, _el$14 = _el$13.firstChild;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, ()=>props.title);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, ()=>props.message);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
            get each () {
                return props.links;
            },
            children: ({ title: title, link: link })=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                    onClick: ()=>navigate(link, {
                            replace: true,
                            reload: true
                        }),
                    children: title
                })
        }));
        return _el$10;
    })();
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);


var $518d93d75c395371$exports = {};

$parcel$export($518d93d75c395371$exports, "de", function () { return $e8e93204cf33cd3c$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "en", function () { return $3ebb84c2438b0a90$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "es", function () { return $b65dc39dc4f77aa0$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "fr", function () { return $9f804369a7a26616$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "ja", function () { return $353c90f5b534128a$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "ko", function () { return $dcef16ee09b318f7$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "pl", function () { return $45d99de3dc341c2d$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "pt", function () { return $73cc5fdf88b88e2e$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "pt-BR", function () { return $4ee04ccb2987a05e$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "ru", function () { return $3cf242074de6adb0$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "tr", function () { return $fc6769ef69036635$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "zh-CN", function () { return $beff090cf88b012d$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "zh-TW", function () { return $82e95096b9bfd413$export$2e2bcd8739ae039; });
$parcel$export($518d93d75c395371$exports, "zh-HK", function () { return $40145e94f5e9e4b3$export$2e2bcd8739ae039; });
// export { default as ar } from './localization/ar';

var $e8e93204cf33cd3c$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>erlaubt`), $e8e93204cf33cd3c$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $e8e93204cf33cd3c$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>nicht erlaubt`), $e8e93204cf33cd3c$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $e8e93204cf33cd3c$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $e8e93204cf33cd3c$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>Profileinstellungen`);
const $e8e93204cf33cd3c$var$dict = {
    languageName: 'Deutsch',
    locale: 'de',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: 'Design',
    'theme.light': 'Hell',
    'theme.dark': 'Dunkel',
    'theme.system': 'System',
    'theme.sakura': 'Sakura',
    // generic
    email: 'E-Mail',
    password: 'Passwort',
    ok: 'OK',
    cancel: 'Abbrechen',
    retry: 'Wiederholen',
    copy: 'Kopieren',
    empty: "(keine Eintr\xe4ge)",
    loading: 'Wird geladen...',
    calculating: 'Berechnung...',
    error: 'Fehler',
    'in_development': 'Diese Seite befindet sich in der Entwicklung.',
    // errors
    'error.not_found': 'nicht gefunden',
    'error.name_conflict': 'Namenskonflikt',
    'error.bad_param': "ung\xfcltiger Parameter",
    'error.wrong_auth': 'falsche Authentifizierung',
    'error.unauthorized': 'nicht autorisiert',
    'error.wrong_credentials': 'falsche Anmeldedaten',
    'error.wrong_provider': 'falscher Anbieter',
    'error.insufficient_privileges': 'unzureichende Rechte',
    'error.not_empty': 'nicht leer',
    'error.limit_exceeded': "Limit \xfcberschritten",
    'error.already_member': 'bereits Mitglied',
    'error.not_finalized': 'nicht abgeschlossen',
    'error.already_finalized': 'bereits abgeschlossen',
    'error.unexpected_patch': 'unerwarteter Patch',
    'error.timeout': "Zeit\xfcberschreitung",
    'error.not_patch': 'kein Patch',
    'error.not_supported': "nicht unterst\xfctzt",
    'error.unexpected_error': 'unerwarteter Fehler',
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': 'Authentifizierung',
    'auth.dialog.please_select': "Bitte w\xe4hlen Sie Ihren Konto-Anbieter zum Anmelden.",
    'auth.dialog.redirecting_to': (provider)=>`Weiterleitung zu ${provider}...`,
    'auth.dialog.remember_me': 'Angemeldet bleiben',
    'auth.dialog.log_in': 'Anmelden',
    'auth.dialog.back': "Zur\xfcck",
    'auth.dialog.progress_header': 'Authentifizierung...',
    'auth.dialog.error.header': 'Authentifizierungsfehler',
    'auth.dialog.error.auth_not_allowed': "Diese Anmeldedaten wurden vom Benutzer f\xfcr die Authentifizierung gesperrt. Bitte nutzen Sie andere Anmeldedaten.",
    'auth.dialog.error.unknown': "Ung\xfcltige Authentifizierungsparameter. Bitte versuchen Sie es erneut.",
    'auth.dialog.error.back': "Zur\xfcckgehen",
    'user.profile': 'Profil',
    'user.logout': 'Abmelden',
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': 'Seite nicht gefunden',
    'page_not_found.message': 'Diese Seite existiert nicht.',
    'page_not_found.message2': "Nun, eigentlich schon, aber hier gibt es nichts. Folgende M\xf6glichkeiten bestehen:",
    'page_not_found.items': [
        "Hier war fr\xfcher etwas, wurde aber gel\xf6scht.",
        'Hier ist noch etwas, aber Sie haben keinen Zugriff.',
        "Oder jemand war beim Kopieren und Einf\xfcgen des Links unvorsichtig."
    ],
    'home': 'Startseite',
    'home.header.hint': "Cloud-Tools f\xfcr Indie-Entwickler",
    'home.description': "Kavykhi.Cloud ist eine Entwicklungsplattform f\xfcr Indie-Spiele. Wir unterst\xfctzen Download- und Browser-Spiele, private und \xf6ffentliche Builds, Branches, Teams und vieles mehr.",
    'home.auth': 'Anmelden oder Registrieren',
    'home.auth.hint': 'Neues Konto erstellen oder in bestehendes einloggen',
    'projects': 'Projekte',
    'projects.hint': 'Die Projekte, an denen Sie arbeiten',
    'projects.project': (project)=>`Projekt: ${project}`,
    'projects.project.hint': 'Projekt',
    'projects.no_projects': 'Sie haben noch keine Projekte.',
    'projects.new': 'Projekt erstellen',
    'projects.new_dialog.header': 'Neues Projekt',
    'projects.new_dialog.label': 'Projektname',
    'projects.new_dialog.ok': 'Projekt erstellen',
    'projects.store_page': "\xd6ffentliche Store-Seite",
    'projects.description': 'Beschreibung',
    'projects.branches': 'Branches',
    'projects.versions': 'Versionen',
    'projects.packages': 'Pakete',
    'projects.management': 'Projekteinstellungen',
    'projects.management.breadcrumb': 'Einstellungen',
    'projects.management.title': (projectTitle)=>`${projectTitle} - Einstellungen`,
    'projects.management.hint': 'Projekteinstellungen',
    'projects.management.users': 'Teammitglieder',
    'projects.management.users.empty': 'Keine Teammitglieder.',
    'projects.management.users.role.tester': 'Tester',
    'projects.management.users.role.developer': 'Entwickler',
    'projects.management.users.role.admin': 'Administrator',
    'projects.management.users.role.owner': 'Inhaber',
    'projects.management.users.role.starred': 'Favorisiert',
    'projects.management.users.exile': 'Aus Team entfernen',
    'projects.management.users.exile.dialog.header': 'Aus Team entfernen',
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "Sind Sie sicher, dass Sie ",
            userTitle,
            " aus dem Projekt ",
            projectTitle,
            " entfernen m\xF6chten?"
        ],
    'projects.management.users.exile.dialog.ok': 'Aus Team entfernen',
    'projects.management.invites.one_time_invite': 'Einmaliger Einladungslink',
    'projects.management.invites.one_time_invite.header': 'Einmaliger Einladungslink',
    'projects.management.invites.one_time_invite.message': 'Einmaliger Einladungslink:',
    'projects.management.invites.one_time_invite.note': "G\xfcltig f\xfcr 24 Stunden, kann einmal verwendet werden.",
    'projects.management.invites.new_dialog.header': 'Einladungslink',
    'projects.management.invites.new_dialog.expires': 'Ablauf in:',
    'projects.management.invites.new_dialog.expires.indefinite': '(kein Ablauf)',
    'projects.management.invites.new_dialog.approval.label': 'Benutzer tritt Projekt bei:',
    'projects.management.invites.new_dialog.approval.not_approved': 'nach Admin-Freigabe',
    'projects.management.invites.new_dialog.approval.approved': 'sofort',
    'projects.management.invites.new_dialog.seats': 'Beitrittslimit:',
    'projects.management.invites.new_dialog.seats.no_limit': '(kein Limit)',
    'projects.management.invites.new_dialog.ok': 'Einladungslink erstellen',
    'projects.management.deploy_sites': 'Deploy-Seiten',
    'projects.management.deploy_sites.empty': "Keine Deploy-Seiten hinzugef\xfcgt.",
    'projects.management.deploy_sites.add': "Deploy-Seite hinzuf\xfcgen",
    'projects.management.deploy_sites.delete': "L\xf6schen",
    'projects.management.deploy_sites.delete_dialog.header': "Deploy-Seite l\xf6schen",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "Sind Sie sicher, dass Sie die ",
            provider,
            " Deploy-Seite ",
            site,
            " l\xF6schen m\xF6chten?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "Deploy-Seite l\xf6schen",
    'projects.management.public_access': "\xd6ffentlicher Zugriff",
    'projects.management.public_access.enable': "\xd6ffentlichen Zugriff aktivieren",
    'projects.management.public_access.enabled': [
        "\xD6ffentlicher Zugriff: ",
        $e8e93204cf33cd3c$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "Der Name und die Beschreibung des Projekts sind \xf6ffentlich, ebenso wie alle als \xf6ffentlich markierten Branches.",
    'projects.management.public_access.enable_dialog.header': "\xd6ffentlichen Zugriff aktivieren",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "Sind Sie sicher, dass Sie den \xF6ffentlichen Zugriff auf das Projekt ",
            projectTitle,
            " erlauben m\xF6chten?",
            $e8e93204cf33cd3c$var$_tmpl$2(),
            $e8e93204cf33cd3c$var$_tmpl$2(),
            "Dadurch werden grundlegende Informationen \xFCber das Projekt ohne Authentifizierung verf\xFCgbar. Sie m\xFCssen den \xF6ffentlichen Zugriff f\xFCr jeden Branch, den Sie ver\xF6ffentlichen m\xF6chten, separat aktivieren."
        ],
    'projects.management.public_access.enable_dialog.ok': "\xd6ffentlichen Zugriff aktivieren",
    'projects.management.public_access.disable': "\xd6ffentlichen Zugriff deaktivieren",
    'projects.management.public_access.disabled': [
        "\xD6ffentlicher Zugriff: ",
        $e8e93204cf33cd3c$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "Das Projekt ist privat. Nur Mitglieder des Projektteams k\xf6nnen darauf zugreifen.",
    'projects.management.public_access.disable_dialog.header': "\xd6ffentlichen Zugriff deaktivieren",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "Sind Sie sicher, dass Sie den gesamten \xF6ffentlichen Zugriff auf das Projekt ",
            projectTitle,
            " deaktivieren m\xF6chten?"
        ],
    'projects.management.public_access.disable_dialog.ok': "\xd6ffentlichen Zugriff deaktivieren",
    'projects.management.public_access.branches': "\xd6ffentliche Branches",
    'projects.management.manage': 'Projekt verwalten',
    'projects.rename': 'Projekt umbenennen',
    'projects.rename_dialog.header': 'Projekt umbenennen',
    'projects.rename_dialog.label': 'Projektname:',
    'projects.rename_dialog.ok': 'Projekt umbenennen',
    'projects.edit_description': 'Beschreibung bearbeiten',
    'projects.edit_description_dialog.header': 'Projektbeschreibung bearbeiten',
    'projects.edit_description_dialog.label': 'Projektbeschreibung:',
    'projects.edit_description_dialog.ok': 'Beschreibung speichern',
    'projects.leave': 'Projekt verlassen',
    'projects.leave_dialog.header': 'Projekt verlassen',
    'projects.leave_dialog.message': (projectTitle)=>[
            "Sind Sie sicher, dass Sie das Projekt ",
            projectTitle,
            " verlassen m\xF6chten?"
        ],
    'projects.leave_dialog.ok': 'Projekt verlassen',
    'projects.delete': "Projekt l\xf6schen",
    'projects.delete_dialog.header': "Projekt l\xf6schen",
    'projects.delete_dialog.message': (projectTitle)=>[
            "Sind Sie sicher, dass Sie das Projekt ",
            projectTitle,
            " l\xF6schen m\xF6chten?"
        ],
    'projects.delete_dialog.ok': "Projekt l\xf6schen",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': 'Branch',
    'branches.no_branches': 'Das Projekt hat noch keine Branches',
    'branches.new': 'Branch erstellen',
    'branches.new_dialog.header': 'Neuer Branch',
    'branches.new_dialog.label': 'Branch-Name',
    'branches.new_dialog.ok': 'Branch erstellen',
    'branches.current_version': (version)=>[
            "Aktuelle Version: ",
            version
        ],
    'branches.current_version.packages': 'Pakete der aktuellen Version',
    'branches.no_current_version': 'Keine aktuelle Version',
    'branches.publish_version.new': "Neue Version ver\xf6ffentlichen",
    'branches.publish_version.existing': "Bestehende Version erneut ver\xf6ffentlichen",
    'branches.version_history': 'Versionsverlauf',
    'branches.version_history.empty': 'Der Versionsverlauf des Branches ist leer.',
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "Die aktuelle Branch-Version wird ",
            quotaTime != null ? [
                "f\xFCr ",
                quotaTime
            ] : "unbegrenzt",
            " aufbewahrt. Vorherige Versionen werden maximal ",
            quotaNonCurrentTime,
            " aufbewahrt. Es werden maximal ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$e8e93204cf33cd3c$var$plural(quotaCount, [
                    quotaCountText,
                    " Version"
                ], [
                    quotaCountText,
                    " Versionen"
                ])),
            " insgesamt pro Branch gespeichert."
        ],
    'branches.manage': 'Branch verwalten',
    'branches.rename': 'Branch umbenennen',
    'branches.rename_dialog.header': 'Branch umbenennen',
    'branches.rename_dialog.label': 'Branch-Name:',
    'branches.rename_dialog.ok': 'Branch umbenennen',
    'branches.delete': "Branch l\xf6schen",
    'branches.delete_dialog.header': "Branch l\xf6schen",
    'branches.delete_dialog.message': (branchTitle)=>[
            "Sind Sie sicher, dass Sie den Branch ",
            branchTitle,
            " l\xF6schen m\xF6chten?"
        ],
    'branches.delete_dialog.ok': "Branch l\xf6schen",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': 'Version',
    'versions.current': 'Aktuell',
    'versions.previous': 'Vorherige',
    'versions.description': 'Beschreibung',
    'versions.deploy_to_site.header': "Auf Seite ver\xf6ffentlichen",
    'versions.deploy_to_site': "Auf Seite ver\xf6ffentlichen",
    'versions.packages': 'Pakete',
    'versions.branches': 'In Branches',
    'versions.branches.publish': "In Branch ver\xf6ffentlichen",
    'versions.branches.empty': "Die Version wurde in keinem Branch ver\xf6ffentlicht.",
    'versions.new_dialog.header': 'Neue Version',
    'versions.new_dialog.label_title': 'Version:',
    'versions.new_dialog.label_branch': 'Branch:',
    'versions.new_dialog.packages.header': 'Pakete',
    'versions.new_dialog.packages.empty': "Keine Pakete hinzugef\xfcgt.",
    'versions.new_dialog.packages.add': "Paket hinzuf\xfcgen",
    'versions.new_dialog.packages.add_existing': "Zuvor hochgeladenes Paket hinzuf\xfcgen",
    'versions.new_dialog.packages.replace': 'Paket ersetzen',
    'versions.new_dialog.packages.edit': 'Paket bearbeiten',
    'versions.new_dialog.ok': 'Version erstellen',
    'versions.manage': 'Version verwalten',
    'versions.rename': 'Version umbenennen',
    'versions.rename_dialog.header': 'Version umbenennen',
    'versions.rename_dialog.label': 'Versionsname:',
    'versions.rename_dialog.ok': 'Version umbenennen',
    'versions.edit_description': 'Versionsbeschreibung bearbeiten',
    'versions.edit_description_dialog.header': 'Versionsbeschreibung bearbeiten',
    'versions.edit_description_dialog.label': 'Versionsbeschreibung:',
    'versions.edit_description_dialog.ok': 'Beschreibung speichern',
    'versions.delete': "Version l\xf6schen",
    'versions.delete_dialog.header': "Version l\xf6schen",
    'versions.delete_dialog.message': (versionTitle)=>[
            "Sind Sie sicher, dass Sie die Version ",
            versionTitle,
            " l\xF6schen m\xF6chten?"
        ],
    'versions.delete_dialog.ok': "Version l\xf6schen",
    'versions.publish_dialog.header': "Version in Branch ver\xf6ffentlichen",
    'versions.publish_dialog.message': (versionTitle)=>[
            "W\xE4hlen Sie den Branch aus, in dem die Version ",
            versionTitle,
            " ver\xF6ffentlicht werden soll."
        ],
    'versions.publish_dialog.no_branches': 'Keine Branches im Projekt.',
    'versions.publish_dialog.ok': "Version ver\xf6ffentlichen",
    'versions.publish_existing_dialog.header': "Version erneut ver\xf6ffentlichen",
    'versions.publish_existing_dialog.message': 'Letzte Versionen:',
    'versions.publish_existing_dialog.no_versions': 'Keine Versionen im Projekt.',
    'versions.publish_existing_dialog.ok': "Version ver\xf6ffentlichen",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': 'Paket',
    'packages.download_zip': 'Als ZIP herunterladen',
    'packages.download_torrent': 'Torrent herunterladen',
    'packages.total_size': (size)=>[
            "Gesamtgr\xF6\xDFe: ",
            size
        ],
    'packages.manage': 'Paket verwalten',
    'packages.rename': 'Paket umbenennen',
    'packages.rename_dialog.header': 'Paket umbenennen',
    'packages.rename_dialog.label': 'Paketname:',
    'packages.rename_dialog.ok': 'Paket umbenennen',
    'packages.edit_tags': 'Paket-Tags bearbeiten',
    'packages.edit_tags_dialog.header': 'Paket-Tags bearbeiten',
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "Geben Sie Tags f\xFCr das Paket ",
            packageTitle,
            " an:"
        ],
    'packages.edit_tags_dialog.ok': 'Tags speichern',
    'packages.entrypoint': (entrypoint)=>[
            "Startdatei: ",
            entrypoint
        ],
    'packages.entrypoint.empty': 'Keine Startdatei festgelegt.',
    'packages.delete': "Paket l\xf6schen",
    'packages.delete_dialog.header': 'Paket verwerfen',
    'packages.delete_dialog.message': (packageTitle)=>[
            "Sind Sie sicher, dass Sie das Paket ",
            packageTitle,
            " l\xF6schen m\xF6chten? Es wird aus allen Versionen entfernt, denen es hinzugef\xFCgt wurde."
        ],
    'packages.delete_dialog.ok': "Paket l\xf6schen",
    'packages.new_dialog.header': 'Neues Paket',
    'packages.new_dialog.label_title': 'Titel:',
    'packages.new_dialog.title_placeholder': '(aus Tags)',
    'packages.new_dialog.tags.header': 'Tags',
    'packages.new_dialog.files.header': 'Dateien',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Gesamtgr\xF6\xDFe: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(maximal ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "Neue Datengr\xF6\xDFe: ",
            size
        ],
    'packages.new_dialog.checks.empty': "Keine Dateien hinzugef\xfcgt.",
    'packages.new_dialog.checks.entrypoint.empty': 'Startdatei ist nicht festgelegt.',
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "Die Startdatei ",
            entrypoint,
            " existiert nicht. Haben Sie vergessen, sie hinzuzuf\xFCgen? Bitte geben Sie eine vorhandene Startdatei an oder lassen Sie das Feld leer."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "Startdatei zur\xfccksetzen",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "Startdatei hat die Endung ",
            fileExt,
            ": Tag ",
            tag,
            " wird empfohlen."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "Tag ",
            tag,
            " hinzuf\xFCgen"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "Startdatei hat die Endung ",
            fileExt,
            ": F\xFCgen Sie das Tag ",
            tag,
            " hinzu, um das Paket im Browser spielbar zu machen."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "Startdatei hat die Endung ",
            fileExt,
            ": Ist das ein Fehler? Normalerweise ist dies kein startbarer Dateityp."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "Startdatei hat die Endung ",
            fileExt,
            ": Es wird empfohlen, die eigentlichen Inhaltsdateien einzubinden, anstatt sie in ein Archiv zu packen."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "Startdatei ist nicht als ausf\xfchrbar markiert",
    'packages.new_dialog.checks.entrypoint.executable.action': "Als ausf\xfchrbar markieren",
    'packages.new_dialog.checks.single_root_dir': 'Es wird empfohlen, Dateien direkt im Stammverzeichnis abzulegen, anstatt einen einzelnen Ordner im Stammverzeichnis zu haben.',
    'packages.new_dialog.checks.single_root_dir.action': 'Ordner durch seinen Inhalt ersetzen',
    'packages.add_existing_dialog.header': "Paket hinzuf\xfcgen",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `${$e8e93204cf33cd3c$var$plural(packagesCount, `${packagesCount} Paket`, `${packagesCount} Pakete`)} hinzuf\xfcgen` : "Keine Pakete ausgew\xe4hlt",
    'packages.add_existing_dialog.message': 'Zuletzt hochgeladene Pakete:',
    'packages.add_existing_dialog.no_packages': "Keine k\xfcrzlich hochgeladenen Pakete.",
    'packages.launch': 'Starten',
    'packages.install': 'Installieren',
    'packages.install_dialog.header': 'Installieren',
    'packages.install_dialog.workdir.label': 'Arbeitsverzeichnis:',
    'packages.install_dialog.workdir.value.new': '(neu erstellen)',
    'packages.install_dialog.workspace.label': 'Ordner erstellen unter:',
    'packages.install_dialog.workspace.placeholder': "(Stammordner w\xe4hlen)",
    'packages.install_dialog.ok': 'Installieren',
    'packages.update': 'Aktualisieren',
    'packages.upload.status.existing': 'Aus vorheriger Version',
    'packages.upload.status.queued': 'In Warteschlange',
    'packages.upload.status.packing': 'Packen...',
    'packages.upload.status.creating': 'Erstellen...',
    'packages.upload.status.create_retrying': 'Erstellung fehlgeschlagen, erneuter Versuch...',
    'packages.upload.status.splitting': 'Aufteilen...',
    'packages.upload.status.uploading': 'Hochladen...',
    'packages.upload.status.finalizing': "Abschlie\xdfen...",
    'packages.upload.status.finalize_retrying': 'Abschluss fehlgeschlagen, erneuter Versuch...',
    'packages.upload.status.resolving': "Patch aufl\xf6sen...",
    'packages.upload.status.resolve_retrying': "Patch-Aufl\xf6sung fehlgeschlagen, erneuter Versuch...",
    'packages.upload.status.done': 'Erfolgreich hochgeladen',
    'packages.upload.status.errored': 'Fehler',
    'packages.upload.part.status.queued': 'In Warteschlange',
    'packages.upload.part.status.hashing': 'Hashing',
    'packages.upload.part.status.upload_queued': 'Upload in Warteschlange',
    'packages.upload.part.status.uploading': 'Hochladen',
    'packages.upload.part.status.upload_retrying': 'Fehler, Upload wird wiederholt',
    'packages.upload.part.status.upload_finalizing': 'Upload wird abgeschlossen',
    'packages.upload.part.status.upload_errored': 'Fehler',
    'packages.upload.part.status.done': 'Hochgeladen',
    'packages.play': 'Im Browser spielen',
    'packages.play.reset': "Zur\xfccksetzen",
    'packages.play.fullscreen': 'Vollbild',
    'deploy_sites.add_dialog.header': "Deploy-Seite hinzuf\xfcgen",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "W\xE4hlen Sie die Deploy-Anmeldedaten und geben Sie die Website-URL ein, um sie als Deploy-Seite f\xFCr das Projekt ",
            projectTitle,
            " zu speichern."
        ],
    'deploy_sites.add_dialog.label_credential': 'Deploy-Anmeldedaten:',
    'deploy_sites.add_dialog.select_credential': "Anmeldedaten ausw\xe4hlen",
    'deploy_sites.add_dialog.select_credential.new': "Neue Anmeldedaten hinzuf\xfcgen...",
    'deploy_sites.add_dialog.label_select_site': "Seite ausw\xe4hlen:",
    'deploy_sites.add_dialog.select_credential_first': "(zuerst Anmeldedaten w\xe4hlen)",
    'deploy_sites.add_dialog.select_site': "(Seite ausw\xe4hlen)",
    'deploy_sites.add_dialog.label_enter_site': 'Oder Website-URL eingeben:',
    'deploy_sites.add_dialog.ok': "Seite hinzuf\xfcgen",
    'deploy_to_site_dialog.header': "Auf Seite ver\xf6ffentlichen",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "W\xE4hlen Sie die Seite aus, auf der die Version ",
            versionTitle,
            " von ",
            projectTitle,
            " ver\xF6ffentlicht werden soll."
        ],
    'deploy_to_site_dialog.label_site': "Auf Seite ver\xf6ffentlichen:",
    'deploy_to_site_dialog.select_site': "Seite ausw\xe4hlen",
    'deploy_to_site_dialog.select_site.new': "Neue Deploy-Seite hinzuf\xfcgen...",
    'deploy_to_site_dialog.packages.message.itch': [
        "Pakete werden auf itch.io mit ",
        $e8e93204cf33cd3c$var$_tmpl$4(),
        " ver\xF6ffentlicht. Die Channel-Namen werden von den Paket-Tags abgeleitet."
    ],
    'deploy_to_site_dialog.deploy': "Ver\xf6ffentlichen",
    'deploy_to_site_dialog.close': "Schlie\xdfen",
    'deploy_to_site_dialog.error.no_packages': "Keine Pakete zum Ver\xf6ffentlichen.",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "Mehrere Pakete k\xF6nnen nicht im selben Channel ver\xF6ffentlicht werden. Derzeit sind ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$e8e93204cf33cd3c$var$plural(packagesCount, [
                    packagesCountText,
                    " Paket"
                ], [
                    packagesCountText,
                    " Pakete"
                ])),
            " f\xFCr die Ver\xF6ffentlichung im Channel ",
            channel,
            " konfiguriert."
        ],
    'deploy_to_site_dialog.job.queued': 'In Warteschlange',
    'deploy_to_site_dialog.job.downloading': 'Herunterladen...',
    'deploy_to_site_dialog.job.unpacking': 'Entpacken...',
    'deploy_to_site_dialog.job.uploading': "Ver\xf6ffentlichen...",
    'deploy_to_site_dialog.job.succeeded': 'Erfolgreich',
    'deploy_to_site_dialog.job.errored': 'Fehler',
    'store': 'Store',
    'store.hint': "\xd6ffentliche Projekte",
    'store.project.hint': 'Projektseite im Store',
    'store.project.owner': 'Entwickler',
    'store.project.description': 'Beschreibung',
    'store.project.star': 'Favorisieren',
    'store.project.starred': 'Favorisiert',
    'store.project.content': 'Inhalt',
    'store.project.content.warning': 'Dieser Inhalt wurde von einem Drittanbieter-Entwickler bereitgestellt.',
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            "Branch ",
            branchTitle,
            ": Version ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "Ver\xF6ffentlicht: ",
            branchVersionPublished
        ],
    'me': 'Profil',
    'me.hint': "Profileinstellungen und verkn\xfcpfte Anmeldedaten",
    'me.rename': 'Profil umbenennen',
    'me.rename_dialog.header': 'Profil umbenennen',
    'me.rename_dialog.label_title': 'Name:',
    'me.rename_dialog.ok': 'Profil umbenennen',
    'me.credentials': 'Anmeldedaten',
    'me.credentials.hint.auth_allowed': 'Jede dieser Anmeldedaten kann verwendet werden, um sich bei diesem Konto anzumelden.',
    'me.credentials.hint.auth_disallowed': "Diese Anmeldedaten sind mit Ihrem Konto verkn\xfcpft, k\xf6nnen aber nicht zur Anmeldung verwendet werden.",
    'me.credentials.empty': 'Keine Anmeldedaten.',
    'me.credentials.empty.auth_allowed.warning': "Sie k\xf6nnten sich aus Ihrem Konto aussperren! Sie haben keine Anmeldedaten f\xfcr den Login verkn\xfcpft. Bitte verkn\xfcpfen Sie so schnell wie m\xf6glich Anmeldedaten, mit denen Sie sich einloggen k\xf6nnen.",
    'me.credentials.profile_picture.alt': (provider)=>`Profilbild von ${$e8e93204cf33cd3c$var$dict[`auth.provider.${provider}`]}`,
    'me.credentials.created': (created)=>[
            "hinzugef\xFCgt am ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "zuletzt verwendet am ",
            lastUsed
        ],
    'me.credential.unlink': "Verkn\xfcpfung aufheben",
    'me.credential.allow_auth': 'Login erlauben',
    'me.credential.disallow_auth': 'Login verbieten',
    'me.credential.display_publicly': "\xd6ffentlich anzeigen",
    'me.credential.dont_display_publicly': "Nicht \xf6ffentlich anzeigen",
    'me.credential.link': "Anmeldedaten verkn\xfcpfen",
    'me.credential.link_dialog.header': "Anmeldedaten verkn\xfcpfen",
    'me.credential.link_dialog.message': "Bitte w\xe4hlen Sie den Konto-Anbieter aus, den Sie verkn\xfcpfen m\xf6chten.",
    'me.credential.unlink_dialog.header': "Verkn\xfcpfung aufheben",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "Sind Sie sicher, dass Sie das ",
            credentialProvider,
            "-Konto ",
            credentialTitle,
            " von Ihrem Kavykhi.Cloud-Konto trennen m\xF6chten?"
        ],
    'me.credential.unlink_dialog.ok': "Verkn\xfcpfung aufheben",
    'me.sessions': 'Sitzungen',
    'me.sessions.hint': "Dies ist eine Liste Ihrer aktiven Sitzungen, einschlie\xdflich Ihres aktuellen Browsers.",
    'me.sessions.started': (started)=>[
            "gestartet am ",
            (()=>{
                var _el$6 = $e8e93204cf33cd3c$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "aktiv am ",
            (()=>{
                var _el$7 = $e8e93204cf33cd3c$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': 'Aktuelle Sitzung',
    'me.sessions.empty': 'Keine Sitzungen.',
    'me.sessions.delete': 'Beenden',
    'me.sessions.delete_dialog.header': 'Sitzung beenden',
    'me.sessions.delete_dialog.message': "Sind Sie sicher, dass Sie diese Sitzung beenden m\xf6chten?",
    'me.sessions.delete_dialog.ok': 'Sitzung beenden',
    'me.api_tokens': 'API-Token',
    'me.api_tokens.hint': "API-Token k\xf6nnen hier f\xfcr die Automatisierung erstellt werden.",
    'me.api_tokens.started': (started)=>[
            "erstellt am ",
            (()=>{
                var _el$8 = $e8e93204cf33cd3c$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "l\xE4uft ab am ",
            (()=>{
                var _el$9 = $e8e93204cf33cd3c$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': 'kein Ablauf',
    'me.api_tokens.empty': 'Keine API-Token.',
    'me.api_tokens.create': 'API-Token generieren',
    'me.api_tokens.create_dialog.header': 'API-Token generieren',
    'me.api_tokens.create_dialog.message': 'Generierter API-Token:',
    'me.api_tokens.create_dialog.note': 'Der Token wird nicht noch einmal angezeigt, bitte speichern Sie ihn sicher ab.',
    'me.api_tokens.delete': "L\xf6schen",
    'me.api_tokens.delete_dialog.header': "API-Token l\xf6schen",
    'me.api_tokens.delete_dialog.message': "Sind Sie sicher, dass Sie diesen Token l\xf6schen m\xf6chten?",
    'me.api_tokens.delete_dialog.ok': "API-Token l\xf6schen",
    'me.deploy_credentials': 'Deploy-Anmeldedaten',
    'me.deploy_credentials.hint': "Anmeldedaten f\xfcr das Deployment auf Publishing-Plattformen k\xf6nnen hier hinzugef\xfcgt werden.",
    'me.deploy_credentials.empty': "Keine Deploy-Anmeldedaten hinzugef\xfcgt.",
    'me.deploy_credential.add': "Deploy-Anmeldedaten hinzuf\xfcgen",
    'me.deploy_credential.add_dialog.header': "Deploy-Anmeldedaten hinzuf\xfcgen",
    'me.deploy_credential.add_dialog.label_site': 'Seite:',
    'me.deploy_credential.add_dialog.label_title': 'Notiz:',
    'me.deploy_credential.add_dialog.label_key': "Schl\xfcssel:",
    'me.deploy_credential.add_dialog.default_title': (date)=>`Schl\xfcssel ${date}`,
    'me.deploy_credential.add_dialog.ok': "Deploy-Anmeldedaten hinzuf\xfcgen",
    'me.deploy_credential.add_dialog.hint.itch': [
        "Um den itch.io-API-Schl\xFCssel zu generieren, gehen Sie zu Ihren ",
        $e8e93204cf33cd3c$var$_tmpl$6(),
        " auf itch.io. Sie k\xF6nnen einen bestehenden API-Schl\xFCssel mit der Quelle \"web\" oder \"wharf\" verwenden. Ein API-Schl\xFCssel mit der Quelle \"Kavykhi.Cloud\" funktioniert nicht."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "Das Hinzuf\xFCgen von ",
            credentialProvider,
            "-Anmeldedaten wird derzeit nicht unterst\xFCtzt."
        ],
    'me.deploy_credential.delete': "L\xf6schen",
    'me.deploy_credential.delete_dialog.header': "Deploy-Anmeldedaten l\xf6schen",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "Sind Sie sicher, dass Sie die Anmeldedaten ",
            credentialTitle,
            " f\xFCr ",
            credentialProvider,
            " l\xF6schen m\xF6chten? Alle mit diesen Anmeldedaten konfigurierten Deploy-Seiten werden ebenfalls aus dem Projekt entfernt."
        ],
    'me.deploy_credential.delete_dialog.ok': "Anmeldedaten l\xf6schen",
    'me.public_profile': "\xd6ffentliches Profil",
    'me.public_profile.public_credentials': "\xd6ffentliche Anmeldedaten",
    'me.public_profile.public_credentials.hint': "W\xe4hlen Sie die Anmeldedaten aus, die \xf6ffentlich angezeigt werden sollen.",
    'me.manage': 'Konto verwalten',
    'me.delete': "Konto l\xf6schen",
    'me.delete.dialog.header': "Konto l\xf6schen",
    'me.delete.dialog.message': (userTitle)=>[
            "Sind Sie sicher, dass Sie Ihr Kavykhi.Cloud-Konto ",
            userTitle,
            " unwiderruflich l\xF6schen m\xF6chten?"
        ],
    'me.delete.dialog.ok': "Konto l\xf6schen",
    'invite': 'Einladung',
    'invite.hint': 'Projekteinladung',
    'invite.message.already_member': (projectTitle)=>[
            "Sie sind bereits Mitglied des Projekts ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "Sie wurden zum Projekt ",
            projectTitle,
            " eingeladen."
        ],
    'invite.join': 'Projekt beitreten',
    'local': 'Lokaler Inhalt',
    'local.hint': 'Lokal installierte Inhalte',
    'local.workdirs': 'Installierte Pakete',
    'local.workdirs.empty': 'Keine installierten Pakete.',
    'local.workdir.action.launch': 'Starten',
    'local.workdir.action.repair': 'Reparieren',
    'local.workdir.action.delete': 'Deinstallieren',
    'local.workdir.delete_dialog.header': 'Paket deinstallieren',
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "Sind Sie sicher, dass Sie das Paket ",
            packageTitle,
            " von Ihrem Ger\xE4t deinstallieren m\xF6chten?"
        ],
    'local.workdir.delete_dialog.ok': 'Deinstallieren',
    'local.workspaces': 'Stammordner',
    'local.app_not_detected.message': "Die lokale Kavykhi.Cloud-App wurde nicht erkannt. Bitte laden Sie sie \xfcber einen der folgenden Links herunter und installieren Sie sie. Wenn Sie sie bereits installiert haben, stellen Sie sicher, dass sie ausgef\xfchrt wird.",
    'local_app.detected': 'Lokaler Inhalt',
    'error_dialog.header': 'Fehler',
    'error_dialog.messageFunc': (e)=>`Fehler: ${$e8e93204cf33cd3c$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': "Dateien ausw\xe4hlen",
    'upload_box.choose_directories': "Ordner ausw\xe4hlen",
    'upload_box.add.progress_dialog.header': "Dateien werden hinzugef\xfcgt",
    'upload_box.add.progress_dialog.message': 'Dateien werden verarbeitet...',
    'upload_box.delete': (itemsCount)=>`${$e8e93204cf33cd3c$var$plural(itemsCount, `${itemsCount} Element`, `${itemsCount} Elemente`)} l\xf6schen`,
    'upload_box.start_upload': 'Upload starten',
    'upload_box.drop_area.message': 'Dateien und Ordner hierher ziehen',
    'upload_box.drop_area.box_dropping_message': "Hier ablegen, um ins Stammverzeichnis einzuf\xfcgen",
    'upload_box.entry.explode_folder': 'Ordner durch Inhalt ersetzen',
    'upload_box.entry.set_entrypoint': 'Als Startdatei festlegen',
    'upload_box.entry.mark_executable': "Als ausf\xfchrbar markieren",
    'upload_box.entry.unmark_executable': "Ausf\xfchrbar-Markierung aufheben",
    'upload_box.entry.remove': 'Entfernen',
    'package.tags.empty': '(keine Tags)',
    'package.tag.os': 'Betriebssystem',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Architektur',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': 'Bit-Breite',
    'package.tag.bits:64': '64-Bit',
    'package.tag.bits:32': '32-Bit',
    'package.tag.packaging': 'Paketierung',
    'package.tag.packaging:installer': 'Installer',
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': 'Komponente',
    'package.tag.component:client': 'Client',
    'package.tag.component:server': 'Server',
    'package.tag.runtime': 'Laufzeitumgebung',
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': 'Linux-Distribution',
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Doku',
    'docs.page_no_language': "In dieser Sprache nicht verf\xfcgbar",
    'docs.page_no_language.message': "Andere Versionen dieses Dokuments sind verf\xfcgbar:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': 'Inhalt melden',
    'report_content.dialog.header': 'Inhalt melden',
    'report_content.dialog.link': 'Meldung per E-Mail senden',
    'report_content.dialog.message': (email, link)=>[
            "Bitte klicken Sie auf den Link, um Ihre Meldung zu senden:",
            $e8e93204cf33cd3c$var$_tmpl$2(),
            $e8e93204cf33cd3c$var$_tmpl$2(),
            link,
            $e8e93204cf33cd3c$var$_tmpl$2(),
            $e8e93204cf33cd3c$var$_tmpl$2(),
            "Oder senden Sie uns manuell eine E-Mail an ",
            email
        ]
};
var $e8e93204cf33cd3c$export$2e2bcd8739ae039 = $e8e93204cf33cd3c$var$dict;
const $e8e93204cf33cd3c$var$plural = (n, one, many)=>n == 1 ? one : many;



var $3ebb84c2438b0a90$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>allowed`), $3ebb84c2438b0a90$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $3ebb84c2438b0a90$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>not allowed`), $3ebb84c2438b0a90$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $3ebb84c2438b0a90$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $3ebb84c2438b0a90$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>profile settings`);
const $3ebb84c2438b0a90$var$dict = {
    languageName: 'English',
    locale: 'en',
    fallback: '',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: 'Theme',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.system': 'System',
    'theme.sakura': 'Sakura',
    // generic
    email: 'Email',
    password: 'Password',
    ok: 'OK',
    cancel: 'Cancel',
    retry: 'Retry',
    copy: 'Copy',
    empty: '(no items)',
    loading: 'Loading...',
    calculating: 'Calculating...',
    error: 'Error',
    'in_development': 'This page is in development.',
    // errors
    'error.not_found': 'not found',
    'error.name_conflict': 'name conflict',
    'error.bad_param': 'bad param',
    'error.wrong_auth': 'wrong auth',
    'error.unauthorized': 'unauthorized',
    'error.wrong_credentials': 'wrong credentials',
    'error.wrong_provider': 'wrong provider',
    'error.insufficient_privileges': 'insufficient privileges',
    'error.not_empty': 'not empty',
    'error.limit_exceeded': 'limit exceeded',
    'error.already_member': 'already member',
    'error.not_finalized': 'not finalized',
    'error.already_finalized': 'already finalized',
    'error.unexpected_patch': 'unexpected patch',
    'error.timeout': 'timeout',
    'error.not_patch': 'not patch',
    'error.not_supported': 'not supported',
    'error.unexpected_error': 'unexpected error',
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': 'Authentication',
    'auth.dialog.please_select': 'Please select your account provider to sign in.',
    'auth.dialog.redirecting_to': (provider)=>`Redirecting to ${provider}...`,
    'auth.dialog.remember_me': 'Remember me',
    'auth.dialog.log_in': 'Log in',
    'auth.dialog.back': 'Back',
    'auth.dialog.progress_header': 'Authentication...',
    'auth.dialog.error.header': 'Authentication error',
    'auth.dialog.error.auth_not_allowed': 'This credential is forbidden by the user from using for authentication. Please use another credential.',
    'auth.dialog.error.unknown': 'Invalid authentication parameters. Please try again.',
    'auth.dialog.error.back': 'Go back',
    'user.profile': 'Profile',
    'user.logout': 'Log out',
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': 'Page not found',
    'page_not_found.message': 'This page does not exist.',
    'page_not_found.message2': 'Well, it kind of does, but there\'s nothing here. Here are the possibilities.',
    'page_not_found.items': [
        'Something was here before, but it is deleted now.',
        'Something is still here, but you do not have access.',
        'Or somebody was simply not careful while copying and pasting the link.'
    ],
    'home': 'Home',
    'home.header.hint': 'Cloud tools for indie devs',
    'home.description': 'Kavykhi.Cloud is a development platform for indie games. We support downloadable and browser games, private and public builds, branches, teams, and many more.',
    'home.auth': 'Sign in or sign up',
    'home.auth.hint': 'Create new account or log into existing one',
    'projects': 'Projects',
    'projects.hint': 'The projects you are working on',
    'projects.project': (project)=>`Project: ${project}`,
    'projects.project.hint': 'project',
    'projects.no_projects': 'You have no projects yet.',
    'projects.new': 'Create project',
    'projects.new_dialog.header': 'New project',
    'projects.new_dialog.label': 'Project name',
    'projects.new_dialog.ok': 'Create project',
    'projects.store_page': 'Public store page',
    'projects.description': 'Description',
    'projects.branches': 'Branches',
    'projects.versions': 'Versions',
    'projects.packages': 'Packages',
    'projects.management': 'Project settings',
    'projects.management.breadcrumb': 'Settings',
    'projects.management.title': (projectTitle)=>`${projectTitle} - settings`,
    'projects.management.hint': 'project settings',
    'projects.management.users': 'Team members',
    'projects.management.users.empty': 'No team members.',
    'projects.management.users.role.tester': 'Tester',
    'projects.management.users.role.developer': 'Developer',
    'projects.management.users.role.admin': 'Administrator',
    'projects.management.users.role.owner': 'Owner',
    'projects.management.users.role.starred': 'Starred',
    'projects.management.users.exile': 'Remove from team',
    'projects.management.users.exile.dialog.header': 'Remove from team',
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "Are you sure you want to remove ",
            userTitle,
            " from ",
            projectTitle,
            " project?"
        ],
    'projects.management.users.exile.dialog.ok': 'Remove from team',
    'projects.management.invites.one_time_invite': 'One-time invite link',
    'projects.management.invites.one_time_invite.header': 'One-time invite link',
    'projects.management.invites.one_time_invite.message': 'One-time invite link:',
    'projects.management.invites.one_time_invite.note': 'Valid for 24 hours, can be used once.',
    'projects.management.invites.new_dialog.header': 'Invite link',
    'projects.management.invites.new_dialog.expires': 'Expires in:',
    'projects.management.invites.new_dialog.expires.indefinite': '(no expiration)',
    'projects.management.invites.new_dialog.approval.label': 'User joins project:',
    'projects.management.invites.new_dialog.approval.not_approved': 'after admin approval',
    'projects.management.invites.new_dialog.approval.approved': 'immediately',
    'projects.management.invites.new_dialog.seats': 'Limit joins:',
    'projects.management.invites.new_dialog.seats.no_limit': '(no limit)',
    'projects.management.invites.new_dialog.ok': 'Create invite link',
    'projects.management.deploy_sites': 'Deploy sites',
    'projects.management.deploy_sites.empty': 'No deploy sites added.',
    'projects.management.deploy_sites.add': 'Add deploy site',
    'projects.management.deploy_sites.delete': 'Delete',
    'projects.management.deploy_sites.delete_dialog.header': 'Delete deploy site',
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "Are you sure you want to delete ",
            provider,
            " deploy site ",
            site,
            "?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': 'Delete deploy site',
    'projects.management.public_access': 'Public access',
    'projects.management.public_access.enable': 'Enable public access',
    'projects.management.public_access.enabled': [
        "Public access: ",
        $3ebb84c2438b0a90$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': 'The project\'s name and description are public, as well as any branches marked public.',
    'projects.management.public_access.enable_dialog.header': 'Enable public access',
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "Are you sure you want to allow public access to the project ",
            projectTitle,
            "?",
            $3ebb84c2438b0a90$var$_tmpl$2(),
            $3ebb84c2438b0a90$var$_tmpl$2(),
            "This will make basic information about the project available without authentication. You will need to separately enable public access for each branch you want to be public."
        ],
    'projects.management.public_access.enable_dialog.ok': 'Enable public access',
    'projects.management.public_access.disable': 'Disable public access',
    'projects.management.public_access.disabled': [
        "Public access: ",
        $3ebb84c2438b0a90$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': 'The project is private. Only the members of the project team can access it.',
    'projects.management.public_access.disable_dialog.header': 'Disable public access',
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "Are you sure you want to disable all public access to the project ",
            projectTitle,
            "?"
        ],
    'projects.management.public_access.disable_dialog.ok': 'Disable public access',
    'projects.management.public_access.branches': 'Public branches',
    'projects.management.manage': 'Manage project',
    'projects.rename': 'Rename project',
    'projects.rename_dialog.header': 'Rename project',
    'projects.rename_dialog.label': 'Project name:',
    'projects.rename_dialog.ok': 'Rename project',
    'projects.edit_description': 'Edit project description',
    'projects.edit_description_dialog.header': 'Edit project description',
    'projects.edit_description_dialog.label': 'Project description:',
    'projects.edit_description_dialog.ok': 'Edit description',
    'projects.leave': 'Leave project',
    'projects.leave_dialog.header': 'Leave project',
    'projects.leave_dialog.message': (projectTitle)=>[
            "Are you sure you want to leave ",
            projectTitle,
            " project?"
        ],
    'projects.leave_dialog.ok': 'Leave project',
    'projects.delete': 'Delete project',
    'projects.delete_dialog.header': 'Delete project',
    'projects.delete_dialog.message': (projectTitle)=>[
            "Are you sure you want to delete ",
            projectTitle,
            " project?"
        ],
    'projects.delete_dialog.ok': 'Delete project',
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': 'branch',
    'branches.no_branches': 'The project has no branches yet',
    'branches.new': 'Create branch',
    'branches.new_dialog.header': 'New branch',
    'branches.new_dialog.label': 'Branch name',
    'branches.new_dialog.ok': 'Create branch',
    'branches.current_version': (version)=>[
            "Current version: ",
            version
        ],
    'branches.current_version.packages': 'Current version packages',
    'branches.no_current_version': 'No current version',
    'branches.publish_version.new': 'Post new version',
    'branches.publish_version.existing': 'Repost existing version',
    'branches.version_history': 'Version history',
    'branches.version_history.empty': 'Version history of the branch is empty.',
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "Current branch version is kept ",
            quotaTime != null ? [
                "for ",
                quotaTime
            ] : "indefinitely",
            ". Previous versions are kept for at most ",
            quotaNonCurrentTime,
            ". Not more than ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$3ebb84c2438b0a90$var$plural(quotaCount, [
                    quotaCountText,
                    " version"
                ], [
                    quotaCountText,
                    " versions"
                ])),
            " total are kept per branch."
        ],
    'branches.manage': 'Manage branch',
    'branches.rename': 'Rename branch',
    'branches.rename_dialog.header': 'Rename branch',
    'branches.rename_dialog.label': 'Branch name:',
    'branches.rename_dialog.ok': 'Rename branch',
    'branches.delete': 'Delete branch',
    'branches.delete_dialog.header': 'Delete branch',
    'branches.delete_dialog.message': (branchTitle)=>[
            "Are you sure you want to delete ",
            branchTitle,
            " branch?"
        ],
    'branches.delete_dialog.ok': 'Delete branch',
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': 'version',
    'versions.current': 'Current',
    'versions.previous': 'Previous',
    'versions.description': 'Description',
    'versions.deploy_to_site.header': 'Publish to site',
    'versions.deploy_to_site': 'Publish to site',
    'versions.packages': 'Packages',
    'versions.branches': 'In branches',
    'versions.branches.publish': 'Post to branch',
    'versions.branches.empty': 'The version has not been posted in any branches.',
    'versions.new_dialog.header': 'New version',
    'versions.new_dialog.label_title': 'Version:',
    'versions.new_dialog.label_branch': 'Branch:',
    'versions.new_dialog.packages.header': 'Packages',
    'versions.new_dialog.packages.empty': 'No packages added.',
    'versions.new_dialog.packages.add': 'Add package',
    'versions.new_dialog.packages.add_existing': 'Add previously uploaded package',
    'versions.new_dialog.packages.replace': 'Replace package',
    'versions.new_dialog.packages.edit': 'Edit package',
    'versions.new_dialog.ok': 'Create version',
    'versions.manage': 'Manage version',
    'versions.rename': 'Rename version',
    'versions.rename_dialog.header': 'Rename version',
    'versions.rename_dialog.label': 'Version name:',
    'versions.rename_dialog.ok': 'Rename version',
    'versions.edit_description': 'Edit version description',
    'versions.edit_description_dialog.header': 'Edit version description',
    'versions.edit_description_dialog.label': 'Version description:',
    'versions.edit_description_dialog.ok': 'Edit description',
    'versions.delete': 'Delete version',
    'versions.delete_dialog.header': 'Delete version',
    'versions.delete_dialog.message': (versionTitle)=>[
            "Are you sure you want to delete version ",
            versionTitle,
            "?"
        ],
    'versions.delete_dialog.ok': 'Delete version',
    'versions.publish_dialog.header': 'Post version to a branch',
    'versions.publish_dialog.message': (versionTitle)=>[
            "Choose branch to post version ",
            versionTitle,
            " to."
        ],
    'versions.publish_dialog.no_branches': 'No branches in the project.',
    'versions.publish_dialog.ok': 'Post version',
    'versions.publish_existing_dialog.header': 'Repost version',
    'versions.publish_existing_dialog.message': 'Last versions:',
    'versions.publish_existing_dialog.no_versions': 'No versions in the project.',
    'versions.publish_existing_dialog.ok': 'Post version',
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': 'Package',
    'packages.download_zip': 'Download as ZIP',
    'packages.download_torrent': 'Download torrent',
    'packages.total_size': (size)=>[
            "Total size: ",
            size
        ],
    'packages.manage': 'Manage package',
    'packages.rename': 'Rename package',
    'packages.rename_dialog.header': 'Rename package',
    'packages.rename_dialog.label': 'Package name:',
    'packages.rename_dialog.ok': 'Rename package',
    'packages.edit_tags': 'Edit package tags',
    'packages.edit_tags_dialog.header': 'Edit package tags',
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "Specify tags of package ",
            packageTitle,
            ":"
        ],
    'packages.edit_tags_dialog.ok': 'Set package tags',
    'packages.entrypoint': (entrypoint)=>[
            "Start file: ",
            entrypoint
        ],
    'packages.entrypoint.empty': 'Start file is not set.',
    'packages.delete': 'Delete package',
    'packages.delete_dialog.header': 'Delete package',
    'packages.delete_dialog.message': (packageTitle)=>[
            "Are you sure you want to delete package ",
            packageTitle,
            "? The package will be deleted from all versions it was added to."
        ],
    'packages.delete_dialog.ok': 'Delete package',
    'packages.new_dialog.header': 'New package',
    'packages.new_dialog.label_title': 'Title:',
    'packages.new_dialog.title_placeholder': '(from tags)',
    'packages.new_dialog.tags.header': 'Tags',
    'packages.new_dialog.files.header': 'Files',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Total size: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(maximum ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "New data size: ",
            size
        ],
    'packages.new_dialog.checks.empty': 'No files added.',
    'packages.new_dialog.checks.entrypoint.empty': 'Start file is not set.',
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "Start file ",
            entrypoint,
            " does not exist; perhaps you forgot to add it? Please specify an existing start file, or you can set no start file at all."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': 'Unset start file',
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "Start file has extension ",
            fileExt,
            ": suggesting ",
            tag,
            " tag."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "Add ",
            tag,
            " tag"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "Start file has extension ",
            fileExt,
            ": add ",
            tag,
            " tag to make the package playable in browser."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "Start file has extension ",
            fileExt,
            ": is it a mistake? Usually it's not the type of file that can be started."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "Start file has extension ",
            fileExt,
            ": it is recommended to include actual content files rather than pack them into an archive file."
        ],
    'packages.new_dialog.checks.entrypoint.executable': 'Start file is not marked executable',
    'packages.new_dialog.checks.entrypoint.executable.action': 'Mark it executable',
    'packages.new_dialog.checks.single_root_dir': 'It is recommended to place files directly into root, rather than have a single directory at root.',
    'packages.new_dialog.checks.single_root_dir.action': 'Replace folder with its contents',
    'packages.add_existing_dialog.header': 'Add package',
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `Add ${$3ebb84c2438b0a90$var$plural(packagesCount, `${packagesCount} package`, `${packagesCount} packages`)}` : 'No packages selected',
    'packages.add_existing_dialog.message': 'Last uploaded packages:',
    'packages.add_existing_dialog.no_packages': 'No recently uploaded packages.',
    'packages.launch': 'Launch',
    'packages.install': 'Install',
    'packages.install_dialog.header': 'Install',
    'packages.install_dialog.workdir.label': 'Workdir:',
    'packages.install_dialog.workdir.value.new': '(create new)',
    'packages.install_dialog.workspace.label': 'Create folder under:',
    'packages.install_dialog.workspace.placeholder': '(select root folder)',
    'packages.install_dialog.ok': 'Install',
    'packages.update': 'Update',
    'packages.upload.status.existing': 'From previous version',
    'packages.upload.status.queued': 'Queued',
    'packages.upload.status.packing': 'Packing...',
    'packages.upload.status.creating': 'Creating...',
    'packages.upload.status.create_retrying': 'Creating failed, waiting and retrying',
    'packages.upload.status.splitting': 'Splitting...',
    'packages.upload.status.uploading': 'Uploading...',
    'packages.upload.status.finalizing': 'Finalizing...',
    'packages.upload.status.finalize_retrying': 'Finalize failed, waiting and retrying',
    'packages.upload.status.resolving': 'Resolving patch...',
    'packages.upload.status.resolve_retrying': 'Resolve patch failed, waiting and retrying...',
    'packages.upload.status.done': 'Uploaded successfully',
    'packages.upload.status.errored': 'Error',
    'packages.upload.part.status.queued': 'Queued',
    'packages.upload.part.status.hashing': 'Hashing',
    'packages.upload.part.status.upload_queued': 'Upload queued',
    'packages.upload.part.status.uploading': 'Uploading',
    'packages.upload.part.status.upload_retrying': 'Error, retrying upload',
    'packages.upload.part.status.upload_finalizing': 'Finalizing upload',
    'packages.upload.part.status.upload_errored': 'Error',
    'packages.upload.part.status.done': 'Uploaded',
    'packages.play': 'Play in browser',
    'packages.play.reset': 'Reset',
    'packages.play.fullscreen': 'Fullscreen',
    'deploy_sites.add_dialog.header': 'Add deploy site',
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "Choose deploy credential and enter site URL to save them as a deploy site for the project ",
            projectTitle,
            "."
        ],
    'deploy_sites.add_dialog.label_credential': 'Deploy credential:',
    'deploy_sites.add_dialog.select_credential': 'Select credential',
    'deploy_sites.add_dialog.select_credential.new': 'Add new credential...',
    'deploy_sites.add_dialog.label_select_site': 'Select site:',
    'deploy_sites.add_dialog.select_credential_first': '(select credential first)',
    'deploy_sites.add_dialog.select_site': '(select site)',
    'deploy_sites.add_dialog.label_enter_site': 'Or enter site URL:',
    'deploy_sites.add_dialog.ok': 'Add site',
    'deploy_to_site_dialog.header': 'Publish to site',
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "Choose site to publish the version ",
            versionTitle,
            " of ",
            projectTitle,
            "."
        ],
    'deploy_to_site_dialog.label_site': 'Publish to site:',
    'deploy_to_site_dialog.select_site': 'Select site',
    'deploy_to_site_dialog.select_site.new': 'Add new deploy site...',
    'deploy_to_site_dialog.packages.message.itch': [
        "Packages will be published to itch.io using ",
        $3ebb84c2438b0a90$var$_tmpl$4(),
        ". Channel names are derived from package tags."
    ],
    'deploy_to_site_dialog.deploy': 'Publish',
    'deploy_to_site_dialog.close': 'Close',
    'deploy_to_site_dialog.error.no_packages': 'No packages to publish.',
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "Multiple packages cannot be published into a single channel. Currently ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$3ebb84c2438b0a90$var$plural(packagesCount, [
                    packagesCountText,
                    " package"
                ], [
                    packagesCountText,
                    " packages"
                ])),
            " are set to publish in the channel ",
            channel,
            "."
        ],
    'deploy_to_site_dialog.job.queued': 'Queued',
    'deploy_to_site_dialog.job.downloading': 'Downloading...',
    'deploy_to_site_dialog.job.unpacking': 'Unpacking...',
    'deploy_to_site_dialog.job.uploading': 'Publishing...',
    'deploy_to_site_dialog.job.succeeded': 'Success',
    'deploy_to_site_dialog.job.errored': 'Error',
    'store': 'Store',
    'store.hint': 'Public projects',
    'store.project.hint': 'Store project page',
    'store.project.owner': 'Developer',
    'store.project.description': 'Description',
    'store.project.star': 'Star',
    'store.project.starred': 'Starred',
    'store.project.content': 'Content',
    'store.project.content.warning': 'The content has been provided by a third-party developer.',
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            branchTitle,
            " branch: version ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "Published: ",
            branchVersionPublished
        ],
    'me': 'Profile',
    'me.hint': 'Profile settings and linked credentials',
    'me.rename': 'Rename profile',
    'me.rename_dialog.header': 'Rename profile',
    'me.rename_dialog.label_title': 'Name:',
    'me.rename_dialog.ok': 'Rename profile',
    'me.credentials': 'Credentials',
    'me.credentials.hint.auth_allowed': 'Any of these credentials can be used to log in into this account.',
    'me.credentials.hint.auth_disallowed': 'These credentials are linked to your account, but cannot be used to log in.',
    'me.credentials.empty': 'No credentials.',
    'me.credentials.empty.auth_allowed.warning': 'You may get locked out of your account! You have linked no credentials to log in with. Please link a credential you can log in with as soon as possible.',
    'me.credentials.profile_picture.alt': (provider)=>`${$3ebb84c2438b0a90$var$dict[`auth.provider.${provider}`]} profile picture`,
    'me.credentials.created': (created)=>[
            "added ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "last used ",
            lastUsed
        ],
    'me.credential.unlink': 'Unlink',
    'me.credential.allow_auth': 'Allow log in',
    'me.credential.disallow_auth': 'Disallow log in',
    'me.credential.display_publicly': 'Display publicly',
    'me.credential.dont_display_publicly': 'Do not display publicly',
    'me.credential.link': 'Link credential',
    'me.credential.link_dialog.header': 'Link credential',
    'me.credential.link_dialog.message': 'Please select your account provider to link with.',
    'me.credential.unlink_dialog.header': 'Unlink credential',
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "Are you sure you want to unlink ",
            credentialProvider,
            " account ",
            credentialTitle,
            " from your Kavykhi.Cloud account?"
        ],
    'me.credential.unlink_dialog.ok': 'Unlink credential',
    'me.sessions': 'Sessions',
    'me.sessions.hint': 'This is a list of your active sessions, including your current browser.',
    'me.sessions.started': (started)=>[
            "started ",
            (()=>{
                var _el$6 = $3ebb84c2438b0a90$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "active ",
            (()=>{
                var _el$7 = $3ebb84c2438b0a90$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': 'Current session',
    'me.sessions.empty': 'No sessions.',
    'me.sessions.delete': 'Terminate',
    'me.sessions.delete_dialog.header': 'Terminate session',
    'me.sessions.delete_dialog.message': 'Are you sure you want to terminate this session?',
    'me.sessions.delete_dialog.ok': 'Terminate session',
    'me.api_tokens': 'API tokens',
    'me.api_tokens.hint': 'API tokens can be created here to use in automation.',
    'me.api_tokens.started': (started)=>[
            "created ",
            (()=>{
                var _el$8 = $3ebb84c2438b0a90$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "expires ",
            (()=>{
                var _el$9 = $3ebb84c2438b0a90$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': 'no expiration',
    'me.api_tokens.empty': 'No API tokens.',
    'me.api_tokens.create': 'Generate API token',
    'me.api_tokens.create_dialog.header': 'Generate API token',
    'me.api_tokens.create_dialog.message': 'Generated API token:',
    'me.api_tokens.create_dialog.note': 'The token will not be shown again, please save it safely.',
    'me.api_tokens.delete': 'Delete',
    'me.api_tokens.delete_dialog.header': 'Delete API token',
    'me.api_tokens.delete_dialog.message': 'Are you sure you want to delete this token?',
    'me.api_tokens.delete_dialog.ok': 'Delete API token',
    'me.deploy_credentials': 'Deploy credentials',
    'me.deploy_credentials.hint': 'Credentials for deploying to publishing platforms can be added here.',
    'me.deploy_credentials.empty': 'No deploy credentials added.',
    'me.deploy_credential.add': 'Add deploy credential',
    'me.deploy_credential.add_dialog.header': 'Add deploy credential',
    'me.deploy_credential.add_dialog.label_site': 'Site:',
    'me.deploy_credential.add_dialog.label_title': 'Note:',
    'me.deploy_credential.add_dialog.label_key': 'Key:',
    'me.deploy_credential.add_dialog.default_title': (date)=>`Key ${date}`,
    'me.deploy_credential.add_dialog.ok': 'Add deploy credential',
    'me.deploy_credential.add_dialog.hint.itch': [
        "To generate the itch.io API key, go to your ",
        $3ebb84c2438b0a90$var$_tmpl$6(),
        " on itch.io. You can use existing API key with source of \"web\" or \"wharf\". API key with source \"Kavykhi.Cloud\" will not work."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "We do not support adding ",
            credentialProvider,
            " credentials at the moment."
        ],
    'me.deploy_credential.delete': 'Delete',
    'me.deploy_credential.delete_dialog.header': 'Delete deploy credential',
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "Are you sure you want to delete credential ",
            credentialTitle,
            " for ",
            credentialProvider,
            "? Any deploy sites configured with this credential will also be removed from the project."
        ],
    'me.deploy_credential.delete_dialog.ok': 'Delete credential',
    'me.public_profile': 'Public profile',
    'me.public_profile.public_credentials': 'Public credentials',
    'me.public_profile.public_credentials.hint': 'Select credentials to display publicly.',
    'me.manage': 'Manage account',
    'me.delete': 'Delete account',
    'me.delete.dialog.header': 'Delete account',
    'me.delete.dialog.message': (userTitle)=>[
            "Are you sure you want to irrevocably delete your Kavykhi.Cloud account ",
            userTitle,
            "?"
        ],
    'me.delete.dialog.ok': 'Delete account',
    'invite': 'Invitation',
    'invite.hint': 'Project invitation',
    'invite.message.already_member': (projectTitle)=>[
            "You are already a member of the project ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "You have been invited to the project ",
            projectTitle,
            "."
        ],
    'invite.join': 'Join project',
    'local': 'Local content',
    'local.hint': 'Locally installed content',
    'local.workdirs': 'Installed packages',
    'local.workdirs.empty': 'No installed packages.',
    'local.workdir.action.launch': 'Launch',
    'local.workdir.action.repair': 'Repair',
    'local.workdir.action.delete': 'Uninstall',
    'local.workdir.delete_dialog.header': 'Uninstall package',
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "Are you sure you want to uninstall the ",
            packageTitle,
            " package from your device?"
        ],
    'local.workdir.delete_dialog.ok': 'Uninstall',
    'local.workspaces': 'Root folders',
    'local.app_not_detected.message': 'Kavykhi.Cloud local app is not detected. Please download and install it using one of the links below. If you already installed it, make sure it is running.',
    'local_app.detected': 'Local content',
    'error_dialog.header': 'Error',
    'error_dialog.messageFunc': (e)=>`Error: ${$3ebb84c2438b0a90$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': 'Pick files',
    'upload_box.choose_directories': 'Pick folders',
    'upload_box.add.progress_dialog.header': 'Adding files',
    'upload_box.add.progress_dialog.message': 'Processing files...',
    'upload_box.delete': (itemsCount)=>`Delete ${$3ebb84c2438b0a90$var$plural(itemsCount, `${itemsCount} item`, `${itemsCount} items`)}`,
    'upload_box.start_upload': 'Start upload',
    'upload_box.drop_area.message': 'Drop files and folders here',
    'upload_box.drop_area.box_dropping_message': 'Drop here to put into root',
    'upload_box.entry.explode_folder': 'Replace folder with its contents',
    'upload_box.entry.set_entrypoint': 'Set start file',
    'upload_box.entry.mark_executable': 'Mark executable',
    'upload_box.entry.unmark_executable': 'Unmark executable',
    'upload_box.entry.remove': 'Remove',
    'package.tags.empty': '(no tags)',
    'package.tag.os': 'OS',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Arch',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': 'Bitness',
    'package.tag.bits:64': '64-bit',
    'package.tag.bits:32': '32-bit',
    'package.tag.packaging': 'Packaging',
    'package.tag.packaging:installer': 'Installer',
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': 'Component',
    'package.tag.component:client': 'Client',
    'package.tag.component:server': 'Server',
    'package.tag.runtime': 'Runtime',
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': 'Linux distribution',
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Docs',
    'docs.page_no_language': 'Not available in this language',
    'docs.page_no_language.message': 'Other versions of this document available:',
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': 'Report content',
    'report_content.dialog.header': 'Report content',
    'report_content.dialog.link': 'Send report by email',
    'report_content.dialog.message': (email, link)=>[
            "Please click the link to send your report:",
            $3ebb84c2438b0a90$var$_tmpl$2(),
            $3ebb84c2438b0a90$var$_tmpl$2(),
            link,
            $3ebb84c2438b0a90$var$_tmpl$2(),
            $3ebb84c2438b0a90$var$_tmpl$2(),
            "Or email us manually at ",
            email
        ]
};
var $3ebb84c2438b0a90$export$2e2bcd8739ae039 = $3ebb84c2438b0a90$var$dict;
const $3ebb84c2438b0a90$var$plural = (n, one, many)=>n == 1 ? one : many;



var $b65dc39dc4f77aa0$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>permitido`), $b65dc39dc4f77aa0$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $b65dc39dc4f77aa0$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>no permitido`), $b65dc39dc4f77aa0$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $b65dc39dc4f77aa0$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $b65dc39dc4f77aa0$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>ajustes de tu perfil`);
const $b65dc39dc4f77aa0$var$dict = {
    languageName: "Espa\xf1ol",
    locale: 'es',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: 'Tema',
    'theme.light': 'Claro',
    'theme.dark': 'Oscuro',
    'theme.system': 'Sistema',
    'theme.sakura': 'Sakura',
    // generic
    email: 'Email',
    password: "Contrase\xf1a",
    ok: 'Aceptar',
    cancel: 'Cancelar',
    retry: 'Reintentar',
    copy: 'Copiar',
    empty: '(sin elementos)',
    loading: 'Cargando...',
    calculating: 'Calculando...',
    error: 'Error',
    'in_development': "Esta p\xe1gina est\xe1 en desarrollo.",
    // errors
    'error.not_found': 'no encontrado',
    'error.name_conflict': 'conflicto de nombres',
    'error.bad_param': "par\xe1metro incorrecto",
    'error.wrong_auth': "autenticaci\xf3n incorrecta",
    'error.unauthorized': 'no autorizado',
    'error.wrong_credentials': 'credenciales incorrectas',
    'error.wrong_provider': 'proveedor incorrecto',
    'error.insufficient_privileges': 'privilegios insuficientes',
    'error.not_empty': "no vac\xedo",
    'error.limit_exceeded': "l\xedmite excedido",
    'error.already_member': 'ya es miembro',
    'error.not_finalized': 'no finalizado',
    'error.already_finalized': 'ya finalizado',
    'error.unexpected_patch': 'parche inesperado',
    'error.timeout': 'tiempo de espera agotado',
    'error.not_patch': 'no es un parche',
    'error.not_supported': 'no soportado',
    'error.unexpected_error': 'error inesperado',
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "Autenticaci\xf3n",
    'auth.dialog.please_select': "Selecciona tu proveedor de cuenta para iniciar sesi\xf3n.",
    'auth.dialog.redirecting_to': (provider)=>`Redirigiendo a ${provider}...`,
    'auth.dialog.remember_me': 'Recordarme',
    'auth.dialog.log_in': "Iniciar sesi\xf3n",
    'auth.dialog.back': "Atr\xe1s",
    'auth.dialog.progress_header': 'Autenticando...',
    'auth.dialog.error.header': "Error de autenticaci\xf3n",
    'auth.dialog.error.auth_not_allowed': "El usuario ha prohibido el uso de esta credencial para la autenticaci\xf3n. Usa otra credencial.",
    'auth.dialog.error.unknown': "Par\xe1metros de autenticaci\xf3n no v\xe1lidos. Int\xe9ntalo de nuevo.",
    'auth.dialog.error.back': 'Volver',
    'user.profile': 'Perfil',
    'user.logout': "Cerrar sesi\xf3n",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "P\xe1gina no encontrada",
    'page_not_found.message': "Esta p\xe1gina no existe.",
    'page_not_found.message2': "Bueno, en cierto modo s\xed, pero no hay nada aqu\xed. Estas son las posibilidades.",
    'page_not_found.items': [
        "Hab\xeda algo aqu\xed antes, pero ya se ha eliminado.",
        "Todav\xeda hay algo aqu\xed, pero no tienes acceso.",
        'O simplemente alguien no tuvo cuidado al copiar y pegar el enlace.'
    ],
    'home': 'Inicio',
    'home.header.hint': 'Herramientas en la nube para desarrolladores indie',
    'home.description': "Kavykhi.Cloud es una plataforma de desarrollo para juegos indie. Soportamos juegos descargables y de navegador, versiones p\xfablicas y privadas, ramas, equipos y mucho m\xe1s.",
    'home.auth': "Iniciar sesi\xf3n o registrarse",
    'home.auth.hint': "Crea una cuenta nueva o inicia sesi\xf3n en una existente",
    'projects': 'Proyectos',
    'projects.hint': "Los proyectos en los que est\xe1s trabajando",
    'projects.project': (project)=>`Proyecto: ${project}`,
    'projects.project.hint': 'proyecto',
    'projects.no_projects': "A\xfan no tienes proyectos.",
    'projects.new': 'Crear proyecto',
    'projects.new_dialog.header': 'Nuevo proyecto',
    'projects.new_dialog.label': 'Nombre del proyecto',
    'projects.new_dialog.ok': 'Crear proyecto',
    'projects.store_page': "P\xe1gina p\xfablica de la tienda",
    'projects.description': "Descripci\xf3n",
    'projects.branches': 'Ramas',
    'projects.versions': 'Versiones',
    'projects.packages': 'Paquetes',
    'projects.management': 'Ajustes del proyecto',
    'projects.management.breadcrumb': 'Ajustes',
    'projects.management.title': (projectTitle)=>`${projectTitle} - ajustes`,
    'projects.management.hint': 'ajustes del proyecto',
    'projects.management.users': 'Miembros del equipo',
    'projects.management.users.empty': 'Sin miembros en el equipo.',
    'projects.management.users.role.tester': 'Tester',
    'projects.management.users.role.developer': 'Desarrollador',
    'projects.management.users.role.admin': 'Administrador',
    'projects.management.users.role.owner': 'Propietario',
    'projects.management.users.role.starred': 'Destacado',
    'projects.management.users.exile': 'Eliminar del equipo',
    'projects.management.users.exile.dialog.header': 'Eliminar del equipo',
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "\xBFSeguro que quieres eliminar a ",
            userTitle,
            " del proyecto ",
            projectTitle,
            "?"
        ],
    'projects.management.users.exile.dialog.ok': 'Eliminar del equipo',
    'projects.management.invites.one_time_invite': "Enlace de invitaci\xf3n de un solo uso",
    'projects.management.invites.one_time_invite.header': "Enlace de invitaci\xf3n de un solo uso",
    'projects.management.invites.one_time_invite.message': "Enlace de invitaci\xf3n de un solo uso:",
    'projects.management.invites.one_time_invite.note': "V\xe1lido por 24 horas, se puede usar una vez.",
    'projects.management.invites.new_dialog.header': "Enlace de invitaci\xf3n",
    'projects.management.invites.new_dialog.expires': 'Expira en:',
    'projects.management.invites.new_dialog.expires.indefinite': "(sin expiraci\xf3n)",
    'projects.management.invites.new_dialog.approval.label': 'El usuario se une al proyecto:',
    'projects.management.invites.new_dialog.approval.not_approved': "tras aprobaci\xf3n del admin",
    'projects.management.invites.new_dialog.approval.approved': 'inmediatamente',
    'projects.management.invites.new_dialog.seats': "L\xedmite de uniones:",
    'projects.management.invites.new_dialog.seats.no_limit': "(sin l\xedmite)",
    'projects.management.invites.new_dialog.ok': "Crear enlace de invitaci\xf3n",
    'projects.management.deploy_sites': 'Sitios de despliegue',
    'projects.management.deploy_sites.empty': "No se han a\xf1adido sitios de despliegue.",
    'projects.management.deploy_sites.add': "A\xf1adir sitio de despliegue",
    'projects.management.deploy_sites.delete': 'Eliminar',
    'projects.management.deploy_sites.delete_dialog.header': 'Eliminar sitio de despliegue',
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "\xBFSeguro que quieres eliminar el sitio de despliegue ",
            provider,
            " ",
            site,
            "?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': 'Eliminar sitio de despliegue',
    'projects.management.public_access': "Acceso p\xfablico",
    'projects.management.public_access.enable': "Habilitar acceso p\xfablico",
    'projects.management.public_access.enabled': [
        "Acceso p\xFAblico: ",
        $b65dc39dc4f77aa0$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "El nombre y la descripci\xf3n del proyecto son p\xfablicos, as\xed como cualquier rama marcada como p\xfablica.",
    'projects.management.public_access.enable_dialog.header': "Habilitar acceso p\xfablico",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "\xBFSeguro que quieres permitir el acceso p\xFAblico al proyecto ",
            projectTitle,
            "?",
            $b65dc39dc4f77aa0$var$_tmpl$2(),
            $b65dc39dc4f77aa0$var$_tmpl$2(),
            "Esto har\xE1 que la informaci\xF3n b\xE1sica del proyecto est\xE9 disponible sin autenticaci\xF3n. Deber\xE1s habilitar el acceso p\xFAblico por separado para cada rama que quieras que sea p\xFAblica."
        ],
    'projects.management.public_access.enable_dialog.ok': "Habilitar acceso p\xfablico",
    'projects.management.public_access.disable': "Deshabilitar acceso p\xfablico",
    'projects.management.public_access.disabled': [
        "Acceso p\xFAblico: ",
        $b65dc39dc4f77aa0$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': 'El proyecto es privado. Solo los miembros del equipo del proyecto pueden acceder.',
    'projects.management.public_access.disable_dialog.header': "Deshabilitar acceso p\xfablico",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "\xBFSeguro que quieres deshabilitar todo el acceso p\xFAblico al proyecto ",
            projectTitle,
            "?"
        ],
    'projects.management.public_access.disable_dialog.ok': "Deshabilitar acceso p\xfablico",
    'projects.management.public_access.branches': "Ramas p\xfablicas",
    'projects.management.manage': 'Gestionar proyecto',
    'projects.rename': 'Renombrar proyecto',
    'projects.rename_dialog.header': 'Renombrar proyecto',
    'projects.rename_dialog.label': 'Nombre del proyecto:',
    'projects.rename_dialog.ok': 'Renombrar proyecto',
    'projects.edit_description': "Editar descripci\xf3n del proyecto",
    'projects.edit_description_dialog.header': "Editar descripci\xf3n del proyecto",
    'projects.edit_description_dialog.label': "Descripci\xf3n del proyecto:",
    'projects.edit_description_dialog.ok': "Editar descripci\xf3n",
    'projects.leave': 'Salir del proyecto',
    'projects.leave_dialog.header': 'Salir del proyecto',
    'projects.leave_dialog.message': (projectTitle)=>[
            "\xBFSeguro que quieres salir del proyecto ",
            projectTitle,
            "?"
        ],
    'projects.leave_dialog.ok': 'Salir del proyecto',
    'projects.delete': 'Eliminar proyecto',
    'projects.delete_dialog.header': 'Eliminar proyecto',
    'projects.delete_dialog.message': (projectTitle)=>[
            "\xBFSeguro que quieres eliminar el proyecto ",
            projectTitle,
            "?"
        ],
    'projects.delete_dialog.ok': 'Eliminar proyecto',
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': 'rama',
    'branches.no_branches': "El proyecto a\xfan no tiene ramas",
    'branches.new': 'Crear rama',
    'branches.new_dialog.header': 'Nueva rama',
    'branches.new_dialog.label': 'Nombre de la rama',
    'branches.new_dialog.ok': 'Crear rama',
    'branches.current_version': (version)=>[
            "Versi\xF3n actual: ",
            version
        ],
    'branches.current_version.packages': "Paquetes de la versi\xf3n actual",
    'branches.no_current_version': "Sin versi\xf3n actual",
    'branches.publish_version.new': "Publicar nueva versi\xf3n",
    'branches.publish_version.existing': "Republicar versi\xf3n existente",
    'branches.version_history': 'Historial de versiones',
    'branches.version_history.empty': "El historial de versiones de la rama est\xe1 vac\xedo.",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "La versi\xF3n actual de la rama se conserva ",
            quotaTime != null ? [
                "durante ",
                quotaTime
            ] : "indefinidamente",
            ". Las versiones anteriores se conservan por un m\xE1ximo de ",
            quotaNonCurrentTime,
            ". No se conservan m\xE1s de ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$b65dc39dc4f77aa0$var$plural(quotaCount, [
                    quotaCountText,
                    " versi\xF3n"
                ], [
                    quotaCountText,
                    " versiones"
                ])),
            " en total por rama."
        ],
    'branches.manage': 'Gestionar rama',
    'branches.rename': 'Renombrar rama',
    'branches.rename_dialog.header': 'Renombrar rama',
    'branches.rename_dialog.label': 'Nombre de la rama:',
    'branches.rename_dialog.ok': 'Renombrar rama',
    'branches.delete': 'Eliminar rama',
    'branches.delete_dialog.header': 'Eliminar rama',
    'branches.delete_dialog.message': (branchTitle)=>[
            "\xBFSeguro que quieres eliminar la rama ",
            branchTitle,
            "?"
        ],
    'branches.delete_dialog.ok': 'Eliminar rama',
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "versi\xf3n",
    'versions.current': 'Actual',
    'versions.previous': 'Anterior',
    'versions.description': "Descripci\xf3n",
    'versions.deploy_to_site.header': 'Publicar en sitio',
    'versions.deploy_to_site': 'Publicar en sitio',
    'versions.packages': 'Paquetes',
    'versions.branches': 'En ramas',
    'versions.branches.publish': 'Publicar en rama',
    'versions.branches.empty': "La versi\xf3n no se ha publicado en ninguna rama.",
    'versions.new_dialog.header': "Nueva versi\xf3n",
    'versions.new_dialog.label_title': "Versi\xf3n:",
    'versions.new_dialog.label_branch': 'Rama:',
    'versions.new_dialog.packages.header': 'Paquetes',
    'versions.new_dialog.packages.empty': "No se han a\xf1adido paquetes.",
    'versions.new_dialog.packages.add': "A\xf1adir paquete",
    'versions.new_dialog.packages.add_existing': "A\xf1adir paquete subido previamente",
    'versions.new_dialog.packages.replace': 'Reemplazar paquete',
    'versions.new_dialog.packages.edit': 'Editar paquete',
    'versions.new_dialog.ok': "Crear versi\xf3n",
    'versions.manage': "Gestionar versi\xf3n",
    'versions.rename': "Renombrar versi\xf3n",
    'versions.rename_dialog.header': "Renombrar versi\xf3n",
    'versions.rename_dialog.label': "Nombre de la versi\xf3n:",
    'versions.rename_dialog.ok': "Renombrar versi\xf3n",
    'versions.edit_description': "Editar descripci\xf3n de la versi\xf3n",
    'versions.edit_description_dialog.header': "Editar descripci\xf3n de la versi\xf3n",
    'versions.edit_description_dialog.label': "Descripci\xf3n de la versi\xf3n:",
    'versions.edit_description_dialog.ok': "Editar descripci\xf3n",
    'versions.delete': "Eliminar versi\xf3n",
    'versions.delete_dialog.header': "Eliminar versi\xf3n",
    'versions.delete_dialog.message': (versionTitle)=>[
            "\xBFSeguro que quieres eliminar la versi\xF3n ",
            versionTitle,
            "?"
        ],
    'versions.delete_dialog.ok': "Eliminar versi\xf3n",
    'versions.publish_dialog.header': "Publicar versi\xf3n en una rama",
    'versions.publish_dialog.message': (versionTitle)=>[
            "Elige la rama en la que publicar la versi\xF3n ",
            versionTitle,
            "."
        ],
    'versions.publish_dialog.no_branches': 'No hay ramas en el proyecto.',
    'versions.publish_dialog.ok': "Publicar versi\xf3n",
    'versions.publish_existing_dialog.header': "Republicar versi\xf3n",
    'versions.publish_existing_dialog.message': "\xdaltimas versiones:",
    'versions.publish_existing_dialog.no_versions': 'No hay versiones en el proyecto.',
    'versions.publish_existing_dialog.ok': "Publicar versi\xf3n",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': 'Paquete',
    'packages.download_zip': 'Descargar como ZIP',
    'packages.download_torrent': 'Descargar torrent',
    'packages.total_size': (size)=>[
            "Tama\xF1o total: ",
            size
        ],
    'packages.manage': 'Gestionar paquete',
    'packages.rename': 'Renombrar paquete',
    'packages.rename_dialog.header': 'Renombrar paquete',
    'packages.rename_dialog.label': 'Nombre del paquete:',
    'packages.rename_dialog.ok': 'Renombrar paquete',
    'packages.edit_tags': 'Editar etiquetas del paquete',
    'packages.edit_tags_dialog.header': 'Editar etiquetas del paquete',
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "Especifica las etiquetas del paquete ",
            packageTitle,
            ":"
        ],
    'packages.edit_tags_dialog.ok': 'Establecer etiquetas',
    'packages.entrypoint': (entrypoint)=>[
            "Archivo de inicio: ",
            entrypoint
        ],
    'packages.entrypoint.empty': 'No se ha establecido el archivo de inicio.',
    'packages.delete': 'Eliminar paquete',
    'packages.delete_dialog.header': 'Eliminar paquete',
    'packages.delete_dialog.message': (packageTitle)=>[
            "\xBFSeguro que quieres eliminar el paquete ",
            packageTitle,
            "? Se eliminar\xE1 de todas las versiones a las que fue a\xF1adido."
        ],
    'packages.delete_dialog.ok': 'Eliminar paquete',
    'packages.new_dialog.header': 'Nuevo paquete',
    'packages.new_dialog.label_title': "T\xedtulo:",
    'packages.new_dialog.title_placeholder': '(desde etiquetas)',
    'packages.new_dialog.tags.header': 'Etiquetas',
    'packages.new_dialog.files.header': 'Archivos',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Tama\xF1o total: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(m\xE1ximo ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "Tama\xF1o de datos nuevos: ",
            size
        ],
    'packages.new_dialog.checks.empty': "No se han a\xf1adido archivos.",
    'packages.new_dialog.checks.entrypoint.empty': 'No se ha establecido el archivo de inicio.',
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "El archivo de inicio ",
            entrypoint,
            " no existe; \xBFquiz\xE1s olvidaste a\xF1adirlo? Especifica un archivo de inicio existente, o no establezcas ninguno."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': 'Quitar archivo de inicio',
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "El archivo de inicio tiene la extensi\xF3n ",
            fileExt,
            ": se sugiere la etiqueta ",
            tag,
            "."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "A\xF1adir etiqueta ",
            tag
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "El archivo de inicio tiene la extensi\xF3n ",
            fileExt,
            ": a\xF1ade la etiqueta ",
            tag,
            " para que el paquete se pueda jugar en el navegador."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "El archivo de inicio tiene la extensi\xF3n ",
            fileExt,
            ": \xBFes un error? Normalmente no es un tipo de archivo ejecutable."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "El archivo de inicio tiene la extensi\xF3n ",
            fileExt,
            ": se recomienda incluir los archivos de contenido reales en lugar de empaquetarlos en un archivo comprimido."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "El archivo de inicio no est\xe1 marcado como ejecutable",
    'packages.new_dialog.checks.entrypoint.executable.action': 'Marcar como ejecutable',
    'packages.new_dialog.checks.single_root_dir': "Se recomienda colocar los archivos directamente en la ra\xedz, en lugar de tener una \xfanica carpeta en la ra\xedz.",
    'packages.new_dialog.checks.single_root_dir.action': 'Reemplazar carpeta con su contenido',
    'packages.add_existing_dialog.header': "A\xf1adir paquete",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `A\xf1adir ${$b65dc39dc4f77aa0$var$plural(packagesCount, `${packagesCount} paquete`, `${packagesCount} paquetes`)}` : "Ning\xfan paquete seleccionado",
    'packages.add_existing_dialog.message': "\xdaltimos paquetes subidos:",
    'packages.add_existing_dialog.no_packages': 'No hay paquetes subidos recientemente.',
    'packages.launch': 'Iniciar',
    'packages.install': 'Instalar',
    'packages.install_dialog.header': 'Instalar',
    'packages.install_dialog.workdir.label': 'Directorio de trabajo:',
    'packages.install_dialog.workdir.value.new': '(crear nuevo)',
    'packages.install_dialog.workspace.label': 'Crear carpeta bajo:',
    'packages.install_dialog.workspace.placeholder': "(seleccionar carpeta ra\xedz)",
    'packages.install_dialog.ok': 'Instalar',
    'packages.update': 'Actualizar',
    'packages.upload.status.existing': "De la versi\xf3n anterior",
    'packages.upload.status.queued': 'En cola',
    'packages.upload.status.packing': 'Empaquetando...',
    'packages.upload.status.creating': 'Creando...',
    'packages.upload.status.create_retrying': 'Error al crear, esperando y reintentando',
    'packages.upload.status.splitting': 'Dividiendo...',
    'packages.upload.status.uploading': 'Subiendo...',
    'packages.upload.status.finalizing': 'Finalizando...',
    'packages.upload.status.finalize_retrying': 'Error al finalizar, esperando y reintentando',
    'packages.upload.status.resolving': 'Resolviendo parche...',
    'packages.upload.status.resolve_retrying': 'Error al resolver parche, esperando y reintentando...',
    'packages.upload.status.done': "Subido con \xe9xito",
    'packages.upload.status.errored': 'Error',
    'packages.upload.part.status.queued': 'En cola',
    'packages.upload.part.status.hashing': 'Calculando hash',
    'packages.upload.part.status.upload_queued': 'Subida en cola',
    'packages.upload.part.status.uploading': 'Subiendo',
    'packages.upload.part.status.upload_retrying': 'Error, reintentando subida',
    'packages.upload.part.status.upload_finalizing': 'Finalizando subida',
    'packages.upload.part.status.upload_errored': 'Error',
    'packages.upload.part.status.done': 'Subido',
    'packages.play': 'Jugar en navegador',
    'packages.play.reset': 'Reiniciar',
    'packages.play.fullscreen': 'Pantalla completa',
    'deploy_sites.add_dialog.header': "A\xf1adir sitio de despliegue",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "Elige una credencial de despliegue e introduce la URL del sitio para guardarlos como sitio de despliegue para el proyecto ",
            projectTitle,
            "."
        ],
    'deploy_sites.add_dialog.label_credential': 'Credencial de despliegue:',
    'deploy_sites.add_dialog.select_credential': 'Seleccionar credencial',
    'deploy_sites.add_dialog.select_credential.new': "A\xf1adir nueva credencial...",
    'deploy_sites.add_dialog.label_select_site': 'Seleccionar sitio:',
    'deploy_sites.add_dialog.select_credential_first': '(selecciona primero una credencial)',
    'deploy_sites.add_dialog.select_site': '(seleccionar sitio)',
    'deploy_sites.add_dialog.label_enter_site': 'O introduce la URL del sitio:',
    'deploy_sites.add_dialog.ok': "A\xf1adir sitio",
    'deploy_to_site_dialog.header': 'Publicar en sitio',
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "Elige el sitio para publicar la versi\xF3n ",
            versionTitle,
            " de ",
            projectTitle,
            "."
        ],
    'deploy_to_site_dialog.label_site': 'Publicar en sitio:',
    'deploy_to_site_dialog.select_site': 'Seleccionar sitio',
    'deploy_to_site_dialog.select_site.new': "A\xf1adir nuevo sitio de despliegue...",
    'deploy_to_site_dialog.packages.message.itch': [
        "Los paquetes se publicar\xE1n en itch.io usando ",
        $b65dc39dc4f77aa0$var$_tmpl$4(),
        ". Los nombres de los canales se derivan de las etiquetas del paquete."
    ],
    'deploy_to_site_dialog.deploy': 'Publicar',
    'deploy_to_site_dialog.close': 'Cerrar',
    'deploy_to_site_dialog.error.no_packages': 'No hay paquetes para publicar.',
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "No se pueden publicar m\xFAltiples paquetes en un solo canal. Actualmente ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$b65dc39dc4f77aa0$var$plural(packagesCount, [
                    packagesCountText,
                    " paquete est\xE1"
                ], [
                    packagesCountText,
                    " paquetes est\xE1n"
                ])),
            " configurados para publicarse en el canal ",
            channel,
            "."
        ],
    'deploy_to_site_dialog.job.queued': 'En cola',
    'deploy_to_site_dialog.job.downloading': 'Descargando...',
    'deploy_to_site_dialog.job.unpacking': 'Desempaquetando...',
    'deploy_to_site_dialog.job.uploading': 'Publicando...',
    'deploy_to_site_dialog.job.succeeded': "\xc9xito",
    'deploy_to_site_dialog.job.errored': 'Error',
    'store': 'Tienda',
    'store.hint': "Proyectos p\xfablicos",
    'store.project.hint': "P\xe1gina del proyecto en la tienda",
    'store.project.owner': 'Desarrollador',
    'store.project.description': "Descripci\xf3n",
    'store.project.star': 'Destacar',
    'store.project.starred': 'Destacado',
    'store.project.content': 'Contenido',
    'store.project.content.warning': 'El contenido ha sido proporcionado por un desarrollador externo.',
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            "Rama ",
            branchTitle,
            ": versi\xF3n ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "Publicado: ",
            branchVersionPublished
        ],
    'me': 'Perfil',
    'me.hint': 'Ajustes de perfil y credenciales vinculadas',
    'me.rename': 'Renombrar perfil',
    'me.rename_dialog.header': 'Renombrar perfil',
    'me.rename_dialog.label_title': 'Nombre:',
    'me.rename_dialog.ok': 'Renombrar perfil',
    'me.credentials': 'Credenciales',
    'me.credentials.hint.auth_allowed': "Cualquiera de estas credenciales se puede usar para iniciar sesi\xf3n en esta cuenta.",
    'me.credentials.hint.auth_disallowed': "Estas credenciales est\xe1n vinculadas a tu cuenta, pero no se pueden usar para iniciar sesi\xf3n.",
    'me.credentials.empty': 'Sin credenciales.',
    'me.credentials.empty.auth_allowed.warning': "\xa1Podr\xedas perder el acceso a tu cuenta! No has vinculado ninguna credencial para iniciar sesi\xf3n. Vincula una credencial con la que puedas iniciar sesi\xf3n lo antes posible.",
    'me.credentials.profile_picture.alt': (provider)=>`Foto de perfil de ${$b65dc39dc4f77aa0$var$dict[`auth.provider.${provider}`]}`,
    'me.credentials.created': (created)=>[
            "a\xF1adido ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\xFAltimo uso ",
            lastUsed
        ],
    'me.credential.unlink': 'Desvincular',
    'me.credential.allow_auth': "Permitir inicio de sesi\xf3n",
    'me.credential.disallow_auth': "No permitir inicio de sesi\xf3n",
    'me.credential.display_publicly': "Mostrar p\xfablicamente",
    'me.credential.dont_display_publicly': "No mostrar p\xfablicamente",
    'me.credential.link': 'Vincular credencial',
    'me.credential.link_dialog.header': 'Vincular credencial',
    'me.credential.link_dialog.message': 'Selecciona el proveedor de cuenta que deseas vincular.',
    'me.credential.unlink_dialog.header': 'Desvincular credencial',
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "\xBFSeguro que quieres desvincular la cuenta de ",
            credentialProvider,
            " ",
            credentialTitle,
            " de tu cuenta de Kavykhi.Cloud?"
        ],
    'me.credential.unlink_dialog.ok': 'Desvincular credencial',
    'me.sessions': 'Sesiones',
    'me.sessions.hint': 'Esta es una lista de tus sesiones activas, incluyendo tu navegador actual.',
    'me.sessions.started': (started)=>[
            "iniciada ",
            (()=>{
                var _el$6 = $b65dc39dc4f77aa0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "activa ",
            (()=>{
                var _el$7 = $b65dc39dc4f77aa0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "Sesi\xf3n actual",
    'me.sessions.empty': 'Sin sesiones.',
    'me.sessions.delete': 'Terminar',
    'me.sessions.delete_dialog.header': "Terminar sesi\xf3n",
    'me.sessions.delete_dialog.message': "\xbfSeguro que quieres terminar esta sesi\xf3n?",
    'me.sessions.delete_dialog.ok': "Terminar sesi\xf3n",
    'me.api_tokens': 'Tokens de API',
    'me.api_tokens.hint': "Aqu\xed se pueden crear tokens de API para usar en automatizaci\xf3n.",
    'me.api_tokens.started': (started)=>[
            "creado ",
            (()=>{
                var _el$8 = $b65dc39dc4f77aa0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "expira ",
            (()=>{
                var _el$9 = $b65dc39dc4f77aa0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "sin expiraci\xf3n",
    'me.api_tokens.empty': 'Sin tokens de API.',
    'me.api_tokens.create': 'Generar token de API',
    'me.api_tokens.create_dialog.header': 'Generar token de API',
    'me.api_tokens.create_dialog.message': 'Token de API generado:',
    'me.api_tokens.create_dialog.note': "El token no se volver\xe1 a mostrar, gu\xe1rdalo de forma segura.",
    'me.api_tokens.delete': 'Eliminar',
    'me.api_tokens.delete_dialog.header': 'Eliminar token de API',
    'me.api_tokens.delete_dialog.message': "\xbfSeguro que quieres eliminar este token?",
    'me.api_tokens.delete_dialog.ok': 'Eliminar token de API',
    'me.deploy_credentials': 'Credenciales de despliegue',
    'me.deploy_credentials.hint': "Aqu\xed se pueden a\xf1adir credenciales para desplegar en plataformas de publicaci\xf3n.",
    'me.deploy_credentials.empty': "No se han a\xf1adido credenciales de despliegue.",
    'me.deploy_credential.add': "A\xf1adir credencial de despliegue",
    'me.deploy_credential.add_dialog.header': "A\xf1adir credencial de despliegue",
    'me.deploy_credential.add_dialog.label_site': 'Sitio:',
    'me.deploy_credential.add_dialog.label_title': 'Nota:',
    'me.deploy_credential.add_dialog.label_key': 'Clave:',
    'me.deploy_credential.add_dialog.default_title': (date)=>`Clave ${date}`,
    'me.deploy_credential.add_dialog.ok': "A\xf1adir credencial de despliegue",
    'me.deploy_credential.add_dialog.hint.itch': [
        "Para generar la clave de API de itch.io, ve a los ",
        $b65dc39dc4f77aa0$var$_tmpl$6(),
        " en itch.io. Puedes usar una clave de API existente con origen \"web\" o \"wharf\". Una clave de API con origen \"Kavykhi.Cloud\" no funcionar\xE1."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "No soportamos a\xF1adir credenciales de ",
            credentialProvider,
            " en este momento."
        ],
    'me.deploy_credential.delete': 'Eliminar',
    'me.deploy_credential.delete_dialog.header': 'Eliminar credencial de despliegue',
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "\xBFSeguro que quieres eliminar la credencial ",
            credentialTitle,
            " para ",
            credentialProvider,
            "? Cualquier sitio de despliegue configurado con esta credencial tambi\xE9n se eliminar\xE1 del proyecto."
        ],
    'me.deploy_credential.delete_dialog.ok': 'Eliminar credencial',
    'me.public_profile': "Perfil p\xfablico",
    'me.public_profile.public_credentials': "Credenciales p\xfablicas",
    'me.public_profile.public_credentials.hint': "Selecciona las credenciales que deseas mostrar p\xfablicamente.",
    'me.manage': 'Gestionar cuenta',
    'me.delete': 'Eliminar cuenta',
    'me.delete.dialog.header': 'Eliminar cuenta',
    'me.delete.dialog.message': (userTitle)=>[
            "\xBFSeguro que quieres eliminar irrevocablemente tu cuenta de Kavykhi.Cloud ",
            userTitle,
            "?"
        ],
    'me.delete.dialog.ok': 'Eliminar cuenta',
    'invite': "Invitaci\xf3n",
    'invite.hint': "Invitaci\xf3n al proyecto",
    'invite.message.already_member': (projectTitle)=>[
            "Ya eres miembro del proyecto ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "Has sido invitado al proyecto ",
            projectTitle,
            "."
        ],
    'invite.join': 'Unirse al proyecto',
    'local': 'Contenido local',
    'local.hint': 'Contenido instalado localmente',
    'local.workdirs': 'Paquetes instalados',
    'local.workdirs.empty': 'No hay paquetes instalados.',
    'local.workdir.action.launch': 'Iniciar',
    'local.workdir.action.repair': 'Reparar',
    'local.workdir.action.delete': 'Desinstalar',
    'local.workdir.delete_dialog.header': 'Desinstalar paquete',
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\xBFSeguro que quieres desinstalar el paquete ",
            packageTitle,
            " de tu dispositivo?"
        ],
    'local.workdir.delete_dialog.ok': 'Desinstalar',
    'local.workspaces': "Carpetas ra\xedz",
    'local.app_not_detected.message': "No se detecta la aplicaci\xf3n local de Kavykhi.Cloud. Desc\xe1rgala e inst\xe1lala usando uno de los enlaces de abajo. Si ya la instalaste, aseg\xfarate de que se est\xe1 ejecutando.",
    'local_app.detected': 'Contenido local',
    'error_dialog.header': 'Error',
    'error_dialog.messageFunc': (e)=>`Error: ${$b65dc39dc4f77aa0$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': 'Elegir archivos',
    'upload_box.choose_directories': 'Elegir carpetas',
    'upload_box.add.progress_dialog.header': "A\xf1adiendo archivos",
    'upload_box.add.progress_dialog.message': 'Procesando archivos...',
    'upload_box.delete': (itemsCount)=>`Eliminar ${$b65dc39dc4f77aa0$var$plural(itemsCount, `${itemsCount} elemento`, `${itemsCount} elementos`)}`,
    'upload_box.start_upload': 'Iniciar subida',
    'upload_box.drop_area.message': "Arrastra archivos y carpetas aqu\xed",
    'upload_box.drop_area.box_dropping_message': "Suelta aqu\xed para colocar en la ra\xedz",
    'upload_box.entry.explode_folder': 'Reemplazar carpeta con su contenido',
    'upload_box.entry.set_entrypoint': 'Establecer archivo de inicio',
    'upload_box.entry.mark_executable': 'Marcar como ejecutable',
    'upload_box.entry.unmark_executable': 'Desmarcar como ejecutable',
    'upload_box.entry.remove': 'Quitar',
    'package.tags.empty': '(sin etiquetas)',
    'package.tag.os': 'SO',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Arq',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': 'Bits',
    'package.tag.bits:64': '64 bits',
    'package.tag.bits:32': '32 bits',
    'package.tag.packaging': 'Empaquetado',
    'package.tag.packaging:installer': 'Instalador',
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': 'Componente',
    'package.tag.component:client': 'Cliente',
    'package.tag.component:server': 'Servidor',
    'package.tag.runtime': "Entorno de ejecuci\xf3n",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Distribuci\xf3n Linux",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Docs',
    'docs.page_no_language': 'No disponible en este idioma',
    'docs.page_no_language.message': 'Otras versiones disponibles de este documento:',
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': 'Reportar contenido',
    'report_content.dialog.header': 'Reportar contenido',
    'report_content.dialog.link': 'Enviar reporte por email',
    'report_content.dialog.message': (email, link)=>[
            "Haz clic en el enlace para enviar tu reporte:",
            $b65dc39dc4f77aa0$var$_tmpl$2(),
            $b65dc39dc4f77aa0$var$_tmpl$2(),
            link,
            $b65dc39dc4f77aa0$var$_tmpl$2(),
            $b65dc39dc4f77aa0$var$_tmpl$2(),
            "O env\xEDanos un correo manualmente a ",
            email
        ]
};
var $b65dc39dc4f77aa0$export$2e2bcd8739ae039 = $b65dc39dc4f77aa0$var$dict;
const $b65dc39dc4f77aa0$var$plural = (n, one, many)=>n == 1 ? one : many;



var $9f804369a7a26616$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>autoris\xe9`), $9f804369a7a26616$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $9f804369a7a26616$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>non autoris\xe9`), $9f804369a7a26616$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $9f804369a7a26616$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $9f804369a7a26616$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>param\xe8tres de votre profil`);
const $9f804369a7a26616$var$dict = {
    languageName: "Fran\xe7ais",
    locale: 'fr',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: "Th\xe8me",
    'theme.light': 'Clair',
    'theme.dark': 'Sombre',
    'theme.system': "Syst\xe8me",
    'theme.sakura': 'Sakura',
    // generic
    email: 'E-mail',
    password: 'Mot de passe',
    ok: 'OK',
    cancel: 'Annuler',
    retry: "R\xe9essayer",
    copy: 'Copier',
    empty: "(aucun \xe9l\xe9ment)",
    loading: 'Chargement...',
    calculating: 'Calcul...',
    error: 'Erreur',
    'in_development': "Cette page est en cours de d\xe9veloppement.",
    // errors
    'error.not_found': 'introuvable',
    'error.name_conflict': 'conflit de nom',
    'error.bad_param': "param\xe8tre incorrect",
    'error.wrong_auth': 'authentification incorrecte',
    'error.unauthorized': "non autoris\xe9",
    'error.wrong_credentials': 'identifiants incorrects',
    'error.wrong_provider': 'fournisseur incorrect',
    'error.insufficient_privileges': "privil\xe8ges insuffisants",
    'error.not_empty': 'non vide',
    'error.limit_exceeded': "limite d\xe9pass\xe9e",
    'error.already_member': "d\xe9j\xe0 membre",
    'error.not_finalized': "non finalis\xe9",
    'error.already_finalized': "d\xe9j\xe0 finalis\xe9",
    'error.unexpected_patch': 'correctif inattendu',
    'error.timeout': "d\xe9lai d'attente d\xe9pass\xe9",
    'error.not_patch': 'pas un correctif',
    'error.not_supported': 'non pris en charge',
    'error.unexpected_error': 'erreur inattendue',
    // data sizes
    'datasize.B': 'Octets',
    'datasize.KiB': 'Kio',
    'datasize.MiB': 'Mio',
    'datasize.GiB': 'Gio',
    'datasize.TiB': 'Tio',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': 'Authentification',
    'auth.dialog.please_select': "Veuillez s\xe9lectionner votre fournisseur de compte pour vous connecter.",
    'auth.dialog.redirecting_to': (provider)=>`Redirection vers ${provider}...`,
    'auth.dialog.remember_me': 'Se souvenir de moi',
    'auth.dialog.log_in': 'Se connecter',
    'auth.dialog.back': 'Retour',
    'auth.dialog.progress_header': 'Authentification...',
    'auth.dialog.error.header': 'Erreur d\'authentification',
    'auth.dialog.error.auth_not_allowed': "Cet identifiant a \xe9t\xe9 interdit d'authentification par l'utilisateur. Veuillez en utiliser un autre.",
    'auth.dialog.error.unknown': "Param\xe8tres d'authentification invalides. Veuillez r\xe9essayer.",
    'auth.dialog.error.back': 'Retour',
    'user.profile': 'Profil',
    'user.logout': "Se d\xe9connecter",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "Page non trouv\xe9e",
    'page_not_found.message': 'Cette page n\'existe pas.',
    'page_not_found.message2': "Enfin, elle existe peut-\xeatre, mais il n'y a rien ici. Voici les possibilit\xe9s.",
    'page_not_found.items': [
        "Quelque chose se trouvait ici auparavant, mais a \xe9t\xe9 supprim\xe9.",
        "Quelque chose s'y trouve, mais vous n'y avez pas acc\xe8s.",
        "Ou quelqu'un a simplement manqu\xe9 de pr\xe9cision en copiant-collant le lien."
    ],
    'home': 'Accueil',
    'home.header.hint': "Outils cloud pour d\xe9veloppeurs ind\xe9s",
    'home.description': "Kavykhi.Cloud est une plateforme de d\xe9veloppement pour jeux ind\xe9pendants. Nous prenons en charge les jeux t\xe9l\xe9chargeables et par navigateur, les builds priv\xe9s et publics, les branches, les \xe9quipes et bien plus encore.",
    'home.auth': 'Se connecter ou s\'inscrire',
    'home.auth.hint': "Cr\xe9er un nouveau compte ou se connecter \xe0 un compte existant",
    'projects': 'Projets',
    'projects.hint': 'Les projets sur lesquels vous travaillez',
    'projects.project': (project)=>`Projet : ${project}`,
    'projects.project.hint': 'projet',
    'projects.no_projects': 'Vous n\'avez pas encore de projet.',
    'projects.new': "Cr\xe9er un projet",
    'projects.new_dialog.header': 'Nouveau projet',
    'projects.new_dialog.label': 'Nom du projet',
    'projects.new_dialog.ok': "Cr\xe9er le projet",
    'projects.store_page': 'Page publique du magasin',
    'projects.description': 'Description',
    'projects.branches': 'Branches',
    'projects.versions': 'Versions',
    'projects.packages': 'Packages',
    'projects.management': "Param\xe8tres du projet",
    'projects.management.breadcrumb': "Param\xe8tres",
    'projects.management.title': (projectTitle)=>`${projectTitle} - param\xe8tres`,
    'projects.management.hint': "param\xe8tres du projet",
    'projects.management.users': "Membres de l'\xe9quipe",
    'projects.management.users.empty': "Aucun membre dans l'\xe9quipe.",
    'projects.management.users.role.tester': 'Testeur',
    'projects.management.users.role.developer': "D\xe9veloppeur",
    'projects.management.users.role.admin': 'Administrateur',
    'projects.management.users.role.owner': "Propri\xe9taire",
    'projects.management.users.role.starred': 'Favori',
    'projects.management.users.exile': "Retirer de l'\xe9quipe",
    'projects.management.users.exile.dialog.header': "Retirer de l'\xe9quipe",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir retirer ",
            userTitle,
            " du projet ",
            projectTitle,
            " ?"
        ],
    'projects.management.users.exile.dialog.ok': "Retirer de l'\xe9quipe",
    'projects.management.invites.one_time_invite': "Lien d'invitation \xe0 usage unique",
    'projects.management.invites.one_time_invite.header': "Lien d'invitation \xe0 usage unique",
    'projects.management.invites.one_time_invite.message': "Lien d'invitation \xe0 usage unique :",
    'projects.management.invites.one_time_invite.note': 'Valable 24 heures, utilisable une seule fois.',
    'projects.management.invites.new_dialog.header': 'Lien d\'invitation',
    'projects.management.invites.new_dialog.expires': 'Expire dans :',
    'projects.management.invites.new_dialog.expires.indefinite': '(pas d\'expiration)',
    'projects.management.invites.new_dialog.approval.label': 'L\'utilisateur rejoint le projet :',
    'projects.management.invites.new_dialog.approval.not_approved': "apr\xe8s approbation de l'admin",
    'projects.management.invites.new_dialog.approval.approved': "imm\xe9diatement",
    'projects.management.invites.new_dialog.seats': 'Limiter les inscriptions :',
    'projects.management.invites.new_dialog.seats.no_limit': '(aucune limite)',
    'projects.management.invites.new_dialog.ok': "Cr\xe9er le lien d'invitation",
    'projects.management.deploy_sites': "Sites de d\xe9ploiement",
    'projects.management.deploy_sites.empty': "Aucun site de d\xe9ploiement ajout\xe9.",
    'projects.management.deploy_sites.add': "Ajouter un site de d\xe9ploiement",
    'projects.management.deploy_sites.delete': 'Supprimer',
    'projects.management.deploy_sites.delete_dialog.header': "Supprimer le site de d\xe9ploiement",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "\xCAtes-vous s\xFBr de vouloir supprimer le site de d\xE9ploiement ",
            provider,
            " ",
            site,
            " ?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "Supprimer le site de d\xe9ploiement",
    'projects.management.public_access': "Acc\xe8s public",
    'projects.management.public_access.enable': "Activer l'acc\xe8s public",
    'projects.management.public_access.enabled': [
        "Acc\xE8s public : ",
        $9f804369a7a26616$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "Le nom et la description du projet sont publics, ainsi que toutes les branches marqu\xe9es comme publiques.",
    'projects.management.public_access.enable_dialog.header': "Activer l'acc\xe8s public",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir autoriser l\\'acc\xE8s public au projet ",
            projectTitle,
            " ?",
            $9f804369a7a26616$var$_tmpl$2(),
            $9f804369a7a26616$var$_tmpl$2(),
            "Cela rendra les informations de base du projet accessibles sans authentification. Vous devrez activer s\xE9par\xE9ment l\\'acc\xE8s public pour chaque branche que vous souhaitez rendre publique."
        ],
    'projects.management.public_access.enable_dialog.ok': "Activer l'acc\xe8s public",
    'projects.management.public_access.disable': "D\xe9sactiver l'acc\xe8s public",
    'projects.management.public_access.disabled': [
        "Acc\xE8s public : ",
        $9f804369a7a26616$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "Le projet est priv\xe9. Seuls les membres de l'\xe9quipe du projet peuvent y acc\xe9der.",
    'projects.management.public_access.disable_dialog.header': "D\xe9sactiver l'acc\xe8s public",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir d\xE9sactiver tout acc\xE8s public au projet ",
            projectTitle,
            " ?"
        ],
    'projects.management.public_access.disable_dialog.ok': "D\xe9sactiver l'acc\xe8s public",
    'projects.management.public_access.branches': 'Branches publiques',
    'projects.management.manage': "G\xe9rer le projet",
    'projects.rename': 'Renommer le projet',
    'projects.rename_dialog.header': 'Renommer le projet',
    'projects.rename_dialog.label': 'Nom du projet :',
    'projects.rename_dialog.ok': 'Renommer le projet',
    'projects.edit_description': 'Modifier la description',
    'projects.edit_description_dialog.header': 'Modifier la description du projet',
    'projects.edit_description_dialog.label': 'Description du projet :',
    'projects.edit_description_dialog.ok': 'Modifier la description',
    'projects.leave': 'Quitter le projet',
    'projects.leave_dialog.header': 'Quitter le projet',
    'projects.leave_dialog.message': (projectTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir quitter le projet ",
            projectTitle,
            " ?"
        ],
    'projects.leave_dialog.ok': 'Quitter le projet',
    'projects.delete': 'Supprimer le projet',
    'projects.delete_dialog.header': 'Supprimer le projet',
    'projects.delete_dialog.message': (projectTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir supprimer le projet ",
            projectTitle,
            " ?"
        ],
    'projects.delete_dialog.ok': 'Supprimer le projet',
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle} : ${branchTitle}`,
    'branches.header.hint': 'branche',
    'branches.no_branches': 'Le projet n\'a pas encore de branche',
    'branches.new': "Cr\xe9er une branche",
    'branches.new_dialog.header': 'Nouvelle branche',
    'branches.new_dialog.label': 'Nom de la branche',
    'branches.new_dialog.ok': "Cr\xe9er la branche",
    'branches.current_version': (version)=>[
            "Version actuelle : ",
            version
        ],
    'branches.current_version.packages': 'Packages de la version actuelle',
    'branches.no_current_version': 'Aucune version actuelle',
    'branches.publish_version.new': 'Publier une nouvelle version',
    'branches.publish_version.existing': 'Republier une version existante',
    'branches.version_history': 'Historique des versions',
    'branches.version_history.empty': 'L\'historique des versions de la branche est vide.',
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "La version actuelle de la branche est conserv\xE9e ",
            quotaTime != null ? [
                "pendant ",
                quotaTime
            ] : "ind\xE9finiment",
            ". Les versions pr\xE9c\xE9dentes sont conserv\xE9es au maximum ",
            quotaNonCurrentTime,
            ". Pas plus de ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$9f804369a7a26616$var$plural(quotaCount, [
                    quotaCountText,
                    " version"
                ], [
                    quotaCountText,
                    " versions"
                ])),
            " au total ne sont conserv\xE9es par branche."
        ],
    'branches.manage': "G\xe9rer la branche",
    'branches.rename': 'Renommer la branche',
    'branches.rename_dialog.header': 'Renommer la branche',
    'branches.rename_dialog.label': 'Nom de la branche :',
    'branches.rename_dialog.ok': 'Renommer la branche',
    'branches.delete': 'Supprimer la branche',
    'branches.delete_dialog.header': 'Supprimer la branche',
    'branches.delete_dialog.message': (branchTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir supprimer la branche ",
            branchTitle,
            " ?"
        ],
    'branches.delete_dialog.ok': 'Supprimer la branche',
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': 'version',
    'versions.current': 'Actuelle',
    'versions.previous': "Pr\xe9c\xe9dente",
    'versions.description': 'Description',
    'versions.deploy_to_site.header': 'Publier sur un site',
    'versions.deploy_to_site': 'Publier sur un site',
    'versions.packages': 'Packages',
    'versions.branches': 'Dans les branches',
    'versions.branches.publish': 'Publier sur la branche',
    'versions.branches.empty': "La version n'a \xe9t\xe9 publi\xe9e dans aucune branche.",
    'versions.new_dialog.header': 'Nouvelle version',
    'versions.new_dialog.label_title': 'Version :',
    'versions.new_dialog.label_branch': 'Branche :',
    'versions.new_dialog.packages.header': 'Packages',
    'versions.new_dialog.packages.empty': "Aucun package ajout\xe9.",
    'versions.new_dialog.packages.add': 'Ajouter un package',
    'versions.new_dialog.packages.add_existing': "Ajouter un package d\xe9j\xe0 t\xe9l\xe9vers\xe9",
    'versions.new_dialog.packages.replace': 'Remplacer le package',
    'versions.new_dialog.packages.edit': 'Modifier le package',
    'versions.new_dialog.ok': "Cr\xe9er la version",
    'versions.manage': "G\xe9rer la version",
    'versions.rename': 'Renommer la version',
    'versions.rename_dialog.header': 'Renommer la version',
    'versions.rename_dialog.label': 'Nom de la version :',
    'versions.rename_dialog.ok': 'Renommer la version',
    'versions.edit_description': 'Modifier la description',
    'versions.edit_description_dialog.header': 'Modifier la description de la version',
    'versions.edit_description_dialog.label': 'Description de la version :',
    'versions.edit_description_dialog.ok': 'Modifier la description',
    'versions.delete': 'Supprimer la version',
    'versions.delete_dialog.header': 'Supprimer la version',
    'versions.delete_dialog.message': (versionTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir supprimer la version ",
            versionTitle,
            " ?"
        ],
    'versions.delete_dialog.ok': 'Supprimer la version',
    'versions.publish_dialog.header': 'Publier la version sur une branche',
    'versions.publish_dialog.message': (versionTitle)=>[
            "Choisissez la branche sur laquelle publier la version ",
            versionTitle,
            "."
        ],
    'versions.publish_dialog.no_branches': 'Aucune branche dans le projet.',
    'versions.publish_dialog.ok': 'Publier la version',
    'versions.publish_existing_dialog.header': 'Republier la version',
    'versions.publish_existing_dialog.message': "Derni\xe8res versions :",
    'versions.publish_existing_dialog.no_versions': 'Aucune version dans le projet.',
    'versions.publish_existing_dialog.ok': 'Publier la version',
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle} : ${packageTitle}`,
    'packages.header.hint': 'Package',
    'packages.download_zip': "T\xe9l\xe9charger en ZIP",
    'packages.download_torrent': "T\xe9l\xe9charger le torrent",
    'packages.total_size': (size)=>[
            "Taille totale : ",
            size
        ],
    'packages.manage': "G\xe9rer le package",
    'packages.rename': 'Renommer le package',
    'packages.rename_dialog.header': 'Renommer le package',
    'packages.rename_dialog.label': 'Nom du package :',
    'packages.rename_dialog.ok': 'Renommer le package',
    'packages.edit_tags': 'Modifier les tags',
    'packages.edit_tags_dialog.header': 'Modifier les tags du package',
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "Sp\xE9cifiez les tags du package ",
            packageTitle,
            " :"
        ],
    'packages.edit_tags_dialog.ok': "D\xe9finir les tags",
    'packages.entrypoint': (entrypoint)=>[
            "Fichier de lancement : ",
            entrypoint
        ],
    'packages.entrypoint.empty': "Fichier de lancement non d\xe9fini.",
    'packages.delete': 'Supprimer le package',
    'packages.delete_dialog.header': 'Supprimer le package',
    'packages.delete_dialog.message': (packageTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir supprimer le package ",
            packageTitle,
            " ? Il sera supprim\xE9 de toutes les versions auxquelles il a \xE9t\xE9 ajout\xE9."
        ],
    'packages.delete_dialog.ok': 'Supprimer le package',
    'packages.new_dialog.header': 'Nouveau package',
    'packages.new_dialog.label_title': 'Titre :',
    'packages.new_dialog.title_placeholder': '(depuis les tags)',
    'packages.new_dialog.tags.header': 'Tags',
    'packages.new_dialog.files.header': 'Fichiers',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Taille totale : ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(maximum ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "Taille des nouvelles donn\xE9es : ",
            size
        ],
    'packages.new_dialog.checks.empty': "Aucun fichier ajout\xe9.",
    'packages.new_dialog.checks.entrypoint.empty': "Fichier de lancement non d\xe9fini.",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "Le fichier de lancement ",
            entrypoint,
            " n\\'existe pas ; l\\'avez-vous oubli\xE9 ? Veuillez sp\xE9cifier un fichier existant, ou aucun fichier de lancement."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': 'Retirer le fichier de lancement',
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "Le fichier de lancement a l\\'extension ",
            fileExt,
            " : suggestion du tag ",
            tag,
            "."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "Ajouter le tag ",
            tag
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "Le fichier de lancement a l\\'extension ",
            fileExt,
            " : ajoutez le tag ",
            tag,
            " pour rendre le package jouable sur navigateur."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "Le fichier de lancement a l\\'extension ",
            fileExt,
            " : est-ce une erreur ? Ce n\\'est g\xE9n\xE9ralement pas un type de fichier ex\xE9cutable."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "Le fichier de lancement a l\\'extension ",
            fileExt,
            " : il est recommand\xE9 d\\'inclure les fichiers r\xE9els plut\xF4t que de les compresser dans une archive."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "Le fichier de lancement n'est pas marqu\xe9 comme ex\xe9cutable",
    'packages.new_dialog.checks.entrypoint.executable.action': "Le marquer comme ex\xe9cutable",
    'packages.new_dialog.checks.single_root_dir': "Il est recommand\xe9 de placer les fichiers directement \xe0 la racine, plut\xf4t que d'avoir un dossier unique \xe0 la racine.",
    'packages.new_dialog.checks.single_root_dir.action': 'Remplacer le dossier par son contenu',
    'packages.add_existing_dialog.header': 'Ajouter un package',
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `Ajouter ${$9f804369a7a26616$var$plural(packagesCount, `${packagesCount} package`, `${packagesCount} packages`)}` : "Aucun package s\xe9lectionn\xe9",
    'packages.add_existing_dialog.message': "Derniers packages t\xe9l\xe9vers\xe9s :",
    'packages.add_existing_dialog.no_packages': "Aucun package r\xe9cemment t\xe9l\xe9vers\xe9.",
    'packages.launch': 'Lancer',
    'packages.install': 'Installer',
    'packages.install_dialog.header': 'Installer',
    'packages.install_dialog.workdir.label': 'Dossier de travail :',
    'packages.install_dialog.workdir.value.new': "(cr\xe9er un nouveau)",
    'packages.install_dialog.workspace.label': "Cr\xe9er le dossier sous :",
    'packages.install_dialog.workspace.placeholder': "(s\xe9lectionner le dossier racine)",
    'packages.install_dialog.ok': 'Installer',
    'packages.update': "Mettre \xe0 jour",
    'packages.upload.status.existing': "Depuis la version pr\xe9c\xe9dente",
    'packages.upload.status.queued': 'En file d\'attente',
    'packages.upload.status.packing': 'Compression...',
    'packages.upload.status.creating': "Cr\xe9ation...",
    'packages.upload.status.create_retrying': "\xc9chec de la cr\xe9ation, attente et nouvel essai",
    'packages.upload.status.splitting': 'Division...',
    'packages.upload.status.uploading': "T\xe9l\xe9versement...",
    'packages.upload.status.finalizing': 'Finalisation...',
    'packages.upload.status.finalize_retrying': "\xc9chec de la finalisation, attente et nouvel essai",
    'packages.upload.status.resolving': "R\xe9solution du correctif...",
    'packages.upload.status.resolve_retrying': "\xc9chec de la r\xe9solution, attente et nouvel essai...",
    'packages.upload.status.done': "T\xe9l\xe9vers\xe9 avec succ\xe8s",
    'packages.upload.status.errored': 'Erreur',
    'packages.upload.part.status.queued': 'En file d\'attente',
    'packages.upload.part.status.hashing': 'Calcul de l\'empreinte',
    'packages.upload.part.status.upload_queued': "T\xe9l\xe9versement en file d'attente",
    'packages.upload.part.status.uploading': "T\xe9l\xe9versement",
    'packages.upload.part.status.upload_retrying': 'Erreur, nouvel essai',
    'packages.upload.part.status.upload_finalizing': "Finalisation du t\xe9l\xe9versement",
    'packages.upload.part.status.upload_errored': 'Erreur',
    'packages.upload.part.status.done': "T\xe9l\xe9vers\xe9",
    'packages.play': 'Jouer sur navigateur',
    'packages.play.reset': "R\xe9initialiser",
    'packages.play.fullscreen': "Plein \xe9cran",
    'deploy_sites.add_dialog.header': "Ajouter un site de d\xe9ploiement",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "Choisissez un identifiant de d\xE9ploiement et saisissez l\\'URL du site pour les enregistrer comme site de d\xE9ploiement pour le projet ",
            projectTitle,
            "."
        ],
    'deploy_sites.add_dialog.label_credential': "Identifiant de d\xe9ploiement :",
    'deploy_sites.add_dialog.select_credential': "S\xe9lectionner l'identifiant",
    'deploy_sites.add_dialog.select_credential.new': 'Ajouter un nouvel identifiant...',
    'deploy_sites.add_dialog.label_select_site': "S\xe9lectionner le site :",
    'deploy_sites.add_dialog.select_credential_first': "(s\xe9lectionner d'abord un identifiant)",
    'deploy_sites.add_dialog.select_site': "(s\xe9lectionner le site)",
    'deploy_sites.add_dialog.label_enter_site': 'Ou saisir l\'URL du site :',
    'deploy_sites.add_dialog.ok': 'Ajouter le site',
    'deploy_to_site_dialog.header': 'Publier sur un site',
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "Choisissez le site sur lequel publier la version ",
            versionTitle,
            " de ",
            projectTitle,
            "."
        ],
    'deploy_to_site_dialog.label_site': 'Publier sur le site :',
    'deploy_to_site_dialog.select_site': "S\xe9lectionner le site",
    'deploy_to_site_dialog.select_site.new': "Ajouter un nouveau site de d\xe9ploiement...",
    'deploy_to_site_dialog.packages.message.itch': [
        "Les packages seront publi\xE9s sur itch.io \xE0 l\\'aide de ",
        $9f804369a7a26616$var$_tmpl$4(),
        ". Les noms des canaux sont d\xE9riv\xE9s des tags des packages."
    ],
    'deploy_to_site_dialog.deploy': 'Publier',
    'deploy_to_site_dialog.close': 'Fermer',
    'deploy_to_site_dialog.error.no_packages': "Aucun package \xe0 publier.",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "Impossible de publier plusieurs packages sur un seul canal. Actuellement, ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$9f804369a7a26616$var$plural(packagesCount, [
                    packagesCountText,
                    " package est configur\xE9"
                ], [
                    packagesCountText,
                    " packages sont configur\xE9s"
                ])),
            " pour \xEAtre publi\xE9s sur le canal ",
            channel,
            "."
        ],
    'deploy_to_site_dialog.job.queued': 'En file d\'attente',
    'deploy_to_site_dialog.job.downloading': "T\xe9l\xe9chargement...",
    'deploy_to_site_dialog.job.unpacking': "D\xe9compression...",
    'deploy_to_site_dialog.job.uploading': 'Publication...',
    'deploy_to_site_dialog.job.succeeded': "Succ\xe8s",
    'deploy_to_site_dialog.job.errored': 'Erreur',
    'store': 'Magasin',
    'store.hint': 'Projets publics',
    'store.project.hint': 'Page magasin du projet',
    'store.project.owner': "D\xe9veloppeur",
    'store.project.description': 'Description',
    'store.project.star': 'Suivre',
    'store.project.starred': 'Suivi',
    'store.project.content': 'Contenu',
    'store.project.content.warning': "Ce contenu a \xe9t\xe9 fourni par un d\xe9veloppeur tiers.",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            "Branche ",
            branchTitle,
            " : version ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "Publi\xE9 le : ",
            branchVersionPublished
        ],
    'me': 'Profil',
    'me.hint': "Param\xe8tres du profil et identifiants associ\xe9s",
    'me.rename': 'Renommer le profil',
    'me.rename_dialog.header': 'Renommer le profil',
    'me.rename_dialog.label_title': 'Nom :',
    'me.rename_dialog.ok': 'Renommer le profil',
    'me.credentials': 'Identifiants',
    'me.credentials.hint.auth_allowed': "Chacun de ces identifiants peut \xeatre utilis\xe9 pour se connecter \xe0 ce compte.",
    'me.credentials.hint.auth_disallowed': "Ces identifiants sont li\xe9s \xe0 votre compte, mais ne peuvent pas \xeatre utilis\xe9s pour se connecter.",
    'me.credentials.empty': 'Aucun identifiant.',
    'me.credentials.empty.auth_allowed.warning': "Vous risquez de perdre l'acc\xe8s \xe0 votre compte ! Vous n'avez li\xe9 aucun identifiant pour vous connecter. Veuillez lier un identifiant de connexion d\xe8s que possible.",
    'me.credentials.profile_picture.alt': (provider)=>`Photo de profil ${$9f804369a7a26616$var$dict[`auth.provider.${provider}`]}`,
    'me.credentials.created': (created)=>[
            "ajout\xE9 le ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "utilis\xE9 le ",
            lastUsed
        ],
    'me.credential.unlink': 'Dissocier',
    'me.credential.allow_auth': 'Autoriser la connexion',
    'me.credential.disallow_auth': 'Interdire la connexion',
    'me.credential.display_publicly': 'Afficher publiquement',
    'me.credential.dont_display_publicly': 'Ne pas afficher publiquement',
    'me.credential.link': 'Lier un identifiant',
    'me.credential.link_dialog.header': 'Lier un identifiant',
    'me.credential.link_dialog.message': "Veuillez s\xe9lectionner le fournisseur de compte \xe0 lier.",
    'me.credential.unlink_dialog.header': 'Dissocier l\'identifiant',
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir dissocier le compte ",
            credentialProvider,
            " (",
            credentialTitle,
            ") de votre compte Kavykhi.Cloud ?"
        ],
    'me.credential.unlink_dialog.ok': 'Dissocier l\'identifiant',
    'me.sessions': 'Sessions',
    'me.sessions.hint': 'Voici la liste de vos sessions actives, y compris votre navigateur actuel.',
    'me.sessions.started': (started)=>[
            "commenc\xE9e le ",
            (()=>{
                var _el$6 = $9f804369a7a26616$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "active le ",
            (()=>{
                var _el$7 = $9f804369a7a26616$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': 'Session actuelle',
    'me.sessions.empty': 'Aucune session.',
    'me.sessions.delete': 'Terminer',
    'me.sessions.delete_dialog.header': 'Terminer la session',
    'me.sessions.delete_dialog.message': "\xcates-vous s\xfbr de vouloir terminer cette session ?",
    'me.sessions.delete_dialog.ok': 'Terminer la session',
    'me.api_tokens': 'Jetons API',
    'me.api_tokens.hint': "Vous pouvez cr\xe9er des jetons API ici pour vos scripts d'automatisation.",
    'me.api_tokens.started': (started)=>[
            "cr\xE9\xE9 le ",
            (()=>{
                var _el$8 = $9f804369a7a26616$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "expire le ",
            (()=>{
                var _el$9 = $9f804369a7a26616$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': 'pas d\'expiration',
    'me.api_tokens.empty': 'Aucun jeton API.',
    'me.api_tokens.create': "G\xe9n\xe9rer un jeton API",
    'me.api_tokens.create_dialog.header': "G\xe9n\xe9rer un jeton API",
    'me.api_tokens.create_dialog.message': "Jeton API g\xe9n\xe9r\xe9 :",
    'me.api_tokens.create_dialog.note': "Le jeton ne sera plus affich\xe9 par la suite, veuillez le conserver pr\xe9cieusement.",
    'me.api_tokens.delete': 'Supprimer',
    'me.api_tokens.delete_dialog.header': 'Supprimer le jeton API',
    'me.api_tokens.delete_dialog.message': "\xcates-vous s\xfbr de vouloir supprimer ce jeton ?",
    'me.api_tokens.delete_dialog.ok': 'Supprimer le jeton API',
    'me.deploy_credentials': "Identifiants de d\xe9ploiement",
    'me.deploy_credentials.hint': "Les identifiants pour d\xe9ployer sur des plateformes de publication peuvent \xeatre ajout\xe9s ici.",
    'me.deploy_credentials.empty': "Aucun identifiant de d\xe9ploiement ajout\xe9.",
    'me.deploy_credential.add': "Ajouter un identifiant de d\xe9ploiement",
    'me.deploy_credential.add_dialog.header': "Ajouter un identifiant de d\xe9ploiement",
    'me.deploy_credential.add_dialog.label_site': 'Site :',
    'me.deploy_credential.add_dialog.label_title': 'Note :',
    'me.deploy_credential.add_dialog.label_key': "Cl\xe9 :",
    'me.deploy_credential.add_dialog.default_title': (date)=>`Cl\xe9 ${date}`,
    'me.deploy_credential.add_dialog.ok': 'Ajouter l\'identifiant',
    'me.deploy_credential.add_dialog.hint.itch': [
        "Pour g\xE9n\xE9rer la cl\xE9 API itch.io, allez dans les ",
        $9f804369a7a26616$var$_tmpl$6(),
        " sur itch.io. Vous pouvez utiliser une cl\xE9 API existante avec pour source \"web\" ou \"wharf\". Les cl\xE9s API avec pour source \"Kavykhi.Cloud\" ne fonctionneront pas."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "L\\'ajout d\\'identifiants ",
            credentialProvider,
            " n\\'est pas pris en charge pour le moment."
        ],
    'me.deploy_credential.delete': 'Supprimer',
    'me.deploy_credential.delete_dialog.header': "Supprimer l'identifiant de d\xe9ploiement",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "\xCAtes-vous s\xFBr de vouloir supprimer l\\'identifiant ",
            credentialTitle,
            " pour ",
            credentialProvider,
            " ? Tous les sites de d\xE9ploiement configur\xE9s avec cet identifiant seront \xE9galement retir\xE9s du projet."
        ],
    'me.deploy_credential.delete_dialog.ok': 'Supprimer l\'identifiant',
    'me.public_profile': 'Profil public',
    'me.public_profile.public_credentials': 'Identifiants publics',
    'me.public_profile.public_credentials.hint': "S\xe9lectionnez les identifiants \xe0 afficher publiquement.",
    'me.manage': "G\xe9rer le compte",
    'me.delete': 'Supprimer le compte',
    'me.delete.dialog.header': 'Supprimer le compte',
    'me.delete.dialog.message': (userTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir supprimer d\xE9finitivement votre compte Kavykhi.Cloud ",
            userTitle,
            " ?"
        ],
    'me.delete.dialog.ok': 'Supprimer le compte',
    'invite': 'Invitation',
    'invite.hint': 'Invitation au projet',
    'invite.message.already_member': (projectTitle)=>[
            "Vous \xEAtes d\xE9j\xE0 membre du projet ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "Vous avez \xE9t\xE9 invit\xE9 \xE0 rejoindre le projet ",
            projectTitle,
            "."
        ],
    'invite.join': 'Rejoindre le projet',
    'local': 'Contenu local',
    'local.hint': "Contenu install\xe9 localement",
    'local.workdirs': "Packages install\xe9s",
    'local.workdirs.empty': "Aucun package install\xe9.",
    'local.workdir.action.launch': 'Lancer',
    'local.workdir.action.repair': "R\xe9parer",
    'local.workdir.action.delete': "D\xe9sinstaller",
    'local.workdir.delete_dialog.header': "D\xe9sinstaller le package",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\xCAtes-vous s\xFBr de vouloir d\xE9sinstaller le package ",
            packageTitle,
            " de votre appareil ?"
        ],
    'local.workdir.delete_dialog.ok': "D\xe9sinstaller",
    'local.workspaces': 'Dossiers racines',
    'local.app_not_detected.message': "L'application locale Kavykhi.Cloud n'est pas d\xe9tect\xe9e. Veuillez la t\xe9l\xe9charger et l'installer via l'un des liens ci-dessous. Si elle est d\xe9j\xe0 install\xe9e, assurez-vous qu'elle est en cours d'ex\xe9cution.",
    'local_app.detected': 'Contenu local',
    'error_dialog.header': 'Erreur',
    'error_dialog.messageFunc': (e)=>`Erreur : ${$9f804369a7a26616$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': 'Choisir des fichiers',
    'upload_box.choose_directories': 'Choisir des dossiers',
    'upload_box.add.progress_dialog.header': 'Ajout des fichiers',
    'upload_box.add.progress_dialog.message': 'Traitement des fichiers...',
    'upload_box.delete': (itemsCount)=>`Supprimer ${$9f804369a7a26616$var$plural(itemsCount, `${itemsCount} \xe9l\xe9ment`, `${itemsCount} \xe9l\xe9ments`)}`,
    'upload_box.start_upload': "D\xe9marrer le t\xe9l\xe9versement",
    'upload_box.drop_area.message': "D\xe9posez les fichiers et dossiers ici",
    'upload_box.drop_area.box_dropping_message': "D\xe9poser ici pour placer \xe0 la racine",
    'upload_box.entry.explode_folder': 'Remplacer le dossier par son contenu',
    'upload_box.entry.set_entrypoint': "D\xe9finir comme fichier de lancement",
    'upload_box.entry.mark_executable': "Marquer comme ex\xe9cutable",
    'upload_box.entry.unmark_executable': "Retirer le marquage ex\xe9cutable",
    'upload_box.entry.remove': 'Retirer',
    'package.tags.empty': '(aucun tag)',
    'package.tag.os': "Syst\xe8me",
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Architecture',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': 'Bits',
    'package.tag.bits:64': '64 bits',
    'package.tag.bits:32': '32 bits',
    'package.tag.packaging': 'Format',
    'package.tag.packaging:installer': 'Installeur',
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': 'Composant',
    'package.tag.component:client': 'Client',
    'package.tag.component:server': 'Serveur',
    'package.tag.runtime': 'Environnement',
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': 'Distribution Linux',
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Docs',
    'docs.page_no_language': 'Non disponible dans cette langue',
    'docs.page_no_language.message': 'Autres versions disponibles pour ce document :',
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': 'Signaler un contenu',
    'report_content.dialog.header': 'Signaler un contenu',
    'report_content.dialog.link': 'Envoyer le rapport par e-mail',
    'report_content.dialog.message': (email, link)=>[
            "Veuillez cliquer sur le lien pour envoyer votre rapport :",
            $9f804369a7a26616$var$_tmpl$2(),
            $9f804369a7a26616$var$_tmpl$2(),
            link,
            $9f804369a7a26616$var$_tmpl$2(),
            $9f804369a7a26616$var$_tmpl$2(),
            "Ou \xE9crivez-nous manuellement \xE0 ",
            email
        ]
};
var $9f804369a7a26616$export$2e2bcd8739ae039 = $9f804369a7a26616$var$dict;
const $9f804369a7a26616$var$plural = (n, one, many)=>n == 1 ? one : many;



var $353c90f5b534128a$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{8A31}\u{53EF}`), $353c90f5b534128a$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $353c90f5b534128a$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{4E0D}\u{8A31}\u{53EF}`), $353c90f5b534128a$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $353c90f5b534128a$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $353c90f5b534128a$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>\u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{8A2D}\u{5B9A}`);
const $353c90f5b534128a$var$dict = {
    languageName: "\u65E5\u672C\u8A9E",
    locale: 'ja',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: "\u30C6\u30FC\u30DE",
    'theme.light': "\u30E9\u30A4\u30C8",
    'theme.dark': "\u30C0\u30FC\u30AF",
    'theme.system': "\u30B7\u30B9\u30C6\u30E0",
    'theme.sakura': "\u30B5\u30AF\u30E9",
    // generic
    email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    password: "\u30D1\u30B9\u30EF\u30FC\u30C9",
    ok: 'OK',
    cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
    retry: "\u518D\u8A66\u884C",
    copy: "\u30B3\u30D4\u30FC",
    empty: "(\u30A2\u30A4\u30C6\u30E0\u306A\u3057)",
    loading: "\u8AAD\u307F\u8FBC\u307F\u4E2D...",
    calculating: "\u8A08\u7B97\u4E2D...",
    error: "\u30A8\u30E9\u30FC",
    'in_development': "\u3053\u306E\u30DA\u30FC\u30B8\u306F\u958B\u767A\u4E2D\u3067\u3059\u3002",
    // errors
    'error.not_found': "\u898B\u3064\u304B\u308A\u307E\u305B\u3093",
    'error.name_conflict': "\u540D\u524D\u306E\u7AF6\u5408",
    'error.bad_param': "\u4E0D\u6B63\u306A\u30D1\u30E9\u30E1\u30FC\u30BF",
    'error.wrong_auth': "\u8A8D\u8A3C\u30A8\u30E9\u30FC",
    'error.unauthorized': "\u672A\u8A8D\u8A3C",
    'error.wrong_credentials': "\u8A8D\u8A3C\u60C5\u5831\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093",
    'error.wrong_provider': "\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093",
    'error.insufficient_privileges': "\u6A29\u9650\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059",
    'error.not_empty': "\u7A7A\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
    'error.limit_exceeded': "\u5236\u9650\u3092\u8D85\u904E\u3057\u307E\u3057\u305F",
    'error.already_member': "\u3059\u3067\u306B\u30E1\u30F3\u30D0\u30FC\u3067\u3059",
    'error.not_finalized': "\u78BA\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    'error.already_finalized': "\u3059\u3067\u306B\u78BA\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059",
    'error.unexpected_patch': "\u4E88\u671F\u3057\u306A\u3044\u30D1\u30C3\u30C1",
    'error.timeout': "\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8",
    'error.not_patch': "\u30D1\u30C3\u30C1\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
    'error.not_supported': "\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    'error.unexpected_error': "\u4E88\u671F\u3057\u306A\u3044\u30A8\u30E9\u30FC",
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "\u8A8D\u8A3C",
    'auth.dialog.please_select': "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'auth.dialog.redirecting_to': (provider)=>`${provider} \u{306B}\u{30EA}\u{30C0}\u{30A4}\u{30EC}\u{30AF}\u{30C8}\u{4E2D}...`,
    'auth.dialog.remember_me': "\u30ED\u30B0\u30A4\u30F3\u72B6\u614B\u3092\u4FDD\u6301\u3059\u308B",
    'auth.dialog.log_in': "\u30ED\u30B0\u30A4\u30F3",
    'auth.dialog.back': "\u623B\u308B",
    'auth.dialog.progress_header': "\u8A8D\u8A3C\u4E2D...",
    'auth.dialog.error.header': "\u8A8D\u8A3C\u30A8\u30E9\u30FC",
    'auth.dialog.error.auth_not_allowed': "\u3053\u306E\u8A8D\u8A3C\u60C5\u5831\u306F\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u3063\u3066\u8A8D\u8A3C\u3078\u306E\u4F7F\u7528\u304C\u7981\u6B62\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u5225\u306E\u8A8D\u8A3C\u60C5\u5831\u3092\u4F7F\u7528\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'auth.dialog.error.unknown': "\u7121\u52B9\u306A\u8A8D\u8A3C\u30D1\u30E9\u30E1\u30FC\u30BF\u3067\u3059\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'auth.dialog.error.back': "\u623B\u308B",
    'user.profile': "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB",
    'user.logout': "\u30ED\u30B0\u30A2\u30A6\u30C8",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093",
    'page_not_found.message': "\u3053\u306E\u30DA\u30FC\u30B8\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    'page_not_found.message2': "\u6B63\u78BA\u306B\u306F\u3001\u3053\u3053\u306B\u306F\u4F55\u3082\u3042\u308A\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u306E\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002",
    'page_not_found.items': [
        "\u4EE5\u524D\u306F\u3053\u3053\u306B\u4F55\u304B\u304C\u3042\u308A\u307E\u3057\u305F\u304C\u3001\u73FE\u5728\u306F\u524A\u9664\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
        "\u4F55\u304B\u306F\u5B58\u5728\u3057\u307E\u3059\u304C\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
        "\u307E\u305F\u306F\u3001\u30EA\u30F3\u30AF\u306E\u30B3\u30D4\u30FC\uFF06\u30DA\u30FC\u30B9\u30C8\u6642\u306B\u8AA4\u308A\u304C\u3042\u3063\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"
    ],
    'home': "\u30DB\u30FC\u30E0",
    'home.header.hint': "\u30A4\u30F3\u30C7\u30A3\u30FC\u958B\u767A\u8005\u5411\u3051\u30AF\u30E9\u30A6\u30C9\u30C4\u30FC\u30EB",
    'home.description': "Kavykhi.Cloud \u306F\u30A4\u30F3\u30C7\u30A3\u30FC\u30B2\u30FC\u30E0\u306E\u958B\u767A\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3067\u3059\u3002\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u7248\u3084\u30D6\u30E9\u30A6\u30B6\u30B2\u30FC\u30E0\u3001\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8/\u30D1\u30D6\u30EA\u30C3\u30AF\u30D3\u30EB\u30C9\u3001\u30D6\u30E9\u30F3\u30C1\u3001\u30C1\u30FC\u30E0\u958B\u767A\u306A\u3069\u3001\u69D8\u3005\u306A\u6A5F\u80FD\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u3059\u3002",
    'home.auth': "\u30B5\u30A4\u30F3\u30A4\u30F3\u307E\u305F\u306F\u65B0\u898F\u767B\u9332",
    'home.auth.hint': "\u65B0\u898F\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210\u3001\u307E\u305F\u306F\u65E2\u5B58\u30A2\u30AB\u30A6\u30F3\u30C8\u3078\u306E\u30ED\u30B0\u30A4\u30F3",
    'projects': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'projects.hint': "\u4F5C\u696D\u4E2D\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'projects.project': (project)=>`\u{30D7}\u{30ED}\u{30B8}\u{30A7}\u{30AF}\u{30C8}: ${project}`,
    'projects.project.hint': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'projects.no_projects': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002",
    'projects.new': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4F5C\u6210",
    'projects.new_dialog.header': "\u65B0\u898F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'projects.new_dialog.label': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u540D",
    'projects.new_dialog.ok': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u4F5C\u6210",
    'projects.store_page': "\u516C\u958B\u30B9\u30C8\u30A2\u30DA\u30FC\u30B8",
    'projects.description': "\u8AAC\u660E",
    'projects.branches': "\u30D6\u30E9\u30F3\u30C1",
    'projects.versions': "\u30D0\u30FC\u30B8\u30E7\u30F3",
    'projects.packages': "\u30D1\u30C3\u30B1\u30FC\u30B8",
    'projects.management': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u8A2D\u5B9A",
    'projects.management.breadcrumb': "\u8A2D\u5B9A",
    'projects.management.title': (projectTitle)=>`${projectTitle} - \u{8A2D}\u{5B9A}`,
    'projects.management.hint': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u8A2D\u5B9A",
    'projects.management.users': "\u30C1\u30FC\u30E0\u30E1\u30F3\u30D0\u30FC",
    'projects.management.users.empty': "\u30C1\u30FC\u30E0\u30E1\u30F3\u30D0\u30FC\u306F\u3044\u307E\u305B\u3093\u3002",
    'projects.management.users.role.tester': "\u30C6\u30B9\u30BF\u30FC",
    'projects.management.users.role.developer': "\u30C7\u30D9\u30ED\u30C3\u30D1\u30FC",
    'projects.management.users.role.admin': "\u7BA1\u7406\u8005",
    'projects.management.users.role.owner': "\u30AA\u30FC\u30CA\u30FC",
    'projects.management.users.role.starred': "\u30B9\u30BF\u30FC\u4ED8\u304D",
    'projects.management.users.exile': "\u30C1\u30FC\u30E0\u304B\u3089\u524A\u9664",
    'projects.management.users.exile.dialog.header': "\u30C1\u30FC\u30E0\u304B\u3089\u524A\u9664",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "\u672C\u5F53\u306B ",
            userTitle,
            " \u3092\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'projects.management.users.exile.dialog.ok': "\u30C1\u30FC\u30E0\u304B\u3089\u524A\u9664",
    'projects.management.invites.one_time_invite': "\u4F7F\u3044\u6368\u3066\u62DB\u5F85\u30EA\u30F3\u30AF",
    'projects.management.invites.one_time_invite.header': "\u4F7F\u3044\u6368\u3066\u62DB\u5F85\u30EA\u30F3\u30AF",
    'projects.management.invites.one_time_invite.message': "\u4F7F\u3044\u6368\u3066\u62DB\u5F85\u30EA\u30F3\u30AF:",
    'projects.management.invites.one_time_invite.note': "24\u6642\u9593\u6709\u52B9\u30011\u56DE\u306E\u307F\u4F7F\u7528\u53EF\u80FD\u3002",
    'projects.management.invites.new_dialog.header': "\u62DB\u5F85\u30EA\u30F3\u30AF",
    'projects.management.invites.new_dialog.expires': "\u6709\u52B9\u671F\u9650:",
    'projects.management.invites.new_dialog.expires.indefinite': "(\u7121\u671F\u9650)",
    'projects.management.invites.new_dialog.approval.label': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3078\u306E\u53C2\u52A0:",
    'projects.management.invites.new_dialog.approval.not_approved': "\u7BA1\u7406\u8005\u306E\u627F\u8A8D\u5F8C",
    'projects.management.invites.new_dialog.approval.approved': "\u5373\u6642",
    'projects.management.invites.new_dialog.seats': "\u53C2\u52A0\u4EBA\u6570\u5236\u9650:",
    'projects.management.invites.new_dialog.seats.no_limit': "(\u5236\u9650\u306A\u3057)",
    'projects.management.invites.new_dialog.ok': "\u62DB\u5F85\u30EA\u30F3\u30AF\u3092\u4F5C\u6210",
    'projects.management.deploy_sites': "\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8",
    'projects.management.deploy_sites.empty': "\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u304C\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'projects.management.deploy_sites.add': "\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u3092\u8FFD\u52A0",
    'projects.management.deploy_sites.delete': "\u524A\u9664",
    'projects.management.deploy_sites.delete_dialog.header': "\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u306E\u524A\u9664",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "\u672C\u5F53\u306B ",
            provider,
            " \u306E\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8 ",
            site,
            " \u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u3092\u524A\u9664",
    'projects.management.public_access': "\u516C\u958B\u30A2\u30AF\u30BB\u30B9",
    'projects.management.public_access.enable': "\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u6709\u52B9\u5316",
    'projects.management.public_access.enabled': [
        "\u516C\u958B\u30A2\u30AF\u30BB\u30B9: ",
        $353c90f5b534128a$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u540D\u524D\u3068\u8AAC\u660E\u3001\u304A\u3088\u3073\u516C\u958B\u8A2D\u5B9A\u3055\u308C\u305F\u30D6\u30E9\u30F3\u30C1\u304C\u4E00\u822C\u516C\u958B\u3055\u308C\u307E\u3059\u3002",
    'projects.management.public_access.enable_dialog.header': "\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u6709\u52B9\u5316",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "\u672C\u5F53\u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u3078\u306E\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF\u3057\u307E\u3059\u304B\uFF1F",
            $353c90f5b534128a$var$_tmpl$2(),
            $353c90f5b534128a$var$_tmpl$2(),
            "\u3053\u308C\u306B\u3088\u308A\u3001\u8A8D\u8A3C\u306A\u3057\u3067\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u57FA\u672C\u60C5\u5831\u304C\u95B2\u89A7\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002\u516C\u958B\u3057\u305F\u3044\u30D6\u30E9\u30F3\u30C1\u306B\u3064\u3044\u3066\u306F\u3001\u500B\u5225\u306B\u516C\u958B\u8A2D\u5B9A\u3092\u6709\u52B9\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"
        ],
    'projects.management.public_access.enable_dialog.ok': "\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u6709\u52B9\u5316",
    'projects.management.public_access.disable': "\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u7121\u52B9\u5316",
    'projects.management.public_access.disabled': [
        "\u516C\u958B\u30A2\u30AF\u30BB\u30B9: ",
        $353c90f5b534128a$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u975E\u516C\u958B\u3067\u3059\u3002\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30C1\u30FC\u30E0\u306E\u30E1\u30F3\u30D0\u30FC\u306E\u307F\u304C\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002",
    'projects.management.public_access.disable_dialog.header': "\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u7121\u52B9\u5316",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "\u672C\u5F53\u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u3078\u306E\u3059\u3079\u3066\u306E\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u7121\u52B9\u306B\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'projects.management.public_access.disable_dialog.ok': "\u516C\u958B\u30A2\u30AF\u30BB\u30B9\u3092\u7121\u52B9\u5316",
    'projects.management.public_access.branches': "\u516C\u958B\u30D6\u30E9\u30F3\u30C1",
    'projects.management.manage': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u7BA1\u7406",
    'projects.rename': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u540D\u306E\u5909\u66F4",
    'projects.rename_dialog.header': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u540D\u306E\u5909\u66F4",
    'projects.rename_dialog.label': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u540D:",
    'projects.rename_dialog.ok': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u540D\u3092\u5909\u66F4",
    'projects.edit_description': "\u8AAC\u660E\u306E\u7DE8\u96C6",
    'projects.edit_description_dialog.header': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u8AAC\u660E\u306E\u7DE8\u96C6",
    'projects.edit_description_dialog.label': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u8AAC\u660E:",
    'projects.edit_description_dialog.ok': "\u8AAC\u660E\u3092\u66F4\u65B0",
    'projects.leave': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u8131\u9000",
    'projects.leave_dialog.header': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u8131\u9000",
    'projects.leave_dialog.message': (projectTitle)=>[
            "\u672C\u5F53\u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u304B\u3089\u8131\u9000\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'projects.leave_dialog.ok': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u8131\u9000",
    'projects.delete': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u524A\u9664",
    'projects.delete_dialog.header': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u524A\u9664",
    'projects.delete_dialog.message': (projectTitle)=>[
            "\u672C\u5F53\u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'projects.delete_dialog.ok': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u524A\u9664",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "\u30D6\u30E9\u30F3\u30C1",
    'branches.no_branches': "\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u306F\u307E\u3060\u30D6\u30E9\u30F3\u30C1\u304C\u3042\u308A\u307E\u305B\u3093",
    'branches.new': "\u30D6\u30E9\u30F3\u30C1\u4F5C\u6210",
    'branches.new_dialog.header': "\u65B0\u898F\u30D6\u30E9\u30F3\u30C1",
    'branches.new_dialog.label': "\u30D6\u30E9\u30F3\u30C1\u540D",
    'branches.new_dialog.ok': "\u30D6\u30E9\u30F3\u30C1\u3092\u4F5C\u6210",
    'branches.current_version': (version)=>[
            "\u73FE\u5728\u306E\u30D0\u30FC\u30B8\u30E7\u30F3: ",
            version
        ],
    'branches.current_version.packages': "\u73FE\u5728\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u306E\u30D1\u30C3\u30B1\u30FC\u30B8",
    'branches.no_current_version': "\u73FE\u5728\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u306A\u3057",
    'branches.publish_version.new': "\u65B0\u3057\u3044\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u6295\u7A3F",
    'branches.publish_version.existing': "\u65E2\u5B58\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u518D\u6295\u7A3F",
    'branches.version_history': "\u30D0\u30FC\u30B8\u30E7\u30F3\u5C65\u6B74",
    'branches.version_history.empty': "\u3053\u306E\u30D6\u30E9\u30F3\u30C1\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u5C65\u6B74\u306F\u7A7A\u3067\u3059\u3002",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "\u73FE\u5728\u306E\u30D6\u30E9\u30F3\u30C1\u30D0\u30FC\u30B8\u30E7\u30F3\u306F ",
            quotaTime != null ? [
                quotaTime,
                "\u9593"
            ] : "\u7121\u671F\u9650\u306B",
            " \u4FDD\u6301\u3055\u308C\u307E\u3059\u3002\u904E\u53BB\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u306F\u6700\u5927 ",
            quotaNonCurrentTime,
            " \u4FDD\u6301\u3055\u308C\u307E\u3059\u30021\u30D6\u30E9\u30F3\u30C1\u3042\u305F\u308A\u5408\u8A08\u3067\u6700\u5927 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$353c90f5b534128a$var$plural(quotaCount, [
                    quotaCountText,
                    " \u500B"
                ], [
                    quotaCountText,
                    " \u500B"
                ])),
            " \u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u304C\u4FDD\u6301\u3055\u308C\u307E\u3059\u3002"
        ],
    'branches.manage': "\u30D6\u30E9\u30F3\u30C1\u7BA1\u7406",
    'branches.rename': "\u30D6\u30E9\u30F3\u30C1\u540D\u306E\u5909\u66F4",
    'branches.rename_dialog.header': "\u30D6\u30E9\u30F3\u30C1\u540D\u306E\u5909\u66F4",
    'branches.rename_dialog.label': "\u30D6\u30E9\u30F3\u30C1\u540D:",
    'branches.rename_dialog.ok': "\u30D6\u30E9\u30F3\u30C1\u540D\u3092\u5909\u66F4",
    'branches.delete': "\u30D6\u30E9\u30F3\u30C1\u524A\u9664",
    'branches.delete_dialog.header': "\u30D6\u30E9\u30F3\u30C1\u524A\u9664",
    'branches.delete_dialog.message': (branchTitle)=>[
            "\u672C\u5F53\u306B\u30D6\u30E9\u30F3\u30C1\u300C",
            branchTitle,
            "\u300D\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'branches.delete_dialog.ok': "\u30D6\u30E9\u30F3\u30C1\u3092\u524A\u9664",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "\u30D0\u30FC\u30B8\u30E7\u30F3",
    'versions.current': "\u73FE\u5728",
    'versions.previous': "\u904E\u53BB",
    'versions.description': "\u8AAC\u660E",
    'versions.deploy_to_site.header': "\u30B5\u30A4\u30C8\u306B\u516C\u958B",
    'versions.deploy_to_site': "\u30B5\u30A4\u30C8\u306B\u516C\u958B",
    'versions.packages': "\u30D1\u30C3\u30B1\u30FC\u30B8",
    'versions.branches': "\u6240\u5C5E\u30D6\u30E9\u30F3\u30C1",
    'versions.branches.publish': "\u30D6\u30E9\u30F3\u30C1\u306B\u6295\u7A3F",
    'versions.branches.empty': "\u3053\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u306F\u3069\u306E\u30D6\u30E9\u30F3\u30C1\u306B\u3082\u6295\u7A3F\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'versions.new_dialog.header': "\u65B0\u898F\u30D0\u30FC\u30B8\u30E7\u30F3",
    'versions.new_dialog.label_title': "\u30D0\u30FC\u30B8\u30E7\u30F3:",
    'versions.new_dialog.label_branch': "\u30D6\u30E9\u30F3\u30C1:",
    'versions.new_dialog.packages.header': "\u30D1\u30C3\u30B1\u30FC\u30B8",
    'versions.new_dialog.packages.empty': "\u30D1\u30C3\u30B1\u30FC\u30B8\u304C\u8FFD\u52A0\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'versions.new_dialog.packages.add': "\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u8FFD\u52A0",
    'versions.new_dialog.packages.add_existing': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u6E08\u307F\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u8FFD\u52A0",
    'versions.new_dialog.packages.replace': "\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u7F6E\u63DB",
    'versions.new_dialog.packages.edit': "\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u7DE8\u96C6",
    'versions.new_dialog.ok': "\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u4F5C\u6210",
    'versions.manage': "\u30D0\u30FC\u30B8\u30E7\u30F3\u7BA1\u7406",
    'versions.rename': "\u30D0\u30FC\u30B8\u30E7\u30F3\u540D\u306E\u5909\u66F4",
    'versions.rename_dialog.header': "\u30D0\u30FC\u30B8\u30E7\u30F3\u540D\u306E\u5909\u66F4",
    'versions.rename_dialog.label': "\u30D0\u30FC\u30B8\u30E7\u30F3\u540D:",
    'versions.rename_dialog.ok': "\u30D0\u30FC\u30B8\u30E7\u30F3\u540D\u3092\u5909\u66F4",
    'versions.edit_description': "\u30D0\u30FC\u30B8\u30E7\u30F3\u8AAC\u660E\u306E\u7DE8\u96C6",
    'versions.edit_description_dialog.header': "\u30D0\u30FC\u30B8\u30E7\u30F3\u8AAC\u660E\u306E\u7DE8\u96C6",
    'versions.edit_description_dialog.label': "\u30D0\u30FC\u30B8\u30E7\u30F3\u8AAC\u660E:",
    'versions.edit_description_dialog.ok': "\u8AAC\u660E\u3092\u66F4\u65B0",
    'versions.delete': "\u30D0\u30FC\u30B8\u30E7\u30F3\u524A\u9664",
    'versions.delete_dialog.header': "\u30D0\u30FC\u30B8\u30E7\u30F3\u524A\u9664",
    'versions.delete_dialog.message': (versionTitle)=>[
            "\u672C\u5F53\u306B\u30D0\u30FC\u30B8\u30E7\u30F3\u300C",
            versionTitle,
            "\u300D\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'versions.delete_dialog.ok': "\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u524A\u9664",
    'versions.publish_dialog.header': "\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u30D6\u30E9\u30F3\u30C1\u306B\u6295\u7A3F",
    'versions.publish_dialog.message': (versionTitle)=>[
            "\u30D0\u30FC\u30B8\u30E7\u30F3\u300C",
            versionTitle,
            "\u300D\u3092\u6295\u7A3F\u3059\u308B\u30D6\u30E9\u30F3\u30C1\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        ],
    'versions.publish_dialog.no_branches': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30D6\u30E9\u30F3\u30C1\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'versions.publish_dialog.ok': "\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u6295\u7A3F",
    'versions.publish_existing_dialog.header': "\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u518D\u6295\u7A3F",
    'versions.publish_existing_dialog.message': "\u6700\u8FD1\u306E\u30D0\u30FC\u30B8\u30E7\u30F3:",
    'versions.publish_existing_dialog.no_versions': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30D0\u30FC\u30B8\u30E7\u30F3\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'versions.publish_existing_dialog.ok': "\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u6295\u7A3F",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': "\u30D1\u30C3\u30B1\u30FC\u30B8",
    'packages.download_zip': "ZIP\u3068\u3057\u3066\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    'packages.download_torrent': "Torrent\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    'packages.total_size': (size)=>[
            "\u7DCF\u5BB9\u91CF: ",
            size
        ],
    'packages.manage': "\u30D1\u30C3\u30B1\u30FC\u30B8\u7BA1\u7406",
    'packages.rename': "\u30D1\u30C3\u30B1\u30FC\u30B8\u540D\u306E\u5909\u66F4",
    'packages.rename_dialog.header': "\u30D1\u30C3\u30B1\u30FC\u30B8\u540D\u306E\u5909\u66F4",
    'packages.rename_dialog.label': "\u30D1\u30C3\u30B1\u30FC\u30B8\u540D:",
    'packages.rename_dialog.ok': "\u30D1\u30C3\u30B1\u30FC\u30B8\u540D\u3092\u5909\u66F4",
    'packages.edit_tags': "\u30D1\u30C3\u30B1\u30FC\u30B8\u30BF\u30B0\u306E\u7DE8\u96C6",
    'packages.edit_tags_dialog.header': "\u30D1\u30C3\u30B1\u30FC\u30B8\u30BF\u30B0\u306E\u7DE8\u96C6",
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "\u30D1\u30C3\u30B1\u30FC\u30B8\u300C",
            packageTitle,
            "\u300D\u306E\u30BF\u30B0\u3092\u6307\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044:"
        ],
    'packages.edit_tags_dialog.ok': "\u30BF\u30B0\u3092\u8A2D\u5B9A",
    'packages.entrypoint': (entrypoint)=>[
            "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB: ",
            entrypoint
        ],
    'packages.entrypoint.empty': "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'packages.delete': "\u30D1\u30C3\u30B1\u30FC\u30B8\u524A\u9664",
    'packages.delete_dialog.header': "\u30D1\u30C3\u30B1\u30FC\u30B8\u524A\u9664",
    'packages.delete_dialog.message': (packageTitle)=>[
            "\u672C\u5F53\u306B\u30D1\u30C3\u30B1\u30FC\u30B8\u300C",
            packageTitle,
            "\u300D\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F\u3053\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u306F\u3001\u8FFD\u52A0\u3055\u308C\u3066\u3044\u308B\u3059\u3079\u3066\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002"
        ],
    'packages.delete_dialog.ok': "\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u524A\u9664",
    'packages.new_dialog.header': "\u65B0\u898F\u30D1\u30C3\u30B1\u30FC\u30B8",
    'packages.new_dialog.label_title': "\u30BF\u30A4\u30C8\u30EB:",
    'packages.new_dialog.title_placeholder': "(\u30BF\u30B0\u304B\u3089\u81EA\u52D5\u751F\u6210)",
    'packages.new_dialog.tags.header': "\u30BF\u30B0",
    'packages.new_dialog.files.header': "\u30D5\u30A1\u30A4\u30EB",
    'packages.new_dialog.total_size': (size, maximum)=>[
            "\u7DCF\u5BB9\u91CF: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(\u6700\u5927 ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "\u65B0\u898F\u30C7\u30FC\u30BF\u5BB9\u91CF: ",
            size
        ],
    'packages.new_dialog.checks.empty': "\u30D5\u30A1\u30A4\u30EB\u304C\u8FFD\u52A0\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'packages.new_dialog.checks.entrypoint.empty': "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u300C",
            entrypoint,
            "\u300D\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u8FFD\u52A0\u3057\u5FD8\u308C\u3066\u3044\u307E\u305B\u3093\u304B\uFF1F\u5B58\u5728\u3059\u308B\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u3092\u6307\u5B9A\u3059\u308B\u304B\u3001\u672A\u8A2D\u5B9A\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u3092\u672A\u8A2D\u5B9A\u306B\u3059\u308B",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u306E\u62E1\u5F35\u5B50\u304C ",
            fileExt,
            " \u3067\u3059: \u30BF\u30B0\u300C",
            tag,
            "\u300D\u3092\u63A8\u5968\u3057\u307E\u3059\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "\u30BF\u30B0\u300C",
            tag,
            "\u300D\u3092\u8FFD\u52A0"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u306E\u62E1\u5F35\u5B50\u304C ",
            fileExt,
            " \u3067\u3059: \u30D6\u30E9\u30A6\u30B6\u3067\u30D7\u30EC\u30A4\u53EF\u80FD\u306B\u3059\u308B\u306B\u306F\u30BF\u30B0\u300C",
            tag,
            "\u300D\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u306E\u62E1\u5F35\u5B50\u304C ",
            fileExt,
            " \u3067\u3059: \u8AA4\u308A\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F\u901A\u5E38\u3001\u3053\u306E\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u306B\u6307\u5B9A\u3055\u308C\u307E\u305B\u3093\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u306E\u62E1\u5F35\u5B50\u304C ",
            fileExt,
            " \u3067\u3059: \u30A2\u30FC\u30AB\u30A4\u30D6\u30D5\u30A1\u30A4\u30EB\u306B\u307E\u3068\u3081\u308B\u306E\u3067\u306F\u306A\u304F\u3001\u5C55\u958B\u3057\u305F\u30D5\u30A1\u30A4\u30EB\u3092\u76F4\u63A5\u542B\u3081\u308B\u3053\u3068\u3092\u63A8\u5968\u3057\u307E\u3059\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.executable': "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u306B\u5B9F\u884C\u53EF\u80FD\u5C5E\u6027\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    'packages.new_dialog.checks.entrypoint.executable.action': "\u5B9F\u884C\u53EF\u80FD\u5C5E\u6027\u3092\u8A2D\u5B9A\u3059\u308B",
    'packages.new_dialog.checks.single_root_dir': "\u30EB\u30FC\u30C8\u306B\u5358\u4E00\u306E\u30D5\u30A9\u30EB\u30C0\u3092\u7F6E\u304F\u306E\u3067\u306F\u306A\u304F\u3001\u30D5\u30A1\u30A4\u30EB\u3092\u76F4\u63A5\u30EB\u30FC\u30C8\u306B\u914D\u7F6E\u3059\u308B\u3053\u3068\u3092\u63A8\u5968\u3057\u307E\u3059\u3002",
    'packages.new_dialog.checks.single_root_dir.action': "\u30D5\u30A9\u30EB\u30C0\u3092\u305D\u306E\u4E2D\u8EAB\u3067\u7F6E\u304D\u63DB\u3048\u308B",
    'packages.add_existing_dialog.header': "\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u8FFD\u52A0",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `${$353c90f5b534128a$var$plural(packagesCount, `${packagesCount} \u{500B}\u{306E}\u{30D1}\u{30C3}\u{30B1}\u{30FC}\u{30B8}`, `${packagesCount} \u{500B}\u{306E}\u{30D1}\u{30C3}\u{30B1}\u{30FC}\u{30B8}`)}\u{3092}\u{8FFD}\u{52A0}` : "\u30D1\u30C3\u30B1\u30FC\u30B8\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    'packages.add_existing_dialog.message': "\u6700\u8FD1\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30D1\u30C3\u30B1\u30FC\u30B8:",
    'packages.add_existing_dialog.no_packages': "\u6700\u8FD1\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30D1\u30C3\u30B1\u30FC\u30B8\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    'packages.launch': "\u8D77\u52D5",
    'packages.install': "\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
    'packages.install_dialog.header': "\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
    'packages.install_dialog.workdir.label': "\u4F5C\u696D\u30C7\u30A3\u30EC\u30AF\u30C8\u30EA:",
    'packages.install_dialog.workdir.value.new': "(\u65B0\u898F\u4F5C\u6210)",
    'packages.install_dialog.workspace.label': "\u4F5C\u6210\u5148\u30D5\u30A9\u30EB\u30C0:",
    'packages.install_dialog.workspace.placeholder': "(\u30EB\u30FC\u30C8\u30D5\u30A9\u30EB\u30C0\u3092\u9078\u629E)",
    'packages.install_dialog.ok': "\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
    'packages.update': "\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8",
    'packages.upload.status.existing': "\u524D\u30D0\u30FC\u30B8\u30E7\u30F3\u304B\u3089\u5F15\u304D\u7D99\u304E",
    'packages.upload.status.queued': "\u5F85\u6A5F\u4E2D",
    'packages.upload.status.packing': "\u30D1\u30C3\u30AF\u4E2D...",
    'packages.upload.status.creating': "\u4F5C\u6210\u4E2D...",
    'packages.upload.status.create_retrying': "\u4F5C\u6210\u5931\u6557\u3001\u518D\u8A66\u884C\u3092\u5F85\u6A5F\u4E2D",
    'packages.upload.status.splitting': "\u5206\u5272\u4E2D...",
    'packages.upload.status.uploading': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D...",
    'packages.upload.status.finalizing': "\u78BA\u5B9A\u4E2D...",
    'packages.upload.status.finalize_retrying': "\u78BA\u5B9A\u5931\u6557\u3001\u518D\u8A66\u884C\u3092\u5F85\u6A5F\u4E2D",
    'packages.upload.status.resolving': "\u30D1\u30C3\u30C1\u89E3\u6C7A\u4E2D...",
    'packages.upload.status.resolve_retrying': "\u30D1\u30C3\u30C1\u89E3\u6C7A\u5931\u6557\u3001\u518D\u8A66\u884C\u3092\u5F85\u6A5F\u4E2D...",
    'packages.upload.status.done': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5B8C\u4E86",
    'packages.upload.status.errored': "\u30A8\u30E9\u30FC",
    'packages.upload.part.status.queued': "\u5F85\u6A5F\u4E2D",
    'packages.upload.part.status.hashing': "\u30CF\u30C3\u30B7\u30E5\u8A08\u7B97\u4E2D",
    'packages.upload.part.status.upload_queued': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5F85\u6A5F\u4E2D",
    'packages.upload.part.status.uploading': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D",
    'packages.upload.part.status.upload_retrying': "\u30A8\u30E9\u30FC\u3001\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u518D\u8A66\u884C\u4E2D",
    'packages.upload.part.status.upload_finalizing': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u78BA\u5B9A\u4E2D",
    'packages.upload.part.status.upload_errored': "\u30A8\u30E9\u30FC",
    'packages.upload.part.status.done': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5B8C\u4E86",
    'packages.play': "\u30D6\u30E9\u30A6\u30B6\u3067\u30D7\u30EC\u30A4",
    'packages.play.reset': "\u30EA\u30BB\u30C3\u30C8",
    'packages.play.fullscreen': "\u5168\u753B\u9762\u8868\u793A",
    'deploy_sites.add_dialog.header': "\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u3092\u8FFD\u52A0",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831\u3092\u9078\u629E\u3057\u3001\u30B5\u30A4\u30C8\u306EURL\u3092\u5165\u529B\u3057\u3066\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u306E\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u3068\u3057\u3066\u4FDD\u5B58\u3057\u307E\u3059\u3002"
        ],
    'deploy_sites.add_dialog.label_credential': "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831:",
    'deploy_sites.add_dialog.select_credential': "\u8A8D\u8A3C\u60C5\u5831\u3092\u9078\u629E",
    'deploy_sites.add_dialog.select_credential.new': "\u65B0\u3057\u3044\u8A8D\u8A3C\u60C5\u5831\u3092\u8FFD\u52A0...",
    'deploy_sites.add_dialog.label_select_site': "\u30B5\u30A4\u30C8\u3092\u9078\u629E:",
    'deploy_sites.add_dialog.select_credential_first': "(\u5148\u306B\u8A8D\u8A3C\u60C5\u5831\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044)",
    'deploy_sites.add_dialog.select_site': "(\u30B5\u30A4\u30C8\u3092\u9078\u629E)",
    'deploy_sites.add_dialog.label_enter_site': "\u307E\u305F\u306F\u30B5\u30A4\u30C8URL\u3092\u5165\u529B:",
    'deploy_sites.add_dialog.ok': "\u30B5\u30A4\u30C8\u3092\u8FFD\u52A0",
    'deploy_to_site_dialog.header': "\u30B5\u30A4\u30C8\u306B\u516C\u958B",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u300C",
            versionTitle,
            "\u300D\u3092\u516C\u958B\u3059\u308B\u30B5\u30A4\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        ],
    'deploy_to_site_dialog.label_site': "\u516C\u958B\u5148\u30B5\u30A4\u30C8:",
    'deploy_to_site_dialog.select_site': "\u30B5\u30A4\u30C8\u3092\u9078\u629E",
    'deploy_to_site_dialog.select_site.new': "\u65B0\u3057\u3044\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u3092\u8FFD\u52A0...",
    'deploy_to_site_dialog.packages.message.itch': [
        "\u30D1\u30C3\u30B1\u30FC\u30B8\u306F ",
        $353c90f5b534128a$var$_tmpl$4(),
        " \u3092\u4F7F\u7528\u3057\u3066 itch.io \u306B\u516C\u958B\u3055\u308C\u307E\u3059\u3002\u30C1\u30E3\u30F3\u30CD\u30EB\u540D\u306F\u30D1\u30C3\u30B1\u30FC\u30B8\u306E\u30BF\u30B0\u304B\u3089\u6D3E\u751F\u3057\u307E\u3059\u3002"
    ],
    'deploy_to_site_dialog.deploy': "\u516C\u958B",
    'deploy_to_site_dialog.close': "\u9589\u3058\u308B",
    'deploy_to_site_dialog.error.no_packages': "\u516C\u958B\u3059\u308B\u30D1\u30C3\u30B1\u30FC\u30B8\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "\u8907\u6570\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u3092\u5358\u4E00\u306E\u30C1\u30E3\u30F3\u30CD\u30EB\u306B\u516C\u958B\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u73FE\u5728\u3001",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$353c90f5b534128a$var$plural(packagesCount, [
                    packagesCountText,
                    " \u500B\u306E\u30D1\u30C3\u30B1\u30FC\u30B8"
                ], [
                    packagesCountText,
                    " \u500B\u306E\u30D1\u30C3\u30B1\u30FC\u30B8"
                ])),
            "\u304C\u30C1\u30E3\u30F3\u30CD\u30EB\u300C",
            channel,
            "\u300D\u306B\u516C\u958B\u3055\u308C\u308B\u3088\u3046\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059\u3002"
        ],
    'deploy_to_site_dialog.job.queued': "\u5F85\u6A5F\u4E2D",
    'deploy_to_site_dialog.job.downloading': "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D...",
    'deploy_to_site_dialog.job.unpacking': "\u5C55\u958B\u4E2D...",
    'deploy_to_site_dialog.job.uploading': "\u516C\u958B\u4E2D...",
    'deploy_to_site_dialog.job.succeeded': "\u6210\u529F",
    'deploy_to_site_dialog.job.errored': "\u30A8\u30E9\u30FC",
    'store': "\u30B9\u30C8\u30A2",
    'store.hint': "\u516C\u958B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'store.project.hint': "\u30B9\u30C8\u30A2\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30DA\u30FC\u30B8",
    'store.project.owner': "\u30C7\u30D9\u30ED\u30C3\u30D1\u30FC",
    'store.project.description': "\u8AAC\u660E",
    'store.project.star': "\u30B9\u30BF\u30FC",
    'store.project.starred': "\u30B9\u30BF\u30FC\u4ED8\u304D",
    'store.project.content': "\u30B3\u30F3\u30C6\u30F3\u30C4",
    'store.project.content.warning': "\u3053\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u306F\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3\u306E\u30C7\u30D9\u30ED\u30C3\u30D1\u30FC\u306B\u3088\u3063\u3066\u63D0\u4F9B\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            "\u30D6\u30E9\u30F3\u30C1\u300C",
            branchTitle,
            "\u300D: \u30D0\u30FC\u30B8\u30E7\u30F3 ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "\u516C\u958B\u65E5: ",
            branchVersionPublished
        ],
    'me': "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB",
    'me.hint': "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u8A2D\u5B9A\u3068\u9023\u643A\u6E08\u307F\u306E\u8A8D\u8A3C\u60C5\u5831",
    'me.rename': "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306E\u540D\u524D\u5909\u66F4",
    'me.rename_dialog.header': "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306E\u540D\u524D\u5909\u66F4",
    'me.rename_dialog.label_title': "\u540D\u524D:",
    'me.rename_dialog.ok': "\u540D\u524D\u3092\u5909\u66F4",
    'me.credentials': "\u8A8D\u8A3C\u60C5\u5831",
    'me.credentials.hint.auth_allowed': "\u3053\u308C\u3089\u306E\u8A8D\u8A3C\u60C5\u5831\u306E\u3044\u305A\u308C\u304B\u3092\u4F7F\u7528\u3057\u3066\u3001\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30ED\u30B0\u30A4\u30F3\u3067\u304D\u307E\u3059\u3002",
    'me.credentials.hint.auth_disallowed': "\u3053\u308C\u3089\u306E\u8A8D\u8A3C\u60C5\u5831\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u9023\u643A\u3055\u308C\u3066\u3044\u307E\u3059\u304C\u3001\u30ED\u30B0\u30A4\u30F3\u306B\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
    'me.credentials.empty': "\u8A8D\u8A3C\u60C5\u5831\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'me.credentials.empty.auth_allowed.warning': "\u30A2\u30AB\u30A6\u30F3\u30C8\u304B\u3089\u30ED\u30C3\u30AF\u30A2\u30A6\u30C8\u3055\u308C\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\uFF01\u30ED\u30B0\u30A4\u30F3\u306B\u4F7F\u7528\u3067\u304D\u308B\u8A8D\u8A3C\u60C5\u5831\u304C\u9023\u643A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u30ED\u30B0\u30A4\u30F3\u53EF\u80FD\u306A\u8A8D\u8A3C\u60C5\u5831\u3092\u9023\u643A\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'me.credentials.profile_picture.alt': (provider)=>`${$353c90f5b534128a$var$dict[`auth.provider.${provider}`]} \u{30D7}\u{30ED}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{753B}\u{50CF}`,
    'me.credentials.created': (created)=>[
            "\u8FFD\u52A0\u65E5: ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\u6700\u7D42\u4F7F\u7528\u65E5: ",
            lastUsed
        ],
    'me.credential.unlink': "\u9023\u643A\u89E3\u9664",
    'me.credential.allow_auth': "\u30ED\u30B0\u30A4\u30F3\u3092\u8A31\u53EF",
    'me.credential.disallow_auth': "\u30ED\u30B0\u30A4\u30F3\u3092\u7981\u6B62",
    'me.credential.display_publicly': "\u516C\u958B\u8868\u793A\u3059\u308B",
    'me.credential.dont_display_publicly': "\u516C\u958B\u8868\u793A\u3057\u306A\u3044",
    'me.credential.link': "\u8A8D\u8A3C\u60C5\u5831\u3092\u9023\u643A",
    'me.credential.link_dialog.header': "\u8A8D\u8A3C\u60C5\u5831\u306E\u9023\u643A",
    'me.credential.link_dialog.message': "\u9023\u643A\u3059\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'me.credential.unlink_dialog.header': "\u8A8D\u8A3C\u60C5\u5831\u306E\u9023\u643A\u89E3\u9664",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "\u672C\u5F53\u306B ",
            credentialProvider,
            " \u30A2\u30AB\u30A6\u30F3\u30C8\u300C",
            credentialTitle,
            "\u300D\u306E Kavykhi.Cloud \u30A2\u30AB\u30A6\u30F3\u30C8\u3068\u306E\u9023\u643A\u3092\u89E3\u9664\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'me.credential.unlink_dialog.ok': "\u9023\u643A\u3092\u89E3\u9664",
    'me.sessions': "\u30BB\u30C3\u30B7\u30E7\u30F3",
    'me.sessions.hint': "\u73FE\u5728\u4F7F\u7528\u4E2D\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u542B\u3080\u3001\u30A2\u30AF\u30C6\u30A3\u30D6\u306A\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u4E00\u89A7\u3067\u3059\u3002",
    'me.sessions.started': (started)=>[
            "\u958B\u59CB\u65E5\u6642 ",
            (()=>{
                var _el$6 = $353c90f5b534128a$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "\u30A2\u30AF\u30C6\u30A3\u30D6 ",
            (()=>{
                var _el$7 = $353c90f5b534128a$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "\u73FE\u5728\u306E\u30BB\u30C3\u30B7\u30E7\u30F3",
    'me.sessions.empty': "\u30BB\u30C3\u30B7\u30E7\u30F3\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    'me.sessions.delete': "\u7D42\u4E86",
    'me.sessions.delete_dialog.header': "\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u7D42\u4E86",
    'me.sessions.delete_dialog.message': "\u672C\u5F53\u306B\u3053\u306E\u30BB\u30C3\u30B7\u30E7\u30F3\u3092\u7D42\u4E86\u3057\u307E\u3059\u304B\uFF1F",
    'me.sessions.delete_dialog.ok': "\u30BB\u30C3\u30B7\u30E7\u30F3\u3092\u7D42\u4E86",
    'me.api_tokens': "API \u30C8\u30FC\u30AF\u30F3",
    'me.api_tokens.hint': "\u81EA\u52D5\u5316\u51E6\u7406\u306A\u3069\u3067\u4F7F\u7528\u3059\u308B API \u30C8\u30FC\u30AF\u30F3\u3092\u751F\u6210\u3067\u304D\u307E\u3059\u3002",
    'me.api_tokens.started': (started)=>[
            "\u4F5C\u6210\u65E5\u6642 ",
            (()=>{
                var _el$8 = $353c90f5b534128a$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "\u6709\u52B9\u671F\u9650 ",
            (()=>{
                var _el$9 = $353c90f5b534128a$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "\u7121\u671F\u9650",
    'me.api_tokens.empty': "API \u30C8\u30FC\u30AF\u30F3\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    'me.api_tokens.create': "API \u30C8\u30FC\u30AF\u30F3\u3092\u751F\u6210",
    'me.api_tokens.create_dialog.header': "API \u30C8\u30FC\u30AF\u30F3\u306E\u751F\u6210",
    'me.api_tokens.create_dialog.message': "\u751F\u6210\u3055\u308C\u305F API \u30C8\u30FC\u30AF\u30F3:",
    'me.api_tokens.create_dialog.note': "\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u306F\u4E8C\u5EA6\u3068\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002\u5B89\u5168\u306A\u5834\u6240\u306B\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'me.api_tokens.delete': "\u524A\u9664",
    'me.api_tokens.delete_dialog.header': "API \u30C8\u30FC\u30AF\u30F3\u306E\u524A\u9664",
    'me.api_tokens.delete_dialog.message': "\u672C\u5F53\u306B\u3053\u306E\u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
    'me.api_tokens.delete_dialog.ok': "API \u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664",
    'me.deploy_credentials': "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831",
    'me.deploy_credentials.hint': "\u914D\u4FE1\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u3078\u306E\u30C7\u30D7\u30ED\u30A4\u7528\u8A8D\u8A3C\u60C5\u5831\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059\u3002",
    'me.deploy_credentials.empty': "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831\u306F\u8FFD\u52A0\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'me.deploy_credential.add': "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831\u3092\u8FFD\u52A0",
    'me.deploy_credential.add_dialog.header': "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831\u306E\u8FFD\u52A0",
    'me.deploy_credential.add_dialog.label_site': "\u30B5\u30A4\u30C8:",
    'me.deploy_credential.add_dialog.label_title': "\u30E1\u30E2:",
    'me.deploy_credential.add_dialog.label_key': "\u30AD\u30FC:",
    'me.deploy_credential.add_dialog.default_title': (date)=>`\u{30AD}\u{30FC} ${date}`,
    'me.deploy_credential.add_dialog.ok': "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831\u3092\u8FFD\u52A0",
    'me.deploy_credential.add_dialog.hint.itch': [
        "itch.io \u306E API \u30AD\u30FC\u3092\u751F\u6210\u3059\u308B\u306B\u306F\u3001itch.io \u306E ",
        $353c90f5b534128a$var$_tmpl$6(),
        " \u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30BD\u30FC\u30B9\u304C\u300Cweb\u300D\u307E\u305F\u306F\u300Cwharf\u300D\u306E\u65E2\u5B58\u306E API \u30AD\u30FC\u3092\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u300CKavykhi.Cloud\u300D\u30BD\u30FC\u30B9\u306E API \u30AD\u30FC\u306F\u6A5F\u80FD\u3057\u307E\u305B\u3093\u3002"
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "\u73FE\u5728\u3001",
            credentialProvider,
            " \u306E\u8A8D\u8A3C\u60C5\u5831\u306E\u8FFD\u52A0\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"
        ],
    'me.deploy_credential.delete': "\u524A\u9664",
    'me.deploy_credential.delete_dialog.header': "\u30C7\u30D7\u30ED\u30A4\u8A8D\u8A3C\u60C5\u5831\u306E\u524A\u9664",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "\u672C\u5F53\u306B ",
            credentialProvider,
            " \u306E\u8A8D\u8A3C\u60C5\u5831\u300C",
            credentialTitle,
            "\u300D\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F\u3053\u306E\u8A8D\u8A3C\u60C5\u5831\u3092\u4F7F\u7528\u3059\u308B\u3088\u3046\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u30C7\u30D7\u30ED\u30A4\u5148\u30B5\u30A4\u30C8\u3082\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002"
        ],
    'me.deploy_credential.delete_dialog.ok': "\u8A8D\u8A3C\u60C5\u5831\u3092\u524A\u9664",
    'me.public_profile': "\u516C\u958B\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB",
    'me.public_profile.public_credentials': "\u516C\u958B\u3059\u308B\u8A8D\u8A3C\u60C5\u5831",
    'me.public_profile.public_credentials.hint': "\u516C\u958B\u8868\u793A\u3059\u308B\u8A8D\u8A3C\u60C5\u5831\u3092\u9078\u629E\u3057\u307E\u3059\u3002",
    'me.manage': "\u30A2\u30AB\u30A6\u30F3\u30C8\u7BA1\u7406",
    'me.delete': "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664",
    'me.delete.dialog.header': "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664",
    'me.delete.dialog.message': (userTitle)=>[
            "\u672C\u5F53\u306B Kavykhi.Cloud \u30A2\u30AB\u30A6\u30F3\u30C8\u300C",
            userTitle,
            "\u300D\u3092\u5B8C\u5168\u306B\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F\u3053\u306E\u64CD\u4F5C\u306F\u53D6\u308A\u6D88\u305B\u307E\u305B\u3093\u3002"
        ],
    'me.delete.dialog.ok': "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664",
    'invite': "\u62DB\u5F85",
    'invite.hint': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3078\u306E\u62DB\u5F85",
    'invite.message.already_member': (projectTitle)=>[
            "\u3042\u306A\u305F\u306F\u3059\u3067\u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u306E\u30E1\u30F3\u30D0\u30FC\u3067\u3059\u3002"
        ],
    'invite.message.join': (projectTitle)=>[
            "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u300C",
            projectTitle,
            "\u300D\u306B\u62DB\u5F85\u3055\u308C\u307E\u3057\u305F\u3002"
        ],
    'invite.join': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u53C2\u52A0",
    'local': "\u30ED\u30FC\u30AB\u30EB\u30B3\u30F3\u30C6\u30F3\u30C4",
    'local.hint': "\u30ED\u30FC\u30AB\u30EB\u306B\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4",
    'local.workdirs': "\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u6E08\u307F\u30D1\u30C3\u30B1\u30FC\u30B8",
    'local.workdirs.empty': "\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u3066\u3044\u308B\u30D1\u30C3\u30B1\u30FC\u30B8\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    'local.workdir.action.launch': "\u8D77\u52D5",
    'local.workdir.action.repair': "\u4FEE\u5FA9",
    'local.workdir.action.delete': "\u30A2\u30F3\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
    'local.workdir.delete_dialog.header': "\u30D1\u30C3\u30B1\u30FC\u30B8\u306E\u30A2\u30F3\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\u672C\u5F53\u306B\u30C7\u30D0\u30A4\u30B9\u304B\u3089\u30D1\u30C3\u30B1\u30FC\u30B8\u300C",
            packageTitle,
            "\u300D\u3092\u30A2\u30F3\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059\u304B\uFF1F"
        ],
    'local.workdir.delete_dialog.ok': "\u30A2\u30F3\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
    'local.workspaces': "\u30EB\u30FC\u30C8\u30D5\u30A9\u30EB\u30C0",
    'local.app_not_detected.message': "Kavykhi.Cloud \u30ED\u30FC\u30AB\u30EB\u30A2\u30D7\u30EA\u304C\u691C\u51FA\u3055\u308C\u307E\u305B\u3093\u3002\u4EE5\u4E0B\u306E\u30EA\u30F3\u30AF\u304B\u3089\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3059\u3067\u306B\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u30A2\u30D7\u30EA\u304C\u8D77\u52D5\u3057\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'local_app.detected': "\u30ED\u30FC\u30AB\u30EB\u30B3\u30F3\u30C6\u30F3\u30C4",
    'error_dialog.header': "\u30A8\u30E9\u30FC",
    'error_dialog.messageFunc': (e)=>`\u{30A8}\u{30E9}\u{30FC}: ${$353c90f5b534128a$var$dict[`error.${e}`] ?? e}\u{3002}`,
    'upload_box.choose_files': "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E",
    'upload_box.choose_directories': "\u30D5\u30A9\u30EB\u30C0\u3092\u9078\u629E",
    'upload_box.add.progress_dialog.header': "\u30D5\u30A1\u30A4\u30EB\u3092\u8FFD\u52A0\u4E2D",
    'upload_box.add.progress_dialog.message': "\u30D5\u30A1\u30A4\u30EB\u3092\u51E6\u7406\u4E2D...",
    'upload_box.delete': (itemsCount)=>`${$353c90f5b534128a$var$plural(itemsCount, `${itemsCount} \u{500B}\u{306E}\u{30A2}\u{30A4}\u{30C6}\u{30E0}`, `${itemsCount} \u{500B}\u{306E}\u{30A2}\u{30A4}\u{30C6}\u{30E0}`)}\u{3092}\u{524A}\u{9664}`,
    'upload_box.start_upload': "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u958B\u59CB",
    'upload_box.drop_area.message': "\u3053\u3053\u306B\u30D5\u30A1\u30A4\u30EB\u3084\u30D5\u30A9\u30EB\u30C0\u3092\u30C9\u30ED\u30C3\u30D7",
    'upload_box.drop_area.box_dropping_message': "\u3053\u3053\u306B\u30C9\u30ED\u30C3\u30D7\u3057\u3066\u30EB\u30FC\u30C8\u306B\u914D\u7F6E",
    'upload_box.entry.explode_folder': "\u30D5\u30A9\u30EB\u30C0\u3092\u305D\u306E\u4E2D\u8EAB\u3067\u7F6E\u304D\u63DB\u3048\u308B",
    'upload_box.entry.set_entrypoint': "\u8D77\u52D5\u30D5\u30A1\u30A4\u30EB\u306B\u8A2D\u5B9A",
    'upload_box.entry.mark_executable': "\u5B9F\u884C\u53EF\u80FD\u306B\u8A2D\u5B9A",
    'upload_box.entry.unmark_executable': "\u5B9F\u884C\u53EF\u80FD\u8A2D\u5B9A\u3092\u89E3\u9664",
    'upload_box.entry.remove': "\u524A\u9664",
    'package.tags.empty': "(\u30BF\u30B0\u306A\u3057)",
    'package.tag.os': 'OS',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': "\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3",
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': "\u30D3\u30C3\u30C8\u6570",
    'package.tag.bits:64': "64\u30D3\u30C3\u30C8",
    'package.tag.bits:32': "32\u30D3\u30C3\u30C8",
    'package.tag.packaging': "\u30D1\u30C3\u30B1\u30FC\u30B8\u30F3\u30B0",
    'package.tag.packaging:installer': "\u30A4\u30F3\u30B9\u30C8\u30FC\u30E9\u30FC",
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': "\u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8",
    'package.tag.component:client': "\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8",
    'package.tag.component:server': "\u30B5\u30FC\u30D0\u30FC",
    'package.tag.runtime': "\u30E9\u30F3\u30BF\u30A4\u30E0",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Linux \u30C7\u30A3\u30B9\u30C8\u30EA\u30D3\u30E5\u30FC\u30B7\u30E7\u30F3",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8",
    'docs.page_no_language': "\u3053\u306E\u8A00\u8A9E\u3067\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093",
    'docs.page_no_language.message': "\u3053\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306F\u4ED6\u306E\u8A00\u8A9E\u3067\u5229\u7528\u53EF\u80FD\u3067\u3059:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5831\u544A",
    'report_content.dialog.header': "\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u5831\u544A",
    'report_content.dialog.link': "\u30E1\u30FC\u30EB\u3067\u5831\u544A\u3092\u9001\u4FE1",
    'report_content.dialog.message': (email, link)=>[
            "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u5831\u544A\u3092\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044:",
            $353c90f5b534128a$var$_tmpl$2(),
            $353c90f5b534128a$var$_tmpl$2(),
            link,
            $353c90f5b534128a$var$_tmpl$2(),
            $353c90f5b534128a$var$_tmpl$2(),
            "\u307E\u305F\u306F\u3001\u624B\u52D5\u3067 ",
            email,
            " \u5B9B\u3066\u306B\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        ]
};
var $353c90f5b534128a$export$2e2bcd8739ae039 = $353c90f5b534128a$var$dict;
const $353c90f5b534128a$var$plural = (n, one, many)=>n == 1 ? one : many;



var $dcef16ee09b318f7$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{D5C8}\u{C6A9}\u{B428}`), $dcef16ee09b318f7$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $dcef16ee09b318f7$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{D5C8}\u{C6A9} \u{C548} \u{B428}`), $dcef16ee09b318f7$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $dcef16ee09b318f7$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $dcef16ee09b318f7$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>\u{D504}\u{B85C}\u{D544} \u{C124}\u{C815}`);
const $dcef16ee09b318f7$var$dict = {
    languageName: "\uD55C\uAD6D\uC5B4",
    locale: 'ko',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: "\uD14C\uB9C8",
    'theme.light': "\uB77C\uC774\uD2B8",
    'theme.dark': "\uB2E4\uD06C",
    'theme.system': "\uC2DC\uC2A4\uD15C",
    'theme.sakura': "\uC0AC\uCFE0\uB77C",
    // generic
    email: "\uC774\uBA54\uC77C",
    password: "\uBE44\uBC00\uBC88\uD638",
    ok: "\uD655\uC778",
    cancel: "\uCDE8\uC18C",
    retry: "\uC7AC\uC2DC\uB3C4",
    copy: "\uBCF5\uC0AC",
    empty: "(\uD56D\uBAA9 \uC5C6\uC74C)",
    loading: "\uB85C\uB529 \uC911...",
    calculating: "\uACC4\uC0B0 \uC911...",
    error: "\uC624\uB958",
    'in_development': "\uC774 \uD398\uC774\uC9C0\uB294 \uAC1C\uBC1C \uC911\uC785\uB2C8\uB2E4.",
    // errors
    'error.not_found': "\uCC3E\uC744 \uC218 \uC5C6\uC74C",
    'error.name_conflict': "\uC774\uB984 \uCDA9\uB3CC",
    'error.bad_param': "\uC798\uBABB\uB41C \uB9E4\uAC1C\uBCC0\uC218",
    'error.wrong_auth': "\uC798\uBABB\uB41C \uC778\uC99D",
    'error.unauthorized': "\uAD8C\uD55C \uC5C6\uC74C",
    'error.wrong_credentials': "\uC798\uBABB\uB41C \uC790\uACA9 \uC99D\uBA85",
    'error.wrong_provider': "\uC798\uBABB\uB41C \uC81C\uACF5\uC790",
    'error.insufficient_privileges': "\uAD8C\uD55C \uBD80\uC871",
    'error.not_empty': "\uBE44\uC5B4 \uC788\uC9C0 \uC54A\uC74C",
    'error.limit_exceeded': "\uD55C\uB3C4 \uCD08\uACFC",
    'error.already_member': "\uC774\uBBF8 \uBA64\uBC84\uC784",
    'error.not_finalized': "\uC644\uB8CC\uB418\uC9C0 \uC54A\uC74C",
    'error.already_finalized': "\uC774\uBBF8 \uC644\uB8CC\uB428",
    'error.unexpected_patch': "\uC608\uAE30\uCE58 \uC54A\uC740 \uD328\uCE58",
    'error.timeout': "\uC2DC\uAC04 \uCD08\uACFC",
    'error.not_patch': "\uD328\uCE58\uAC00 \uC544\uB2D8",
    'error.not_supported': "\uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC74C",
    'error.unexpected_error': "\uC608\uAE30\uCE58 \uC54A\uC740 \uC624\uB958",
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "\uC778\uC99D",
    'auth.dialog.please_select': "\uB85C\uADF8\uC778\uD560 \uACC4\uC815 \uC81C\uACF5\uC790\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.",
    'auth.dialog.redirecting_to': (provider)=>`${provider}(\u{C73C})\u{B85C} \u{C774}\u{B3D9} \u{C911}...`,
    'auth.dialog.remember_me': "\uB85C\uADF8\uC778 \uC0C1\uD0DC \uC720\uC9C0",
    'auth.dialog.log_in': "\uB85C\uADF8\uC778",
    'auth.dialog.back': "\uC774\uC804",
    'auth.dialog.progress_header': "\uC778\uC99D \uC911...",
    'auth.dialog.error.header': "\uC778\uC99D \uC624\uB958",
    'auth.dialog.error.auth_not_allowed': "\uC774 \uC790\uACA9 \uC99D\uBA85\uC740 \uC0AC\uC6A9\uC790\uAC00 \uC778\uC99D\uC5D0 \uC0AC\uC6A9\uD558\uC9C0 \uBABB\uD558\uB3C4\uB85D \uAE08\uC9C0\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uB978 \uC790\uACA9 \uC99D\uBA85\uC744 \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694.",
    'auth.dialog.error.unknown': "\uC798\uBABB\uB41C \uC778\uC99D \uB9E4\uAC1C\uBCC0\uC218\uC785\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
    'auth.dialog.error.back': "\uB3CC\uC544\uAC00\uAE30",
    'user.profile': "\uD504\uB85C\uD544",
    'user.logout': "\uB85C\uADF8\uC544\uC6C3",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "\uD398\uC774\uC9C0\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC74C",
    'page_not_found.message': "\uC774 \uD398\uC774\uC9C0\uB294 \uC874\uC7AC\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    'page_not_found.message2': "\uC774\uC804\uC5D0\uB294 \uC788\uC5C8\uC744 \uC218 \uC788\uC73C\uB098 \uD604\uC7AC\uB294 \uC544\uBB34\uAC83\uB3C4 \uC5C6\uC2B5\uB2C8\uB2E4. \uB2E4\uC74C\uACFC \uAC19\uC740 \uAC00\uB2A5\uC131\uC774 \uC788\uC2B5\uB2C8\uB2E4.",
    'page_not_found.items': [
        "\uC774\uC804\uC5D0 \uC5EC\uAE30\uC5D0 \uBB34\uC5B8\uAC00 \uC788\uC5C8\uC73C\uB098 \uC9C0\uAE08\uC740 \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
        "\uC544\uC9C1 \uC5EC\uAE30\uC5D0 \uBB34\uC5B8\uAC00 \uC788\uC73C\uB098 \uC811\uADFC \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
        "\uB610\uB294 \uB9C1\uD06C\uB97C \uBCF5\uC0AC\uD558\uC5EC \uBD99\uC5EC\uB123\uB294 \uB3D9\uC548 \uC2E4\uC218\uAC00 \uC788\uC5C8\uC2B5\uB2C8\uB2E4."
    ],
    'home': "\uD648",
    'home.header.hint': "\uC778\uB514 \uAC1C\uBC1C\uC790\uB97C \uC704\uD55C \uD074\uB77C\uC6B0\uB4DC \uB3C4\uAD6C",
    'home.description': "Kavykhi.Cloud\uB294 \uC778\uB514 \uAC8C\uC784 \uAC1C\uBC1C \uD50C\uB7AB\uD3FC\uC785\uB2C8\uB2E4. \uB2E4\uC6B4\uB85C\uB4DC\uD615 \uBC0F \uBE0C\uB77C\uC6B0\uC800 \uAC8C\uC784, \uBE44\uACF5\uAC1C \uBC0F \uACF5\uAC1C \uBE4C\uB4DC, \uBE0C\uB79C\uCE58, \uD300 \uB4F1 \uB2E4\uC591\uD55C \uAE30\uB2A5\uC744 \uC9C0\uC6D0\uD569\uB2C8\uB2E4.",
    'home.auth': "\uB85C\uADF8\uC778 \uB610\uB294 \uAC00\uC785",
    'home.auth.hint': "\uC0C8 \uACC4\uC815 \uC0DD\uC131 \uB610\uB294 \uAE30\uC874 \uACC4\uC815 \uB85C\uADF8\uC778",
    'projects': "\uD504\uB85C\uC81D\uD2B8",
    'projects.hint': "\uC791\uC5C5 \uC911\uC778 \uD504\uB85C\uC81D\uD2B8",
    'projects.project': (project)=>`\u{D504}\u{B85C}\u{C81D}\u{D2B8}: ${project}`,
    'projects.project.hint': "\uD504\uB85C\uC81D\uD2B8",
    'projects.no_projects': "\uC544\uC9C1 \uD504\uB85C\uC81D\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'projects.new': "\uD504\uB85C\uC81D\uD2B8 \uC0DD\uC131",
    'projects.new_dialog.header': "\uC0C8 \uD504\uB85C\uC81D\uD2B8",
    'projects.new_dialog.label': "\uD504\uB85C\uC81D\uD2B8 \uC774\uB984",
    'projects.new_dialog.ok': "\uD504\uB85C\uC81D\uD2B8 \uC0DD\uC131",
    'projects.store_page': "\uACF5\uAC1C \uC2A4\uD1A0\uC5B4 \uD398\uC774\uC9C0",
    'projects.description': "\uC124\uBA85",
    'projects.branches': "\uBE0C\uB79C\uCE58",
    'projects.versions': "\uBC84\uC804",
    'projects.packages': "\uD328\uD0A4\uC9C0",
    'projects.management': "\uD504\uB85C\uC81D\uD2B8 \uC124\uC815",
    'projects.management.breadcrumb': "\uC124\uC815",
    'projects.management.title': (projectTitle)=>`${projectTitle} - \u{C124}\u{C815}`,
    'projects.management.hint': "\uD504\uB85C\uC81D\uD2B8 \uC124\uC815",
    'projects.management.users': "\uD300 \uBA64\uBC84",
    'projects.management.users.empty': "\uD300 \uBA64\uBC84\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'projects.management.users.role.tester': "\uD14C\uC2A4\uD130",
    'projects.management.users.role.developer': "\uAC1C\uBC1C\uC790",
    'projects.management.users.role.admin': "\uAD00\uB9AC\uC790",
    'projects.management.users.role.owner': "\uC18C\uC720\uC790",
    'projects.management.users.role.starred': "\uC2A4\uD0C0 \uD45C\uC2DC\uB428",
    'projects.management.users.exile': "\uD300\uC5D0\uC11C \uC81C\uAC70",
    'projects.management.users.exile.dialog.header': "\uD300\uC5D0\uC11C \uC81C\uAC70",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C ",
            userTitle,
            "\uB2D8\uC744 \uC81C\uAC70\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'projects.management.users.exile.dialog.ok': "\uD300\uC5D0\uC11C \uC81C\uAC70",
    'projects.management.invites.one_time_invite': "\uC77C\uD68C\uC6A9 \uCD08\uB300 \uB9C1\uD06C",
    'projects.management.invites.one_time_invite.header': "\uC77C\uD68C\uC6A9 \uCD08\uB300 \uB9C1\uD06C",
    'projects.management.invites.one_time_invite.message': "\uC77C\uD68C\uC6A9 \uCD08\uB300 \uB9C1\uD06C:",
    'projects.management.invites.one_time_invite.note': "24\uC2DC\uAC04 \uB3D9\uC548 \uC720\uD6A8\uD558\uBA70, \uD55C \uBC88\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'projects.management.invites.new_dialog.header': "\uCD08\uB300 \uB9C1\uD06C",
    'projects.management.invites.new_dialog.expires': "\uB9CC\uB8CC \uC2DC\uAC04:",
    'projects.management.invites.new_dialog.expires.indefinite': "(\uB9CC\uB8CC \uC5C6\uC74C)",
    'projects.management.invites.new_dialog.approval.label': "\uC0AC\uC6A9\uC790 \uD504\uB85C\uC81D\uD2B8 \uAC00\uC785:",
    'projects.management.invites.new_dialog.approval.not_approved': "\uAD00\uB9AC\uC790 \uC2B9\uC778 \uD6C4",
    'projects.management.invites.new_dialog.approval.approved': "\uC989\uC2DC",
    'projects.management.invites.new_dialog.seats': "\uAC00\uC785 \uC81C\uD55C:",
    'projects.management.invites.new_dialog.seats.no_limit': "(\uC81C\uD55C \uC5C6\uC74C)",
    'projects.management.invites.new_dialog.ok': "\uCD08\uB300 \uB9C1\uD06C \uC0DD\uC131",
    'projects.management.deploy_sites': "\uBC30\uD3EC \uC0AC\uC774\uD2B8",
    'projects.management.deploy_sites.empty': "\uCD94\uAC00\uB41C \uBC30\uD3EC \uC0AC\uC774\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'projects.management.deploy_sites.add': "\uBC30\uD3EC \uC0AC\uC774\uD2B8 \uCD94\uAC00",
    'projects.management.deploy_sites.delete': "\uC0AD\uC81C",
    'projects.management.deploy_sites.delete_dialog.header': "\uBC30\uD3EC \uC0AC\uC774\uD2B8 \uC0AD\uC81C",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            provider,
            " \uBC30\uD3EC \uC0AC\uC774\uD2B8 ",
            site,
            "\uC744(\uB97C) \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "\uBC30\uD3EC \uC0AC\uC774\uD2B8 \uC0AD\uC81C",
    'projects.management.public_access': "\uACF5\uAC1C \uC811\uADFC",
    'projects.management.public_access.enable': "\uACF5\uAC1C \uC811\uADFC \uD65C\uC131\uD654",
    'projects.management.public_access.enabled': [
        "\uACF5\uAC1C \uC811\uADFC: ",
        $dcef16ee09b318f7$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "\uD504\uB85C\uC81D\uD2B8\uC758 \uC774\uB984\uACFC \uC124\uBA85, \uADF8\uB9AC\uACE0 \uACF5\uAC1C\uB85C \uD45C\uC2DC\uB41C \uBAA8\uB4E0 \uBE0C\uB79C\uCE58\uAC00 \uACF5\uAC1C\uB429\uB2C8\uB2E4.",
    'projects.management.public_access.enable_dialog.header': "\uACF5\uAC1C \uC811\uADFC \uD65C\uC131\uD654",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uC5D0 \uB300\uD55C \uACF5\uAC1C \uC811\uADFC\uC744 \uD5C8\uC6A9\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
            $dcef16ee09b318f7$var$_tmpl$2(),
            $dcef16ee09b318f7$var$_tmpl$2(),
            "\uC774\uB807\uAC8C \uD558\uBA74 \uC778\uC99D \uC5C6\uC774 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uB300\uD55C \uAE30\uBCF8 \uC815\uBCF4\uB97C \uBCFC \uC218 \uC788\uAC8C \uB429\uB2C8\uB2E4. \uACF5\uAC1C\uD558\uB824\uB294 \uAC01 \uBE0C\uB79C\uCE58\uC5D0 \uB300\uD574 \uAC1C\uBCC4\uC801\uC73C\uB85C \uACF5\uAC1C \uC811\uADFC\uC744 \uD65C\uC131\uD654\uD574\uC57C \uD569\uB2C8\uB2E4."
        ],
    'projects.management.public_access.enable_dialog.ok': "\uACF5\uAC1C \uC811\uADFC \uD65C\uC131\uD654",
    'projects.management.public_access.disable': "\uACF5\uAC1C \uC811\uADFC \uBE44\uD65C\uC131\uD654",
    'projects.management.public_access.disabled': [
        "\uACF5\uAC1C \uC811\uADFC: ",
        $dcef16ee09b318f7$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "\uD504\uB85C\uC81D\uD2B8\uAC00 \uBE44\uACF5\uAC1C \uC0C1\uD0DC\uC785\uB2C8\uB2E4. \uD504\uB85C\uC81D\uD2B8 \uD300 \uBA64\uBC84\uB9CC \uC811\uADFC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'projects.management.public_access.disable_dialog.header': "\uACF5\uAC1C \uC811\uADFC \uBE44\uD65C\uC131\uD654",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uC5D0 \uB300\uD55C \uBAA8\uB4E0 \uACF5\uAC1C \uC811\uADFC\uC744 \uBE44\uD65C\uC131\uD654\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'projects.management.public_access.disable_dialog.ok': "\uACF5\uAC1C \uC811\uADFC \uBE44\uD65C\uC131\uD654",
    'projects.management.public_access.branches': "\uACF5\uAC1C \uBE0C\uB79C\uCE58",
    'projects.management.manage': "\uD504\uB85C\uC81D\uD2B8 \uAD00\uB9AC",
    'projects.rename': "\uD504\uB85C\uC81D\uD2B8 \uC774\uB984 \uBCC0\uACBD",
    'projects.rename_dialog.header': "\uD504\uB85C\uC81D\uD2B8 \uC774\uB984 \uBCC0\uACBD",
    'projects.rename_dialog.label': "\uD504\uB85C\uC81D\uD2B8 \uC774\uB984:",
    'projects.rename_dialog.ok': "\uD504\uB85C\uC81D\uD2B8 \uC774\uB984 \uBCC0\uACBD",
    'projects.edit_description': "\uD504\uB85C\uC81D\uD2B8 \uC124\uBA85 \uC218\uC815",
    'projects.edit_description_dialog.header': "\uD504\uB85C\uC81D\uD2B8 \uC124\uBA85 \uC218\uC815",
    'projects.edit_description_dialog.label': "\uD504\uB85C\uC81D\uD2B8 \uC124\uBA85:",
    'projects.edit_description_dialog.ok': "\uC124\uBA85 \uC218\uC815",
    'projects.leave': "\uD504\uB85C\uC81D\uD2B8 \uD0C8\uD1F4",
    'projects.leave_dialog.header': "\uD504\uB85C\uC81D\uD2B8 \uD0C8\uD1F4",
    'projects.leave_dialog.message': (projectTitle)=>[
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C \uD0C8\uD1F4\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'projects.leave_dialog.ok': "\uD504\uB85C\uC81D\uD2B8 \uD0C8\uD1F4",
    'projects.delete': "\uD504\uB85C\uC81D\uD2B8 \uC0AD\uC81C",
    'projects.delete_dialog.header': "\uD504\uB85C\uC81D\uD2B8 \uC0AD\uC81C",
    'projects.delete_dialog.message': (projectTitle)=>[
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'projects.delete_dialog.ok': "\uD504\uB85C\uC81D\uD2B8 \uC0AD\uC81C",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "\uBE0C\uB79C\uCE58",
    'branches.no_branches': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uC544\uC9C1 \uBE0C\uB79C\uCE58\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'branches.new': "\uBE0C\uB79C\uCE58 \uC0DD\uC131",
    'branches.new_dialog.header': "\uC0C8 \uBE0C\uB79C\uCE58",
    'branches.new_dialog.label': "\uBE0C\uB79C\uCE58 \uC774\uB984",
    'branches.new_dialog.ok': "\uBE0C\uB79C\uCE58 \uC0DD\uC131",
    'branches.current_version': (version)=>[
            "\uD604\uC7AC \uBC84\uC804: ",
            version
        ],
    'branches.current_version.packages': "\uD604\uC7AC \uBC84\uC804 \uD328\uD0A4\uC9C0",
    'branches.no_current_version': "\uD604\uC7AC \uBC84\uC804 \uC5C6\uC74C",
    'branches.publish_version.new': "\uC0C8 \uBC84\uC804 \uAC8C\uC2DC",
    'branches.publish_version.existing': "\uAE30\uC874 \uBC84\uC804 \uB2E4\uC2DC \uAC8C\uC2DC",
    'branches.version_history': "\uBC84\uC804 \uAE30\uB85D",
    'branches.version_history.empty': "\uBE0C\uB79C\uCE58\uC758 \uBC84\uC804 \uAE30\uB85D\uC774 \uBE44\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "\uD604\uC7AC \uBE0C\uB79C\uCE58 \uBC84\uC804\uC740 ",
            quotaTime != null ? [
                quotaTime,
                " \uB3D9\uC548"
            ] : "\uBB34\uAE30\uD55C",
            " \uC720\uC9C0\uB429\uB2C8\uB2E4. \uC774\uC804 \uBC84\uC804\uC740 \uCD5C\uB300 ",
            quotaNonCurrentTime,
            " \uB3D9\uC548 \uC720\uC9C0\uB429\uB2C8\uB2E4. \uBE0C\uB79C\uCE58\uB2F9 \uCD1D ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$dcef16ee09b318f7$var$plural(quotaCount, [
                    quotaCountText,
                    "\uAC1C \uBC84\uC804"
                ], [
                    quotaCountText,
                    "\uAC1C \uBC84\uC804"
                ])),
            "\uAE4C\uC9C0\uB9CC \uC720\uC9C0\uB429\uB2C8\uB2E4."
        ],
    'branches.manage': "\uBE0C\uB79C\uCE58 \uAD00\uB9AC",
    'branches.rename': "\uBE0C\uB79C\uCE58 \uC774\uB984 \uBCC0\uACBD",
    'branches.rename_dialog.header': "\uBE0C\uB79C\uCE58 \uC774\uB984 \uBCC0\uACBD",
    'branches.rename_dialog.label': "\uBE0C\uB79C\uCE58 \uC774\uB984:",
    'branches.rename_dialog.ok': "\uBE0C\uB79C\uCE58 \uC774\uB984 \uBCC0\uACBD",
    'branches.delete': "\uBE0C\uB79C\uCE58 \uC0AD\uC81C",
    'branches.delete_dialog.header': "\uBE0C\uB79C\uCE58 \uC0AD\uC81C",
    'branches.delete_dialog.message': (branchTitle)=>[
            branchTitle,
            " \uBE0C\uB79C\uCE58\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'branches.delete_dialog.ok': "\uBE0C\uB79C\uCE58 \uC0AD\uC81C",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "\uBC84\uC804",
    'versions.current': "\uD604\uC7AC",
    'versions.previous': "\uC774\uC804",
    'versions.description': "\uC124\uBA85",
    'versions.deploy_to_site.header': "\uC0AC\uC774\uD2B8\uC5D0 \uAC8C\uC2DC",
    'versions.deploy_to_site': "\uC0AC\uC774\uD2B8\uC5D0 \uAC8C\uC2DC",
    'versions.packages': "\uD328\uD0A4\uC9C0",
    'versions.branches': "\uD3EC\uD568\uB41C \uBE0C\uB79C\uCE58",
    'versions.branches.publish': "\uBE0C\uB79C\uCE58\uC5D0 \uAC8C\uC2DC",
    'versions.branches.empty': "\uC774 \uBC84\uC804\uC740 \uC5B4\uB5A4 \uBE0C\uB79C\uCE58\uC5D0\uB3C4 \uAC8C\uC2DC\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.",
    'versions.new_dialog.header': "\uC0C8 \uBC84\uC804",
    'versions.new_dialog.label_title': "\uBC84\uC804:",
    'versions.new_dialog.label_branch': "\uBE0C\uB79C\uCE58:",
    'versions.new_dialog.packages.header': "\uD328\uD0A4\uC9C0",
    'versions.new_dialog.packages.empty': "\uCD94\uAC00\uB41C \uD328\uD0A4\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'versions.new_dialog.packages.add': "\uD328\uD0A4\uC9C0 \uCD94\uAC00",
    'versions.new_dialog.packages.add_existing': "\uC774\uC804\uC5D0 \uC5C5\uB85C\uB4DC\uB41C \uD328\uD0A4\uC9C0 \uCD94\uAC00",
    'versions.new_dialog.packages.replace': "\uD328\uD0A4\uC9C0 \uAD50\uCCB4",
    'versions.new_dialog.packages.edit': "\uD328\uD0A4\uC9C0 \uD3B8\uC9D1",
    'versions.new_dialog.ok': "\uBC84\uC804 \uC0DD\uC131",
    'versions.manage': "\uBC84\uC804 \uAD00\uB9AC",
    'versions.rename': "\uBC84\uC804 \uC774\uB984 \uBCC0\uACBD",
    'versions.rename_dialog.header': "\uBC84\uC804 \uC774\uB984 \uBCC0\uACBD",
    'versions.rename_dialog.label': "\uBC84\uC804 \uC774\uB984:",
    'versions.rename_dialog.ok': "\uBC84\uC804 \uC774\uB984 \uBCC0\uACBD",
    'versions.edit_description': "\uBC84\uC804 \uC124\uBA85 \uC218\uC815",
    'versions.edit_description_dialog.header': "\uBC84\uC804 \uC124\uBA85 \uC218\uC815",
    'versions.edit_description_dialog.label': "\uBC84\uC804 \uC124\uBA85:",
    'versions.edit_description_dialog.ok': "\uC124\uBA85 \uC218\uC815",
    'versions.delete': "\uBC84\uC804 \uC0AD\uC81C",
    'versions.delete_dialog.header': "\uBC84\uC804 \uC0AD\uC81C",
    'versions.delete_dialog.message': (versionTitle)=>[
            "\uBC84\uC804 ",
            versionTitle,
            "\uC744(\uB97C) \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'versions.delete_dialog.ok': "\uBC84\uC804 \uC0AD\uC81C",
    'versions.publish_dialog.header': "\uBE0C\uB79C\uCE58\uC5D0 \uBC84\uC804 \uAC8C\uC2DC",
    'versions.publish_dialog.message': (versionTitle)=>[
            "\uBC84\uC804 ",
            versionTitle,
            "\uC744(\uB97C) \uAC8C\uC2DC\uD560 \uBE0C\uB79C\uCE58\uB97C \uC120\uD0DD\uD558\uC138\uC694."
        ],
    'versions.publish_dialog.no_branches': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uBE0C\uB79C\uCE58\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'versions.publish_dialog.ok': "\uBC84\uC804 \uAC8C\uC2DC",
    'versions.publish_existing_dialog.header': "\uBC84\uC804 \uB2E4\uC2DC \uAC8C\uC2DC",
    'versions.publish_existing_dialog.message': "\uCD5C\uADFC \uBC84\uC804:",
    'versions.publish_existing_dialog.no_versions': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uBC84\uC804\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'versions.publish_existing_dialog.ok': "\uBC84\uC804 \uAC8C\uC2DC",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': "\uD328\uD0A4\uC9C0",
    'packages.download_zip': "ZIP\uC73C\uB85C \uB2E4\uC6B4\uB85C\uB4DC",
    'packages.download_torrent': "\uD1A0\uB80C\uD2B8 \uB2E4\uC6B4\uB85C\uB4DC",
    'packages.total_size': (size)=>[
            "\uCD1D \uD06C\uAE30: ",
            size
        ],
    'packages.manage': "\uD328\uD0A4\uC9C0 \uAD00\uB9AC",
    'packages.rename': "\uD328\uD0A4\uC9C0 \uC774\uB984 \uBCC0\uACBD",
    'packages.rename_dialog.header': "\uD328\uD0A4\uC9C0 \uC774\uB984 \uBCC0\uACBD",
    'packages.rename_dialog.label': "\uD328\uD0A4\uC9C0 \uC774\uB984:",
    'packages.rename_dialog.ok': "\uD328\uD0A4\uC9C0 \uC774\uB984 \uBCC0\uACBD",
    'packages.edit_tags': "\uD328\uD0A4\uC9C0 \uD0DC\uADF8 \uC218\uC815",
    'packages.edit_tags_dialog.header': "\uD328\uD0A4\uC9C0 \uD0DC\uADF8 \uC218\uC815",
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "\uD328\uD0A4\uC9C0 ",
            packageTitle,
            "\uC758 \uD0DC\uADF8\uB97C \uC9C0\uC815\uD558\uC138\uC694:"
        ],
    'packages.edit_tags_dialog.ok': "\uD328\uD0A4\uC9C0 \uD0DC\uADF8 \uC124\uC815",
    'packages.entrypoint': (entrypoint)=>[
            "\uC2DC\uC791 \uD30C\uC77C: ",
            entrypoint
        ],
    'packages.entrypoint.empty': "\uC2DC\uC791 \uD30C\uC77C\uC774 \uC124\uC815\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.",
    'packages.delete': "\uD328\uD0A4\uC9C0 \uC0AD\uC81C",
    'packages.delete_dialog.header': "\uD328\uD0A4\uC9C0 \uC0AD\uC81C",
    'packages.delete_dialog.message': (packageTitle)=>[
            "\uD328\uD0A4\uC9C0 ",
            packageTitle,
            "\uC744(\uB97C) \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? \uC774 \uD328\uD0A4\uC9C0\uAC00 \uCD94\uAC00\uB41C \uBAA8\uB4E0 \uBC84\uC804\uC5D0\uC11C \uC0AD\uC81C\uB429\uB2C8\uB2E4."
        ],
    'packages.delete_dialog.ok': "\uD328\uD0A4\uC9C0 \uC0AD\uC81C",
    'packages.new_dialog.header': "\uC0C8 \uD328\uD0A4\uC9C0",
    'packages.new_dialog.label_title': "\uC81C\uBAA9:",
    'packages.new_dialog.title_placeholder': "(\uD0DC\uADF8\uC5D0\uC11C \uAC00\uC838\uC634)",
    'packages.new_dialog.tags.header': "\uD0DC\uADF8",
    'packages.new_dialog.files.header': "\uD30C\uC77C",
    'packages.new_dialog.total_size': (size, maximum)=>[
            "\uCD1D \uD06C\uAE30: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(\uCD5C\uB300 ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "\uC0C8 \uB370\uC774\uD130 \uD06C\uAE30: ",
            size
        ],
    'packages.new_dialog.checks.empty': "\uCD94\uAC00\uB41C \uD30C\uC77C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'packages.new_dialog.checks.entrypoint.empty': "\uC2DC\uC791 \uD30C\uC77C\uC774 \uC124\uC815\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "\uC2DC\uC791 \uD30C\uC77C ",
            entrypoint,
            "\uC774(\uAC00) \uC874\uC7AC\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uCD94\uAC00\uD558\uB294 \uAC83\uC744 \uC78A\uC73C\uC168\uB098\uC694? \uC874\uC7AC\uD558\uB294 \uC2DC\uC791 \uD30C\uC77C\uC744 \uC9C0\uC815\uD558\uAC70\uB098 \uC2DC\uC791 \uD30C\uC77C\uC744 \uC124\uC815\uD558\uC9C0 \uC54A\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "\uC2DC\uC791 \uD30C\uC77C \uC124\uC815 \uD574\uC81C",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "\uC2DC\uC791 \uD30C\uC77C\uC758 \uD655\uC7A5\uC790\uAC00 ",
            fileExt,
            "\uC785\uB2C8\uB2E4. ",
            tag,
            " \uD0DC\uADF8\uB97C \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            tag,
            " \uD0DC\uADF8 \uCD94\uAC00"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "\uC2DC\uC791 \uD30C\uC77C\uC758 \uD655\uC7A5\uC790\uAC00 ",
            fileExt,
            "\uC785\uB2C8\uB2E4. \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uD328\uD0A4\uC9C0\uB97C \uC2E4\uD589\uD560 \uC218 \uC788\uB3C4\uB85D ",
            tag,
            " \uD0DC\uADF8\uB97C \uCD94\uAC00\uD558\uC138\uC694."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "\uC2DC\uC791 \uD30C\uC77C\uC758 \uD655\uC7A5\uC790\uAC00 ",
            fileExt,
            "\uC785\uB2C8\uB2E4. \uC2E4\uC218\uC778\uAC00\uC694? \uBCF4\uD1B5 \uC2DC\uC791\uD560 \uC218 \uC788\uB294 \uD30C\uC77C \uD615\uC2DD\uC774 \uC544\uB2D9\uB2C8\uB2E4."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "\uC2DC\uC791 \uD30C\uC77C\uC758 \uD655\uC7A5\uC790\uAC00 ",
            fileExt,
            "\uC785\uB2C8\uB2E4. \uC544\uCE74\uC774\uBE0C \uD30C\uC77C\uB85C \uBB36\uB294 \uAC83\uBCF4\uB2E4 \uC2E4\uC81C \uCF58\uD150\uCE20 \uD30C\uC77C\uC744 \uD3EC\uD568\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "\uC2DC\uC791 \uD30C\uC77C\uC774 \uC2E4\uD589 \uAC00\uB2A5\uC73C\uB85C \uD45C\uC2DC\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.",
    'packages.new_dialog.checks.entrypoint.executable.action': "\uC2E4\uD589 \uAC00\uB2A5\uC73C\uB85C \uD45C\uC2DC",
    'packages.new_dialog.checks.single_root_dir': "\uB8E8\uD2B8\uC5D0 \uB2E8\uC77C \uB514\uB809\uD1A0\uB9AC\uB97C \uB450\uB294 \uAC83\uBCF4\uB2E4 \uD30C\uC77C\uC744 \uB8E8\uD2B8\uC5D0 \uC9C1\uC811 \uBC30\uCE58\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
    'packages.new_dialog.checks.single_root_dir.action': "\uD3F4\uB354\uB97C \uD574\uB2F9 \uB0B4\uC6A9\uBB3C\uB85C \uAD50\uCCB4",
    'packages.add_existing_dialog.header': "\uD328\uD0A4\uC9C0 \uCD94\uAC00",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `${$dcef16ee09b318f7$var$plural(packagesCount, `${packagesCount}\u{AC1C} \u{D328}\u{D0A4}\u{C9C0}`, `${packagesCount}\u{AC1C} \u{D328}\u{D0A4}\u{C9C0}`)} \u{CD94}\u{AC00}` : "\uC120\uD0DD\uB41C \uD328\uD0A4\uC9C0 \uC5C6\uC74C",
    'packages.add_existing_dialog.message': "\uCD5C\uADFC \uC5C5\uB85C\uB4DC\uB41C \uD328\uD0A4\uC9C0:",
    'packages.add_existing_dialog.no_packages': "\uCD5C\uADFC \uC5C5\uB85C\uB4DC\uB41C \uD328\uD0A4\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'packages.launch': "\uC2E4\uD589",
    'packages.install': "\uC124\uCE58",
    'packages.install_dialog.header': "\uC124\uCE58",
    'packages.install_dialog.workdir.label': "\uC791\uC5C5 \uB514\uB809\uD1A0\uB9AC:",
    'packages.install_dialog.workdir.value.new': "(\uC0C8\uB85C \uB9CC\uB4E4\uAE30)",
    'packages.install_dialog.workspace.label': "\uD3F4\uB354 \uC0DD\uC131 \uC704\uCE58:",
    'packages.install_dialog.workspace.placeholder': "(\uB8E8\uD2B8 \uD3F4\uB354 \uC120\uD0DD)",
    'packages.install_dialog.ok': "\uC124\uCE58",
    'packages.update': "\uC5C5\uB370\uC774\uD2B8",
    'packages.upload.status.existing': "\uC774\uC804 \uBC84\uC804\uC5D0\uC11C \uAC00\uC838\uC634",
    'packages.upload.status.queued': "\uB300\uAE30 \uC911",
    'packages.upload.status.packing': "\uD328\uD0B9 \uC911...",
    'packages.upload.status.creating': "\uC0DD\uC131 \uC911...",
    'packages.upload.status.create_retrying': "\uC0DD\uC131 \uC2E4\uD328, \uB300\uAE30 \uD6C4 \uC7AC\uC2DC\uB3C4 \uC911",
    'packages.upload.status.splitting': "\uBD84\uD560 \uC911...",
    'packages.upload.status.uploading': "\uC5C5\uB85C\uB4DC \uC911...",
    'packages.upload.status.finalizing': "\uC644\uB8CC \uC911...",
    'packages.upload.status.finalize_retrying': "\uC644\uB8CC \uC2E4\uD328, \uB300\uAE30 \uD6C4 \uC7AC\uC2DC\uB3C4 \uC911",
    'packages.upload.status.resolving': "\uD328\uCE58 \uD655\uC778 \uC911...",
    'packages.upload.status.resolve_retrying': "\uD328\uCE58 \uD655\uC778 \uC2E4\uD328, \uB300\uAE30 \uD6C4 \uC7AC\uC2DC\uB3C4 \uC911...",
    'packages.upload.status.done': "\uC5C5\uB85C\uB4DC \uC131\uACF5",
    'packages.upload.status.errored': "\uC624\uB958",
    'packages.upload.part.status.queued': "\uB300\uAE30 \uC911",
    'packages.upload.part.status.hashing': "\uD574\uC2F1 \uC911",
    'packages.upload.part.status.upload_queued': "\uC5C5\uB85C\uB4DC \uB300\uAE30 \uC911",
    'packages.upload.part.status.uploading': "\uC5C5\uB85C\uB4DC \uC911",
    'packages.upload.part.status.upload_retrying': "\uC624\uB958 \uBC1C\uC0DD, \uC5C5\uB85C\uB4DC \uC7AC\uC2DC\uB3C4 \uC911",
    'packages.upload.part.status.upload_finalizing': "\uC5C5\uB85C\uB4DC \uC644\uB8CC \uC911",
    'packages.upload.part.status.upload_errored': "\uC624\uB958",
    'packages.upload.part.status.done': "\uC5C5\uB85C\uB4DC\uB428",
    'packages.play': "\uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uD50C\uB808\uC774",
    'packages.play.reset': "\uCD08\uAE30\uD654",
    'packages.play.fullscreen': "\uC804\uCCB4 \uD654\uBA74",
    'deploy_sites.add_dialog.header': "\uBC30\uD3EC \uC0AC\uC774\uD2B8 \uCD94\uAC00",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "\uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85\uC744 \uC120\uD0DD\uD558\uACE0 \uC0AC\uC774\uD2B8 URL\uC744 \uC785\uB825\uD558\uC5EC ",
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uC758 \uBC30\uD3EC \uC0AC\uC774\uD2B8\uB85C \uC800\uC7A5\uD558\uC138\uC694."
        ],
    'deploy_sites.add_dialog.label_credential': "\uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85:",
    'deploy_sites.add_dialog.select_credential': "\uC790\uACA9 \uC99D\uBA85 \uC120\uD0DD",
    'deploy_sites.add_dialog.select_credential.new': "\uC0C8 \uC790\uACA9 \uC99D\uBA85 \uCD94\uAC00...",
    'deploy_sites.add_dialog.label_select_site': "\uC0AC\uC774\uD2B8 \uC120\uD0DD:",
    'deploy_sites.add_dialog.select_credential_first': "(\uC790\uACA9 \uC99D\uBA85\uC744 \uBA3C\uC800 \uC120\uD0DD\uD558\uC138\uC694)",
    'deploy_sites.add_dialog.select_site': "(\uC0AC\uC774\uD2B8 \uC120\uD0DD)",
    'deploy_sites.add_dialog.label_enter_site': "\uB610\uB294 \uC0AC\uC774\uD2B8 URL \uC785\uB825:",
    'deploy_sites.add_dialog.ok': "\uC0AC\uC774\uD2B8 \uCD94\uAC00",
    'deploy_to_site_dialog.header': "\uC0AC\uC774\uD2B8\uC5D0 \uAC8C\uC2DC",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            projectTitle,
            "\uC758 ",
            versionTitle,
            " \uBC84\uC804\uC744 \uAC8C\uC2DC\uD560 \uC0AC\uC774\uD2B8\uB97C \uC120\uD0DD\uD558\uC138\uC694."
        ],
    'deploy_to_site_dialog.label_site': "\uC0AC\uC774\uD2B8\uC5D0 \uAC8C\uC2DC:",
    'deploy_to_site_dialog.select_site': "\uC0AC\uC774\uD2B8 \uC120\uD0DD",
    'deploy_to_site_dialog.select_site.new': "\uC0C8 \uBC30\uD3EC \uC0AC\uC774\uD2B8 \uCD94\uAC00...",
    'deploy_to_site_dialog.packages.message.itch': [
        "\uD328\uD0A4\uC9C0\uB294 ",
        $dcef16ee09b318f7$var$_tmpl$4(),
        "\uB97C \uC0AC\uC6A9\uD558\uC5EC itch.io\uC5D0 \uAC8C\uC2DC\uB429\uB2C8\uB2E4. \uCC44\uB110 \uC774\uB984\uC740 \uD328\uD0A4\uC9C0 \uD0DC\uADF8\uC5D0\uC11C \uD30C\uC0DD\uB429\uB2C8\uB2E4."
    ],
    'deploy_to_site_dialog.deploy': "\uAC8C\uC2DC",
    'deploy_to_site_dialog.close': "\uB2EB\uAE30",
    'deploy_to_site_dialog.error.no_packages': "\uAC8C\uC2DC\uD560 \uD328\uD0A4\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "\uB2E8\uC77C \uCC44\uB110\uC5D0 \uC5EC\uB7EC \uD328\uD0A4\uC9C0\uB97C \uAC8C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uD604\uC7AC ",
            channel,
            " \uCC44\uB110\uC5D0 \uAC8C\uC2DC\uD558\uB3C4\uB85D \uC124\uC815\uB41C \uD328\uD0A4\uC9C0\uAC00 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$dcef16ee09b318f7$var$plural(packagesCount, [
                    packagesCountText,
                    "\uAC1C"
                ], [
                    packagesCountText,
                    "\uAC1C"
                ])),
            " \uC788\uC2B5\uB2C8\uB2E4."
        ],
    'deploy_to_site_dialog.job.queued': "\uB300\uAE30 \uC911",
    'deploy_to_site_dialog.job.downloading': "\uB2E4\uC6B4\uB85C\uB4DC \uC911...",
    'deploy_to_site_dialog.job.unpacking': "\uC555\uCD95 \uD574\uC81C \uC911...",
    'deploy_to_site_dialog.job.uploading': "\uAC8C\uC2DC \uC911...",
    'deploy_to_site_dialog.job.succeeded': "\uC131\uACF5",
    'deploy_to_site_dialog.job.errored': "\uC624\uB958",
    'store': "\uC2A4\uD1A0\uC5B4",
    'store.hint': "\uACF5\uAC1C \uD504\uB85C\uC81D\uD2B8",
    'store.project.hint': "\uC2A4\uD1A0\uC5B4 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0",
    'store.project.owner': "\uAC1C\uBC1C\uC790",
    'store.project.description': "\uC124\uBA85",
    'store.project.star': "\uC2A4\uD0C0 \uCD94\uAC00",
    'store.project.starred': "\uC2A4\uD0C0 \uD45C\uC2DC\uB428",
    'store.project.content': "\uCF58\uD150\uCE20",
    'store.project.content.warning': "\uC774 \uCF58\uD150\uCE20\uB294 \uC81C3\uC790 \uAC1C\uBC1C\uC790\uC5D0 \uC758\uD574 \uC81C\uACF5\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            branchTitle,
            " \uBE0C\uB79C\uCE58: \uBC84\uC804 ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "\uAC8C\uC2DC\uC77C: ",
            branchVersionPublished
        ],
    'me': "\uD504\uB85C\uD544",
    'me.hint': "\uD504\uB85C\uD544 \uC124\uC815 \uBC0F \uC5F0\uACB0\uB41C \uC790\uACA9 \uC99D\uBA85",
    'me.rename': "\uD504\uB85C\uD544 \uC774\uB984 \uBCC0\uACBD",
    'me.rename_dialog.header': "\uD504\uB85C\uD544 \uC774\uB984 \uBCC0\uACBD",
    'me.rename_dialog.label_title': "\uC774\uB984:",
    'me.rename_dialog.ok': "\uD504\uB85C\uD544 \uC774\uB984 \uBCC0\uACBD",
    'me.credentials': "\uC790\uACA9 \uC99D\uBA85",
    'me.credentials.hint.auth_allowed': "\uC774 \uC790\uACA9 \uC99D\uBA85 \uC911 \uD558\uB098\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC774 \uACC4\uC815\uC5D0 \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'me.credentials.hint.auth_disallowed': "\uC774 \uC790\uACA9 \uC99D\uBA85\uC740 \uACC4\uC815\uC5D0 \uC5F0\uACB0\uB418\uC5B4 \uC788\uC9C0\uB9CC \uB85C\uADF8\uC778\uC5D0 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'me.credentials.empty': "\uC790\uACA9 \uC99D\uBA85\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'me.credentials.empty.auth_allowed.warning': "\uACC4\uC815\uC774 \uC7A0\uAE38 \uC218 \uC788\uC2B5\uB2C8\uB2E4! \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uB294 \uC790\uACA9 \uC99D\uBA85\uC774 \uC5F0\uACB0\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uAC00\uB2A5\uD55C \uD55C \uBE68\uB9AC \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uB294 \uC790\uACA9 \uC99D\uBA85\uC744 \uC5F0\uACB0\uD574 \uC8FC\uC138\uC694.",
    'me.credentials.profile_picture.alt': (provider)=>`${$dcef16ee09b318f7$var$dict[`auth.provider.${provider}`]} \u{D504}\u{B85C}\u{D544} \u{C0AC}\u{C9C4}`,
    'me.credentials.created': (created)=>[
            "\uCD94\uAC00\uB428: ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\uCD5C\uADFC \uC0AC\uC6A9: ",
            lastUsed
        ],
    'me.credential.unlink': "\uC5F0\uACB0 \uD574\uC81C",
    'me.credential.allow_auth': "\uB85C\uADF8\uC778 \uD5C8\uC6A9",
    'me.credential.disallow_auth': "\uB85C\uADF8\uC778 \uBE44\uD5C8\uC6A9",
    'me.credential.display_publicly': "\uACF5\uAC1C \uD45C\uC2DC",
    'me.credential.dont_display_publicly': "\uACF5\uAC1C \uD45C\uC2DC \uC548 \uD568",
    'me.credential.link': "\uC790\uACA9 \uC99D\uBA85 \uC5F0\uACB0",
    'me.credential.link_dialog.header': "\uC790\uACA9 \uC99D\uBA85 \uC5F0\uACB0",
    'me.credential.link_dialog.message': "\uC5F0\uACB0\uD560 \uACC4\uC815 \uC81C\uACF5\uC790\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.",
    'me.credential.unlink_dialog.header': "\uC790\uACA9 \uC99D\uBA85 \uC5F0\uACB0 \uD574\uC81C",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "Kavykhi.Cloud \uACC4\uC815\uC5D0\uC11C ",
            credentialProvider,
            " \uACC4\uC815 ",
            credentialTitle,
            "\uC758 \uC5F0\uACB0\uC744 \uD574\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'me.credential.unlink_dialog.ok': "\uC790\uACA9 \uC99D\uBA85 \uC5F0\uACB0 \uD574\uC81C",
    'me.sessions': "\uC138\uC158",
    'me.sessions.hint': "\uD604\uC7AC \uBE0C\uB77C\uC6B0\uC800\uB97C \uD3EC\uD568\uD55C \uD65C\uC131 \uC138\uC158 \uBAA9\uB85D\uC785\uB2C8\uB2E4.",
    'me.sessions.started': (started)=>[
            "\uC2DC\uC791\uB428 ",
            (()=>{
                var _el$6 = $dcef16ee09b318f7$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "\uD65C\uB3D9 ",
            (()=>{
                var _el$7 = $dcef16ee09b318f7$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "\uD604\uC7AC \uC138\uC158",
    'me.sessions.empty': "\uC138\uC158\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'me.sessions.delete': "\uC885\uB8CC",
    'me.sessions.delete_dialog.header': "\uC138\uC158 \uC885\uB8CC",
    'me.sessions.delete_dialog.message': "\uC774 \uC138\uC158\uC744 \uC885\uB8CC\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    'me.sessions.delete_dialog.ok': "\uC138\uC158 \uC885\uB8CC",
    'me.api_tokens': "API \uD1A0\uD070",
    'me.api_tokens.hint': "\uC790\uB3D9\uD654\uC5D0 \uC0AC\uC6A9\uD560 API \uD1A0\uD070\uC744 \uC5EC\uAE30\uC5D0\uC11C \uC0DD\uC131\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'me.api_tokens.started': (started)=>[
            "\uC0DD\uC131\uB428 ",
            (()=>{
                var _el$8 = $dcef16ee09b318f7$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "\uB9CC\uB8CC\uC77C ",
            (()=>{
                var _el$9 = $dcef16ee09b318f7$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "\uB9CC\uB8CC \uC5C6\uC74C",
    'me.api_tokens.empty': "API \uD1A0\uD070\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'me.api_tokens.create': "API \uD1A0\uD070 \uC0DD\uC131",
    'me.api_tokens.create_dialog.header': "API \uD1A0\uD070 \uC0DD\uC131",
    'me.api_tokens.create_dialog.message': "\uC0DD\uC131\uB41C API \uD1A0\uD070:",
    'me.api_tokens.create_dialog.note': "\uD1A0\uD070\uC740 \uB2E4\uC2DC \uD45C\uC2DC\uB418\uC9C0 \uC54A\uC73C\uBBC0\uB85C \uC548\uC804\uD558\uAC8C \uC800\uC7A5\uD574 \uC8FC\uC138\uC694.",
    'me.api_tokens.delete': "\uC0AD\uC81C",
    'me.api_tokens.delete_dialog.header': "API \uD1A0\uD070 \uC0AD\uC81C",
    'me.api_tokens.delete_dialog.message': "\uC774 \uD1A0\uD070\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
    'me.api_tokens.delete_dialog.ok': "API \uD1A0\uD070 \uC0AD\uC81C",
    'me.deploy_credentials': "\uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85",
    'me.deploy_credentials.hint': "\uAC8C\uC2DC \uD50C\uB7AB\uD3FC\uC5D0 \uBC30\uD3EC\uD558\uAE30 \uC704\uD55C \uC790\uACA9 \uC99D\uBA85\uC744 \uC5EC\uAE30\uC5D0\uC11C \uCD94\uAC00\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'me.deploy_credentials.empty': "\uCD94\uAC00\uB41C \uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'me.deploy_credential.add': "\uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85 \uCD94\uAC00",
    'me.deploy_credential.add_dialog.header': "\uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85 \uCD94\uAC00",
    'me.deploy_credential.add_dialog.label_site': "\uC0AC\uC774\uD2B8:",
    'me.deploy_credential.add_dialog.label_title': "\uBA54\uBAA8:",
    'me.deploy_credential.add_dialog.label_key': "\uD0A4:",
    'me.deploy_credential.add_dialog.default_title': (date)=>`\u{D0A4} ${date}`,
    'me.deploy_credential.add_dialog.ok': "\uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85 \uCD94\uAC00",
    'me.deploy_credential.add_dialog.hint.itch': [
        "itch.io API \uD0A4\uB97C \uC0DD\uC131\uD558\uB824\uBA74 itch.io\uC758 ",
        $dcef16ee09b318f7$var$_tmpl$6(),
        "\uC73C\uB85C \uC774\uB3D9\uD558\uC138\uC694. \uC18C\uC2A4\uAC00 \"web\" \uB610\uB294 \"wharf\"\uC778 \uAE30\uC874 API \uD0A4\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC18C\uC2A4\uAC00 \"Kavykhi.Cloud\"\uC778 API \uD0A4\uB294 \uC791\uB3D9\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "\uD604\uC7AC ",
            credentialProvider,
            " \uC790\uACA9 \uC99D\uBA85 \uCD94\uAC00\uB294 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."
        ],
    'me.deploy_credential.delete': "\uC0AD\uC81C",
    'me.deploy_credential.delete_dialog.header': "\uBC30\uD3EC \uC790\uACA9 \uC99D\uBA85 \uC0AD\uC81C",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            credentialProvider,
            "\uC758 \uC790\uACA9 \uC99D\uBA85 ",
            credentialTitle,
            "\uC744(\uB97C) \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C? \uC774 \uC790\uACA9 \uC99D\uBA85\uC73C\uB85C \uAD6C\uC131\uB41C \uBAA8\uB4E0 \uBC30\uD3EC \uC0AC\uC774\uD2B8\uB3C4 \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C \uC81C\uAC70\uB429\uB2C8\uB2E4."
        ],
    'me.deploy_credential.delete_dialog.ok': "\uC790\uACA9 \uC99D\uBA85 \uC0AD\uC81C",
    'me.public_profile': "\uACF5\uAC1C \uD504\uB85C\uD544",
    'me.public_profile.public_credentials': "\uACF5\uAC1C \uC790\uACA9 \uC99D\uBA85",
    'me.public_profile.public_credentials.hint': "\uACF5\uAC1C\uB85C \uD45C\uC2DC\uD560 \uC790\uACA9 \uC99D\uBA85\uC744 \uC120\uD0DD\uD558\uC138\uC694.",
    'me.manage': "\uACC4\uC815 \uAD00\uB9AC",
    'me.delete': "\uACC4\uC815 \uC0AD\uC81C",
    'me.delete.dialog.header': "\uACC4\uC815 \uC0AD\uC81C",
    'me.delete.dialog.message': (userTitle)=>[
            "Kavykhi.Cloud \uACC4\uC815 ",
            userTitle,
            "\uC744(\uB97C) \uC601\uAD6C\uD788 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'me.delete.dialog.ok': "\uACC4\uC815 \uC0AD\uC81C",
    'invite': "\uCD08\uB300",
    'invite.hint': "\uD504\uB85C\uC81D\uD2B8 \uCD08\uB300",
    'invite.message.already_member': (projectTitle)=>[
            "\uC774\uBBF8 ",
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uC758 \uBA64\uBC84\uC785\uB2C8\uB2E4."
        ],
    'invite.message.join': (projectTitle)=>[
            projectTitle,
            " \uD504\uB85C\uC81D\uD2B8\uC5D0 \uCD08\uB300\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
        ],
    'invite.join': "\uD504\uB85C\uC81D\uD2B8 \uAC00\uC785",
    'local': "\uB85C\uCEEC \uCF58\uD150\uCE20",
    'local.hint': "\uB85C\uCEEC\uC5D0 \uC124\uCE58\uB41C \uCF58\uD150\uCE20",
    'local.workdirs': "\uC124\uCE58\uB41C \uD328\uD0A4\uC9C0",
    'local.workdirs.empty': "\uC124\uCE58\uB41C \uD328\uD0A4\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'local.workdir.action.launch': "\uC2E4\uD589",
    'local.workdir.action.repair': "\uBCF5\uAD6C",
    'local.workdir.action.delete': "\uC81C\uAC70",
    'local.workdir.delete_dialog.header': "\uD328\uD0A4\uC9C0 \uC81C\uAC70",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\uAE30\uAE30\uC5D0\uC11C ",
            packageTitle,
            " \uD328\uD0A4\uC9C0\uB97C \uC81C\uAC70\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
        ],
    'local.workdir.delete_dialog.ok': "\uC81C\uAC70",
    'local.workspaces': "\uB8E8\uD2B8 \uD3F4\uB354",
    'local.app_not_detected.message': "Kavykhi.Cloud \uB85C\uCEEC \uC571\uC774 \uAC10\uC9C0\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uC544\uB798 \uB9C1\uD06C \uC911 \uD558\uB098\uB97C \uC0AC\uC6A9\uD558\uC5EC \uB2E4\uC6B4\uB85C\uB4DC\uD558\uACE0 \uC124\uCE58\uD574 \uC8FC\uC138\uC694. \uC774\uBBF8 \uC124\uCE58\uD588\uB2E4\uBA74 \uC2E4\uD589 \uC911\uC778\uC9C0 \uD655\uC778\uD558\uC138\uC694.",
    'local_app.detected': "\uB85C\uCEEC \uCF58\uD150\uCE20",
    'error_dialog.header': "\uC624\uB958",
    'error_dialog.messageFunc': (e)=>`\u{C624}\u{B958}: ${$dcef16ee09b318f7$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': "\uD30C\uC77C \uC120\uD0DD",
    'upload_box.choose_directories': "\uD3F4\uB354 \uC120\uD0DD",
    'upload_box.add.progress_dialog.header': "\uD30C\uC77C \uCD94\uAC00 \uC911",
    'upload_box.add.progress_dialog.message': "\uD30C\uC77C \uCC98\uB9AC \uC911...",
    'upload_box.delete': (itemsCount)=>`${$dcef16ee09b318f7$var$plural(itemsCount, `${itemsCount}\u{AC1C} \u{D56D}\u{BAA9}`, `${itemsCount}\u{AC1C} \u{D56D}\u{BAA9}`)} \u{C0AD}\u{C81C}`,
    'upload_box.start_upload': "\uC5C5\uB85C\uB4DC \uC2DC\uC791",
    'upload_box.drop_area.message': "\uC5EC\uAE30\uC5D0 \uD30C\uC77C \uBC0F \uD3F4\uB354 \uB4DC\uB86D",
    'upload_box.drop_area.box_dropping_message': "\uB8E8\uD2B8\uC5D0 \uB123\uC73C\uB824\uBA74 \uC5EC\uAE30\uC5D0 \uB4DC\uB86D",
    'upload_box.entry.explode_folder': "\uD3F4\uB354\uB97C \uD574\uB2F9 \uB0B4\uC6A9\uBB3C\uB85C \uAD50\uCCB4",
    'upload_box.entry.set_entrypoint': "\uC2DC\uC791 \uD30C\uC77C\uB85C \uC124\uC815",
    'upload_box.entry.mark_executable': "\uC2E4\uD589 \uAC00\uB2A5\uC73C\uB85C \uD45C\uC2DC",
    'upload_box.entry.unmark_executable': "\uC2E4\uD589 \uAC00\uB2A5 \uD45C\uC2DC \uD574\uC81C",
    'upload_box.entry.remove': "\uC81C\uAC70",
    'package.tags.empty': "(\uD0DC\uADF8 \uC5C6\uC74C)",
    'package.tag.os': 'OS',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': "\uC544\uD0A4\uD14D\uCC98",
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': "\uBE44\uD2B8 \uC218",
    'package.tag.bits:64': "64\uBE44\uD2B8",
    'package.tag.bits:32': "32\uBE44\uD2B8",
    'package.tag.packaging': "\uD328\uD0A4\uC9D5",
    'package.tag.packaging:installer': "\uC124\uCE58 \uD504\uB85C\uADF8\uB7A8",
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': "\uAD6C\uC131 \uC694\uC18C",
    'package.tag.component:client': "\uD074\uB77C\uC774\uC5B8\uD2B8",
    'package.tag.component:server': "\uC11C\uBC84",
    'package.tag.runtime': "\uB7F0\uD0C0\uC784",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Linux \uBC30\uD3EC\uD310",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': "\uBB38\uC11C",
    'docs.page_no_language': "\uC774 \uC5B8\uC5B4\uB85C\uB294 \uC81C\uACF5\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
    'docs.page_no_language.message': "\uC774 \uBB38\uC11C\uC758 \uB2E4\uB978 \uC5B8\uC5B4 \uBC84\uC804:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "\uCF58\uD150\uCE20 \uC2E0\uACE0",
    'report_content.dialog.header': "\uCF58\uD150\uCE20 \uC2E0\uACE0",
    'report_content.dialog.link': "\uC774\uBA54\uC77C\uB85C \uC2E0\uACE0 \uBCF4\uB0B4\uAE30",
    'report_content.dialog.message': (email, link)=>[
            "\uC2E0\uACE0\uB97C \uBCF4\uB0B4\uB824\uBA74 \uB9C1\uD06C\uB97C \uD074\uB9AD\uD558\uC138\uC694:",
            $dcef16ee09b318f7$var$_tmpl$2(),
            $dcef16ee09b318f7$var$_tmpl$2(),
            link,
            $dcef16ee09b318f7$var$_tmpl$2(),
            $dcef16ee09b318f7$var$_tmpl$2(),
            "\uB610\uB294 ",
            email,
            "(\uC73C)\uB85C \uC9C1\uC811 \uC774\uBA54\uC77C\uC744 \uBCF4\uB0B4\uC8FC\uC138\uC694."
        ]
};
var $dcef16ee09b318f7$export$2e2bcd8739ae039 = $dcef16ee09b318f7$var$dict;
const $dcef16ee09b318f7$var$plural = (n, one, many)=>n == 1 ? one : many;



var $45d99de3dc341c2d$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>dozwolony`), $45d99de3dc341c2d$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $45d99de3dc341c2d$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>niedozwolony`), $45d99de3dc341c2d$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $45d99de3dc341c2d$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $45d99de3dc341c2d$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>ustawie\u{144} profilu`);
const $45d99de3dc341c2d$var$dict = {
    languageName: 'Polski',
    locale: 'pl',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: 'Motyw',
    'theme.light': 'Jasny',
    'theme.dark': 'Ciemny',
    'theme.system': 'Systemowy',
    'theme.sakura': 'Sakura',
    // generic
    email: 'E-mail',
    password: "Has\u0142o",
    ok: 'OK',
    cancel: 'Anuluj',
    retry: "Pon\xf3w",
    copy: 'Kopiuj',
    empty: "(brak element\xf3w)",
    loading: "\u0141adowanie...",
    calculating: 'Obliczanie...',
    error: "B\u0142\u0105d",
    'in_development': 'Ta strona jest w przygotowaniu.',
    // errors
    'error.not_found': 'nie znaleziono',
    'error.name_conflict': 'konflikt nazw',
    'error.bad_param': "b\u0142\u0119dny parametr",
    'error.wrong_auth': "b\u0142\u0119dna autoryzacja",
    'error.unauthorized': 'brak autoryzacji',
    'error.wrong_credentials': "b\u0142\u0119dne dane logowania",
    'error.wrong_provider': "b\u0142\u0119dny dostawca",
    'error.insufficient_privileges': "niewystarczaj\u0105ce uprawnienia",
    'error.not_empty': 'nie jest pusty',
    'error.limit_exceeded': 'przekroczono limit',
    'error.already_member': "ju\u017C jest cz\u0142onkiem",
    'error.not_finalized': 'nie sfinalizowano',
    'error.already_finalized': "ju\u017C sfinalizowano",
    'error.unexpected_patch': 'nieoczekiwana poprawka',
    'error.timeout': 'przekroczono limit czasu',
    'error.not_patch': "nie jest poprawk\u0105",
    'error.not_supported': "nieobs\u0142ugiwane",
    'error.unexpected_error': "nieoczekiwany b\u0142\u0105d",
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': 'Uwierzytelnianie',
    'auth.dialog.please_select': "Wybierz dostawc\u0119 konta, aby si\u0119 zalogowa\u0107.",
    'auth.dialog.redirecting_to': (provider)=>`Przekierowywanie do ${provider}...`,
    'auth.dialog.remember_me': "Zapami\u0119taj mnie",
    'auth.dialog.log_in': "Zaloguj si\u0119",
    'auth.dialog.back': 'Wstecz',
    'auth.dialog.progress_header': 'Uwierzytelnianie...',
    'auth.dialog.error.header': "B\u0142\u0105d uwierzytelniania",
    'auth.dialog.error.auth_not_allowed': "U\u017Cycie tych danych logowania do uwierzytelniania zosta\u0142o zablokowane przez u\u017Cytkownika. U\u017Cyj innych danych.",
    'auth.dialog.error.unknown': "Nieprawid\u0142owe parametry uwierzytelniania. Spr\xf3buj ponownie.",
    'auth.dialog.error.back': "Wr\xf3\u0107",
    'user.profile': 'Profil',
    'user.logout': "Wyloguj si\u0119",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': 'Nie znaleziono strony',
    'page_not_found.message': 'Ta strona nie istnieje.',
    'page_not_found.message2': "C\xf3\u017C, w pewnym sensie istnieje, ale nic tu nie ma. Oto mo\u017Cliwe przyczyny.",
    'page_not_found.items': [
        "Co\u015B tu wcze\u015Bniej by\u0142o, ale zosta\u0142o usuni\u0119te.",
        "Co\u015B tu nadal jest, ale nie masz do tego dost\u0119pu.",
        "Albo kto\u015B po prostu pomyli\u0142 si\u0119 przy kopiowaniu i wklejaniu linku."
    ],
    'home': "G\u0142\xf3wna",
    'home.header.hint': "Narz\u0119dzia chmurowe dla tw\xf3rc\xf3w indie",
    'home.description': "Kavykhi.Cloud to platforma programistyczna dla gier indie. Wspieramy gry do pobrania i przegl\u0105darkowe, wersje prywatne i publiczne, ga\u0142\u0119zie, zespo\u0142y i wiele wi\u0119cej.",
    'home.auth': "Zaloguj si\u0119 lub zarejestruj",
    'home.auth.hint': "Utw\xf3rz nowe konto lub zaloguj si\u0119 na istniej\u0105ce",
    'projects': 'Projekty',
    'projects.hint': "Projekty, nad kt\xf3rymi pracujesz",
    'projects.project': (project)=>`Projekt: ${project}`,
    'projects.project.hint': 'projekt',
    'projects.no_projects': "Nie masz jeszcze \u017Cadnych projekt\xf3w.",
    'projects.new': "Utw\xf3rz projekt",
    'projects.new_dialog.header': 'Nowy projekt',
    'projects.new_dialog.label': 'Nazwa projektu',
    'projects.new_dialog.ok': "Utw\xf3rz projekt",
    'projects.store_page': 'Publiczna strona sklepu',
    'projects.description': 'Opis',
    'projects.branches': "Ga\u0142\u0119zie",
    'projects.versions': 'Wersje',
    'projects.packages': 'Pakiety',
    'projects.management': 'Ustawienia projektu',
    'projects.management.breadcrumb': 'Ustawienia',
    'projects.management.title': (projectTitle)=>`${projectTitle} - ustawienia`,
    'projects.management.hint': 'ustawienia projektu',
    'projects.management.users': "Cz\u0142onkowie zespo\u0142u",
    'projects.management.users.empty': "Brak cz\u0142onk\xf3w zespo\u0142u.",
    'projects.management.users.role.tester': 'Tester',
    'projects.management.users.role.developer': 'Deweloper',
    'projects.management.users.role.admin': 'Administrator',
    'projects.management.users.role.owner': "W\u0142a\u015Bciciel",
    'projects.management.users.role.starred': "Wyr\xf3\u017Cniony",
    'projects.management.users.exile': "Usu\u0144 z zespo\u0142u",
    'projects.management.users.exile.dialog.header': "Usu\u0144 z zespo\u0142u",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "Czy na pewno chcesz usun\u0105\u0107 u\u017Cytkownika ",
            userTitle,
            " z projektu ",
            projectTitle,
            "?"
        ],
    'projects.management.users.exile.dialog.ok': "Usu\u0144 z zespo\u0142u",
    'projects.management.invites.one_time_invite': 'Jednorazowy link zaproszenia',
    'projects.management.invites.one_time_invite.header': 'Jednorazowy link zaproszenia',
    'projects.management.invites.one_time_invite.message': 'Jednorazowy link zaproszenia:',
    'projects.management.invites.one_time_invite.note': "Wa\u017Cny przez 24 godziny, mo\u017Ce by\u0107 u\u017Cyty raz.",
    'projects.management.invites.new_dialog.header': 'Link zaproszenia',
    'projects.management.invites.new_dialog.expires': 'Wygasa za:',
    'projects.management.invites.new_dialog.expires.indefinite': '(brak wygasania)',
    'projects.management.invites.new_dialog.approval.label': "U\u017Cytkownik do\u0142\u0105cza do projektu:",
    'projects.management.invites.new_dialog.approval.not_approved': 'po zatwierdzeniu przez admina',
    'projects.management.invites.new_dialog.approval.approved': 'natychmiast',
    'projects.management.invites.new_dialog.seats': "Limit do\u0142\u0105cze\u0144:",
    'projects.management.invites.new_dialog.seats.no_limit': '(bez limitu)',
    'projects.management.invites.new_dialog.ok': "Utw\xf3rz link zaproszenia",
    'projects.management.deploy_sites': "Witryny wdro\u017Ceniowe",
    'projects.management.deploy_sites.empty': "Nie dodano witryn wdro\u017Ceniowych.",
    'projects.management.deploy_sites.add': "Dodaj witryn\u0119 wdro\u017Ceniow\u0105",
    'projects.management.deploy_sites.delete': "Usu\u0144",
    'projects.management.deploy_sites.delete_dialog.header': "Usu\u0144 witryn\u0119 wdro\u017Ceniow\u0105",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "Czy na pewno chcesz usun\u0105\u0107 witryn\u0119 wdro\u017Ceniow\u0105 ",
            provider,
            " ",
            site,
            "?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "Usu\u0144 witryn\u0119 wdro\u017Ceniow\u0105",
    'projects.management.public_access': "Dost\u0119p publiczny",
    'projects.management.public_access.enable': "W\u0142\u0105cz dost\u0119p publiczny",
    'projects.management.public_access.enabled': [
        "Dost\u0119p publiczny: ",
        $45d99de3dc341c2d$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "Nazwa i opis projektu s\u0105 publiczne, podobnie jak wszelkie ga\u0142\u0119zie oznaczone jako publiczne.",
    'projects.management.public_access.enable_dialog.header': "W\u0142\u0105cz dost\u0119p publiczny",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "Czy na pewno chcesz zezwoli\u0107 na publiczny dost\u0119p do projektu ",
            projectTitle,
            "?",
            $45d99de3dc341c2d$var$_tmpl$2(),
            $45d99de3dc341c2d$var$_tmpl$2(),
            "Spowoduje to, \u017Ce podstawowe informacje o projekcie b\u0119d\u0105 dost\u0119pne bez uwierzytelniania. Musisz osobno w\u0142\u0105czy\u0107 dost\u0119p publiczny dla ka\u017Cdej ga\u0142\u0119zi, kt\xF3r\u0105 chcesz upubliczni\u0107."
        ],
    'projects.management.public_access.enable_dialog.ok': "W\u0142\u0105cz dost\u0119p publiczny",
    'projects.management.public_access.disable': "Wy\u0142\u0105cz dost\u0119p publiczny",
    'projects.management.public_access.disabled': [
        "Dost\u0119p publiczny: ",
        $45d99de3dc341c2d$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "Projekt jest prywatny. Tylko cz\u0142onkowie zespo\u0142u projektu maj\u0105 do niego dost\u0119p.",
    'projects.management.public_access.disable_dialog.header': "Wy\u0142\u0105cz dost\u0119p publiczny",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "Czy na pewno chcesz wy\u0142\u0105czy\u0107 publiczny dost\u0119p do projektu ",
            projectTitle,
            "?"
        ],
    'projects.management.public_access.disable_dialog.ok': "Wy\u0142\u0105cz dost\u0119p publiczny",
    'projects.management.public_access.branches': "Publiczne ga\u0142\u0119zie",
    'projects.management.manage': "Zarz\u0105dzaj projektem",
    'projects.rename': "Zmie\u0144 nazw\u0119 projektu",
    'projects.rename_dialog.header': "Zmie\u0144 nazw\u0119 projektu",
    'projects.rename_dialog.label': 'Nazwa projektu:',
    'projects.rename_dialog.ok': "Zmie\u0144 nazw\u0119",
    'projects.edit_description': 'Edytuj opis projektu',
    'projects.edit_description_dialog.header': 'Edytuj opis projektu',
    'projects.edit_description_dialog.label': 'Opis projektu:',
    'projects.edit_description_dialog.ok': 'Zapisz opis',
    'projects.leave': "Opu\u015B\u0107 projekt",
    'projects.leave_dialog.header': "Opu\u015B\u0107 projekt",
    'projects.leave_dialog.message': (projectTitle)=>[
            "Czy na pewno chcesz opu\u015Bci\u0107 projekt ",
            projectTitle,
            "?"
        ],
    'projects.leave_dialog.ok': "Opu\u015B\u0107 projekt",
    'projects.delete': "Usu\u0144 projekt",
    'projects.delete_dialog.header': "Usu\u0144 projekt",
    'projects.delete_dialog.message': (projectTitle)=>[
            "Czy na pewno chcesz usun\u0105\u0107 projekt ",
            projectTitle,
            "?"
        ],
    'projects.delete_dialog.ok': "Usu\u0144 projekt",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "ga\u0142\u0105\u017A",
    'branches.no_branches': "Projekt nie ma jeszcze \u017Cadnych ga\u0142\u0119zi",
    'branches.new': "Utw\xf3rz ga\u0142\u0105\u017A",
    'branches.new_dialog.header': "Nowa ga\u0142\u0105\u017A",
    'branches.new_dialog.label': "Nazwa ga\u0142\u0119zi",
    'branches.new_dialog.ok': "Utw\xf3rz ga\u0142\u0105\u017A",
    'branches.current_version': (version)=>[
            "Aktualna wersja: ",
            version
        ],
    'branches.current_version.packages': 'Pakiety aktualnej wersji',
    'branches.no_current_version': 'Brak aktualnej wersji',
    'branches.publish_version.new': "Opublikuj now\u0105 wersj\u0119",
    'branches.publish_version.existing': "Opublikuj istniej\u0105c\u0105 wersj\u0119",
    'branches.version_history': 'Historia wersji',
    'branches.version_history.empty': "Historia wersji tej ga\u0142\u0119zi jest pusta.",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "Aktualna wersja ga\u0142\u0119zi jest przechowywana ",
            quotaTime != null ? [
                "przez ",
                quotaTime
            ] : "bezterminowo",
            ". Poprzednie wersje s\u0105 przechowywane maksymalnie przez ",
            quotaNonCurrentTime,
            ". \u0141\u0105cznie w ga\u0142\u0119zi przechowywanych jest nie wi\u0119cej ni\u017C ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$45d99de3dc341c2d$var$plural(quotaCount, [
                    quotaCountText,
                    " wersja"
                ], [
                    quotaCountText,
                    " wersji"
                ])),
            "."
        ],
    'branches.manage': "Zarz\u0105dzaj ga\u0142\u0119zi\u0105",
    'branches.rename': "Zmie\u0144 nazw\u0119 ga\u0142\u0119zi",
    'branches.rename_dialog.header': "Zmie\u0144 nazw\u0119 ga\u0142\u0119zi",
    'branches.rename_dialog.label': "Nazwa ga\u0142\u0119zi:",
    'branches.rename_dialog.ok': "Zmie\u0144 nazw\u0119",
    'branches.delete': "Usu\u0144 ga\u0142\u0105\u017A",
    'branches.delete_dialog.header': "Usu\u0144 ga\u0142\u0105\u017A",
    'branches.delete_dialog.message': (branchTitle)=>[
            "Czy na pewno chcesz usun\u0105\u0107 ga\u0142\u0105\u017A ",
            branchTitle,
            "?"
        ],
    'branches.delete_dialog.ok': "Usu\u0144 ga\u0142\u0105\u017A",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': 'wersja',
    'versions.current': 'Aktualna',
    'versions.previous': 'Poprzednia',
    'versions.description': 'Opis',
    'versions.deploy_to_site.header': 'Publikuj w witrynie',
    'versions.deploy_to_site': 'Publikuj w witrynie',
    'versions.packages': 'Pakiety',
    'versions.branches': "W ga\u0142\u0119ziach",
    'versions.branches.publish': "Opublikuj w ga\u0142\u0119zi",
    'versions.branches.empty': "Ta wersja nie zosta\u0142a opublikowana w \u017Cadnej ga\u0142\u0119zi.",
    'versions.new_dialog.header': 'Nowa wersja',
    'versions.new_dialog.label_title': 'Wersja:',
    'versions.new_dialog.label_branch': "Ga\u0142\u0105\u017A:",
    'versions.new_dialog.packages.header': 'Pakiety',
    'versions.new_dialog.packages.empty': "Nie dodano pakiet\xf3w.",
    'versions.new_dialog.packages.add': 'Dodaj pakiet',
    'versions.new_dialog.packages.add_existing': "Dodaj wcze\u015Bniej przes\u0142any pakiet",
    'versions.new_dialog.packages.replace': "Zast\u0105p pakiet",
    'versions.new_dialog.packages.edit': 'Edytuj pakiet',
    'versions.new_dialog.ok': "Utw\xf3rz wersj\u0119",
    'versions.manage': "Zarz\u0105dzaj wersj\u0105",
    'versions.rename': "Zmie\u0144 nazw\u0119 wersji",
    'versions.rename_dialog.header': "Zmie\u0144 nazw\u0119 wersji",
    'versions.rename_dialog.label': 'Nazwa wersji:',
    'versions.rename_dialog.ok': "Zmie\u0144 nazw\u0119",
    'versions.edit_description': 'Edytuj opis wersji',
    'versions.edit_description_dialog.header': 'Edytuj opis wersji',
    'versions.edit_description_dialog.label': 'Opis wersji:',
    'versions.edit_description_dialog.ok': 'Zapisz opis',
    'versions.delete': "Usu\u0144 wersj\u0119",
    'versions.delete_dialog.header': "Usu\u0144 wersj\u0119",
    'versions.delete_dialog.message': (versionTitle)=>[
            "Czy na pewno chcesz usun\u0105\u0107 wersj\u0119 ",
            versionTitle,
            "?"
        ],
    'versions.delete_dialog.ok': "Usu\u0144 wersj\u0119",
    'versions.publish_dialog.header': "Opublikuj wersj\u0119 w ga\u0142\u0119zi",
    'versions.publish_dialog.message': (versionTitle)=>[
            "Wybierz ga\u0142\u0105\u017A, w kt\xF3rej chcesz opublikowa\u0107 wersj\u0119 ",
            versionTitle,
            "."
        ],
    'versions.publish_dialog.no_branches': "Brak ga\u0142\u0119zi w projekcie.",
    'versions.publish_dialog.ok': "Opublikuj wersj\u0119",
    'versions.publish_existing_dialog.header': "Opublikuj wersj\u0119 ponownie",
    'versions.publish_existing_dialog.message': 'Ostatnie wersje:',
    'versions.publish_existing_dialog.no_versions': 'Brak wersji w projekcie.',
    'versions.publish_existing_dialog.ok': "Opublikuj wersj\u0119",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': 'Pakiet',
    'packages.download_zip': 'Pobierz jako ZIP',
    'packages.download_torrent': 'Pobierz torrent',
    'packages.total_size': (size)=>[
            "Ca\u0142kowity rozmiar: ",
            size
        ],
    'packages.manage': "Zarz\u0105dzaj pakietem",
    'packages.rename': "Zmie\u0144 nazw\u0119 pakietu",
    'packages.rename_dialog.header': "Zmie\u0144 nazw\u0119 pakietu",
    'packages.rename_dialog.label': 'Nazwa pakietu:',
    'packages.rename_dialog.ok': "Zmie\u0144 nazw\u0119",
    'packages.edit_tags': 'Edytuj tagi pakietu',
    'packages.edit_tags_dialog.header': 'Edytuj tagi pakietu',
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "Okre\u015Bl tagi pakietu ",
            packageTitle,
            ":"
        ],
    'packages.edit_tags_dialog.ok': 'Zapisz tagi',
    'packages.entrypoint': (entrypoint)=>[
            "Plik startowy: ",
            entrypoint
        ],
    'packages.entrypoint.empty': 'Plik startowy nie jest ustawiony.',
    'packages.delete': "Usu\u0144 pakiet",
    'packages.delete_dialog.header': "Usu\u0144 pakiet",
    'packages.delete_dialog.message': (packageTitle)=>[
            "Czy na pewno chcesz usun\u0105\u0107 pakiet ",
            packageTitle,
            "? Pakiet zostanie usuni\u0119ty ze wszystkich wersji, do kt\xF3rych zosta\u0142 dodany."
        ],
    'packages.delete_dialog.ok': "Usu\u0144 pakiet",
    'packages.new_dialog.header': 'Nowy pakiet',
    'packages.new_dialog.label_title': "Tytu\u0142:",
    'packages.new_dialog.title_placeholder': "(z tag\xf3w)",
    'packages.new_dialog.tags.header': 'Tagi',
    'packages.new_dialog.files.header': 'Pliki',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Ca\u0142kowity rozmiar: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(maksymalnie ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "Rozmiar nowych danych: ",
            size
        ],
    'packages.new_dialog.checks.empty': "Nie dodano plik\xf3w.",
    'packages.new_dialog.checks.entrypoint.empty': 'Plik startowy nie jest ustawiony.',
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "Plik startowy ",
            entrypoint,
            " nie istnieje; by\u0107 mo\u017Ce zapomnia\u0142e\u015B go doda\u0107? Podaj istniej\u0105cy plik startowy lub nie ustawiaj go wcale."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "Usu\u0144 plik startowy",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "Plik startowy ma rozszerzenie ",
            fileExt,
            ": sugerowany tag ",
            tag,
            "."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "Dodaj tag ",
            tag
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "Plik startowy ma rozszerzenie ",
            fileExt,
            ": dodaj tag ",
            tag,
            ", aby pakiet by\u0142 grywalny w przegl\u0105darce."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "Plik startowy ma rozszerzenie ",
            fileExt,
            ": czy to pomy\u0142ka? Zwykle nie jest to typ pliku, kt\xF3ry mo\u017Cna uruchomi\u0107."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "Plik startowy ma rozszerzenie ",
            fileExt,
            ": zaleca si\u0119 do\u0142\u0105czenie rzeczywistych plik\xF3w zawarto\u015Bci zamiast pakowania ich do archiwum."
        ],
    'packages.new_dialog.checks.entrypoint.executable': 'Plik startowy nie jest oznaczony jako wykonywalny',
    'packages.new_dialog.checks.entrypoint.executable.action': 'Oznacz jako wykonywalny',
    'packages.new_dialog.checks.single_root_dir': "Zaleca si\u0119 umieszczanie plik\xf3w bezpo\u015Brednio w katalogu g\u0142\xf3wnym, zamiast jednego podfolderu.",
    'packages.new_dialog.checks.single_root_dir.action': "Zast\u0105p folder jego zawarto\u015Bci\u0105",
    'packages.add_existing_dialog.header': 'Dodaj pakiet',
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `Dodaj ${$45d99de3dc341c2d$var$plural(packagesCount, `${packagesCount} pakiet`, `${packagesCount} pakiety`)}` : "Nie wybrano pakiet\xf3w",
    'packages.add_existing_dialog.message': "Ostatnio przes\u0142ane pakiety:",
    'packages.add_existing_dialog.no_packages': "Brak ostatnio przes\u0142anych pakiet\xf3w.",
    'packages.launch': 'Uruchom',
    'packages.install': 'Instaluj',
    'packages.install_dialog.header': 'Instaluj',
    'packages.install_dialog.workdir.label': 'Katalog roboczy:',
    'packages.install_dialog.workdir.value.new': "(utw\xf3rz nowy)",
    'packages.install_dialog.workspace.label': "Utw\xf3rz folder w:",
    'packages.install_dialog.workspace.placeholder': "(wybierz folder g\u0142\xf3wny)",
    'packages.install_dialog.ok': 'Instaluj',
    'packages.update': 'Aktualizuj',
    'packages.upload.status.existing': 'Z poprzedniej wersji',
    'packages.upload.status.queued': 'W kolejce',
    'packages.upload.status.packing': 'Pakowanie...',
    'packages.upload.status.creating': 'Tworzenie...',
    'packages.upload.status.create_retrying': "Tworzenie nie powiod\u0142o si\u0119, oczekiwanie i ponawianie",
    'packages.upload.status.splitting': 'Dzielenie...',
    'packages.upload.status.uploading': "Przesy\u0142anie...",
    'packages.upload.status.finalizing': 'Finalizowanie...',
    'packages.upload.status.finalize_retrying': "Finalizowanie nie powiod\u0142o si\u0119, oczekiwanie i ponawianie",
    'packages.upload.status.resolving': "Rozwi\u0105zywanie poprawki...",
    'packages.upload.status.resolve_retrying': "Rozwi\u0105zywanie poprawki nie powiod\u0142o si\u0119, oczekiwanie...",
    'packages.upload.status.done': "Przes\u0142ano pomy\u015Blnie",
    'packages.upload.status.errored': "B\u0142\u0105d",
    'packages.upload.part.status.queued': 'W kolejce',
    'packages.upload.part.status.hashing': 'Haszowanie',
    'packages.upload.part.status.upload_queued': "Przesy\u0142anie w kolejce",
    'packages.upload.part.status.uploading': "Przesy\u0142anie",
    'packages.upload.part.status.upload_retrying': "B\u0142\u0105d, ponawianie przesy\u0142ania",
    'packages.upload.part.status.upload_finalizing': "Finalizowanie przesy\u0142ania",
    'packages.upload.part.status.upload_errored': "B\u0142\u0105d",
    'packages.upload.part.status.done': "Przes\u0142ano",
    'packages.play': "Graj w przegl\u0105darce",
    'packages.play.reset': 'Resetuj',
    'packages.play.fullscreen': "Pe\u0142ny ekran",
    'deploy_sites.add_dialog.header': "Dodaj witryn\u0119 wdro\u017Ceniow\u0105",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "Wybierz dane uwierzytelniaj\u0105ce wdro\u017Cenia i wprowad\u017A adres URL witryny, aby zapisa\u0107 je jako witryn\u0119 wdro\u017Ceniow\u0105 dla projektu ",
            projectTitle,
            "."
        ],
    'deploy_sites.add_dialog.label_credential': "Dane wdro\u017Ceniowe:",
    'deploy_sites.add_dialog.select_credential': "Wybierz dane uwierzytelniaj\u0105ce",
    'deploy_sites.add_dialog.select_credential.new': 'Dodaj nowe dane...',
    'deploy_sites.add_dialog.label_select_site': "Wybierz witryn\u0119:",
    'deploy_sites.add_dialog.select_credential_first': '(najpierw wybierz dane)',
    'deploy_sites.add_dialog.select_site': "(wybierz witryn\u0119)",
    'deploy_sites.add_dialog.label_enter_site': 'Lub wpisz URL witryny:',
    'deploy_sites.add_dialog.ok': "Dodaj witryn\u0119",
    'deploy_to_site_dialog.header': 'Publikuj w witrynie',
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "Wybierz witryn\u0119, w kt\xF3rej chcesz opublikowa\u0107 wersj\u0119 ",
            versionTitle,
            " projektu ",
            projectTitle,
            "."
        ],
    'deploy_to_site_dialog.label_site': 'Publikuj w witrynie:',
    'deploy_to_site_dialog.select_site': "Wybierz witryn\u0119",
    'deploy_to_site_dialog.select_site.new': "Dodaj now\u0105 witryn\u0119...",
    'deploy_to_site_dialog.packages.message.itch': [
        "Pakiety zostan\u0105 opublikowane na itch.io przy u\u017Cyciu narz\u0119dzia ",
        $45d99de3dc341c2d$var$_tmpl$4(),
        ". Nazwy kana\u0142\xF3w pochodz\u0105 z tag\xF3w pakiet\xF3w."
    ],
    'deploy_to_site_dialog.deploy': 'Publikuj',
    'deploy_to_site_dialog.close': 'Zamknij',
    'deploy_to_site_dialog.error.no_packages': "Brak pakiet\xf3w do opublikowania.",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "Nie mo\u017Cna opublikowa\u0107 wielu pakiet\xF3w w jednym kanale. Obecnie ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$45d99de3dc341c2d$var$plural(packagesCount, [
                    packagesCountText,
                    " pakiet jest"
                ], [
                    packagesCountText,
                    " pakiety s\u0105"
                ])),
            " ustawione do publikacji w kanale ",
            channel,
            "."
        ],
    'deploy_to_site_dialog.job.queued': 'W kolejce',
    'deploy_to_site_dialog.job.downloading': 'Pobieranie...',
    'deploy_to_site_dialog.job.unpacking': 'Rozpakowywanie...',
    'deploy_to_site_dialog.job.uploading': 'Publikowanie...',
    'deploy_to_site_dialog.job.succeeded': 'Sukces',
    'deploy_to_site_dialog.job.errored': "B\u0142\u0105d",
    'store': 'Sklep',
    'store.hint': 'Projekty publiczne',
    'store.project.hint': 'Strona projektu w sklepie',
    'store.project.owner': 'Deweloper',
    'store.project.description': 'Opis',
    'store.project.star': "Dodaj gwiazdk\u0119",
    'store.project.starred': "Z gwiazdk\u0105",
    'store.project.content': "Zawarto\u015B\u0107",
    'store.project.content.warning': "Zawarto\u015B\u0107 zosta\u0142a dostarczona przez zewn\u0119trznego dewelopera.",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            "Ga\u0142\u0105\u017A ",
            branchTitle,
            ": wersja ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "Opublikowano: ",
            branchVersionPublished
        ],
    'me': 'Profil',
    'me.hint': "Ustawienia profilu i po\u0142\u0105czone dane uwierzytelniaj\u0105ce",
    'me.rename': "Zmie\u0144 nazw\u0119 profilu",
    'me.rename_dialog.header': "Zmie\u0144 nazw\u0119 profilu",
    'me.rename_dialog.label_title': 'Nazwa:',
    'me.rename_dialog.ok': "Zmie\u0144 nazw\u0119",
    'me.credentials': "Dane uwierzytelniaj\u0105ce",
    'me.credentials.hint.auth_allowed': "Dowolne z tych danych mog\u0105 by\u0107 u\u017Cyte do zalogowania si\u0119 na to konto.",
    'me.credentials.hint.auth_disallowed': "Te dane s\u0105 powi\u0105zane z Twoim kontem, ale nie mo\u017Cna ich u\u017Cy\u0107 do logowania.",
    'me.credentials.empty': "Brak danych uwierzytelniaj\u0105cych.",
    'me.credentials.empty.auth_allowed.warning': "Mo\u017Cesz straci\u0107 dost\u0119p do konta! Nie masz powi\u0105zanych \u017Cadnych danych do logowania. Jak najszybciej powi\u0105\u017C dane, kt\xf3rymi mo\u017Cesz si\u0119 zalogowa\u0107.",
    'me.credentials.profile_picture.alt': (provider)=>`Zdj\u{119}cie profilowe ${$45d99de3dc341c2d$var$dict[`auth.provider.${provider}`]}`,
    'me.credentials.created': (created)=>[
            "dodano ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "ostatnio u\u017Cyto ",
            lastUsed
        ],
    'me.credential.unlink': "Od\u0142\u0105cz",
    'me.credential.allow_auth': "Zezw\xf3l na logowanie",
    'me.credential.disallow_auth': 'Zablokuj logowanie',
    'me.credential.display_publicly': "Wy\u015Bwietlaj publicznie",
    'me.credential.dont_display_publicly': "Nie wy\u015Bwietlaj publicznie",
    'me.credential.link': "Powi\u0105\u017C dane",
    'me.credential.link_dialog.header': "Powi\u0105\u017C dane uwierzytelniaj\u0105ce",
    'me.credential.link_dialog.message': "Wybierz dostawc\u0119 konta do powi\u0105zania.",
    'me.credential.unlink_dialog.header': "Od\u0142\u0105cz dane uwierzytelniaj\u0105ce",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "Czy na pewno chcesz od\u0142\u0105czy\u0107 konto ",
            credentialProvider,
            " (",
            credentialTitle,
            ") od swojego konta Kavykhi.Cloud?"
        ],
    'me.credential.unlink_dialog.ok': "Od\u0142\u0105cz dane",
    'me.sessions': 'Sesje',
    'me.sessions.hint': "To jest lista Twoich aktywnych sesji, w tym obecnej przegl\u0105darki.",
    'me.sessions.started': (started)=>[
            "rozpocz\u0119to ",
            (()=>{
                var _el$6 = $45d99de3dc341c2d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "aktywno\u015B\u0107 ",
            (()=>{
                var _el$7 = $45d99de3dc341c2d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "Bie\u017C\u0105ca sesja",
    'me.sessions.empty': 'Brak sesji.',
    'me.sessions.delete': "Zako\u0144cz",
    'me.sessions.delete_dialog.header': "Zako\u0144cz sesj\u0119",
    'me.sessions.delete_dialog.message': "Czy na pewno chcesz zako\u0144czy\u0107 t\u0119 sesj\u0119?",
    'me.sessions.delete_dialog.ok': "Zako\u0144cz sesj\u0119",
    'me.api_tokens': 'Tokeny API',
    'me.api_tokens.hint': "Tutaj mo\u017Cesz wygenerowa\u0107 tokeny API do automatyzacji.",
    'me.api_tokens.started': (started)=>[
            "utworzono ",
            (()=>{
                var _el$8 = $45d99de3dc341c2d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "wygasa ",
            (()=>{
                var _el$9 = $45d99de3dc341c2d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': 'brak wygasania',
    'me.api_tokens.empty': "Brak token\xf3w API.",
    'me.api_tokens.create': 'Generuj token API',
    'me.api_tokens.create_dialog.header': 'Generuj token API',
    'me.api_tokens.create_dialog.message': 'Wygenerowany token API:',
    'me.api_tokens.create_dialog.note': 'Token nie zostanie pokazany ponownie, zapisz go w bezpiecznym miejscu.',
    'me.api_tokens.delete': "Usu\u0144",
    'me.api_tokens.delete_dialog.header': "Usu\u0144 token API",
    'me.api_tokens.delete_dialog.message': "Czy na pewno chcesz usun\u0105\u0107 ten token?",
    'me.api_tokens.delete_dialog.ok': "Usu\u0144 token API",
    'me.deploy_credentials': "Dane wdro\u017Ceniowe",
    'me.deploy_credentials.hint': "Tutaj mo\u017Cesz doda\u0107 dane uwierzytelniaj\u0105ce do platform wydawniczych.",
    'me.deploy_credentials.empty': "Nie dodano danych wdro\u017Ceniowych.",
    'me.deploy_credential.add': "Dodaj dane wdro\u017Ceniowe",
    'me.deploy_credential.add_dialog.header': "Dodaj dane wdro\u017Ceniowe",
    'me.deploy_credential.add_dialog.label_site': 'Witryna:',
    'me.deploy_credential.add_dialog.label_title': 'Notatka:',
    'me.deploy_credential.add_dialog.label_key': 'Klucz:',
    'me.deploy_credential.add_dialog.default_title': (date)=>`Klucz ${date}`,
    'me.deploy_credential.add_dialog.ok': 'Dodaj dane',
    'me.deploy_credential.add_dialog.hint.itch': [
        "Aby wygenerowa\u0107 klucz API itch.io, przejd\u017A do ",
        $45d99de3dc341c2d$var$_tmpl$6(),
        " na itch.io. Mo\u017Cesz u\u017Cy\u0107 istniej\u0105cego klucza ze \u017Ar\xF3d\u0142em \u201Eweb\u201D lub \u201Ewharf\u201D. Klucz ze \u017Ar\xF3d\u0142em \u201EKavykhi.Cloud\u201D nie zadzia\u0142a."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "Obecnie nie obs\u0142ugujemy dodawania danych dla ",
            credentialProvider,
            "."
        ],
    'me.deploy_credential.delete': "Usu\u0144",
    'me.deploy_credential.delete_dialog.header': "Usu\u0144 dane wdro\u017Ceniowe",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "Czy na pewno chcesz usun\u0105\u0107 dane ",
            credentialTitle,
            " dla ",
            credentialProvider,
            "? Wszystkie witryny wdro\u017Ceniowe skonfigurowane z tymi danymi zostan\u0105 r\xF3wnie\u017C usuni\u0119te z projektu."
        ],
    'me.deploy_credential.delete_dialog.ok': "Usu\u0144 dane",
    'me.public_profile': 'Profil publiczny',
    'me.public_profile.public_credentials': 'Dane publiczne',
    'me.public_profile.public_credentials.hint': "Wybierz dane uwierzytelniaj\u0105ce do wy\u015Bwietlania publicznego.",
    'me.manage': "Zarz\u0105dzaj kontem",
    'me.delete': "Usu\u0144 konto",
    'me.delete.dialog.header': "Usu\u0144 konto",
    'me.delete.dialog.message': (userTitle)=>[
            "Czy na pewno chcesz bezpowrotnie usun\u0105\u0107 swoje konto Kavykhi.Cloud ",
            userTitle,
            "?"
        ],
    'me.delete.dialog.ok': "Usu\u0144 konto",
    'invite': 'Zaproszenie',
    'invite.hint': 'Zaproszenie do projektu',
    'invite.message.already_member': (projectTitle)=>[
            "Jeste\u015B ju\u017C cz\u0142onkiem projektu ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "Zosta\u0142e\u015B zaproszony do projektu ",
            projectTitle,
            "."
        ],
    'invite.join': "Do\u0142\u0105cz do projektu",
    'local': "Lokalna zawarto\u015B\u0107",
    'local.hint': "Lokalnie zainstalowana zawarto\u015B\u0107",
    'local.workdirs': 'Zainstalowane pakiety',
    'local.workdirs.empty': "Brak zainstalowanych pakiet\xf3w.",
    'local.workdir.action.launch': 'Uruchom',
    'local.workdir.action.repair': 'Napraw',
    'local.workdir.action.delete': 'Odinstaluj',
    'local.workdir.delete_dialog.header': 'Odinstaluj pakiet',
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "Czy na pewno chcesz odinstalowa\u0107 pakiet ",
            packageTitle,
            " ze swojego urz\u0105dzenia?"
        ],
    'local.workdir.delete_dialog.ok': 'Odinstaluj',
    'local.workspaces': "Foldery g\u0142\xf3wne",
    'local.app_not_detected.message': "Nie wykryto lokalnej aplikacji Kavykhi.Cloud. Pobierz j\u0105 i zainstaluj, korzystaj\u0105c z jednego z poni\u017Cszych link\xf3w. Je\u015Bli jest ju\u017C zainstalowana, upewnij si\u0119, \u017Ce dzia\u0142a.",
    'local_app.detected': "Lokalna zawarto\u015B\u0107",
    'error_dialog.header': "B\u0142\u0105d",
    'error_dialog.messageFunc': (e)=>`B\u{142}\u{105}d: ${$45d99de3dc341c2d$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': 'Wybierz pliki',
    'upload_box.choose_directories': 'Wybierz foldery',
    'upload_box.add.progress_dialog.header': "Dodawanie plik\xf3w",
    'upload_box.add.progress_dialog.message': "Przetwarzanie plik\xf3w...",
    'upload_box.delete': (itemsCount)=>`Usu\u{144} ${$45d99de3dc341c2d$var$plural(itemsCount, `${itemsCount} element`, `${itemsCount} elementy`)}`,
    'upload_box.start_upload': "Rozpocznij przesy\u0142anie",
    'upload_box.drop_area.message': "Przeci\u0105gnij pliki i foldery tutaj",
    'upload_box.drop_area.box_dropping_message': "Upu\u015B\u0107 tutaj, aby umie\u015Bci\u0107 w katalogu g\u0142\xf3wnym",
    'upload_box.entry.explode_folder': "Zast\u0105p folder jego zawarto\u015Bci\u0105",
    'upload_box.entry.set_entrypoint': 'Ustaw plik startowy',
    'upload_box.entry.mark_executable': 'Oznacz jako wykonywalny',
    'upload_box.entry.unmark_executable': 'Cofnij ozn. wykonywalnego',
    'upload_box.entry.remove': "Usu\u0144",
    'package.tags.empty': "(brak tag\xf3w)",
    'package.tag.os': 'System',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Architektura',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': 'Bity',
    'package.tag.bits:64': '64-bit',
    'package.tag.bits:32': '32-bit',
    'package.tag.packaging': 'Pakowanie',
    'package.tag.packaging:installer': 'Instalator',
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': 'Komponent',
    'package.tag.component:client': 'Klient',
    'package.tag.component:server': 'Serwer',
    'package.tag.runtime': "\u015Arodowisko",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': 'Dystrybucja Linux',
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Dokumentacja',
    'docs.page_no_language': "Niedost\u0119pne w tym j\u0119zyku",
    'docs.page_no_language.message': "Inne wersje j\u0119zykowe tego dokumentu:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "Zg\u0142o\u015B zawarto\u015B\u0107",
    'report_content.dialog.header': "Zg\u0142o\u015B zawarto\u015B\u0107",
    'report_content.dialog.link': "Wy\u015Blij zg\u0142oszenie e-mailem",
    'report_content.dialog.message': (email, link)=>[
            "Kliknij link, aby wys\u0142a\u0107 zg\u0142oszenie:",
            $45d99de3dc341c2d$var$_tmpl$2(),
            $45d99de3dc341c2d$var$_tmpl$2(),
            link,
            $45d99de3dc341c2d$var$_tmpl$2(),
            $45d99de3dc341c2d$var$_tmpl$2(),
            "Lub napisz do nas r\u0119cznie na adres ",
            email
        ]
};
var $45d99de3dc341c2d$export$2e2bcd8739ae039 = $45d99de3dc341c2d$var$dict;
const $45d99de3dc341c2d$var$plural = (n, one, many)=>n == 1 ? one : many;



var $73cc5fdf88b88e2e$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>permitido`), $73cc5fdf88b88e2e$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $73cc5fdf88b88e2e$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>n\xe3o permitido`), $73cc5fdf88b88e2e$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $73cc5fdf88b88e2e$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $73cc5fdf88b88e2e$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>configura\xe7\xf5es do seu perfil`);
const $73cc5fdf88b88e2e$var$dict = {
    languageName: "Portugu\xeas",
    locale: 'pt',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: 'Tema',
    'theme.light': 'Claro',
    'theme.dark': 'Escuro',
    'theme.system': 'Sistema',
    'theme.sakura': 'Sakura',
    // generic
    email: 'E-mail',
    password: 'Senha',
    ok: 'OK',
    cancel: 'Cancelar',
    retry: 'Tentar novamente',
    copy: 'Copiar',
    empty: '(sem itens)',
    loading: 'Carregando...',
    calculating: 'Calculando...',
    error: 'Erro',
    'in_development': "Esta p\xe1gina est\xe1 em desenvolvimento.",
    // errors
    'error.not_found': "n\xe3o encontrado",
    'error.name_conflict': 'conflito de nome',
    'error.bad_param': "par\xe2metro inv\xe1lido",
    'error.wrong_auth': "autentica\xe7\xe3o incorreta",
    'error.unauthorized': "n\xe3o autorizado",
    'error.wrong_credentials': 'credenciais incorretas',
    'error.wrong_provider': 'provedor incorreto',
    'error.insufficient_privileges': "privil\xe9gios insuficientes",
    'error.not_empty': "n\xe3o est\xe1 vazio",
    'error.limit_exceeded': 'limite excedido',
    'error.already_member': "j\xe1 \xe9 membro",
    'error.not_finalized': "n\xe3o finalizado",
    'error.already_finalized': "j\xe1 finalizado",
    'error.unexpected_patch': 'patch inesperado',
    'error.timeout': 'tempo limite esgotado',
    'error.not_patch': "n\xe3o \xe9 um patch",
    'error.not_supported': "n\xe3o suportado",
    'error.unexpected_error': 'erro inesperado',
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "Autentica\xe7\xe3o",
    'auth.dialog.please_select': 'Selecione seu provedor de conta para entrar.',
    'auth.dialog.redirecting_to': (provider)=>`Redirecionando para ${provider}...`,
    'auth.dialog.remember_me': 'Lembrar de mim',
    'auth.dialog.log_in': 'Entrar',
    'auth.dialog.back': 'Voltar',
    'auth.dialog.progress_header': "Autentica\xe7\xe3o...",
    'auth.dialog.error.header': "Erro de autentica\xe7\xe3o",
    'auth.dialog.error.auth_not_allowed': "Esta credencial foi proibida pelo usu\xe1rio para autentica\xe7\xe3o. Use outra credencial.",
    'auth.dialog.error.unknown': "Par\xe2metros de autentica\xe7\xe3o inv\xe1lidos. Tente novamente.",
    'auth.dialog.error.back': 'Voltar',
    'user.profile': 'Perfil',
    'user.logout': 'Sair',
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "P\xe1gina n\xe3o encontrada",
    'page_not_found.message': "Esta p\xe1gina n\xe3o existe.",
    'page_not_found.message2': "Bem, na verdade ela existe, mas n\xe3o h\xe1 nada aqui. Aqui est\xe3o as possibilidades.",
    'page_not_found.items': [
        "Algo estava aqui antes, mas foi exclu\xeddo.",
        "Algo ainda est\xe1 aqui, mas voc\xea n\xe3o tem acesso.",
        "Ou algu\xe9m simplesmente n\xe3o teve cuidado ao copiar e colar o link."
    ],
    'home': "In\xedcio",
    'home.header.hint': 'Ferramentas em nuvem para desenvolvedores indie',
    'home.description': "Kavykhi.Cloud \xe9 uma plataforma de desenvolvimento para jogos indie. Suportamos jogos para download e navegador, builds privadas e p\xfablicas, ramos (branches), equipes e muito mais.",
    'home.auth': 'Entrar ou cadastrar-se',
    'home.auth.hint': 'Criar nova conta ou entrar em uma existente',
    'projects': 'Projetos',
    'projects.hint': "Os projetos em que voc\xea est\xe1 trabalhando",
    'projects.project': (project)=>`Projeto: ${project}`,
    'projects.project.hint': 'projeto',
    'projects.no_projects': "Voc\xea ainda n\xe3o tem projetos.",
    'projects.new': 'Criar projeto',
    'projects.new_dialog.header': 'Novo projeto',
    'projects.new_dialog.label': 'Nome do projeto',
    'projects.new_dialog.ok': 'Criar projeto',
    'projects.store_page': "P\xe1gina p\xfablica da loja",
    'projects.description': "Descri\xe7\xe3o",
    'projects.branches': 'Ramos',
    'projects.versions': "Vers\xf5es",
    'projects.packages': 'Pacotes',
    'projects.management': "Configura\xe7\xf5es do projeto",
    'projects.management.breadcrumb': "Configura\xe7\xf5es",
    'projects.management.title': (projectTitle)=>`${projectTitle} - configura\xe7\xf5es`,
    'projects.management.hint': "configura\xe7\xf5es do projeto",
    'projects.management.users': 'Membros da equipe',
    'projects.management.users.empty': 'Nenhum membro na equipe.',
    'projects.management.users.role.tester': 'Tester',
    'projects.management.users.role.developer': 'Desenvolvedor',
    'projects.management.users.role.admin': 'Administrador',
    'projects.management.users.role.owner': 'Dono',
    'projects.management.users.role.starred': 'Favoritado',
    'projects.management.users.exile': 'Remover da equipe',
    'projects.management.users.exile.dialog.header': 'Remover da equipe',
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "Tem certeza de que deseja remover ",
            userTitle,
            " do projeto ",
            projectTitle,
            "?"
        ],
    'projects.management.users.exile.dialog.ok': 'Remover da equipe',
    'projects.management.invites.one_time_invite': "Link de convite de uso \xfanico",
    'projects.management.invites.one_time_invite.header': "Link de convite de uso \xfanico",
    'projects.management.invites.one_time_invite.message': "Link de convite de uso \xfanico:",
    'projects.management.invites.one_time_invite.note': "V\xe1lido por 24 horas, pode ser usado uma vez.",
    'projects.management.invites.new_dialog.header': 'Link de convite',
    'projects.management.invites.new_dialog.expires': 'Expira em:',
    'projects.management.invites.new_dialog.expires.indefinite': "(sem expira\xe7\xe3o)",
    'projects.management.invites.new_dialog.approval.label': "Usu\xe1rio entra no projeto:",
    'projects.management.invites.new_dialog.approval.not_approved': "ap\xf3s aprova\xe7\xe3o do admin",
    'projects.management.invites.new_dialog.approval.approved': 'imediatamente',
    'projects.management.invites.new_dialog.seats': 'Limite de entradas:',
    'projects.management.invites.new_dialog.seats.no_limit': '(sem limite)',
    'projects.management.invites.new_dialog.ok': 'Criar link de convite',
    'projects.management.deploy_sites': 'Sites de deploy',
    'projects.management.deploy_sites.empty': 'Nenhum site de deploy adicionado.',
    'projects.management.deploy_sites.add': 'Adicionar site de deploy',
    'projects.management.deploy_sites.delete': 'Excluir',
    'projects.management.deploy_sites.delete_dialog.header': 'Excluir site de deploy',
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "Tem certeza de que deseja excluir o site de deploy ",
            provider,
            " ",
            site,
            "?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': 'Excluir site de deploy',
    'projects.management.public_access': "Acesso p\xfablico",
    'projects.management.public_access.enable': "Ativar acesso p\xfablico",
    'projects.management.public_access.enabled': [
        "Acesso p\xFAblico: ",
        $73cc5fdf88b88e2e$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "O nome e a descri\xe7\xe3o do projeto s\xe3o p\xfablicos, assim como quaisquer ramos marcados como p\xfablicos.",
    'projects.management.public_access.enable_dialog.header': "Ativar acesso p\xfablico",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja permitir o acesso p\xFAblico ao projeto ",
            projectTitle,
            "?",
            $73cc5fdf88b88e2e$var$_tmpl$2(),
            $73cc5fdf88b88e2e$var$_tmpl$2(),
            "Isso tornar\xE1 as informa\xE7\xF5es b\xE1sicas do projeto dispon\xEDveis sem autentica\xE7\xE3o. Voc\xEA precisar\xE1 ativar o acesso p\xFAblico separadamente para cada ramo que deseja tornar p\xFAblico."
        ],
    'projects.management.public_access.enable_dialog.ok': "Ativar acesso p\xfablico",
    'projects.management.public_access.disable': "Desativar acesso p\xfablico",
    'projects.management.public_access.disabled': [
        "Acesso p\xFAblico: ",
        $73cc5fdf88b88e2e$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "O projeto \xe9 privado. Apenas membros da equipe do projeto podem acess\xe1-lo.",
    'projects.management.public_access.disable_dialog.header': "Desativar acesso p\xfablico",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja desativar todo o acesso p\xFAblico ao projeto ",
            projectTitle,
            "?"
        ],
    'projects.management.public_access.disable_dialog.ok': "Desativar acesso p\xfablico",
    'projects.management.public_access.branches': "Ramos p\xfablicos",
    'projects.management.manage': 'Gerenciar projeto',
    'projects.rename': 'Renomear projeto',
    'projects.rename_dialog.header': 'Renomear projeto',
    'projects.rename_dialog.label': 'Nome do projeto:',
    'projects.rename_dialog.ok': 'Renomear projeto',
    'projects.edit_description': "Editar descri\xe7\xe3o do projeto",
    'projects.edit_description_dialog.header': "Editar descri\xe7\xe3o do projeto",
    'projects.edit_description_dialog.label': "Descri\xe7\xe3o do projeto:",
    'projects.edit_description_dialog.ok': "Editar descri\xe7\xe3o",
    'projects.leave': 'Sair do projeto',
    'projects.leave_dialog.header': 'Sair do projeto',
    'projects.leave_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja sair do projeto ",
            projectTitle,
            "?"
        ],
    'projects.leave_dialog.ok': 'Sair do projeto',
    'projects.delete': 'Excluir projeto',
    'projects.delete_dialog.header': 'Excluir projeto',
    'projects.delete_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja excluir o projeto ",
            projectTitle,
            "?"
        ],
    'projects.delete_dialog.ok': 'Excluir projeto',
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': 'ramo',
    'branches.no_branches': "O projeto ainda n\xe3o possui ramos",
    'branches.new': 'Criar ramo',
    'branches.new_dialog.header': 'Novo ramo',
    'branches.new_dialog.label': 'Nome do ramo',
    'branches.new_dialog.ok': 'Criar ramo',
    'branches.current_version': (version)=>[
            "Vers\xE3o atual: ",
            version
        ],
    'branches.current_version.packages': "Pacotes da vers\xe3o atual",
    'branches.no_current_version': "Sem vers\xe3o atual",
    'branches.publish_version.new': "Publicar nova vers\xe3o",
    'branches.publish_version.existing': "Republicar vers\xe3o existente",
    'branches.version_history': "Hist\xf3rico de vers\xf5es",
    'branches.version_history.empty': "O hist\xf3rico de vers\xf5es do ramo est\xe1 vazio.",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "A vers\xE3o atual do ramo \xE9 mantida ",
            quotaTime != null ? [
                "por ",
                quotaTime
            ] : "indefinidamente",
            ". Vers\xF5es anteriores s\xE3o mantidas por no m\xE1ximo ",
            quotaNonCurrentTime,
            ". No m\xE1ximo ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$73cc5fdf88b88e2e$var$plural(quotaCount, [
                    quotaCountText,
                    " vers\xE3o"
                ], [
                    quotaCountText,
                    " vers\xF5es"
                ])),
            " no total s\xE3o mantidas por ramo."
        ],
    'branches.manage': 'Gerenciar ramo',
    'branches.rename': 'Renomear ramo',
    'branches.rename_dialog.header': 'Renomear ramo',
    'branches.rename_dialog.label': 'Nome do ramo:',
    'branches.rename_dialog.ok': 'Renomear ramo',
    'branches.delete': 'Excluir ramo',
    'branches.delete_dialog.header': 'Excluir ramo',
    'branches.delete_dialog.message': (branchTitle)=>[
            "Tem certeza de que deseja excluir o ramo ",
            branchTitle,
            "?"
        ],
    'branches.delete_dialog.ok': 'Excluir ramo',
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "vers\xe3o",
    'versions.current': 'Atual',
    'versions.previous': 'Anterior',
    'versions.description': "Descri\xe7\xe3o",
    'versions.deploy_to_site.header': 'Publicar no site',
    'versions.deploy_to_site': 'Publicar no site',
    'versions.packages': 'Pacotes',
    'versions.branches': 'Nos ramos',
    'versions.branches.publish': 'Publicar no ramo',
    'versions.branches.empty': "A vers\xe3o n\xe3o foi publicada em nenhum ramo.",
    'versions.new_dialog.header': "Nova vers\xe3o",
    'versions.new_dialog.label_title': "Vers\xe3o:",
    'versions.new_dialog.label_branch': 'Ramo:',
    'versions.new_dialog.packages.header': 'Pacotes',
    'versions.new_dialog.packages.empty': 'Nenhum pacote adicionado.',
    'versions.new_dialog.packages.add': 'Adicionar pacote',
    'versions.new_dialog.packages.add_existing': 'Adicionar pacote enviado anteriormente',
    'versions.new_dialog.packages.replace': 'Substituir pacote',
    'versions.new_dialog.packages.edit': 'Editar pacote',
    'versions.new_dialog.ok': "Criar vers\xe3o",
    'versions.manage': "Gerenciar vers\xe3o",
    'versions.rename': "Renomear vers\xe3o",
    'versions.rename_dialog.header': "Renomear vers\xe3o",
    'versions.rename_dialog.label': "Nome da vers\xe3o:",
    'versions.rename_dialog.ok': "Renomear vers\xe3o",
    'versions.edit_description': "Editar descri\xe7\xe3o da vers\xe3o",
    'versions.edit_description_dialog.header': "Editar descri\xe7\xe3o da vers\xe3o",
    'versions.edit_description_dialog.label': "Descri\xe7\xe3o da vers\xe3o:",
    'versions.edit_description_dialog.ok': "Editar descri\xe7\xe3o",
    'versions.delete': "Excluir vers\xe3o",
    'versions.delete_dialog.header': "Excluir vers\xe3o",
    'versions.delete_dialog.message': (versionTitle)=>[
            "Tem certeza de que deseja excluir a vers\xE3o ",
            versionTitle,
            "?"
        ],
    'versions.delete_dialog.ok': "Excluir vers\xe3o",
    'versions.publish_dialog.header': "Publicar vers\xe3o em um ramo",
    'versions.publish_dialog.message': (versionTitle)=>[
            "Escolha o ramo para publicar a vers\xE3o ",
            versionTitle,
            "."
        ],
    'versions.publish_dialog.no_branches': 'Nenhum ramo no projeto.',
    'versions.publish_dialog.ok': "Publicar vers\xe3o",
    'versions.publish_existing_dialog.header': "Republicar vers\xe3o",
    'versions.publish_existing_dialog.message': "\xdaltimas vers\xf5es:",
    'versions.publish_existing_dialog.no_versions': "Nenhuma vers\xe3o no projeto.",
    'versions.publish_existing_dialog.ok': "Publicar vers\xe3o",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': 'Pacote',
    'packages.download_zip': 'Baixar como ZIP',
    'packages.download_torrent': 'Baixar torrent',
    'packages.total_size': (size)=>[
            "Tamanho total: ",
            size
        ],
    'packages.manage': 'Gerenciar pacote',
    'packages.rename': 'Renomear pacote',
    'packages.rename_dialog.header': 'Renomear pacote',
    'packages.rename_dialog.label': 'Nome do pacote:',
    'packages.rename_dialog.ok': 'Renomear pacote',
    'packages.edit_tags': 'Editar tags do pacote',
    'packages.edit_tags_dialog.header': 'Editar tags do pacote',
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "Especifique as tags do pacote ",
            packageTitle,
            ":"
        ],
    'packages.edit_tags_dialog.ok': 'Definir tags do pacote',
    'packages.entrypoint': (entrypoint)=>[
            "Arquivo inicial: ",
            entrypoint
        ],
    'packages.entrypoint.empty': "Arquivo inicial n\xe3o definido.",
    'packages.delete': 'Excluir pacote',
    'packages.delete_dialog.header': 'Excluir pacote',
    'packages.delete_dialog.message': (packageTitle)=>[
            "Tem certeza de que deseja excluir o pacote ",
            packageTitle,
            "? O pacote ser\xE1 exclu\xEDdo de todas as vers\xF5es em que foi adicionado."
        ],
    'packages.delete_dialog.ok': 'Excluir pacote',
    'packages.new_dialog.header': 'Novo pacote',
    'packages.new_dialog.label_title': "T\xedtulo:",
    'packages.new_dialog.title_placeholder': '(a partir das tags)',
    'packages.new_dialog.tags.header': 'Tags',
    'packages.new_dialog.files.header': 'Arquivos',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Tamanho total: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(m\xE1ximo ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "Tamanho dos novos dados: ",
            size
        ],
    'packages.new_dialog.checks.empty': 'Nenhum arquivo adicionado.',
    'packages.new_dialog.checks.entrypoint.empty': "Arquivo inicial n\xe3o definido.",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "O arquivo inicial ",
            entrypoint,
            " n\xE3o existe; talvez voc\xEA tenha esquecido de adicion\xE1-lo? Especifique um arquivo inicial existente ou deixe em branco."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': 'Remover arquivo inicial',
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "O arquivo inicial tem a extens\xE3o ",
            fileExt,
            ": sugerindo a tag ",
            tag,
            "."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "Adicionar tag ",
            tag
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "O arquivo inicial tem a extens\xE3o ",
            fileExt,
            ": adicione a tag ",
            tag,
            " para tornar o pacote jog\xE1vel no navegador."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "O arquivo inicial tem a extens\xE3o ",
            fileExt,
            ": isso \xE9 um erro? Geralmente n\xE3o \xE9 um tipo de arquivo que pode ser iniciado."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "O arquivo inicial tem a extens\xE3o ",
            fileExt,
            ": \xE9 recomendado incluir os arquivos de conte\xFAdo reais em vez de compact\xE1-los em um arquivo de arquivo."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "O arquivo inicial n\xe3o est\xe1 marcado como execut\xe1vel",
    'packages.new_dialog.checks.entrypoint.executable.action': "Marcar como execut\xe1vel",
    'packages.new_dialog.checks.single_root_dir': "Recomenda-se colocar os arquivos diretamente na raiz, em vez de ter uma \xfanica pasta na raiz.",
    'packages.new_dialog.checks.single_root_dir.action': "Substituir pasta pelo seu conte\xfado",
    'packages.add_existing_dialog.header': 'Adicionar pacote',
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `Adicionar ${$73cc5fdf88b88e2e$var$plural(packagesCount, `${packagesCount} pacote`, `${packagesCount} pacotes`)}` : 'Nenhum pacote selecionado',
    'packages.add_existing_dialog.message': "\xdaltimos pacotes enviados:",
    'packages.add_existing_dialog.no_packages': 'Nenhum pacote enviado recentemente.',
    'packages.launch': 'Iniciar',
    'packages.install': 'Instalar',
    'packages.install_dialog.header': 'Instalar',
    'packages.install_dialog.workdir.label': "Diret\xf3rio de trabalho:",
    'packages.install_dialog.workdir.value.new': '(criar novo)',
    'packages.install_dialog.workspace.label': 'Criar pasta em:',
    'packages.install_dialog.workspace.placeholder': '(selecionar pasta raiz)',
    'packages.install_dialog.ok': 'Instalar',
    'packages.update': 'Atualizar',
    'packages.upload.status.existing': "Da vers\xe3o anterior",
    'packages.upload.status.queued': 'Na fila',
    'packages.upload.status.packing': 'Compactando...',
    'packages.upload.status.creating': 'Criando...',
    'packages.upload.status.create_retrying': 'Falha ao criar, aguardando e tentando novamente',
    'packages.upload.status.splitting': 'Dividindo...',
    'packages.upload.status.uploading': 'Enviando...',
    'packages.upload.status.finalizing': 'Finalizando...',
    'packages.upload.status.finalize_retrying': 'Falha ao finalizar, aguardando e tentando novamente',
    'packages.upload.status.resolving': 'Resolvendo patch...',
    'packages.upload.status.resolve_retrying': 'Falha ao resolver patch, aguardando e tentando novamente...',
    'packages.upload.status.done': 'Enviado com sucesso',
    'packages.upload.status.errored': 'Erro',
    'packages.upload.part.status.queued': 'Na fila',
    'packages.upload.part.status.hashing': 'Calculando hash',
    'packages.upload.part.status.upload_queued': 'Envio na fila',
    'packages.upload.part.status.uploading': 'Enviando',
    'packages.upload.part.status.upload_retrying': 'Erro, tentando enviar novamente',
    'packages.upload.part.status.upload_finalizing': 'Finalizando envio',
    'packages.upload.part.status.upload_errored': 'Erro',
    'packages.upload.part.status.done': 'Enviado',
    'packages.play': 'Jogar no navegador',
    'packages.play.reset': 'Reiniciar',
    'packages.play.fullscreen': 'Tela cheia',
    'deploy_sites.add_dialog.header': 'Adicionar site de deploy',
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "Escolha a credencial de deploy e insira a URL do site para salv\xE1-los como um site de deploy para o projeto ",
            projectTitle,
            "."
        ],
    'deploy_sites.add_dialog.label_credential': 'Credencial de deploy:',
    'deploy_sites.add_dialog.select_credential': 'Selecionar credencial',
    'deploy_sites.add_dialog.select_credential.new': 'Adicionar nova credencial...',
    'deploy_sites.add_dialog.label_select_site': 'Selecionar site:',
    'deploy_sites.add_dialog.select_credential_first': '(selecione a credencial primeiro)',
    'deploy_sites.add_dialog.select_site': '(selecionar site)',
    'deploy_sites.add_dialog.label_enter_site': 'Ou insira a URL do site:',
    'deploy_sites.add_dialog.ok': 'Adicionar site',
    'deploy_to_site_dialog.header': 'Publicar no site',
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "Escolha o site para publicar a vers\xE3o ",
            versionTitle,
            " de ",
            projectTitle,
            "."
        ],
    'deploy_to_site_dialog.label_site': 'Publicar no site:',
    'deploy_to_site_dialog.select_site': 'Selecionar site',
    'deploy_to_site_dialog.select_site.new': 'Adicionar novo site de deploy...',
    'deploy_to_site_dialog.packages.message.itch': [
        "Os pacotes ser\xE3o publicados no itch.io usando o ",
        $73cc5fdf88b88e2e$var$_tmpl$4(),
        ". Os nomes dos canais s\xE3o derivados das tags do pacote."
    ],
    'deploy_to_site_dialog.deploy': 'Publicar',
    'deploy_to_site_dialog.close': 'Fechar',
    'deploy_to_site_dialog.error.no_packages': 'Nenhum pacote para publicar.',
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "N\xE3o \xE9 poss\xEDvel publicar m\xFAltiplos pacotes em um \xFAnico canal. Atualmente, ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$73cc5fdf88b88e2e$var$plural(packagesCount, [
                    packagesCountText,
                    " pacote est\xE1"
                ], [
                    packagesCountText,
                    " pacotes est\xE3o"
                ])),
            " configurados para publicar no canal ",
            channel,
            "."
        ],
    'deploy_to_site_dialog.job.queued': 'Na fila',
    'deploy_to_site_dialog.job.downloading': 'Baixando...',
    'deploy_to_site_dialog.job.unpacking': 'Descompactando...',
    'deploy_to_site_dialog.job.uploading': 'Publicando...',
    'deploy_to_site_dialog.job.succeeded': 'Sucesso',
    'deploy_to_site_dialog.job.errored': 'Erro',
    'store': 'Loja',
    'store.hint': "Projetos p\xfablicos",
    'store.project.hint': "P\xe1gina do projeto na loja",
    'store.project.owner': 'Desenvolvedor',
    'store.project.description': "Descri\xe7\xe3o",
    'store.project.star': 'Favoritar',
    'store.project.starred': 'Favoritado',
    'store.project.content': "Conte\xfado",
    'store.project.content.warning': "O conte\xfado foi fornecido por um desenvolvedor terceirizado.",
    'store.project.branch_version': (branchTitle, versionTitle)=>`Ramo ${branchTitle}: vers\xe3o ${versionTitle}`,
    'store.project.branch_version.published': (branchVersionPublished)=>`Publicado: ${branchVersionPublished}`,
    'me': 'Perfil',
    'me.hint': "Configura\xe7\xf5es de perfil e credenciais vinculadas",
    'me.rename': 'Renomear perfil',
    'me.rename_dialog.header': 'Renomear perfil',
    'me.rename_dialog.label_title': 'Nome:',
    'me.rename_dialog.ok': 'Renomear perfil',
    'me.credentials': 'Credenciais',
    'me.credentials.hint.auth_allowed': 'Qualquer uma destas credenciais pode ser usada para entrar nesta conta.',
    'me.credentials.hint.auth_disallowed': "Estas credenciais est\xe3o vinculadas \xe0 sua conta, mas n\xe3o podem ser usadas para entrar.",
    'me.credentials.empty': 'Nenhuma credencial.',
    'me.credentials.empty.auth_allowed.warning': "Voc\xea pode perder o acesso \xe0 sua conta! Voc\xea n\xe3o vinculou nenhuma credencial para entrar. Vincule uma credencial de login o mais r\xe1pido poss\xedvel.",
    'me.credentials.profile_picture.alt': (provider)=>`Foto de perfil do ${$73cc5fdf88b88e2e$var$dict[`auth.provider.${provider}`]}`,
    'me.credentials.created': (created)=>[
            "adicionado em ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\xFAltimo uso em ",
            lastUsed
        ],
    'me.credential.unlink': 'Desvincular',
    'me.credential.allow_auth': 'Permitir login',
    'me.credential.disallow_auth': 'Proibir login',
    'me.credential.display_publicly': 'Exibir publicamente',
    'me.credential.dont_display_publicly': "N\xe3o exibir publicamente",
    'me.credential.link': 'Vincular credencial',
    'me.credential.link_dialog.header': 'Vincular credencial',
    'me.credential.link_dialog.message': 'Selecione o provedor de conta para vincular.',
    'me.credential.unlink_dialog.header': 'Desvincular credencial',
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "Tem certeza de que deseja desvincular a conta do ",
            credentialProvider,
            " (",
            credentialTitle,
            ") da sua conta Kavykhi.Cloud?"
        ],
    'me.credential.unlink_dialog.ok': 'Desvincular credencial',
    'me.sessions': "Sess\xf5es",
    'me.sessions.hint': "Esta \xe9 uma lista das suas sess\xf5es ativas, incluindo o navegador atual.",
    'me.sessions.started': (started)=>[
            "iniciada em ",
            (()=>{
                var _el$6 = $73cc5fdf88b88e2e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "ativa em ",
            (()=>{
                var _el$7 = $73cc5fdf88b88e2e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "Sess\xe3o atual",
    'me.sessions.empty': "Nenhuma sess\xe3o.",
    'me.sessions.delete': 'Encerrar',
    'me.sessions.delete_dialog.header': "Encerrar sess\xe3o",
    'me.sessions.delete_dialog.message': "Tem certeza de que deseja encerrar esta sess\xe3o?",
    'me.sessions.delete_dialog.ok': "Encerrar sess\xe3o",
    'me.api_tokens': 'Tokens de API',
    'me.api_tokens.hint': "Tokens de API podem ser criados aqui para uso em automa\xe7\xe3o.",
    'me.api_tokens.started': (started)=>[
            "criado em ",
            (()=>{
                var _el$8 = $73cc5fdf88b88e2e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "expira em ",
            (()=>{
                var _el$9 = $73cc5fdf88b88e2e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "sem expira\xe7\xe3o",
    'me.api_tokens.empty': 'Nenhum token de API.',
    'me.api_tokens.create': 'Gerar token de API',
    'me.api_tokens.create_dialog.header': 'Gerar token de API',
    'me.api_tokens.create_dialog.message': 'Token de API gerado:',
    'me.api_tokens.create_dialog.note': "O token n\xe3o ser\xe1 exibido novamente, salve-o com seguran\xe7a.",
    'me.api_tokens.delete': 'Excluir',
    'me.api_tokens.delete_dialog.header': 'Excluir token de API',
    'me.api_tokens.delete_dialog.message': 'Tem certeza de que deseja excluir este token?',
    'me.api_tokens.delete_dialog.ok': 'Excluir token de API',
    'me.deploy_credentials': 'Credenciais de deploy',
    'me.deploy_credentials.hint': "Credenciais para publica\xe7\xe3o em plataformas externas podem ser adicionadas aqui.",
    'me.deploy_credentials.empty': 'Nenhuma credencial de deploy adicionada.',
    'me.deploy_credential.add': 'Adicionar credencial de deploy',
    'me.deploy_credential.add_dialog.header': 'Adicionar credencial de deploy',
    'me.deploy_credential.add_dialog.label_site': 'Site:',
    'me.deploy_credential.add_dialog.label_title': 'Nota:',
    'me.deploy_credential.add_dialog.label_key': 'Chave:',
    'me.deploy_credential.add_dialog.default_title': (date)=>`Chave ${date}`,
    'me.deploy_credential.add_dialog.ok': 'Adicionar credencial de deploy',
    'me.deploy_credential.add_dialog.hint.itch': [
        "Para gerar a chave de API do itch.io, acesse as ",
        $73cc5fdf88b88e2e$var$_tmpl$6(),
        " no itch.io. Voc\xEA pode usar uma chave existente com origem \"web\" ou \"wharf\". Chaves com origem \"Kavykhi.Cloud\" n\xE3o funcionar\xE3o."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "N\xE3o oferecemos suporte para adicionar credenciais do ",
            credentialProvider,
            " no momento."
        ],
    'me.deploy_credential.delete': 'Excluir',
    'me.deploy_credential.delete_dialog.header': 'Excluir credencial de deploy',
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "Tem certeza de que deseja excluir a credencial ",
            credentialTitle,
            " do ",
            credentialProvider,
            "? Quaisquer sites de deploy configurados com esta credencial tamb\xE9m ser\xE3o removidos do projeto."
        ],
    'me.deploy_credential.delete_dialog.ok': 'Excluir credencial',
    'me.public_profile': "Perfil p\xfablico",
    'me.public_profile.public_credentials': "Credenciais p\xfablicas",
    'me.public_profile.public_credentials.hint': 'Selecione as credenciais para exibir publicamente.',
    'me.manage': 'Gerenciar conta',
    'me.delete': 'Excluir conta',
    'me.delete.dialog.header': 'Excluir conta',
    'me.delete.dialog.message': (userTitle)=>[
            "Tem certeza de que deseja excluir permanentemente sua conta Kavykhi.Cloud (",
            userTitle,
            ")?"
        ],
    'me.delete.dialog.ok': 'Excluir conta',
    'invite': 'Convite',
    'invite.hint': 'Convite de projeto',
    'invite.message.already_member': (projectTitle)=>[
            "Voc\xEA j\xE1 \xE9 membro do projeto ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "Voc\xEA foi convidado para o projeto ",
            projectTitle,
            "."
        ],
    'invite.join': 'Entrar no projeto',
    'local': "Conte\xfado local",
    'local.hint': "Conte\xfado instalado localmente",
    'local.workdirs': 'Pacotes instalados',
    'local.workdirs.empty': 'Nenhum pacote instalado.',
    'local.workdir.action.launch': 'Iniciar',
    'local.workdir.action.repair': 'Reparar',
    'local.workdir.action.delete': 'Desinstalar',
    'local.workdir.delete_dialog.header': 'Desinstalar pacote',
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "Tem certeza de que deseja desinstalar o pacote ",
            packageTitle,
            " do seu dispositivo?"
        ],
    'local.workdir.delete_dialog.ok': 'Desinstalar',
    'local.workspaces': 'Pastas raiz',
    'local.app_not_detected.message': "O aplicativo local Kavykhi.Cloud n\xe3o foi detectado. Baixe e instale-o usando um dos links abaixo. Se j\xe1 estiver instalado, certifique-se de que est\xe1 em execu\xe7\xe3o.",
    'local_app.detected': "Conte\xfado local",
    'error_dialog.header': 'Erro',
    'error_dialog.messageFunc': (e)=>`Erro: ${$73cc5fdf88b88e2e$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': 'Selecionar arquivos',
    'upload_box.choose_directories': 'Selecionar pastas',
    'upload_box.add.progress_dialog.header': 'Adicionando arquivos',
    'upload_box.add.progress_dialog.message': 'Processando arquivos...',
    'upload_box.delete': (itemsCount)=>`Excluir ${$73cc5fdf88b88e2e$var$plural(itemsCount, `${itemsCount} item`, `${itemsCount} itens`)}`,
    'upload_box.start_upload': 'Iniciar envio',
    'upload_box.drop_area.message': 'Arraste arquivos e pastas aqui',
    'upload_box.drop_area.box_dropping_message': 'Solte aqui para colocar na raiz',
    'upload_box.entry.explode_folder': "Substituir pasta pelo seu conte\xfado",
    'upload_box.entry.set_entrypoint': 'Definir arquivo inicial',
    'upload_box.entry.mark_executable': "Marcar como execut\xe1vel",
    'upload_box.entry.unmark_executable': "Desmarcar como execut\xe1vel",
    'upload_box.entry.remove': 'Remover',
    'package.tags.empty': '(sem tags)',
    'package.tag.os': 'SO',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Arq',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': 'Bits',
    'package.tag.bits:64': '64-bit',
    'package.tag.bits:32': '32-bit',
    'package.tag.packaging': 'Empacotamento',
    'package.tag.packaging:installer': 'Instalador',
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': 'Componente',
    'package.tag.component:client': 'Cliente',
    'package.tag.component:server': 'Servidor',
    'package.tag.runtime': 'Runtime',
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Distribui\xe7\xe3o Linux",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Docs',
    'docs.page_no_language': "N\xe3o dispon\xedvel neste idioma",
    'docs.page_no_language.message': "Outras vers\xf5es deste documento dispon\xedveis:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "Denunciar conte\xfado",
    'report_content.dialog.header': "Denunciar conte\xfado",
    'report_content.dialog.link': "Enviar den\xfancia por e-mail",
    'report_content.dialog.message': (email, link)=>[
            "Clique no link para enviar sua den\xFAncia:",
            $73cc5fdf88b88e2e$var$_tmpl$2(),
            $73cc5fdf88b88e2e$var$_tmpl$2(),
            link,
            $73cc5fdf88b88e2e$var$_tmpl$2(),
            $73cc5fdf88b88e2e$var$_tmpl$2(),
            "Ou envie um e-mail manualmente para ",
            email
        ]
};
var $73cc5fdf88b88e2e$export$2e2bcd8739ae039 = $73cc5fdf88b88e2e$var$dict;
const $73cc5fdf88b88e2e$var$plural = (n, one, many)=>n == 1 ? one : many;



var $4ee04ccb2987a05e$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>permitido`), $4ee04ccb2987a05e$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $4ee04ccb2987a05e$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>n\xe3o permitido`), $4ee04ccb2987a05e$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $4ee04ccb2987a05e$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $4ee04ccb2987a05e$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>configura\xe7\xf5es do seu perfil`);
const $4ee04ccb2987a05e$var$dict = {
    languageName: "Portugu\xeas brasileiro",
    locale: 'pt-BR',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: 'Tema',
    'theme.light': 'Claro',
    'theme.dark': 'Escuro',
    'theme.system': 'Sistema',
    'theme.sakura': 'Sakura',
    // generic
    email: 'E-mail',
    password: 'Senha',
    ok: 'OK',
    cancel: 'Cancelar',
    retry: 'Tentar novamente',
    copy: 'Copiar',
    empty: '(sem itens)',
    loading: 'Carregando...',
    calculating: 'Calculando...',
    error: 'Erro',
    'in_development': "Esta p\xe1gina est\xe1 em desenvolvimento.",
    // errors
    'error.not_found': "n\xe3o encontrado",
    'error.name_conflict': 'conflito de nomes',
    'error.bad_param': "par\xe2metro inv\xe1lido",
    'error.wrong_auth': "autentica\xe7\xe3o incorreta",
    'error.unauthorized': "n\xe3o autorizado",
    'error.wrong_credentials': 'credenciais incorretas',
    'error.wrong_provider': 'provedor incorreto',
    'error.insufficient_privileges': "privil\xe9gios insuficientes",
    'error.not_empty': "n\xe3o est\xe1 vazio",
    'error.limit_exceeded': 'limite excedido',
    'error.already_member': "j\xe1 \xe9 membro",
    'error.not_finalized': "n\xe3o finalizado",
    'error.already_finalized': "j\xe1 finalizado",
    'error.unexpected_patch': 'patch inesperado',
    'error.timeout': 'tempo limite esgotado',
    'error.not_patch': "n\xe3o \xe9 um patch",
    'error.not_supported': "n\xe3o suportado",
    'error.unexpected_error': 'erro inesperado',
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "Autentica\xe7\xe3o",
    'auth.dialog.please_select': 'Selecione seu provedor de conta para entrar.',
    'auth.dialog.redirecting_to': (provider)=>`Redirecionando para o ${provider}...`,
    'auth.dialog.remember_me': 'Lembrar de mim',
    'auth.dialog.log_in': 'Entrar',
    'auth.dialog.back': 'Voltar',
    'auth.dialog.progress_header': 'Autenticando...',
    'auth.dialog.error.header': "Erro de autentica\xe7\xe3o",
    'auth.dialog.error.auth_not_allowed': "Esta credencial foi proibida pelo usu\xe1rio para autentica\xe7\xe3o. Use outra credencial.",
    'auth.dialog.error.unknown': "Par\xe2metros de autentica\xe7\xe3o inv\xe1lidos. Tente novamente.",
    'auth.dialog.error.back': 'Voltar',
    'user.profile': 'Perfil',
    'user.logout': 'Sair',
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "P\xe1gina n\xe3o encontrada",
    'page_not_found.message': "Esta p\xe1gina n\xe3o existe.",
    'page_not_found.message2': "Bem, na verdade ela existe, mas n\xe3o h\xe1 nada aqui. Aqui est\xe3o as possibilidades.",
    'page_not_found.items': [
        "Algo estava aqui antes, mas foi exclu\xeddo.",
        "Algo ainda est\xe1 aqui, mas voc\xea n\xe3o tem acesso.",
        "Ou algu\xe9m simplesmente n\xe3o teve cuidado ao copiar e colar o link."
    ],
    'home': "In\xedcio",
    'home.header.hint': 'Ferramentas em nuvem para devs indie',
    'home.description': "Kavykhi.Cloud \xe9 uma plataforma de desenvolvimento para jogos indie. Suportamos jogos para download e navegador, builds privadas e p\xfablicas, ramifica\xe7\xf5es, equipes e muito mais.",
    'home.auth': 'Entrar ou cadastrar-se',
    'home.auth.hint': 'Criar nova conta ou entrar em uma existente',
    'projects': 'Projetos',
    'projects.hint': "Os projetos em que voc\xea est\xe1 trabalhando",
    'projects.project': (project)=>`Projeto: ${project}`,
    'projects.project.hint': 'projeto',
    'projects.no_projects': "Voc\xea ainda n\xe3o tem projetos.",
    'projects.new': 'Criar projeto',
    'projects.new_dialog.header': 'Novo projeto',
    'projects.new_dialog.label': 'Nome do projeto',
    'projects.new_dialog.ok': 'Criar projeto',
    'projects.store_page': "P\xe1gina p\xfablica da loja",
    'projects.description': "Descri\xe7\xe3o",
    'projects.branches': "Ramifica\xe7\xf5es",
    'projects.versions': "Vers\xf5es",
    'projects.packages': 'Pacotes',
    'projects.management': "Configura\xe7\xf5es do projeto",
    'projects.management.breadcrumb': "Configura\xe7\xf5es",
    'projects.management.title': (projectTitle)=>`${projectTitle} - configura\xe7\xf5es`,
    'projects.management.hint': "configura\xe7\xf5es do projeto",
    'projects.management.users': 'Membros da equipe',
    'projects.management.users.empty': 'Nenhum membro na equipe.',
    'projects.management.users.role.tester': 'Testador',
    'projects.management.users.role.developer': 'Desenvolvedor',
    'projects.management.users.role.admin': 'Administrador',
    'projects.management.users.role.owner': 'Dono',
    'projects.management.users.role.starred': 'Favoritado',
    'projects.management.users.exile': 'Remover da equipe',
    'projects.management.users.exile.dialog.header': 'Remover da equipe',
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "Tem certeza de que deseja remover ",
            userTitle,
            " do projeto ",
            projectTitle,
            "?"
        ],
    'projects.management.users.exile.dialog.ok': 'Remover da equipe',
    'projects.management.invites.one_time_invite': "Link de convite de uso \xfanico",
    'projects.management.invites.one_time_invite.header': "Link de convite de uso \xfanico",
    'projects.management.invites.one_time_invite.message': "Link de convite de uso \xfanico:",
    'projects.management.invites.one_time_invite.note': "V\xe1lido por 24 horas, pode ser usado uma vez.",
    'projects.management.invites.new_dialog.header': 'Link de convite',
    'projects.management.invites.new_dialog.expires': 'Expira em:',
    'projects.management.invites.new_dialog.expires.indefinite': "(sem expira\xe7\xe3o)",
    'projects.management.invites.new_dialog.approval.label': "Usu\xe1rio entra no projeto:",
    'projects.management.invites.new_dialog.approval.not_approved': "ap\xf3s aprova\xe7\xe3o do admin",
    'projects.management.invites.new_dialog.approval.approved': 'imediatamente',
    'projects.management.invites.new_dialog.seats': 'Limite de entradas:',
    'projects.management.invites.new_dialog.seats.no_limit': '(sem limite)',
    'projects.management.invites.new_dialog.ok': 'Criar link de convite',
    'projects.management.deploy_sites': 'Sites de deploy',
    'projects.management.deploy_sites.empty': 'Nenhum site de deploy adicionado.',
    'projects.management.deploy_sites.add': 'Adicionar site de deploy',
    'projects.management.deploy_sites.delete': 'Excluir',
    'projects.management.deploy_sites.delete_dialog.header': 'Excluir site de deploy',
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "Tem certeza de que deseja excluir o site de deploy ",
            site,
            " do ",
            provider,
            "?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': 'Excluir site de deploy',
    'projects.management.public_access': "Acesso p\xfablico",
    'projects.management.public_access.enable': "Ativar acesso p\xfablico",
    'projects.management.public_access.enabled': [
        "Acesso p\xFAblico: ",
        $4ee04ccb2987a05e$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "O nome e a descri\xe7\xe3o do projeto s\xe3o p\xfablicos, assim como qualquer ramifica\xe7\xe3o marcada como p\xfablica.",
    'projects.management.public_access.enable_dialog.header': "Ativar acesso p\xfablico",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja permitir o acesso p\xFAblico ao projeto ",
            projectTitle,
            "?",
            $4ee04ccb2987a05e$var$_tmpl$2(),
            $4ee04ccb2987a05e$var$_tmpl$2(),
            "Isso tornar\xE1 as informa\xE7\xF5es b\xE1sicas do projeto dispon\xEDveis sem autentica\xE7\xE3o. Voc\xEA precisar\xE1 ativar o acesso p\xFAblico separadamente para cada ramifica\xE7\xE3o que deseja tornar p\xFAblica."
        ],
    'projects.management.public_access.enable_dialog.ok': "Ativar acesso p\xfablico",
    'projects.management.public_access.disable': "Desativar acesso p\xfablico",
    'projects.management.public_access.disabled': [
        "Acesso p\xFAblico: ",
        $4ee04ccb2987a05e$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "O projeto \xe9 privado. Apenas os membros da equipe do projeto podem acess\xe1-lo.",
    'projects.management.public_access.disable_dialog.header': "Desativar acesso p\xfablico",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja desativar todo o acesso p\xFAblico ao projeto ",
            projectTitle,
            "?"
        ],
    'projects.management.public_access.disable_dialog.ok': "Desativar acesso p\xfablico",
    'projects.management.public_access.branches': "Ramifica\xe7\xf5es p\xfablicas",
    'projects.management.manage': 'Gerenciar projeto',
    'projects.rename': 'Renomear projeto',
    'projects.rename_dialog.header': 'Renomear projeto',
    'projects.rename_dialog.label': 'Nome do projeto:',
    'projects.rename_dialog.ok': 'Renomear projeto',
    'projects.edit_description': "Editar descri\xe7\xe3o do projeto",
    'projects.edit_description_dialog.header': "Editar descri\xe7\xe3o do projeto",
    'projects.edit_description_dialog.label': "Descri\xe7\xe3o do projeto:",
    'projects.edit_description_dialog.ok': "Editar descri\xe7\xe3o",
    'projects.leave': 'Sair do projeto',
    'projects.leave_dialog.header': 'Sair do projeto',
    'projects.leave_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja sair do projeto ",
            projectTitle,
            "?"
        ],
    'projects.leave_dialog.ok': 'Sair do projeto',
    'projects.delete': 'Excluir projeto',
    'projects.delete_dialog.header': 'Excluir projeto',
    'projects.delete_dialog.message': (projectTitle)=>[
            "Tem certeza de que deseja excluir o projeto ",
            projectTitle,
            "?"
        ],
    'projects.delete_dialog.ok': 'Excluir projeto',
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "ramifica\xe7\xe3o",
    'branches.no_branches': "O projeto ainda n\xe3o possui ramifica\xe7\xf5es",
    'branches.new': "Criar ramifica\xe7\xe3o",
    'branches.new_dialog.header': "Nova ramifica\xe7\xe3o",
    'branches.new_dialog.label': "Nome da ramifica\xe7\xe3o",
    'branches.new_dialog.ok': "Criar ramifica\xe7\xe3o",
    'branches.current_version': (version)=>[
            "Vers\xE3o atual: ",
            version
        ],
    'branches.current_version.packages': "Pacotes da vers\xe3o atual",
    'branches.no_current_version': "Sem vers\xe3o atual",
    'branches.publish_version.new': "Publicar nova vers\xe3o",
    'branches.publish_version.existing': "Republicar vers\xe3o existente",
    'branches.version_history': "Hist\xf3rico de vers\xf5es",
    'branches.version_history.empty': "O hist\xf3rico de vers\xf5es da ramifica\xe7\xe3o est\xe1 vazio.",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "A vers\xE3o atual da ramifica\xE7\xE3o \xE9 mantida ",
            quotaTime != null ? [
                "por ",
                quotaTime
            ] : "indefinidamente",
            ". Vers\xF5es anteriores s\xE3o mantidas por no m\xE1ximo ",
            quotaNonCurrentTime,
            ". No m\xE1ximo ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$4ee04ccb2987a05e$var$plural(quotaCount, [
                    quotaCountText,
                    " vers\xE3o"
                ], [
                    quotaCountText,
                    " vers\xF5es"
                ])),
            " no total s\xE3o mantidas por ramifica\xE7\xE3o."
        ],
    'branches.manage': "Gerenciar ramifica\xe7\xe3o",
    'branches.rename': "Renomear ramifica\xe7\xe3o",
    'branches.rename_dialog.header': "Renomear ramifica\xe7\xe3o",
    'branches.rename_dialog.label': "Nome da ramifica\xe7\xe3o:",
    'branches.rename_dialog.ok': "Renomear ramifica\xe7\xe3o",
    'branches.delete': "Excluir ramifica\xe7\xe3o",
    'branches.delete_dialog.header': "Excluir ramifica\xe7\xe3o",
    'branches.delete_dialog.message': (branchTitle)=>[
            "Tem certeza de que deseja excluir a ramifica\xE7\xE3o ",
            branchTitle,
            "?"
        ],
    'branches.delete_dialog.ok': "Excluir ramifica\xe7\xe3o",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "vers\xe3o",
    'versions.current': 'Atual',
    'versions.previous': 'Anterior',
    'versions.description': "Descri\xe7\xe3o",
    'versions.deploy_to_site.header': 'Publicar no site',
    'versions.deploy_to_site': 'Publicar no site',
    'versions.packages': 'Pacotes',
    'versions.branches': "Nas ramifica\xe7\xf5es",
    'versions.branches.publish': "Publicar na ramifica\xe7\xe3o",
    'versions.branches.empty': "A vers\xe3o n\xe3o foi publicada em nenhuma ramifica\xe7\xe3o.",
    'versions.new_dialog.header': "Nova vers\xe3o",
    'versions.new_dialog.label_title': "Vers\xe3o:",
    'versions.new_dialog.label_branch': "Ramifica\xe7\xe3o:",
    'versions.new_dialog.packages.header': 'Pacotes',
    'versions.new_dialog.packages.empty': 'Nenhum pacote adicionado.',
    'versions.new_dialog.packages.add': 'Adicionar pacote',
    'versions.new_dialog.packages.add_existing': 'Adicionar pacote enviado anteriormente',
    'versions.new_dialog.packages.replace': 'Substituir pacote',
    'versions.new_dialog.packages.edit': 'Editar pacote',
    'versions.new_dialog.ok': "Criar vers\xe3o",
    'versions.manage': "Gerenciar vers\xe3o",
    'versions.rename': "Renomear vers\xe3o",
    'versions.rename_dialog.header': "Renomear vers\xe3o",
    'versions.rename_dialog.label': "Nome da vers\xe3o:",
    'versions.rename_dialog.ok': "Renomear vers\xe3o",
    'versions.edit_description': "Editar descri\xe7\xe3o da vers\xe3o",
    'versions.edit_description_dialog.header': "Editar descri\xe7\xe3o da vers\xe3o",
    'versions.edit_description_dialog.label': "Descri\xe7\xe3o da vers\xe3o:",
    'versions.edit_description_dialog.ok': "Editar descri\xe7\xe3o",
    'versions.delete': "Excluir vers\xe3o",
    'versions.delete_dialog.header': "Excluir vers\xe3o",
    'versions.delete_dialog.message': (versionTitle)=>[
            "Tem certeza de que deseja excluir a vers\xE3o ",
            versionTitle,
            "?"
        ],
    'versions.delete_dialog.ok': "Excluir vers\xe3o",
    'versions.publish_dialog.header': "Publicar vers\xe3o em uma ramifica\xe7\xe3o",
    'versions.publish_dialog.message': (versionTitle)=>[
            "Escolha a ramifica\xE7\xE3o para publicar a vers\xE3o ",
            versionTitle,
            "."
        ],
    'versions.publish_dialog.no_branches': "Nenhuma ramifica\xe7\xe3o no projeto.",
    'versions.publish_dialog.ok': "Publicar vers\xe3o",
    'versions.publish_existing_dialog.header': "Republicar vers\xe3o",
    'versions.publish_existing_dialog.message': "\xdaltimas vers\xf5es:",
    'versions.publish_existing_dialog.no_versions': "Nenhuma vers\xe3o no projeto.",
    'versions.publish_existing_dialog.ok': "Publicar vers\xe3o",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': 'Pacote',
    'packages.download_zip': 'Baixar como ZIP',
    'packages.download_torrent': 'Baixar torrent',
    'packages.total_size': (size)=>[
            "Tamanho total: ",
            size
        ],
    'packages.manage': 'Gerenciar pacote',
    'packages.rename': 'Renomear pacote',
    'packages.rename_dialog.header': 'Renomear pacote',
    'packages.rename_dialog.label': 'Nome do pacote:',
    'packages.rename_dialog.ok': 'Renomear pacote',
    'packages.edit_tags': 'Editar tags do pacote',
    'packages.edit_tags_dialog.header': 'Editar tags do pacote',
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "Especifique as tags do pacote ",
            packageTitle,
            ":"
        ],
    'packages.edit_tags_dialog.ok': 'Definir tags do pacote',
    'packages.entrypoint': (entrypoint)=>[
            "Arquivo de in\xEDcio: ",
            entrypoint
        ],
    'packages.entrypoint.empty': "Arquivo de in\xedcio n\xe3o definido.",
    'packages.delete': 'Excluir pacote',
    'packages.delete_dialog.header': 'Excluir pacote',
    'packages.delete_dialog.message': (packageTitle)=>[
            "Tem certeza de que deseja excluir o pacote ",
            packageTitle,
            "? O pacote ser\xE1 exclu\xEDdo de todas as vers\xF5es em que foi adicionado."
        ],
    'packages.delete_dialog.ok': 'Excluir pacote',
    'packages.new_dialog.header': 'Novo pacote',
    'packages.new_dialog.label_title': "T\xedtulo:",
    'packages.new_dialog.title_placeholder': '(a partir das tags)',
    'packages.new_dialog.tags.header': 'Tags',
    'packages.new_dialog.files.header': 'Arquivos',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Tamanho total: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(m\xE1ximo ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "Tamanho dos novos dados: ",
            size
        ],
    'packages.new_dialog.checks.empty': 'Nenhum arquivo adicionado.',
    'packages.new_dialog.checks.entrypoint.empty': "Arquivo de in\xedcio n\xe3o definido.",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "O arquivo de in\xEDcio ",
            entrypoint,
            " n\xE3o existe; talvez voc\xEA tenha esquecido de adicion\xE1-lo? Especifique um arquivo de in\xEDcio existente ou deixe sem nenhum."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "Remover arquivo de in\xedcio",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "O arquivo de in\xEDcio tem a extens\xE3o ",
            fileExt,
            ": sugerindo a tag ",
            tag,
            "."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "Adicionar tag ",
            tag
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "O arquivo de in\xEDcio tem a extens\xE3o ",
            fileExt,
            ": adicione a tag ",
            tag,
            " para tornar o pacote jog\xE1vel no navegador."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "O arquivo de in\xEDcio tem a extens\xE3o ",
            fileExt,
            ": isso \xE9 um erro? Geralmente este n\xE3o \xE9 o tipo de arquivo que pode ser iniciado."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "O arquivo de in\xEDcio tem a extens\xE3o ",
            fileExt,
            ": \xE9 recomendado incluir os arquivos de conte\xFAdo reais em vez de compact\xE1-los em um arquivo de arquivo."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "O arquivo de in\xedcio n\xe3o est\xe1 marcado como execut\xe1vel",
    'packages.new_dialog.checks.entrypoint.executable.action': "Marcar como execut\xe1vel",
    'packages.new_dialog.checks.single_root_dir': "Recomenda-se colocar os arquivos diretamente na raiz, em vez de ter uma \xfanica pasta na raiz.",
    'packages.new_dialog.checks.single_root_dir.action': "Substituir pasta pelo seu conte\xfado",
    'packages.add_existing_dialog.header': 'Adicionar pacote',
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `Adicionar ${$4ee04ccb2987a05e$var$plural(packagesCount, `${packagesCount} pacote`, `${packagesCount} pacotes`)}` : 'Nenhum pacote selecionado',
    'packages.add_existing_dialog.message': "\xdaltimos pacotes enviados:",
    'packages.add_existing_dialog.no_packages': 'Nenhum pacote enviado recentemente.',
    'packages.launch': 'Iniciar',
    'packages.install': 'Instalar',
    'packages.install_dialog.header': 'Instalar',
    'packages.install_dialog.workdir.label': "Diret\xf3rio de trabalho:",
    'packages.install_dialog.workdir.value.new': '(criar novo)',
    'packages.install_dialog.workspace.label': 'Criar pasta em:',
    'packages.install_dialog.workspace.placeholder': '(selecionar pasta raiz)',
    'packages.install_dialog.ok': 'Instalar',
    'packages.update': 'Atualizar',
    'packages.upload.status.existing': "Da vers\xe3o anterior",
    'packages.upload.status.queued': 'Na fila',
    'packages.upload.status.packing': 'Compactando...',
    'packages.upload.status.creating': 'Criando...',
    'packages.upload.status.create_retrying': 'Falha ao criar, aguardando e tentando novamente',
    'packages.upload.status.splitting': 'Dividindo...',
    'packages.upload.status.uploading': 'Enviando...',
    'packages.upload.status.finalizing': 'Finalizando...',
    'packages.upload.status.finalize_retrying': 'Falha ao finalizar, aguardando e tentando novamente',
    'packages.upload.status.resolving': 'Resolvendo patch...',
    'packages.upload.status.resolve_retrying': 'Falha ao resolver patch, aguardando e tentando novamente...',
    'packages.upload.status.done': 'Enviado com sucesso',
    'packages.upload.status.errored': 'Erro',
    'packages.upload.part.status.queued': 'Na fila',
    'packages.upload.part.status.hashing': 'Calculando hash',
    'packages.upload.part.status.upload_queued': 'Envio na fila',
    'packages.upload.part.status.uploading': 'Enviando',
    'packages.upload.part.status.upload_retrying': 'Erro, tentando enviar novamente',
    'packages.upload.part.status.upload_finalizing': 'Finalizando envio',
    'packages.upload.part.status.upload_errored': 'Erro',
    'packages.upload.part.status.done': 'Enviado',
    'packages.play': 'Jogar no navegador',
    'packages.play.reset': 'Reiniciar',
    'packages.play.fullscreen': 'Tela cheia',
    'deploy_sites.add_dialog.header': 'Adicionar site de deploy',
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "Escolha a credencial de deploy e insira a URL do site para salv\xE1-los como um site de deploy para o projeto ",
            projectTitle,
            "."
        ],
    'deploy_sites.add_dialog.label_credential': 'Credencial de deploy:',
    'deploy_sites.add_dialog.select_credential': 'Selecionar credencial',
    'deploy_sites.add_dialog.select_credential.new': 'Adicionar nova credencial...',
    'deploy_sites.add_dialog.label_select_site': 'Selecionar site:',
    'deploy_sites.add_dialog.select_credential_first': '(selecione a credencial primeiro)',
    'deploy_sites.add_dialog.select_site': '(selecionar site)',
    'deploy_sites.add_dialog.label_enter_site': 'Ou insira a URL do site:',
    'deploy_sites.add_dialog.ok': 'Adicionar site',
    'deploy_to_site_dialog.header': 'Publicar no site',
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "Escolha o site para publicar a vers\xE3o ",
            versionTitle,
            " de ",
            projectTitle,
            "."
        ],
    'deploy_to_site_dialog.label_site': 'Publicar no site:',
    'deploy_to_site_dialog.select_site': 'Selecionar site',
    'deploy_to_site_dialog.select_site.new': 'Adicionar novo site de deploy...',
    'deploy_to_site_dialog.packages.message.itch': [
        "Os pacotes ser\xE3o publicados no itch.io usando o ",
        $4ee04ccb2987a05e$var$_tmpl$4(),
        ". Os nomes dos canais s\xE3o derivados das tags do pacote."
    ],
    'deploy_to_site_dialog.deploy': 'Publicar',
    'deploy_to_site_dialog.close': 'Fechar',
    'deploy_to_site_dialog.error.no_packages': 'Nenhum pacote para publicar.',
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "N\xE3o \xE9 poss\xEDvel publicar m\xFAltiplos pacotes em um \xFAnico canal. Atualmente, ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$4ee04ccb2987a05e$var$plural(packagesCount, [
                    packagesCountText,
                    " pacote est\xE1"
                ], [
                    packagesCountText,
                    " pacotes est\xE3o"
                ])),
            " configurados para publicar no canal ",
            channel,
            "."
        ],
    'deploy_to_site_dialog.job.queued': 'Na fila',
    'deploy_to_site_dialog.job.downloading': 'Baixando...',
    'deploy_to_site_dialog.job.unpacking': 'Descompactando...',
    'deploy_to_site_dialog.job.uploading': 'Publicando...',
    'deploy_to_site_dialog.job.succeeded': 'Sucesso',
    'deploy_to_site_dialog.job.errored': 'Erro',
    'store': 'Loja',
    'store.hint': "Projetos p\xfablicos",
    'store.project.hint': "P\xe1gina do projeto na loja",
    'store.project.owner': 'Desenvolvedor',
    'store.project.description': "Descri\xe7\xe3o",
    'store.project.star': 'Favoritar',
    'store.project.starred': 'Favoritado',
    'store.project.content': "Conte\xfado",
    'store.project.content.warning': "O conte\xfado foi fornecido por um desenvolvedor terceiro.",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            "Ramifica\xE7\xE3o ",
            branchTitle,
            ": vers\xE3o ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "Publicado: ",
            branchVersionPublished
        ],
    'me': 'Perfil',
    'me.hint': "Configura\xe7\xf5es de perfil e credenciais vinculadas",
    'me.rename': 'Renomear perfil',
    'me.rename_dialog.header': 'Renomear perfil',
    'me.rename_dialog.label_title': 'Nome:',
    'me.rename_dialog.ok': 'Renomear perfil',
    'me.credentials': 'Credenciais',
    'me.credentials.hint.auth_allowed': 'Qualquer uma destas credenciais pode ser usada para entrar nesta conta.',
    'me.credentials.hint.auth_disallowed': "Estas credenciais est\xe3o vinculadas \xe0 sua conta, mas n\xe3o podem ser usadas para entrar.",
    'me.credentials.empty': 'Nenhuma credencial.',
    'me.credentials.empty.auth_allowed.warning': "Voc\xea pode perder o acesso \xe0 sua conta! Voc\xea n\xe3o vinculou nenhuma credencial para entrar. Vincule uma credencial de login o quanto antes.",
    'me.credentials.profile_picture.alt': (provider)=>`Foto de perfil do ${$4ee04ccb2987a05e$var$dict[`auth.provider.${provider}`]}`,
    'me.credentials.created': (created)=>[
            "adicionado em ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "usado pela \xFAltima vez em ",
            lastUsed
        ],
    'me.credential.unlink': 'Desvincular',
    'me.credential.allow_auth': 'Permitir login',
    'me.credential.disallow_auth': 'Desativar login',
    'me.credential.display_publicly': 'Exibir publicamente',
    'me.credential.dont_display_publicly': "N\xe3o exibir publicamente",
    'me.credential.link': 'Vincular credencial',
    'me.credential.link_dialog.header': 'Vincular credencial',
    'me.credential.link_dialog.message': 'Selecione o provedor de conta para vincular.',
    'me.credential.unlink_dialog.header': 'Desvincular credencial',
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "Tem certeza de que deseja desvincular a conta do ",
            credentialProvider,
            " (",
            credentialTitle,
            ") da sua conta Kavykhi.Cloud?"
        ],
    'me.credential.unlink_dialog.ok': 'Desvincular credencial',
    'me.sessions': "Sess\xf5es",
    'me.sessions.hint': "Esta \xe9 uma lista das suas sess\xf5es ativas, incluindo o navegador atual.",
    'me.sessions.started': (started)=>[
            "iniciada em ",
            (()=>{
                var _el$6 = $4ee04ccb2987a05e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "ativa em ",
            (()=>{
                var _el$7 = $4ee04ccb2987a05e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "Sess\xe3o atual",
    'me.sessions.empty': "Nenhuma sess\xe3o.",
    'me.sessions.delete': 'Encerrar',
    'me.sessions.delete_dialog.header': "Encerrar sess\xe3o",
    'me.sessions.delete_dialog.message': "Tem certeza de que deseja encerrar esta sess\xe3o?",
    'me.sessions.delete_dialog.ok': "Encerrar sess\xe3o",
    'me.api_tokens': 'Tokens de API',
    'me.api_tokens.hint': "Tokens de API podem ser criados aqui para uso em automa\xe7\xe3o.",
    'me.api_tokens.started': (started)=>[
            "criado em ",
            (()=>{
                var _el$8 = $4ee04ccb2987a05e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "expira em ",
            (()=>{
                var _el$9 = $4ee04ccb2987a05e$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "sem expira\xe7\xe3o",
    'me.api_tokens.empty': 'Nenhum token de API.',
    'me.api_tokens.create': 'Gerar token de API',
    'me.api_tokens.create_dialog.header': 'Gerar token de API',
    'me.api_tokens.create_dialog.message': 'Token de API gerado:',
    'me.api_tokens.create_dialog.note': "O token n\xe3o ser\xe1 exibido novamente, salve-o em um local seguro.",
    'me.api_tokens.delete': 'Excluir',
    'me.api_tokens.delete_dialog.header': 'Excluir token de API',
    'me.api_tokens.delete_dialog.message': 'Tem certeza de que deseja excluir este token?',
    'me.api_tokens.delete_dialog.ok': 'Excluir token de API',
    'me.deploy_credentials': 'Credenciais de deploy',
    'me.deploy_credentials.hint': "Credenciais para deploy em plataformas de publica\xe7\xe3o podem ser adicionadas aqui.",
    'me.deploy_credentials.empty': 'Nenhuma credencial de deploy adicionada.',
    'me.deploy_credential.add': 'Adicionar credencial de deploy',
    'me.deploy_credential.add_dialog.header': 'Adicionar credencial de deploy',
    'me.deploy_credential.add_dialog.label_site': 'Site:',
    'me.deploy_credential.add_dialog.label_title': 'Nota:',
    'me.deploy_credential.add_dialog.label_key': 'Chave:',
    'me.deploy_credential.add_dialog.default_title': (date)=>`Chave ${date}`,
    'me.deploy_credential.add_dialog.ok': 'Adicionar credencial de deploy',
    'me.deploy_credential.add_dialog.hint.itch': [
        "Para gerar a chave de API do itch.io, acesse as ",
        $4ee04ccb2987a05e$var$_tmpl$6(),
        " no itch.io. Voc\xEA pode usar uma chave de API existente com origem \"web\" ou \"wharf\". Chaves de API com origem \"Kavykhi.Cloud\" n\xE3o funcionar\xE3o."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "N\xE3o oferecemos suporte para adicionar credenciais do ",
            credentialProvider,
            " no momento."
        ],
    'me.deploy_credential.delete': 'Excluir',
    'me.deploy_credential.delete_dialog.header': 'Excluir credencial de deploy',
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "Tem certeza de que deseja excluir a credencial ",
            credentialTitle,
            " do ",
            credentialProvider,
            "? Quaisquer sites de deploy configurados com esta credencial tamb\xE9m ser\xE3o removidos do projeto."
        ],
    'me.deploy_credential.delete_dialog.ok': 'Excluir credencial',
    'me.public_profile': "Perfil p\xfablico",
    'me.public_profile.public_credentials': "Credenciais p\xfablicas",
    'me.public_profile.public_credentials.hint': 'Selecione as credenciais para exibir publicamente.',
    'me.manage': 'Gerenciar conta',
    'me.delete': 'Excluir conta',
    'me.delete.dialog.header': 'Excluir conta',
    'me.delete.dialog.message': (userTitle)=>[
            "Tem certeza de que deseja excluir permanentemente sua conta Kavykhi.Cloud ",
            userTitle,
            "?"
        ],
    'me.delete.dialog.ok': 'Excluir conta',
    'invite': 'Convite',
    'invite.hint': 'Convite para projeto',
    'invite.message.already_member': (projectTitle)=>[
            "Voc\xEA j\xE1 \xE9 um membro do projeto ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "Voc\xEA foi convidado para o projeto ",
            projectTitle,
            "."
        ],
    'invite.join': 'Entrar no projeto',
    'local': "Conte\xfado local",
    'local.hint': "Conte\xfado instalado localmente",
    'local.workdirs': 'Pacotes instalados',
    'local.workdirs.empty': 'Nenhum pacote instalado.',
    'local.workdir.action.launch': 'Iniciar',
    'local.workdir.action.repair': 'Reparar',
    'local.workdir.action.delete': 'Desinstalar',
    'local.workdir.delete_dialog.header': 'Desinstalar pacote',
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "Tem certeza de que deseja desinstalar o pacote ",
            packageTitle,
            " do seu dispositivo?"
        ],
    'local.workdir.delete_dialog.ok': 'Desinstalar',
    'local.workspaces': 'Pastas raiz',
    'local.app_not_detected.message': "O aplicativo local Kavykhi.Cloud n\xe3o foi detectado. Baixe e instale-o usando um dos links abaixo. Se voc\xea j\xe1 o instalou, certifique-se de que ele est\xe1 em execu\xe7\xe3o.",
    'local_app.detected': "Conte\xfado local",
    'error_dialog.header': 'Erro',
    'error_dialog.messageFunc': (e)=>`Erro: ${$4ee04ccb2987a05e$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': 'Escolher arquivos',
    'upload_box.choose_directories': 'Escolher pastas',
    'upload_box.add.progress_dialog.header': 'Adicionando arquivos',
    'upload_box.add.progress_dialog.message': 'Processando arquivos...',
    'upload_box.delete': (itemsCount)=>`Excluir ${$4ee04ccb2987a05e$var$plural(itemsCount, `${itemsCount} item`, `${itemsCount} itens`)}`,
    'upload_box.start_upload': 'Iniciar envio',
    'upload_box.drop_area.message': 'Solte arquivos e pastas aqui',
    'upload_box.drop_area.box_dropping_message': 'Solte aqui para colocar na raiz',
    'upload_box.entry.explode_folder': "Substituir pasta pelo seu conte\xfado",
    'upload_box.entry.set_entrypoint': "Definir arquivo de in\xedcio",
    'upload_box.entry.mark_executable': "Marcar como execut\xe1vel",
    'upload_box.entry.unmark_executable': "Desmarcar como execut\xe1vel",
    'upload_box.entry.remove': 'Remover',
    'package.tags.empty': '(sem tags)',
    'package.tag.os': 'SO',
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Arquitetura',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': 'Bits',
    'package.tag.bits:64': '64-bit',
    'package.tag.bits:32': '32-bit',
    'package.tag.packaging': 'Empacotamento',
    'package.tag.packaging:installer': 'Instalador',
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': 'Componente',
    'package.tag.component:client': 'Cliente',
    'package.tag.component:server': 'Servidor',
    'package.tag.runtime': 'Runtime',
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Distribui\xe7\xe3o Linux",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Docs',
    'docs.page_no_language': "N\xe3o dispon\xedvel neste idioma",
    'docs.page_no_language.message': "Outras vers\xf5es deste documento dispon\xedveis:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "Denunciar conte\xfado",
    'report_content.dialog.header': "Denunciar conte\xfado",
    'report_content.dialog.link': "Enviar den\xfancia por e-mail",
    'report_content.dialog.message': (email, link)=>[
            "Clique no link para enviar sua den\xFAncia:",
            $4ee04ccb2987a05e$var$_tmpl$2(),
            $4ee04ccb2987a05e$var$_tmpl$2(),
            link,
            $4ee04ccb2987a05e$var$_tmpl$2(),
            $4ee04ccb2987a05e$var$_tmpl$2(),
            "Ou envie um e-mail manualmente para ",
            email
        ]
};
var $4ee04ccb2987a05e$export$2e2bcd8739ae039 = $4ee04ccb2987a05e$var$dict;
const $4ee04ccb2987a05e$var$plural = (n, one, many)=>n == 1 ? one : many;



var $3cf242074de6adb0$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{451}\u{43D}`), $3cf242074de6adb0$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $3cf242074de6adb0$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{437}\u{430}\u{43F}\u{440}\u{435}\u{449}\u{451}\u{43D}`), $3cf242074de6adb0$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $3cf242074de6adb0$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $3cf242074de6adb0$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>\u{43D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{439}\u{43A}\u{438} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44F}`);
const $3cf242074de6adb0$var$dict = {
    languageName: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    locale: 'ru',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': "\u041A\u0430\u0432\u044B\u0445\u0438.Cloud",
    'app.title': (sub)=>`${sub} - \u{41A}\u{430}\u{432}\u{44B}\u{445}\u{438}.Cloud`,
    // themes
    theme: "\u0422\u0435\u043C\u0430",
    'theme.light': "\u0421\u0432\u0435\u0442\u043B\u0430\u044F",
    'theme.dark': "\u0422\u0451\u043C\u043D\u0430\u044F",
    'theme.system': "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F",
    'theme.sakura': "\u0421\u0430\u043A\u0443\u0440\u0430",
    // generic
    email: 'Email',
    password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    ok: 'OK',
    cancel: "\u041E\u0442\u043C\u0435\u043D\u0430",
    retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    copy: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    empty: "(\u043F\u0443\u0441\u0442\u043E)",
    loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
    calculating: "\u0412\u044B\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435...",
    error: "\u041E\u0448\u0438\u0431\u043A\u0430",
    'in_development': "\u042D\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0432 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435.",
    // errors
    'error.not_found': "\u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'error.name_conflict': "\u043A\u043E\u043D\u0444\u043B\u0438\u043A\u0442 \u0438\u043C\u0451\u043D",
    'error.bad_param': "\u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440",
    'error.wrong_auth': "\u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
    'error.unauthorized': "\u043D\u0435\u0442 \u043F\u0440\u0430\u0432",
    'error.wrong_credentials': "\u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
    'error.wrong_provider': "\u043D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
    'error.insufficient_privileges': "\u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0439",
    'error.not_empty': "\u043D\u0435 \u043F\u0443\u0441\u0442\u043E\u0439",
    'error.limit_exceeded': "\u043B\u0438\u043C\u0438\u0442 \u043F\u0440\u0435\u0432\u044B\u0448\u0435\u043D",
    'error.already_member': "\u0443\u0436\u0435 \u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u0435",
    'error.not_finalized': "\u043D\u0435 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D",
    'error.already_finalized': "\u0443\u0436\u0435 \u0444\u0438\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D",
    'error.unexpected_patch': "\u043D\u0435\u043E\u0436\u0438\u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u0430\u0442\u0447",
    'error.timeout': "\u0442\u0430\u0439\u043C\u0430\u0443\u0442",
    'error.not_patch': "\u043D\u0435 \u043F\u0430\u0442\u0447",
    'error.not_supported': "\u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F",
    'error.unexpected_error': "\u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430",
    // data sizes
    'datasize.B': "\u0411",
    'datasize.KiB': "\u041A\u0438\u0411",
    'datasize.MiB': "\u041C\u0438\u0411",
    'datasize.GiB': "\u0413\u0438\u0411",
    'datasize.TiB': "\u0422\u0438\u0411",
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F",
    'auth.dialog.please_select': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430.",
    'auth.dialog.redirecting_to': (provider)=>`\u{410}\u{432}\u{442}\u{43E}\u{440}\u{438}\u{437}\u{430}\u{446}\u{438}\u{44F} \u{447}\u{435}\u{440}\u{435}\u{437} ${provider}...`,
    'auth.dialog.remember_me': "\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043C\u0435\u043D\u044F",
    'auth.dialog.log_in': "\u0412\u0445\u043E\u0434",
    'auth.dialog.back': "\u041D\u0430\u0437\u0430\u0434",
    'auth.dialog.progress_header': "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F...",
    'auth.dialog.error.header': "\u041E\u0448\u0438\u0431\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438",
    'auth.dialog.error.auth_not_allowed': "\u042D\u0442\u043E\u0442 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0437\u0430\u043F\u0440\u0435\u0449\u0451\u043D \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430.",
    'auth.dialog.error.unknown': "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437.",
    'auth.dialog.error.back': "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430\u0437\u0430\u0434",
    'user.profile': "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
    'user.logout': "\u0412\u044B\u0445\u043E\u0434",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430",
    'page_not_found.message': "\u042D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442.",
    'page_not_found.message2': "\u041D\u0443 \u043B\u0430\u0434\u043D\u043E, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442, \u043D\u043E \u0442\u0443\u0442 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u044B:",
    'page_not_found.items': [
        "\u0427\u0442\u043E-\u0442\u043E \u0431\u044B\u043B\u043E \u0437\u0434\u0435\u0441\u044C \u0440\u0430\u043D\u044C\u0448\u0435, \u043D\u043E \u0442\u0435\u043F\u0435\u0440\u044C \u044D\u0442\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E.",
        "\u0427\u0442\u043E-\u0442\u043E \u0432\u0441\u0451 \u0435\u0449\u0451 \u0437\u0434\u0435\u0441\u044C, \u043D\u043E \u0432\u044B \u043D\u0435 \u0438\u043C\u0435\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
        "\u0418\u043B\u0438 \u043F\u0440\u043E\u0441\u0442\u043E \u043A\u0442\u043E-\u0442\u043E \u043D\u0435\u0430\u043A\u043A\u0443\u0440\u0430\u0442\u043D\u043E \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043B \u0441\u0441\u044B\u043B\u043A\u0443."
    ],
    'home': "\u041D\u0430\u0447\u0430\u043B\u043E",
    'home.header.hint': "\u041E\u0431\u043B\u0430\u043A\u043E \u0434\u043B\u044F \u0438\u043D\u0434\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0432",
    'home.description': "\u041A\u0430\u0432\u044B\u0445\u0438.Cloud - \u044D\u0442\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0438\u043D\u0434\u0438 \u0438\u0433\u0440. \u041C\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u0435\u043C\u044B\u0435 \u0438 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u043D\u044B\u0435 \u0438\u0433\u0440\u044B, \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u044B\u0435 \u0438 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0435 \u0431\u0438\u043B\u0434\u044B, \u0432\u0435\u0442\u043A\u0438, \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439 \u0438 \u043C\u043D\u043E\u0433\u043E\u0435 \u0434\u0440\u0443\u0433\u043E\u0435.",
    'home.auth': "\u0412\u043E\u0439\u0442\u0438 \u0438\u043B\u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    'home.auth.hint': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0438\u043B\u0438 \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439",
    'projects': "\u041F\u0440\u043E\u0435\u043A\u0442\u044B",
    'projects.hint': "\u041F\u0440\u043E\u0435\u043A\u0442\u044B, \u043D\u0430\u0434 \u043A\u043E\u0442\u043E\u0440\u044B\u043C\u0438 \u0432\u044B \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442\u0435",
    'projects.project': (project)=>`\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442}: ${project}`,
    'projects.project.hint': "\u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.no_projects': "\u0423 \u0432\u0430\u0441 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432.",
    'projects.new': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.new_dialog.header': "\u041D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.new_dialog.label': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projects.new_dialog.ok': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.store_page': "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projects.description': "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    'projects.branches': "\u0412\u0435\u0442\u043A\u0438",
    'projects.versions': "\u0412\u0435\u0440\u0441\u0438\u0438",
    'projects.packages': "\u041F\u0430\u043A\u0435\u0442\u044B",
    'projects.management': "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C",
    'projects.management.breadcrumb': "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
    'projects.management.title': (projectTitle)=>`${projectTitle} - \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}`,
    'projects.management.hint': "\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C",
    'projects.management.users': "\u041A\u043E\u043C\u0430\u043D\u0434\u0430",
    'projects.management.users.empty': "\u0412 \u043A\u043E\u043C\u0430\u043D\u0434\u0435 \u043D\u0438\u043A\u043E\u0433\u043E \u043D\u0435\u0442.",
    'projects.management.users.role.tester': "\u0422\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0449\u0438\u043A",
    'projects.management.users.role.developer': "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
    'projects.management.users.role.admin': "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
    'projects.management.users.role.owner': "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446",
    'projects.management.users.role.starred': "\u0412 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u043C",
    'projects.management.users.exile': "\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'projects.management.users.exile.dialog.header': "\u0418\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C ",
            userTitle,
            " \u0438\u0437 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 ",
            projectTitle,
            "?"
        ],
    'projects.management.users.exile.dialog.ok': "\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'projects.management.invites.one_time_invite': "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
    'projects.management.invites.one_time_invite.header': "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
    'projects.management.invites.one_time_invite.message': "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F:",
    'projects.management.invites.one_time_invite.note': "\u0411\u0443\u0434\u0435\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C 24 \u0447\u0430\u0441\u0430, \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0440\u0430\u0437.",
    'projects.management.invites.new_dialog.header': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0434\u043B\u044F \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F",
    'projects.management.invites.new_dialog.expires': "\u0410\u043A\u0442\u0438\u0432\u043D\u0430:",
    'projects.management.invites.new_dialog.expires.indefinite': "\u0431\u0435\u0441\u0441\u0440\u043E\u0447\u043D\u043E",
    'projects.management.invites.new_dialog.approval.label': "\u0412\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u0432 \u043F\u0440\u043E\u0435\u043A\u0442:",
    'projects.management.invites.new_dialog.approval.not_approved': "\u043F\u043E\u0441\u043B\u0435 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C",
    'projects.management.invites.new_dialog.approval.approved': "\u0441\u0440\u0430\u0437\u0443",
    'projects.management.invites.new_dialog.seats': "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0442\u044C \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E:",
    'projects.management.invites.new_dialog.seats.no_limit': "(\u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F)",
    'projects.management.invites.new_dialog.ok': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'projects.management.deploy_sites': "\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438",
    'projects.management.deploy_sites.empty': "\u041D\u0435\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438.",
    'projects.management.deploy_sites.add': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443",
    'projects.management.deploy_sites.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    'projects.management.deploy_sites.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0446\u0435\u043B\u044C ",
            site,
            " \u043D\u0430 ",
            provider,
            "?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443",
    'projects.management.public_access': "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F",
    'projects.management.public_access.enable': "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F",
    'projects.management.public_access.enabled': [
        "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F: ",
        $3cf242074de6adb0$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E, \u043A\u0430\u043A \u0438 \u0432\u0435\u0442\u043A\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u044B \u0441\u0434\u0435\u043B\u0430\u043B\u0438 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u043C\u0438.",
    'projects.management.public_access.enable_dialog.header': "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 ",
            projectTitle,
            "?",
            $3cf242074de6adb0$var$_tmpl$2(),
            $3cf242074de6adb0$var$_tmpl$2(),
            "\u042D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0435\u0442 \u043E\u0441\u043D\u043E\u0432\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0439 \u0431\u0435\u0437 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438. \u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0439 \u0432\u0435\u0442\u043A\u0438, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0442\u0430\u043A\u043E\u0432\u043E\u0439."
        ],
    'projects.management.public_access.enable_dialog.ok': "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F",
    'projects.management.public_access.disable': "\u0417\u0430\u043F\u0440\u0435\u0442\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F",
    'projects.management.public_access.disabled': [
        "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F: ",
        $3cf242074de6adb0$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "\u041F\u0440\u043E\u0435\u043A\u0442 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u044B\u0439. \u0422\u043E\u043B\u044C\u043A\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0438\u043C\u0435\u0435\u0442 \u043A \u043D\u0435\u043C\u0443 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'projects.management.public_access.disable_dialog.header': "\u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u0438\u0435 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0437\u0430\u043F\u0440\u0435\u0442\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 ",
            projectTitle,
            "?"
        ],
    'projects.management.public_access.disable_dialog.ok': "\u0417\u0430\u043F\u0440\u0435\u0442\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F",
    'projects.management.public_access.branches': "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0435 \u0432\u0435\u0442\u043A\u0438",
    'projects.management.manage': "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C",
    'projects.rename': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.rename_dialog.header': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projects.rename_dialog.label': "\u0418\u043C\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430:",
    'projects.rename_dialog.ok': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.edit_description': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projects.edit_description_dialog.header': "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projects.edit_description_dialog.label': "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430:",
    'projects.edit_description_dialog.ok': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    'projects.leave': "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.leave_dialog.header': "\u0412\u044B\u0445\u043E\u0434 \u0438\u0437 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projects.leave_dialog.message': (projectTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 ",
            projectTitle,
            "?"
        ],
    'projects.leave_dialog.ok': "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'projects.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'projects.delete_dialog.message': (projectTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 ",
            projectTitle,
            "?"
        ],
    'projects.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "\u0432\u0435\u0442\u043A\u0430",
    'branches.no_branches': "\u0412 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442 \u0432\u0435\u0442\u043E\u043A.",
    'branches.new': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432\u0435\u0442\u043A\u0443",
    'branches.new_dialog.header': "\u041D\u043E\u0432\u0430\u044F \u0432\u0435\u0442\u043A\u0430",
    'branches.new_dialog.label': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0432\u0435\u0442\u043A\u0438",
    'branches.new_dialog.ok': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432\u0435\u0442\u043A\u0443",
    'branches.current_version': (version)=>[
            "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F: ",
            version
        ],
    'branches.current_version.packages': "\u041F\u0430\u043A\u0435\u0442\u044B \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u0432\u0435\u0440\u0441\u0438\u0438",
    'branches.no_current_version': "\u041D\u0435\u0442 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u0438",
    'branches.publish_version.new': "\u0417\u0430\u043F\u043E\u0441\u0442\u0438\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0432\u0435\u0440\u0441\u0438\u044E",
    'branches.publish_version.existing': "\u041F\u0435\u0440\u0435\u043F\u043E\u0441\u0442\u0438\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0443\u044E \u0432\u0435\u0440\u0441\u0438\u044E",
    'branches.version_history': "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0432\u0435\u0440\u0441\u0438\u0439",
    'branches.version_history.empty': "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0432\u0435\u0440\u0441\u0438\u0439 \u0432\u0435\u0442\u043A\u0438 \u043F\u0443\u0441\u0442\u0430.",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u0432\u0435\u0442\u043A\u0438 \u0445\u0440\u0430\u043D\u0438\u0442\u0441\u044F ",
            quotaTime != null ? quotaTime : "\u0431\u0435\u0441\u0441\u0440\u043E\u0447\u043D\u043E",
            ". \u0410\u0440\u0445\u0438\u0432\u043D\u044B\u0435 \u0432\u0435\u0440\u0441\u0438\u0438 \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 ",
            quotaNonCurrentTime,
            ". \u0412\u0441\u0435\u0433\u043E \u0434\u043B\u044F \u0432\u0435\u0442\u043A\u0438 \u0445\u0440\u0430\u043D\u0438\u0442\u0441\u044F \u043D\u0435 \u0431\u043E\u043B\u0435\u0435 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$3cf242074de6adb0$var$plural(quotaCount, [
                    quotaCountText,
                    " \u0432\u0435\u0440\u0441\u0438\u0438"
                ], [
                    quotaCountText,
                    " \u0432\u0435\u0440\u0441\u0438\u0439"
                ], [
                    quotaCountText,
                    " \u0432\u0435\u0440\u0441\u0438\u0439"
                ])),
            "."
        ],
    'branches.manage': "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0435\u0442\u043A\u043E\u0439",
    'branches.rename': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u0432\u0435\u0442\u043A\u0443",
    'branches.rename_dialog.header': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0435\u0442\u043A\u0438",
    'branches.rename_dialog.label': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0432\u0435\u0442\u043A\u0438:",
    'branches.rename_dialog.ok': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u0432\u0435\u0442\u043A\u0443",
    'branches.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0435\u0442\u043A\u0443",
    'branches.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0432\u0435\u0442\u043A\u0438",
    'branches.delete_dialog.message': (branchTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0435\u0442\u043A\u0443 ",
            branchTitle,
            "?"
        ],
    'branches.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0435\u0442\u043A\u0443",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "\u0432\u0435\u0440\u0441\u0438\u044F",
    'versions.current': "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F",
    'versions.previous': "\u0410\u0440\u0445\u0438\u0432\u043D\u0430\u044F",
    'versions.description': "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    'versions.deploy_to_site.header': "\u041F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435",
    'versions.deploy_to_site': "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435",
    'versions.packages': "\u041F\u0430\u043A\u0435\u0442\u044B",
    'versions.branches': "\u0412 \u0432\u0435\u0442\u043A\u0430\u0445",
    'versions.branches.publish': "\u0417\u0430\u043F\u043E\u0441\u0442\u0438\u0442\u044C \u0432 \u0432\u0435\u0442\u043A\u0443",
    'versions.branches.empty': "\u0412\u0435\u0440\u0441\u0438\u044F \u043D\u0435 \u043F\u043E\u0441\u0442\u0438\u043B\u0430\u0441\u044C \u043D\u0438 \u0432 \u043E\u0434\u043D\u043E\u0439 \u0432\u0435\u0442\u043A\u0435.",
    'versions.new_dialog.header': "\u041D\u043E\u0432\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F",
    'versions.new_dialog.label_title': "\u0412\u0435\u0440\u0441\u0438\u044F:",
    'versions.new_dialog.label_branch': "\u0412\u0435\u0442\u043A\u0430:",
    'versions.new_dialog.packages.header': "\u041F\u0430\u043A\u0435\u0442\u044B",
    'versions.new_dialog.packages.empty': "\u041D\u0435\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u0430\u043A\u0435\u0442\u043E\u0432.",
    'versions.new_dialog.packages.add': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'versions.new_dialog.packages.add_existing': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0436\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u043A\u0435\u0442",
    'versions.new_dialog.packages.replace': "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'versions.new_dialog.packages.edit': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'versions.new_dialog.ok': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'versions.manage': "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0435\u0439",
    'versions.rename': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'versions.rename_dialog.header': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0438",
    'versions.rename_dialog.label': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0438:",
    'versions.rename_dialog.ok': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'versions.edit_description': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0438",
    'versions.edit_description_dialog.header': "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0432\u0435\u0440\u0441\u0438\u0438",
    'versions.edit_description_dialog.label': "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0438:",
    'versions.edit_description_dialog.ok': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    'versions.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'versions.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0438",
    'versions.delete_dialog.message': (versionTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E ",
            versionTitle,
            "?"
        ],
    'versions.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'versions.publish_dialog.header': "\u0417\u0430\u043F\u043E\u0441\u0442\u0438\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'versions.publish_dialog.message': (versionTitle)=>[
            "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0435\u0442\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043F\u043E\u0441\u0442\u0438\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E ",
            versionTitle,
            "."
        ],
    'versions.publish_dialog.no_branches': "\u0412 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u043D\u0435\u0442 \u0432\u0435\u0442\u043E\u043A.",
    'versions.publish_dialog.ok': "\u0417\u0430\u043F\u043E\u0441\u0442\u0438\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'versions.publish_existing_dialog.header': "\u041F\u0435\u0440\u0435\u043F\u043E\u0441\u0442 \u0432\u0435\u0440\u0441\u0438\u0438",
    'versions.publish_existing_dialog.message': "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0438:",
    'versions.publish_existing_dialog.no_versions': "\u0412 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u043D\u0435\u0442 \u0432\u0435\u0440\u0441\u0438\u0439.",
    'versions.publish_existing_dialog.ok': "\u0417\u0430\u043F\u043E\u0441\u0442\u0438\u0442\u044C \u0432\u0435\u0440\u0441\u0438\u044E",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': "\u041F\u0430\u043A\u0435\u0442",
    'packages.download_zip': "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432 ZIP",
    'packages.download_torrent': "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0442\u043E\u0440\u0440\u0435\u043D\u0442",
    'packages.total_size': (size)=>[
            "\u0412\u0441\u0435\u0433\u043E \u043E\u0431\u044A\u0451\u043C: ",
            size
        ],
    'packages.manage': "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u043A\u0435\u0442\u043E\u043C",
    'packages.rename': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'packages.rename_dialog.header': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u0430\u043A\u0435\u0442\u0430",
    'packages.rename_dialog.label': "\u0418\u043C\u044F \u043F\u0430\u043A\u0435\u0442\u0430:",
    'packages.rename_dialog.ok': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'packages.edit_tags': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0435\u0433\u0438 \u043F\u0430\u043A\u0435\u0442\u0430",
    'packages.edit_tags_dialog.header': "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0442\u0435\u0433\u043E\u0432 \u043F\u0430\u043A\u0435\u0442\u0430",
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u0435\u0433\u0438 \u0434\u043B\u044F \u043F\u0430\u043A\u0435\u0442\u0430 ",
            packageTitle,
            ":"
        ],
    'packages.edit_tags_dialog.ok': "\u0423\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0435\u0433\u0438 \u043F\u0430\u043A\u0435\u0442\u0430",
    'packages.entrypoint': (entrypoint)=>[
            "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B: ",
            entrypoint
        ],
    'packages.entrypoint.empty': "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D.",
    'packages.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'packages.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u043A\u0435\u0442\u0430",
    'packages.delete_dialog.message': (packageTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442 ",
            packageTitle,
            "? \u041F\u0430\u043A\u0435\u0442 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0451\u043D \u0438\u0437 \u0432\u0441\u0435\u0445 \u0432\u0435\u0440\u0441\u0438\u0439, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u043D \u0431\u044B\u043B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D."
        ],
    'packages.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'packages.new_dialog.header': "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u043A\u0435\u0442",
    'packages.new_dialog.label_title': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435:",
    'packages.new_dialog.title_placeholder': "(\u0438\u0437 \u0442\u0435\u0433\u043E\u0432)",
    'packages.new_dialog.tags.header': "\u0422\u0435\u0433\u0438",
    'packages.new_dialog.files.header': "\u0424\u0430\u0439\u043B\u044B",
    'packages.new_dialog.total_size': (size, maximum)=>[
            "\u0412\u0441\u0435\u0433\u043E \u043E\u0431\u044A\u0451\u043C: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(\u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "\u041E\u0431\u044A\u0451\u043C \u043D\u043E\u0432\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445: ",
            size
        ],
    'packages.new_dialog.checks.empty': "\u0424\u0430\u0439\u043B\u044B \u043D\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B.",
    'packages.new_dialog.checks.entrypoint.empty': "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D.",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B ",
            entrypoint,
            " \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442; \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0432\u044B \u0437\u0430\u0431\u044B\u043B\u0438 \u0435\u0433\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C? \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B, \u0438\u043B\u0438 \u043D\u0435 \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0439\u0442\u0435 \u043D\u0438\u043A\u0430\u043A\u043E\u0433\u043E."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "\u041D\u0435 \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B \u0438\u043C\u0435\u0435\u0442 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 ",
            fileExt,
            ": \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u0442\u0435\u0433 ",
            tag,
            "."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0435\u0433 ",
            tag
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B \u0438\u043C\u0435\u0435\u0442 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 ",
            fileExt,
            ": \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0442\u0435\u0433 ",
            tag,
            ", \u0447\u0442\u043E\u0431\u044B \u043F\u0430\u043A\u0435\u0442 \u043C\u043E\u0436\u043D\u043E \u0431\u044B\u043B\u043E \u0437\u0430\u043F\u0443\u0441\u043A\u0430\u0442\u044C \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B \u0438\u043C\u0435\u0435\u0442 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 ",
            fileExt,
            ": \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u044D\u0442\u043E \u043E\u0448\u0438\u0431\u043A\u0430? \u041E\u0431\u044B\u0447\u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0444\u0430\u0439\u043B \u043D\u0435\u043B\u044C\u0437\u044F \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B \u0438\u043C\u0435\u0435\u0442 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 ",
            fileExt,
            ": \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0442\u044C \u0441\u0430\u043C\u0438 \u0444\u0430\u0439\u043B\u044B \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0430 \u043D\u0435 \u0443\u043F\u0430\u043A\u043E\u0432\u044B\u0432\u0430\u0442\u044C \u0438\u0445 \u0432 \u0430\u0440\u0445\u0438\u0432\u043D\u044B\u0439 \u0444\u0430\u0439\u043B."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B \u043D\u0435 \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0438\u0441\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0439",
    'packages.new_dialog.checks.entrypoint.executable.action': "\u041F\u043E\u043C\u0435\u0442\u0438\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u043C",
    'packages.new_dialog.checks.single_root_dir': "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F \u043A\u043B\u0430\u0441\u0442\u044C \u0444\u0430\u0439\u043B\u044B \u043D\u0435\u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u0432 \u043A\u043E\u0440\u0435\u043D\u044C, \u0430 \u043D\u0435 \u0438\u043C\u0435\u0442\u044C \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u0443\u044E \u043F\u0430\u043F\u043A\u0443.",
    'packages.new_dialog.checks.single_root_dir.action': "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u043A\u043E\u0440\u043D\u0435\u0432\u0443\u044E \u043F\u0430\u043F\u043A\u0443 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u044B\u043C",
    'packages.add_existing_dialog.header': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `\u{414}\u{43E}\u{431}\u{430}\u{432}\u{438}\u{442}\u{44C} ${$3cf242074de6adb0$var$plural(packagesCount, `${packagesCount} \u{43F}\u{430}\u{43A}\u{435}\u{442}`, `${packagesCount} \u{43F}\u{430}\u{43A}\u{435}\u{442}\u{430}`, `${packagesCount} \u{43F}\u{430}\u{43A}\u{435}\u{442}\u{43E}\u{432}`)}` : "\u041F\u0430\u043A\u0435\u0442\u044B \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u044B",
    'packages.add_existing_dialog.message': "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u0430\u043A\u0435\u0442\u044B:",
    'packages.add_existing_dialog.no_packages': "\u041D\u0435\u0442 \u043D\u0435\u0434\u0430\u0432\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0445 \u043F\u0430\u043A\u0435\u0442\u043E\u0432.",
    'packages.launch': "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C",
    'packages.install': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
    'packages.install_dialog.header': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430",
    'packages.install_dialog.workdir.label': "\u041F\u0430\u043F\u043A\u0430:",
    'packages.install_dialog.workdir.value.new': "(\u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E)",
    'packages.install_dialog.workspace.label': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0430\u043F\u043A\u0443 \u0432:",
    'packages.install_dialog.workspace.placeholder': "(\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0440\u043D\u0435\u0432\u0443\u044E \u043F\u0430\u043F\u043A\u0443)",
    'packages.install_dialog.ok': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
    'packages.update': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'packages.upload.status.existing': "\u0418\u0437 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u0439 \u0432\u0435\u0440\u0441\u0438\u0438",
    'packages.upload.status.queued': "\u0412 \u043E\u0447\u0435\u0440\u0435\u0434\u0438",
    'packages.upload.status.packing': "\u0423\u043F\u0430\u043A\u043E\u0432\u043A\u0430...",
    'packages.upload.status.creating': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435...",
    'packages.upload.status.create_retrying': "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F, \u043F\u043E\u0432\u0442\u043E\u0440 \u043F\u043E\u0441\u043B\u0435 \u043F\u0430\u0443\u0437\u044B",
    'packages.upload.status.splitting': "\u041D\u0430\u0440\u0435\u0437\u043A\u0430...",
    'packages.upload.status.uploading': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
    'packages.upload.status.finalizing': "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435...",
    'packages.upload.status.finalize_retrying': "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F, \u043F\u043E\u0432\u0442\u043E\u0440 \u043F\u043E\u0441\u043B\u0435 \u043F\u0430\u0443\u0437\u044B",
    'packages.upload.status.resolving': "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u0430\u0442\u0447\u0430...",
    'packages.upload.status.resolve_retrying': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0430\u0442\u0447\u0430, \u043F\u043E\u0432\u0442\u043E\u0440 \u043F\u043E\u0441\u043B\u0435 \u043F\u0430\u0443\u0437\u044B...",
    'packages.upload.status.done': "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E",
    'packages.upload.status.errored': "\u041E\u0448\u0438\u0431\u043A\u0430",
    'packages.upload.part.status.queued': "\u0412 \u043E\u0447\u0435\u0440\u0435\u0434\u0438",
    'packages.upload.part.status.hashing': "\u0425\u0435\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
    'packages.upload.part.status.upload_queued': "\u0412 \u043E\u0447\u0435\u0440\u0435\u0434\u0438 \u043D\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0443",
    'packages.upload.part.status.uploading': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    'packages.upload.part.status.upload_retrying': "\u041E\u0448\u0438\u0431\u043A\u0430, \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    'packages.upload.part.status.upload_finalizing': "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438",
    'packages.upload.part.status.upload_errored': "\u041E\u0448\u0438\u0431\u043A\u0430",
    'packages.upload.part.status.done': "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E",
    'packages.play': "\u0418\u0433\u0440\u0430\u0442\u044C \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435",
    'packages.play.reset': "\u041F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C",
    'packages.play.fullscreen': "\u041D\u0430 \u043F\u043E\u043B\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D",
    'deploy_sites.add_dialog.header': "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043B\u044E\u0447 \u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 URL \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435, \u0447\u0442\u043E\u0431\u044B \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 ",
            projectTitle,
            "."
        ],
    'deploy_sites.add_dialog.label_credential': "\u041A\u043B\u044E\u0447 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438:",
    'deploy_sites.add_dialog.select_credential': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043B\u044E\u0447",
    'deploy_sites.add_dialog.select_credential.new': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u043B\u044E\u0447...",
    'deploy_sites.add_dialog.label_select_site': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0430\u0439\u0442:",
    'deploy_sites.add_dialog.select_credential_first': "(\u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043B\u044E\u0447)",
    'deploy_sites.add_dialog.select_site': "(\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0430\u0439\u0442)",
    'deploy_sites.add_dialog.label_enter_site': "\u0418\u043B\u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 URL:",
    'deploy_sites.add_dialog.ok': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443",
    'deploy_to_site_dialog.header': "\u041F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u044F \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443 \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0432\u0435\u0440\u0441\u0438\u0438 ",
            versionTitle,
            " \u043F\u0440\u043E\u0435\u043A\u0442\u0430 ",
            projectTitle,
            "."
        ],
    'deploy_to_site_dialog.label_site': "\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430:",
    'deploy_to_site_dialog.select_site': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443",
    'deploy_to_site_dialog.select_site.new': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438...",
    'deploy_to_site_dialog.packages.message.itch': [
        "\u041F\u0430\u043A\u0435\u0442\u044B \u0431\u0443\u0434\u0443\u0442 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u044B \u043D\u0430 itch.io \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E ",
        $3cf242074de6adb0$var$_tmpl$4(),
        ". \u0418\u043C\u0435\u043D\u0430 \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u0444\u043E\u0440\u043C\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0438\u0437 \u0442\u0435\u0433\u043E\u0432 \u043F\u0430\u043A\u0435\u0442\u043E\u0432."
    ],
    'deploy_to_site_dialog.deploy': "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C",
    'deploy_to_site_dialog.close': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'deploy_to_site_dialog.error.no_packages': "\u041D\u0435\u0442 \u043F\u0430\u043A\u0435\u0442\u043E\u0432 \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438.",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "\u041D\u0435\u043B\u044C\u0437\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u0430\u043A\u0435\u0442\u043E\u0432 \u0432 \u043E\u0434\u0438\u043D \u043A\u0430\u043D\u0430\u043B. \u0421\u0435\u0439\u0447\u0430\u0441 \u043D\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u044E \u0432 \u043A\u0430\u043D\u0430\u043B ",
            channel,
            " \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043D\u044B ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$3cf242074de6adb0$var$plural(packagesCount, [
                    packagesCountText,
                    " \u043F\u0430\u043A\u0435\u0442"
                ], [
                    packagesCountText,
                    " \u043F\u0430\u043A\u0435\u0442\u0430"
                ], [
                    packagesCountText,
                    " \u043F\u0430\u043A\u0435\u0442\u043E\u0432"
                ])),
            "."
        ],
    'deploy_to_site_dialog.job.queued': "\u0412 \u043E\u0447\u0435\u0440\u0435\u0434\u0438",
    'deploy_to_site_dialog.job.downloading': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
    'deploy_to_site_dialog.job.unpacking': "\u0420\u0430\u0441\u043F\u0430\u043A\u043E\u0432\u043A\u0430...",
    'deploy_to_site_dialog.job.uploading': "\u041F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u044F...",
    'deploy_to_site_dialog.job.succeeded': "\u0423\u0441\u043F\u0435\u0448\u043D\u043E",
    'deploy_to_site_dialog.job.errored': "\u041E\u0448\u0438\u0431\u043A\u0430",
    'store': "\u0412\u0438\u0442\u0440\u0438\u043D\u0430",
    'store.hint': "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B",
    'store.project.hint': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'store.project.owner': "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
    'store.project.description': "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
    'store.project.star': "\u0412 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435",
    'store.project.starred': "\u0412 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u043C",
    'store.project.content': "\u041A\u043E\u043D\u0442\u0435\u043D\u0442",
    'store.project.content.warning': "\u041A\u043E\u043D\u0442\u0435\u043D\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u043C \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u043C.",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            "\u0412\u0435\u0442\u043A\u0430 ",
            branchTitle,
            ": \u0432\u0435\u0440\u0441\u0438\u044F ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043E: ",
            branchVersionPublished
        ],
    'me': "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
    'me.hint': "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0438 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B",
    'me.rename': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
    'me.rename_dialog.header': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044F",
    'me.rename_dialog.label_title': "\u0418\u043C\u044F:",
    'me.rename_dialog.ok': "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C",
    'me.credentials': "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B",
    'me.credentials.hint.auth_allowed': "\u041B\u044E\u0431\u043E\u0439 \u0438\u0437 \u044D\u0442\u0438\u0445 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u0432 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430.",
    'me.credentials.hint.auth_disallowed': "\u042D\u0442\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u044B, \u043D\u043E \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u044B \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430.",
    'me.credentials.empty': "\u041D\u0435\u0442 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u0432.",
    'me.credentials.empty.auth_allowed.warning': "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u0442\u044C \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442! \u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u0438\u0432\u044F\u0436\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u043A\u0430\u043A \u043C\u043E\u0436\u043D\u043E \u0441\u043A\u043E\u0440\u0435\u0435.",
    'me.credentials.profile_picture.alt': (provider)=>`\u{41A}\u{430}\u{440}\u{442}\u{438}\u{43D}\u{43A}\u{430} \u{43F}\u{440}\u{43E}\u{444}\u{438}\u{43B}\u{44F} ${$3cf242074de6adb0$var$dict[`auth.provider.${provider}`]}`,
    'me.credentials.created': (created)=>[
            "\u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\u0432\u0445\u043E\u0434 ",
            lastUsed
        ],
    'me.credential.unlink': "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C",
    'me.credential.allow_auth': "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0432\u0445\u043E\u0434",
    'me.credential.disallow_auth': "\u0417\u0430\u043F\u0440\u0435\u0442\u0438\u0442\u044C \u0432\u0445\u043E\u0434",
    'me.credential.display_publicly': "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E",
    'me.credential.dont_display_publicly': "\u041D\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E",
    'me.credential.link': "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    'me.credential.link_dialog.header': "\u041F\u0440\u0438\u0432\u044F\u0437\u043A\u0430 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    'me.credential.link_dialog.message': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u0434\u043B\u044F \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0438.",
    'me.credential.unlink_dialog.header': "\u041E\u0442\u0432\u044F\u0437\u043A\u0430 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442 ",
            credentialTitle,
            " \u043D\u0430 ",
            credentialProvider,
            " \u043E\u0442 \u0432\u0430\u0448\u0435\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u041A\u0430\u0432\u044B\u0445\u0438.Cloud?"
        ],
    'me.credential.unlink_dialog.ok': "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    'me.sessions': "\u0421\u0435\u0441\u0441\u0438\u0438",
    'me.sessions.hint': "\u042D\u0442\u043E \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u0430\u0448\u0438\u0445 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0441\u0435\u0441\u0441\u0438\u0439, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440.",
    'me.sessions.started': (started)=>[
            "\u0441\u043E\u0437\u0434\u0430\u043D\u0430 ",
            (()=>{
                var _el$6 = $3cf242074de6adb0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "\u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C ",
            (()=>{
                var _el$7 = $3cf242074de6adb0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0441\u0435\u0441\u0441\u0438\u044F",
    'me.sessions.empty': "\u041D\u0435\u0442 \u0441\u0435\u0441\u0441\u0438\u0439.",
    'me.sessions.delete': "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C",
    'me.sessions.delete_dialog.header': "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0441\u0435\u0441\u0441\u0438\u0438",
    'me.sessions.delete_dialog.message': "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u044D\u0442\u0443 \u0441\u0435\u0441\u0441\u0438\u044E?",
    'me.sessions.delete_dialog.ok': "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0441\u0435\u0441\u0441\u0438\u044E",
    'me.api_tokens': "API \u0442\u043E\u043A\u0435\u043D\u044B",
    'me.api_tokens.hint': "\u0417\u0434\u0435\u0441\u044C \u043C\u043E\u0436\u043D\u043E \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C API \u0442\u043E\u043A\u0435\u043D\u044B, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0438\u0445 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u0441 \u043E\u0431\u043B\u0430\u043A\u043E\u043C.",
    'me.api_tokens.started': (started)=>[
            "\u0441\u043E\u0437\u0434\u0430\u043D ",
            (()=>{
                var _el$8 = $3cf242074de6adb0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "\u043F\u0440\u043E\u0442\u0443\u0445\u043D\u0435\u0442 ",
            (()=>{
                var _el$9 = $3cf242074de6adb0$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "\u0432\u0435\u0447\u043D\u044B\u0439",
    'me.api_tokens.empty': "\u041D\u0435\u0442 API \u0442\u043E\u043A\u0435\u043D\u043E\u0432.",
    'me.api_tokens.create': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C API \u0442\u043E\u043A\u0435\u043D",
    'me.api_tokens.create_dialog.header': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 API \u0442\u043E\u043A\u0435\u043D\u0430",
    'me.api_tokens.create_dialog.message': "API \u0442\u043E\u043A\u0435\u043D \u0441\u043E\u0437\u0434\u0430\u043D:",
    'me.api_tokens.create_dialog.note': "\u0422\u043E\u043A\u0435\u043D \u043D\u0435\u043B\u044C\u0437\u044F \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0435\u0449\u0451 \u0440\u0430\u0437, \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0435\u0433\u043E \u0441\u0435\u0439\u0447\u0430\u0441.",
    'me.api_tokens.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    'me.api_tokens.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 API \u0442\u043E\u043A\u0435\u043D\u0430",
    'me.api_tokens.delete_dialog.message': "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 API \u0442\u043E\u043A\u0435\u043D?",
    'me.api_tokens.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C API \u0442\u043E\u043A\u0435\u043D",
    'me.deploy_credentials': "\u041A\u043B\u044E\u0447\u0438 \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438",
    'me.deploy_credentials.hint': "\u0417\u0434\u0435\u0441\u044C \u043C\u043E\u0436\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043B\u044E\u0447\u0438 \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u0430 \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0445 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430\u0445.",
    'me.deploy_credentials.empty': "\u041D\u0435\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u043A\u043B\u044E\u0447\u0435\u0439 \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438.",
    'me.deploy_credential.add': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043B\u044E\u0447",
    'me.deploy_credential.add_dialog.header': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043B\u044E\u0447",
    'me.deploy_credential.add_dialog.label_site': "\u0421\u0430\u0439\u0442:",
    'me.deploy_credential.add_dialog.label_title': "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435:",
    'me.deploy_credential.add_dialog.label_key': "\u041A\u043B\u044E\u0447:",
    'me.deploy_credential.add_dialog.default_title': (date)=>`\u{41A}\u{43B}\u{44E}\u{447} ${date}`,
    'me.deploy_credential.add_dialog.ok': "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043B\u044E\u0447",
    'me.deploy_credential.add_dialog.hint.itch': [
        "\u0427\u0442\u043E\u0431\u044B \u0441\u0433\u0435\u043D\u0435\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C API \u043A\u043B\u044E\u0447 itch.io, \u0437\u0430\u0439\u0434\u0438\u0442\u0435 \u0432 ",
        $3cf242074de6adb0$var$_tmpl$6(),
        " \u043D\u0430 itch.io. \u0415\u0441\u043B\u0438 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C API \u043A\u043B\u044E\u0447 \u0441 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C \"web\" \u0438\u043B\u0438 \"wharf\", \u043C\u043E\u0436\u043D\u043E \u0432\u0437\u044F\u0442\u044C \u0435\u0433\u043E. \u041A\u043B\u044E\u0447 \u0441 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C \"Kavykhi.Cloud\" \u0437\u0434\u0435\u0441\u044C \u043D\u0435 \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043B\u044E\u0447\u0430 ",
            credentialProvider,
            " \u0434\u043B\u044F \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043F\u043E\u043A\u0430 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F."
        ],
    'me.deploy_credential.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    'me.deploy_credential.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043A\u043B\u044E\u0447\u0430",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043B\u044E\u0447 ",
            credentialTitle,
            " \u0434\u043B\u044F ",
            credentialProvider,
            "? \u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0449\u0438\u0435 \u044D\u0442\u043E\u0442 \u043A\u043B\u044E\u0447, \u0431\u0443\u0434\u0443\u0442 \u0442\u0430\u043A\u0436\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438\u0437 \u043F\u0440\u043E\u0435\u043A\u0442\u0430."
        ],
    'me.deploy_credential.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043B\u044E\u0447",
    'me.public_profile': "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
    'me.public_profile.public_credentials': "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B",
    'me.public_profile.public_credentials.hint': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0431\u0443\u0434\u0443\u0442 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F.",
    'me.manage': "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C",
    'me.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    'me.delete.dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    'me.delete.dialog.message': (userTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0431\u0435\u0437\u0432\u043E\u0437\u0432\u0440\u0430\u0442\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u041A\u0430\u0432\u044B\u0445\u0438.Cloud ",
            userTitle,
            "?"
        ],
    'me.delete.dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    'invite': "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435",
    'invite.hint': "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0432 \u043F\u0440\u043E\u0435\u043A\u0442",
    'invite.message.already_member': (projectTitle)=>[
            "\u0412\u044B \u0443\u0436\u0435 \u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 ",
            projectTitle,
            "."
        ],
    'invite.message.join': (projectTitle)=>[
            "\u0412\u044B \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u044B \u0432 \u043F\u0440\u043E\u0435\u043A\u0442 ",
            projectTitle,
            "."
        ],
    'invite.join': "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443",
    'local': "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442",
    'local.hint': "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442",
    'local.workdirs': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043F\u0430\u043A\u0435\u0442\u044B",
    'local.workdirs.empty': "\u041D\u0435\u0442 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u0430\u043A\u0435\u0442\u043E\u0432.",
    'local.workdir.action.launch': "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C",
    'local.workdir.action.repair': "\u0418\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'local.workdir.action.delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    'local.workdir.delete_dialog.header': "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u043A\u0435\u0442\u0430",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0430\u043A\u0435\u0442 ",
            packageTitle,
            " \u0441 \u044D\u0442\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430?"
        ],
    'local.workdir.delete_dialog.ok': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    'local.workspaces': "\u041A\u043E\u0440\u043D\u0435\u0432\u044B\u0435 \u043F\u0430\u043F\u043A\u0438",
    'local.app_not_detected.message': "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u041A\u0430\u0432\u044B\u0445 \u043D\u0435 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u043A\u0430\u0447\u0430\u0439\u0442\u0435 \u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0435\u0433\u043E \u043F\u043E \u043E\u0434\u043D\u043E\u0439 \u0438\u0437 \u0441\u0441\u044B\u043B\u043E\u043A \u0432\u043D\u0438\u0437\u0443. \u0415\u0441\u043B\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0443\u0436\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E, \u0443\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u043E\u043D\u043E \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u043E.",
    'local_app.detected': "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442",
    'error_dialog.header': "\u041E\u0448\u0438\u0431\u043A\u0430",
    'error_dialog.messageFunc': (e)=>`\u{41E}\u{448}\u{438}\u{431}\u{43A}\u{430}: ${$3cf242074de6adb0$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0444\u0430\u0439\u043B\u044B",
    'upload_box.choose_directories': "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u0430\u043F\u043A\u0438",
    'upload_box.add.progress_dialog.header': "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u043E\u0432",
    'upload_box.add.progress_dialog.message': "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u0444\u0430\u0439\u043B\u043E\u0432...",
    'upload_box.delete': (itemsCount)=>`\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} ${$3cf242074de6adb0$var$plural(itemsCount, `${itemsCount} \u{444}\u{430}\u{439}\u{43B}`, `${itemsCount} \u{444}\u{430}\u{439}\u{43B}\u{430}`, `${itemsCount} \u{444}\u{430}\u{439}\u{43B}\u{43E}\u{432}`)}`,
    'upload_box.start_upload': "\u041D\u0430\u0447\u0430\u0442\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0443",
    'upload_box.drop_area.message': "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B \u0438 \u043F\u0430\u043F\u043A\u0438 \u0441\u044E\u0434\u0430",
    'upload_box.drop_area.box_dropping_message': "\u041E\u0442\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u043E\u0436\u0438\u0442\u044C \u0432 \u043A\u043E\u0440\u0435\u043D\u044C",
    'upload_box.entry.explode_folder': "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u043F\u043A\u0443 \u0435\u0451 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u044B\u043C",
    'upload_box.entry.set_entrypoint': "\u0423\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u0444\u0430\u0439\u043B",
    'upload_box.entry.mark_executable': "\u041F\u043E\u043C\u0435\u0442\u0438\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u043C",
    'upload_box.entry.unmark_executable': "\u0423\u0431\u0440\u0430\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u043E\u0441\u0442\u044C",
    'upload_box.entry.remove': "\u0423\u0431\u0440\u0430\u0442\u044C",
    'package.tags.empty': "(\u043D\u0435\u0442 \u0442\u0435\u0433\u043E\u0432)",
    'package.tag.os': "\u041E\u0421",
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': "\u0410\u0440\u0445\u0438\u0442\u0435\u043A\u0442\u0443\u0440\u0430",
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': "\u0411\u0438\u0442\u043D\u043E\u0441\u0442\u044C",
    'package.tag.bits:64': "64 \u0431\u0438\u0442\u0430",
    'package.tag.bits:32': "32 \u0431\u0438\u0442\u0430",
    'package.tag.packaging': "\u041F\u0430\u043A\u0435\u0442",
    'package.tag.packaging:installer': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0449\u0438\u043A",
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442",
    'package.tag.component:client': "\u041A\u043B\u0438\u0435\u043D\u0442",
    'package.tag.component:server': "\u0421\u0435\u0440\u0432\u0435\u0440",
    'package.tag.runtime': "\u0421\u0440\u0435\u0434\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "\u0414\u0438\u0441\u0442\u0440\u0438\u0431\u0443\u0442\u0438\u0432 Linux",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F",
    'docs.page_no_language': "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u043D\u0430 \u044D\u0442\u043E\u043C \u044F\u0437\u044B\u043A\u0435",
    'docs.page_no_language.message': "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u0440\u0443\u0433\u0438\u0435 \u0432\u0435\u0440\u0441\u0438\u0438 \u044D\u0442\u043E\u0433\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "\u041F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043A\u043E\u043D\u0442\u0435\u043D\u0442",
    'report_content.dialog.header': "\u0416\u0430\u043B\u043E\u0431\u0430 \u043D\u0430 \u043A\u043E\u043D\u0442\u0435\u043D\u0442",
    'report_content.dialog.link': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0436\u0430\u043B\u043E\u0431\u0443 \u043F\u043E email",
    'report_content.dialog.message': (email, link)=>[
            "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0441\u0441\u044B\u043B\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0436\u0430\u043B\u043E\u0431\u0443:",
            $3cf242074de6adb0$var$_tmpl$2(),
            $3cf242074de6adb0$var$_tmpl$2(),
            link,
            $3cf242074de6adb0$var$_tmpl$2(),
            $3cf242074de6adb0$var$_tmpl$2(),
            "\u0418\u043B\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u043D\u0430 ",
            email
        ]
};
var $3cf242074de6adb0$export$2e2bcd8739ae039 = $3cf242074de6adb0$var$dict;
const $3cf242074de6adb0$var$plural = (n, one, few, many)=>{
    if (Math.floor(n / 10) % 10 == 1) return many;
    n %= 10;
    if (n == 0 || n >= 5) return many;
    if (n == 1) return one;
    return few;
};



var $fc6769ef69036635$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>izin verildi`), $fc6769ef69036635$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $fc6769ef69036635$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>izin verilmedi`), $fc6769ef69036635$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $fc6769ef69036635$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $fc6769ef69036635$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>profil ayarlar\u{131}n\u{131}za`);
const $fc6769ef69036635$var$dict = {
    languageName: "T\xfcrk\xe7e",
    locale: 'tr',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: 'Tema',
    'theme.light': "A\xe7\u0131k",
    'theme.dark': 'Koyu',
    'theme.system': 'Sistem',
    'theme.sakura': 'Sakura',
    // generic
    email: 'E-posta',
    password: "\u015Eifre",
    ok: 'Tamam',
    cancel: "\u0130ptal",
    retry: 'Yeniden Dene',
    copy: 'Kopyala',
    empty: "(\xf6\u011Fe yok)",
    loading: "Y\xfckleniyor...",
    calculating: "Hesaplan\u0131yor...",
    error: 'Hata',
    'in_development': "Bu sayfa geli\u015Ftirme a\u015Famas\u0131ndad\u0131r.",
    // errors
    'error.not_found': "bulunamad\u0131",
    'error.name_conflict': "isim \xe7ak\u0131\u015Fmas\u0131",
    'error.bad_param': "ge\xe7ersiz parametre",
    'error.wrong_auth': "yanl\u0131\u015F kimlik do\u011Frulama",
    'error.unauthorized': 'yetkisiz',
    'error.wrong_credentials': "yanl\u0131\u015F kimlik bilgileri",
    'error.wrong_provider': "yanl\u0131\u015F sa\u011Flay\u0131c\u0131",
    'error.insufficient_privileges': 'yetersiz yetki',
    'error.not_empty': "bo\u015F de\u011Fil",
    'error.limit_exceeded': "limit a\u015F\u0131ld\u0131",
    'error.already_member': "zaten \xfcye",
    'error.not_finalized': "tamamlanmad\u0131",
    'error.already_finalized': "zaten tamamland\u0131",
    'error.unexpected_patch': 'beklenmedik yama',
    'error.timeout': "zaman a\u015F\u0131m\u0131",
    'error.not_patch': "yama de\u011Fil",
    'error.not_supported': 'desteklenmiyor',
    'error.unexpected_error': 'beklenmedik hata',
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "Kimlik Do\u011Frulama",
    'auth.dialog.please_select': "Giri\u015F yapmak i\xe7in l\xfctfen hesap sa\u011Flay\u0131c\u0131n\u0131z\u0131 se\xe7in.",
    'auth.dialog.redirecting_to': (provider)=>`${provider} sayfas\u{131}na y\xf6nlendiriliyorsunuz...`,
    'auth.dialog.remember_me': "Beni hat\u0131rla",
    'auth.dialog.log_in': "Giri\u015F yap",
    'auth.dialog.back': 'Geri',
    'auth.dialog.progress_header': "Kimlik do\u011Frulan\u0131yor...",
    'auth.dialog.error.header': "Kimlik do\u011Frulama hatas\u0131",
    'auth.dialog.error.auth_not_allowed': "Bu kimlik bilgisinin kimlik do\u011Frulama i\xe7in kullan\u0131lmas\u0131 kullan\u0131c\u0131 taraf\u0131ndan yasaklanm\u0131\u015Ft\u0131r. L\xfctfen ba\u015Fka bir kimlik bilgisi kullan\u0131n.",
    'auth.dialog.error.unknown': "Ge\xe7ersiz kimlik do\u011Frulama parametreleri. L\xfctfen tekrar deneyin.",
    'auth.dialog.error.back': "Geri d\xf6n",
    'user.profile': 'Profil',
    'user.logout': "\xc7\u0131k\u0131\u015F yap",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "Sayfa bulunamad\u0131",
    'page_not_found.message': "Bu sayfa mevcut de\u011Fil.",
    'page_not_found.message2': "Asl\u0131nda bir nevi mevcut, ancak burada hi\xe7bir \u015Fey yok. Olas\u0131l\u0131klar \u015Funlard\u0131r:",
    'page_not_found.items': [
        "Daha \xf6nce burada bir \u015Fey vard\u0131, ancak \u015Fimdi silindi.",
        "Burada hala bir \u015Fey var, ancak eri\u015Fiminiz yok.",
        "Veya birisi ba\u011Flant\u0131y\u0131 kopyalay\u0131p yap\u0131\u015Ft\u0131r\u0131rken dikkatli davranmad\u0131."
    ],
    'home': 'Ana Sayfa',
    'home.header.hint': "Ba\u011F\u0131ms\u0131z geli\u015Ftiriciler i\xe7in bulut ara\xe7lar\u0131",
    'home.description': "Kavykhi.Cloud, ba\u011F\u0131ms\u0131z oyunlar i\xe7in bir geli\u015Ftirme platformudur. \u0130ndirilebilir ve taray\u0131c\u0131 oyunlar\u0131n\u0131, \xf6zel ve genel s\xfcr\xfcmleri, dallar\u0131, ekipleri ve \xe7ok daha fazlas\u0131n\u0131 destekliyoruz.",
    'home.auth': "Giri\u015F yap veya kaydol",
    'home.auth.hint': "Yeni hesap olu\u015Fturun veya mevcut hesaba giri\u015F yap\u0131n",
    'projects': 'Projeler',
    'projects.hint': "\xdczerinde \xe7al\u0131\u015Ft\u0131\u011F\u0131n\u0131z projeler",
    'projects.project': (project)=>`Proje: ${project}`,
    'projects.project.hint': 'proje',
    'projects.no_projects': "Hen\xfcz hi\xe7 projeniz yok.",
    'projects.new': "Proje olu\u015Ftur",
    'projects.new_dialog.header': 'Yeni proje',
    'projects.new_dialog.label': "Proje ad\u0131",
    'projects.new_dialog.ok': "Proje olu\u015Ftur",
    'projects.store_page': "Genel ma\u011Faza sayfas\u0131",
    'projects.description': "A\xe7\u0131klama",
    'projects.branches': 'Dallar',
    'projects.versions': "S\xfcr\xfcmler",
    'projects.packages': 'Paketler',
    'projects.management': "Proje ayarlar\u0131",
    'projects.management.breadcrumb': 'Ayarlar',
    'projects.management.title': (projectTitle)=>`${projectTitle} - ayarlar`,
    'projects.management.hint': "proje ayarlar\u0131",
    'projects.management.users': "Ekip \xfcyeleri",
    'projects.management.users.empty': "Ekip \xfcyesi yok.",
    'projects.management.users.role.tester': "Test\xe7i",
    'projects.management.users.role.developer': "Geli\u015Ftirici",
    'projects.management.users.role.admin': "Y\xf6netici",
    'projects.management.users.role.owner': 'Sahip',
    'projects.management.users.role.starred': "Y\u0131ld\u0131zl\u0131",
    'projects.management.users.exile': "Ekipten \xe7\u0131kar",
    'projects.management.users.exile.dialog.header': "Ekipten \xe7\u0131kar",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            userTitle,
            " kullan\u0131c\u0131s\u0131n\u0131 ",
            projectTitle,
            " projesinden \xE7\u0131karmak istedi\u011Finize emin misiniz?"
        ],
    'projects.management.users.exile.dialog.ok': "Ekipten \xe7\u0131kar",
    'projects.management.invites.one_time_invite': "Tek kullan\u0131ml\u0131k davet ba\u011Flant\u0131s\u0131",
    'projects.management.invites.one_time_invite.header': "Tek kullan\u0131ml\u0131k davet ba\u011Flant\u0131s\u0131",
    'projects.management.invites.one_time_invite.message': "Tek kullan\u0131ml\u0131k davet ba\u011Flant\u0131s\u0131:",
    'projects.management.invites.one_time_invite.note': "24 saat ge\xe7erlidir, bir kez kullan\u0131labilir.",
    'projects.management.invites.new_dialog.header': "Davet ba\u011Flant\u0131s\u0131",
    'projects.management.invites.new_dialog.expires': "Ge\xe7erlilik s\xfcresi:",
    'projects.management.invites.new_dialog.expires.indefinite': "(s\xfcre s\u0131n\u0131r\u0131 yok)",
    'projects.management.invites.new_dialog.approval.label': "Kullan\u0131c\u0131 projeye kat\u0131ld\u0131\u011F\u0131nda:",
    'projects.management.invites.new_dialog.approval.not_approved': "y\xf6netici onay\u0131ndan sonra",
    'projects.management.invites.new_dialog.approval.approved': 'hemen',
    'projects.management.invites.new_dialog.seats': "Kat\u0131l\u0131m s\u0131n\u0131r\u0131:",
    'projects.management.invites.new_dialog.seats.no_limit': "(s\u0131n\u0131r yok)",
    'projects.management.invites.new_dialog.ok': "Davet ba\u011Flant\u0131s\u0131 olu\u015Ftur",
    'projects.management.deploy_sites': "Da\u011F\u0131t\u0131m siteleri",
    'projects.management.deploy_sites.empty': "Hi\xe7 da\u011F\u0131t\u0131m sitesi eklenmedi.",
    'projects.management.deploy_sites.add': "Da\u011F\u0131t\u0131m sitesi ekle",
    'projects.management.deploy_sites.delete': 'Sil',
    'projects.management.deploy_sites.delete_dialog.header': "Da\u011F\u0131t\u0131m sitesini sil",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            provider,
            " da\u011F\u0131t\u0131m sitesini (",
            site,
            ") silmek istedi\u011Finize emin misiniz?"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "Da\u011F\u0131t\u0131m sitesini sil",
    'projects.management.public_access': "Genel eri\u015Fim",
    'projects.management.public_access.enable': "Genel eri\u015Fimi etkinle\u015Ftir",
    'projects.management.public_access.enabled': [
        "Genel eri\u015Fim: ",
        $fc6769ef69036635$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "Projenin ad\u0131, a\xe7\u0131klamas\u0131 ve genel olarak i\u015Faretlenmi\u015F t\xfcm dallar herkese a\xe7\u0131kt\u0131r.",
    'projects.management.public_access.enable_dialog.header': "Genel eri\u015Fimi etkinle\u015Ftir",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            projectTitle,
            " projesine genel eri\u015Fime izin vermek istedi\u011Finize emin misiniz?",
            $fc6769ef69036635$var$_tmpl$2(),
            $fc6769ef69036635$var$_tmpl$2(),
            "Bu, proje hakk\u0131ndaki temel bilgileri kimlik do\u011Frulamas\u0131 olmadan eri\u015Filebilir hale getirecektir. Genel olmas\u0131n\u0131 istedi\u011Finiz her dal i\xE7in genel eri\u015Fimi ayr\u0131 ayr\u0131 etkinle\u015Ftirmeniz gerekecektir."
        ],
    'projects.management.public_access.enable_dialog.ok': "Genel eri\u015Fimi etkinle\u015Ftir",
    'projects.management.public_access.disable': "Genel eri\u015Fimi devre d\u0131\u015F\u0131 b\u0131rak",
    'projects.management.public_access.disabled': [
        "Genel eri\u015Fim: ",
        $fc6769ef69036635$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "Proje \xf6zeldir. Sadece proje ekibinin \xfcyeleri eri\u015Febilir.",
    'projects.management.public_access.disable_dialog.header': "Genel eri\u015Fimi devre d\u0131\u015F\u0131 b\u0131rak",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            projectTitle,
            " projesine olan t\xFCm genel eri\u015Fimi devre d\u0131\u015F\u0131 b\u0131rakmak istedi\u011Finize emin misiniz?"
        ],
    'projects.management.public_access.disable_dialog.ok': "Genel eri\u015Fimi devre d\u0131\u015F\u0131 b\u0131rak",
    'projects.management.public_access.branches': 'Genel dallar',
    'projects.management.manage': "Projeyi y\xf6net",
    'projects.rename': "Projeyi yeniden adland\u0131r",
    'projects.rename_dialog.header': "Projeyi yeniden adland\u0131r",
    'projects.rename_dialog.label': "Proje ad\u0131:",
    'projects.rename_dialog.ok': "Projeyi yeniden adland\u0131r",
    'projects.edit_description': "Proje a\xe7\u0131klamas\u0131n\u0131 d\xfczenle",
    'projects.edit_description_dialog.header': "Proje a\xe7\u0131klamas\u0131n\u0131 d\xfczenle",
    'projects.edit_description_dialog.label': "Proje a\xe7\u0131klamas\u0131:",
    'projects.edit_description_dialog.ok': "A\xe7\u0131klamay\u0131 d\xfczenle",
    'projects.leave': "Projeden ayr\u0131l",
    'projects.leave_dialog.header': "Projeden ayr\u0131l",
    'projects.leave_dialog.message': (projectTitle)=>[
            projectTitle,
            " projesinden ayr\u0131lmak istedi\u011Finize emin misiniz?"
        ],
    'projects.leave_dialog.ok': "Projeden ayr\u0131l",
    'projects.delete': 'Projeyi sil',
    'projects.delete_dialog.header': 'Projeyi sil',
    'projects.delete_dialog.message': (projectTitle)=>[
            projectTitle,
            " projesini silmek istedi\u011Finize emin misiniz?"
        ],
    'projects.delete_dialog.ok': 'Projeyi sil',
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': 'dal',
    'branches.no_branches': "Projenin hen\xfcz hi\xe7 dal\u0131 yok",
    'branches.new': "Dal olu\u015Ftur",
    'branches.new_dialog.header': 'Yeni dal',
    'branches.new_dialog.label': "Dal ad\u0131",
    'branches.new_dialog.ok': "Dal olu\u015Ftur",
    'branches.current_version': (version)=>[
            "Mevcut s\xFCr\xFCm: ",
            version
        ],
    'branches.current_version.packages': "Mevcut s\xfcr\xfcm paketleri",
    'branches.no_current_version': "Mevcut s\xfcr\xfcm yok",
    'branches.publish_version.new': "Yeni s\xfcr\xfcm yay\u0131nla",
    'branches.publish_version.existing': "Mevcut s\xfcr\xfcm\xfc yeniden yay\u0131nla",
    'branches.version_history': "S\xfcr\xfcm ge\xe7mi\u015Fi",
    'branches.version_history.empty': "Dal\u0131n s\xfcr\xfcm ge\xe7mi\u015Fi bo\u015F.",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "Mevcut dal s\xFCr\xFCm\xFC ",
            quotaTime != null ? [
                quotaTime,
                " boyunca"
            ] : "s\xFCresiz olarak",
            " saklan\u0131r. \xD6nceki s\xFCr\xFCmler en fazla ",
            quotaNonCurrentTime,
            " saklan\u0131r. Dal ba\u015F\u0131na toplamda en fazla ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$fc6769ef69036635$var$plural(quotaCount, [
                    quotaCountText,
                    " s\xFCr\xFCm"
                ], [
                    quotaCountText,
                    " s\xFCr\xFCm"
                ])),
            " saklan\u0131r."
        ],
    'branches.manage': "Dal\u0131 y\xf6net",
    'branches.rename': "Dal\u0131 yeniden adland\u0131r",
    'branches.rename_dialog.header': "Dal\u0131 yeniden adland\u0131r",
    'branches.rename_dialog.label': "Dal ad\u0131:",
    'branches.rename_dialog.ok': "Dal\u0131 yeniden adland\u0131r",
    'branches.delete': "Dal\u0131 sil",
    'branches.delete_dialog.header': "Dal\u0131 sil",
    'branches.delete_dialog.message': (branchTitle)=>[
            branchTitle,
            " dal\u0131n\u0131 silmek istedi\u011Finize emin misiniz?"
        ],
    'branches.delete_dialog.ok': "Dal\u0131 sil",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "s\xfcr\xfcm",
    'versions.current': 'Mevcut',
    'versions.previous': "\xd6nceki",
    'versions.description': "A\xe7\u0131klama",
    'versions.deploy_to_site.header': "Sitede yay\u0131nla",
    'versions.deploy_to_site': "Sitede yay\u0131nla",
    'versions.packages': 'Paketler',
    'versions.branches': 'Dallarda',
    'versions.branches.publish': "Dala g\xf6nder",
    'versions.branches.empty': "Bu s\xfcr\xfcm hi\xe7bir dalda yay\u0131nlanmad\u0131.",
    'versions.new_dialog.header': "Yeni s\xfcr\xfcm",
    'versions.new_dialog.label_title': "S\xfcr\xfcm:",
    'versions.new_dialog.label_branch': 'Dal:',
    'versions.new_dialog.packages.header': 'Paketler',
    'versions.new_dialog.packages.empty': "Hi\xe7 paket eklenmedi.",
    'versions.new_dialog.packages.add': 'Paket ekle',
    'versions.new_dialog.packages.add_existing': "\xd6nceden y\xfcklenmi\u015F paketi ekle",
    'versions.new_dialog.packages.replace': "Paketi de\u011Fi\u015Ftir",
    'versions.new_dialog.packages.edit': "Paketi d\xfczenle",
    'versions.new_dialog.ok': "S\xfcr\xfcm olu\u015Ftur",
    'versions.manage': "S\xfcr\xfcm\xfc y\xf6net",
    'versions.rename': "S\xfcr\xfcm\xfc yeniden adland\u0131r",
    'versions.rename_dialog.header': "S\xfcr\xfcm\xfc yeniden adland\u0131r",
    'versions.rename_dialog.label': "S\xfcr\xfcm ad\u0131:",
    'versions.rename_dialog.ok': "S\xfcr\xfcm\xfc yeniden adland\u0131r",
    'versions.edit_description': "S\xfcr\xfcm a\xe7\u0131klamas\u0131n\u0131 d\xfczenle",
    'versions.edit_description_dialog.header': "S\xfcr\xfcm a\xe7\u0131klamas\u0131n\u0131 d\xfczenle",
    'versions.edit_description_dialog.label': "S\xfcr\xfcm a\xe7\u0131klamas\u0131:",
    'versions.edit_description_dialog.ok': "A\xe7\u0131klamay\u0131 d\xfczenle",
    'versions.delete': "S\xfcr\xfcm\xfc sil",
    'versions.delete_dialog.header': "S\xfcr\xfcm\xfc sil",
    'versions.delete_dialog.message': (versionTitle)=>[
            "S\xFCr\xFCm ",
            versionTitle,
            " silmek istedi\u011Finize emin misiniz?"
        ],
    'versions.delete_dialog.ok': "S\xfcr\xfcm\xfc sil",
    'versions.publish_dialog.header': "S\xfcr\xfcm\xfc bir dala g\xf6nder",
    'versions.publish_dialog.message': (versionTitle)=>[
            "S\xFCr\xFCm ",
            versionTitle,
            " g\xF6ndermek istedi\u011Finiz dal\u0131 se\xE7in."
        ],
    'versions.publish_dialog.no_branches': "Projede hi\xe7 dal yok.",
    'versions.publish_dialog.ok': "S\xfcr\xfcm\xfc g\xf6nder",
    'versions.publish_existing_dialog.header': "S\xfcr\xfcm\xfc yeniden g\xf6nder",
    'versions.publish_existing_dialog.message': "Son s\xfcr\xfcmler:",
    'versions.publish_existing_dialog.no_versions': "Projede hi\xe7 s\xfcr\xfcm yok.",
    'versions.publish_existing_dialog.ok': "S\xfcr\xfcm\xfc g\xf6nder",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': 'Paket',
    'packages.download_zip': 'ZIP olarak indir',
    'packages.download_torrent': 'Torrent indir',
    'packages.total_size': (size)=>[
            "Toplam boyut: ",
            size
        ],
    'packages.manage': "Paketi y\xf6net",
    'packages.rename': "Paketi yeniden adland\u0131r",
    'packages.rename_dialog.header': "Paketi yeniden adland\u0131r",
    'packages.rename_dialog.label': "Paket ad\u0131:",
    'packages.rename_dialog.ok': "Paketi yeniden adland\u0131r",
    'packages.edit_tags': "Paket etiketlerini d\xfczenle",
    'packages.edit_tags_dialog.header': "Paket etiketlerini d\xfczenle",
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            packageTitle,
            " paketinin etiketlerini belirtin:"
        ],
    'packages.edit_tags_dialog.ok': 'Paket etiketlerini ayarla',
    'packages.entrypoint': (entrypoint)=>[
            "Ba\u015Flang\u0131\xE7 dosyas\u0131: ",
            entrypoint
        ],
    'packages.entrypoint.empty': "Ba\u015Flang\u0131\xe7 dosyas\u0131 ayarlanmad\u0131.",
    'packages.delete': 'Paketi sil',
    'packages.delete_dialog.header': 'Paketi sil',
    'packages.delete_dialog.message': (packageTitle)=>[
            packageTitle,
            " paketini silmek istedi\u011Finize emin misiniz? Paket, eklendi\u011Fi t\xFCm s\xFCr\xFCmlerden silinecektir."
        ],
    'packages.delete_dialog.ok': 'Paketi sil',
    'packages.new_dialog.header': 'Yeni paket',
    'packages.new_dialog.label_title': "Ba\u015Fl\u0131k:",
    'packages.new_dialog.title_placeholder': '(etiketlerden)',
    'packages.new_dialog.tags.header': 'Etiketler',
    'packages.new_dialog.files.header': 'Dosyalar',
    'packages.new_dialog.total_size': (size, maximum)=>[
            "Toplam boyut: ",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(maksimum ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "Yeni veri boyutu: ",
            size
        ],
    'packages.new_dialog.checks.empty': "Hi\xe7 dosya eklenmedi.",
    'packages.new_dialog.checks.entrypoint.empty': "Ba\u015Flang\u0131\xe7 dosyas\u0131 ayarlanmad\u0131.",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "Ba\u015Flang\u0131\xE7 dosyas\u0131 ",
            entrypoint,
            " mevcut de\u011Fil; eklemeyi unutmu\u015F olabilir misiniz? L\xFCtfen mevcut bir ba\u015Flang\u0131\xE7 dosyas\u0131 belirtin veya hi\xE7 ba\u015Flang\u0131\xE7 dosyas\u0131 ayarlamay\u0131n."
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "Ba\u015Flang\u0131\xe7 dosyas\u0131n\u0131 kald\u0131r",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "Ba\u015Flang\u0131\xE7 dosyas\u0131 ",
            fileExt,
            " uzant\u0131s\u0131na sahip: ",
            tag,
            " etiketi \xF6neriliyor."
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            tag,
            " etiketini ekle"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "Ba\u015Flang\u0131\xE7 dosyas\u0131 ",
            fileExt,
            " uzant\u0131s\u0131na sahip: paketi taray\u0131c\u0131da oynat\u0131labilir k\u0131lmak i\xE7in ",
            tag,
            " etiketini ekleyin."
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "Ba\u015Flang\u0131\xE7 dosyas\u0131 ",
            fileExt,
            " uzant\u0131s\u0131na sahip: bu bir hata m\u0131? Genellikle bu t\xFCr dosyalar ba\u015Flat\u0131lamaz."
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "Ba\u015Flang\u0131\xE7 dosyas\u0131 ",
            fileExt,
            " uzant\u0131s\u0131na sahip: dosyalar\u0131 bir ar\u015Fiv dosyas\u0131na paketlemek yerine do\u011Frudan eklemeniz \xF6nerilir."
        ],
    'packages.new_dialog.checks.entrypoint.executable': "Ba\u015Flang\u0131\xe7 dosyas\u0131 \xe7al\u0131\u015Ft\u0131r\u0131labilir olarak i\u015Faretlenmemi\u015F",
    'packages.new_dialog.checks.entrypoint.executable.action': "\xc7al\u0131\u015Ft\u0131r\u0131labilir olarak i\u015Faretle",
    'packages.new_dialog.checks.single_root_dir': "Dosyalar\u0131 tek bir klas\xf6r i\xe7ine koymak yerine do\u011Frudan k\xf6k dizine yerle\u015Ftirmeniz \xf6nerilir.",
    'packages.new_dialog.checks.single_root_dir.action': "Klas\xf6r\xfc i\xe7eri\u011Fiyle de\u011Fi\u015Ftir",
    'packages.add_existing_dialog.header': 'Paket ekle',
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `${$fc6769ef69036635$var$plural(packagesCount, `${packagesCount} paket`, `${packagesCount} paket`)} ekle` : "Hi\xe7 paket se\xe7ilmedi",
    'packages.add_existing_dialog.message': "Son y\xfcklenen paketler:",
    'packages.add_existing_dialog.no_packages': "Yak\u0131n zamanda y\xfcklenmi\u015F paket yok.",
    'packages.launch': "Ba\u015Flat",
    'packages.install': "Y\xfckle",
    'packages.install_dialog.header': "Y\xfckle",
    'packages.install_dialog.workdir.label': "\xc7al\u0131\u015Fma dizini:",
    'packages.install_dialog.workdir.value.new': "(yeni olu\u015Ftur)",
    'packages.install_dialog.workspace.label': "\u015Eunun alt\u0131nda klas\xf6r olu\u015Ftur:",
    'packages.install_dialog.workspace.placeholder': "(k\xf6k klas\xf6r\xfc se\xe7in)",
    'packages.install_dialog.ok': "Y\xfckle",
    'packages.update': "G\xfcncelle",
    'packages.upload.status.existing': "\xd6nceki s\xfcr\xfcmden",
    'packages.upload.status.queued': "S\u0131rada",
    'packages.upload.status.packing': 'Paketleniyor...',
    'packages.upload.status.creating': "Olu\u015Fturuluyor...",
    'packages.upload.status.create_retrying': "Olu\u015Fturma ba\u015Far\u0131s\u0131z oldu, bekleniyor ve yeniden deneniyor",
    'packages.upload.status.splitting': "B\xf6l\xfcn\xfcyor...",
    'packages.upload.status.uploading': "Y\xfckleniyor...",
    'packages.upload.status.finalizing': "Tamamlan\u0131yor...",
    'packages.upload.status.finalize_retrying': "Tamamlama ba\u015Far\u0131s\u0131z oldu, bekleniyor ve yeniden deneniyor",
    'packages.upload.status.resolving': "Yama \xe7\xf6z\xfcmleniyor...",
    'packages.upload.status.resolve_retrying': "Yama \xe7\xf6z\xfcmleme ba\u015Far\u0131s\u0131z oldu, bekleniyor ve yeniden deneniyor...",
    'packages.upload.status.done': "Ba\u015Far\u0131yla y\xfcklendi",
    'packages.upload.status.errored': 'Hata',
    'packages.upload.part.status.queued': "S\u0131rada",
    'packages.upload.part.status.hashing': "Karma olu\u015Fturuluyor",
    'packages.upload.part.status.upload_queued': "Y\xfckleme s\u0131raya al\u0131nd\u0131",
    'packages.upload.part.status.uploading': "Y\xfckleniyor",
    'packages.upload.part.status.upload_retrying': "Hata, y\xfckleme yeniden deneniyor",
    'packages.upload.part.status.upload_finalizing': "Y\xfckleme tamamlan\u0131yor",
    'packages.upload.part.status.upload_errored': 'Hata',
    'packages.upload.part.status.done': "Y\xfcklendi",
    'packages.play': "Taray\u0131c\u0131da oyna",
    'packages.play.reset': "S\u0131f\u0131rla",
    'packages.play.fullscreen': 'Tam ekran',
    'deploy_sites.add_dialog.header': "Da\u011F\u0131t\u0131m sitesi ekle",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            projectTitle,
            " projesi i\xE7in da\u011F\u0131t\u0131m sitesi olarak kaydetmek \xFCzere da\u011F\u0131t\u0131m kimlik bilgisini se\xE7in ve site URL\\'sini girin."
        ],
    'deploy_sites.add_dialog.label_credential': "Da\u011F\u0131t\u0131m kimlik bilgisi:",
    'deploy_sites.add_dialog.select_credential': "Kimlik bilgisi se\xe7",
    'deploy_sites.add_dialog.select_credential.new': 'Yeni kimlik bilgisi ekle...',
    'deploy_sites.add_dialog.label_select_site': "Site se\xe7:",
    'deploy_sites.add_dialog.select_credential_first': "(\xf6nce kimlik bilgisi se\xe7in)",
    'deploy_sites.add_dialog.select_site': "(site se\xe7in)",
    'deploy_sites.add_dialog.label_enter_site': 'Veya site URL\'si girin:',
    'deploy_sites.add_dialog.ok': 'Site ekle',
    'deploy_to_site_dialog.header': "Sitede yay\u0131nla",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            projectTitle,
            " projesinin ",
            versionTitle,
            " s\xFCr\xFCm\xFCn\xFC yay\u0131nlamak i\xE7in site se\xE7in."
        ],
    'deploy_to_site_dialog.label_site': "Sitede yay\u0131nla:",
    'deploy_to_site_dialog.select_site': "Site se\xe7",
    'deploy_to_site_dialog.select_site.new': "Yeni da\u011F\u0131t\u0131m sitesi ekle...",
    'deploy_to_site_dialog.packages.message.itch': [
        "Paketler, ",
        $fc6769ef69036635$var$_tmpl$4(),
        " kullan\u0131larak itch.io\\'da yay\u0131nlanacakt\u0131r. Kanal adlar\u0131 paket etiketlerinden t\xFCretilir."
    ],
    'deploy_to_site_dialog.deploy': "Yay\u0131nla",
    'deploy_to_site_dialog.close': 'Kapat',
    'deploy_to_site_dialog.error.no_packages': "Yay\u0131nlanacak paket yok.",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "Birden fazla paket tek bir kanalda yay\u0131nlanamaz. \u015Eu anda ",
            channel,
            " kanal\u0131nda yay\u0131nlanmak \xFCzere ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$fc6769ef69036635$var$plural(packagesCount, [
                    packagesCountText,
                    " paket"
                ], [
                    packagesCountText,
                    " paket"
                ])),
            " ayarlanm\u0131\u015F durumda."
        ],
    'deploy_to_site_dialog.job.queued': "S\u0131rada",
    'deploy_to_site_dialog.job.downloading': "\u0130ndiriliyor...",
    'deploy_to_site_dialog.job.unpacking': "Paket a\xe7\u0131l\u0131yor...",
    'deploy_to_site_dialog.job.uploading': "Yay\u0131nlan\u0131yor...",
    'deploy_to_site_dialog.job.succeeded': "Ba\u015Far\u0131l\u0131",
    'deploy_to_site_dialog.job.errored': 'Hata',
    'store': "Ma\u011Faza",
    'store.hint': 'Genel projeler',
    'store.project.hint': "Ma\u011Faza proje sayfas\u0131",
    'store.project.owner': "Geli\u015Ftirici",
    'store.project.description': "A\xe7\u0131klama",
    'store.project.star': "Y\u0131ld\u0131zla",
    'store.project.starred': "Y\u0131ld\u0131zl\u0131",
    'store.project.content': "\u0130\xe7erik",
    'store.project.content.warning': "\u0130\xe7erik \xfc\xe7\xfcnc\xfc taraf bir geli\u015Ftirici taraf\u0131ndan sa\u011Flanm\u0131\u015Ft\u0131r.",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            branchTitle,
            " dal\u0131: s\xFCr\xFCm ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "Yay\u0131nlanma: ",
            branchVersionPublished
        ],
    'me': 'Profil',
    'me.hint': "Profil ayarlar\u0131 ve ba\u011Fl\u0131 kimlik bilgileri",
    'me.rename': "Profili yeniden adland\u0131r",
    'me.rename_dialog.header': "Profili yeniden adland\u0131r",
    'me.rename_dialog.label_title': 'Ad:',
    'me.rename_dialog.ok': "Profili yeniden adland\u0131r",
    'me.credentials': 'Kimlik Bilgileri',
    'me.credentials.hint.auth_allowed': "Bu kimlik bilgilerinden herhangi biri bu hesaba giri\u015F yapmak i\xe7in kullan\u0131labilir.",
    'me.credentials.hint.auth_disallowed': "Bu kimlik bilgileri hesab\u0131n\u0131za ba\u011Fl\u0131d\u0131r ancak giri\u015F yapmak i\xe7in kullan\u0131lamaz.",
    'me.credentials.empty': 'Kimlik bilgisi yok.',
    'me.credentials.empty.auth_allowed.warning': "Hesab\u0131n\u0131zdan kilitlenebilirsiniz! Giri\u015F yapmak i\xe7in hi\xe7bir kimlik bilgisi ba\u011Flamad\u0131n\u0131z. L\xfctfen en k\u0131sa s\xfcrede giri\u015F yapabilece\u011Finiz bir kimlik bilgisi ba\u011Flay\u0131n.",
    'me.credentials.profile_picture.alt': (provider)=>`${$fc6769ef69036635$var$dict[`auth.provider.${provider}`]} profil resmi`,
    'me.credentials.created': (created)=>[
            "eklendi ",
            created
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "son kullan\u0131m ",
            lastUsed
        ],
    'me.credential.unlink': "Ba\u011Flant\u0131y\u0131 Kes",
    'me.credential.allow_auth': "Giri\u015Fe izin ver",
    'me.credential.disallow_auth': "Giri\u015Fi engelle",
    'me.credential.display_publicly': "Herkese a\xe7\u0131k g\xf6ster",
    'me.credential.dont_display_publicly': "Herkese a\xe7\u0131k g\xf6sterme",
    'me.credential.link': "Kimlik bilgisi ba\u011Fla",
    'me.credential.link_dialog.header': "Kimlik bilgisi ba\u011Fla",
    'me.credential.link_dialog.message': "L\xfctfen ba\u011Flamak istedi\u011Finiz hesap sa\u011Flay\u0131c\u0131s\u0131n\u0131 se\xe7in.",
    'me.credential.unlink_dialog.header': "Kimlik bilgisi ba\u011Flant\u0131s\u0131n\u0131 kes",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            credentialProvider,
            " hesab\u0131 ",
            credentialTitle,
            " ile Kavykhi.Cloud hesab\u0131n\u0131z aras\u0131ndaki ba\u011Flant\u0131y\u0131 kesmek istedi\u011Finize emin misiniz?"
        ],
    'me.credential.unlink_dialog.ok': "Ba\u011Flant\u0131y\u0131 kes",
    'me.sessions': 'Oturumlar',
    'me.sessions.hint': "Bu, mevcut taray\u0131c\u0131n\u0131z dahil aktif oturumlar\u0131n\u0131z\u0131n listesidir.",
    'me.sessions.started': (started)=>[
            "ba\u015Flat\u0131ld\u0131 ",
            (()=>{
                var _el$6 = $fc6769ef69036635$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "aktif ",
            (()=>{
                var _el$7 = $fc6769ef69036635$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': 'Mevcut oturum',
    'me.sessions.empty': 'Oturum yok.',
    'me.sessions.delete': "Sonland\u0131r",
    'me.sessions.delete_dialog.header': "Oturumu sonland\u0131r",
    'me.sessions.delete_dialog.message': "Bu oturumu sonland\u0131rmak istedi\u011Finize emin misiniz?",
    'me.sessions.delete_dialog.ok': "Oturumu sonland\u0131r",
    'me.api_tokens': "API anahtarlar\u0131",
    'me.api_tokens.hint': "Otomasyonda kullanmak \xfczere buradan API anahtarlar\u0131 olu\u015Fturulabilir.",
    'me.api_tokens.started': (started)=>[
            "olu\u015Fturuldu ",
            (()=>{
                var _el$8 = $fc6769ef69036635$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "son kullanma ",
            (()=>{
                var _el$9 = $fc6769ef69036635$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "s\xfcre s\u0131n\u0131r\u0131 yok",
    'me.api_tokens.empty': "API anahtar\u0131 yok.",
    'me.api_tokens.create': "API anahtar\u0131 olu\u015Ftur",
    'me.api_tokens.create_dialog.header': "API anahtar\u0131 olu\u015Ftur",
    'me.api_tokens.create_dialog.message': "Olu\u015Fturulan API anahtar\u0131:",
    'me.api_tokens.create_dialog.note': "Anahtar bir daha g\xf6sterilmeyecektir, l\xfctfen g\xfcvenli bir yere kaydedin.",
    'me.api_tokens.delete': 'Sil',
    'me.api_tokens.delete_dialog.header': "API anahtar\u0131n\u0131 sil",
    'me.api_tokens.delete_dialog.message': "Bu anahtar\u0131 silmek istedi\u011Finize emin misiniz?",
    'me.api_tokens.delete_dialog.ok': "API anahtar\u0131n\u0131 sil",
    'me.deploy_credentials': "Da\u011F\u0131t\u0131m kimlik bilgileri",
    'me.deploy_credentials.hint': "Yay\u0131nlama platformlar\u0131na da\u011F\u0131t\u0131m yapmak i\xe7in kimlik bilgileri buradan eklenebilir.",
    'me.deploy_credentials.empty': "Hi\xe7 da\u011F\u0131t\u0131m kimlik bilgisi eklenmedi.",
    'me.deploy_credential.add': "Da\u011F\u0131t\u0131m kimlik bilgisi ekle",
    'me.deploy_credential.add_dialog.header': "Da\u011F\u0131t\u0131m kimlik bilgisi ekle",
    'me.deploy_credential.add_dialog.label_site': 'Site:',
    'me.deploy_credential.add_dialog.label_title': 'Not:',
    'me.deploy_credential.add_dialog.label_key': 'Anahtar:',
    'me.deploy_credential.add_dialog.default_title': (date)=>`Anahtar ${date}`,
    'me.deploy_credential.add_dialog.ok': "Da\u011F\u0131t\u0131m kimlik bilgisi ekle",
    'me.deploy_credential.add_dialog.hint.itch': [
        "itch.io API anahtar\u0131n\u0131 olu\u015Fturmak i\xE7in itch.io\\'daki ",
        $fc6769ef69036635$var$_tmpl$6(),
        " gidin. Kayna\u011F\u0131 \"web\" veya \"wharf\" olan mevcut bir API anahtar\u0131n\u0131 kullanabilirsiniz. Kayna\u011F\u0131 \"Kavykhi.Cloud\" olan API anahtarlar\u0131 \xE7al\u0131\u015Fmayacakt\u0131r."
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "\u015Eu anda ",
            credentialProvider,
            " kimlik bilgilerini eklemeyi desteklemiyoruz."
        ],
    'me.deploy_credential.delete': 'Sil',
    'me.deploy_credential.delete_dialog.header': "Da\u011F\u0131t\u0131m kimlik bilgisini sil",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            credentialProvider,
            " i\xE7in ",
            credentialTitle,
            " kimlik bilgisini silmek istedi\u011Finize emin misiniz? Bu kimlik bilgisiyle yap\u0131land\u0131r\u0131lm\u0131\u015F t\xFCm da\u011F\u0131t\u0131m siteleri de projeden kald\u0131r\u0131lacakt\u0131r."
        ],
    'me.deploy_credential.delete_dialog.ok': 'Kimlik bilgisini sil',
    'me.public_profile': 'Genel profil',
    'me.public_profile.public_credentials': 'Genel kimlik bilgileri',
    'me.public_profile.public_credentials.hint': "Herkese a\xe7\u0131k olarak g\xf6sterilecek kimlik bilgilerini se\xe7in.",
    'me.manage': "Hesab\u0131 y\xf6net",
    'me.delete': "Hesab\u0131 sil",
    'me.delete.dialog.header': "Hesab\u0131 sil",
    'me.delete.dialog.message': (userTitle)=>[
            "Kavykhi.Cloud hesab\u0131n\u0131z\u0131 (",
            userTitle,
            ") geri al\u0131namaz \u015Fekilde silmek istedi\u011Finize emin misiniz?"
        ],
    'me.delete.dialog.ok': "Hesab\u0131 sil",
    'invite': 'Davet',
    'invite.hint': 'Proje daveti',
    'invite.message.already_member': (projectTitle)=>[
            "Zaten ",
            projectTitle,
            " projesinin bir \xFCyesisiniz."
        ],
    'invite.message.join': (projectTitle)=>[
            projectTitle,
            " projesine davet edildiniz."
        ],
    'invite.join': "Projeye kat\u0131l",
    'local': "Yerel i\xe7erik",
    'local.hint': "Yerel olarak y\xfcklenmi\u015F i\xe7erik",
    'local.workdirs': "Y\xfckl\xfc paketler",
    'local.workdirs.empty': "Y\xfckl\xfc paket yok.",
    'local.workdir.action.launch': "Ba\u015Flat",
    'local.workdir.action.repair': 'Onar',
    'local.workdir.action.delete': "Kald\u0131r",
    'local.workdir.delete_dialog.header': "Paketi kald\u0131r",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            packageTitle,
            " paketini cihaz\u0131n\u0131zdan kald\u0131rmak istedi\u011Finize emin misiniz?"
        ],
    'local.workdir.delete_dialog.ok': "Kald\u0131r",
    'local.workspaces': "K\xf6k klas\xf6rler",
    'local.app_not_detected.message': "Kavykhi.Cloud yerel uygulamas\u0131 tespit edilemedi. L\xfctfen a\u015Fa\u011F\u0131daki ba\u011Flant\u0131lardan birini kullanarak indirip y\xfckleyin. Zaten y\xfcklediyseniz, \xe7al\u0131\u015Ft\u0131\u011F\u0131ndan emin olun.",
    'local_app.detected': "Yerel i\xe7erik",
    'error_dialog.header': 'Hata',
    'error_dialog.messageFunc': (e)=>`Hata: ${$fc6769ef69036635$var$dict[`error.${e}`] ?? e}.`,
    'upload_box.choose_files': "Dosya se\xe7",
    'upload_box.choose_directories': "Klas\xf6r se\xe7",
    'upload_box.add.progress_dialog.header': 'Dosyalar ekleniyor',
    'upload_box.add.progress_dialog.message': "Dosyalar i\u015Fleniyor...",
    'upload_box.delete': (itemsCount)=>`${$fc6769ef69036635$var$plural(itemsCount, `${itemsCount} \xf6\u{11F}eyi`, `${itemsCount} \xf6\u{11F}eyi`)} sil`,
    'upload_box.start_upload': "Y\xfcklemeyi ba\u015Flat",
    'upload_box.drop_area.message': "Dosya ve klas\xf6rleri buraya s\xfcr\xfckleyin",
    'upload_box.drop_area.box_dropping_message': "K\xf6k dizine yerle\u015Ftirmek i\xe7in buraya b\u0131rak\u0131n",
    'upload_box.entry.explode_folder': "Klas\xf6r\xfc i\xe7eri\u011Fiyle de\u011Fi\u015Ftir",
    'upload_box.entry.set_entrypoint': "Ba\u015Flang\u0131\xe7 dosyas\u0131 olarak ayarla",
    'upload_box.entry.mark_executable': "\xc7al\u0131\u015Ft\u0131r\u0131labilir olarak i\u015Faretle",
    'upload_box.entry.unmark_executable': "\xc7al\u0131\u015Ft\u0131r\u0131labilir i\u015Faretini kald\u0131r",
    'upload_box.entry.remove': "Kald\u0131r",
    'package.tags.empty': '(etiket yok)',
    'package.tag.os': "\u0130\u015Fletim Sistemi",
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': 'Mimari',
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': "Bit Geni\u015Fli\u011Fi",
    'package.tag.bits:64': '64-bit',
    'package.tag.bits:32': '32-bit',
    'package.tag.packaging': 'Paketleme',
    'package.tag.packaging:installer': "Y\xfckleyici",
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': "Bile\u015Fen",
    'package.tag.component:client': "\u0130stemci",
    'package.tag.component:server': 'Sunucu',
    'package.tag.runtime': "\xc7al\u0131\u015Fma Ortam\u0131",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Linux da\u011F\u0131t\u0131m\u0131",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': 'Belgeler',
    'docs.page_no_language': "Bu dilde mevcut de\u011Fil",
    'docs.page_no_language.message': "Bu belgenin di\u011Fer s\xfcr\xfcmleri mevcuttur:",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "\u0130\xe7eri\u011Fi bildir",
    'report_content.dialog.header': "\u0130\xe7eri\u011Fi bildir",
    'report_content.dialog.link': "Bildirimi e-posta ile g\xf6nder",
    'report_content.dialog.message': (email, link)=>[
            "Bildiriminizi g\xF6ndermek i\xE7in l\xFCtfen ba\u011Flant\u0131ya t\u0131klay\u0131n:",
            $fc6769ef69036635$var$_tmpl$2(),
            $fc6769ef69036635$var$_tmpl$2(),
            link,
            $fc6769ef69036635$var$_tmpl$2(),
            $fc6769ef69036635$var$_tmpl$2(),
            "Veya bize manuel olarak \u015Fu adresten e-posta g\xF6nderin: ",
            email
        ]
};
var $fc6769ef69036635$export$2e2bcd8739ae039 = $fc6769ef69036635$var$dict;
const $fc6769ef69036635$var$plural = (n, one, many)=>n == 1 ? one : many;



var $beff090cf88b012d$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{5DF2}\u{5141}\u{8BB8}`), $beff090cf88b012d$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $beff090cf88b012d$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{672A}\u{5141}\u{8BB8}`), $beff090cf88b012d$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $beff090cf88b012d$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $beff090cf88b012d$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>\u{4E2A}\u{4EBA}\u{8D44}\u{6599}\u{8BBE}\u{7F6E}`);
const $beff090cf88b012d$var$dict = {
    languageName: "\u7B80\u4F53\u4E2D\u6587",
    locale: 'zh-CN',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: "\u4E3B\u9898",
    'theme.light': "\u6D45\u8272",
    'theme.dark': "\u6DF1\u8272",
    'theme.system': "\u7CFB\u7EDF",
    'theme.sakura': "\u6A31\u82B1",
    // generic
    email: "\u7535\u5B50\u90AE\u7BB1",
    password: "\u5BC6\u7801",
    ok: "\u786E\u5B9A",
    cancel: "\u53D6\u6D88",
    retry: "\u91CD\u8BD5",
    copy: "\u590D\u5236",
    empty: "(\u65E0\u9879\u76EE)",
    loading: "\u52A0\u8F7D\u4E2D...",
    calculating: "\u8BA1\u7B97\u4E2D...",
    error: "\u9519\u8BEF",
    'in_development': "\u6B64\u9875\u9762\u6B63\u5728\u5F00\u53D1\u4E2D\u3002",
    // errors
    'error.not_found': "\u672A\u627E\u5230",
    'error.name_conflict': "\u540D\u79F0\u51B2\u7A81",
    'error.bad_param': "\u53C2\u6570\u9519\u8BEF",
    'error.wrong_auth': "\u8BA4\u8BC1\u9519\u8BEF",
    'error.unauthorized': "\u672A\u6388\u6743",
    'error.wrong_credentials': "\u51ED\u636E\u9519\u8BEF",
    'error.wrong_provider': "\u670D\u52A1\u5546\u9519\u8BEF",
    'error.insufficient_privileges': "\u6743\u9650\u4E0D\u8DB3",
    'error.not_empty': "\u975E\u7A7A",
    'error.limit_exceeded': "\u8D85\u51FA\u9650\u5236",
    'error.already_member': "\u5DF2\u662F\u6210\u5458",
    'error.not_finalized': "\u672A\u5B8C\u6210",
    'error.already_finalized': "\u5DF2\u5B8C\u6210",
    'error.unexpected_patch': "\u975E\u9884\u671F\u7684\u8865\u4E01",
    'error.timeout': "\u8D85\u65F6",
    'error.not_patch': "\u975E\u8865\u4E01",
    'error.not_supported': "\u4E0D\u652F\u6301",
    'error.unexpected_error': "\u975E\u9884\u671F\u9519\u8BEF",
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "\u8EAB\u4EFD\u8BA4\u8BC1",
    'auth.dialog.please_select': "\u8BF7\u9009\u62E9\u60A8\u7684\u8D26\u53F7\u670D\u52A1\u5546\u4EE5\u767B\u5F55\u3002",
    'auth.dialog.redirecting_to': (provider)=>`\u{6B63}\u{5728}\u{91CD}\u{5B9A}\u{5411}\u{81F3} ${provider}...`,
    'auth.dialog.remember_me': "\u8BB0\u4F4F\u6211",
    'auth.dialog.log_in': "\u767B\u5F55",
    'auth.dialog.back': "\u8FD4\u56DE",
    'auth.dialog.progress_header': "\u6B63\u5728\u8BA4\u8BC1...",
    'auth.dialog.error.header': "\u8BA4\u8BC1\u9519\u8BEF",
    'auth.dialog.error.auth_not_allowed': "\u7528\u6237\u5DF2\u7981\u6B62\u4F7F\u7528\u6B64\u51ED\u636E\u8FDB\u884C\u8BA4\u8BC1\u3002\u8BF7\u4F7F\u7528\u5176\u4ED6\u51ED\u636E\u3002",
    'auth.dialog.error.unknown': "\u65E0\u6548\u7684\u8BA4\u8BC1\u53C2\u6570\u3002\u8BF7\u91CD\u8BD5\u3002",
    'auth.dialog.error.back': "\u8FD4\u56DE",
    'user.profile': "\u4E2A\u4EBA\u8D44\u6599",
    'user.logout': "\u9000\u51FA\u767B\u5F55",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "\u9875\u9762\u672A\u627E\u5230",
    'page_not_found.message': "\u6B64\u9875\u9762\u4E0D\u5B58\u5728\u3002",
    'page_not_found.message2': "\u597D\u5427\uFF0C\u5B83\u5176\u5B9E\u7B97\u5B58\u5728\uFF0C\u4F46\u8FD9\u91CC\u4EC0\u4E48\u90FD\u6CA1\u6709\u3002\u53EF\u80FD\u6709\u4EE5\u4E0B\u539F\u56E0\uFF1A",
    'page_not_found.items': [
        "\u8FD9\u91CC\u4EE5\u524D\u6709\u4E1C\u897F\uFF0C\u4F46\u73B0\u5728\u5DF2\u88AB\u5220\u9664\u3002",
        "\u8FD9\u91CC\u786E\u5B9E\u6709\u4E1C\u897F\uFF0C\u4F46\u60A8\u6CA1\u6709\u8BBF\u95EE\u6743\u9650\u3002",
        "\u6216\u8005\u53EA\u662F\u6709\u4EBA\u5728\u590D\u5236\u7C98\u8D34\u94FE\u63A5\u65F6\u4E0D\u591F\u5C0F\u5FC3\u3002"
    ],
    'home': "\u9996\u9875",
    'home.header.hint': "\u9762\u5411\u72EC\u7ACB\u5F00\u53D1\u8005\u7684\u4E91\u7AEF\u5DE5\u5177",
    'home.description': "Kavykhi.Cloud \u662F\u4E00\u4E2A\u9762\u5411\u72EC\u7ACB\u6E38\u620F\u7684\u5F00\u53D1\u5E73\u53F0\u3002\u6211\u4EEC\u652F\u6301\u53EF\u4E0B\u8F7D\u6E38\u620F\u548C\u7F51\u9875\u6E38\u620F\u3001\u79C1\u6709\u548C\u516C\u5F00\u6784\u5EFA\u7248\u672C\u3001\u5206\u652F\u3001\u56E2\u961F\u7B49\u4F17\u591A\u529F\u80FD\u3002",
    'home.auth': "\u767B\u5F55\u6216\u6CE8\u518C",
    'home.auth.hint': "\u521B\u5EFA\u65B0\u8D26\u53F7\u6216\u767B\u5F55\u73B0\u6709\u8D26\u53F7",
    'projects': "\u9879\u76EE",
    'projects.hint': "\u60A8\u6B63\u5728\u53C2\u4E0E\u7684\u9879\u76EE",
    'projects.project': (project)=>`\u{9879}\u{76EE}\u{FF1A}${project}`,
    'projects.project.hint': "\u9879\u76EE",
    'projects.no_projects': "\u60A8\u76EE\u524D\u6CA1\u6709\u4EFB\u4F55\u9879\u76EE\u3002",
    'projects.new': "\u521B\u5EFA\u9879\u76EE",
    'projects.new_dialog.header': "\u65B0\u5EFA\u9879\u76EE",
    'projects.new_dialog.label': "\u9879\u76EE\u540D\u79F0",
    'projects.new_dialog.ok': "\u521B\u5EFA\u9879\u76EE",
    'projects.store_page': "\u516C\u5F00\u5546\u5E97\u9875\u9762",
    'projects.description': "\u63CF\u8FF0",
    'projects.branches': "\u5206\u652F",
    'projects.versions': "\u7248\u672C",
    'projects.packages': "\u5305",
    'projects.management': "\u9879\u76EE\u8BBE\u7F6E",
    'projects.management.breadcrumb': "\u8BBE\u7F6E",
    'projects.management.title': (projectTitle)=>`${projectTitle} - \u{8BBE}\u{7F6E}`,
    'projects.management.hint': "\u9879\u76EE\u8BBE\u7F6E",
    'projects.management.users': "\u56E2\u961F\u6210\u5458",
    'projects.management.users.empty': "\u6682\u65E0\u56E2\u961F\u6210\u5458\u3002",
    'projects.management.users.role.tester': "\u6D4B\u8BD5\u5458",
    'projects.management.users.role.developer': "\u5F00\u53D1\u8005",
    'projects.management.users.role.admin': "\u7BA1\u7406\u5458",
    'projects.management.users.role.owner': "\u6240\u6709\u8005",
    'projects.management.users.role.starred': "\u5DF2\u661F\u6807",
    'projects.management.users.exile': "\u79FB\u51FA\u56E2\u961F",
    'projects.management.users.exile.dialog.header': "\u79FB\u51FA\u56E2\u961F",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u5C06 ",
            userTitle,
            " \u4ECE\u9879\u76EE ",
            projectTitle,
            " \u4E2D\u79FB\u51FA\u5417\uFF1F"
        ],
    'projects.management.users.exile.dialog.ok': "\u79FB\u51FA\u56E2\u961F",
    'projects.management.invites.one_time_invite': "\u4E00\u6B21\u6027\u9080\u8BF7\u94FE\u63A5",
    'projects.management.invites.one_time_invite.header': "\u4E00\u6B21\u6027\u9080\u8BF7\u94FE\u63A5",
    'projects.management.invites.one_time_invite.message': "\u4E00\u6B21\u6027\u9080\u8BF7\u94FE\u63A5\uFF1A",
    'projects.management.invites.one_time_invite.note': "\u6709\u6548\u671F 24 \u5C0F\u65F6\uFF0C\u4EC5\u53EF\u4F7F\u7528\u4E00\u6B21\u3002",
    'projects.management.invites.new_dialog.header': "\u9080\u8BF7\u94FE\u63A5",
    'projects.management.invites.new_dialog.expires': "\u8FC7\u671F\u65F6\u95F4\uFF1A",
    'projects.management.invites.new_dialog.expires.indefinite': "(\u6C38\u4E0D\u8FC7\u671F)",
    'projects.management.invites.new_dialog.approval.label': "\u7528\u6237\u52A0\u5165\u9879\u76EE\uFF1A",
    'projects.management.invites.new_dialog.approval.not_approved': "\u9700\u7BA1\u7406\u5458\u6279\u51C6",
    'projects.management.invites.new_dialog.approval.approved': "\u7ACB\u5373\u52A0\u5165",
    'projects.management.invites.new_dialog.seats': "\u52A0\u5165\u4EBA\u6570\u9650\u5236\uFF1A",
    'projects.management.invites.new_dialog.seats.no_limit': "(\u65E0\u9650\u5236)",
    'projects.management.invites.new_dialog.ok': "\u521B\u5EFA\u9080\u8BF7\u94FE\u63A5",
    'projects.management.deploy_sites': "\u90E8\u7F72\u7AD9\u70B9",
    'projects.management.deploy_sites.empty': "\u672A\u6DFB\u52A0\u90E8\u7F72\u7AD9\u70B9\u3002",
    'projects.management.deploy_sites.add': "\u6DFB\u52A0\u90E8\u7F72\u7AD9\u70B9",
    'projects.management.deploy_sites.delete': "\u5220\u9664",
    'projects.management.deploy_sites.delete_dialog.header': "\u5220\u9664\u90E8\u7F72\u7AD9\u70B9",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "\u60A8\u786E\u5B9A\u8981\u5220\u9664 ",
            provider,
            " \u7684\u90E8\u7F72\u7AD9\u70B9 ",
            site,
            " \u5417\uFF1F"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "\u5220\u9664\u90E8\u7F72\u7AD9\u70B9",
    'projects.management.public_access': "\u516C\u5F00\u8BBF\u95EE",
    'projects.management.public_access.enable': "\u542F\u7528\u516C\u5F00\u8BBF\u95EE",
    'projects.management.public_access.enabled': [
        "\u516C\u5F00\u8BBF\u95EE\uFF1A",
        $beff090cf88b012d$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "\u9879\u76EE\u7684\u540D\u79F0\u548C\u63CF\u8FF0\u662F\u516C\u5F00\u7684\uFF0C\u4EFB\u4F55\u6807\u8BB0\u4E3A\u516C\u5F00\u7684\u5206\u652F\u4E5F\u662F\u516C\u5F00\u7684\u3002",
    'projects.management.public_access.enable_dialog.header': "\u542F\u7528\u516C\u5F00\u8BBF\u95EE",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u5141\u8BB8\u516C\u5F00\u8BBF\u95EE\u9879\u76EE ",
            projectTitle,
            " \u5417\uFF1F",
            $beff090cf88b012d$var$_tmpl$2(),
            $beff090cf88b012d$var$_tmpl$2(),
            "\u8FD9\u5C06\u4F7F\u9879\u76EE\u7684\u57FA\u672C\u4FE1\u606F\u5728\u65E0\u9700\u8BA4\u8BC1\u7684\u60C5\u51B5\u4E0B\u53EF\u89C1\u3002\u60A8\u9700\u8981\u5355\u72EC\u4E3A\u5E0C\u671B\u516C\u5F00\u7684\u6BCF\u4E2A\u5206\u652F\u542F\u7528\u516C\u5F00\u8BBF\u95EE\u3002"
        ],
    'projects.management.public_access.enable_dialog.ok': "\u542F\u7528\u516C\u5F00\u8BBF\u95EE",
    'projects.management.public_access.disable': "\u7981\u7528\u516C\u5F00\u8BBF\u95EE",
    'projects.management.public_access.disabled': [
        "\u516C\u5F00\u8BBF\u95EE\uFF1A",
        $beff090cf88b012d$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "\u8BE5\u9879\u76EE\u4E3A\u79C1\u6709\u3002\u53EA\u6709\u9879\u76EE\u56E2\u961F\u7684\u6210\u5458\u624D\u80FD\u8BBF\u95EE\u3002",
    'projects.management.public_access.disable_dialog.header': "\u7981\u7528\u516C\u5F00\u8BBF\u95EE",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u7981\u7528\u9879\u76EE ",
            projectTitle,
            " \u7684\u6240\u6709\u516C\u5F00\u8BBF\u95EE\u5417\uFF1F"
        ],
    'projects.management.public_access.disable_dialog.ok': "\u7981\u7528\u516C\u5F00\u8BBF\u95EE",
    'projects.management.public_access.branches': "\u516C\u5F00\u5206\u652F",
    'projects.management.manage': "\u7BA1\u7406\u9879\u76EE",
    'projects.rename': "\u91CD\u547D\u540D\u9879\u76EE",
    'projects.rename_dialog.header': "\u91CD\u547D\u540D\u9879\u76EE",
    'projects.rename_dialog.label': "\u9879\u76EE\u540D\u79F0\uFF1A",
    'projects.rename_dialog.ok': "\u91CD\u547D\u540D\u9879\u76EE",
    'projects.edit_description': "\u7F16\u8F91\u9879\u76EE\u63CF\u8FF0",
    'projects.edit_description_dialog.header': "\u7F16\u8F91\u9879\u76EE\u63CF\u8FF0",
    'projects.edit_description_dialog.label': "\u9879\u76EE\u63CF\u8FF0\uFF1A",
    'projects.edit_description_dialog.ok': "\u7F16\u8F91\u63CF\u8FF0",
    'projects.leave': "\u79BB\u5F00\u9879\u76EE",
    'projects.leave_dialog.header': "\u79BB\u5F00\u9879\u76EE",
    'projects.leave_dialog.message': (projectTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u79BB\u5F00\u9879\u76EE ",
            projectTitle,
            " \u5417\uFF1F"
        ],
    'projects.leave_dialog.ok': "\u79BB\u5F00\u9879\u76EE",
    'projects.delete': "\u5220\u9664\u9879\u76EE",
    'projects.delete_dialog.header': "\u5220\u9664\u9879\u76EE",
    'projects.delete_dialog.message': (projectTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u9879\u76EE ",
            projectTitle,
            " \u5417\uFF1F"
        ],
    'projects.delete_dialog.ok': "\u5220\u9664\u9879\u76EE",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "\u5206\u652F",
    'branches.no_branches': "\u8BE5\u9879\u76EE\u6682\u65E0\u5206\u652F",
    'branches.new': "\u521B\u5EFA\u5206\u652F",
    'branches.new_dialog.header': "\u65B0\u5EFA\u5206\u652F",
    'branches.new_dialog.label': "\u5206\u652F\u540D\u79F0",
    'branches.new_dialog.ok': "\u521B\u5EFA\u5206\u652F",
    'branches.current_version': (version)=>[
            "\u5F53\u524D\u7248\u672C\uFF1A",
            version
        ],
    'branches.current_version.packages': "\u5F53\u524D\u7248\u672C\u5305",
    'branches.no_current_version': "\u65E0\u5F53\u524D\u7248\u672C",
    'branches.publish_version.new': "\u53D1\u5E03\u65B0\u7248\u672C",
    'branches.publish_version.existing': "\u91CD\u65B0\u53D1\u5E03\u73B0\u6709\u7248\u672C",
    'branches.version_history': "\u7248\u672C\u5386\u53F2",
    'branches.version_history.empty': "\u8BE5\u5206\u652F\u7684\u7248\u672C\u5386\u53F2\u4E3A\u7A7A\u3002",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "\u5F53\u524D\u5206\u652F\u7248\u672C\u4FDD\u7559\u65F6\u95F4\uFF1A",
            quotaTime != null ? quotaTime : "\u6C38\u4E45",
            "\u3002\u5386\u53F2\u7248\u672C\u6700\u591A\u4FDD\u7559 ",
            quotaNonCurrentTime,
            "\u3002\u6BCF\u4E2A\u5206\u652F\u603B\u5171\u6700\u591A\u4FDD\u7559 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$beff090cf88b012d$var$plural(quotaCount, [
                    quotaCountText,
                    " \u4E2A\u7248\u672C"
                ], [
                    quotaCountText,
                    " \u4E2A\u7248\u672C"
                ])),
            "\u3002"
        ],
    'branches.manage': "\u7BA1\u7406\u5206\u652F",
    'branches.rename': "\u91CD\u547D\u540D\u5206\u652F",
    'branches.rename_dialog.header': "\u91CD\u547D\u540D\u5206\u652F",
    'branches.rename_dialog.label': "\u5206\u652F\u540D\u79F0\uFF1A",
    'branches.rename_dialog.ok': "\u91CD\u547D\u540D\u5206\u652F",
    'branches.delete': "\u5220\u9664\u5206\u652F",
    'branches.delete_dialog.header': "\u5220\u9664\u5206\u652F",
    'branches.delete_dialog.message': (branchTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u5206\u652F ",
            branchTitle,
            " \u5417\uFF1F"
        ],
    'branches.delete_dialog.ok': "\u5220\u9664\u5206\u652F",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "\u7248\u672C",
    'versions.current': "\u5F53\u524D",
    'versions.previous': "\u5386\u53F2",
    'versions.description': "\u63CF\u8FF0",
    'versions.deploy_to_site.header': "\u53D1\u5E03\u5230\u7AD9\u70B9",
    'versions.deploy_to_site': "\u53D1\u5E03\u5230\u7AD9\u70B9",
    'versions.packages': "\u5305",
    'versions.branches': "\u6240\u5728\u5206\u652F",
    'versions.branches.publish': "\u53D1\u5E03\u5230\u5206\u652F",
    'versions.branches.empty': "\u8BE5\u7248\u672C\u5C1A\u672A\u5728\u4EFB\u4F55\u5206\u652F\u4E2D\u53D1\u5E03\u3002",
    'versions.new_dialog.header': "\u65B0\u5EFA\u7248\u672C",
    'versions.new_dialog.label_title': "\u7248\u672C\uFF1A",
    'versions.new_dialog.label_branch': "\u5206\u652F\uFF1A",
    'versions.new_dialog.packages.header': "\u5305",
    'versions.new_dialog.packages.empty': "\u672A\u6DFB\u52A0\u5305\u3002",
    'versions.new_dialog.packages.add': "\u6DFB\u52A0\u5305",
    'versions.new_dialog.packages.add_existing': "\u6DFB\u52A0\u5148\u524D\u4E0A\u4F20\u7684\u5305",
    'versions.new_dialog.packages.replace': "\u66FF\u6362\u5305",
    'versions.new_dialog.packages.edit': "\u7F16\u8F91\u5305",
    'versions.new_dialog.ok': "\u521B\u5EFA\u7248\u672C",
    'versions.manage': "\u7BA1\u7406\u7248\u672C",
    'versions.rename': "\u91CD\u547D\u540D\u7248\u672C",
    'versions.rename_dialog.header': "\u91CD\u547D\u540D\u7248\u672C",
    'versions.rename_dialog.label': "\u7248\u672C\u540D\u79F0\uFF1A",
    'versions.rename_dialog.ok': "\u91CD\u547D\u540D\u7248\u672C",
    'versions.edit_description': "\u7F16\u8F91\u7248\u672C\u63CF\u8FF0",
    'versions.edit_description_dialog.header': "\u7F16\u8F91\u7248\u672C\u63CF\u8FF0",
    'versions.edit_description_dialog.label': "\u7248\u672C\u63CF\u8FF0\uFF1A",
    'versions.edit_description_dialog.ok': "\u7F16\u8F91\u63CF\u8FF0",
    'versions.delete': "\u5220\u9664\u7248\u672C",
    'versions.delete_dialog.header': "\u5220\u9664\u7248\u672C",
    'versions.delete_dialog.message': (versionTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u7248\u672C ",
            versionTitle,
            " \u5417\uFF1F"
        ],
    'versions.delete_dialog.ok': "\u5220\u9664\u7248\u672C",
    'versions.publish_dialog.header': "\u53D1\u5E03\u7248\u672C\u5230\u5206\u652F",
    'versions.publish_dialog.message': (versionTitle)=>[
            "\u9009\u62E9\u8981\u5C06\u7248\u672C ",
            versionTitle,
            " \u53D1\u5E03\u5230\u7684\u5206\u652F\u3002"
        ],
    'versions.publish_dialog.no_branches': "\u9879\u76EE\u4E2D\u6CA1\u6709\u5206\u652F\u3002",
    'versions.publish_dialog.ok': "\u53D1\u5E03\u7248\u672C",
    'versions.publish_existing_dialog.header': "\u91CD\u65B0\u53D1\u5E03\u7248\u672C",
    'versions.publish_existing_dialog.message': "\u6700\u8FD1\u7248\u672C\uFF1A",
    'versions.publish_existing_dialog.no_versions': "\u9879\u76EE\u4E2D\u6CA1\u6709\u7248\u672C\u3002",
    'versions.publish_existing_dialog.ok': "\u53D1\u5E03\u7248\u672C",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': "\u5305",
    'packages.download_zip': "\u4E0B\u8F7D\u4E3A ZIP",
    'packages.download_torrent': "\u4E0B\u8F7D\u79CD\u5B50",
    'packages.total_size': (size)=>[
            "\u603B\u5927\u5C0F\uFF1A",
            size
        ],
    'packages.manage': "\u7BA1\u7406\u5305",
    'packages.rename': "\u91CD\u547D\u540D\u5305",
    'packages.rename_dialog.header': "\u91CD\u547D\u540D\u5305",
    'packages.rename_dialog.label': "\u5305\u540D\u79F0\uFF1A",
    'packages.rename_dialog.ok': "\u91CD\u547D\u540D\u5305",
    'packages.edit_tags': "\u7F16\u8F91\u5305\u6807\u7B7E",
    'packages.edit_tags_dialog.header': "\u7F16\u8F91\u5305\u6807\u7B7E",
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "\u6307\u5B9A\u5305 ",
            packageTitle,
            " \u7684\u6807\u7B7E\uFF1A"
        ],
    'packages.edit_tags_dialog.ok': "\u8BBE\u7F6E\u5305\u6807\u7B7E",
    'packages.entrypoint': (entrypoint)=>[
            "\u542F\u52A8\u6587\u4EF6\uFF1A",
            entrypoint
        ],
    'packages.entrypoint.empty': "\u672A\u8BBE\u7F6E\u542F\u52A8\u6587\u4EF6\u3002",
    'packages.delete': "\u5220\u9664\u5305",
    'packages.delete_dialog.header': "\u5220\u9664\u5305",
    'packages.delete_dialog.message': (packageTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u5305 ",
            packageTitle,
            " \u5417\uFF1F\u8BE5\u5305\u5C06\u4ECE\u6240\u6709\u5DF2\u6DFB\u52A0\u7684\u7248\u672C\u4E2D\u5220\u9664\u3002"
        ],
    'packages.delete_dialog.ok': "\u5220\u9664\u5305",
    'packages.new_dialog.header': "\u65B0\u5EFA\u5305",
    'packages.new_dialog.label_title': "\u6807\u9898\uFF1A",
    'packages.new_dialog.title_placeholder': "(\u6765\u81EA\u6807\u7B7E)",
    'packages.new_dialog.tags.header': "\u6807\u7B7E",
    'packages.new_dialog.files.header': "\u6587\u4EF6",
    'packages.new_dialog.total_size': (size, maximum)=>[
            "\u603B\u5927\u5C0F\uFF1A",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(\u6700\u5927 ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "\u65B0\u6570\u636E\u5927\u5C0F\uFF1A",
            size
        ],
    'packages.new_dialog.checks.empty': "\u672A\u6DFB\u52A0\u6587\u4EF6\u3002",
    'packages.new_dialog.checks.entrypoint.empty': "\u672A\u8BBE\u7F6E\u542F\u52A8\u6587\u4EF6\u3002",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "\u542F\u52A8\u6587\u4EF6 ",
            entrypoint,
            " \u4E0D\u5B58\u5728\uFF1B\u60A8\u662F\u5426\u5FD8\u8BB0\u6DFB\u52A0\u5B83\uFF1F\u8BF7\u6307\u5B9A\u4E00\u4E2A\u73B0\u6709\u7684\u542F\u52A8\u6587\u4EF6\uFF0C\u6216\u8005\u60A8\u4E5F\u53EF\u4EE5\u4E0D\u8BBE\u7F6E\u542F\u52A8\u6587\u4EF6\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "\u53D6\u6D88\u8BBE\u7F6E\u542F\u52A8\u6587\u4EF6",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "\u542F\u52A8\u6587\u4EF6\u6269\u5C55\u540D\u4E3A ",
            fileExt,
            "\uFF1A\u5EFA\u8BAE\u6DFB\u52A0 ",
            tag,
            " \u6807\u7B7E\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "\u6DFB\u52A0 ",
            tag,
            " \u6807\u7B7E"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "\u542F\u52A8\u6587\u4EF6\u6269\u5C55\u540D\u4E3A ",
            fileExt,
            "\uFF1A\u6DFB\u52A0 ",
            tag,
            " \u6807\u7B7E\u4EE5\u4F7F\u8BE5\u5305\u53EF\u5728\u6D4F\u89C8\u5668\u4E2D\u8FD0\u884C\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "\u542F\u52A8\u6587\u4EF6\u6269\u5C55\u540D\u4E3A ",
            fileExt,
            "\uFF1A\u8FD9\u662F\u5426\u662F\u4E2A\u9519\u8BEF\uFF1F\u901A\u5E38\u8FD9\u4E0D\u662F\u53EF\u4EE5\u542F\u52A8\u7684\u6587\u4EF6\u7C7B\u578B\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "\u542F\u52A8\u6587\u4EF6\u6269\u5C55\u540D\u4E3A ",
            fileExt,
            "\uFF1A\u5EFA\u8BAE\u76F4\u63A5\u5305\u542B\u5B9E\u9645\u5185\u5BB9\u6587\u4EF6\uFF0C\u800C\u4E0D\u662F\u5C06\u5176\u6253\u5305\u5230\u5F52\u6863\u6587\u4EF6\u4E2D\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.executable': "\u542F\u52A8\u6587\u4EF6\u672A\u6807\u8BB0\u4E3A\u53EF\u6267\u884C\u6587\u4EF6",
    'packages.new_dialog.checks.entrypoint.executable.action': "\u6807\u8BB0\u4E3A\u53EF\u6267\u884C\u6587\u4EF6",
    'packages.new_dialog.checks.single_root_dir': "\u5EFA\u8BAE\u5C06\u6587\u4EF6\u76F4\u63A5\u653E\u5728\u6839\u76EE\u5F55\u4E0B\uFF0C\u800C\u4E0D\u662F\u5728\u6839\u76EE\u5F55\u4E0B\u53EA\u5305\u542B\u5355\u4E2A\u6587\u4EF6\u5939\u3002",
    'packages.new_dialog.checks.single_root_dir.action': "\u7528\u6587\u4EF6\u5939\u5185\u5BB9\u66FF\u6362\u6587\u4EF6\u5939",
    'packages.add_existing_dialog.header': "\u6DFB\u52A0\u5305",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `\u{6DFB}\u{52A0} ${$beff090cf88b012d$var$plural(packagesCount, `${packagesCount} \u{4E2A}\u{5305}`, `${packagesCount} \u{4E2A}\u{5305}`)}` : "\u672A\u9009\u62E9\u5305",
    'packages.add_existing_dialog.message': "\u6700\u8FD1\u4E0A\u4F20\u7684\u5305\uFF1A",
    'packages.add_existing_dialog.no_packages': "\u6700\u8FD1\u6CA1\u6709\u4E0A\u4F20\u7684\u5305\u3002",
    'packages.launch': "\u542F\u52A8",
    'packages.install': "\u5B89\u88C5",
    'packages.install_dialog.header': "\u5B89\u88C5",
    'packages.install_dialog.workdir.label': "\u5DE5\u4F5C\u76EE\u5F55\uFF1A",
    'packages.install_dialog.workdir.value.new': "(\u521B\u5EFA\u65B0\u76EE\u5F55)",
    'packages.install_dialog.workspace.label': "\u5728\u6B64\u76EE\u5F55\u4E0B\u521B\u5EFA\u6587\u4EF6\u5939\uFF1A",
    'packages.install_dialog.workspace.placeholder': "(\u9009\u62E9\u6839\u6587\u4EF6\u5939)",
    'packages.install_dialog.ok': "\u5B89\u88C5",
    'packages.update': "\u66F4\u65B0",
    'packages.upload.status.existing': "\u6765\u81EA\u4E0A\u4E00\u4E2A\u7248\u672C",
    'packages.upload.status.queued': "\u6392\u961F\u4E2D",
    'packages.upload.status.packing': "\u6253\u5305\u4E2D...",
    'packages.upload.status.creating': "\u521B\u5EFA\u4E2D...",
    'packages.upload.status.create_retrying': "\u521B\u5EFA\u5931\u8D25\uFF0C\u6B63\u5728\u7B49\u5F85\u5E76\u91CD\u8BD5",
    'packages.upload.status.splitting': "\u62C6\u5206\u4E2D...",
    'packages.upload.status.uploading': "\u4E0A\u4F20\u4E2D...",
    'packages.upload.status.finalizing': "\u6B63\u5728\u5B8C\u6210...",
    'packages.upload.status.finalize_retrying': "\u5B8C\u6210\u5931\u8D25\uFF0C\u6B63\u5728\u7B49\u5F85\u5E76\u91CD\u8BD5",
    'packages.upload.status.resolving': "\u6B63\u5728\u89E3\u6790\u8865\u4E01...",
    'packages.upload.status.resolve_retrying': "\u89E3\u6790\u8865\u4E01\u5931\u8D25\uFF0C\u6B63\u5728\u7B49\u5F85\u5E76\u91CD\u8BD5...",
    'packages.upload.status.done': "\u4E0A\u4F20\u6210\u529F",
    'packages.upload.status.errored': "\u9519\u8BEF",
    'packages.upload.part.status.queued': "\u6392\u961F\u4E2D",
    'packages.upload.part.status.hashing': "\u54C8\u5E0C\u8BA1\u7B97\u4E2D",
    'packages.upload.part.status.upload_queued': "\u4E0A\u4F20\u6392\u961F\u4E2D",
    'packages.upload.part.status.uploading': "\u4E0A\u4F20\u4E2D",
    'packages.upload.part.status.upload_retrying': "\u9519\u8BEF\uFF0C\u6B63\u5728\u91CD\u8BD5\u4E0A\u4F20",
    'packages.upload.part.status.upload_finalizing': "\u6B63\u5728\u5B8C\u6210\u4E0A\u4F20",
    'packages.upload.part.status.upload_errored': "\u9519\u8BEF",
    'packages.upload.part.status.done': "\u5DF2\u4E0A\u4F20",
    'packages.play': "\u5728\u6D4F\u89C8\u5668\u4E2D\u8FD0\u884C",
    'packages.play.reset': "\u91CD\u7F6E",
    'packages.play.fullscreen': "\u5168\u5C4F",
    'deploy_sites.add_dialog.header': "\u6DFB\u52A0\u90E8\u7F72\u7AD9\u70B9",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "\u9009\u62E9\u90E8\u7F72\u51ED\u636E\u5E76\u8F93\u5165\u7AD9\u70B9 URL\uFF0C\u4EE5\u5C06\u5176\u4FDD\u5B58\u4E3A\u9879\u76EE ",
            projectTitle,
            " \u7684\u90E8\u7F72\u7AD9\u70B9\u3002"
        ],
    'deploy_sites.add_dialog.label_credential': "\u90E8\u7F72\u51ED\u636E\uFF1A",
    'deploy_sites.add_dialog.select_credential': "\u9009\u62E9\u51ED\u636E",
    'deploy_sites.add_dialog.select_credential.new': "\u6DFB\u52A0\u65B0\u51ED\u636E...",
    'deploy_sites.add_dialog.label_select_site': "\u9009\u62E9\u7AD9\u70B9\uFF1A",
    'deploy_sites.add_dialog.select_credential_first': "(\u8BF7\u5148\u9009\u62E9\u51ED\u636E)",
    'deploy_sites.add_dialog.select_site': "(\u9009\u62E9\u7AD9\u70B9)",
    'deploy_sites.add_dialog.label_enter_site': "\u6216\u8F93\u5165\u7AD9\u70B9 URL\uFF1A",
    'deploy_sites.add_dialog.ok': "\u6DFB\u52A0\u7AD9\u70B9",
    'deploy_to_site_dialog.header': "\u53D1\u5E03\u5230\u7AD9\u70B9",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "\u9009\u62E9\u8981\u53D1\u5E03\u9879\u76EE ",
            projectTitle,
            " \u7684\u7248\u672C ",
            versionTitle,
            " \u7684\u7AD9\u70B9\u3002"
        ],
    'deploy_to_site_dialog.label_site': "\u53D1\u5E03\u5230\u7AD9\u70B9\uFF1A",
    'deploy_to_site_dialog.select_site': "\u9009\u62E9\u7AD9\u70B9",
    'deploy_to_site_dialog.select_site.new': "\u6DFB\u52A0\u65B0\u90E8\u7F72\u7AD9\u70B9...",
    'deploy_to_site_dialog.packages.message.itch': [
        "\u5305\u5C06\u4F7F\u7528 ",
        $beff090cf88b012d$var$_tmpl$4(),
        " \u53D1\u5E03\u5230 itch.io\u3002\u9891\u9053\u540D\u79F0\u6D3E\u751F\u81EA\u5305\u6807\u7B7E\u3002"
    ],
    'deploy_to_site_dialog.deploy': "\u53D1\u5E03",
    'deploy_to_site_dialog.close': "\u5173\u95ED",
    'deploy_to_site_dialog.error.no_packages': "\u6CA1\u6709\u53EF\u53D1\u5E03\u7684\u5305\u3002",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "\u4E0D\u80FD\u5C06\u591A\u4E2A\u5305\u53D1\u5E03\u5230\u5355\u4E2A\u9891\u9053\u4E2D\u3002\u5F53\u524D\u5DF2\u8BBE\u7F6E\u5C06 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$beff090cf88b012d$var$plural(packagesCount, [
                    packagesCountText,
                    " \u4E2A\u5305"
                ], [
                    packagesCountText,
                    " \u4E2A\u5305"
                ])),
            " \u53D1\u5E03\u5230\u9891\u9053 ",
            channel,
            "\u3002"
        ],
    'deploy_to_site_dialog.job.queued': "\u6392\u961F\u4E2D",
    'deploy_to_site_dialog.job.downloading': "\u4E0B\u8F7D\u4E2D...",
    'deploy_to_site_dialog.job.unpacking': "\u89E3\u5305\u4E2D...",
    'deploy_to_site_dialog.job.uploading': "\u53D1\u5E03\u4E2D...",
    'deploy_to_site_dialog.job.succeeded': "\u6210\u529F",
    'deploy_to_site_dialog.job.errored': "\u9519\u8BEF",
    'store': "\u5546\u5E97",
    'store.hint': "\u516C\u5F00\u9879\u76EE",
    'store.project.hint': "\u5546\u5E97\u9879\u76EE\u9875\u9762",
    'store.project.owner': "\u5F00\u53D1\u8005",
    'store.project.description': "\u63CF\u8FF0",
    'store.project.star': "\u661F\u6807",
    'store.project.starred': "\u5DF2\u661F\u6807",
    'store.project.content': "\u5185\u5BB9",
    'store.project.content.warning': "\u6B64\u5185\u5BB9\u7531\u7B2C\u4E09\u65B9\u5F00\u53D1\u8005\u63D0\u4F9B\u3002",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            branchTitle,
            " \u5206\u652F\uFF1A\u7248\u672C ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "\u53D1\u5E03\u65F6\u95F4\uFF1A",
            branchVersionPublished
        ],
    'me': "\u4E2A\u4EBA\u8D44\u6599",
    'me.hint': "\u4E2A\u4EBA\u8D44\u6599\u8BBE\u7F6E\u548C\u5173\u8054\u7684\u51ED\u636E",
    'me.rename': "\u91CD\u547D\u540D\u4E2A\u4EBA\u8D44\u6599",
    'me.rename_dialog.header': "\u91CD\u547D\u540D\u4E2A\u4EBA\u8D44\u6599",
    'me.rename_dialog.label_title': "\u540D\u79F0\uFF1A",
    'me.rename_dialog.ok': "\u91CD\u547D\u540D\u4E2A\u4EBA\u8D44\u6599",
    'me.credentials': "\u51ED\u636E",
    'me.credentials.hint.auth_allowed': "\u8FD9\u4E9B\u51ED\u636E\u4E2D\u7684\u4EFB\u4F55\u4E00\u4E2A\u90FD\u53EF\u4EE5\u7528\u4E8E\u767B\u5F55\u6B64\u8D26\u53F7\u3002",
    'me.credentials.hint.auth_disallowed': "\u8FD9\u4E9B\u51ED\u636E\u5DF2\u5173\u8054\u5230\u60A8\u7684\u8D26\u53F7\uFF0C\u4F46\u4E0D\u80FD\u7528\u4E8E\u767B\u5F55\u3002",
    'me.credentials.empty': "\u65E0\u51ED\u636E\u3002",
    'me.credentials.empty.auth_allowed.warning': "\u60A8\u53EF\u80FD\u4F1A\u88AB\u9501\u5B9A\u5728\u8D26\u53F7\u4E4B\u5916\uFF01\u60A8\u5C1A\u672A\u5173\u8054\u4EFB\u4F55\u53EF\u7528\u4E8E\u767B\u5F55\u7684\u51ED\u636E\u3002\u8BF7\u5C3D\u5FEB\u5173\u8054\u4E00\u4E2A\u53EF\u767B\u5F55\u7684\u51ED\u636E\u3002",
    'me.credentials.profile_picture.alt': (provider)=>`${$beff090cf88b012d$var$dict[`auth.provider.${provider}`]} \u{5934}\u{50CF}`,
    'me.credentials.created': (created)=>[
            "\u5DF2\u4E8E ",
            created,
            " \u6DFB\u52A0"
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\u4E0A\u6B21\u4F7F\u7528\u4E8E ",
            lastUsed
        ],
    'me.credential.unlink': "\u53D6\u6D88\u5173\u8054",
    'me.credential.allow_auth': "\u5141\u8BB8\u767B\u5F55",
    'me.credential.disallow_auth': "\u7981\u6B62\u767B\u5F55",
    'me.credential.display_publicly': "\u516C\u5F00\u663E\u793A",
    'me.credential.dont_display_publicly': "\u4E0D\u516C\u5F00\u663E\u793A",
    'me.credential.link': "\u5173\u8054\u51ED\u636E",
    'me.credential.link_dialog.header': "\u5173\u8054\u51ED\u636E",
    'me.credential.link_dialog.message': "\u8BF7\u9009\u62E9\u8981\u5173\u8054\u7684\u8D26\u53F7\u670D\u52A1\u5546\u3002",
    'me.credential.unlink_dialog.header': "\u53D6\u6D88\u5173\u8054\u51ED\u636E",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u4ECE\u60A8\u7684 Kavykhi.Cloud \u8D26\u53F7\u4E2D\u53D6\u6D88\u5173\u8054 ",
            credentialProvider,
            " \u8D26\u53F7 ",
            credentialTitle,
            " \u5417\uFF1F"
        ],
    'me.credential.unlink_dialog.ok': "\u53D6\u6D88\u5173\u8054\u51ED\u636E",
    'me.sessions': "\u4F1A\u8BDD",
    'me.sessions.hint': "\u8FD9\u662F\u60A8\u7684\u6D3B\u52A8\u4F1A\u8BDD\u5217\u8868\uFF0C\u5305\u62EC\u60A8\u5F53\u524D\u7684\u6D4F\u89C8\u5668\u3002",
    'me.sessions.started': (started)=>[
            "\u5F00\u59CB\u4E8E ",
            (()=>{
                var _el$6 = $beff090cf88b012d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "\u6D3B\u8DC3\u4E8E ",
            (()=>{
                var _el$7 = $beff090cf88b012d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "\u5F53\u524D\u4F1A\u8BDD",
    'me.sessions.empty': "\u65E0\u4F1A\u8BDD\u3002",
    'me.sessions.delete': "\u7EC8\u6B62",
    'me.sessions.delete_dialog.header': "\u7EC8\u6B62\u4F1A\u8BDD",
    'me.sessions.delete_dialog.message': "\u60A8\u786E\u5B9A\u8981\u7EC8\u6B62\u6B64\u4F1A\u8BDD\u5417\uFF1F",
    'me.sessions.delete_dialog.ok': "\u7EC8\u6B62\u4F1A\u8BDD",
    'me.api_tokens': "API \u4EE4\u724C",
    'me.api_tokens.hint': "\u53EF\u4EE5\u5728\u6B64\u5904\u521B\u5EFA API \u4EE4\u724C\u4EE5\u7528\u4E8E\u81EA\u52A8\u5316\u3002",
    'me.api_tokens.started': (started)=>[
            "\u521B\u5EFA\u4E8E ",
            (()=>{
                var _el$8 = $beff090cf88b012d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "\u8FC7\u671F\u65F6\u95F4 ",
            (()=>{
                var _el$9 = $beff090cf88b012d$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "\u6C38\u4E0D\u8FC7\u671F",
    'me.api_tokens.empty': "\u65E0 API \u4EE4\u724C\u3002",
    'me.api_tokens.create': "\u751F\u6210 API \u4EE4\u724C",
    'me.api_tokens.create_dialog.header': "\u751F\u6210 API \u4EE4\u724C",
    'me.api_tokens.create_dialog.message': "\u751F\u6210\u7684 API \u4EE4\u724C\uFF1A",
    'me.api_tokens.create_dialog.note': "\u8BE5\u4EE4\u724C\u4E0D\u4F1A\u518D\u6B21\u663E\u793A\uFF0C\u8BF7\u59A5\u5584\u4FDD\u5B58\u3002",
    'me.api_tokens.delete': "\u5220\u9664",
    'me.api_tokens.delete_dialog.header': "\u5220\u9664 API \u4EE4\u724C",
    'me.api_tokens.delete_dialog.message': "\u60A8\u786E\u5B9A\u8981\u5220\u9664\u6B64\u4EE4\u724C\u5417\uFF1F",
    'me.api_tokens.delete_dialog.ok': "\u5220\u9664 API \u4EE4\u724C",
    'me.deploy_credentials': "\u90E8\u7F72\u51ED\u636E",
    'me.deploy_credentials.hint': "\u53EF\u4EE5\u5728\u6B64\u5904\u6DFB\u52A0\u7528\u4E8E\u90E8\u7F72\u5230\u53D1\u5E03\u5E73\u53F0\u7684\u51ED\u636E\u3002",
    'me.deploy_credentials.empty': "\u672A\u6DFB\u52A0\u90E8\u7F72\u51ED\u636E\u3002",
    'me.deploy_credential.add': "\u6DFB\u52A0\u90E8\u7F72\u51ED\u636E",
    'me.deploy_credential.add_dialog.header': "\u6DFB\u52A0\u90E8\u7F72\u51ED\u636E",
    'me.deploy_credential.add_dialog.label_site': "\u7AD9\u70B9\uFF1A",
    'me.deploy_credential.add_dialog.label_title': "\u5907\u6CE8\uFF1A",
    'me.deploy_credential.add_dialog.label_key': "\u5BC6\u94A5\uFF1A",
    'me.deploy_credential.add_dialog.default_title': (date)=>`\u{5BC6}\u{94A5} ${date}`,
    'me.deploy_credential.add_dialog.ok': "\u6DFB\u52A0\u90E8\u7F72\u51ED\u636E",
    'me.deploy_credential.add_dialog.hint.itch': [
        "\u8981\u751F\u6210 itch.io API \u5BC6\u94A5\uFF0C\u8BF7\u8F6C\u5230\u60A8\u5728 itch.io \u4E0A\u7684 ",
        $beff090cf88b012d$var$_tmpl$6(),
        "\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u6765\u6E90\u4E3A \"web\" \u6216 \"wharf\" \u7684\u73B0\u6709 API \u5BC6\u94A5\u3002\u6765\u6E90\u4E3A \"Kavykhi.Cloud\" \u7684 API \u5BC6\u94A5\u5C06\u65E0\u6CD5\u5DE5\u4F5C\u3002"
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "\u6211\u4EEC\u76EE\u524D\u4E0D\u652F\u6301\u6DFB\u52A0 ",
            credentialProvider,
            " \u51ED\u636E\u3002"
        ],
    'me.deploy_credential.delete': "\u5220\u9664",
    'me.deploy_credential.delete_dialog.header': "\u5220\u9664\u90E8\u7F72\u51ED\u636E",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "\u60A8\u786E\u5B9A\u8981\u5220\u9664 ",
            credentialProvider,
            " \u7684\u51ED\u636E ",
            credentialTitle,
            " \u5417\uFF1F\u4F7F\u7528\u6B64\u51ED\u636E\u914D\u7F6E\u7684\u4EFB\u4F55\u90E8\u7F72\u7AD9\u70B9\u4E5F\u5C06\u4ECE\u9879\u76EE\u4E2D\u79FB\u9664\u3002"
        ],
    'me.deploy_credential.delete_dialog.ok': "\u5220\u9664\u51ED\u636E",
    'me.public_profile': "\u516C\u5F00\u4E2A\u4EBA\u8D44\u6599",
    'me.public_profile.public_credentials': "\u516C\u5F00\u51ED\u636E",
    'me.public_profile.public_credentials.hint': "\u9009\u62E9\u8981\u516C\u5F00\u663E\u793A\u7684\u51ED\u636E\u3002",
    'me.manage': "\u7BA1\u7406\u8D26\u53F7",
    'me.delete': "\u5220\u9664\u8D26\u53F7",
    'me.delete.dialog.header': "\u5220\u9664\u8D26\u53F7",
    'me.delete.dialog.message': (userTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u6C38\u4E45\u5220\u9664\u60A8\u7684 Kavykhi.Cloud \u8D26\u53F7 ",
            userTitle,
            " \u5417\uFF1F"
        ],
    'me.delete.dialog.ok': "\u5220\u9664\u8D26\u53F7",
    'invite': "\u9080\u8BF7",
    'invite.hint': "\u9879\u76EE\u9080\u8BF7",
    'invite.message.already_member': (projectTitle)=>[
            "\u60A8\u5DF2\u7ECF\u662F\u9879\u76EE ",
            projectTitle,
            " \u7684\u6210\u5458\u3002"
        ],
    'invite.message.join': (projectTitle)=>[
            "\u60A8\u5DF2\u88AB\u9080\u8BF7\u52A0\u5165\u9879\u76EE ",
            projectTitle,
            "\u3002"
        ],
    'invite.join': "\u52A0\u5165\u9879\u76EE",
    'local': "\u672C\u5730\u5185\u5BB9",
    'local.hint': "\u672C\u5730\u5B89\u88C5\u7684\u5185\u5BB9",
    'local.workdirs': "\u5DF2\u5B89\u88C5\u7684\u5305",
    'local.workdirs.empty': "\u65E0\u5DF2\u5B89\u88C5\u7684\u5305\u3002",
    'local.workdir.action.launch': "\u542F\u52A8",
    'local.workdir.action.repair': "\u4FEE\u590D",
    'local.workdir.action.delete': "\u5378\u8F7D",
    'local.workdir.delete_dialog.header': "\u5378\u8F7D\u5305",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\u60A8\u786E\u5B9A\u8981\u4ECE\u60A8\u7684\u8BBE\u5907\u4E0A\u5378\u8F7D\u5305 ",
            packageTitle,
            " \u5417\uFF1F"
        ],
    'local.workdir.delete_dialog.ok': "\u5378\u8F7D",
    'local.workspaces': "\u6839\u6587\u4EF6\u5939",
    'local.app_not_detected.message': "\u672A\u68C0\u6D4B\u5230 Kavykhi.Cloud \u672C\u5730\u5E94\u7528\u3002\u8BF7\u4F7F\u7528\u4E0B\u65B9\u94FE\u63A5\u4E0B\u8F7D\u5E76\u5B89\u88C5\u3002\u5982\u679C\u60A8\u5DF2\u7ECF\u5B89\u88C5\uFF0C\u8BF7\u786E\u4FDD\u5B83\u6B63\u5728\u8FD0\u884C\u3002",
    'local_app.detected': "\u672C\u5730\u5185\u5BB9",
    'error_dialog.header': "\u9519\u8BEF",
    'error_dialog.messageFunc': (e)=>`\u{9519}\u{8BEF}\u{FF1A}${$beff090cf88b012d$var$dict[`error.${e}`] ?? e}\u{3002}`,
    'upload_box.choose_files': "\u9009\u62E9\u6587\u4EF6",
    'upload_box.choose_directories': "\u9009\u62E9\u6587\u4EF6\u5939",
    'upload_box.add.progress_dialog.header': "\u6B63\u5728\u6DFB\u52A0\u6587\u4EF6",
    'upload_box.add.progress_dialog.message': "\u6B63\u5728\u5904\u7406\u6587\u4EF6...",
    'upload_box.delete': (itemsCount)=>`\u{5220}\u{9664} ${$beff090cf88b012d$var$plural(itemsCount, `${itemsCount} \u{4E2A}\u{9879}\u{76EE}`, `${itemsCount} \u{4E2A}\u{9879}\u{76EE}`)}`,
    'upload_box.start_upload': "\u5F00\u59CB\u4E0A\u4F20",
    'upload_box.drop_area.message': "\u5C06\u6587\u4EF6\u548C\u6587\u4EF6\u5939\u62D6\u653E\u5230\u6B64\u5904",
    'upload_box.drop_area.box_dropping_message': "\u62D6\u653E\u5230\u6B64\u5904\u4EE5\u653E\u5165\u6839\u76EE\u5F55",
    'upload_box.entry.explode_folder': "\u7528\u6587\u4EF6\u5939\u5185\u5BB9\u66FF\u6362\u6587\u4EF6\u5939",
    'upload_box.entry.set_entrypoint': "\u8BBE\u7F6E\u542F\u52A8\u6587\u4EF6",
    'upload_box.entry.mark_executable': "\u6807\u8BB0\u4E3A\u53EF\u6267\u884C\u6587\u4EF6",
    'upload_box.entry.unmark_executable': "\u53D6\u6D88\u53EF\u6267\u884C\u6807\u8BB0",
    'upload_box.entry.remove': "\u79FB\u9664",
    'package.tags.empty': "(\u65E0\u6807\u7B7E)",
    'package.tag.os': "\u64CD\u4F5C\u7CFB\u7EDF",
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': "\u67B6\u6784",
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': "\u4F4D\u6570",
    'package.tag.bits:64': "64 \u4F4D",
    'package.tag.bits:32': "32 \u4F4D",
    'package.tag.packaging': "\u6253\u5305\u683C\u5F0F",
    'package.tag.packaging:installer': "\u5B89\u88C5\u7A0B\u5E8F",
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': "\u7EC4\u4EF6",
    'package.tag.component:client': "\u5BA2\u6237\u7AEF",
    'package.tag.component:server': "\u670D\u52A1\u7AEF",
    'package.tag.runtime': "\u8FD0\u884C\u73AF\u5883",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Linux \u53D1\u884C\u7248",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': "\u6587\u6863",
    'docs.page_no_language': "\u6B64\u8BED\u8A00\u7248\u672C\u4E0D\u53EF\u7528",
    'docs.page_no_language.message': "\u6B64\u6587\u6863\u7684\u5176\u4ED6\u53EF\u7528\u7248\u672C\uFF1A",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "\u4E3E\u62A5\u5185\u5BB9",
    'report_content.dialog.header': "\u4E3E\u62A5\u5185\u5BB9",
    'report_content.dialog.link': "\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u4E3E\u62A5",
    'report_content.dialog.message': (email, link)=>[
            "\u8BF7\u70B9\u51FB\u94FE\u63A5\u53D1\u9001\u60A8\u7684\u4E3E\u62A5\uFF1A",
            $beff090cf88b012d$var$_tmpl$2(),
            $beff090cf88b012d$var$_tmpl$2(),
            link,
            $beff090cf88b012d$var$_tmpl$2(),
            $beff090cf88b012d$var$_tmpl$2(),
            "\u6216\u8005\u624B\u52A8\u53D1\u9001\u7535\u5B50\u90AE\u4EF6\u81F3 ",
            email
        ]
};
var $beff090cf88b012d$export$2e2bcd8739ae039 = $beff090cf88b012d$var$dict;
const $beff090cf88b012d$var$plural = (n, one, many)=>n == 1 ? one : many;



var $82e95096b9bfd413$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{5DF2}\u{5141}\u{8A31}`), $82e95096b9bfd413$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $82e95096b9bfd413$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{4E0D}\u{5141}\u{8A31}`), $82e95096b9bfd413$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $82e95096b9bfd413$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $82e95096b9bfd413$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>\u{500B}\u{4EBA}\u{6A94}\u{6848}\u{8A2D}\u{5B9A}`);
const $82e95096b9bfd413$var$dict = {
    languageName: "\u7E41\u9AD4\u4E2D\u6587 (\u53F0\u7063)",
    locale: 'zh-TW',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: "\u4F48\u666F\u4E3B\u984C",
    'theme.light': "\u6DFA\u8272",
    'theme.dark': "\u6DF1\u8272",
    'theme.system': "\u7CFB\u7D71\u9810\u8A2D",
    'theme.sakura': "\u6AFB\u82B1",
    // generic
    email: "\u96FB\u5B50\u90F5\u4EF6",
    password: "\u5BC6\u78BC",
    ok: "\u78BA\u5B9A",
    cancel: "\u53D6\u6D88",
    retry: "\u91CD\u8A66",
    copy: "\u8907\u88FD",
    empty: "(\u7121\u9805\u76EE)",
    loading: "\u8F09\u5165\u4E2D...",
    calculating: "\u8A08\u7B97\u4E2D...",
    error: "\u932F\u8AA4",
    'in_development': "\u6B64\u9801\u9762\u6B63\u5728\u958B\u767C\u4E2D\u3002",
    // errors
    'error.not_found': "\u627E\u4E0D\u5230",
    'error.name_conflict': "\u540D\u7A31\u885D\u7A81",
    'error.bad_param': "\u53C3\u6578\u932F\u8AA4",
    'error.wrong_auth': "\u9A57\u8B49\u932F\u8AA4",
    'error.unauthorized': "\u672A\u6388\u6B0A",
    'error.wrong_credentials': "\u6191\u8B49\u932F\u8AA4",
    'error.wrong_provider': "\u63D0\u4F9B\u5546\u932F\u8AA4",
    'error.insufficient_privileges': "\u6B0A\u9650\u4E0D\u8DB3",
    'error.not_empty': "\u975E\u7A7A",
    'error.limit_exceeded': "\u8D85\u51FA\u9650\u5236",
    'error.already_member': "\u5DF2\u662F\u6210\u54E1",
    'error.not_finalized': "\u672A\u5B8C\u6210",
    'error.already_finalized': "\u5DF2\u5B8C\u6210",
    'error.unexpected_patch': "\u975E\u9810\u671F\u7684\u4FEE\u88DC\u6A94",
    'error.timeout': "\u903E\u6642",
    'error.not_patch': "\u975E\u4FEE\u88DC\u6A94",
    'error.not_supported': "\u4E0D\u652F\u63F4",
    'error.unexpected_error': "\u672A\u9810\u671F\u7684\u932F\u8AA4",
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "\u8EAB\u5206\u9A57\u8B49",
    'auth.dialog.please_select': "\u8ACB\u9078\u64C7\u60A8\u7684\u5E33\u865F\u63D0\u4F9B\u5546\u4EE5\u767B\u5165\u3002",
    'auth.dialog.redirecting_to': (provider)=>`\u{6B63}\u{5728}\u{91CD}\u{65B0}\u{5C0E}\u{5411}\u{81F3} ${provider}...`,
    'auth.dialog.remember_me': "\u8A18\u4F4F\u6211",
    'auth.dialog.log_in': "\u767B\u5165",
    'auth.dialog.back': "\u8FD4\u56DE",
    'auth.dialog.progress_header': "\u9A57\u8B49\u4E2D...",
    'auth.dialog.error.header': "\u9A57\u8B49\u932F\u8AA4",
    'auth.dialog.error.auth_not_allowed': "\u4F7F\u7528\u8005\u5DF2\u7981\u6B62\u4F7F\u7528\u6B64\u6191\u8B49\u9032\u884C\u9A57\u8B49\u3002\u8ACB\u4F7F\u7528\u5176\u4ED6\u6191\u8B49\u3002",
    'auth.dialog.error.unknown': "\u7121\u6548\u7684\u9A57\u8B49\u53C3\u6578\u3002\u8ACB\u91CD\u8A66\u3002",
    'auth.dialog.error.back': "\u8FD4\u56DE",
    'user.profile': "\u500B\u4EBA\u6A94\u6848",
    'user.logout': "\u767B\u51FA",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "\u627E\u4E0D\u5230\u9801\u9762",
    'page_not_found.message': "\u6B64\u9801\u9762\u4E0D\u5B58\u5728\u3002",
    'page_not_found.message2': "\u55EF\uFF0C\u5B83\u53EF\u80FD\u66FE\u7D93\u5B58\u5728\uFF0C\u4F46\u73FE\u5728\u9019\u88E1\u4EC0\u9EBC\u90FD\u6C92\u6709\u3002\u4EE5\u4E0B\u662F\u53EF\u80FD\u7684\u539F\u56E0\uFF1A",
    'page_not_found.items': [
        "\u9019\u88E1\u4EE5\u524D\u6709\u6771\u897F\uFF0C\u4F46\u73FE\u5728\u5DF2\u88AB\u522A\u9664\u3002",
        "\u9019\u88E1\u4ECD\u6709\u6771\u897F\uFF0C\u4F46\u60A8\u6C92\u6709\u5B58\u53D6\u6B0A\u9650\u3002",
        "\u6216\u8005\u53EA\u662F\u6709\u4EBA\u5728\u8907\u88FD\u8CBC\u4E0A\u9023\u7D50\u6642\u4E0D\u5920\u5C0F\u5FC3\u3002"
    ],
    'home': "\u9996\u9801",
    'home.header.hint': "\u7368\u7ACB\u958B\u767C\u8005\u7684\u96F2\u7AEF\u5DE5\u5177",
    'home.description': "Kavykhi.Cloud \u662F\u4E00\u500B\u5C08\u70BA\u7368\u7ACB\u904A\u6232\u6253\u9020\u7684\u958B\u767C\u5E73\u53F0\u3002\u6211\u5011\u652F\u63F4\u53EF\u4E0B\u8F09\u8207\u700F\u89BD\u5668\u904A\u6232\u3001\u79C1\u6709\u8207\u516C\u958B\u7248\u672C\u3001\u5206\u652F\u3001\u5718\u968A\u7B49\u773E\u591A\u529F\u80FD\u3002",
    'home.auth': "\u767B\u5165\u6216\u8A3B\u518A",
    'home.auth.hint': "\u5EFA\u7ACB\u65B0\u5E33\u865F\u6216\u767B\u5165\u73FE\u6709\u5E33\u865F",
    'projects': "\u5C08\u6848",
    'projects.hint': "\u60A8\u6B63\u5728\u53C3\u8207\u7684\u5C08\u6848",
    'projects.project': (project)=>`\u{5C08}\u{6848}\u{FF1A}${project}`,
    'projects.project.hint': "\u5C08\u6848",
    'projects.no_projects': "\u60A8\u76EE\u524D\u6C92\u6709\u4EFB\u4F55\u5C08\u6848\u3002",
    'projects.new': "\u5EFA\u7ACB\u5C08\u6848",
    'projects.new_dialog.header': "\u65B0\u5C08\u6848",
    'projects.new_dialog.label': "\u5C08\u6848\u540D\u7A31",
    'projects.new_dialog.ok': "\u5EFA\u7ACB\u5C08\u6848",
    'projects.store_page': "\u516C\u958B\u5546\u5E97\u9801\u9762",
    'projects.description': "\u63CF\u8FF0",
    'projects.branches': "\u5206\u652F",
    'projects.versions': "\u7248\u672C",
    'projects.packages': "\u5957\u4EF6",
    'projects.management': "\u5C08\u6848\u8A2D\u5B9A",
    'projects.management.breadcrumb': "\u8A2D\u5B9A",
    'projects.management.title': (projectTitle)=>`${projectTitle} - \u{8A2D}\u{5B9A}`,
    'projects.management.hint': "\u5C08\u6848\u8A2D\u5B9A",
    'projects.management.users': "\u5718\u968A\u6210\u54E1",
    'projects.management.users.empty': "\u7121\u5718\u968A\u6210\u54E1\u3002",
    'projects.management.users.role.tester': "\u6E2C\u8A66\u54E1",
    'projects.management.users.role.developer': "\u958B\u767C\u8005",
    'projects.management.users.role.admin': "\u7BA1\u7406\u54E1",
    'projects.management.users.role.owner': "\u64C1\u6709\u8005",
    'projects.management.users.role.starred': "\u5DF2\u661F\u6A19",
    'projects.management.users.exile': "\u79FB\u51FA\u5718\u968A",
    'projects.management.users.exile.dialog.header': "\u79FB\u51FA\u5718\u968A",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5C07 ",
            userTitle,
            " \u5F9E ",
            projectTitle,
            " \u5C08\u6848\u4E2D\u79FB\u9664\u55CE\uFF1F"
        ],
    'projects.management.users.exile.dialog.ok': "\u79FB\u51FA\u5718\u968A",
    'projects.management.invites.one_time_invite': "\u4E00\u6B21\u6027\u9080\u8ACB\u9023\u7D50",
    'projects.management.invites.one_time_invite.header': "\u4E00\u6B21\u6027\u9080\u8ACB\u9023\u7D50",
    'projects.management.invites.one_time_invite.message': "\u4E00\u6B21\u6027\u9080\u8ACB\u9023\u7D50\uFF1A",
    'projects.management.invites.one_time_invite.note': "24 \u5C0F\u6642\u5167\u6709\u6548\uFF0C\u50C5\u53EF\u4F7F\u7528\u4E00\u6B21\u3002",
    'projects.management.invites.new_dialog.header': "\u9080\u8ACB\u9023\u7D50",
    'projects.management.invites.new_dialog.expires': "\u904E\u671F\u6642\u9593\uFF1A",
    'projects.management.invites.new_dialog.expires.indefinite': "(\u6C38\u4E45\u6709\u6548)",
    'projects.management.invites.new_dialog.approval.label': "\u4F7F\u7528\u8005\u52A0\u5165\u5C08\u6848\uFF1A",
    'projects.management.invites.new_dialog.approval.not_approved': "\u9700\u7D93\u7BA1\u7406\u54E1\u6279\u51C6",
    'projects.management.invites.new_dialog.approval.approved': "\u7ACB\u5373\u52A0\u5165",
    'projects.management.invites.new_dialog.seats': "\u9650\u5236\u52A0\u5165\u4EBA\u6578\uFF1A",
    'projects.management.invites.new_dialog.seats.no_limit': "(\u7121\u9650\u5236)",
    'projects.management.invites.new_dialog.ok': "\u5EFA\u7ACB\u9080\u8ACB\u9023\u7D50",
    'projects.management.deploy_sites': "\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.deploy_sites.empty': "\u672A\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9\u3002",
    'projects.management.deploy_sites.add': "\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.deploy_sites.delete': "\u522A\u9664",
    'projects.management.deploy_sites.delete_dialog.header': "\u522A\u9664\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664 ",
            provider,
            " \u7684\u90E8\u7F72\u7DB2\u7AD9 ",
            site,
            " \u55CE\uFF1F"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "\u522A\u9664\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.public_access': "\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.enable': "\u555F\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.enabled': [
        "\u516C\u958B\u5B58\u53D6\uFF1A",
        $82e95096b9bfd413$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "\u5C08\u6848\u7684\u540D\u7A31\u3001\u63CF\u8FF0\u4EE5\u53CA\u4EFB\u4F55\u6A19\u8A18\u70BA\u516C\u958B\u7684\u5206\u652F\u90FD\u5C07\u516C\u958B\u3002",
    'projects.management.public_access.enable_dialog.header': "\u555F\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5141\u8A31\u516C\u958B\u5B58\u53D6\u5C08\u6848 ",
            projectTitle,
            " \u55CE\uFF1F",
            $82e95096b9bfd413$var$_tmpl$2(),
            $82e95096b9bfd413$var$_tmpl$2(),
            "\u9019\u5C07\u4F7F\u5C08\u6848\u7684\u57FA\u672C\u8CC7\u8A0A\u5728\u672A\u9A57\u8B49\u7684\u60C5\u6CC1\u4E0B\u4E5F\u53EF\u898B\u3002\u60A8\u9700\u8981\u55AE\u7368\u70BA\u5E0C\u671B\u516C\u958B\u7684\u6BCF\u500B\u5206\u652F\u555F\u7528\u516C\u958B\u5B58\u53D6\u3002"
        ],
    'projects.management.public_access.enable_dialog.ok': "\u555F\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.disable': "\u505C\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.disabled': [
        "\u516C\u958B\u5B58\u53D6\uFF1A",
        $82e95096b9bfd413$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "\u6B64\u5C08\u6848\u70BA\u79C1\u6709\u3002\u53EA\u6709\u5C08\u6848\u5718\u968A\u7684\u6210\u54E1\u53EF\u4EE5\u5B58\u53D6\u3002",
    'projects.management.public_access.disable_dialog.header': "\u505C\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u505C\u7528\u5C08\u6848 ",
            projectTitle,
            " \u7684\u6240\u6709\u516C\u958B\u5B58\u53D6\u55CE\uFF1F"
        ],
    'projects.management.public_access.disable_dialog.ok': "\u505C\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.branches': "\u516C\u958B\u5206\u652F",
    'projects.management.manage': "\u7BA1\u7406\u5C08\u6848",
    'projects.rename': "\u91CD\u65B0\u547D\u540D\u5C08\u6848",
    'projects.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u5C08\u6848",
    'projects.rename_dialog.label': "\u5C08\u6848\u540D\u7A31\uFF1A",
    'projects.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u5C08\u6848",
    'projects.edit_description': "\u7DE8\u8F2F\u5C08\u6848\u63CF\u8FF0",
    'projects.edit_description_dialog.header': "\u7DE8\u8F2F\u5C08\u6848\u63CF\u8FF0",
    'projects.edit_description_dialog.label': "\u5C08\u6848\u63CF\u8FF0\uFF1A",
    'projects.edit_description_dialog.ok': "\u7DE8\u8F2F\u63CF\u8FF0",
    'projects.leave': "\u96E2\u958B\u5C08\u6848",
    'projects.leave_dialog.header': "\u96E2\u958B\u5C08\u6848",
    'projects.leave_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u96E2\u958B ",
            projectTitle,
            " \u5C08\u6848\u55CE\uFF1F"
        ],
    'projects.leave_dialog.ok': "\u96E2\u958B\u5C08\u6848",
    'projects.delete': "\u522A\u9664\u5C08\u6848",
    'projects.delete_dialog.header': "\u522A\u9664\u5C08\u6848",
    'projects.delete_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664 ",
            projectTitle,
            " \u5C08\u6848\u55CE\uFF1F"
        ],
    'projects.delete_dialog.ok': "\u522A\u9664\u5C08\u6848",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "\u5206\u652F",
    'branches.no_branches': "\u6B64\u5C08\u6848\u5C1A\u7121\u5206\u652F",
    'branches.new': "\u5EFA\u7ACB\u5206\u652F",
    'branches.new_dialog.header': "\u65B0\u5206\u652F",
    'branches.new_dialog.label': "\u5206\u652F\u540D\u7A31",
    'branches.new_dialog.ok': "\u5EFA\u7ACB\u5206\u652F",
    'branches.current_version': (version)=>[
            "\u76EE\u524D\u7248\u672C\uFF1A",
            version
        ],
    'branches.current_version.packages': "\u76EE\u524D\u7248\u672C\u7684\u5957\u4EF6",
    'branches.no_current_version': "\u7121\u76EE\u524D\u7248\u672C",
    'branches.publish_version.new': "\u767C\u5E03\u65B0\u7248\u672C",
    'branches.publish_version.existing': "\u91CD\u65B0\u767C\u5E03\u73FE\u6709\u7248\u672C",
    'branches.version_history': "\u7248\u672C\u6B77\u53F2\u7D00\u9304",
    'branches.version_history.empty': "\u6B64\u5206\u652F\u7684\u7248\u672C\u6B77\u53F2\u7D00\u9304\u70BA\u7A7A\u3002",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "\u76EE\u524D\u7684\u5206\u652F\u7248\u672C\u5C07\u4FDD\u7559 ",
            quotaTime != null ? [
                " ",
                quotaTime
            ] : "\u6C38\u4E45",
            "\u3002\u5148\u524D\u7684\u7248\u672C\u6700\u591A\u4FDD\u7559 ",
            quotaNonCurrentTime,
            "\u3002\u6BCF\u500B\u5206\u652F\u6700\u591A\u4FDD\u7559 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$82e95096b9bfd413$var$plural(quotaCount, [
                    quotaCountText,
                    " \u500B\u7248\u672C"
                ], [
                    quotaCountText,
                    " \u500B\u7248\u672C"
                ])),
            "\u3002"
        ],
    'branches.manage': "\u7BA1\u7406\u5206\u652F",
    'branches.rename': "\u91CD\u65B0\u547D\u540D\u5206\u652F",
    'branches.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u5206\u652F",
    'branches.rename_dialog.label': "\u5206\u652F\u540D\u7A31\uFF1A",
    'branches.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u5206\u652F",
    'branches.delete': "\u522A\u9664\u5206\u652F",
    'branches.delete_dialog.header': "\u522A\u9664\u5206\u652F",
    'branches.delete_dialog.message': (branchTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664 ",
            branchTitle,
            " \u5206\u652F\u55CE\uFF1F"
        ],
    'branches.delete_dialog.ok': "\u522A\u9664\u5206\u652F",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "\u7248\u672C",
    'versions.current': "\u76EE\u524D",
    'versions.previous': "\u4E0A\u4E00\u500B",
    'versions.description': "\u63CF\u8FF0",
    'versions.deploy_to_site.header': "\u767C\u5E03\u81F3\u7DB2\u7AD9",
    'versions.deploy_to_site': "\u767C\u5E03\u81F3\u7DB2\u7AD9",
    'versions.packages': "\u5957\u4EF6",
    'versions.branches': "\u6240\u5728\u5206\u652F",
    'versions.branches.publish': "\u767C\u5E03\u81F3\u5206\u652F",
    'versions.branches.empty': "\u6B64\u7248\u672C\u5C1A\u672A\u767C\u5E03\u81F3\u4EFB\u4F55\u5206\u652F\u3002",
    'versions.new_dialog.header': "\u65B0\u7248\u672C",
    'versions.new_dialog.label_title': "\u7248\u672C\uFF1A",
    'versions.new_dialog.label_branch': "\u5206\u652F\uFF1A",
    'versions.new_dialog.packages.header': "\u5957\u4EF6",
    'versions.new_dialog.packages.empty': "\u672A\u65B0\u589E\u5957\u4EF6\u3002",
    'versions.new_dialog.packages.add': "\u65B0\u589E\u5957\u4EF6",
    'versions.new_dialog.packages.add_existing': "\u65B0\u589E\u5148\u524D\u4E0A\u50B3\u7684\u5957\u4EF6",
    'versions.new_dialog.packages.replace': "\u66FF\u63DB\u5957\u4EF6",
    'versions.new_dialog.packages.edit': "\u7DE8\u8F2F\u5957\u4EF6",
    'versions.new_dialog.ok': "\u5EFA\u7ACB\u7248\u672C",
    'versions.manage': "\u7BA1\u7406\u7248\u672C",
    'versions.rename': "\u91CD\u65B0\u547D\u540D\u7248\u672C",
    'versions.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u7248\u672C",
    'versions.rename_dialog.label': "\u7248\u672C\u540D\u7A31\uFF1A",
    'versions.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u7248\u672C",
    'versions.edit_description': "\u7DE8\u8F2F\u7248\u672C\u63CF\u8FF0",
    'versions.edit_description_dialog.header': "\u7DE8\u8F2F\u7248\u672C\u63CF\u8FF0",
    'versions.edit_description_dialog.label': "\u7248\u672C\u63CF\u8FF0\uFF1A",
    'versions.edit_description_dialog.ok': "\u7DE8\u8F2F\u63CF\u8FF0",
    'versions.delete': "\u522A\u9664\u7248\u672C",
    'versions.delete_dialog.header': "\u522A\u9664\u7248\u672C",
    'versions.delete_dialog.message': (versionTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u7248\u672C ",
            versionTitle,
            " \u55CE\uFF1F"
        ],
    'versions.delete_dialog.ok': "\u522A\u9664\u7248\u672C",
    'versions.publish_dialog.header': "\u767C\u5E03\u7248\u672C\u81F3\u5206\u652F",
    'versions.publish_dialog.message': (versionTitle)=>[
            "\u9078\u64C7\u8981\u5C07\u7248\u672C ",
            versionTitle,
            " \u767C\u5E03\u81F3\u7684\u5206\u652F\u3002"
        ],
    'versions.publish_dialog.no_branches': "\u5C08\u6848\u4E2D\u7121\u5206\u652F\u3002",
    'versions.publish_dialog.ok': "\u767C\u5E03\u7248\u672C",
    'versions.publish_existing_dialog.header': "\u91CD\u65B0\u767C\u5E03\u7248\u672C",
    'versions.publish_existing_dialog.message': "\u6700\u65B0\u7248\u672C\uFF1A",
    'versions.publish_existing_dialog.no_versions': "\u5C08\u6848\u4E2D\u7121\u7248\u672C\u3002",
    'versions.publish_existing_dialog.ok': "\u767C\u5E03\u7248\u672C",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': "\u5957\u4EF6",
    'packages.download_zip': "\u4E0B\u8F09\u70BA ZIP",
    'packages.download_torrent': "\u4E0B\u8F09 Torrent",
    'packages.total_size': (size)=>[
            "\u7E3D\u5927\u5C0F\uFF1A",
            size
        ],
    'packages.manage': "\u7BA1\u7406\u5957\u4EF6",
    'packages.rename': "\u91CD\u65B0\u547D\u540D\u5957\u4EF6",
    'packages.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u5957\u4EF6",
    'packages.rename_dialog.label': "\u5957\u4EF6\u540D\u7A31\uFF1A",
    'packages.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u5957\u4EF6",
    'packages.edit_tags': "\u7DE8\u8F2F\u5957\u4EF6\u6A19\u7C64",
    'packages.edit_tags_dialog.header': "\u7DE8\u8F2F\u5957\u4EF6\u6A19\u7C64",
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "\u6307\u5B9A\u5957\u4EF6 ",
            packageTitle,
            " \u7684\u6A19\u7C64\uFF1A"
        ],
    'packages.edit_tags_dialog.ok': "\u8A2D\u5B9A\u5957\u4EF6\u6A19\u7C64",
    'packages.entrypoint': (entrypoint)=>[
            "\u555F\u52D5\u6A94\u6848\uFF1A",
            entrypoint
        ],
    'packages.entrypoint.empty': "\u672A\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848\u3002",
    'packages.delete': "\u522A\u9664\u5957\u4EF6",
    'packages.delete_dialog.header': "\u522A\u9664\u5957\u4EF6",
    'packages.delete_dialog.message': (packageTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u5957\u4EF6 ",
            packageTitle,
            " \u55CE\uFF1F\u8A72\u5957\u4EF6\u5C07\u5F9E\u6240\u6709\u5DF2\u52A0\u5165\u7684\u7248\u672C\u4E2D\u522A\u9664\u3002"
        ],
    'packages.delete_dialog.ok': "\u522A\u9664\u5957\u4EF6",
    'packages.new_dialog.header': "\u65B0\u5957\u4EF6",
    'packages.new_dialog.label_title': "\u6A19\u984C\uFF1A",
    'packages.new_dialog.title_placeholder': "(\u4F86\u81EA\u6A19\u7C64)",
    'packages.new_dialog.tags.header': "\u6A19\u7C64",
    'packages.new_dialog.files.header': "\u6A94\u6848",
    'packages.new_dialog.total_size': (size, maximum)=>[
            "\u7E3D\u5927\u5C0F\uFF1A",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(\u6700\u5927 ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "\u65B0\u8CC7\u6599\u5927\u5C0F\uFF1A",
            size
        ],
    'packages.new_dialog.checks.empty': "\u672A\u65B0\u589E\u6A94\u6848\u3002",
    'packages.new_dialog.checks.entrypoint.empty': "\u672A\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848\u3002",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "\u555F\u52D5\u6A94\u6848 ",
            entrypoint,
            " \u4E0D\u5B58\u5728\uFF1B\u4E5F\u8A31\u60A8\u5FD8\u8A18\u65B0\u589E\u5B83\uFF1F\u8ACB\u6307\u5B9A\u73FE\u6709\u7684\u555F\u52D5\u6A94\u6848\uFF0C\u6216\u8005\u60A8\u4E5F\u53EF\u4EE5\u4E0D\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "\u53D6\u6D88\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "\u555F\u52D5\u6A94\u6848\u7684\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u5EFA\u8B70\u4F7F\u7528 ",
            tag,
            " \u6A19\u7C64\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "\u65B0\u589E ",
            tag,
            " \u6A19\u7C64"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "\u555F\u52D5\u6A94\u6848\u7684\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u65B0\u589E ",
            tag,
            " \u6A19\u7C64\u4EE5\u4F7F\u5957\u4EF6\u53EF\u5728\u700F\u89BD\u5668\u4E2D\u904A\u73A9\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "\u555F\u52D5\u6A94\u6848\u7684\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u9019\u662F\u5426\u70BA\u932F\u8AA4\uFF1F\u901A\u5E38\u9019\u4E0D\u662F\u53EF\u4EE5\u555F\u52D5\u7684\u6A94\u6848\u985E\u578B\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "\u555F\u52D5\u6A94\u6848\u7684\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u5EFA\u8B70\u5305\u542B\u5BE6\u969B\u7684\u5167\u5BB9\u6A94\u6848\uFF0C\u800C\u4E0D\u662F\u5C07\u5B83\u5011\u6253\u5305\u6210\u58D3\u7E2E\u6A94\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.executable': "\u555F\u52D5\u6A94\u6848\u672A\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'packages.new_dialog.checks.entrypoint.executable.action': "\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'packages.new_dialog.checks.single_root_dir': "\u5EFA\u8B70\u5C07\u6A94\u6848\u76F4\u63A5\u653E\u5728\u6839\u76EE\u9304\u4E2D\uFF0C\u800C\u4E0D\u662F\u5728\u6839\u76EE\u9304\u4E0B\u53EA\u6709\u55AE\u500B\u8CC7\u6599\u593E\u3002",
    'packages.new_dialog.checks.single_root_dir.action': "\u5C07\u8CC7\u6599\u593E\u66FF\u63DB\u70BA\u5176\u5167\u5BB9",
    'packages.add_existing_dialog.header': "\u65B0\u589E\u5957\u4EF6",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `\u{65B0}\u{589E} ${$82e95096b9bfd413$var$plural(packagesCount, `${packagesCount} \u{500B}\u{5957}\u{4EF6}`, `${packagesCount} \u{500B}\u{5957}\u{4EF6}`)}` : "\u672A\u9078\u64C7\u5957\u4EF6",
    'packages.add_existing_dialog.message': "\u6700\u8FD1\u4E0A\u50B3\u7684\u5957\u4EF6\uFF1A",
    'packages.add_existing_dialog.no_packages': "\u6C92\u6709\u6700\u8FD1\u4E0A\u50B3\u7684\u5957\u4EF6\u3002",
    'packages.launch': "\u555F\u52D5",
    'packages.install': "\u5B89\u88DD",
    'packages.install_dialog.header': "\u5B89\u88DD",
    'packages.install_dialog.workdir.label': "\u5DE5\u4F5C\u76EE\u9304\uFF1A",
    'packages.install_dialog.workdir.value.new': "(\u5EFA\u7ACB\u65B0\u76EE\u9304)",
    'packages.install_dialog.workspace.label': "\u5728\u6B64\u8CC7\u6599\u593E\u4E0B\u5EFA\u7ACB\uFF1A",
    'packages.install_dialog.workspace.placeholder': "(\u9078\u64C7\u6839\u8CC7\u6599\u593E)",
    'packages.install_dialog.ok': "\u5B89\u88DD",
    'packages.update': "\u66F4\u65B0",
    'packages.upload.status.existing': "\u4F86\u81EA\u4E0A\u4E00\u500B\u7248\u672C",
    'packages.upload.status.queued': "\u5DF2\u6392\u968A",
    'packages.upload.status.packing': "\u6253\u5305\u4E2D...",
    'packages.upload.status.creating': "\u5EFA\u7ACB\u4E2D...",
    'packages.upload.status.create_retrying': "\u5EFA\u7ACB\u5931\u6557\uFF0C\u6B63\u5728\u7B49\u5F85\u4E26\u91CD\u8A66",
    'packages.upload.status.splitting': "\u5206\u5272\u4E2D...",
    'packages.upload.status.uploading': "\u4E0A\u50B3\u4E2D...",
    'packages.upload.status.finalizing': "\u5B8C\u6210\u4E2D...",
    'packages.upload.status.finalize_retrying': "\u5B8C\u6210\u5931\u6557\uFF0C\u6B63\u5728\u7B49\u5F85\u4E26\u91CD\u8A66",
    'packages.upload.status.resolving': "\u6B63\u5728\u89E3\u6790\u4FEE\u88DC\u6A94...",
    'packages.upload.status.resolve_retrying': "\u89E3\u6790\u4FEE\u88DC\u6A94\u5931\u6557\uFF0C\u6B63\u5728\u7B49\u5F85\u4E26\u91CD\u8A66...",
    'packages.upload.status.done': "\u4E0A\u50B3\u6210\u529F",
    'packages.upload.status.errored': "\u932F\u8AA4",
    'packages.upload.part.status.queued': "\u5DF2\u6392\u968A",
    'packages.upload.part.status.hashing': "\u96DC\u6E4A\u4E2D",
    'packages.upload.part.status.upload_queued': "\u4E0A\u50B3\u5DF2\u6392\u968A",
    'packages.upload.part.status.uploading': "\u4E0A\u50B3\u4E2D",
    'packages.upload.part.status.upload_retrying': "\u932F\u8AA4\uFF0C\u6B63\u5728\u91CD\u8A66\u4E0A\u50B3",
    'packages.upload.part.status.upload_finalizing': "\u6B63\u5728\u5B8C\u6210\u4E0A\u50B3",
    'packages.upload.part.status.upload_errored': "\u932F\u8AA4",
    'packages.upload.part.status.done': "\u5DF2\u4E0A\u50B3",
    'packages.play': "\u5728\u700F\u89BD\u5668\u4E2D\u904A\u73A9",
    'packages.play.reset': "\u91CD\u8A2D",
    'packages.play.fullscreen': "\u5168\u87A2\u5E55",
    'deploy_sites.add_dialog.header': "\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "\u9078\u64C7\u90E8\u7F72\u6191\u8B49\u4E26\u8F38\u5165\u7DB2\u7AD9 URL\uFF0C\u4EE5\u5C07\u5176\u5132\u5B58\u70BA\u5C08\u6848 ",
            projectTitle,
            " \u7684\u90E8\u7F72\u7DB2\u7AD9\u3002"
        ],
    'deploy_sites.add_dialog.label_credential': "\u90E8\u7F72\u6191\u8B49\uFF1A",
    'deploy_sites.add_dialog.select_credential': "\u9078\u64C7\u6191\u8B49",
    'deploy_sites.add_dialog.select_credential.new': "\u65B0\u589E\u6191\u8B49...",
    'deploy_sites.add_dialog.label_select_site': "\u9078\u64C7\u7DB2\u7AD9\uFF1A",
    'deploy_sites.add_dialog.select_credential_first': "(\u8ACB\u5148\u9078\u64C7\u6191\u8B49)",
    'deploy_sites.add_dialog.select_site': "(\u9078\u64C7\u7DB2\u7AD9)",
    'deploy_sites.add_dialog.label_enter_site': "\u6216\u8F38\u5165\u7DB2\u7AD9 URL\uFF1A",
    'deploy_sites.add_dialog.ok': "\u65B0\u589E\u7DB2\u7AD9",
    'deploy_to_site_dialog.header': "\u767C\u5E03\u81F3\u7DB2\u7AD9",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "\u9078\u64C7\u8981\u767C\u5E03 ",
            projectTitle,
            " \u7684\u7248\u672C ",
            versionTitle,
            " \u7684\u7DB2\u7AD9\u3002"
        ],
    'deploy_to_site_dialog.label_site': "\u767C\u5E03\u81F3\u7DB2\u7AD9\uFF1A",
    'deploy_to_site_dialog.select_site': "\u9078\u64C7\u7DB2\u7AD9",
    'deploy_to_site_dialog.select_site.new': "\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9...",
    'deploy_to_site_dialog.packages.message.itch': [
        "\u5957\u4EF6\u5C07\u4F7F\u7528 ",
        $82e95096b9bfd413$var$_tmpl$4(),
        " \u767C\u5E03\u81F3 itch.io\u3002\u983B\u9053\u540D\u7A31\u884D\u751F\u81EA\u5957\u4EF6\u6A19\u7C64\u3002"
    ],
    'deploy_to_site_dialog.deploy': "\u767C\u5E03",
    'deploy_to_site_dialog.close': "\u95DC\u9589",
    'deploy_to_site_dialog.error.no_packages': "\u6C92\u6709\u53EF\u767C\u5E03\u7684\u5957\u4EF6\u3002",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "\u591A\u500B\u5957\u4EF6\u7121\u6CD5\u767C\u5E03\u5230\u55AE\u500B\u983B\u9053\u3002\u76EE\u524D\u5DF2\u8A2D\u5B9A\u5C07 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$82e95096b9bfd413$var$plural(packagesCount, [
                    packagesCountText,
                    " \u500B\u5957\u4EF6"
                ], [
                    packagesCountText,
                    " \u500B\u5957\u4EF6"
                ])),
            " \u767C\u5E03\u5230\u983B\u9053 ",
            channel,
            "\u3002"
        ],
    'deploy_to_site_dialog.job.queued': "\u5DF2\u6392\u968A",
    'deploy_to_site_dialog.job.downloading': "\u4E0B\u8F09\u4E2D...",
    'deploy_to_site_dialog.job.unpacking': "\u89E3\u5305\u4E2D...",
    'deploy_to_site_dialog.job.uploading': "\u767C\u5E03\u4E2D...",
    'deploy_to_site_dialog.job.succeeded': "\u6210\u529F",
    'deploy_to_site_dialog.job.errored': "\u932F\u8AA4",
    'store': "\u5546\u5E97",
    'store.hint': "\u516C\u958B\u5C08\u6848",
    'store.project.hint': "\u5546\u5E97\u5C08\u6848\u9801\u9762",
    'store.project.owner': "\u958B\u767C\u8005",
    'store.project.description': "\u63CF\u8FF0",
    'store.project.star': "\u661F\u6A19",
    'store.project.starred': "\u5DF2\u661F\u6A19",
    'store.project.content': "\u5167\u5BB9",
    'store.project.content.warning': "\u6B64\u5167\u5BB9\u7531\u7B2C\u4E09\u65B9\u958B\u767C\u8005\u63D0\u4F9B\u3002",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            branchTitle,
            " \u5206\u652F\uFF1A\u7248\u672C ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "\u767C\u5E03\u6642\u9593\uFF1A",
            branchVersionPublished
        ],
    'me': "\u500B\u4EBA\u6A94\u6848",
    'me.hint': "\u500B\u4EBA\u6A94\u6848\u8A2D\u5B9A\u8207\u9023\u7D50\u7684\u6191\u8B49",
    'me.rename': "\u91CD\u65B0\u547D\u540D\u500B\u4EBA\u6A94\u6848",
    'me.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u500B\u4EBA\u6A94\u6848",
    'me.rename_dialog.label_title': "\u540D\u7A31\uFF1A",
    'me.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u500B\u4EBA\u6A94\u6848",
    'me.credentials': "\u6191\u8B49",
    'me.credentials.hint.auth_allowed': "\u9019\u4E9B\u6191\u8B49\u4E2D\u7684\u4EFB\u4F55\u4E00\u500B\u90FD\u53EF\u4EE5\u7528\u4F86\u767B\u5165\u6B64\u5E33\u865F\u3002",
    'me.credentials.hint.auth_disallowed': "\u9019\u4E9B\u6191\u8B49\u5DF2\u9023\u7D50\u5230\u60A8\u7684\u5E33\u865F\uFF0C\u4F46\u7121\u6CD5\u7528\u65BC\u767B\u5165\u3002",
    'me.credentials.empty': "\u7121\u6191\u8B49\u3002",
    'me.credentials.empty.auth_allowed.warning': "\u60A8\u53EF\u80FD\u6703\u88AB\u9396\u5728\u5E33\u865F\u4E4B\u5916\uFF01\u60A8\u5C1A\u672A\u9023\u7D50\u4EFB\u4F55\u53EF\u7528\u65BC\u767B\u5165\u7684\u6191\u8B49\u3002\u8ACB\u5118\u5FEB\u9023\u7D50\u4E00\u500B\u60A8\u53EF\u4EE5\u767B\u5165\u7684\u6191\u8B49\u3002",
    'me.credentials.profile_picture.alt': (provider)=>`${$82e95096b9bfd413$var$dict[`auth.provider.${provider}`]} \u{500B}\u{4EBA}\u{6A94}\u{6848}\u{5716}\u{7247}`,
    'me.credentials.created': (created)=>[
            "\u5DF2\u65BC ",
            created,
            " \u65B0\u589E"
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\u4E0A\u6B21\u4F7F\u7528\u65BC ",
            lastUsed
        ],
    'me.credential.unlink': "\u53D6\u6D88\u9023\u7D50",
    'me.credential.allow_auth': "\u5141\u8A31\u767B\u5165",
    'me.credential.disallow_auth': "\u4E0D\u5141\u8A31\u767B\u5165",
    'me.credential.display_publicly': "\u516C\u958B\u986F\u793A",
    'me.credential.dont_display_publicly': "\u4E0D\u516C\u958B\u986F\u793A",
    'me.credential.link': "\u9023\u7D50\u6191\u8B49",
    'me.credential.link_dialog.header': "\u9023\u7D50\u6191\u8B49",
    'me.credential.link_dialog.message': "\u8ACB\u9078\u64C7\u8981\u9023\u7D50\u7684\u5E33\u865F\u63D0\u4F9B\u5546\u3002",
    'me.credential.unlink_dialog.header': "\u53D6\u6D88\u9023\u7D50\u6191\u8B49",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5F9E\u60A8\u7684 Kavykhi.Cloud \u5E33\u865F\u4E2D\u53D6\u6D88\u9023\u7D50 ",
            credentialProvider,
            " \u5E33\u865F ",
            credentialTitle,
            " \u55CE\uFF1F"
        ],
    'me.credential.unlink_dialog.ok': "\u53D6\u6D88\u9023\u7D50\u6191\u8B49",
    'me.sessions': "\u5DE5\u4F5C\u968E\u6BB5",
    'me.sessions.hint': "\u9019\u662F\u60A8\u6D3B\u52D5\u4E2D\u7684\u5DE5\u4F5C\u968E\u6BB5\u5217\u8868\uFF0C\u5305\u62EC\u60A8\u76EE\u524D\u7684\u700F\u89BD\u5668\u3002",
    'me.sessions.started': (started)=>[
            "\u958B\u59CB\u65BC ",
            (()=>{
                var _el$6 = $82e95096b9bfd413$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "\u6D3B\u52D5\u65BC ",
            (()=>{
                var _el$7 = $82e95096b9bfd413$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "\u76EE\u524D\u5DE5\u4F5C\u968E\u6BB5",
    'me.sessions.empty': "\u7121\u5DE5\u4F5C\u968E\u6BB5\u3002",
    'me.sessions.delete': "\u7D42\u6B62",
    'me.sessions.delete_dialog.header': "\u7D42\u6B62\u5DE5\u4F5C\u968E\u6BB5",
    'me.sessions.delete_dialog.message': "\u60A8\u78BA\u5B9A\u8981\u7D42\u6B62\u6B64\u5DE5\u4F5C\u968E\u6BB5\u55CE\uFF1F",
    'me.sessions.delete_dialog.ok': "\u7D42\u6B62\u5DE5\u4F5C\u968E\u6BB5",
    'me.api_tokens': "API \u6B0A\u6756",
    'me.api_tokens.hint': "\u60A8\u53EF\u4EE5\u5728\u6B64\u8655\u5EFA\u7ACB API \u6B0A\u6756\u4EE5\u7528\u65BC\u81EA\u52D5\u5316\u3002",
    'me.api_tokens.started': (started)=>[
            "\u5EFA\u7ACB\u65BC ",
            (()=>{
                var _el$8 = $82e95096b9bfd413$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "\u904E\u671F\u65BC ",
            (()=>{
                var _el$9 = $82e95096b9bfd413$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "\u6C38\u4E45\u6709\u6548",
    'me.api_tokens.empty': "\u7121 API \u6B0A\u6756\u3002",
    'me.api_tokens.create': "\u7522\u751F API \u6B0A\u6756",
    'me.api_tokens.create_dialog.header': "\u7522\u751F API \u6B0A\u6756",
    'me.api_tokens.create_dialog.message': "\u7522\u751F\u7684 API \u6B0A\u6756\uFF1A",
    'me.api_tokens.create_dialog.note': "\u6B64\u6B0A\u6756\u5C07\u4E0D\u6703\u518D\u6B21\u986F\u793A\uFF0C\u8ACB\u59A5\u5584\u5132\u5B58\u3002",
    'me.api_tokens.delete': "\u522A\u9664",
    'me.api_tokens.delete_dialog.header': "\u522A\u9664 API \u6B0A\u6756",
    'me.api_tokens.delete_dialog.message': "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u6B64\u6B0A\u6756\u55CE\uFF1F",
    'me.api_tokens.delete_dialog.ok': "\u522A\u9664 API \u6B0A\u6756",
    'me.deploy_credentials': "\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credentials.hint': "\u60A8\u53EF\u4EE5\u5728\u6B64\u8655\u65B0\u589E\u7528\u65BC\u90E8\u7F72\u5230\u767C\u5E03\u5E73\u53F0\u7684\u6191\u8B49\u3002",
    'me.deploy_credentials.empty': "\u672A\u65B0\u589E\u90E8\u7F72\u6191\u8B49\u3002",
    'me.deploy_credential.add': "\u65B0\u589E\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.add_dialog.header': "\u65B0\u589E\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.add_dialog.label_site': "\u7DB2\u7AD9\uFF1A",
    'me.deploy_credential.add_dialog.label_title': "\u5099\u8A3B\uFF1A",
    'me.deploy_credential.add_dialog.label_key': "\u91D1\u9470\uFF1A",
    'me.deploy_credential.add_dialog.default_title': (date)=>`\u{91D1}\u{9470} ${date}`,
    'me.deploy_credential.add_dialog.ok': "\u65B0\u589E\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.add_dialog.hint.itch': [
        "\u8981\u7522\u751F itch.io API \u91D1\u9470\uFF0C\u8ACB\u524D\u5F80\u60A8\u5728 itch.io \u4E0A\u7684 ",
        $82e95096b9bfd413$var$_tmpl$6(),
        "\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u4F86\u6E90\u70BA \"web\" \u6216 \"wharf\" \u7684\u73FE\u6709 API \u91D1\u9470\u3002\u4F86\u6E90\u70BA \"Kavykhi.Cloud\" \u7684 API \u91D1\u9470\u5C07\u7121\u6CD5\u904B\u4F5C\u3002"
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "\u6211\u5011\u76EE\u524D\u4E0D\u652F\u63F4\u65B0\u589E ",
            credentialProvider,
            " \u6191\u8B49\u3002"
        ],
    'me.deploy_credential.delete': "\u522A\u9664",
    'me.deploy_credential.delete_dialog.header': "\u522A\u9664\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664 ",
            credentialProvider,
            " \u7684\u6191\u8B49 ",
            credentialTitle,
            " \u55CE\uFF1F\u4F7F\u7528\u6B64\u6191\u8B49\u8A2D\u5B9A\u7684\u4EFB\u4F55\u90E8\u7F72\u7DB2\u7AD9\u4E5F\u5C07\u5F9E\u5C08\u6848\u4E2D\u79FB\u9664\u3002"
        ],
    'me.deploy_credential.delete_dialog.ok': "\u522A\u9664\u6191\u8B49",
    'me.public_profile': "\u516C\u958B\u500B\u4EBA\u6A94\u6848",
    'me.public_profile.public_credentials': "\u516C\u958B\u6191\u8B49",
    'me.public_profile.public_credentials.hint': "\u9078\u64C7\u8981\u516C\u958B\u986F\u793A\u7684\u6191\u8B49\u3002",
    'me.manage': "\u7BA1\u7406\u5E33\u865F",
    'me.delete': "\u522A\u9664\u5E33\u865F",
    'me.delete.dialog.header': "\u522A\u9664\u5E33\u865F",
    'me.delete.dialog.message': (userTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u6C38\u4E45\u522A\u9664\u60A8\u7684 Kavykhi.Cloud \u5E33\u865F ",
            userTitle,
            " \u55CE\uFF1F"
        ],
    'me.delete.dialog.ok': "\u522A\u9664\u5E33\u865F",
    'invite': "\u9080\u8ACB",
    'invite.hint': "\u5C08\u6848\u9080\u8ACB",
    'invite.message.already_member': (projectTitle)=>[
            "\u60A8\u5DF2\u7D93\u662F\u5C08\u6848 ",
            projectTitle,
            " \u7684\u6210\u54E1\u3002"
        ],
    'invite.message.join': (projectTitle)=>[
            "\u60A8\u5DF2\u88AB\u9080\u8ACB\u52A0\u5165\u5C08\u6848 ",
            projectTitle,
            "\u3002"
        ],
    'invite.join': "\u52A0\u5165\u5C08\u6848",
    'local': "\u672C\u6A5F\u5167\u5BB9",
    'local.hint': "\u672C\u6A5F\u5B89\u88DD\u7684\u5167\u5BB9",
    'local.workdirs': "\u5DF2\u5B89\u88DD\u7684\u5957\u4EF6",
    'local.workdirs.empty': "\u7121\u5DF2\u5B89\u88DD\u7684\u5957\u4EF6\u3002",
    'local.workdir.action.launch': "\u555F\u52D5",
    'local.workdir.action.repair': "\u4FEE\u5FA9",
    'local.workdir.action.delete': "\u89E3\u9664\u5B89\u88DD",
    'local.workdir.delete_dialog.header': "\u89E3\u9664\u5B89\u88DD\u5957\u4EF6",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5F9E\u60A8\u7684\u88DD\u7F6E\u4E0A\u89E3\u9664\u5B89\u88DD ",
            packageTitle,
            " \u5957\u4EF6\u55CE\uFF1F"
        ],
    'local.workdir.delete_dialog.ok': "\u89E3\u9664\u5B89\u88DD",
    'local.workspaces': "\u6839\u8CC7\u6599\u593E",
    'local.app_not_detected.message': "\u672A\u5075\u6E2C\u5230 Kavykhi.Cloud \u672C\u6A5F\u61C9\u7528\u7A0B\u5F0F\u3002\u8ACB\u4F7F\u7528\u4E0B\u65B9\u7684\u9023\u7D50\u4E0B\u8F09\u4E26\u5B89\u88DD\u3002\u5982\u679C\u60A8\u5DF2\u7D93\u5B89\u88DD\uFF0C\u8ACB\u78BA\u4FDD\u5B83\u6B63\u5728\u57F7\u884C\u3002",
    'local_app.detected': "\u672C\u6A5F\u5167\u5BB9",
    'error_dialog.header': "\u932F\u8AA4",
    'error_dialog.messageFunc': (e)=>`\u{932F}\u{8AA4}\u{FF1A}${$82e95096b9bfd413$var$dict[`error.${e}`] ?? e}\u{3002}`,
    'upload_box.choose_files': "\u9078\u64C7\u6A94\u6848",
    'upload_box.choose_directories': "\u9078\u64C7\u8CC7\u6599\u593E",
    'upload_box.add.progress_dialog.header': "\u6B63\u5728\u65B0\u589E\u6A94\u6848",
    'upload_box.add.progress_dialog.message': "\u6B63\u5728\u8655\u7406\u6A94\u6848...",
    'upload_box.delete': (itemsCount)=>`\u{522A}\u{9664} ${$82e95096b9bfd413$var$plural(itemsCount, `${itemsCount} \u{500B}\u{9805}\u{76EE}`, `${itemsCount} \u{500B}\u{9805}\u{76EE}`)}`,
    'upload_box.start_upload': "\u958B\u59CB\u4E0A\u50B3",
    'upload_box.drop_area.message': "\u5C07\u6A94\u6848\u548C\u8CC7\u6599\u593E\u62D6\u653E\u5230\u6B64\u8655",
    'upload_box.drop_area.box_dropping_message': "\u62D6\u653E\u5230\u6B64\u8655\u4EE5\u653E\u5165\u6839\u76EE\u9304",
    'upload_box.entry.explode_folder': "\u5C07\u8CC7\u6599\u593E\u66FF\u63DB\u70BA\u5176\u5167\u5BB9",
    'upload_box.entry.set_entrypoint': "\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848",
    'upload_box.entry.mark_executable': "\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'upload_box.entry.unmark_executable': "\u53D6\u6D88\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'upload_box.entry.remove': "\u79FB\u9664",
    'package.tags.empty': "(\u7121\u6A19\u7C64)",
    'package.tag.os': "\u4F5C\u696D\u7CFB\u7D71",
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': "\u67B6\u69CB",
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': "\u4F4D\u5143",
    'package.tag.bits:64': "64 \u4F4D\u5143",
    'package.tag.bits:32': "32 \u4F4D\u5143",
    'package.tag.packaging': "\u6253\u5305\u65B9\u5F0F",
    'package.tag.packaging:installer': "\u5B89\u88DD\u7A0B\u5F0F",
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': "\u7D44\u4EF6",
    'package.tag.component:client': "\u7528\u6236\u7AEF",
    'package.tag.component:server': "\u4F3A\u670D\u5668\u7AEF",
    'package.tag.runtime': "\u57F7\u884C\u74B0\u5883",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Linux \u767C\u884C\u7248",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': "\u6587\u4EF6",
    'docs.page_no_language': "\u6B64\u8A9E\u8A00\u7248\u672C\u4E0D\u53EF\u7528",
    'docs.page_no_language.message': "\u6B64\u6587\u4EF6\u7684\u5176\u4ED6\u8A9E\u8A00\u7248\u672C\uFF1A",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "\u6AA2\u8209\u5167\u5BB9",
    'report_content.dialog.header': "\u6AA2\u8209\u5167\u5BB9",
    'report_content.dialog.link': "\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u50B3\u9001\u6AA2\u8209",
    'report_content.dialog.message': (email, link)=>[
            "\u8ACB\u9EDE\u64CA\u9023\u7D50\u50B3\u9001\u60A8\u7684\u6AA2\u8209\uFF1A",
            $82e95096b9bfd413$var$_tmpl$2(),
            $82e95096b9bfd413$var$_tmpl$2(),
            link,
            $82e95096b9bfd413$var$_tmpl$2(),
            $82e95096b9bfd413$var$_tmpl$2(),
            "\u6216\u624B\u52D5\u50B3\u9001\u96FB\u5B50\u90F5\u4EF6\u81F3 ",
            email
        ]
};
var $82e95096b9bfd413$export$2e2bcd8739ae039 = $82e95096b9bfd413$var$dict;
const $82e95096b9bfd413$var$plural = (n, one, many)=>n == 1 ? one : many;



var $40145e94f5e9e4b3$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{5DF2}\u{5141}\u{8A31}`), $40145e94f5e9e4b3$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<br>`), $40145e94f5e9e4b3$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>\u{4E0D}\u{5141}\u{8A31}`), $40145e94f5e9e4b3$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/docs/butler/pushing.html target=_blank>butler`), $40145e94f5e9e4b3$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=value>`), $40145e94f5e9e4b3$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a href=https://itch.io/user/settings/api-keys target=_blank>\u{500B}\u{4EBA}\u{6A94}\u{6848}\u{8A2D}\u{5B9A}`);
const $40145e94f5e9e4b3$var$dict = {
    languageName: "\u7E41\u9AD4\u4E2D\u6587 (\u9999\u6E2F)",
    locale: 'zh-HK',
    fallback: 'en',
    dir: 'ltr',
    // app
    'app.name': 'Kavykhi.Cloud',
    'app.title': (sub)=>`${sub} - Kavykhi.Cloud`,
    // themes
    theme: "\u4E3B\u984C",
    'theme.light': "\u6DFA\u8272",
    'theme.dark': "\u6DF1\u8272",
    'theme.system': "\u7CFB\u7D71\u9810\u8A2D",
    'theme.sakura': "\u6AFB\u82B1",
    // generic
    email: "\u96FB\u90F5",
    password: "\u5BC6\u78BC",
    ok: "\u78BA\u5B9A",
    cancel: "\u53D6\u6D88",
    retry: "\u91CD\u8A66",
    copy: "\u8907\u88FD",
    empty: "(\u7121\u9805\u76EE)",
    loading: "\u8F09\u5165\u4E2D...",
    calculating: "\u8A08\u7B97\u4E2D...",
    error: "\u932F\u8AA4",
    'in_development': "\u6B64\u9801\u9762\u6B63\u5728\u958B\u767C\u4E2D\u3002",
    // errors
    'error.not_found': "\u672A\u627E\u5230",
    'error.name_conflict': "\u540D\u7A31\u885D\u7A81",
    'error.bad_param': "\u53C3\u6578\u932F\u8AA4",
    'error.wrong_auth': "\u8A8D\u8B49\u932F\u8AA4",
    'error.unauthorized': "\u672A\u6388\u6B0A",
    'error.wrong_credentials': "\u6191\u8B49\u932F\u8AA4",
    'error.wrong_provider': "\u670D\u52D9\u5546\u932F\u8AA4",
    'error.insufficient_privileges': "\u6B0A\u9650\u4E0D\u8DB3",
    'error.not_empty': "\u975E\u7A7A",
    'error.limit_exceeded': "\u8D85\u51FA\u9650\u5236",
    'error.already_member': "\u5DF2\u662F\u6210\u54E1",
    'error.not_finalized': "\u672A\u5B8C\u6210",
    'error.already_finalized': "\u5DF2\u5B8C\u6210",
    'error.unexpected_patch': "\u975E\u9810\u671F\u7684\u88DC\u4E01",
    'error.timeout': "\u903E\u6642",
    'error.not_patch': "\u975E\u88DC\u4E01",
    'error.not_supported': "\u4E0D\u652F\u63F4",
    'error.unexpected_error': "\u975E\u9810\u671F\u932F\u8AA4",
    // data sizes
    'datasize.B': 'B',
    'datasize.KiB': 'KiB',
    'datasize.MiB': 'MiB',
    'datasize.GiB': 'GiB',
    'datasize.TiB': 'TiB',
    // auth providers
    'auth.provider.steam': 'Steam',
    'auth.provider.github': 'GitHub',
    'auth.provider.gitlab': 'GitLab',
    'auth.provider.itch': 'itch.io',
    'auth.provider.twitch': 'Twitch',
    'auth.provider.discord': 'Discord',
    'auth.provider.google': 'Google',
    // auth dialog
    'auth.dialog.header': "\u8EAB\u4EFD\u8A8D\u8B49",
    'auth.dialog.please_select': "\u8ACB\u9078\u64C7\u60A8\u7684\u5E33\u6236\u670D\u52D9\u5546\u4EE5\u767B\u5165\u3002",
    'auth.dialog.redirecting_to': (provider)=>`\u{6B63}\u{5728}\u{91CD}\u{65B0}\u{5C0E}\u{5411}\u{81F3} ${provider}...`,
    'auth.dialog.remember_me': "\u8A18\u4F4F\u6211",
    'auth.dialog.log_in': "\u767B\u5165",
    'auth.dialog.back': "\u8FD4\u56DE",
    'auth.dialog.progress_header': "\u6B63\u5728\u8A8D\u8B49...",
    'auth.dialog.error.header': "\u8A8D\u8B49\u932F\u8AA4",
    'auth.dialog.error.auth_not_allowed': "\u7528\u6236\u5DF2\u7981\u6B62\u4F7F\u7528\u6B64\u6191\u8B49\u9032\u884C\u8A8D\u8B49\u3002\u8ACB\u4F7F\u7528\u5176\u4ED6\u6191\u8B49\u3002",
    'auth.dialog.error.unknown': "\u8A8D\u8B49\u53C3\u6578\u7121\u6548\u3002\u8ACB\u91CD\u8A66\u3002",
    'auth.dialog.error.back': "\u8FD4\u56DE",
    'user.profile': "\u500B\u4EBA\u6A94\u6848",
    'user.logout': "\u767B\u51FA",
    // deploy credential providers
    'deploy_credential_provider.steam': 'Steam',
    'deploy_credential_provider.itch': 'itch.io',
    'page_not_found.header': "\u627E\u4E0D\u5230\u9801\u9762",
    'page_not_found.message': "\u6B64\u9801\u9762\u4E0D\u5B58\u5728\u3002",
    'page_not_found.message2': "\u55EF\uFF0C\u5B83\u53EF\u80FD\u66FE\u7D93\u5B58\u5728\uFF0C\u4F46\u73FE\u5728\u9019\u88E1\u751A\u9EBC\u90FD\u6C92\u6709\u3002\u4EE5\u4E0B\u662F\u53EF\u80FD\u7684\u539F\u56E0\uFF1A",
    'page_not_found.items': [
        "\u9019\u88E1\u4EE5\u524D\u6709\u6771\u897F\uFF0C\u4F46\u73FE\u5728\u5DF2\u88AB\u522A\u9664\u3002",
        "\u9019\u88E1\u4ECD\u6709\u6771\u897F\uFF0C\u4F46\u60A8\u6C92\u6709\u5B58\u53D6\u6B0A\u9650\u3002",
        "\u6216\u8005\u53EA\u662F\u6709\u4EBA\u5728\u8907\u88FD\u8CBC\u4E0A\u9023\u7D50\u6642\u4E0D\u5920\u5C0F\u5FC3\u3002"
    ],
    'home': "\u9996\u9801",
    'home.header.hint': "\u5C08\u70BA\u7368\u7ACB\u958B\u767C\u8005\u6253\u9020\u7684\u96F2\u7AEF\u5DE5\u5177",
    'home.description': "Kavykhi.Cloud \u662F\u4E00\u500B\u7368\u7ACB\u904A\u6232\u958B\u767C\u5E73\u53F0\u3002\u6211\u5011\u652F\u63F4\u53EF\u4E0B\u8F09\u53CA\u700F\u89BD\u5668\u904A\u6232\u3001\u79C1\u6709\u8207\u516C\u958B\u7248\u672C\u3001\u5206\u652F\u3001\u5718\u968A\u7BA1\u7406\u7B49\u773E\u591A\u529F\u80FD\u3002",
    'home.auth': "\u767B\u5165\u6216\u8A3B\u518A",
    'home.auth.hint': "\u5EFA\u7ACB\u65B0\u5E33\u6236\u6216\u767B\u5165\u73FE\u6709\u5E33\u6236",
    'projects': "\u5C08\u6848",
    'projects.hint': "\u60A8\u6B63\u5728\u53C3\u8207\u7684\u5C08\u6848",
    'projects.project': (project)=>`\u{5C08}\u{6848}\u{FF1A}${project}`,
    'projects.project.hint': "\u5C08\u6848",
    'projects.no_projects': "\u60A8\u76EE\u524D\u6C92\u6709\u4EFB\u4F55\u5C08\u6848\u3002",
    'projects.new': "\u5EFA\u7ACB\u5C08\u6848",
    'projects.new_dialog.header': "\u65B0\u5C08\u6848",
    'projects.new_dialog.label': "\u5C08\u6848\u540D\u7A31",
    'projects.new_dialog.ok': "\u5EFA\u7ACB\u5C08\u6848",
    'projects.store_page': "\u516C\u958B\u5546\u5E97\u9801\u9762",
    'projects.description': "\u63CF\u8FF0",
    'projects.branches': "\u5206\u652F",
    'projects.versions': "\u7248\u672C",
    'projects.packages': "\u5957\u4EF6",
    'projects.management': "\u5C08\u6848\u8A2D\u5B9A",
    'projects.management.breadcrumb': "\u8A2D\u5B9A",
    'projects.management.title': (projectTitle)=>`${projectTitle} - \u{8A2D}\u{5B9A}`,
    'projects.management.hint': "\u5C08\u6848\u8A2D\u5B9A",
    'projects.management.users': "\u5718\u968A\u6210\u54E1",
    'projects.management.users.empty': "\u6C92\u6709\u5718\u968A\u6210\u54E1\u3002",
    'projects.management.users.role.tester': "\u6E2C\u8A66\u54E1",
    'projects.management.users.role.developer': "\u958B\u767C\u8005",
    'projects.management.users.role.admin': "\u7BA1\u7406\u54E1",
    'projects.management.users.role.owner': "\u64C1\u6709\u8005",
    'projects.management.users.role.starred': "\u5DF2\u661F\u6A19",
    'projects.management.users.exile': "\u79FB\u51FA\u5718\u968A",
    'projects.management.users.exile.dialog.header': "\u79FB\u51FA\u5718\u968A",
    'projects.management.users.exile.dialog.message': (projectTitle, userTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5C07 ",
            userTitle,
            " \u5F9E\u5C08\u6848 ",
            projectTitle,
            " \u4E2D\u79FB\u9664\u55CE\uFF1F"
        ],
    'projects.management.users.exile.dialog.ok': "\u79FB\u51FA\u5718\u968A",
    'projects.management.invites.one_time_invite': "\u4E00\u6B21\u6027\u9080\u8ACB\u9023\u7D50",
    'projects.management.invites.one_time_invite.header': "\u4E00\u6B21\u6027\u9080\u8ACB\u9023\u7D50",
    'projects.management.invites.one_time_invite.message': "\u4E00\u6B21\u6027\u9080\u8ACB\u9023\u7D50\uFF1A",
    'projects.management.invites.one_time_invite.note': "24 \u5C0F\u6642\u5167\u6709\u6548\uFF0C\u50C5\u53EF\u4F7F\u7528\u4E00\u6B21\u3002",
    'projects.management.invites.new_dialog.header': "\u9080\u8ACB\u9023\u7D50",
    'projects.management.invites.new_dialog.expires': "\u6709\u6548\u671F\u81F3\uFF1A",
    'projects.management.invites.new_dialog.expires.indefinite': "(\u6C38\u4E45\u6709\u6548)",
    'projects.management.invites.new_dialog.approval.label': "\u7528\u6236\u52A0\u5165\u5C08\u6848\uFF1A",
    'projects.management.invites.new_dialog.approval.not_approved': "\u9700\u7D93\u7BA1\u7406\u54E1\u6279\u51C6",
    'projects.management.invites.new_dialog.approval.approved': "\u7ACB\u5373\u52A0\u5165",
    'projects.management.invites.new_dialog.seats': "\u4EBA\u6578\u9650\u5236\uFF1A",
    'projects.management.invites.new_dialog.seats.no_limit': "(\u7121\u9650\u5236)",
    'projects.management.invites.new_dialog.ok': "\u5EFA\u7ACB\u9080\u8ACB\u9023\u7D50",
    'projects.management.deploy_sites': "\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.deploy_sites.empty': "\u672A\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9\u3002",
    'projects.management.deploy_sites.add': "\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.deploy_sites.delete': "\u522A\u9664",
    'projects.management.deploy_sites.delete_dialog.header': "\u522A\u9664\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.deploy_sites.delete_dialog.message': (provider, site)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664 ",
            provider,
            " \u7684\u90E8\u7F72\u7DB2\u7AD9 ",
            site,
            " \u55CE\uFF1F"
        ],
    'projects.management.deploy_sites.delete_dialog.ok': "\u522A\u9664\u90E8\u7F72\u7DB2\u7AD9",
    'projects.management.public_access': "\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.enable': "\u555F\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.enabled': [
        "\u516C\u958B\u5B58\u53D6\uFF1A",
        $40145e94f5e9e4b3$var$_tmpl$()
    ],
    'projects.management.public_access.enabled.note': "\u5C08\u6848\u540D\u7A31\u3001\u63CF\u8FF0\u4EE5\u53CA\u4EFB\u4F55\u6A19\u8A18\u70BA\u516C\u958B\u7684\u5206\u652F\u90FD\u5C07\u5C0D\u5916\u516C\u958B\u3002",
    'projects.management.public_access.enable_dialog.header': "\u555F\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.enable_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5141\u8A31\u516C\u958B\u5B58\u53D6\u5C08\u6848 ",
            projectTitle,
            " \u55CE\uFF1F",
            $40145e94f5e9e4b3$var$_tmpl$2(),
            $40145e94f5e9e4b3$var$_tmpl$2(),
            "\u9019\u5C07\u4F7F\u5C08\u6848\u7684\u57FA\u672C\u8CC7\u8A0A\u5728\u672A\u8A8D\u8B49\u7684\u60C5\u6CC1\u4E0B\u53EF\u898B\u3002\u60A8\u9700\u8981\u70BA\u6BCF\u500B\u5E0C\u671B\u516C\u958B\u7684\u5206\u652F\u55AE\u7368\u555F\u7528\u516C\u958B\u5B58\u53D6\u3002"
        ],
    'projects.management.public_access.enable_dialog.ok': "\u555F\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.disable': "\u505C\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.disabled': [
        "\u516C\u958B\u5B58\u53D6\uFF1A",
        $40145e94f5e9e4b3$var$_tmpl$3()
    ],
    'projects.management.public_access.disabled.note': "\u6B64\u5C08\u6848\u70BA\u79C1\u6709\u3002\u53EA\u6709\u5C08\u6848\u5718\u968A\u6210\u54E1\u53EF\u4EE5\u5B58\u53D6\u3002",
    'projects.management.public_access.disable_dialog.header': "\u505C\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.disable_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u505C\u7528\u5C08\u6848 ",
            projectTitle,
            " \u7684\u6240\u6709\u516C\u958B\u5B58\u53D6\u55CE\uFF1F"
        ],
    'projects.management.public_access.disable_dialog.ok': "\u505C\u7528\u516C\u958B\u5B58\u53D6",
    'projects.management.public_access.branches': "\u516C\u958B\u5206\u652F",
    'projects.management.manage': "\u7BA1\u7406\u5C08\u6848",
    'projects.rename': "\u91CD\u65B0\u547D\u540D\u5C08\u6848",
    'projects.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u5C08\u6848",
    'projects.rename_dialog.label': "\u5C08\u6848\u540D\u7A31\uFF1A",
    'projects.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u5C08\u6848",
    'projects.edit_description': "\u7DE8\u8F2F\u5C08\u6848\u63CF\u8FF0",
    'projects.edit_description_dialog.header': "\u7DE8\u8F2F\u5C08\u6848\u63CF\u8FF0",
    'projects.edit_description_dialog.label': "\u5C08\u6848\u63CF\u8FF0\uFF1A",
    'projects.edit_description_dialog.ok': "\u7DE8\u8F2F\u63CF\u8FF0",
    'projects.leave': "\u9000\u51FA\u5C08\u6848",
    'projects.leave_dialog.header': "\u9000\u51FA\u5C08\u6848",
    'projects.leave_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u9000\u51FA\u5C08\u6848 ",
            projectTitle,
            " \u55CE\uFF1F"
        ],
    'projects.leave_dialog.ok': "\u9000\u51FA\u5C08\u6848",
    'projects.delete': "\u522A\u9664\u5C08\u6848",
    'projects.delete_dialog.header': "\u522A\u9664\u5C08\u6848",
    'projects.delete_dialog.message': (projectTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u5C08\u6848 ",
            projectTitle,
            " \u55CE\uFF1F"
        ],
    'projects.delete_dialog.ok': "\u522A\u9664\u5C08\u6848",
    'branches.header': (projectTitle, branchTitle)=>`${projectTitle}: ${branchTitle}`,
    'branches.header.hint': "\u5206\u652F",
    'branches.no_branches': "\u6B64\u5C08\u6848\u5C1A\u7121\u5206\u652F",
    'branches.new': "\u5EFA\u7ACB\u5206\u652F",
    'branches.new_dialog.header': "\u65B0\u5206\u652F",
    'branches.new_dialog.label': "\u5206\u652F\u540D\u7A31",
    'branches.new_dialog.ok': "\u5EFA\u7ACB\u5206\u652F",
    'branches.current_version': (version)=>[
            "\u76EE\u524D\u7248\u672C\uFF1A",
            version
        ],
    'branches.current_version.packages': "\u76EE\u524D\u7248\u672C\u7684\u5957\u4EF6",
    'branches.no_current_version': "\u7121\u76EE\u524D\u7248\u672C",
    'branches.publish_version.new': "\u767C\u4F48\u65B0\u7248\u672C",
    'branches.publish_version.existing': "\u91CD\u65B0\u767C\u4F48\u73FE\u6709\u7248\u672C",
    'branches.version_history': "\u7248\u672C\u6B77\u53F2",
    'branches.version_history.empty': "\u6B64\u5206\u652F\u7684\u7248\u672C\u6B77\u53F2\u70BA\u7A7A\u3002",
    'branches.version_history.note_removal': ({ quotaCount: quotaCount, quotaCountText: quotaCountText, quotaNonCurrentTime: quotaNonCurrentTime, quotaTime: quotaTime })=>[
            "\u76EE\u524D\u7684\u5206\u652F\u7248\u672C\u5C07\u4FDD\u7559 ",
            quotaTime != null ? [
                " ",
                quotaTime
            ] : "\u6C38\u4E45",
            "\u3002\u5148\u524D\u7684\u7248\u672C\u6700\u591A\u4FDD\u7559 ",
            quotaNonCurrentTime,
            "\u3002\u6BCF\u500B\u5206\u652F\u6700\u591A\u4FDD\u7559 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$40145e94f5e9e4b3$var$plural(quotaCount, [
                    quotaCountText,
                    " \u500B\u7248\u672C"
                ], [
                    quotaCountText,
                    " \u500B\u7248\u672C"
                ])),
            "\u3002"
        ],
    'branches.manage': "\u7BA1\u7406\u5206\u652F",
    'branches.rename': "\u91CD\u65B0\u547D\u540D\u5206\u652F",
    'branches.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u5206\u652F",
    'branches.rename_dialog.label': "\u5206\u652F\u540D\u7A31\uFF1A",
    'branches.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u5206\u652F",
    'branches.delete': "\u522A\u9664\u5206\u652F",
    'branches.delete_dialog.header': "\u522A\u9664\u5206\u652F",
    'branches.delete_dialog.message': (branchTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u5206\u652F ",
            branchTitle,
            " \u55CE\uFF1F"
        ],
    'branches.delete_dialog.ok': "\u522A\u9664\u5206\u652F",
    'versions.header': (projectTitle, versionTitle)=>`${projectTitle} ${versionTitle}`,
    'versions.header.hint': "\u7248\u672C",
    'versions.current': "\u76EE\u524D",
    'versions.previous': "\u5148\u524D",
    'versions.description': "\u63CF\u8FF0",
    'versions.deploy_to_site.header': "\u767C\u4F48\u81F3\u7DB2\u7AD9",
    'versions.deploy_to_site': "\u767C\u4F48\u81F3\u7DB2\u7AD9",
    'versions.packages': "\u5957\u4EF6",
    'versions.branches': "\u6240\u5C6C\u5206\u652F",
    'versions.branches.publish': "\u767C\u4F48\u81F3\u5206\u652F",
    'versions.branches.empty': "\u6B64\u7248\u672C\u5C1A\u672A\u767C\u4F48\u81F3\u4EFB\u4F55\u5206\u652F\u3002",
    'versions.new_dialog.header': "\u65B0\u7248\u672C",
    'versions.new_dialog.label_title': "\u7248\u672C\uFF1A",
    'versions.new_dialog.label_branch': "\u5206\u652F\uFF1A",
    'versions.new_dialog.packages.header': "\u5957\u4EF6",
    'versions.new_dialog.packages.empty': "\u672A\u65B0\u589E\u5957\u4EF6\u3002",
    'versions.new_dialog.packages.add': "\u65B0\u589E\u5957\u4EF6",
    'versions.new_dialog.packages.add_existing': "\u65B0\u589E\u5148\u524D\u4E0A\u50B3\u7684\u5957\u4EF6",
    'versions.new_dialog.packages.replace': "\u66FF\u63DB\u5957\u4EF6",
    'versions.new_dialog.packages.edit': "\u7DE8\u8F2F\u5957\u4EF6",
    'versions.new_dialog.ok': "\u5EFA\u7ACB\u7248\u672C",
    'versions.manage': "\u7BA1\u7406\u7248\u672C",
    'versions.rename': "\u91CD\u65B0\u547D\u540D\u7248\u672C",
    'versions.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u7248\u672C",
    'versions.rename_dialog.label': "\u7248\u672C\u540D\u7A31\uFF1A",
    'versions.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u7248\u672C",
    'versions.edit_description': "\u7DE8\u8F2F\u7248\u672C\u63CF\u8FF0",
    'versions.edit_description_dialog.header': "\u7DE8\u8F2F\u7248\u672C\u63CF\u8FF0",
    'versions.edit_description_dialog.label': "\u7248\u672C\u63CF\u8FF0\uFF1A",
    'versions.edit_description_dialog.ok': "\u7DE8\u8F2F\u63CF\u8FF0",
    'versions.delete': "\u522A\u9664\u7248\u672C",
    'versions.delete_dialog.header': "\u522A\u9664\u7248\u672C",
    'versions.delete_dialog.message': (versionTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u7248\u672C ",
            versionTitle,
            " \u55CE\uFF1F"
        ],
    'versions.delete_dialog.ok': "\u522A\u9664\u7248\u672C",
    'versions.publish_dialog.header': "\u767C\u4F48\u7248\u672C\u81F3\u5206\u652F",
    'versions.publish_dialog.message': (versionTitle)=>[
            "\u9078\u64C7\u8981\u5C07\u7248\u672C ",
            versionTitle,
            " \u767C\u4F48\u81F3\u7684\u5206\u652F\u3002"
        ],
    'versions.publish_dialog.no_branches': "\u5C08\u6848\u4E2D\u7121\u5206\u652F\u3002",
    'versions.publish_dialog.ok': "\u767C\u4F48\u7248\u672C",
    'versions.publish_existing_dialog.header': "\u91CD\u65B0\u767C\u4F48\u7248\u672C",
    'versions.publish_existing_dialog.message': "\u6700\u65B0\u7248\u672C\uFF1A",
    'versions.publish_existing_dialog.no_versions': "\u5C08\u6848\u4E2D\u7121\u7248\u672C\u3002",
    'versions.publish_existing_dialog.ok': "\u767C\u4F48\u7248\u672C",
    'packages.header': (projectTitle, packageTitle)=>`${projectTitle}: ${packageTitle}`,
    'packages.header.hint': "\u5957\u4EF6",
    'packages.download_zip': "\u4E0B\u8F09\u70BA ZIP",
    'packages.download_torrent': "\u4E0B\u8F09 Torrent",
    'packages.total_size': (size)=>[
            "\u7E3D\u5927\u5C0F\uFF1A",
            size
        ],
    'packages.manage': "\u7BA1\u7406\u5957\u4EF6",
    'packages.rename': "\u91CD\u65B0\u547D\u540D\u5957\u4EF6",
    'packages.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u5957\u4EF6",
    'packages.rename_dialog.label': "\u5957\u4EF6\u540D\u7A31\uFF1A",
    'packages.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u5957\u4EF6",
    'packages.edit_tags': "\u7DE8\u8F2F\u5957\u4EF6\u6A19\u7C64",
    'packages.edit_tags_dialog.header': "\u7DE8\u8F2F\u5957\u4EF6\u6A19\u7C64",
    'packages.edit_tags_dialog.message': (packageTitle)=>[
            "\u6307\u5B9A\u5957\u4EF6 ",
            packageTitle,
            " \u7684\u6A19\u7C64\uFF1A"
        ],
    'packages.edit_tags_dialog.ok': "\u8A2D\u5B9A\u5957\u4EF6\u6A19\u7C64",
    'packages.entrypoint': (entrypoint)=>[
            "\u555F\u52D5\u6A94\u6848\uFF1A",
            entrypoint
        ],
    'packages.entrypoint.empty': "\u672A\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848\u3002",
    'packages.delete': "\u522A\u9664\u5957\u4EF6",
    'packages.delete_dialog.header': "\u522A\u9664\u5957\u4EF6",
    'packages.delete_dialog.message': (packageTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u5957\u4EF6 ",
            packageTitle,
            " \u55CE\uFF1F\u8A72\u5957\u4EF6\u5C07\u5F9E\u6240\u6709\u5DF2\u52A0\u5165\u7684\u7248\u672C\u4E2D\u522A\u9664\u3002"
        ],
    'packages.delete_dialog.ok': "\u522A\u9664\u5957\u4EF6",
    'packages.new_dialog.header': "\u65B0\u5957\u4EF6",
    'packages.new_dialog.label_title': "\u6A19\u984C\uFF1A",
    'packages.new_dialog.title_placeholder': "(\u4F86\u81EA\u6A19\u7C64)",
    'packages.new_dialog.tags.header': "\u6A19\u7C64",
    'packages.new_dialog.files.header': "\u6A94\u6848",
    'packages.new_dialog.total_size': (size, maximum)=>[
            "\u7E3D\u5927\u5C0F\uFF1A",
            size,
            " ",
            maximum
        ],
    'packages.new_dialog.total_size.maximum': (size)=>[
            "(\u6700\u5927 ",
            size,
            ")"
        ],
    'packages.new_dialog.new_data_size': (size)=>[
            "\u65B0\u6578\u64DA\u5927\u5C0F\uFF1A",
            size
        ],
    'packages.new_dialog.checks.empty': "\u672A\u65B0\u589E\u6A94\u6848\u3002",
    'packages.new_dialog.checks.entrypoint.empty': "\u672A\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848\u3002",
    'packages.new_dialog.checks.entrypoint.missing': (entrypoint)=>[
            "\u555F\u52D5\u6A94\u6848 ",
            entrypoint,
            " \u4E0D\u5B58\u5728\uFF1B\u60A8\u662F\u5426\u5FD8\u8A18\u65B0\u589E\u5B83\uFF1F\u8ACB\u6307\u5B9A\u73FE\u6709\u7684\u555F\u52D5\u6A94\u6848\uFF0C\u6216\u8005\u60A8\u4E5F\u53EF\u4EE5\u4E0D\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.missing.action': "\u53D6\u6D88\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848",
    'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag)=>[
            "\u555F\u52D5\u6A94\u6848\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u5EFA\u8B70\u4F7F\u7528 ",
            tag,
            " \u6A19\u7C64\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag)=>[
            "\u65B0\u589E ",
            tag,
            " \u6A19\u7C64"
        ],
    'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag)=>[
            "\u555F\u52D5\u6A94\u6848\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u8ACB\u65B0\u589E ",
            tag,
            " \u6A19\u7C64\u4EE5\u4F7F\u5957\u4EF6\u53EF\u5728\u700F\u89BD\u5668\u4E2D\u904A\u73A9\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt)=>[
            "\u555F\u52D5\u6A94\u6848\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u9019\u662F\u5426\u70BA\u932F\u8AA4\uFF1F\u901A\u5E38\u9019\u4E0D\u662F\u53EF\u4EE5\u555F\u52D5\u7684\u6A94\u6848\u985E\u578B\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt)=>[
            "\u555F\u52D5\u6A94\u6848\u526F\u6A94\u540D\u70BA ",
            fileExt,
            "\uFF1A\u5EFA\u8B70\u76F4\u63A5\u5305\u542B\u5BE6\u969B\u5167\u5BB9\u6A94\u6848\uFF0C\u800C\u975E\u5C07\u5176\u6253\u5305\u70BA\u58D3\u7E2E\u6A94\u3002"
        ],
    'packages.new_dialog.checks.entrypoint.executable': "\u555F\u52D5\u6A94\u6848\u672A\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'packages.new_dialog.checks.entrypoint.executable.action': "\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'packages.new_dialog.checks.single_root_dir': "\u5EFA\u8B70\u5C07\u6A94\u6848\u76F4\u63A5\u653E\u5728\u6839\u76EE\u9304\uFF0C\u800C\u975E\u5728\u6839\u76EE\u9304\u4E0B\u50C5\u5305\u542B\u55AE\u500B\u8CC7\u6599\u593E\u3002",
    'packages.new_dialog.checks.single_root_dir.action': "\u5C07\u8CC7\u6599\u593E\u66FF\u63DB\u70BA\u5176\u5167\u5BB9",
    'packages.add_existing_dialog.header': "\u65B0\u589E\u5957\u4EF6",
    'packages.add_existing_dialog.add': (packagesCount)=>packagesCount > 0 ? `\u{65B0}\u{589E} ${$40145e94f5e9e4b3$var$plural(packagesCount, `${packagesCount} \u{500B}\u{5957}\u{4EF6}`, `${packagesCount} \u{500B}\u{5957}\u{4EF6}`)}` : "\u672A\u9078\u64C7\u5957\u4EF6",
    'packages.add_existing_dialog.message': "\u6700\u8FD1\u4E0A\u50B3\u7684\u5957\u4EF6\uFF1A",
    'packages.add_existing_dialog.no_packages': "\u6C92\u6709\u6700\u8FD1\u4E0A\u50B3\u7684\u5957\u4EF6\u3002",
    'packages.launch': "\u555F\u52D5",
    'packages.install': "\u5B89\u88DD",
    'packages.install_dialog.header': "\u5B89\u88DD",
    'packages.install_dialog.workdir.label': "\u5DE5\u4F5C\u76EE\u9304\uFF1A",
    'packages.install_dialog.workdir.value.new': "(\u5EFA\u7ACB\u65B0\u76EE\u9304)",
    'packages.install_dialog.workspace.label': "\u5EFA\u7ACB\u8CC7\u6599\u593E\u65BC\uFF1A",
    'packages.install_dialog.workspace.placeholder': "(\u9078\u64C7\u6839\u8CC7\u6599\u593E)",
    'packages.install_dialog.ok': "\u5B89\u88DD",
    'packages.update': "\u66F4\u65B0",
    'packages.upload.status.existing': "\u4F86\u81EA\u5148\u524D\u7248\u672C",
    'packages.upload.status.queued': "\u5DF2\u6392\u968A",
    'packages.upload.status.packing': "\u6253\u5305\u4E2D...",
    'packages.upload.status.creating': "\u5EFA\u7ACB\u4E2D...",
    'packages.upload.status.create_retrying': "\u5EFA\u7ACB\u5931\u6557\uFF0C\u6B63\u5728\u7B49\u5F85\u4E26\u91CD\u8A66",
    'packages.upload.status.splitting': "\u5206\u5272\u4E2D...",
    'packages.upload.status.uploading': "\u4E0A\u50B3\u4E2D...",
    'packages.upload.status.finalizing': "\u5B8C\u6210\u4E2D...",
    'packages.upload.status.finalize_retrying': "\u5B8C\u6210\u5931\u6557\uFF0C\u6B63\u5728\u7B49\u5F85\u4E26\u91CD\u8A66",
    'packages.upload.status.resolving': "\u89E3\u6790\u88DC\u4E01\u4E2D...",
    'packages.upload.status.resolve_retrying': "\u89E3\u6790\u88DC\u4E01\u5931\u6557\uFF0C\u6B63\u5728\u7B49\u5F85\u4E26\u91CD\u8A66...",
    'packages.upload.status.done': "\u4E0A\u50B3\u6210\u529F",
    'packages.upload.status.errored': "\u932F\u8AA4",
    'packages.upload.part.status.queued': "\u5DF2\u6392\u968A",
    'packages.upload.part.status.hashing': "\u96DC\u6E4A\u8A08\u7B97\u4E2D",
    'packages.upload.part.status.upload_queued': "\u4E0A\u50B3\u5DF2\u6392\u968A",
    'packages.upload.part.status.uploading': "\u4E0A\u50B3\u4E2D",
    'packages.upload.part.status.upload_retrying': "\u932F\u8AA4\uFF0C\u6B63\u5728\u91CD\u8A66\u4E0A\u50B3",
    'packages.upload.part.status.upload_finalizing': "\u6B63\u5728\u5B8C\u6210\u4E0A\u50B3",
    'packages.upload.part.status.upload_errored': "\u932F\u8AA4",
    'packages.upload.part.status.done': "\u5DF2\u4E0A\u50B3",
    'packages.play': "\u5728\u700F\u89BD\u5668\u4E2D\u904A\u73A9",
    'packages.play.reset': "\u91CD\u8A2D",
    'packages.play.fullscreen': "\u5168\u87A2\u5E55",
    'deploy_sites.add_dialog.header': "\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9",
    'deploy_sites.add_dialog.message': (projectTitle)=>[
            "\u9078\u64C7\u90E8\u7F72\u6191\u8B49\u4E26\u8F38\u5165\u7DB2\u7AD9 URL\uFF0C\u4EE5\u5C07\u5176\u5132\u5B58\u70BA\u5C08\u6848 ",
            projectTitle,
            " \u7684\u90E8\u7F72\u7DB2\u7AD9\u3002"
        ],
    'deploy_sites.add_dialog.label_credential': "\u90E8\u7F72\u6191\u8B49\uFF1A",
    'deploy_sites.add_dialog.select_credential': "\u9078\u64C7\u6191\u8B49",
    'deploy_sites.add_dialog.select_credential.new': "\u65B0\u589E\u6191\u8B49...",
    'deploy_sites.add_dialog.label_select_site': "\u9078\u64C7\u7DB2\u7AD9\uFF1A",
    'deploy_sites.add_dialog.select_credential_first': "(\u8ACB\u5148\u9078\u64C7\u6191\u8B49)",
    'deploy_sites.add_dialog.select_site': "(\u9078\u64C7\u7DB2\u7AD9)",
    'deploy_sites.add_dialog.label_enter_site': "\u6216\u8F38\u5165\u7DB2\u7AD9 URL\uFF1A",
    'deploy_sites.add_dialog.ok': "\u65B0\u589E\u7DB2\u7AD9",
    'deploy_to_site_dialog.header': "\u767C\u4F48\u81F3\u7DB2\u7AD9",
    'deploy_to_site_dialog.message': (projectTitle, versionTitle)=>[
            "\u9078\u64C7\u8981\u767C\u4F48\u5C08\u6848 ",
            projectTitle,
            " \u7248\u672C ",
            versionTitle,
            " \u7684\u7DB2\u7AD9\u3002"
        ],
    'deploy_to_site_dialog.label_site': "\u767C\u4F48\u81F3\u7DB2\u7AD9\uFF1A",
    'deploy_to_site_dialog.select_site': "\u9078\u64C7\u7DB2\u7AD9",
    'deploy_to_site_dialog.select_site.new': "\u65B0\u589E\u90E8\u7F72\u7DB2\u7AD9...",
    'deploy_to_site_dialog.packages.message.itch': [
        "\u5957\u4EF6\u5C07\u4F7F\u7528 ",
        $40145e94f5e9e4b3$var$_tmpl$4(),
        " \u767C\u4F48\u81F3 itch.io\u3002\u983B\u9053\u540D\u7A31\u884D\u751F\u81EA\u5957\u4EF6\u6A19\u7C64\u3002"
    ],
    'deploy_to_site_dialog.deploy': "\u767C\u4F48",
    'deploy_to_site_dialog.close': "\u95DC\u9589",
    'deploy_to_site_dialog.error.no_packages': "\u7121\u53EF\u767C\u4F48\u7684\u5957\u4EF6\u3002",
    'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount: packagesCount, packagesCountText: packagesCountText, channel: channel })=>[
            "\u591A\u500B\u5957\u4EF6\u7121\u6CD5\u767C\u4F48\u81F3\u540C\u4E00\u500B\u983B\u9053\u3002\u76EE\u524D\u6709 ",
            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>$40145e94f5e9e4b3$var$plural(packagesCount, [
                    packagesCountText,
                    " \u500B\u5957\u4EF6"
                ], [
                    packagesCountText,
                    " \u500B\u5957\u4EF6"
                ])),
            " \u8A2D\u5B9A\u767C\u4F48\u81F3\u983B\u9053 ",
            channel,
            "\u3002"
        ],
    'deploy_to_site_dialog.job.queued': "\u5DF2\u6392\u968A",
    'deploy_to_site_dialog.job.downloading': "\u4E0B\u8F09\u4E2D...",
    'deploy_to_site_dialog.job.unpacking': "\u89E3\u5305\u4E2D...",
    'deploy_to_site_dialog.job.uploading': "\u767C\u4F48\u4E2D...",
    'deploy_to_site_dialog.job.succeeded': "\u6210\u529F",
    'deploy_to_site_dialog.job.errored': "\u932F\u8AA4",
    'store': "\u5546\u5E97",
    'store.hint': "\u516C\u958B\u5C08\u6848",
    'store.project.hint': "\u5546\u5E97\u5C08\u6848\u9801\u9762",
    'store.project.owner': "\u958B\u767C\u8005",
    'store.project.description': "\u63CF\u8FF0",
    'store.project.star': "\u661F\u6A19",
    'store.project.starred': "\u5DF2\u661F\u6A19",
    'store.project.content': "\u5167\u5BB9",
    'store.project.content.warning': "\u6B64\u5167\u5BB9\u7531\u7B2C\u4E09\u65B9\u958B\u767C\u8005\u63D0\u4F9B\u3002",
    'store.project.branch_version': (branchTitle, versionTitle)=>[
            branchTitle,
            " \u5206\u652F\uFF1A\u7248\u672C ",
            versionTitle
        ],
    'store.project.branch_version.published': (branchVersionPublished)=>[
            "\u767C\u4F48\u6642\u9593\uFF1A",
            branchVersionPublished
        ],
    'me': "\u500B\u4EBA\u6A94\u6848",
    'me.hint': "\u500B\u4EBA\u6A94\u6848\u8A2D\u5B9A\u8207\u5DF2\u9023\u7D50\u7684\u6191\u8B49",
    'me.rename': "\u91CD\u65B0\u547D\u540D\u500B\u4EBA\u6A94\u6848",
    'me.rename_dialog.header': "\u91CD\u65B0\u547D\u540D\u500B\u4EBA\u6A94\u6848",
    'me.rename_dialog.label_title': "\u540D\u7A31\uFF1A",
    'me.rename_dialog.ok': "\u91CD\u65B0\u547D\u540D\u500B\u4EBA\u6A94\u6848",
    'me.credentials': "\u6191\u8B49",
    'me.credentials.hint.auth_allowed': "\u4EE5\u4E0B\u4EFB\u4F55\u6191\u8B49\u5747\u53EF\u7528\u65BC\u767B\u5165\u6B64\u5E33\u6236\u3002",
    'me.credentials.hint.auth_disallowed': "\u9019\u4E9B\u6191\u8B49\u5DF2\u9023\u7D50\u81F3\u60A8\u7684\u5E33\u6236\uFF0C\u4F46\u7121\u6CD5\u7528\u65BC\u767B\u5165\u3002",
    'me.credentials.empty': "\u7121\u6191\u8B49\u3002",
    'me.credentials.empty.auth_allowed.warning': "\u60A8\u53EF\u80FD\u6703\u88AB\u9396\u5728\u5E33\u6236\u4E4B\u5916\uFF01\u60A8\u5C1A\u672A\u9023\u7D50\u4EFB\u4F55\u53EF\u7528\u65BC\u767B\u5165\u7684\u6191\u8B49\u3002\u8ACB\u5118\u5FEB\u9023\u7D50\u4E00\u500B\u53EF\u7528\u65BC\u767B\u5165\u7684\u6191\u8B49\u3002",
    'me.credentials.profile_picture.alt': (provider)=>`${$40145e94f5e9e4b3$var$dict[`auth.provider.${provider}`]} \u{500B}\u{4EBA}\u{6A94}\u{6848}\u{5716}\u{7247}`,
    'me.credentials.created': (created)=>[
            "\u5DF2\u65BC ",
            created,
            " \u65B0\u589E"
        ],
    'me.credentials.last_used': (lastUsed)=>[
            "\u4E0A\u6B21\u4F7F\u7528\u65BC ",
            lastUsed
        ],
    'me.credential.unlink': "\u53D6\u6D88\u9023\u7D50",
    'me.credential.allow_auth': "\u5141\u8A31\u767B\u5165",
    'me.credential.disallow_auth': "\u4E0D\u5141\u8A31\u767B\u5165",
    'me.credential.display_publicly': "\u516C\u958B\u986F\u793A",
    'me.credential.dont_display_publicly': "\u4E0D\u516C\u958B\u986F\u793A",
    'me.credential.link': "\u9023\u7D50\u6191\u8B49",
    'me.credential.link_dialog.header': "\u9023\u7D50\u6191\u8B49",
    'me.credential.link_dialog.message': "\u8ACB\u9078\u64C7\u8981\u9023\u7D50\u7684\u5E33\u6236\u670D\u52D9\u5546\u3002",
    'me.credential.unlink_dialog.header': "\u53D6\u6D88\u9023\u7D50\u6191\u8B49",
    'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5F9E\u60A8\u7684 Kavykhi.Cloud \u5E33\u6236\u4E2D\u53D6\u6D88\u9023\u7D50 ",
            credentialProvider,
            " \u5E33\u6236 ",
            credentialTitle,
            " \u55CE\uFF1F"
        ],
    'me.credential.unlink_dialog.ok': "\u53D6\u6D88\u9023\u7D50\u6191\u8B49",
    'me.sessions': "\u5DE5\u4F5C\u968E\u6BB5",
    'me.sessions.hint': "\u9019\u662F\u60A8\u7684\u6D3B\u52D5\u5DE5\u4F5C\u968E\u6BB5\u5217\u8868\uFF0C\u5305\u62EC\u60A8\u76EE\u524D\u7684\u700F\u89BD\u5668\u3002",
    'me.sessions.started': (started)=>[
            "\u958B\u59CB\u65BC ",
            (()=>{
                var _el$6 = $40145e94f5e9e4b3$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, started);
                return _el$6;
            })()
        ],
    'me.sessions.last_auth': (lastAuth)=>[
            "\u6D3B\u52D5\u65BC ",
            (()=>{
                var _el$7 = $40145e94f5e9e4b3$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, lastAuth);
                return _el$7;
            })()
        ],
    'me.sessions.current': "\u76EE\u524D\u5DE5\u4F5C\u968E\u6BB5",
    'me.sessions.empty': "\u7121\u5DE5\u4F5C\u968E\u6BB5\u3002",
    'me.sessions.delete': "\u7D42\u6B62",
    'me.sessions.delete_dialog.header': "\u7D42\u6B62\u5DE5\u4F5C\u968E\u6BB5",
    'me.sessions.delete_dialog.message': "\u60A8\u78BA\u5B9A\u8981\u7D42\u6B62\u6B64\u5DE5\u4F5C\u968E\u6BB5\u55CE\uFF1F",
    'me.sessions.delete_dialog.ok': "\u7D42\u6B62\u5DE5\u4F5C\u968E\u6BB5",
    'me.api_tokens': "API \u6B0A\u6756",
    'me.api_tokens.hint': "\u60A8\u53EF\u4EE5\u5728\u6B64\u5EFA\u7ACB API \u6B0A\u6756\u4EE5\u7528\u65BC\u81EA\u52D5\u5316\u6D41\u7A0B\u3002",
    'me.api_tokens.started': (started)=>[
            "\u5EFA\u7ACB\u65BC ",
            (()=>{
                var _el$8 = $40145e94f5e9e4b3$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, started);
                return _el$8;
            })()
        ],
    'me.api_tokens.expires': (expires)=>[
            "\u904E\u671F\u65BC ",
            (()=>{
                var _el$9 = $40145e94f5e9e4b3$var$_tmpl$5();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, expires);
                return _el$9;
            })()
        ],
    'me.api_tokens.no_expiration': "\u6C38\u4E45\u6709\u6548",
    'me.api_tokens.empty': "\u7121 API \u6B0A\u6756\u3002",
    'me.api_tokens.create': "\u7522\u751F API \u6B0A\u6756",
    'me.api_tokens.create_dialog.header': "\u7522\u751F API \u6B0A\u6756",
    'me.api_tokens.create_dialog.message': "\u5DF2\u7522\u751F\u7684 API \u6B0A\u6756\uFF1A",
    'me.api_tokens.create_dialog.note': "\u6B64\u6B0A\u6756\u5C07\u4E0D\u6703\u518D\u6B21\u986F\u793A\uFF0C\u8ACB\u59A5\u5584\u5132\u5B58\u3002",
    'me.api_tokens.delete': "\u522A\u9664",
    'me.api_tokens.delete_dialog.header': "\u522A\u9664 API \u6B0A\u6756",
    'me.api_tokens.delete_dialog.message': "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u6B64\u6B0A\u6756\u55CE\uFF1F",
    'me.api_tokens.delete_dialog.ok': "\u522A\u9664 API \u6B0A\u6756",
    'me.deploy_credentials': "\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credentials.hint': "\u60A8\u53EF\u4EE5\u5728\u6B64\u65B0\u589E\u7528\u65BC\u90E8\u7F72\u81F3\u767C\u4F48\u5E73\u53F0\u7684\u6191\u8B49\u3002",
    'me.deploy_credentials.empty': "\u672A\u65B0\u589E\u90E8\u7F72\u6191\u8B49\u3002",
    'me.deploy_credential.add': "\u65B0\u589E\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.add_dialog.header': "\u65B0\u589E\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.add_dialog.label_site': "\u7DB2\u7AD9\uFF1A",
    'me.deploy_credential.add_dialog.label_title': "\u5099\u8A3B\uFF1A",
    'me.deploy_credential.add_dialog.label_key': "\u91D1\u9470\uFF1A",
    'me.deploy_credential.add_dialog.default_title': (date)=>`\u{91D1}\u{9470} ${date}`,
    'me.deploy_credential.add_dialog.ok': "\u65B0\u589E\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.add_dialog.hint.itch': [
        "\u8981\u7522\u751F itch.io API \u91D1\u9470\uFF0C\u8ACB\u524D\u5F80\u60A8\u5728 itch.io \u7684 ",
        $40145e94f5e9e4b3$var$_tmpl$6(),
        "\u3002\u60A8\u53EF\u4EE5\u4F7F\u7528\u4F86\u6E90\u70BA \"web\" \u6216 \"wharf\" \u7684\u73FE\u6709 API \u91D1\u9470\u3002\u4F86\u6E90\u70BA \"Kavykhi.Cloud\" \u7684 API \u91D1\u9470\u5C07\u7121\u6CD5\u904B\u4F5C\u3002"
    ],
    'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider)=>[
            "\u6211\u5011\u76EE\u524D\u4E0D\u652F\u63F4\u65B0\u589E ",
            credentialProvider,
            " \u6191\u8B49\u3002"
        ],
    'me.deploy_credential.delete': "\u522A\u9664",
    'me.deploy_credential.delete_dialog.header': "\u522A\u9664\u90E8\u7F72\u6191\u8B49",
    'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider)=>[
            "\u60A8\u78BA\u5B9A\u8981\u522A\u9664 ",
            credentialProvider,
            " \u7684\u6191\u8B49 ",
            credentialTitle,
            " \u55CE\uFF1F\u4EFB\u4F55\u4F7F\u7528\u6B64\u6191\u8B49\u8A2D\u5B9A\u7684\u90E8\u7F72\u7DB2\u7AD9\u4E5F\u5C07\u5F9E\u5C08\u6848\u4E2D\u79FB\u9664\u3002"
        ],
    'me.deploy_credential.delete_dialog.ok': "\u522A\u9664\u6191\u8B49",
    'me.public_profile': "\u516C\u958B\u500B\u4EBA\u6A94\u6848",
    'me.public_profile.public_credentials': "\u516C\u958B\u6191\u8B49",
    'me.public_profile.public_credentials.hint': "\u9078\u64C7\u8981\u516C\u958B\u986F\u793A\u7684\u6191\u8B49\u3002",
    'me.manage': "\u7BA1\u7406\u5E33\u6236",
    'me.delete': "\u522A\u9664\u5E33\u6236",
    'me.delete.dialog.header': "\u522A\u9664\u5E33\u6236",
    'me.delete.dialog.message': (userTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u6C38\u4E45\u522A\u9664\u60A8\u7684 Kavykhi.Cloud \u5E33\u6236 ",
            userTitle,
            " \u55CE\uFF1F"
        ],
    'me.delete.dialog.ok': "\u522A\u9664\u5E33\u6236",
    'invite': "\u9080\u8ACB",
    'invite.hint': "\u5C08\u6848\u9080\u8ACB",
    'invite.message.already_member': (projectTitle)=>[
            "\u60A8\u5DF2\u7D93\u662F\u5C08\u6848 ",
            projectTitle,
            " \u7684\u6210\u54E1\u3002"
        ],
    'invite.message.join': (projectTitle)=>[
            "\u60A8\u5DF2\u88AB\u9080\u8ACB\u52A0\u5165\u5C08\u6848 ",
            projectTitle,
            "\u3002"
        ],
    'invite.join': "\u52A0\u5165\u5C08\u6848",
    'local': "\u672C\u5730\u5167\u5BB9",
    'local.hint': "\u672C\u5730\u5B89\u88DD\u7684\u5167\u5BB9",
    'local.workdirs': "\u5DF2\u5B89\u88DD\u7684\u5957\u4EF6",
    'local.workdirs.empty': "\u7121\u5DF2\u5B89\u88DD\u7684\u5957\u4EF6\u3002",
    'local.workdir.action.launch': "\u555F\u52D5",
    'local.workdir.action.repair': "\u4FEE\u5FA9",
    'local.workdir.action.delete': "\u89E3\u9664\u5B89\u88DD",
    'local.workdir.delete_dialog.header': "\u89E3\u9664\u5B89\u88DD\u5957\u4EF6",
    'local.workdir.delete_dialog.message': (packageTitle)=>[
            "\u60A8\u78BA\u5B9A\u8981\u5F9E\u60A8\u7684\u88DD\u7F6E\u4E0A\u89E3\u9664\u5B89\u88DD\u5957\u4EF6 ",
            packageTitle,
            " \u55CE\uFF1F"
        ],
    'local.workdir.delete_dialog.ok': "\u89E3\u9664\u5B89\u88DD",
    'local.workspaces': "\u6839\u8CC7\u6599\u593E",
    'local.app_not_detected.message': "\u672A\u5075\u6E2C\u5230 Kavykhi.Cloud \u672C\u5730\u61C9\u7528\u7A0B\u5F0F\u3002\u8ACB\u4F7F\u7528\u4E0B\u65B9\u9023\u7D50\u4E0B\u8F09\u4E26\u5B89\u88DD\u3002\u5982\u679C\u60A8\u5DF2\u7D93\u5B89\u88DD\uFF0C\u8ACB\u78BA\u4FDD\u5B83\u6B63\u5728\u57F7\u884C\u3002",
    'local_app.detected': "\u672C\u5730\u5167\u5BB9",
    'error_dialog.header': "\u932F\u8AA4",
    'error_dialog.messageFunc': (e)=>`\u{932F}\u{8AA4}\u{FF1A}${$40145e94f5e9e4b3$var$dict[`error.${e}`] ?? e}\u{3002}`,
    'upload_box.choose_files': "\u9078\u64C7\u6A94\u6848",
    'upload_box.choose_directories': "\u9078\u64C7\u8CC7\u6599\u593E",
    'upload_box.add.progress_dialog.header': "\u6B63\u5728\u65B0\u589E\u6A94\u6848",
    'upload_box.add.progress_dialog.message': "\u6B63\u5728\u8655\u7406\u6A94\u6848...",
    'upload_box.delete': (itemsCount)=>`\u{522A}\u{9664} ${$40145e94f5e9e4b3$var$plural(itemsCount, `${itemsCount} \u{500B}\u{9805}\u{76EE}`, `${itemsCount} \u{500B}\u{9805}\u{76EE}`)}`,
    'upload_box.start_upload': "\u958B\u59CB\u4E0A\u50B3",
    'upload_box.drop_area.message': "\u5C07\u6A94\u6848\u548C\u8CC7\u6599\u593E\u62D6\u653E\u5230\u6B64\u8655",
    'upload_box.drop_area.box_dropping_message': "\u62D6\u653E\u5230\u6B64\u8655\u4EE5\u653E\u5165\u6839\u76EE\u9304",
    'upload_box.entry.explode_folder': "\u5C07\u8CC7\u6599\u593E\u66FF\u63DB\u70BA\u5176\u5167\u5BB9",
    'upload_box.entry.set_entrypoint': "\u8A2D\u5B9A\u555F\u52D5\u6A94\u6848",
    'upload_box.entry.mark_executable': "\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'upload_box.entry.unmark_executable': "\u53D6\u6D88\u6A19\u8A18\u70BA\u53EF\u57F7\u884C\u6A94",
    'upload_box.entry.remove': "\u79FB\u9664",
    'package.tags.empty': "(\u7121\u6A19\u7C64)",
    'package.tag.os': "\u4F5C\u696D\u7CFB\u7D71",
    'package.tag.os:windows': 'Windows',
    'package.tag.os:linux': 'Linux',
    'package.tag.os:macos': 'macOS',
    'package.tag.os:android': 'Android',
    'package.tag.os:ios': 'iOS',
    'package.tag.os:web': 'Web',
    'package.tag.arch': "\u67B6\u69CB",
    'package.tag.arch:x86': 'x86',
    'package.tag.arch:arm': 'ARM',
    'package.tag.bits': "\u4F4D\u5143",
    'package.tag.bits:64': "64 \u4F4D\u5143",
    'package.tag.bits:32': "32 \u4F4D\u5143",
    'package.tag.packaging': "\u6253\u5305\u683C\u5F0F",
    'package.tag.packaging:installer': "\u5B89\u88DD\u7A0B\u5F0F",
    'package.tag.packaging:deb': '.deb',
    'package.tag.packaging:rpm': '.rpm',
    'package.tag.packaging:flatpak': 'Flatpak',
    'package.tag.component': "\u7D44\u4EF6",
    'package.tag.component:client': "\u7528\u6236\u7AEF",
    'package.tag.component:server': "\u4F3A\u670D\u5668",
    'package.tag.runtime': "\u57F7\u884C\u74B0\u5883",
    'package.tag.runtime:nodejs': 'Node.js',
    'package.tag.runtime:java': 'Java',
    'package.tag.distro': "Linux \u767C\u884C\u7248",
    'package.tag.distro:ubuntu': 'Ubuntu',
    'package.tag.distro:fedora': 'Fedora',
    'package.tag.distro:arch': 'Arch Linux',
    'package.tag.distro:nixos': 'NixOS',
    'docs': "\u6587\u4EF6",
    'docs.page_no_language': "\u6B64\u8A9E\u8A00\u7248\u672C\u4E0D\u53EF\u7528",
    'docs.page_no_language.message': "\u6B64\u6587\u4EF6\u7684\u5176\u4ED6\u8A9E\u8A00\u7248\u672C\uFF1A",
    'docs.page_no_language.other_link': (doc, lang)=>[
            "(",
            lang,
            ") ",
            doc
        ],
    'social_links.discord': 'Discord',
    'report_content': "\u8209\u5831\u5167\u5BB9",
    'report_content.dialog.header': "\u8209\u5831\u5167\u5BB9",
    'report_content.dialog.link': "\u900F\u904E\u96FB\u90F5\u50B3\u9001\u8209\u5831",
    'report_content.dialog.message': (email, link)=>[
            "\u8ACB\u9EDE\u64CA\u9023\u7D50\u50B3\u9001\u60A8\u7684\u8209\u5831\uFF1A",
            $40145e94f5e9e4b3$var$_tmpl$2(),
            $40145e94f5e9e4b3$var$_tmpl$2(),
            link,
            $40145e94f5e9e4b3$var$_tmpl$2(),
            $40145e94f5e9e4b3$var$_tmpl$2(),
            "\u6216\u624B\u52D5\u767C\u9001\u96FB\u90F5\u81F3 ",
            email
        ]
};
var $40145e94f5e9e4b3$export$2e2bcd8739ae039 = $40145e94f5e9e4b3$var$dict;
const $40145e94f5e9e4b3$var$plural = (n, one, many)=>n == 1 ? one : many;










var $f76c1440e65621fa$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $f76c1440e65621fa$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer>`);
const $f76c1440e65621fa$export$28a9d9f228b717af = ()=>{
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    return [
        (()=>{
            var _el$ = $f76c1440e65621fa$var$_tmpl$();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                onClick: async ()=>{
                    await api.postAdminMaintenanceOptimizeContentImages();
                },
                children: "Optimize images"
            }));
            return _el$;
        })(),
        $f76c1440e65621fa$var$_tmpl$2()
    ];
};






var $0d03c01d318066a5$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end"></div><div>`), $0d03c01d318066a5$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div></div><div>`);
const $0d03c01d318066a5$export$817f10b3675cea1a = ()=>{
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [jobs, setJobs] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)([]);
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            title: "Experiment",
            breadcrumb: ()=>'Experiment',
            uiClass: "experiment"
        }),
        (()=>{
            var _el$ = $0d03c01d318066a5$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                onClick: async ()=>{
                    const tokens = [];
                    for(let i = 0; i < 5; ++i)tokens.push(await api.postJobs());
                    setJobs(await (0, $d542c09ca8fd8013$export$e702be3367c4e877)(tokens));
                },
                children: "Test"
            }));
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                get each () {
                    return jobs();
                },
                children: (job)=>(()=>{
                        var _el$4 = $0d03c01d318066a5$var$_tmpl$2(), _el$5 = _el$4.firstChild, _el$6 = _el$5.nextSibling;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>JSON.stringify(job().output));
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>JSON.stringify(job().progress));
                        return _el$4;
                    })()
            }));
            return _el$;
        })()
    ];
};







var $bd526e86fe658bf8$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1><div class=hint>`), $bd526e86fe658bf8$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $bd526e86fe658bf8$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $bd526e86fe658bf8$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer>`), $bd526e86fe658bf8$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`);
const $bd526e86fe658bf8$export$5d496d0c210dc288 = ()=>{
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const navigate = (0, $bcd7d00b4653a471$export$2b3a76f83deeece4)();
    const token = new URL(window.location.href).searchParams.get('token');
    const [inviteInfo] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        if (!token) return null;
        try {
            return await api.getInvites({
                token: token
            });
        } catch (e) {
            return null;
        }
    });
    const onJoin = async ()=>{
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            const projectId = await api.postInvites({
                token: token
            });
            navigate((0, $c900760615f37aa7$export$d9c91539b7b67f34)(projectId), {
                replace: true
            });
        });
    };
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            get title () {
                return t('invite');
            },
            breadcrumb: ()=>t('invite'),
            uiClass: "invite"
        }),
        (()=>{
            var _el$ = $bd526e86fe658bf8$var$_tmpl$(), _el$2 = _el$.firstChild;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>inviteInfo()?.projectTitle ?? t('invite'), _el$2);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('invite.hint'));
            return _el$;
        })(),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return inviteInfo();
            },
            get fallback () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                    resource: inviteInfo,
                    page: true
                });
            },
            get children () {
                return [
                    (()=>{
                        var _el$3 = $bd526e86fe658bf8$var$_tmpl$2();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>t(inviteInfo()?.projectId ? 'invite.message.already_member' : 'invite.message.join')(inviteInfo()?.projectId ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                get href () {
                                    return (0, $c900760615f37aa7$export$d9c91539b7b67f34)(inviteInfo()?.projectId);
                                },
                                get children () {
                                    return inviteInfo()?.projectTitle;
                                }
                            }) : (()=>{
                                var _el$6 = $bd526e86fe658bf8$var$_tmpl$5();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>inviteInfo()?.projectTitle);
                                return _el$6;
                            })()));
                        return _el$3;
                    })(),
                    (()=>{
                        var _el$4 = $bd526e86fe658bf8$var$_tmpl$4();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                            get when () {
                                return inviteInfo()?.projectId === null;
                            },
                            get children () {
                                var _el$5 = $bd526e86fe658bf8$var$_tmpl$3();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                    onClick: onJoin,
                                    get children () {
                                        return t('invite.join');
                                    }
                                }));
                                return _el$5;
                            }
                        }));
                        return _el$4;
                    })()
                ];
            }
        })
    ];
};








var $03b25ed780fb341f$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $03b25ed780fb341f$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<progress>`), $03b25ed780fb341f$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class="buttons group"></div><a class=local_path>`), $03b25ed780fb341f$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $03b25ed780fb341f$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2>`), $03b25ed780fb341f$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list workdirs">`), $03b25ed780fb341f$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list workspaces">`), $03b25ed780fb341f$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer>`), $03b25ed780fb341f$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="highlight warning"><p>`), $03b25ed780fb341f$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $03b25ed780fb341f$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=empty>`), $03b25ed780fb341f$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=local_path>`);
const $03b25ed780fb341f$var$Workdir = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { callLocalApi: callLocalApi, connected: connected, workspaces: workspaces, workdirs: workdirs, refreshWorkdirs: refreshWorkdirs, transition: transition } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $30026173677b80c4$export$ecd60d42f6b10f45));
    const actions = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const actions = [];
        if (!props.workdir.transitioning) {
            actions.push({
                title: t('local.workdir.action.launch'),
                icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                    solid: true,
                    play: true,
                    inline: true,
                    weak: true
                }),
                onAction: async ()=>{
                    await callLocalApi('workdir_launch', {
                        workdir: props.workdir.id
                    });
                }
            });
            actions.push({
                title: t('local.workdir.action.repair'),
                icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                    solid: true,
                    hammer: true,
                    inline: true,
                    weak: true
                }),
                onAction: async ()=>{
                    await callLocalApi('workdir_repair', {
                        workdir: props.workdir.id
                    });
                }
            });
        }
        actions.push({
            title: t('local.workdir.action.delete'),
            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                solid: true,
                "trash-can": true,
                inline: true,
                weak: true
            }),
            onAction: async ()=>{
                if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                    header: t('local.workdir.delete_dialog.header'),
                    message: t('local.workdir.delete_dialog.message')((()=>{
                        var _el$ = $03b25ed780fb341f$var$_tmpl$();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>props.workdir.package_title);
                        return _el$;
                    })()),
                    ok: t('local.workdir.delete_dialog.ok'),
                    danger: true
                })) return;
                await callLocalApi('workdir_delete', {
                    workdir: props.workdir.id,
                    deleteFiles: true
                });
                refreshWorkdirs();
            },
            danger: true
        });
        return actions;
    });
    return (()=>{
        var _el$2 = $03b25ed780fb341f$var$_tmpl$3(), _el$4 = _el$2.firstChild, _el$5 = _el$4.nextSibling;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return props.workdir.package_id != null;
            },
            get children () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$2dc68d50d56fbbd), {
                    breadcrumbs: [
                        ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                get href () {
                                    return (0, $c900760615f37aa7$export$d9c91539b7b67f34)(props.workdir.project_id);
                                },
                                get children () {
                                    return props.workdir.project_title;
                                }
                            }),
                        ()=>props.workdir.branch_id ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                get href () {
                                    return (0, $c900760615f37aa7$export$5be20f864ea0a7)(props.workdir.project_id, props.workdir.branch_id);
                                },
                                get children () {
                                    return props.workdir.branch_title;
                                }
                            }) : undefined,
                        ()=>props.workdir.version_id ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                get href () {
                                    return (0, $c900760615f37aa7$export$18639e2046d399f4)({
                                        projectId: props.workdir.project_id,
                                        branchId: props.workdir.branch_id,
                                        versionId: props.workdir.version_id
                                    });
                                },
                                get children () {
                                    return props.workdir.version_title;
                                }
                            }) : undefined,
                        ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                get href () {
                                    return (0, $c900760615f37aa7$export$2950deb3882ada89)({
                                        projectId: props.workdir.project_id,
                                        branchId: props.workdir.branch_id,
                                        versionId: props.workdir.version_id,
                                        packageId: props.workdir.package_id
                                    });
                                },
                                get children () {
                                    return props.workdir.package_title;
                                }
                            })
                    ]
                });
            }
        }), _el$4);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return props.workdir?.package_id === transition()?.workdir?.package_id;
            },
            get children () {
                var _el$3 = $03b25ed780fb341f$var$_tmpl$2();
                (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$3, "max", transition()?.total));
                (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$3.value = transition()?.done);
                return _el$3;
            }
        }), _el$4);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$d5503927a7d116d), {
            get actions () {
                return actions();
            }
        }));
        _el$5.$$click = async (e)=>{
            e.preventDefault();
            e.stopPropagation();
            await callLocalApi('workdir_show_folder', props.workdir.id);
        };
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
            regular: true,
            folder: true,
            inline: true,
            weak: true
        }), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>props.workdir.local_path, null);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$5, "href", `file://${props.workdir.local_path}`));
        return _el$2;
    })();
};
const $03b25ed780fb341f$export$48fa16f53f83b086 = ()=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { callLocalApi: callLocalApi, connected: connected, workspaces: workspaces, workdirs: workdirs, refreshWorkdirs: refreshWorkdirs, transition: transition } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $30026173677b80c4$export$ecd60d42f6b10f45));
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            get title () {
                return t('local');
            },
            breadcrumb: ()=>t('local'),
            uiClass: "local"
        }),
        (()=>{
            var _el$6 = $03b25ed780fb341f$var$_tmpl$4();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t('local'));
            return _el$6;
        })(),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return connected();
            },
            get fallback () {
                return (()=>{
                    var _el$10 = $03b25ed780fb341f$var$_tmpl$9(), _el$11 = _el$10.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, ()=>t('local.app_not_detected.message'));
                    return _el$10;
                })();
            },
            get children () {
                return [
                    (()=>{
                        var _el$7 = $03b25ed780fb341f$var$_tmpl$5();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('local.workdirs'));
                        return _el$7;
                    })(),
                    (()=>{
                        var _el$8 = $03b25ed780fb341f$var$_tmpl$6();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                            get each () {
                                return workdirs();
                            },
                            get fallback () {
                                return (()=>{
                                    var _el$12 = $03b25ed780fb341f$var$_tmpl$0();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                        resource: workdirs,
                                        get empty () {
                                            return (()=>{
                                                var _el$13 = $03b25ed780fb341f$var$_tmpl$1();
                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>t('local.workdirs.empty'));
                                                return _el$13;
                                            })();
                                        }
                                    }));
                                    return _el$12;
                                })();
                            },
                            children: (workdir)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($03b25ed780fb341f$var$Workdir, {
                                    workdir: workdir
                                })
                        }));
                        return _el$8;
                    })(),
                    (()=>{
                        var _el$9 = $03b25ed780fb341f$var$_tmpl$5();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t('local.workspaces'));
                        return _el$9;
                    })(),
                    (()=>{
                        var _el$0 = $03b25ed780fb341f$var$_tmpl$7();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                            get each () {
                                return workspaces();
                            },
                            children: (workspace)=>(()=>{
                                    var _el$14 = $03b25ed780fb341f$var$_tmpl$10(), _el$15 = _el$14.firstChild;
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, ()=>workspace.local_path);
                                    return _el$14;
                                })()
                        }));
                        return _el$0;
                    })()
                ];
            }
        }),
        $03b25ed780fb341f$var$_tmpl$8()
    ];
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);










var $c635ef25c1ca39c0$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $c635ef25c1ca39c0$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><div class=label>`), $c635ef25c1ca39c0$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><div class=label></div><div class=value><input type=text>`), $c635ef25c1ca39c0$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><div class=label></div><div class=value><input type=password>`), $c635ef25c1ca39c0$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="hint weak">`), $c635ef25c1ca39c0$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="highlight warning"><p>`), $c635ef25c1ca39c0$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`);
const $c635ef25c1ca39c0$export$3237e270a2a93ea2 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [provider, setProvider] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)('itch');
    const providerInfo = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>({
            steam: {},
            itch: {
                key: true,
                isKeyValid: (key)=>/^[a-zA-Z0-9]{40}$/.test(key),
                hint: true
            }
        })[provider()]);
    const [key, setKey] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)('');
    let refTitle;
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        refTitle.value = t('me.deploy_credential.add_dialog.default_title')((0, $f3842ea939e9c33f$export$82f9ebd9adeba146).fromJSDate(new Date()).toLocaleString({
            dateStyle: 'long'
        }, {
            locale: t('locale')
        }));
    });
    const onAdd = async ()=>{
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            const credentialId = await api.postUsersMeDeployCredentials({
                requestBody: {
                    title: refTitle.value,
                    provider: provider(),
                    key: key()
                }
            });
            props.resolve(credentialId);
        });
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet small ui add_deploy_credential",
        get children () {
            return [
                (()=>{
                    var _el$ = $c635ef25c1ca39c0$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('me.deploy_credential.add_dialog.header'));
                    return _el$;
                })(),
                (()=>{
                    var _el$2 = $c635ef25c1ca39c0$var$_tmpl$2(), _el$3 = _el$2.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>t('me.deploy_credential.add_dialog.label_site'));
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                        get title () {
                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5d066e7ee5279edb), {
                                get provider () {
                                    return provider();
                                }
                            });
                        },
                        classList: {
                            value: true
                        },
                        get items () {
                            return (0, $06e3e498f7096fae$export$b7c56583b614ede0).map((provider)=>({
                                    key: provider,
                                    title: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5d066e7ee5279edb), {
                                        provider: provider
                                    })
                                }));
                        },
                        onSelect: setProvider
                    }), null);
                    return _el$2;
                })(),
                (()=>{
                    var _el$4 = $c635ef25c1ca39c0$var$_tmpl$3(), _el$5 = _el$4.firstChild, _el$6 = _el$5.nextSibling, _el$7 = _el$6.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>t('me.deploy_credential.add_dialog.label_title'));
                    var _ref$ = refTitle;
                    typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$7) : refTitle = _el$7;
                    return _el$4;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return providerInfo().key;
                    },
                    get children () {
                        var _el$8 = $c635ef25c1ca39c0$var$_tmpl$4(), _el$9 = _el$8.firstChild, _el$0 = _el$9.nextSibling, _el$1 = _el$0.firstChild;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t('me.deploy_credential.add_dialog.label_key'));
                        _el$1.$$input = (e)=>{
                            e.preventDefault();
                            setKey(e.target.value);
                        };
                        return _el$8;
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return providerInfo().hint;
                    },
                    get children () {
                        var _el$10 = $c635ef25c1ca39c0$var$_tmpl$5();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>t(`me.deploy_credential.add_dialog.hint.${provider()}`));
                        return _el$10;
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return !providerInfo().isKeyValid;
                    },
                    get children () {
                        var _el$11 = $c635ef25c1ca39c0$var$_tmpl$6(), _el$12 = _el$11.firstChild;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, ()=>t('me.deploy_credential.add_dialog.error.not_supported')(t(`deploy_credential_provider.${provider()}`)));
                        return _el$11;
                    }
                }),
                (()=>{
                    var _el$13 = $c635ef25c1ca39c0$var$_tmpl$7(), _el$14 = _el$13.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: onAdd,
                        get disabled () {
                            return !providerInfo().isKeyValid?.(key());
                        },
                        get children () {
                            return t('me.deploy_credential.add_dialog.ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        autofocus: true,
                        onClick: ()=>props.resolve(null),
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$13;
                })()
            ];
        }
    });
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "input"
]);




var $c5a8c0c33bb04031$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $c5a8c0c33bb04031$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p>`), $c5a8c0c33bb04031$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $c5a8c0c33bb04031$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $c5a8c0c33bb04031$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<button class=button>`), $c5a8c0c33bb04031$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $c5a8c0c33bb04031$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a class=profile_link target=_blank>`), $c5a8c0c33bb04031$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=profile_provider></div><div class=created></div><div class=last_used></div><div class="buttons group">`), $c5a8c0c33bb04031$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=profile_link>`), $c5a8c0c33bb04031$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="highlight warning"><p>`), $c5a8c0c33bb04031$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2><span></span><div class=buttons>`), $c5a8c0c33bb04031$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=hint>`), $c5a8c0c33bb04031$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list credentials">`), $c5a8c0c33bb04031$var$_tmpl$12 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2>`), $c5a8c0c33bb04031$var$_tmpl$13 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list sessions">`), $c5a8c0c33bb04031$var$_tmpl$14 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list deploy_credentials">`), $c5a8c0c33bb04031$var$_tmpl$15 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h3>`), $c5a8c0c33bb04031$var$_tmpl$16 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list public_credentials">`), $c5a8c0c33bb04031$var$_tmpl$17 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $c5a8c0c33bb04031$var$_tmpl$18 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=empty>`), $c5a8c0c33bb04031$var$_tmpl$19 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=current></div><div class=started></div><div class=last_auth></div><div class=buttons>`), $c5a8c0c33bb04031$var$_tmpl$20 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=started></div><div class=expiration></div><div class=buttons>`), $c5a8c0c33bb04031$var$_tmpl$21 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=title></div><div class=provider></div><div class=buttons>`), $c5a8c0c33bb04031$var$_tmpl$22 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a class=credential rel="ugc nofollow"target=_blank>`), $c5a8c0c33bb04031$var$_tmpl$23 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><input type=checkbox>`), $c5a8c0c33bb04031$var$_tmpl$24 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=credential>`);
const $c5a8c0c33bb04031$export$36fd7346460dab4b = ()=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { session: session, refetchSession: refetchSession, api: api, providers: providers, startAuth: startAuth } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [sessions, { refetch: refetchSessions }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getUsersMeSessions();
    });
    const [credentials, { refetch: refetchCredentials }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getUsersMeCredentials();
    });
    const [deployCredentials, { refetch: refetchDeployCredentials }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getUsersMeDeployCredentials();
    });
    const onMeRename = async ()=>{
        const title = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$a551a871839880f9), {
            size: 'small',
            header: t('me.rename_dialog.header'),
            label: t('me.rename_dialog.label_title'),
            value: session()?.userInfo?.title ?? '',
            ok: t('me.rename_dialog.ok')
        });
        if (title !== undefined) {
            await api.patchUsersMe({
                requestBody: {
                    title: title
                }
            });
            refetchSession();
        }
    };
    const DialogLinkCredential = (props)=>{
        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
            "class": "sheet small ui link_credential",
            get children () {
                return [
                    (()=>{
                        var _el$ = $c5a8c0c33bb04031$var$_tmpl$();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('me.credential.link_dialog.header'));
                        return _el$;
                    })(),
                    (()=>{
                        var _el$2 = $c5a8c0c33bb04031$var$_tmpl$2();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('me.credential.link_dialog.message'));
                        return _el$2;
                    })(),
                    (()=>{
                        var _el$3 = $c5a8c0c33bb04031$var$_tmpl$3();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                            each: providers,
                            children: (provider)=>(()=>{
                                    var _el$6 = $c5a8c0c33bb04031$var$_tmpl$5();
                                    _el$6.$$click = props.resolve;
                                    _el$6.$$clickData = provider;
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$b56300d3452a4bc6), {
                                        provider: provider
                                    }));
                                    return _el$6;
                                })()
                        }));
                        return _el$3;
                    })(),
                    (()=>{
                        var _el$4 = $c5a8c0c33bb04031$var$_tmpl$4(), _el$5 = _el$4.firstChild;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                            autofocus: true,
                            onClick: ()=>props.resolve(null),
                            get children () {
                                return t('cancel');
                            }
                        }));
                        return _el$4;
                    })()
                ];
            }
        });
    };
    const onLinkCredential = async ()=>{
        const provider = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)(DialogLinkCredential, {});
        if (provider) startAuth(provider, 'link');
    };
    const onUnlinkCredential = async (credential)=>{
        if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
            header: t('me.credential.unlink_dialog.header'),
            message: t('me.credential.unlink_dialog.are_you_sure')((()=>{
                var _el$7 = $c5a8c0c33bb04031$var$_tmpl$6();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t(`auth.provider.${credential.provider}`));
                return _el$7;
            })(), (()=>{
                var _el$8 = $c5a8c0c33bb04031$var$_tmpl$6();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>credential.title);
                return _el$8;
            })()),
            ok: t('me.credential.unlink_dialog.ok'),
            focus: 'cancel',
            danger: true
        })) return;
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            await api.deleteUsersMeCredentials(credential);
            refetchCredentials();
        });
    };
    const onChangeCredentialIsAuth = async (credential, isAuth)=>{
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            await api.patchUsersMeCredentials({
                provider: credential.provider,
                name: credential.name,
                requestBody: {
                    isAuth: isAuth
                }
            });
            refetchCredentials();
        });
    };
    const onChangeCredentialIsPublic = async (credential, isPublic)=>{
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            await api.patchUsersMeCredentials({
                provider: credential.provider,
                name: credential.name,
                requestBody: {
                    isPublic: isPublic
                }
            });
            refetchCredentials();
        });
    };
    const CredentialItem = (credential)=>(()=>{
            var _el$9 = $c5a8c0c33bb04031$var$_tmpl$8(), _el$1 = _el$9.firstChild, _el$10 = _el$1.nextSibling, _el$11 = _el$10.nextSibling, _el$12 = _el$11.nextSibling;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                get when () {
                    return credential.profilePictureUrl;
                },
                get children () {
                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$ef7152bf8efb10e8), {
                        get provider () {
                            return credential.provider;
                        },
                        get url () {
                            return credential.profilePictureUrl;
                        },
                        "class": "profile_picture",
                        get alt () {
                            return t('me.credentials.profile_picture.alt')(credential.provider);
                        }
                    });
                }
            }), _el$1);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                get when () {
                    return credential.profileUrl;
                },
                get fallback () {
                    return (()=>{
                        var _el$13 = $c5a8c0c33bb04031$var$_tmpl$9();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>credential.title);
                        return _el$13;
                    })();
                },
                get children () {
                    var _el$0 = $c5a8c0c33bb04031$var$_tmpl$7();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>credential.title);
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$0, "href", credential.profileUrl));
                    return _el$0;
                }
            }), _el$1);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$b56300d3452a4bc6), {
                get provider () {
                    return credential.provider;
                }
            }), null);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                get when () {
                    return credential.isAuth;
                },
                get fallback () {
                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        solid: true,
                        inline: true,
                        weak: true,
                        hand: true
                    });
                },
                get children () {
                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        solid: true,
                        inline: true,
                        weak: true,
                        key: true
                    });
                }
            }), null);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                get when () {
                    return credential.isPublic;
                },
                get children () {
                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                        solid: true,
                        inline: true,
                        weak: true,
                        eye: true
                    });
                }
            }), null);
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>t('me.credentials.created')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                    get date () {
                        return new Date(credential.created);
                    }
                })));
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, ()=>t('me.credentials.last_used')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                    get date () {
                        return new Date(credential.lastUsed);
                    }
                })));
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$d5503927a7d116d), {
                get actions () {
                    return [
                        {
                            title: t('me.credential.unlink'),
                            onAction: ()=>onUnlinkCredential(credential),
                            danger: true
                        },
                        {
                            title: t(credential.isAuth ? 'me.credential.disallow_auth' : 'me.credential.allow_auth'),
                            icon: credential.isAuth ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                solid: true,
                                inline: true,
                                hand: true
                            }) : (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                solid: true,
                                inline: true,
                                key: true
                            }),
                            onAction: ()=>onChangeCredentialIsAuth(credential, !credential.isAuth)
                        },
                        ...credential.isPublic || credential.profileUrl ? [
                            {
                                title: t(credential.isPublic ? 'me.credential.dont_display_publicly' : 'me.credential.display_publicly'),
                                icon: credential.isPublic ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                    solid: true,
                                    inline: true,
                                    "eye-slash": true
                                }) : (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                    solid: true,
                                    inline: true,
                                    eye: true
                                }),
                                onAction: ()=>onChangeCredentialIsPublic(credential, !credential.isPublic)
                            }
                        ] : []
                    ];
                }
            }));
            return _el$9;
        })();
    const onDeleteSession = async (apiKeyId)=>{
        if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
            header: t('me.sessions.delete_dialog.header'),
            message: t('me.sessions.delete_dialog.message'),
            ok: t('me.sessions.delete_dialog.ok'),
            focus: 'cancel',
            danger: true
        })) return;
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            await api.deleteUsersMeSessions({
                session: apiKeyId
            });
            refetchSessions();
        });
    };
    const onCreateApiKey = async ()=>{
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            const newUserSession = await api.postUsersMeSessions({
                requestBody: {
                }
            });
            await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$84a13477b53beb51), {
                header: t('me.api_tokens.create_dialog.header'),
                message: t('me.api_tokens.create_dialog.message'),
                text: newUserSession.token,
                note: t('me.api_tokens.create_dialog.note')
            });
            refetchSessions();
        });
    };
    const onDeleteApiKey = async (apiKeyId)=>{
        if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
            header: t('me.api_tokens.delete_dialog.header'),
            message: t('me.api_tokens.delete_dialog.message'),
            ok: t('me.api_tokens.delete_dialog.ok'),
            focus: 'cancel',
            danger: true
        })) return;
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            await api.deleteUsersMeSessions({
                session: apiKeyId
            });
            refetchSessions();
        });
    };
    const onAddDeployCredential = async ()=>{
        const credentialId = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $c635ef25c1ca39c0$export$3237e270a2a93ea2), {});
        if (credentialId) refetchDeployCredentials();
    };
    const onDeleteDeployCredential = async (deployCredential)=>{
        if (await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
            header: t('me.deploy_credential.delete_dialog.header'),
            message: t('me.deploy_credential.delete_dialog.message')((()=>{
                var _el$14 = $c5a8c0c33bb04031$var$_tmpl$6();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, ()=>deployCredential.title);
                return _el$14;
            })(), (()=>{
                var _el$15 = $c5a8c0c33bb04031$var$_tmpl$6();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, ()=>t(`deploy_credential_provider.${deployCredential.provider}`));
                return _el$15;
            })()),
            ok: t('me.deploy_credential.delete_dialog.ok'),
            focus: 'cancel',
            danger: true
        })) {
            await api.deleteUsersMeDeployCredentials({
                deployCredential: deployCredential.id
            });
            refetchDeployCredentials();
        }
    };
    const onMeAction = async (key)=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            switch(key){
                case 'delete':
                    if (await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                        header: t('me.delete.dialog.header'),
                        message: t('me.delete.dialog.message')((()=>{
                            var _el$16 = $c5a8c0c33bb04031$var$_tmpl$6();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, ()=>session()?.userInfo?.title);
                            return _el$16;
                        })()),
                        ok: t('me.delete.dialog.ok'),
                        focus: 'cancel',
                        danger: true
                    })) {
                        await api.deleteUsersMe();
                        window.location.href = (0, $c900760615f37aa7$export$77c015370703bac0);
                    }
                    break;
            }
        });
    const credentialsAuthAllowed = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>credentials()?.filter((credential)=>credential.isAuth));
    const credentialsAuthDisallowed = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>credentials()?.filter((credential)=>!credential.isAuth));
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            get title () {
                return t('me');
            },
            breadcrumb: ()=>t('me'),
            uiClass: "me"
        }),
        (()=>{
            var _el$17 = $c5a8c0c33bb04031$var$_tmpl$();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, ()=>session()?.userInfo?.title);
            return _el$17;
        })(),
        (()=>{
            var _el$18 = $c5a8c0c33bb04031$var$_tmpl$3();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$18, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                onClick: onMeRename,
                get children () {
                    return t('me.rename');
                }
            }));
            return _el$18;
        })(),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return credentialsAuthAllowed()?.length === 0;
            },
            get children () {
                var _el$19 = $c5a8c0c33bb04031$var$_tmpl$0(), _el$20 = _el$19.firstChild;
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, ()=>t('me.credentials.empty.auth_allowed.warning'));
                return _el$19;
            }
        }),
        (()=>{
            var _el$21 = $c5a8c0c33bb04031$var$_tmpl$1(), _el$22 = _el$21.firstChild, _el$23 = _el$22.nextSibling;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$22, ()=>t('me.credentials'));
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$23, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                onClick: onLinkCredential,
                get children () {
                    return [
                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            solid: true,
                            plus: true,
                            inline: true,
                            weak: true
                        }),
                        (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('me.credential.link'))
                    ];
                }
            }));
            return _el$21;
        })(),
        (()=>{
            var _el$24 = $c5a8c0c33bb04031$var$_tmpl$10();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$24, ()=>t('me.credentials.hint.auth_allowed'));
            return _el$24;
        })(),
        (()=>{
            var _el$25 = $c5a8c0c33bb04031$var$_tmpl$11();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$25, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                get each () {
                    return credentialsAuthAllowed();
                },
                get fallback () {
                    return (()=>{
                        var _el$47 = $c5a8c0c33bb04031$var$_tmpl$17();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$47, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                            resource: credentials,
                            get empty () {
                                return (()=>{
                                    var _el$48 = $c5a8c0c33bb04031$var$_tmpl$18();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$48, ()=>t('me.credentials.empty'));
                                    return _el$48;
                                })();
                            }
                        }));
                        return _el$47;
                    })();
                },
                children: CredentialItem
            }));
            return _el$25;
        })(),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return credentialsAuthDisallowed()?.length ?? 0;
            },
            get children () {
                return [
                    (()=>{
                        var _el$26 = $c5a8c0c33bb04031$var$_tmpl$10();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$26, ()=>t('me.credentials.hint.auth_disallowed'));
                        return _el$26;
                    })(),
                    (()=>{
                        var _el$27 = $c5a8c0c33bb04031$var$_tmpl$11();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$27, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                            get each () {
                                return credentialsAuthDisallowed();
                            },
                            children: CredentialItem
                        }));
                        return _el$27;
                    })()
                ];
            }
        }),
        (()=>{
            var _el$28 = $c5a8c0c33bb04031$var$_tmpl$12();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$28, ()=>t('me.sessions'));
            return _el$28;
        })(),
        (()=>{
            var _el$29 = $c5a8c0c33bb04031$var$_tmpl$10();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$29, ()=>t('me.sessions.hint'));
            return _el$29;
        })(),
        (()=>{
            var _el$30 = $c5a8c0c33bb04031$var$_tmpl$13();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$30, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                get each () {
                    return sessions()?.filter((session)=>session.requireSession);
                },
                get fallback () {
                    return (()=>{
                        var _el$49 = $c5a8c0c33bb04031$var$_tmpl$17();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$49, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                            resource: sessions,
                            get empty () {
                                return (()=>{
                                    var _el$50 = $c5a8c0c33bb04031$var$_tmpl$18();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$50, ()=>t('me.sessions.empty'));
                                    return _el$50;
                                })();
                            }
                        }));
                        return _el$49;
                    })();
                },
                children: (userSession)=>(()=>{
                        var _el$51 = $c5a8c0c33bb04031$var$_tmpl$19(), _el$52 = _el$51.firstChild, _el$53 = _el$52.nextSibling, _el$54 = _el$53.nextSibling, _el$55 = _el$54.nextSibling;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$51, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            solid: true,
                            "id-card": true,
                            "fa-2xl": true
                        }), _el$52);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$52, (()=>{
                            var _c$ = (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>userSession.id == session()?.id);
                            return ()=>_c$() ? t('me.sessions.current') : null;
                        })());
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$53, ()=>t('me.sessions.started')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                get date () {
                                    return new Date(userSession.started);
                                }
                            })));
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$54, (()=>{
                            var _c$2 = (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!userSession.lastAuth);
                            return ()=>_c$2() ? t('me.sessions.last_auth')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                    get date () {
                                        return new Date(userSession.lastAuth);
                                    }
                                })) : null;
                        })());
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$55, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                            onClick: ()=>onDeleteSession(userSession.id),
                            danger: true,
                            get children () {
                                return t('me.sessions.delete');
                            }
                        }));
                        return _el$51;
                    })()
            }));
            return _el$30;
        })(),
        (()=>{
            var _el$31 = $c5a8c0c33bb04031$var$_tmpl$1(), _el$32 = _el$31.firstChild, _el$33 = _el$32.nextSibling;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$32, ()=>t('me.api_tokens'));
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$33, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                onClick: onCreateApiKey,
                get children () {
                    return [
                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            solid: true,
                            plus: true,
                            inline: true,
                            weak: true
                        }),
                        (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('me.api_tokens.create'))
                    ];
                }
            }));
            return _el$31;
        })(),
        (()=>{
            var _el$34 = $c5a8c0c33bb04031$var$_tmpl$10();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$34, ()=>t('me.api_tokens.hint'));
            return _el$34;
        })(),
        (()=>{
            var _el$35 = $c5a8c0c33bb04031$var$_tmpl$13();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$35, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                get each () {
                    return sessions()?.filter((session)=>!session.requireSession);
                },
                get fallback () {
                    return (()=>{
                        var _el$56 = $c5a8c0c33bb04031$var$_tmpl$17();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$56, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                            resource: sessions,
                            get empty () {
                                return (()=>{
                                    var _el$57 = $c5a8c0c33bb04031$var$_tmpl$18();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$57, ()=>t('me.api_tokens.empty'));
                                    return _el$57;
                                })();
                            }
                        }));
                        return _el$56;
                    })();
                },
                children: (userSession)=>(()=>{
                        var _el$58 = $c5a8c0c33bb04031$var$_tmpl$20(), _el$59 = _el$58.firstChild, _el$60 = _el$59.nextSibling, _el$61 = _el$60.nextSibling;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$58, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            solid: true,
                            key: true,
                            "fa-2xl": true
                        }), _el$59);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$59, ()=>t('me.api_tokens.started')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                get date () {
                                    return new Date(userSession.started);
                                }
                            })));
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$60, (()=>{
                            var _c$3 = (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!userSession.expiration);
                            return ()=>_c$3() ? t('me.api_tokens.expires')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                    get date () {
                                        return new Date(userSession.expiration);
                                    }
                                })) : t('me.api_tokens.no_expiration');
                        })());
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$61, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                            onClick: ()=>onDeleteApiKey(userSession.id),
                            danger: true,
                            get children () {
                                return t('me.api_tokens.delete');
                            }
                        }));
                        return _el$58;
                    })()
            }));
            return _el$35;
        })(),
        (()=>{
            var _el$36 = $c5a8c0c33bb04031$var$_tmpl$1(), _el$37 = _el$36.firstChild, _el$38 = _el$37.nextSibling;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$37, ()=>t('me.deploy_credentials'));
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$38, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                onClick: onAddDeployCredential,
                get children () {
                    return [
                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            solid: true,
                            plus: true,
                            inline: true,
                            weak: true
                        }),
                        (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('me.deploy_credential.add'))
                    ];
                }
            }));
            return _el$36;
        })(),
        (()=>{
            var _el$39 = $c5a8c0c33bb04031$var$_tmpl$10();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$39, ()=>t('me.deploy_credentials.hint'));
            return _el$39;
        })(),
        (()=>{
            var _el$40 = $c5a8c0c33bb04031$var$_tmpl$14();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$40, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                get each () {
                    return deployCredentials();
                },
                get fallback () {
                    return (()=>{
                        var _el$62 = $c5a8c0c33bb04031$var$_tmpl$17();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$62, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                            resource: deployCredentials,
                            get empty () {
                                return (()=>{
                                    var _el$63 = $c5a8c0c33bb04031$var$_tmpl$18();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$63, ()=>t('me.deploy_credentials.empty'));
                                    return _el$63;
                                })();
                            }
                        }));
                        return _el$62;
                    })();
                },
                children: (deployCredential)=>(()=>{
                        var _el$64 = $c5a8c0c33bb04031$var$_tmpl$21(), _el$65 = _el$64.firstChild, _el$66 = _el$65.nextSibling, _el$67 = _el$66.nextSibling;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$64, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$d3ea39a55c5c7a6e), {
                            get provider () {
                                return deployCredential.provider;
                            },
                            big: true
                        }), _el$65);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$65, ()=>deployCredential.title);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$66, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5d066e7ee5279edb), {
                            icon: false,
                            get provider () {
                                return deployCredential.provider;
                            }
                        }));
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$67, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                            danger: true,
                            onClick: ()=>onDeleteDeployCredential(deployCredential),
                            get children () {
                                return t('me.deploy_credential.delete');
                            }
                        }));
                        return _el$64;
                    })()
            }));
            return _el$40;
        })(),
        (()=>{
            var _el$41 = $c5a8c0c33bb04031$var$_tmpl$12();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$41, ()=>t('me.public_profile'));
            return _el$41;
        })(),
        (()=>{
            var _el$42 = $c5a8c0c33bb04031$var$_tmpl$15();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$42, ()=>t('me.public_profile.public_credentials'));
            return _el$42;
        })(),
        (()=>{
            var _el$43 = $c5a8c0c33bb04031$var$_tmpl$10();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$43, ()=>t('me.public_profile.public_credentials.hint'));
            return _el$43;
        })(),
        (()=>{
            var _el$44 = $c5a8c0c33bb04031$var$_tmpl$16();
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$44, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                get each () {
                    return credentials()?.filter((credential)=>credential.isPublic || credential.profileUrl);
                },
                get fallback () {
                    return (()=>{
                        var _el$68 = $c5a8c0c33bb04031$var$_tmpl$17();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$68, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                            resource: credentials,
                            get empty () {
                                return (()=>{
                                    var _el$69 = $c5a8c0c33bb04031$var$_tmpl$18();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$69, ()=>t('me.credentials.empty'));
                                    return _el$69;
                                })();
                            }
                        }));
                        return _el$68;
                    })();
                },
                children: (credential)=>(()=>{
                        var _el$70 = $c5a8c0c33bb04031$var$_tmpl$23(), _el$71 = _el$70.firstChild;
                        _el$71.$$click = (e)=>onChangeCredentialIsPublic(credential, e.currentTarget.checked);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$70, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                            get when () {
                                return credential.profileUrl;
                            },
                            get fallback () {
                                return (()=>{
                                    var _el$73 = $c5a8c0c33bb04031$var$_tmpl$24();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$73, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$b56300d3452a4bc6), {
                                        get provider () {
                                            return credential.provider;
                                        }
                                    }));
                                    return _el$73;
                                })();
                            },
                            get children () {
                                var _el$72 = $c5a8c0c33bb04031$var$_tmpl$22();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$72, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$b56300d3452a4bc6), {
                                    get provider () {
                                        return credential.provider;
                                    }
                                }));
                                (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$72, "href", credential.profileUrl));
                                return _el$72;
                            }
                        }), null);
                        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$71.checked = credential.isPublic);
                        return _el$70;
                    })()
            }));
            return _el$44;
        })(),
        (()=>{
            var _el$45 = $c5a8c0c33bb04031$var$_tmpl$4(), _el$46 = _el$45.firstChild;
            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$46, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                get title () {
                    return t('me.manage');
                },
                get items () {
                    return [
                        {
                            key: 'delete',
                            title: t('me.delete'),
                            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                regular: true,
                                "trash-can": true,
                                inline: true,
                                weak: true
                            }),
                            danger: true
                        }
                    ];
                },
                onSelect: onMeAction
            }));
            return _el$45;
        })()
    ];
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);




var $9DGpR = parcelRequire("9DGpR");









var $47e9739db5f31991$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span>`), $47e9739db5f31991$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $47e9739db5f31991$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $47e9739db5f31991$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><div class=label>`), $47e9739db5f31991$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><div class=label></div><div class=value><input class=value type=text>`), $47e9739db5f31991$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $47e9739db5f31991$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $47e9739db5f31991$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=title>`), $47e9739db5f31991$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=url>`);
const $47e9739db5f31991$export$25a15dedccd726b7 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [deployCredentials, { refetch: refetchDeployCredentials }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getUsersMeDeployCredentials();
    });
    const [selectedDeployCredential, setSelectedDeployCredential] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const deployCredentialTitle = (deployCredential)=>deployCredential && [
            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$d3ea39a55c5c7a6e), {
                get provider () {
                    return deployCredential.provider;
                }
            }),
            (()=>{
                var _el$ = $47e9739db5f31991$var$_tmpl$();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>deployCredential.title);
                return _el$;
            })()
        ];
    const onSelectDeployCredential = async (deployCredential)=>{
        if (deployCredential) setSelectedDeployCredential((currentDeployCredential)=>{
            // reset site on credential change
            if (currentDeployCredential != deployCredential) setSiteURL('');
            return deployCredential;
        });
        else {
            const deployCredentialId = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $c635ef25c1ca39c0$export$3237e270a2a93ea2), {});
            if (!deployCredentialId) return;
            await refetchDeployCredentials();
            const deployCredential = deployCredentials()?.find((deployCredential)=>deployCredential.id == deployCredentialId);
            if (!deployCredential) return;
            setSelectedDeployCredential(deployCredential);
        }
    };
    const [deployCredentialAvailableSites] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(selectedDeployCredential, async (deployCredential)=>{
        if (!deployCredential) return null;
        return Object.fromEntries((await api.getUsersMeDeployCredentialsAvailableSites({
            deployCredential: deployCredential.id
        })).map((site)=>[
                site.id,
                site
            ]));
    });
    const [siteURL, setSiteURL] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)('');
    const selectedAvailableSite = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>(deployCredentialAvailableSites() ?? {})[siteURL()]);
    const info = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const info = (0, $06e3e498f7096fae$export$bada93f69d30c1d6)[selectedDeployCredential()?.provider ?? ''];
        if (!info) return null;
        return {
            placeholder: info.siteInputPlaceholder,
            site: info.fromSiteInput(siteURL())
        };
    });
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui small add_deploy_site",
        get children () {
            return [
                (()=>{
                    var _el$2 = $47e9739db5f31991$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('deploy_sites.add_dialog.header'));
                    return _el$2;
                })(),
                (()=>{
                    var _el$3 = $47e9739db5f31991$var$_tmpl$3();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>t('deploy_sites.add_dialog.message')((()=>{
                            var _el$12 = $47e9739db5f31991$var$_tmpl$7();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, ()=>props.project.title);
                            return _el$12;
                        })()));
                    return _el$3;
                })(),
                (()=>{
                    var _el$4 = $47e9739db5f31991$var$_tmpl$4(), _el$5 = _el$4.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>t('deploy_sites.add_dialog.label_credential'));
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                        classList: {
                            value: true
                        },
                        get title () {
                            return deployCredentialTitle(selectedDeployCredential()) ?? t('deploy_sites.add_dialog.select_credential');
                        },
                        get items () {
                            return [
                                ...deployCredentials()?.map((deployCredential)=>({
                                        key: deployCredential,
                                        title: deployCredentialTitle(deployCredential)
                                    })) ?? [],
                                {
                                    key: null,
                                    title: t('deploy_sites.add_dialog.select_credential.new')
                                }
                            ];
                        },
                        onSelect: onSelectDeployCredential
                    }), null);
                    return _el$4;
                })(),
                (()=>{
                    var _el$6 = $47e9739db5f31991$var$_tmpl$4(), _el$7 = _el$6.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('deploy_sites.add_dialog.label_select_site'));
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                        classList: {
                            value: true
                        },
                        menuClassList: {
                            available_deploy_sites: true
                        },
                        get title () {
                            return selectedAvailableSite()?.title ?? (selectedDeployCredential() ? t('deploy_sites.add_dialog.select_site') : t('deploy_sites.add_dialog.select_credential_first'));
                        },
                        get items () {
                            return Object.entries(deployCredentialAvailableSites() ?? {}).sort(([_a, a], [_b, b])=>new Intl.Collator(t('locale')).compare(a.title, b.title)).map(([_siteId, site])=>({
                                    key: site.id,
                                    title: [
                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                            get when () {
                                                return site.pictureUrl;
                                            },
                                            get children () {
                                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$ef7152bf8efb10e8), {
                                                    "class": "picture",
                                                    get provider () {
                                                        return selectedDeployCredential().provider;
                                                    },
                                                    get url () {
                                                        return site.pictureUrl;
                                                    }
                                                });
                                            }
                                        }),
                                        (()=>{
                                            var _el$13 = $47e9739db5f31991$var$_tmpl$8();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>site.title);
                                            return _el$13;
                                        })(),
                                        (()=>{
                                            var _el$14 = $47e9739db5f31991$var$_tmpl$9();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, ()=>site.id);
                                            return _el$14;
                                        })()
                                    ]
                                })) || [];
                        },
                        get fallback () {
                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                resource: deployCredentialAvailableSites
                            });
                        },
                        onSelect: (siteId)=>setSiteURL(siteId),
                        get disabled () {
                            return !selectedDeployCredential();
                        }
                    }), null);
                    return _el$6;
                })(),
                (()=>{
                    var _el$8 = $47e9739db5f31991$var$_tmpl$5(), _el$9 = _el$8.firstChild, _el$0 = _el$9.nextSibling, _el$1 = _el$0.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t('deploy_sites.add_dialog.label_enter_site'));
                    _el$1.$$input = (e)=>{
                        setSiteURL(e.target.value);
                    };
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$1, "placeholder", info()?.placeholder));
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$1.value = siteURL());
                    return _el$8;
                })(),
                (()=>{
                    var _el$10 = $47e9739db5f31991$var$_tmpl$6(), _el$11 = _el$10.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        get disabled () {
                            return selectedDeployCredential() == null || !info()?.site;
                        },
                        onClick: async ()=>{
                            await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                const deploySiteId = await api.postProjectsDeploySites({
                                    project: props.project.id,
                                    requestBody: {
                                        credential: selectedDeployCredential().id,
                                        site: info().site
                                    }
                                });
                                props.resolve(deploySiteId);
                            });
                        },
                        get children () {
                            return t('deploy_sites.add_dialog.ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(),
                        autofocus: true,
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$10;
                })()
            ];
        }
    });
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "input"
]);








var $62639f3fbb14edb2$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span>`), $62639f3fbb14edb2$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $62639f3fbb14edb2$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $62639f3fbb14edb2$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $62639f3fbb14edb2$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label><div class=label>`), $62639f3fbb14edb2$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list packages">`), $62639f3fbb14edb2$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="message weak">`), $62639f3fbb14edb2$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message><span>`), $62639f3fbb14edb2$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $62639f3fbb14edb2$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $62639f3fbb14edb2$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=job>`), $62639f3fbb14edb2$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=channel>`), $62639f3fbb14edb2$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=title>`);
const $62639f3fbb14edb2$export$4fdc2171a142cc2c = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [deploySites, { refetch: refetchDeploySites }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getProjectsDeploySites({
            project: props.project.id
        });
    });
    const [versionPackages] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getProjectsVersionsPackages({
            project: props.project.id,
            version: props.version.id
        });
    });
    const [selectedDeploySite, setSelectedDeploySite] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const deploySiteTitle = (deploySite)=>deploySite && [
            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$d3ea39a55c5c7a6e), {
                get provider () {
                    return deploySite.provider;
                }
            }),
            (()=>{
                var _el$ = $62639f3fbb14edb2$var$_tmpl$();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>(0, $06e3e498f7096fae$export$bada93f69d30c1d6)[deploySite.provider].siteTitle(deploySite.site));
                return _el$;
            })()
        ];
    const onSelectDeploySite = async (deploySite)=>{
        if (deploySite) setSelectedDeploySite(deploySite);
        else {
            const deploySiteId = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $47e9739db5f31991$export$25a15dedccd726b7), {
                project: props.project
            });
            if (!deploySiteId) return;
            await refetchDeploySites();
            const deploySite = deploySites()?.find((deploySite)=>deploySite.id == deploySiteId);
            if (!deploySite) return;
            setSelectedDeploySite(deploySite);
        }
    };
    const deployInfo = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const deploySite = selectedDeploySite();
        if (!deploySite) return null;
        const packageMapFunc = (()=>{
            switch(deploySite.provider){
                case 'itch':
                    return (pkg)=>{
                        const channel = pkg.tags.toSorted((0, $9cb6667deff6c421$export$9b33fb7751632f7d)).map((tag)=>tag.split(':').at(-1)).join('-') || 'default';
                        return [
                            {
                                id: pkg.id,
                                title: pkg.title,
                                size: pkg.size,
                                channel: channel,
                                channelTitle: `${(0, $06e3e498f7096fae$export$bada93f69d30c1d6).itch.siteTitle(deploySite.site)}:${channel}`
                            }
                        ];
                    };
                default:
                    return null;
            }
        })();
        if (!packageMapFunc) return null;
        const packages = versionPackages();
        if (!packages) return null;
        return {
            deploySite: deploySite,
            packages: [].concat(...packages.map(packageMapFunc))
        };
    });
    const errorInfo = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const info = deployInfo();
        if (!info) return null;
        if (!info.packages.length) return t('deploy_to_site_dialog.error.no_packages');
        const channelsPackagesTitles = new Map();
        for (const pkg of info.packages){
            const channelPackagesTitles = channelsPackagesTitles.get(pkg.channel) ?? [];
            channelPackagesTitles.push(pkg.title);
            channelsPackagesTitles.set(pkg.channel, channelPackagesTitles);
        }
        for (const [channel, packagesTitles] of channelsPackagesTitles){
            if (packagesTitles.length > 1) return t('deploy_to_site_dialog.error.non_unique_channels')({
                packagesCount: packagesTitles.length,
                packagesCountText: (()=>{
                    var _el$2 = $62639f3fbb14edb2$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>packagesTitles.length);
                    return _el$2;
                })(),
                channel: (()=>{
                    var _el$3 = $62639f3fbb14edb2$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, channel);
                    return _el$3;
                })()
            });
        }
        return null;
    });
    const [isDeploying, setIsDeploying] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(false);
    const [deployJobsStates, setDeployJobsStates] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)();
    const isFinished = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const states = deployJobsStates();
        if (states === undefined) return false;
        return states.every((state)=>state().output !== undefined);
    });
    const onDeployOrClose = async ()=>{
        if (isFinished()) {
            props.resolve(true);
            return;
        }
        const info = deployInfo();
        if (!info) return;
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            setIsDeploying(true);
            setDeployJobsStates(await (0, $d542c09ca8fd8013$export$e702be3367c4e877)(await api.postProjectsVersionsDeploy({
                project: props.project.id,
                version: props.version.id,
                requestBody: {
                    site: info.deploySite.id,
                    packages: info.packages.map((pkg)=>({
                            package: pkg.id,
                            channel: pkg.channel
                        }))
                }
            })));
        });
    };
    const DeployJobProgress = (props)=>(0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t(`deploy_to_site_dialog.job.${props.deployJobState.output !== undefined ? props.deployJobState.output?.ok ? 'succeeded' : 'errored' : props.deployJobState.progress ?? 'queued'}`));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui big deploy_to_site",
        get children () {
            return [
                (()=>{
                    var _el$4 = $62639f3fbb14edb2$var$_tmpl$3();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>t('deploy_to_site_dialog.header'));
                    return _el$4;
                })(),
                (()=>{
                    var _el$5 = $62639f3fbb14edb2$var$_tmpl$4();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>t('deploy_to_site_dialog.message')((()=>{
                            var _el$12 = $62639f3fbb14edb2$var$_tmpl$2();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, ()=>props.project.title);
                            return _el$12;
                        })(), (()=>{
                            var _el$13 = $62639f3fbb14edb2$var$_tmpl$2();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>props.version.title);
                            return _el$13;
                        })()));
                    return _el$5;
                })(),
                (()=>{
                    var _el$6 = $62639f3fbb14edb2$var$_tmpl$5(), _el$7 = _el$6.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('deploy_to_site_dialog.label_site'));
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                        classList: {
                            value: true
                        },
                        get title () {
                            return deploySiteTitle(selectedDeploySite()) ?? t('deploy_to_site_dialog.select_site');
                        },
                        get items () {
                            return [
                                ...deploySites()?.map((deploySite)=>({
                                        key: deploySite,
                                        title: deploySiteTitle(deploySite)
                                    })) ?? [],
                                {
                                    key: null,
                                    title: t('deploy_to_site_dialog.select_site.new')
                                }
                            ];
                        },
                        onSelect: onSelectDeploySite,
                        get disabled () {
                            return isDeploying();
                        }
                    }), null);
                    return _el$6;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return selectedDeploySite();
                    },
                    get children () {
                        return [
                            (()=>{
                                var _el$8 = $62639f3fbb14edb2$var$_tmpl$6();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                    get each () {
                                        return deployInfo()?.packages;
                                    },
                                    get fallback () {
                                        return (()=>{
                                            var _el$14 = $62639f3fbb14edb2$var$_tmpl$0();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                resource: versionPackages
                                            }));
                                            return _el$14;
                                        })();
                                    },
                                    children: (pkg, packageIndex)=>(()=>{
                                            var _el$15 = $62639f3fbb14edb2$var$_tmpl$10(), _el$17 = _el$15.firstChild;
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return deployJobsStates();
                                                },
                                                get fallback () {
                                                    return (()=>{
                                                        var _el$18 = $62639f3fbb14edb2$var$_tmpl$11();
                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$18, ()=>pkg.title);
                                                        return _el$18;
                                                    })();
                                                },
                                                get children () {
                                                    var _el$16 = $62639f3fbb14edb2$var$_tmpl$1();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(DeployJobProgress, {
                                                        get deployJobState () {
                                                            return deployJobsStates()[packageIndex()]();
                                                        }
                                                    }));
                                                    return _el$16;
                                                }
                                            }), _el$17);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                                get size () {
                                                    return pkg.size;
                                                }
                                            }), _el$17);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                solid: true,
                                                "right-long": true,
                                                weak: true
                                            }), _el$17);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$d3ea39a55c5c7a6e), {
                                                get provider () {
                                                    return selectedDeploySite().provider;
                                                }
                                            }), null);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, ()=>pkg.channelTitle, null);
                                            return _el$15;
                                        })()
                                }));
                                return _el$8;
                            })(),
                            (()=>{
                                var _el$9 = $62639f3fbb14edb2$var$_tmpl$7();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t(`deploy_to_site_dialog.packages.message.${selectedDeploySite().provider}`));
                                return _el$9;
                            })()
                        ];
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return errorInfo();
                    },
                    get children () {
                        var _el$0 = $62639f3fbb14edb2$var$_tmpl$8(), _el$1 = _el$0.firstChild;
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                            solid: true,
                            "triangle-exclamation": true,
                            error: true,
                            inline: true
                        }), _el$1);
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, errorInfo);
                        return _el$0;
                    }
                }),
                (()=>{
                    var _el$10 = $62639f3fbb14edb2$var$_tmpl$9(), _el$11 = _el$10.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        get disabled () {
                            return selectedDeploySite() == null || errorInfo() != null || isDeploying() && !isFinished();
                        },
                        onClick: onDeployOrClose,
                        get children () {
                            return t(isFinished() ? 'deploy_to_site_dialog.close' : 'deploy_to_site_dialog.deploy');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(false),
                        autofocus: true,
                        get disabled () {
                            return isDeploying();
                        },
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$10;
                })()
            ];
        }
    });
};




var $9DGpR = parcelRequire("9DGpR");


var $eb92de567b07383b$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $eb92de567b07383b$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p>`), $eb92de567b07383b$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $eb92de567b07383b$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`);
const $eb92de567b07383b$export$ac808de93d2f334b = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [tags, setTags] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((0, $9DGpR.Set)(props.pkg.tags));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui big edit_package_tags",
        get children () {
            return [
                (()=>{
                    var _el$ = $eb92de567b07383b$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('packages.edit_tags_dialog.header'));
                    return _el$;
                })(),
                (()=>{
                    var _el$2 = $eb92de567b07383b$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('packages.edit_tags_dialog.message')((()=>{
                            var _el$5 = $eb92de567b07383b$var$_tmpl$4();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>props.pkg.title);
                            return _el$5;
                        })()));
                    return _el$2;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$4b94e81825be0936), {
                    tags: tags,
                    setTags: setTags,
                    compact: false
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
                    get tags () {
                        return tags();
                    },
                    showCodes: true
                }),
                (()=>{
                    var _el$3 = $eb92de567b07383b$var$_tmpl$3(), _el$4 = _el$3.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(tags()),
                        get children () {
                            return t('packages.edit_tags_dialog.ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(),
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$3;
                })()
            ];
        }
    });
};




var $9DGpR = parcelRequire("9DGpR");


var $ca8b75b9d09409e7$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $ca8b75b9d09409e7$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $ca8b75b9d09409e7$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class=input><div class=label>`), $ca8b75b9d09409e7$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`);
const $ca8b75b9d09409e7$export$8f17baed84443f0d = (props)=>{
    const { t: t, lang: currentLang } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const sigMarkdown = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(props.value?.markdown ?? '');
    const sigLang = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(props.value?.lang);
    const sigImages = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((0, $9DGpR.Map)((props.value?.images ?? []).map((image)=>[
            image.id,
            image
        ])));
    const resolve = ()=>{
        props.resolve({
            markdown: sigMarkdown[0](),
            lang: sigLang[0]() ?? currentLang(),
            images: sigImages[0]().toArray().map((image)=>image[0])
        });
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui big dialog_prompt_markdown",
        get children () {
            return [
                (()=>{
                    var _el$ = $ca8b75b9d09409e7$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>props.header);
                    return _el$;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return props.message;
                    },
                    get children () {
                        var _el$2 = $ca8b75b9d09409e7$var$_tmpl$2();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>props.message);
                        return _el$2;
                    }
                }),
                (()=>{
                    var _el$3 = $ca8b75b9d09409e7$var$_tmpl$3(), _el$4 = _el$3.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>props.label);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c9ba532eab0ac5a8$export$18a9461578883ec4), {
                        markdown: sigMarkdown,
                        lang: sigLang,
                        images: sigImages,
                        get projectId () {
                            return props.projectId;
                        },
                        level: 2,
                        ugc: true,
                        linkInNewTab: true
                    }), null);
                    return _el$3;
                })(),
                (()=>{
                    var _el$5 = $ca8b75b9d09409e7$var$_tmpl$4(), _el$6 = _el$5.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        type: "submit",
                        onClick: resolve,
                        get children () {
                            return props.ok ?? t('ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(undefined),
                        get children () {
                            return props.cancel ?? t('cancel');
                        }
                    }), null);
                    return _el$5;
                })()
            ];
        }
    });
};




var $9DGpR = parcelRequire("9DGpR");





var $9DGpR = parcelRequire("9DGpR");


var $545d4e080a209568$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $545d4e080a209568$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $545d4e080a209568$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list packages">`), $545d4e080a209568$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $545d4e080a209568$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=link><div class=title>`);
const $545d4e080a209568$export$dd78947766873331 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [packages] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getProjectsPackages({
            project: props.project.id
        });
    });
    const [selectedPackages, setSelectedPackages] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((0, $9DGpR.Map)());
    const onItemClick = (pkg, e)=>{
        if (e.ctrlKey) setSelectedPackages((selected)=>selected.has(pkg.id) ? selected.delete(pkg.id) : selected.set(pkg.id, pkg));
        else setSelectedPackages((0, $9DGpR.Map)([
            [
                pkg.id,
                pkg
            ]
        ]));
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui big add_existing_package",
        get children () {
            return [
                (()=>{
                    var _el$ = $545d4e080a209568$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('packages.add_existing_dialog.header'));
                    return _el$;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return packages()?.length;
                    },
                    get fallback () {
                        return (()=>{
                            var _el$6 = $545d4e080a209568$var$_tmpl$2();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t('packages.add_existing_dialog.no_packages'));
                            return _el$6;
                        })();
                    },
                    get children () {
                        return [
                            (()=>{
                                var _el$2 = $545d4e080a209568$var$_tmpl$2();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('packages.add_existing_dialog.message'));
                                return _el$2;
                            })(),
                            (()=>{
                                var _el$3 = $545d4e080a209568$var$_tmpl$3();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                    get each () {
                                        return packages();
                                    },
                                    children: (pkg)=>(()=>{
                                            var _el$7 = $545d4e080a209568$var$_tmpl$5(), _el$8 = _el$7.firstChild;
                                            _el$7.$$click = (e)=>onItemClick(pkg, e);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>pkg.title);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
                                                get tags () {
                                                    return (0, $9DGpR.Set)(pkg.tags);
                                                }
                                            }), null);
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                                get size () {
                                                    return pkg.size;
                                                }
                                            }), null);
                                            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$7.classList.toggle("selected", !!selectedPackages().has(pkg.id)));
                                            return _el$7;
                                        })()
                                }));
                                return _el$3;
                            })()
                        ];
                    }
                }),
                (()=>{
                    var _el$4 = $545d4e080a209568$var$_tmpl$4(), _el$5 = _el$4.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        get disabled () {
                            return selectedPackages().isEmpty();
                        },
                        onClick: ()=>{
                            props.resolve(selectedPackages().valueSeq().toArray());
                        },
                        get children () {
                            return t('packages.add_existing_dialog.add')(selectedPackages().size);
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>{
                            props.resolve();
                        },
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$4;
                })()
            ];
        }
    });
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);





var $9DGpR = parcelRequire("9DGpR");


var $98d7cd641177b993$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<code>`), $98d7cd641177b993$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<code>.`), $98d7cd641177b993$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $98d7cd641177b993$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2>`), $98d7cd641177b993$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $98d7cd641177b993$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=checks>`), $98d7cd641177b993$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=size>`), $98d7cd641177b993$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class=title><div class=label></div><div class=value><input type=text autofocus>`), $98d7cd641177b993$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $98d7cd641177b993$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $98d7cd641177b993$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><p class=message>`), $98d7cd641177b993$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=inline_size>`), $98d7cd641177b993$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=note>`);
const $98d7cd641177b993$export$b72c2ef238d22309 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const [tags, setTags] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(props.tags ?? (0, $9DGpR.Set)());
    const root = props.baseRoot && props.cloneFilesFromBase ? props.baseRoot.clone() : new (0, $d31846142152482d$export$51c46da272110b9a)('');
    const [entrypoint, setEntrypoint] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(props.entrypoint ?? (0, $9DGpR.List)());
    let refTitle;
    const tagsStr = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)((lastTagsStr)=>{
        const tagsStr = (props.version ? [
            props.version
        ] : []).concat(tags().toArray().sort((0, $9cb6667deff6c421$export$9b33fb7751632f7d)).map((tag)=>tag.split(':').at(-1))).join('-');
        if (refTitle?.value === '' || refTitle?.value === lastTagsStr) refTitle.value = tagsStr;
        return tagsStr;
    }, '');
    const onTitleBlur = (e)=>{
        if (refTitle?.value === '') refTitle.value = tagsStr();
    };
    const checkEmpty = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        if (root.entries().isEmpty()) return {
            message: t('packages.new_dialog.checks.empty')
        };
        return null;
    });
    const checkEntrypoint = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const entrypointValue = entrypoint();
        // check if entrypoint is not set
        if (entrypointValue.isEmpty()) return {
            message: t('packages.new_dialog.checks.entrypoint.empty')
        };
        // check if entrypoint is set, but entry is missing
        let entry = root;
        for(let i = 0; entry; ++i){
            const name = entrypointValue.get(i);
            if (!name) break;
            entry = entry instanceof (0, $d31846142152482d$export$5230a91395080b61) ? entry.entries().get(name) : undefined;
        }
        if (!entry) return {
            message: t('packages.new_dialog.checks.entrypoint.missing')((()=>{
                var _el$ = $98d7cd641177b993$var$_tmpl$();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>entrypointValue.toArray().join('/'));
                return _el$;
            })()),
            action: {
                title: t('packages.new_dialog.checks.entrypoint.missing.action'),
                fix: ()=>{
                    setEntrypoint((0, $9DGpR.List)([]));
                }
            }
        };
        // check type of entrypoint file and suggest tags or wrong files
        const entryName = entry.name();
        const tagsSet = tags();
        for (const [fileExt, tag, category] of [
            [
                '7z',
                undefined,
                'archive'
            ],
            [
                'bat',
                'os:windows'
            ],
            [
                'css'
            ],
            [
                'dat'
            ],
            [
                'deb',
                'packaging:deb'
            ],
            [
                'dll'
            ],
            [
                'exe',
                'os:windows'
            ],
            [
                'flatpak',
                'packaging:flatpak'
            ],
            [
                'html',
                'os:web'
            ],
            [
                'jar',
                'runtime:java'
            ],
            [
                'js',
                'runtime:nodejs'
            ],
            [
                'json'
            ],
            [
                'msi',
                'packaging:installer'
            ],
            [
                'rar',
                undefined,
                'archive'
            ],
            [
                'rpm',
                'packaging:rpm'
            ],
            [
                'sh',
                'os:linux'
            ],
            [
                'so'
            ],
            [
                'tar.bz',
                undefined,
                'archive'
            ],
            [
                'tar.gz',
                undefined,
                'archive'
            ],
            [
                'tar.xz',
                undefined,
                'archive'
            ],
            [
                'tar',
                undefined,
                'archive'
            ],
            [
                'toml'
            ],
            [
                'txt'
            ],
            [
                'yaml'
            ],
            [
                'yml'
            ],
            [
                'zip',
                undefined,
                'archive'
            ]
        ]){
            if (entryName.endsWith(`.${fileExt}`) && (!tag || !tagsSet.has(tag))) return {
                message: (t(`packages.new_dialog.checks.entrypoint.ext.${fileExt}`) ?? t(`packages.new_dialog.checks.entrypoint.ext${category ? `.${category}` : tag ? '.tag' : '.wrong'}`))((()=>{
                    var _el$2 = $98d7cd641177b993$var$_tmpl$2(), _el$3 = _el$2.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, fileExt, null);
                    return _el$2;
                })(), tag ? (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
                    get tags () {
                        return (0, $9DGpR.Set)([
                            tag
                        ]);
                    },
                    inline: true
                }) : undefined),
                action: tag ? {
                    title: t('packages.new_dialog.checks.entrypoint.ext.tag.action')(t(`package.tag.${tag}`)),
                    fix: ()=>{
                        setTags((tags)=>tags.add(tag));
                    }
                } : undefined
            };
        }
        // advise to add executable bit
        if ((tagsSet.has('os:linux') || tagsSet.has('os:macos')) && entry instanceof (0, $d31846142152482d$export$af701efb7ddbdf6b) && !(entry.mode() & (0, $d31846142152482d$export$e019a04e95b2bad).Executable) && [
            'deb',
            'flatpak',
            'rpm'
        ].every((ext)=>!entry.name().endsWith(`.${ext}`))) return {
            message: t('packages.new_dialog.checks.entrypoint.executable'),
            action: {
                title: t('packages.new_dialog.checks.entrypoint.executable.action'),
                fix: ()=>{
                    entry.setMode((mode)=>mode | (0, $d31846142152482d$export$e019a04e95b2bad).Executable);
                }
            }
        };
        return null;
    });
    const checkSingleRootDir = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const entries = root.entries();
        if (entries.size == 1 && entries.first() instanceof (0, $d31846142152482d$export$51c46da272110b9a)) return {
            message: t('packages.new_dialog.checks.single_root_dir'),
            action: {
                title: t('packages.new_dialog.checks.single_root_dir.action'),
                fix: ()=>{
                    if (entries.size == 1) {
                        const entry = entries.first();
                        if (entry instanceof (0, $d31846142152482d$export$51c46da272110b9a)) {
                            entry.removeFromParent();
                            for (const [_subentryName, subentry] of entry.entries())subentry.moveTo(root);
                        }
                    }
                }
            }
        };
        else return null;
    });
    const checks = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>[
            checkEmpty(),
            checkEntrypoint(),
            checkSingleRootDir()
        ].filter((check)=>check != null));
    const chunkingAlgorithm = (0, $fe57e090ef2afef2$export$53ba34a64bd6362a).Gear17;
    const compressionAlgorithm = (0, $fe57e090ef2afef2$export$dea40e325ea0b38b).None;
    const baseChunksIndex = props.baseRoot ? (0, $fe57e090ef2afef2$export$81c6440f04a67fe0)(props.baseRoot) : undefined;
    const onStartUpload = ()=>{
        props.resolve({
            title: refTitle.value,
            tags: tags(),
            entrypoint: entrypoint(),
            root: root,
            chunkingAlgorithm: chunkingAlgorithm,
            compressionAlgorithm: compressionAlgorithm,
            baseChunksIndex: baseChunksIndex
        });
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui big new_package",
        get children () {
            return [
                (()=>{
                    var _el$4 = $98d7cd641177b993$var$_tmpl$3();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, ()=>t('packages.new_dialog.header'));
                    return _el$4;
                })(),
                (()=>{
                    var _el$5 = $98d7cd641177b993$var$_tmpl$4();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>t('packages.new_dialog.tags.header'));
                    return _el$5;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$4b94e81825be0936), {
                    tags: tags,
                    setTags: setTags,
                    compact: true
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
                    get tags () {
                        return tags();
                    },
                    showCodes: true
                }),
                (()=>{
                    var _el$6 = $98d7cd641177b993$var$_tmpl$4();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t('packages.new_dialog.files.header'));
                    return _el$6;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$240af65705974100), {
                    get children () {
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$2633c22b7a1b7cb), {
                            root: root,
                            get baseRoot () {
                                return props.baseRoot;
                            },
                            baseChunksIndex: baseChunksIndex,
                            entrypoint: entrypoint,
                            setEntrypoint: setEntrypoint,
                            editable: true
                        });
                    }
                }),
                (()=>{
                    var _el$7 = $98d7cd641177b993$var$_tmpl$5();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                        get when () {
                            return !entrypoint().isEmpty();
                        },
                        get children () {
                            return t('packages.entrypoint')([
                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                    solid: true,
                                    play: true,
                                    inline: true,
                                    weak: true
                                }),
                                (()=>{
                                    var _el$15 = $98d7cd641177b993$var$_tmpl$();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, ()=>entrypoint().toArray().join('/'));
                                    return _el$15;
                                })()
                            ]);
                        }
                    }));
                    return _el$7;
                })(),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                    get when () {
                        return checks().length > 0;
                    },
                    get children () {
                        var _el$8 = $98d7cd641177b993$var$_tmpl$6();
                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                            get each () {
                                return checks();
                            },
                            children: (check)=>(()=>{
                                    var _el$16 = $98d7cd641177b993$var$_tmpl$1(), _el$17 = _el$16.firstChild;
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                        solid: true,
                                        warning: true,
                                        inline: true,
                                        weak: true
                                    }), null);
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, ()=>check?.message, null);
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                        get when () {
                                            return check?.action;
                                        },
                                        get children () {
                                            var _el$18 = $98d7cd641177b993$var$_tmpl$0();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$18, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                get onClick () {
                                                    return check?.action?.fix;
                                                },
                                                get children () {
                                                    return check?.action?.title;
                                                }
                                            }));
                                            return _el$18;
                                        }
                                    }), null);
                                    return _el$16;
                                })()
                        }));
                        return _el$8;
                    }
                }),
                (()=>{
                    var _el$9 = $98d7cd641177b993$var$_tmpl$7();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t('packages.new_dialog.total_size')((()=>{
                            var _el$19 = $98d7cd641177b993$var$_tmpl$10();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$19, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                get size () {
                                    return root.totalSize();
                                }
                            }));
                            return _el$19;
                        })(), (()=>{
                            var _el$20 = $98d7cd641177b993$var$_tmpl$11();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, ()=>t('packages.new_dialog.total_size.maximum')((()=>{
                                    var _el$21 = $98d7cd641177b993$var$_tmpl$10();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$21, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                        get size () {
                                            return props.projectQuotas.packageSize;
                                        }
                                    }));
                                    return _el$21;
                                })()));
                            return _el$20;
                        })()));
                    return _el$9;
                })(),
                (()=>{
                    var _el$0 = $98d7cd641177b993$var$_tmpl$7();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>t('packages.new_dialog.new_data_size')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                            get when () {
                                return root.extra.ready();
                            },
                            get fallback () {
                                return (()=>{
                                    var _el$23 = $98d7cd641177b993$var$_tmpl$11();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$23, ()=>t('calculating'));
                                    return _el$23;
                                })();
                            },
                            get children () {
                                var _el$22 = $98d7cd641177b993$var$_tmpl$10();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$22, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                    get size () {
                                        return root.extra?.patchSize?.(props.baseRoot)?.() ?? 0;
                                    }
                                }));
                                return _el$22;
                            }
                        })));
                    return _el$0;
                })(),
                (()=>{
                    var _el$1 = $98d7cd641177b993$var$_tmpl$8(), _el$10 = _el$1.firstChild, _el$11 = _el$10.nextSibling, _el$12 = _el$11.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>t('packages.new_dialog.label_title'));
                    _el$12.addEventListener("blur", onTitleBlur);
                    var _ref$ = refTitle;
                    typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$12) : refTitle = _el$12;
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$12, "placeholder", tagsStr() || t('packages.new_dialog.title_placeholder')));
                    return _el$1;
                })(),
                (()=>{
                    var _el$13 = $98d7cd641177b993$var$_tmpl$9(), _el$14 = _el$13.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: onStartUpload,
                        get disabled () {
                            return root.entries().isEmpty() || !root.extra?.ready?.();
                        },
                        get children () {
                            return [
                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                    inline: true,
                                    solid: true,
                                    "cloud-arrow-up": true
                                }),
                                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('upload_box.start_upload'))
                            ];
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(),
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$13;
                })()
            ];
        }
    });
};


var $6afe1cf3aea4b123$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $6afe1cf3aea4b123$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class=version><div class=label></div><div class=value><input type=text autofocus>`), $6afe1cf3aea4b123$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class=branch><div class=label></div><div class=value><strong>`), $6afe1cf3aea4b123$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2>`), $6afe1cf3aea4b123$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $6afe1cf3aea4b123$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list packages">`), $6afe1cf3aea4b123$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $6afe1cf3aea4b123$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=empty>`), $6afe1cf3aea4b123$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=spacer>`), $6afe1cf3aea4b123$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=title>`), $6afe1cf3aea4b123$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=status>`), $6afe1cf3aea4b123$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=note>`), $6afe1cf3aea4b123$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div>&nbsp;`), $6afe1cf3aea4b123$var$_tmpl$12 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`);
const $6afe1cf3aea4b123$export$e0dfd3e047556b8b = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [packages, setPackages] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)((0, $9DGpR.List)());
    const acquirePackageSemaphore = (0, $e19c4daa2d9c3184$export$245149afd82cd08f)(2); // covers all work on an package
    const addExistingPackage = async (packages, packageInfo)=>{
        const [state, setState] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({
            id: packageInfo.id,
            title: packageInfo.title,
            tags: (0, $9DGpR.Set)(packageInfo.tags),
            entrypoint: (0, $9DGpR.List)(packageInfo.entrypoint),
            size: packageInfo.size,
            status: 'existing',
            parts: []
        });
        packages.push({
            state: state,
            setState: setState
        });
        (async ()=>{
            const url = new URL(await api.getProjectsPackagesDownload({
                project: props.project.id,
                _package: packageInfo.id
            }), (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
            url.searchParams.set('filter', 'index');
            const root = await (0, $fe57e090ef2afef2$export$b6eb13e118c144bd)(url.toString());
            setState((state)=>({
                    ...state,
                    root: root
                }));
        })();
    };
    let refTextBoxTitle;
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        // set initial version title
        if (props.initialVersionTitle) refTextBoxTitle.value = props.initialVersionTitle;
        // add base version's packages
        (async ()=>{
            if (props.baseVersion) {
                const baseVersionPackages = await api.getProjectsVersionsPackages({
                    project: props.project.id,
                    version: props.baseVersion.id
                });
                setPackages((packages)=>packages.withMutations((packages)=>{
                        for (const packageInfo of baseVersionPackages)addExistingPackage(packages, packageInfo);
                    }));
            }
        })();
    });
    const jobsWatcher = new (0, $d542c09ca8fd8013$export$ba4b5e9e211cc848)();
    const uploadPackage = async (pkg, { root: root, chunkingAlgorithm: chunkingAlgorithm, compressionAlgorithm: compressionAlgorithm, baseChunksIndex: baseChunksIndex }, basePackageId)=>{
        const setPackageStatus = (status)=>pkg.setState((state)=>({
                    ...state,
                    status: status
                }));
        const freePackageSemaphore = await acquirePackageSemaphore();
        try {
            setPackageStatus('packing');
            const blob = await (0, $fe57e090ef2afef2$export$e8e171792b146fcc)(root, chunkingAlgorithm, compressionAlgorithm, baseChunksIndex);
            const { id: packageId, uploadInfo: { token: storageToken, uploadUrl: uploadUrl, partSize: partSize, partHashAlgorithm: partHashAlgorithm } } = await $6afe1cf3aea4b123$var$tryFewTimes(async ()=>{
                setPackageStatus('creating');
                const newPackage = await api.postProjectsPackages({
                    project: props.project.id,
                    requestBody: {
                        size: blob.size,
                        title: pkg.state().title,
                        tags: pkg.state().tags.toArray().sort(),
                        entrypoint: pkg.state().entrypoint.toArray(),
                        basePackage: basePackageId
                    }
                });
                newPackage.uploadInfo.uploadUrl = new URL(newPackage.uploadInfo.uploadUrl, (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl).toString();
                return newPackage;
            }, async ()=>{
                setPackageStatus('create_retrying');
            });
            pkg.setState((state)=>({
                    ...state,
                    id: packageId,
                    root: root
                }));
            setPackageStatus('splitting');
            const parts = [];
            for(let i = 0; i < blob.size; i += partSize){
                const size = Math.min(partSize, blob.size - i);
                const [state, setState] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({
                    status: 'queued',
                    progress: 0,
                    total: size
                });
                parts.push({
                    blob: blob.slice(i, i + size),
                    size: size,
                    state: state,
                    setState: setState
                });
            }
            pkg.setState((state)=>({
                    ...state,
                    parts: parts
                }));
            setPackageStatus('uploading');
            const acquirePartSemaphore = (0, $e19c4daa2d9c3184$export$245149afd82cd08f)(3); // covers all work on a part
            const acquireUploadSemaphore = (0, $e19c4daa2d9c3184$export$245149afd82cd08f)(2); // covers actual uploading (without waiting for response)
            const promises = new Array(parts.length);
            const partsTokens = new Array(parts.length);
            for(let partIndex = 0; partIndex < parts.length; ++partIndex)promises[partIndex] = (async (partIndex, freePartSemaphore, freeUploadSemaphore)=>{
                try {
                    const part = parts[partIndex];
                    const setPartStatus = (status)=>part.setState((state)=>({
                                ...state,
                                status: status
                            }));
                    setPartStatus('hashing');
                    let hash;
                    switch(partHashAlgorithm){
                        case 'sha1':
                            hash = (0, $f710aae7717efd0b$export$c5411f1b08998578)(await crypto.subtle.digest('SHA-1', await part.blob.arrayBuffer()));
                            break;
                        default:
                            throw 'unsupported_hash_algorithm';
                    }
                    await $6afe1cf3aea4b123$var$tryFewTimes(async ()=>{
                        setPartStatus('upload_queued');
                        let isFinished = false;
                        try {
                            setPartStatus('uploading');
                            const uploadFinished = ()=>{
                                freeUploadSemaphore();
                                if (!isFinished) setPartStatus('upload_finalizing');
                            };
                            await new Promise((resolve, reject)=>{
                                // use XHR instead of fetch because it supports upload progress
                                const xhr = new XMLHttpRequest();
                                xhr.responseType = 'json';
                                xhr.addEventListener('error', reject);
                                xhr.addEventListener('load', ()=>{
                                    if (xhr.status !== 200) return reject(xhr.response);
                                    partsTokens[partIndex] = xhr.response;
                                    resolve();
                                });
                                xhr.upload.addEventListener('progress', (e)=>{
                                    if (e.lengthComputable) {
                                        const progress = Number(e.loaded);
                                        const total = Number(e.total);
                                        part.setState((state)=>({
                                                ...state,
                                                progress: progress,
                                                total: total
                                            }));
                                        if (progress >= total) // not every browser sends upload.load event (notably Firefox)
                                        // so deduce finished upload from progress
                                        uploadFinished();
                                    }
                                });
                                xhr.upload.addEventListener('load', uploadFinished);
                                xhr.open('PUT', (()=>{
                                    const url = new URL(uploadUrl);
                                    url.searchParams.set('part', String(partIndex));
                                    url.searchParams.set('hash', hash);
                                    return url.toString();
                                })(), true);
                                xhr.setRequestHeader('Content-Type', 'application/octet-stream');
                                // no Content-Length header, it's forbidden in browsers
                                xhr.send(part.blob);
                            });
                            isFinished = true;
                            uploadFinished();
                        } finally{
                            freeUploadSemaphore();
                        }
                    }, async ()=>{
                        setPartStatus('upload_retrying');
                    });
                    part.setState((state)=>({
                            ...state,
                            status: 'done',
                            progress: state.total // just in case
                        }));
                } finally{
                    freePartSemaphore();
                }
            })(partIndex, await acquirePartSemaphore(), await acquireUploadSemaphore());
            for (const promise of promises)await promise;
            await $6afe1cf3aea4b123$var$tryFewTimes(async ()=>{
                setPackageStatus('finalizing');
                await api.putProjectsPackagesFinalize({
                    project: props.project.id,
                    _package: packageId,
                    requestBody: {
                        token: storageToken,
                        parts: partsTokens
                    }
                });
            }, async ()=>{
                setPackageStatus('finalize_retrying');
            });
            if (basePackageId) {
                const jobToken = await $6afe1cf3aea4b123$var$tryFewTimes(async ()=>{
                    setPackageStatus('resolving');
                    return await api.postProjectsPackagesResolve({
                        project: props.project.id,
                        _package: packageId
                    });
                }, async ()=>{
                    setPackageStatus('resolve_retrying');
                });
                const jobState = jobsWatcher.add(jobToken);
                pkg.setState((state)=>({
                        ...state,
                        resolving: jobState
                    }));
                const resolvedPackageId = await new Promise((resolve, reject)=>{
                    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
                        const output = jobState().output;
                        if (output !== undefined) {
                            if (output?.package) resolve(output.package);
                            else reject();
                        }
                    });
                });
                pkg.setState((state)=>({
                        ...state,
                        id: resolvedPackageId,
                        root: root
                    }));
            }
            setPackageStatus('done');
        } catch (e) {
            setPackageStatus('errored');
            throw e;
        } finally{
            freePackageSemaphore();
        }
    };
    const onNewPackage = async ()=>{
        const newPackage = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $98d7cd641177b993$export$b72c2ef238d22309), {
            project: props.project,
            projectQuotas: props.projectQuotas,
            version: refTextBoxTitle.value
        });
        if (!newPackage) return;
        const [state, setState] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)({
            title: newPackage.title,
            tags: newPackage.tags,
            entrypoint: newPackage.entrypoint,
            size: newPackage.root.totalSize(),
            status: 'queued',
            parts: []
        });
        setPackages((packages)=>{
            const pkg = {
                state: state,
                setState: setState
            };
            uploadPackage(pkg, newPackage);
            return packages.push(pkg);
        });
    };
    const newPackageWithBase = async (pkg, keepFiles)=>{
        const basePackageId = pkg.state().id;
        const newPackage = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $98d7cd641177b993$export$b72c2ef238d22309), {
            project: props.project,
            projectQuotas: props.projectQuotas,
            version: refTextBoxTitle.value,
            baseRoot: pkg.state().root,
            cloneFilesFromBase: keepFiles,
            tags: pkg.state().tags,
            entrypoint: pkg.state().entrypoint
        });
        if (!newPackage) return;
        pkg.setState((state)=>({
                ...state,
                title: newPackage.title,
                tags: newPackage.tags,
                entrypoint: newPackage.entrypoint,
                size: newPackage.root.totalSize(),
                status: 'queued',
                parts: []
            }));
        uploadPackage(pkg, newPackage, basePackageId);
    };
    const onReplacePackage = (pkg)=>newPackageWithBase(pkg, false);
    const onEditPackage = async (pkg)=>newPackageWithBase(pkg, true);
    const onAddExistingPackage = async ()=>{
        const packageInfos = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $545d4e080a209568$export$dd78947766873331), {
            project: props.project
        });
        if (!packageInfos) return;
        setPackages((packages)=>packages.withMutations((packages)=>{
                for (const packageInfo of packageInfos)addExistingPackage(packages, packageInfo);
            }));
    };
    const onDeletePackage = (index)=>{
        setPackages((packages)=>packages.delete(index));
    };
    const cancelAllUploads = ()=>{};
    const packageInProgress = (pkg)=>{
        switch(pkg.state().status){
            case 'existing':
            case 'done':
            case 'errored':
                return false;
            default:
                return true;
        }
    };
    const packagesDone = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>packages().every((pkg)=>{
            switch(pkg.state().status){
                case 'existing':
                case 'done':
                    return true;
                default:
                    return false;
            }
        }));
    const onCreateVersion = async ()=>{
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            const versionId = await api.postProjectsVersions({
                project: props.project.id,
                requestBody: {
                    title: refTextBoxTitle.value,
                    description: '',
                    packages: packages().map((pkg)=>pkg.state().id).toArray()
                }
            });
            props.resolve(versionId);
        });
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui big new_version",
        get children () {
            return [
                (()=>{
                    var _el$ = $6afe1cf3aea4b123$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('versions.new_dialog.header'));
                    return _el$;
                })(),
                (()=>{
                    var _el$2 = $6afe1cf3aea4b123$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling, _el$5 = _el$4.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>t('versions.new_dialog.label_title'));
                    var _ref$ = refTextBoxTitle;
                    typeof _ref$ === "function" ? (0, $fb40d00dea10da1a$export$1f96ae73734a86cc)(_ref$, _el$5) : refTextBoxTitle = _el$5;
                    return _el$2;
                })(),
                (()=>{
                    var _el$6 = $6afe1cf3aea4b123$var$_tmpl$3(), _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('versions.new_dialog.label_branch'));
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>props.branch.title);
                    return _el$6;
                })(),
                (()=>{
                    var _el$0 = $6afe1cf3aea4b123$var$_tmpl$4();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>t('versions.new_dialog.packages.header'));
                    return _el$0;
                })(),
                (()=>{
                    var _el$1 = $6afe1cf3aea4b123$var$_tmpl$5();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: onNewPackage,
                        get children () {
                            return t('versions.new_dialog.packages.add');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: onAddExistingPackage,
                        get children () {
                            return t('versions.new_dialog.packages.add_existing');
                        }
                    }), null);
                    return _el$1;
                })(),
                (()=>{
                    var _el$10 = $6afe1cf3aea4b123$var$_tmpl$6();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                        get each () {
                            return packages().toArray();
                        },
                        get fallback () {
                            return (()=>{
                                var _el$13 = $6afe1cf3aea4b123$var$_tmpl$8(), _el$14 = _el$13.firstChild;
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, ()=>t('versions.new_dialog.packages.empty'));
                                return _el$13;
                            })();
                        },
                        children: (pkg, index)=>(()=>{
                                var _el$15 = $6afe1cf3aea4b123$var$_tmpl$0(), _el$16 = _el$15.firstChild;
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, ()=>pkg.state().title);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
                                    get tags () {
                                        return (0, $9DGpR.Set)(pkg.state().tags);
                                    }
                                }), null);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                    get when () {
                                        return pkg.state().size != null;
                                    },
                                    get children () {
                                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                            get size () {
                                                return pkg.state().size;
                                            }
                                        });
                                    }
                                }), null);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                    get when () {
                                        return pkg.state().status == 'uploading';
                                    },
                                    get fallback () {
                                        return (()=>{
                                            var _el$19 = $6afe1cf3aea4b123$var$_tmpl$1();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$19, ()=>t(`packages.upload.status.${pkg.state().status}`));
                                            return _el$19;
                                        })();
                                    },
                                    get children () {
                                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($6afe1cf3aea4b123$var$PackagePartProgress, {
                                            parts: ()=>pkg.state().parts.map((part)=>part.state())
                                        });
                                    }
                                }), null);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                    get when () {
                                        return !packageInProgress(pkg);
                                    },
                                    get children () {
                                        var _el$17 = $6afe1cf3aea4b123$var$_tmpl$5();
                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                            get when () {
                                                return pkg.state().root;
                                            },
                                            get fallback () {
                                                return (()=>{
                                                    var _el$20 = $6afe1cf3aea4b123$var$_tmpl$10();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, ()=>t('loading'));
                                                    return _el$20;
                                                })();
                                            },
                                            get children () {
                                                return [
                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                        onClick: ()=>onReplacePackage(pkg),
                                                        get children () {
                                                            return t('versions.new_dialog.packages.replace');
                                                        }
                                                    }),
                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                        onClick: ()=>onEditPackage(pkg),
                                                        get children () {
                                                            return t('versions.new_dialog.packages.edit');
                                                        }
                                                    }),
                                                    $6afe1cf3aea4b123$var$_tmpl$9(),
                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                        danger: true,
                                                        onClick: ()=>onDeletePackage(index()),
                                                        get children () {
                                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                solid: true,
                                                                "trash-can": true
                                                            });
                                                        }
                                                    })
                                                ];
                                            }
                                        }));
                                        return _el$17;
                                    }
                                }), null);
                                return _el$15;
                            })()
                    }));
                    return _el$10;
                })(),
                (()=>{
                    var _el$11 = $6afe1cf3aea4b123$var$_tmpl$7(), _el$12 = _el$11.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        type: "submit",
                        get disabled () {
                            return !packagesDone();
                        },
                        onClick: onCreateVersion,
                        get children () {
                            return t('versions.new_dialog.ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>{
                            cancelAllUploads();
                            props.resolve();
                        },
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$11;
                })()
            ];
        }
    });
};
const $6afe1cf3aea4b123$var$tryFewTimes = async (work, beforeRetry)=>{
    const errors = [];
    for(let i = 0; i < 3; ++i){
        try {
            return await work();
        } catch (e) {
            errors.push(e);
            console.log('tryFewTimes error', i + 1, e);
        }
        if (beforeRetry) await beforeRetry();
        await new Promise((resolve)=>setTimeout(resolve, 5000));
    }
    throw {
        error: 'trying_few_times_failed',
        errors: errors
    };
};
const $6afe1cf3aea4b123$var$PackagePartProgress = (props)=>{
    const partsCount = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>props.parts().length);
    const allSegments = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)((prevAllSegments)=>{
        const segmentsCount = partsCount() * 2;
        if (prevAllSegments.length == segmentsCount) return prevAllSegments;
        const allSegments = new Array(segmentsCount);
        for(let i = 0; i < segmentsCount; ++i){
            const [start, setStart] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
            const [end, setEnd] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(0);
            const [status, setStatus] = i % 2 == 0 ? (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)('queued') : [];
            const [displayStatus, setDisplayStatus] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)('normal');
            allSegments[i] = {
                filled: !(i % 2),
                start: start,
                setStart: setStart,
                end: end,
                setEnd: setEnd,
                status: status,
                setStatus: setStatus,
                displayStatus: displayStatus,
                setDisplayStatus: setDisplayStatus
            };
        }
        return allSegments;
    }, []);
    const visibleSegments = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const segments = allSegments();
        const parts = props.parts();
        const visibleSegments = [];
        let position = 0;
        for(let partIndex = 0; partIndex < parts.length; ++partIndex){
            const segmentIndex = partIndex * 2;
            const status = parts[partIndex].status;
            let displayStatus;
            switch(status){
                case 'done':
                    displayStatus = 'ok';
                    break;
                case 'upload_retrying':
                    displayStatus = 'error';
                    break;
                default:
                    displayStatus = 'normal';
                    break;
            }
            // progress part
            const progressSize = parts[partIndex].progress;
            const progressSegment = segments[segmentIndex];
            progressSegment.setStart(position);
            position += progressSize;
            progressSegment.setEnd(position);
            progressSegment.setStatus(status);
            progressSegment.setDisplayStatus(displayStatus);
            if (progressSize > 0) {
                // glue to previous progress part only for 'done' segments
                if (status == 'done' && visibleSegments.length > 0 && visibleSegments[visibleSegments.length - 1].filled && visibleSegments[visibleSegments.length - 1].status() == status) visibleSegments[visibleSegments.length - 1].setEnd(position);
                else visibleSegments.push(progressSegment);
            }
            // empty part
            const emptySize = parts[partIndex].total - progressSize;
            const emptySegment = segments[segmentIndex + 1];
            emptySegment.setStart(position);
            position += emptySize;
            emptySegment.setEnd(position);
            if (emptySize > 0) {
                if (visibleSegments.length > 0 && !visibleSegments[visibleSegments.length - 1].filled) visibleSegments[visibleSegments.length - 1].setEnd(position);
                else visibleSegments.push(emptySegment);
            }
        }
        return visibleSegments;
    });
    const total = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>visibleSegments().length ? visibleSegments().at(-1).end() : 0);
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    // nbsp for working baseline alignment
    return (()=>{
        var _el$21 = $6afe1cf3aea4b123$var$_tmpl$11(), _el$22 = _el$21.firstChild, _el$23 = _el$22.firstChild;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$22, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
            get each () {
                return visibleSegments();
            },
            children: ({ filled: filled, start: start, end: end, status: status, displayStatus: displayStatus })=>(()=>{
                    var _el$24 = $6afe1cf3aea4b123$var$_tmpl$12();
                    _el$24.classList.toggle("filled", !!filled);
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                        var _v$ = !!(displayStatus() == 'normal'), _v$2 = !!(displayStatus() == 'ok'), _v$3 = !!(displayStatus() == 'error'), _v$4 = `${(start() / total() * 100).toFixed(3)}%`, _v$5 = `${((1 - end() / total()) * 100).toFixed(3)}%`, _v$6 = filled ? t(`packages.upload.part.status.${status()}`) : undefined;
                        _v$ !== _p$.e && _el$24.classList.toggle("status-normal", _p$.e = _v$);
                        _v$2 !== _p$.t && _el$24.classList.toggle("status-ok", _p$.t = _v$2);
                        _v$3 !== _p$.a && _el$24.classList.toggle("status-error", _p$.a = _v$3);
                        _v$4 !== _p$.o && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$24, "inset-inline-start", _p$.o = _v$4);
                        _v$5 !== _p$.i && (0, $fb40d00dea10da1a$export$36a7c0615a5a1a31)(_el$24, "inset-inline-end", _p$.i = _v$5);
                        _v$6 !== _p$.n && (0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$24, "title", _p$.n = _v$6);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined,
                        a: undefined,
                        o: undefined,
                        i: undefined,
                        n: undefined
                    });
                    return _el$24;
                })()
        }), null);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)((_$p)=>(0, $fb40d00dea10da1a$export$11c615ce16f87241)(_el$21, {
                part_progress: true,
                ...props.classList ?? {}
            }, _$p));
        return _el$21;
    })();
};





var $3737fd6ddf50a8c5$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $3737fd6ddf50a8c5$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $3737fd6ddf50a8c5$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list versions">`), $3737fd6ddf50a8c5$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $3737fd6ddf50a8c5$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $3737fd6ddf50a8c5$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=empty>`), $3737fd6ddf50a8c5$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=title></div><div class=created>`);
const $3737fd6ddf50a8c5$export$2118d960daa50051 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [versions, { refetch: refetchVersions }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getProjectsVersions({
            project: props.project.id
        });
    });
    const [selectedVersion, setSelectedVersion] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const onItemClick = (version, e)=>{
        setSelectedVersion(version.id);
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui medium select_existing_version",
        get children () {
            return [
                (()=>{
                    var _el$ = $3737fd6ddf50a8c5$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('versions.publish_existing_dialog.header'));
                    return _el$;
                })(),
                (()=>{
                    var _el$2 = $3737fd6ddf50a8c5$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('versions.publish_existing_dialog.message'));
                    return _el$2;
                })(),
                (()=>{
                    var _el$3 = $3737fd6ddf50a8c5$var$_tmpl$3();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                        get each () {
                            return versions();
                        },
                        get fallback () {
                            return (()=>{
                                var _el$6 = $3737fd6ddf50a8c5$var$_tmpl$5();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                    resource: versions,
                                    get empty () {
                                        return (()=>{
                                            var _el$7 = $3737fd6ddf50a8c5$var$_tmpl$6();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('versions.publish_existing_dialog.no_versions'));
                                            return _el$7;
                                        })();
                                    }
                                }));
                                return _el$6;
                            })();
                        },
                        children: (version)=>(()=>{
                                var _el$8 = $3737fd6ddf50a8c5$var$_tmpl$7(), _el$9 = _el$8.firstChild, _el$0 = _el$9.nextSibling;
                                (0, $fb40d00dea10da1a$export$3f65cefe8380dbea)(_el$8, "click", props.currentVersion == null || version.id != props.currentVersion.id ? [
                                    onItemClick,
                                    version
                                ] : undefined, true);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>version.title);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                    get date () {
                                        return new Date(version.created);
                                    }
                                }));
                                (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                                    var _v$ = !!(props.currentVersion == null || version.id != props.currentVersion.id), _v$2 = !!(version.id == props.currentVersion?.id), _v$3 = !!(selectedVersion() === version.id);
                                    _v$ !== _p$.e && _el$8.classList.toggle("link", _p$.e = _v$);
                                    _v$2 !== _p$.t && _el$8.classList.toggle("current", _p$.t = _v$2);
                                    _v$3 !== _p$.a && _el$8.classList.toggle("selected", _p$.a = _v$3);
                                    return _p$;
                                }, {
                                    e: undefined,
                                    t: undefined,
                                    a: undefined
                                });
                                return _el$8;
                            })()
                    }));
                    return _el$3;
                })(),
                (()=>{
                    var _el$4 = $3737fd6ddf50a8c5$var$_tmpl$4(), _el$5 = _el$4.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        get disabled () {
                            return selectedVersion() == null;
                        },
                        onClick: ()=>props.resolve(selectedVersion()),
                        get children () {
                            return t('versions.publish_existing_dialog.ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(),
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$4;
                })()
            ];
        }
    });
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);





var $13f1b87065075eea$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $13f1b87065075eea$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $13f1b87065075eea$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list branches">`), $13f1b87065075eea$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $13f1b87065075eea$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $13f1b87065075eea$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $13f1b87065075eea$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=empty>`), $13f1b87065075eea$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=current_version>`), $13f1b87065075eea$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=title>`);
const $13f1b87065075eea$export$61a5e4e90266ae01 = (props)=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { api: api } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const [branches, { refetch: refetchBranches }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getProjectsBranches({
            project: props.project.id
        });
    });
    const [selectedBranch, setSelectedBranch] = (0, $1f5a16020b51a07b$export$c1e1e1ecbbe76a5)(null);
    const onItemClick = (branch, e)=>{
        setSelectedBranch(branch.id);
    };
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(props.dialog, {
        "class": "sheet ui medium select_branch",
        get children () {
            return [
                (()=>{
                    var _el$ = $13f1b87065075eea$var$_tmpl$();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('versions.publish_dialog.header'));
                    return _el$;
                })(),
                (()=>{
                    var _el$2 = $13f1b87065075eea$var$_tmpl$2();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('versions.publish_dialog.message')((()=>{
                            var _el$6 = $13f1b87065075eea$var$_tmpl$5();
                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>props.version.title);
                            return _el$6;
                        })()));
                    return _el$2;
                })(),
                (()=>{
                    var _el$3 = $13f1b87065075eea$var$_tmpl$3();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                        get each () {
                            return branches();
                        },
                        get fallback () {
                            return (()=>{
                                var _el$7 = $13f1b87065075eea$var$_tmpl$6();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                    resource: branches,
                                    get empty () {
                                        return (()=>{
                                            var _el$8 = $13f1b87065075eea$var$_tmpl$7();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>t('versions.publish_dialog.empty'));
                                            return _el$8;
                                        })();
                                    }
                                }));
                                return _el$7;
                            })();
                        },
                        children: (branch)=>(()=>{
                                var _el$9 = $13f1b87065075eea$var$_tmpl$9(), _el$0 = _el$9.firstChild;
                                (0, $fb40d00dea10da1a$export$3f65cefe8380dbea)(_el$9, "click", branch.currentVersion?.version.id !== props.version.id ? [
                                    onItemClick,
                                    branch
                                ] : undefined, true);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>branch.title);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                    get when () {
                                        return branch.currentVersion;
                                    },
                                    get children () {
                                        var _el$1 = $13f1b87065075eea$var$_tmpl$8();
                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, ()=>branch.currentVersion?.version?.title);
                                        return _el$1;
                                    }
                                }), null);
                                (0, $1f5a16020b51a07b$export$314dade334ae905d)((_p$)=>{
                                    var _v$ = !!(branch.currentVersion?.version.id !== props.version.id), _v$2 = !!(branch.currentVersion?.version.id === props.version.id), _v$3 = !!(selectedBranch() === branch.id);
                                    _v$ !== _p$.e && _el$9.classList.toggle("link", _p$.e = _v$);
                                    _v$2 !== _p$.t && _el$9.classList.toggle("current", _p$.t = _v$2);
                                    _v$3 !== _p$.a && _el$9.classList.toggle("selected", _p$.a = _v$3);
                                    return _p$;
                                }, {
                                    e: undefined,
                                    t: undefined,
                                    a: undefined
                                });
                                return _el$9;
                            })()
                    }));
                    return _el$3;
                })(),
                (()=>{
                    var _el$4 = $13f1b87065075eea$var$_tmpl$4(), _el$5 = _el$4.firstChild;
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        get disabled () {
                            return selectedBranch() == null;
                        },
                        onClick: ()=>props.resolve(selectedBranch()),
                        get children () {
                            return t('versions.publish_dialog.ok');
                        }
                    }), null);
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                        onClick: ()=>props.resolve(),
                        get children () {
                            return t('cancel');
                        }
                    }), null);
                    return _el$4;
                })()
            ];
        }
    });
};
(0, $fb40d00dea10da1a$export$ad0f7f87f67e17d6)([
    "click"
]);



var $58b7e17de267e8d7$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1><span></span><div class=buttons>`), $58b7e17de267e8d7$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list projects">`), $58b7e17de267e8d7$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer>`), $58b7e17de267e8d7$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div>`), $58b7e17de267e8d7$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=empty>`), $58b7e17de267e8d7$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=title>`), $58b7e17de267e8d7$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=role>`), $58b7e17de267e8d7$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $58b7e17de267e8d7$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=published>`), $58b7e17de267e8d7$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="buttons group">`), $58b7e17de267e8d7$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=buttons>`), $58b7e17de267e8d7$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1><span class=user-selectable></span><div class=hint>`), $58b7e17de267e8d7$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2><span>`), $58b7e17de267e8d7$var$_tmpl$12 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2>`), $58b7e17de267e8d7$var$_tmpl$13 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list packages">`), $58b7e17de267e8d7$var$_tmpl$14 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list branches">`), $58b7e17de267e8d7$var$_tmpl$15 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=hint>`), $58b7e17de267e8d7$var$_tmpl$16 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=message>`), $58b7e17de267e8d7$var$_tmpl$17 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=size>`), $58b7e17de267e8d7$var$_tmpl$18 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<code>`), $58b7e17de267e8d7$var$_tmpl$19 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=inline_size>`), $58b7e17de267e8d7$var$_tmpl$20 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p><a target=_blank>`), $58b7e17de267e8d7$var$_tmpl$21 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2><span></span><div class=buttons>`), $58b7e17de267e8d7$var$_tmpl$22 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class="buttons align_end">`), $58b7e17de267e8d7$var$_tmpl$23 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=current_version>`), $58b7e17de267e8d7$var$_tmpl$24 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=current_version_published>`), $58b7e17de267e8d7$var$_tmpl$25 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list branch_versions">`), $58b7e17de267e8d7$var$_tmpl$26 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=note>`), $58b7e17de267e8d7$var$_tmpl$27 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h3>`), $58b7e17de267e8d7$var$_tmpl$28 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list project_users">`), $58b7e17de267e8d7$var$_tmpl$29 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list deploy_sites">`), $58b7e17de267e8d7$var$_tmpl$30 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a class=store_link target=_blank>`), $58b7e17de267e8d7$var$_tmpl$31 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class=buttons>`), $58b7e17de267e8d7$var$_tmpl$32 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list public_access"><div><div class=message></div><div class=note>`), $58b7e17de267e8d7$var$_tmpl$33 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=title>`), $58b7e17de267e8d7$var$_tmpl$34 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class=site></div><div class=provider>`), $58b7e17de267e8d7$var$_tmpl$35 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<label class=branch><input type=checkbox>`);
const $58b7e17de267e8d7$export$e281e188db3065f7 = ()=>{
    const { api: api, session: session } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const navigate = (0, $bcd7d00b4653a471$export$2b3a76f83deeece4)();
    const [projects, { refetch: refetchProjects }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
        return await api.getUsersMeProjects();
    });
    const projectsById = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>Object.fromEntries(projects()?.map((project)=>[
                project.id,
                project
            ]) ?? []));
    const onCreateProject = async ()=>{
        const title = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$a551a871839880f9), {
            header: t('projects.new_dialog.header'),
            label: t('projects.new_dialog.label'),
            ok: t('projects.new_dialog.ok')
        });
        if (title == null) return;
        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
            const projectId = await api.postProjects({
                requestBody: {
                    title: title
                }
            });
            refetchProjects();
            navigate((0, $c900760615f37aa7$export$d9c91539b7b67f34)(projectId));
        });
    };
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            get title () {
                return t('projects');
            },
            breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                    href: (0, $c900760615f37aa7$export$d7c176430feb555b),
                    get children () {
                        return t('projects');
                    }
                }),
            uiClass: "projects"
        }),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
            routes: [
                {
                    path: '',
                    component: ()=>[
                            (()=>{
                                var _el$ = $58b7e17de267e8d7$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling;
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('projects'));
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                    get when () {
                                        return (session()?.userPrivileges ?? []).indexOf('create_project') >= 0;
                                    },
                                    get children () {
                                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                            onClick: onCreateProject,
                                            get children () {
                                                return [
                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                        solid: true,
                                                        plus: true,
                                                        inline: true,
                                                        weak: true
                                                    }),
                                                    (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('projects.new'))
                                                ];
                                            }
                                        });
                                    }
                                }));
                                return _el$;
                            })(),
                            (()=>{
                                var _el$4 = $58b7e17de267e8d7$var$_tmpl$2();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                    get each () {
                                        return projects();
                                    },
                                    get fallback () {
                                        return (()=>{
                                            var _el$6 = $58b7e17de267e8d7$var$_tmpl$4();
                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                resource: projects,
                                                get empty () {
                                                    return (()=>{
                                                        var _el$7 = $58b7e17de267e8d7$var$_tmpl$5();
                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('projects.no_projects'));
                                                        return _el$7;
                                                    })();
                                                }
                                            }));
                                            return _el$6;
                                        })();
                                    },
                                    children: (project)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                            get href () {
                                                return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!(project.userIsOwner || project.userIsListed))() ? (0, $c900760615f37aa7$export$d9c91539b7b67f34)(project.id) : (0, $c900760615f37aa7$export$4934a533ea20858c)(project.id);
                                            },
                                            get children () {
                                                return [
                                                    (()=>{
                                                        var _el$8 = $58b7e17de267e8d7$var$_tmpl$6();
                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>project.title, null);
                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return project.isPublic;
                                                            },
                                                            get children () {
                                                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                    solid: true,
                                                                    weak: true,
                                                                    inline: true,
                                                                    store: true
                                                                });
                                                            }
                                                        }), null);
                                                        return _el$8;
                                                    })(),
                                                    (()=>{
                                                        var _el$9 = $58b7e17de267e8d7$var$_tmpl$7();
                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t(`projects.management.users.role.${project.userIsOwner ? 'owner' : project.userRole ?? 'starred'}`));
                                                        return _el$9;
                                                    })()
                                                ];
                                            }
                                        })
                                }));
                                return _el$4;
                            })(),
                            $58b7e17de267e8d7$var$_tmpl$3()
                        ]
                },
                {
                    component: (props)=>{
                        const project = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>projectsById()[props.route]);
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                            get when () {
                                return project();
                            },
                            keyed: true,
                            get fallback () {
                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                    resource: projects,
                                    page: true
                                });
                            },
                            children: (project)=>{
                                const [projectQuotas] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                    return await api.getProjectsQuotas({
                                        project: project.id
                                    });
                                });
                                const [branches, { refetch: refetchBranches }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                    return await api.getProjectsBranches({
                                        project: project.id
                                    });
                                });
                                const branchesById = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>Object.fromEntries(branches()?.map((branch)=>[
                                            branch.id,
                                            branch
                                        ]) ?? []));
                                const [versions, { refetch: refetchVersions }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                    return await api.getProjectsVersions({
                                        project: project.id
                                    });
                                });
                                const versionsById = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>Object.fromEntries(versions()?.map((version)=>[
                                            version.id,
                                            version
                                        ]) ?? []));
                                const [projectDescription] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                    return await api.getProjectsDescription({
                                        project: project.id
                                    });
                                });
                                const onCreateBranch = async ()=>{
                                    const title = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$a551a871839880f9), {
                                        header: t('branches.new_dialog.header'),
                                        label: t('branches.new_dialog.label'),
                                        ok: t('branches.new_dialog.ok')
                                    });
                                    if (title == null) return null;
                                    await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                        const branchId = await api.postProjectsBranches({
                                            project: project.id,
                                            requestBody: {
                                                title: title
                                            }
                                        });
                                        navigate((0, $c900760615f37aa7$export$5be20f864ea0a7)(project.id, branchId));
                                    });
                                    refetchBranches();
                                };
                                const onProjectAction = async (key)=>{
                                    switch(key){
                                        case 'rename':
                                            {
                                                const title = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$a551a871839880f9), {
                                                    header: t('projects.rename_dialog.header'),
                                                    label: t('projects.rename_dialog.label'),
                                                    value: project.title,
                                                    ok: t('projects.rename_dialog.ok'),
                                                    focus: 'cancel'
                                                });
                                                if (title !== undefined) {
                                                    await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                        await api.patchProjects({
                                                            project: project.id,
                                                            requestBody: {
                                                                title: title
                                                            }
                                                        });
                                                    });
                                                    refetchProjects();
                                                }
                                                break;
                                            }
                                        case 'edit_description':
                                            {
                                                const description = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $ca8b75b9d09409e7$export$8f17baed84443f0d), {
                                                    header: t('projects.edit_description_dialog.header'),
                                                    label: t('projects.edit_description_dialog.label'),
                                                    value: projectDescription(),
                                                    projectId: project.id,
                                                    ok: t('projects.edit_description_dialog.ok'),
                                                    focus: 'cancel'
                                                });
                                                if (description !== undefined) {
                                                    await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                        await api.putProjectsDescription({
                                                            project: project.id,
                                                            requestBody: description
                                                        });
                                                    });
                                                    refetchProjects();
                                                }
                                                break;
                                            }
                                        case 'leave':
                                            if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                header: t('projects.leave_dialog.header'),
                                                message: t('projects.leave_dialog.message')((()=>{
                                                    var _el$0 = $58b7e17de267e8d7$var$_tmpl$8();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>project.title);
                                                    return _el$0;
                                                })()),
                                                ok: t('projects.leave_dialog.ok'),
                                                focus: 'cancel',
                                                danger: true
                                            })) return;
                                            await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                await api.postProjectsUsersLeave({
                                                    project: project.id
                                                });
                                            });
                                            refetchProjects();
                                            navigate((0, $c900760615f37aa7$export$d7c176430feb555b));
                                            break;
                                        case 'delete':
                                            if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                header: t('projects.delete_dialog.header'),
                                                message: t('projects.delete_dialog.message')((()=>{
                                                    var _el$1 = $58b7e17de267e8d7$var$_tmpl$8();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, ()=>project.title);
                                                    return _el$1;
                                                })()),
                                                ok: t('projects.delete_dialog.ok'),
                                                focus: 'cancel',
                                                danger: true
                                            })) return;
                                            await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                await api.deleteProjects({
                                                    project: project.id
                                                });
                                            });
                                            refetchProjects();
                                            navigate((0, $c900760615f37aa7$export$d7c176430feb555b));
                                            break;
                                    }
                                };
                                const Package = ({ branch: branch, version: version, pkg: pkg })=>{
                                    const tagsInfo = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
                                        const osTags = [];
                                        const info = {};
                                        for (const tag of pkg.tags){
                                            const [tagType, tagValue] = tag.split(':');
                                            if (!tagValue) continue;
                                            switch(tagType){
                                                case 'os':
                                                    osTags.push(tagValue);
                                                    break;
                                            }
                                        }
                                        if (osTags.length == 1) info.os = osTags[0];
                                        return info;
                                    });
                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                        get href () {
                                            return (0, $c900760615f37aa7$export$2950deb3882ada89)({
                                                projectId: project.id,
                                                branchId: branch?.id,
                                                versionId: version.id,
                                                packageId: pkg.id
                                            });
                                        },
                                        get children () {
                                            return [
                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return tagsInfo().os;
                                                    },
                                                    children: (os)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)({
                                                            "fa-2xl": true
                                                        }, ()=>(0, $9cb6667deff6c421$export$d13993e02571356d).os.options[os()].icon))
                                                }),
                                                (()=>{
                                                    var _el$10 = $58b7e17de267e8d7$var$_tmpl$6();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>pkg.title);
                                                    return _el$10;
                                                })(),
                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                                    get size () {
                                                        return pkg.size;
                                                    }
                                                }),
                                                (()=>{
                                                    var _el$11 = $58b7e17de267e8d7$var$_tmpl$9();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                                        get date () {
                                                            return new Date(pkg.created);
                                                        }
                                                    }));
                                                    return _el$11;
                                                })(),
                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
                                                    get tags () {
                                                        return (0, $9DGpR.Set)(pkg.tags);
                                                    },
                                                    showIcons: false
                                                }),
                                                (()=>{
                                                    var _el$12 = $58b7e17de267e8d7$var$_tmpl$0();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $4cadc02efe646f32$export$a41f7b788abf9c93), {
                                                        project: project,
                                                        branch: branch,
                                                        version: version,
                                                        pkg: pkg
                                                    }));
                                                    return _el$12;
                                                })()
                                            ];
                                        }
                                    });
                                };
                                const VersionsSubroute = ({ branch: branch })=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                        routes: [
                                            {
                                                component: (props)=>{
                                                    const version = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>versionsById()[props.route]);
                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return version();
                                                        },
                                                        keyed: true,
                                                        get fallback () {
                                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                resource: versions,
                                                                page: true
                                                            });
                                                        },
                                                        children: (version)=>{
                                                            const [versionPackages] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(version, async (version)=>{
                                                                return await api.getProjectsVersionsPackages({
                                                                    project: project.id,
                                                                    version: version.id
                                                                });
                                                            });
                                                            return [
                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                                                    get title () {
                                                                        return t('versions.header')(project.title, version.title);
                                                                    },
                                                                    breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                            get href () {
                                                                                return (0, $c900760615f37aa7$export$18639e2046d399f4)({
                                                                                    projectId: project.id,
                                                                                    branchId: branch?.id,
                                                                                    versionId: version.id
                                                                                });
                                                                            },
                                                                            get children () {
                                                                                return version.title;
                                                                            }
                                                                        }),
                                                                    uiClass: "version",
                                                                    sidelinks: ()=>({
                                                                            header: t('projects.versions'),
                                                                            items: (versions() ?? []).map((otherVersion)=>({
                                                                                    title: otherVersion.title,
                                                                                    link: (0, $c900760615f37aa7$export$18639e2046d399f4)({
                                                                                        projectId: project.id,
                                                                                        branchId: branch?.id,
                                                                                        versionId: otherVersion.id
                                                                                    }),
                                                                                    selected: otherVersion.id === version.id
                                                                                }))
                                                                        })
                                                                }),
                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                                                    routes: [
                                                                        {
                                                                            path: '',
                                                                            component: ()=>{
                                                                                const [versionBranches, { refetch: refetchVersionBranches }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(version, async (version)=>{
                                                                                    return await api.getProjectsVersionsBranches({
                                                                                        project: project.id,
                                                                                        version: version.id
                                                                                    });
                                                                                });
                                                                                const onPublish = async ()=>{
                                                                                    const branchId = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $13f1b87065075eea$export$61a5e4e90266ae01), {
                                                                                        project: project,
                                                                                        version: version
                                                                                    });
                                                                                    if (!branchId) return;
                                                                                    await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                        await api.postProjectsBranchesVersions({
                                                                                            project: project.id,
                                                                                            branch: branchId,
                                                                                            version: version.id
                                                                                        });
                                                                                        refetchBranches();
                                                                                        refetchVersionBranches();
                                                                                    });
                                                                                };
                                                                                const onDeployToSite = async ()=>{
                                                                                    if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $62639f3fbb14edb2$export$4fdc2171a142cc2c), {
                                                                                        project: project,
                                                                                        version: version
                                                                                    })) return;
                                                                                };
                                                                                const onVersionAction = async (key)=>{
                                                                                    switch(key){
                                                                                        case 'rename':
                                                                                            {
                                                                                                const newVersionTitle = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$a551a871839880f9), {
                                                                                                    header: t('versions.rename_dialog.header'),
                                                                                                    label: t('versions.rename_dialog.label'),
                                                                                                    value: version.title,
                                                                                                    ok: t('versions.rename_dialog.ok')
                                                                                                });
                                                                                                if (!newVersionTitle) return;
                                                                                                await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                                    await api.patchProjectsVersions({
                                                                                                        project: project.id,
                                                                                                        version: version.id,
                                                                                                        requestBody: {
                                                                                                            title: newVersionTitle
                                                                                                        }
                                                                                                    });
                                                                                                });
                                                                                                refetchVersions();
                                                                                                refetchBranches();
                                                                                                break;
                                                                                            }
                                                                                        case 'edit_description':
                                                                                            {
                                                                                                const description = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $ca8b75b9d09409e7$export$8f17baed84443f0d), {
                                                                                                    header: t('versions.edit_description_dialog.header'),
                                                                                                    label: t('versions.edit_description_dialog.label'),
                                                                                                    value: {
                                                                                                        markdown: version.description,
                                                                                                        images: []
                                                                                                    },
                                                                                                    ok: t('versions.edit_description_dialog.ok'),
                                                                                                    focus: 'cancel'
                                                                                                });
                                                                                                if (description !== undefined) {
                                                                                                    await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                                        await api.patchProjectsVersions({
                                                                                                            project: project.id,
                                                                                                            version: version.id,
                                                                                                            requestBody: {
                                                                                                                description: description.markdown
                                                                                                            }
                                                                                                        });
                                                                                                    });
                                                                                                    refetchVersions();
                                                                                                    refetchBranches();
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                        case 'delete':
                                                                                            if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                                                                header: t('versions.delete_dialog.header'),
                                                                                                message: t('versions.delete_dialog.message')((()=>{
                                                                                                    var _el$13 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>version.title);
                                                                                                    return _el$13;
                                                                                                })()),
                                                                                                ok: t('versions.delete_dialog.ok'),
                                                                                                focus: 'cancel',
                                                                                                danger: true
                                                                                            })) return;
                                                                                            await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                                await api.deleteProjectsVersions({
                                                                                                    project: project.id,
                                                                                                    version: version.id
                                                                                                });
                                                                                            });
                                                                                            refetchVersions();
                                                                                            refetchBranches();
                                                                                            navigate(branch ? (0, $c900760615f37aa7$export$5be20f864ea0a7)(project.id, branch.id) : (0, $c900760615f37aa7$export$d9c91539b7b67f34)(project.id));
                                                                                            break;
                                                                                    }
                                                                                };
                                                                                return [
                                                                                    (()=>{
                                                                                        var _el$14 = $58b7e17de267e8d7$var$_tmpl$10(), _el$15 = _el$14.firstChild, _el$17 = _el$15.nextSibling;
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, ()=>t('versions.header')(project.title, version.title));
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                            get when () {
                                                                                                return project.userPossibleActions.indexOf('patchVersion') >= 0;
                                                                                            },
                                                                                            get children () {
                                                                                                var _el$16 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$16, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                                    light: true,
                                                                                                    onClick: ()=>onVersionAction('rename'),
                                                                                                    get children () {
                                                                                                        return t('versions.rename');
                                                                                                    }
                                                                                                }));
                                                                                                return _el$16;
                                                                                            }
                                                                                        }), _el$17);
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, ()=>t('versions.header.hint'));
                                                                                        return _el$14;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        var _el$18 = $58b7e17de267e8d7$var$_tmpl$11(), _el$19 = _el$18.firstChild;
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$19, ()=>t('versions.description'));
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$18, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                            get when () {
                                                                                                return project.userPossibleActions.indexOf('patchVersion') >= 0;
                                                                                            },
                                                                                            get children () {
                                                                                                var _el$20 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                                    light: true,
                                                                                                    onClick: ()=>onVersionAction('edit_description'),
                                                                                                    get children () {
                                                                                                        return t('versions.edit_description');
                                                                                                    }
                                                                                                }));
                                                                                                return _el$20;
                                                                                            }
                                                                                        }), null);
                                                                                        return _el$18;
                                                                                    })(),
                                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c9ba532eab0ac5a8$export$d5163f1ce1e6a5f9), {
                                                                                        markdown: ()=>({
                                                                                                markdown: version.description,
                                                                                                lang: projectDescription()?.lang,
                                                                                                images: []
                                                                                            }),
                                                                                        level: 3,
                                                                                        ugc: true,
                                                                                        linkInNewTab: true
                                                                                    }),
                                                                                    (()=>{
                                                                                        var _el$21 = $58b7e17de267e8d7$var$_tmpl$12();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$21, ()=>t('versions.packages'));
                                                                                        return _el$21;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        var _el$22 = $58b7e17de267e8d7$var$_tmpl$13();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$22, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                                            get each () {
                                                                                                return versionPackages();
                                                                                            },
                                                                                            get fallback () {
                                                                                                return (()=>{
                                                                                                    var _el$30 = $58b7e17de267e8d7$var$_tmpl$4();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$30, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                                                        resource: versionPackages
                                                                                                    }));
                                                                                                    return _el$30;
                                                                                                })();
                                                                                            },
                                                                                            children: (pkg)=>Package({
                                                                                                    branch: branch,
                                                                                                    version: version,
                                                                                                    pkg: pkg
                                                                                                })
                                                                                        }));
                                                                                        return _el$22;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        var _el$23 = $58b7e17de267e8d7$var$_tmpl$11(), _el$24 = _el$23.firstChild;
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$24, ()=>t('versions.branches'));
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$23, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                            get when () {
                                                                                                return project.userPossibleActions.indexOf('publishVersion') >= 0;
                                                                                            },
                                                                                            get children () {
                                                                                                var _el$25 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$25, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                                    onClick: onPublish,
                                                                                                    get children () {
                                                                                                        return [
                                                                                                            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                                solid: true,
                                                                                                                plus: true,
                                                                                                                inline: true,
                                                                                                                weak: true
                                                                                                            }),
                                                                                                            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('versions.branches.publish'))
                                                                                                        ];
                                                                                                    }
                                                                                                }));
                                                                                                return _el$25;
                                                                                            }
                                                                                        }), null);
                                                                                        return _el$23;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        var _el$26 = $58b7e17de267e8d7$var$_tmpl$14();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$26, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                                            get each () {
                                                                                                return versionBranches();
                                                                                            },
                                                                                            get fallback () {
                                                                                                return (()=>{
                                                                                                    var _el$31 = $58b7e17de267e8d7$var$_tmpl$4();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$31, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                                                        resource: versionBranches,
                                                                                                        get empty () {
                                                                                                            return (()=>{
                                                                                                                var _el$32 = $58b7e17de267e8d7$var$_tmpl$5();
                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$32, ()=>t('versions.branches.empty'));
                                                                                                                return _el$32;
                                                                                                            })();
                                                                                                        }
                                                                                                    }));
                                                                                                    return _el$31;
                                                                                                })();
                                                                                            },
                                                                                            children: (versionBranch)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                                                    get href () {
                                                                                                        return (0, $c900760615f37aa7$export$5be20f864ea0a7)(project.id, versionBranch.branchId);
                                                                                                    },
                                                                                                    get children () {
                                                                                                        return [
                                                                                                            (()=>{
                                                                                                                var _el$33 = $58b7e17de267e8d7$var$_tmpl$6();
                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$33, ()=>versionBranch.branchTitle);
                                                                                                                return _el$33;
                                                                                                            })(),
                                                                                                            (()=>{
                                                                                                                var _el$34 = $58b7e17de267e8d7$var$_tmpl$15();
                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$34, ()=>t(versionBranch.isCurrent ? 'versions.current' : 'versions.previous'));
                                                                                                                return _el$34;
                                                                                                            })(),
                                                                                                            (()=>{
                                                                                                                var _el$35 = $58b7e17de267e8d7$var$_tmpl$9();
                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$35, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                                                                                                    get date () {
                                                                                                                        return new Date(versionBranch.published);
                                                                                                                    }
                                                                                                                }));
                                                                                                                return _el$35;
                                                                                                            })()
                                                                                                        ];
                                                                                                    }
                                                                                                })
                                                                                        }));
                                                                                        return _el$26;
                                                                                    })(),
                                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                        get when () {
                                                                                            return project.userPossibleActions.indexOf('deployVersionToSite') >= 0;
                                                                                        },
                                                                                        get children () {
                                                                                            return [
                                                                                                (()=>{
                                                                                                    var _el$27 = $58b7e17de267e8d7$var$_tmpl$12();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$27, ()=>t('versions.deploy_to_site.header'));
                                                                                                    return _el$27;
                                                                                                })(),
                                                                                                (()=>{
                                                                                                    var _el$28 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$28, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                                        onClick: onDeployToSite,
                                                                                                        get children () {
                                                                                                            return t('versions.deploy_to_site');
                                                                                                        }
                                                                                                    }));
                                                                                                    return _el$28;
                                                                                                })()
                                                                                            ];
                                                                                        }
                                                                                    }),
                                                                                    (()=>{
                                                                                        var _el$29 = $58b7e17de267e8d7$var$_tmpl$3();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$29, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$8e2513724899fb47), {
                                                                                            project: project,
                                                                                            get title () {
                                                                                                return t('versions.manage');
                                                                                            },
                                                                                            get items () {
                                                                                                return [
                                                                                                    {
                                                                                                        key: 'rename',
                                                                                                        title: t('versions.rename'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            solid: true,
                                                                                                            pen: true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        action: 'patchVersion'
                                                                                                    },
                                                                                                    {
                                                                                                        key: 'edit_description',
                                                                                                        title: t('versions.edit_description'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            regular: true,
                                                                                                            "file-lines": true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        action: 'patchVersion'
                                                                                                    },
                                                                                                    {
                                                                                                        key: 'delete',
                                                                                                        title: t('versions.delete'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            regular: true,
                                                                                                            "trash-can": true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        danger: true,
                                                                                                        action: 'deleteVersion'
                                                                                                    }
                                                                                                ];
                                                                                            },
                                                                                            onSelect: onVersionAction
                                                                                        }));
                                                                                        return _el$29;
                                                                                    })()
                                                                                ];
                                                                            }
                                                                        },
                                                                        {
                                                                            path: 'packages',
                                                                            component: ()=>PackagesSubroute({
                                                                                    branch: branch,
                                                                                    version: version,
                                                                                    versionPackages: versionPackages
                                                                                })
                                                                        }
                                                                    ]
                                                                })
                                                            ];
                                                        }
                                                    });
                                                }
                                            }
                                        ]
                                    });
                                const PackagesSubroute = ({ branch: branch, version: version, versionPackages: versionPackages, refetchVersionPackages: refetchVersionPackages })=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                        routes: [
                                            {
                                                path: '',
                                                component: ()=>{
                                                    return [];
                                                }
                                            },
                                            {
                                                component: (props)=>{
                                                    const [pkg, { refetch: refetchPackage }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(()=>props.route, async (route)=>{
                                                        try {
                                                            return await api.getProjectsPackages1({
                                                                project: project.id,
                                                                _package: route
                                                            });
                                                        } catch (e) {}
                                                    });
                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return pkg();
                                                        },
                                                        keyed: true,
                                                        get fallback () {
                                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                resource: pkg,
                                                                page: true
                                                            });
                                                        },
                                                        children: (pkg)=>[
                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                                                    get title () {
                                                                        return t('packages.header')(project.title, pkg.title);
                                                                    },
                                                                    breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                            get href () {
                                                                                return (0, $c900760615f37aa7$export$2950deb3882ada89)({
                                                                                    projectId: project.id,
                                                                                    branchId: branch?.id,
                                                                                    versionId: version?.id,
                                                                                    packageId: pkg.id
                                                                                });
                                                                            },
                                                                            get children () {
                                                                                return pkg.title;
                                                                            }
                                                                        }),
                                                                    uiClass: "package",
                                                                    sidelinks: ()=>({
                                                                            header: t('projects.packages'),
                                                                            items: (versionPackages?.() ?? []).map((otherPackage)=>({
                                                                                    title: otherPackage.title,
                                                                                    link: (0, $c900760615f37aa7$export$2950deb3882ada89)({
                                                                                        projectId: project.id,
                                                                                        branchId: branch?.id,
                                                                                        versionId: version?.id,
                                                                                        packageId: otherPackage.id
                                                                                    }),
                                                                                    selected: otherPackage.id === pkg.id
                                                                                }))
                                                                        })
                                                                }),
                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                                                    routes: [
                                                                        {
                                                                            path: '',
                                                                            component: ()=>{
                                                                                const [rootEntry] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(pkg, async (pkg)=>{
                                                                                    const url = new URL(await api.getProjectsPackagesDownload({
                                                                                        project: project.id,
                                                                                        _package: pkg.id
                                                                                    }), (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
                                                                                    url.searchParams.set('filter', 'index');
                                                                                    return await (0, $fe57e090ef2afef2$export$b6eb13e118c144bd)(url.toString());
                                                                                });
                                                                                const onPackageAction = async (key)=>{
                                                                                    switch(key){
                                                                                        case 'rename':
                                                                                            {
                                                                                                const newPackageTitle = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$a551a871839880f9), {
                                                                                                    header: t('packages.rename_dialog.header'),
                                                                                                    label: t('packages.rename_dialog.label'),
                                                                                                    value: pkg.title,
                                                                                                    ok: t('packages.rename_dialog.ok')
                                                                                                });
                                                                                                if (!newPackageTitle) return;
                                                                                                await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                                    await api.patchProjectsPackages({
                                                                                                        project: project.id,
                                                                                                        _package: pkg.id,
                                                                                                        requestBody: {
                                                                                                            title: newPackageTitle
                                                                                                        }
                                                                                                    });
                                                                                                });
                                                                                                refetchPackage();
                                                                                                refetchVersionPackages?.();
                                                                                                break;
                                                                                            }
                                                                                        case 'edit_tags':
                                                                                            {
                                                                                                const newPackageTags = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $eb92de567b07383b$export$ac808de93d2f334b), {
                                                                                                    pkg: pkg
                                                                                                });
                                                                                                if (newPackageTags == undefined) return;
                                                                                                await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                                    await api.patchProjectsPackages({
                                                                                                        project: project.id,
                                                                                                        _package: pkg.id,
                                                                                                        requestBody: {
                                                                                                            tags: newPackageTags.toArray()
                                                                                                        }
                                                                                                    });
                                                                                                });
                                                                                                refetchPackage();
                                                                                                refetchVersionPackages?.();
                                                                                                break;
                                                                                            }
                                                                                        case 'delete':
                                                                                            if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                                                                header: t('packages.delete_dialog.header'),
                                                                                                message: t('packages.delete_dialog.message')((()=>{
                                                                                                    var _el$36 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$36, ()=>pkg.title);
                                                                                                    return _el$36;
                                                                                                })()),
                                                                                                ok: t('packages.delete_dialog.ok'),
                                                                                                focus: 'cancel',
                                                                                                danger: true
                                                                                            })) return;
                                                                                            await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                                await api.deleteProjectsPackages({
                                                                                                    project: project.id,
                                                                                                    _package: pkg.id
                                                                                                });
                                                                                            });
                                                                                            refetchVersionPackages?.();
                                                                                            navigate(version ? (0, $c900760615f37aa7$export$18639e2046d399f4)({
                                                                                                projectId: project.id,
                                                                                                branchId: branch?.id,
                                                                                                versionId: version.id
                                                                                            }) : (0, $c900760615f37aa7$export$d9c91539b7b67f34)(project.id));
                                                                                            break;
                                                                                    }
                                                                                };
                                                                                return [
                                                                                    (()=>{
                                                                                        var _el$37 = $58b7e17de267e8d7$var$_tmpl$10(), _el$38 = _el$37.firstChild, _el$40 = _el$38.nextSibling;
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$38, ()=>t('packages.header')(project.title, pkg.title));
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$37, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                            get when () {
                                                                                                return project.userPossibleActions.indexOf('patchPackage') >= 0;
                                                                                            },
                                                                                            get children () {
                                                                                                var _el$39 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$39, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                                    light: true,
                                                                                                    onClick: ()=>onPackageAction('rename'),
                                                                                                    get children () {
                                                                                                        return t('packages.rename');
                                                                                                    }
                                                                                                }));
                                                                                                return _el$39;
                                                                                            }
                                                                                        }), _el$40);
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$40, ()=>t('packages.header.hint'));
                                                                                        return _el$37;
                                                                                    })(),
                                                                                    (()=>{
                                                                                        var _el$41 = $58b7e17de267e8d7$var$_tmpl$0();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$41, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $4cadc02efe646f32$export$a41f7b788abf9c93), {
                                                                                            project: project,
                                                                                            branch: branch,
                                                                                            version: version,
                                                                                            pkg: pkg
                                                                                        }));
                                                                                        return _el$41;
                                                                                    })(),
                                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
                                                                                        get tags () {
                                                                                            return (0, $9DGpR.Set)(pkg.tags);
                                                                                        },
                                                                                        showCodes: true,
                                                                                        get children () {
                                                                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                                get when () {
                                                                                                    return project.userPossibleActions.indexOf('patchPackage') >= 0;
                                                                                                },
                                                                                                get children () {
                                                                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                                        light: true,
                                                                                                        onClick: ()=>onPackageAction('edit_tags'),
                                                                                                        get children () {
                                                                                                            return t('packages.edit_tags');
                                                                                                        }
                                                                                                    });
                                                                                                }
                                                                                            });
                                                                                        }
                                                                                    }),
                                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                        get when () {
                                                                                            return rootEntry();
                                                                                        },
                                                                                        get fallback () {
                                                                                            return (()=>{
                                                                                                var _el$45 = $58b7e17de267e8d7$var$_tmpl$16();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$45, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                                                    resource: rootEntry
                                                                                                }));
                                                                                                return _el$45;
                                                                                            })();
                                                                                        },
                                                                                        get children () {
                                                                                            return [
                                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$240af65705974100), {
                                                                                                    get children () {
                                                                                                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$2633c22b7a1b7cb), {
                                                                                                            get root () {
                                                                                                                return rootEntry();
                                                                                                            },
                                                                                                            get entrypoint () {
                                                                                                                return (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>(0, $9DGpR.List)(pkg.entrypoint));
                                                                                                            }
                                                                                                        });
                                                                                                    }
                                                                                                }),
                                                                                                (()=>{
                                                                                                    var _el$42 = $58b7e17de267e8d7$var$_tmpl$16();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$42, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                                        get when () {
                                                                                                            return pkg.entrypoint.length > 0;
                                                                                                        },
                                                                                                        get fallback () {
                                                                                                            return t('packages.entrypoint.empty');
                                                                                                        },
                                                                                                        get children () {
                                                                                                            return t('packages.entrypoint')([
                                                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                                    solid: true,
                                                                                                                    play: true,
                                                                                                                    inline: true,
                                                                                                                    weak: true
                                                                                                                }),
                                                                                                                (()=>{
                                                                                                                    var _el$46 = $58b7e17de267e8d7$var$_tmpl$18();
                                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$46, ()=>pkg.entrypoint.join('/'));
                                                                                                                    return _el$46;
                                                                                                                })()
                                                                                                            ]);
                                                                                                        }
                                                                                                    }));
                                                                                                    return _el$42;
                                                                                                })(),
                                                                                                (()=>{
                                                                                                    var _el$43 = $58b7e17de267e8d7$var$_tmpl$17();
                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$43, ()=>t('packages.total_size')((()=>{
                                                                                                            var _el$47 = $58b7e17de267e8d7$var$_tmpl$19();
                                                                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$47, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
                                                                                                                get size () {
                                                                                                                    return rootEntry().totalSize();
                                                                                                                }
                                                                                                            }));
                                                                                                            return _el$47;
                                                                                                        })()));
                                                                                                    return _el$43;
                                                                                                })()
                                                                                            ];
                                                                                        }
                                                                                    }),
                                                                                    (()=>{
                                                                                        var _el$44 = $58b7e17de267e8d7$var$_tmpl$3();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$44, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$8e2513724899fb47), {
                                                                                            project: project,
                                                                                            get title () {
                                                                                                return t('packages.manage');
                                                                                            },
                                                                                            get items () {
                                                                                                return [
                                                                                                    {
                                                                                                        key: 'rename',
                                                                                                        title: t('packages.rename'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            solid: true,
                                                                                                            pen: true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        action: 'patchPackage'
                                                                                                    },
                                                                                                    {
                                                                                                        key: 'edit_tags',
                                                                                                        title: t('packages.edit_tags'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            solid: true,
                                                                                                            tags: true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        action: 'patchPackage'
                                                                                                    },
                                                                                                    {
                                                                                                        key: 'delete',
                                                                                                        title: t('packages.delete'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            regular: true,
                                                                                                            "trash-can": true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        danger: true,
                                                                                                        action: 'deletePackage'
                                                                                                    }
                                                                                                ];
                                                                                            },
                                                                                            onSelect: onPackageAction
                                                                                        }));
                                                                                        return _el$44;
                                                                                    })()
                                                                                ];
                                                                            }
                                                                        },
                                                                        {
                                                                            path: 'play',
                                                                            component: ()=>{
                                                                                const [spaceUrlResource] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                                                                    const spaceUrl = new URL(await api.getProjectsPackagesSpace({
                                                                                        project: project.id,
                                                                                        _package: pkg.id
                                                                                    }));
                                                                                    spaceUrl.pathname += pkg.entrypoint.join('/');
                                                                                    return spaceUrl.toString();
                                                                                });
                                                                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1024668015f4bbf6$export$f4545b84808b8529), {
                                                                                    spaceUrlResource: spaceUrlResource
                                                                                });
                                                                            }
                                                                        }
                                                                    ]
                                                                })
                                                            ]
                                                    });
                                                }
                                            }
                                        ]
                                    });
                                return [
                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                        get title () {
                                            return project.title;
                                        },
                                        breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                get href () {
                                                    return (0, $c900760615f37aa7$export$d9c91539b7b67f34)(project.id);
                                                },
                                                get children () {
                                                    return project.title;
                                                }
                                            }),
                                        uiClass: "project",
                                        sidelinks: ()=>({
                                                header: t('projects'),
                                                items: (projects() ?? []).map((otherProject)=>({
                                                        title: otherProject.title,
                                                        link: (0, $c900760615f37aa7$export$d9c91539b7b67f34)(otherProject.id),
                                                        selected: otherProject.id === project.id
                                                    }))
                                            })
                                    }),
                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                        routes: [
                                            {
                                                path: '',
                                                component: ()=>[
                                                        (()=>{
                                                            var _el$48 = $58b7e17de267e8d7$var$_tmpl$10(), _el$49 = _el$48.firstChild, _el$51 = _el$49.nextSibling;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$49, ()=>project.title);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$48, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return project.userPossibleActions.indexOf('patchProject') >= 0;
                                                                },
                                                                get children () {
                                                                    var _el$50 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$50, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                        light: true,
                                                                        onClick: ()=>onProjectAction('rename'),
                                                                        get children () {
                                                                            return t('projects.rename');
                                                                        }
                                                                    }));
                                                                    return _el$50;
                                                                }
                                                            }), _el$51);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$51, ()=>t('projects.project.hint'));
                                                            return _el$48;
                                                        })(),
                                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return project.isPublic;
                                                            },
                                                            get children () {
                                                                var _el$52 = $58b7e17de267e8d7$var$_tmpl$20(), _el$53 = _el$52.firstChild;
                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$53, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                    solid: true,
                                                                    weak: true,
                                                                    inline: true,
                                                                    store: true
                                                                }), null);
                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$53, ()=>t('projects.store_page'), null);
                                                                (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$53, "href", (0, $c900760615f37aa7$export$4934a533ea20858c)(project.id)));
                                                                return _el$52;
                                                            }
                                                        }),
                                                        (()=>{
                                                            var _el$54 = $58b7e17de267e8d7$var$_tmpl$11(), _el$55 = _el$54.firstChild;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$55, ()=>t('projects.description'));
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$54, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return project.userPossibleActions.indexOf('patchProject') >= 0;
                                                                },
                                                                get children () {
                                                                    var _el$56 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$56, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                        light: true,
                                                                        onClick: ()=>onProjectAction('edit_description'),
                                                                        get children () {
                                                                            return t('projects.edit_description');
                                                                        }
                                                                    }));
                                                                    return _el$56;
                                                                }
                                                            }), null);
                                                            return _el$54;
                                                        })(),
                                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return projectDescription();
                                                            },
                                                            get fallback () {
                                                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                    resource: projectDescription
                                                                });
                                                            },
                                                            get children () {
                                                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c9ba532eab0ac5a8$export$d5163f1ce1e6a5f9), {
                                                                    markdown: ()=>projectDescription(),
                                                                    level: 3,
                                                                    ugc: true,
                                                                    linkInNewTab: true
                                                                });
                                                            }
                                                        }),
                                                        (()=>{
                                                            var _el$57 = $58b7e17de267e8d7$var$_tmpl$21(), _el$58 = _el$57.firstChild, _el$59 = _el$58.nextSibling;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$58, ()=>t('projects.branches'));
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$59, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return project.userPossibleActions.indexOf('createBranch') >= 0;
                                                                },
                                                                get children () {
                                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                        onClick: onCreateBranch,
                                                                        get children () {
                                                                            return [
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                    solid: true,
                                                                                    plus: true,
                                                                                    inline: true,
                                                                                    weak: true
                                                                                }),
                                                                                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('branches.new'))
                                                                            ];
                                                                        }
                                                                    });
                                                                }
                                                            }));
                                                            return _el$57;
                                                        })(),
                                                        (()=>{
                                                            var _el$60 = $58b7e17de267e8d7$var$_tmpl$14();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$60, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                get each () {
                                                                    return branches();
                                                                },
                                                                get fallback () {
                                                                    return (()=>{
                                                                        var _el$63 = $58b7e17de267e8d7$var$_tmpl$4();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$63, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                            resource: branches,
                                                                            get empty () {
                                                                                return (()=>{
                                                                                    var _el$64 = $58b7e17de267e8d7$var$_tmpl$5();
                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$64, ()=>t('branches.no_branches'));
                                                                                    return _el$64;
                                                                                })();
                                                                            }
                                                                        }));
                                                                        return _el$63;
                                                                    })();
                                                                },
                                                                children: (branch)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                        get href () {
                                                                            return (0, $c900760615f37aa7$export$5be20f864ea0a7)(project.id, branch.id);
                                                                        },
                                                                        get children () {
                                                                            return [
                                                                                (()=>{
                                                                                    var _el$65 = $58b7e17de267e8d7$var$_tmpl$6();
                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$65, ()=>branch.title);
                                                                                    return _el$65;
                                                                                })(),
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                    get when () {
                                                                                        return branch.currentVersion;
                                                                                    },
                                                                                    get children () {
                                                                                        return [
                                                                                            (()=>{
                                                                                                var _el$66 = $58b7e17de267e8d7$var$_tmpl$23();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$66, ()=>branch.currentVersion.version.title);
                                                                                                return _el$66;
                                                                                            })(),
                                                                                            (()=>{
                                                                                                var _el$67 = $58b7e17de267e8d7$var$_tmpl$24();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$67, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                                                                                    get date () {
                                                                                                        return new Date(branch.currentVersion.published);
                                                                                                    }
                                                                                                }));
                                                                                                return _el$67;
                                                                                            })()
                                                                                        ];
                                                                                    }
                                                                                })
                                                                            ];
                                                                        }
                                                                    })
                                                            }));
                                                            return _el$60;
                                                        })(),
                                                        (()=>{
                                                            var _el$61 = $58b7e17de267e8d7$var$_tmpl$22(), _el$62 = _el$61.firstChild;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$62, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                get href () {
                                                                    return (0, $c900760615f37aa7$export$84bf59898a10bb0e)(project.id);
                                                                },
                                                                get children () {
                                                                    return t('projects.management');
                                                                }
                                                            }));
                                                            return _el$61;
                                                        })()
                                                    ]
                                            },
                                            {
                                                path: 'branches',
                                                component: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                                        routes: [
                                                            {
                                                                component: (props)=>{
                                                                    const branch = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>branchesById()[props.route]);
                                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                        get when () {
                                                                            return branch();
                                                                        },
                                                                        keyed: true,
                                                                        get fallback () {
                                                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                                resource: branches,
                                                                                page: true
                                                                            });
                                                                        },
                                                                        children: (branch)=>{
                                                                            const [branchVersions] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                                                                return await api.getProjectsBranchesVersions({
                                                                                    project: project.id,
                                                                                    branch: branch.id
                                                                                });
                                                                            });
                                                                            const [currentVersionPackages] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(branch.currentVersion, async (branchVersion)=>{
                                                                                if (!branchVersion) return;
                                                                                return await api.getProjectsVersionsPackages({
                                                                                    project: project.id,
                                                                                    version: branchVersion.version.id
                                                                                });
                                                                            });
                                                                            const putVersion = async (versionId)=>{
                                                                                await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                    await api.postProjectsBranchesVersions({
                                                                                        project: project.id,
                                                                                        branch: branch.id,
                                                                                        version: versionId
                                                                                    });
                                                                                    refetchBranches();
                                                                                });
                                                                            };
                                                                            const onPublishNewVersion = async ()=>{
                                                                                const baseVersion = branch.currentVersion?.version;
                                                                                const versionId = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $6afe1cf3aea4b123$export$e0dfd3e047556b8b), {
                                                                                    project: project,
                                                                                    projectQuotas: projectQuotas(),
                                                                                    branch: branch,
                                                                                    baseVersion: baseVersion,
                                                                                    initialVersionTitle: $58b7e17de267e8d7$var$calculateNextVersionTitle(baseVersion?.title) ?? '1.0.0'
                                                                                });
                                                                                if (!versionId) return;
                                                                                refetchVersions();
                                                                                await putVersion(versionId);
                                                                            };
                                                                            const onPublishExistingVersion = async ()=>{
                                                                                const versionId = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $3737fd6ddf50a8c5$export$2118d960daa50051), {
                                                                                    project: project,
                                                                                    currentVersion: branch.currentVersion?.version
                                                                                });
                                                                                if (!versionId) return;
                                                                                await putVersion(versionId);
                                                                            };
                                                                            const onBranchAction = async (key)=>{
                                                                                switch(key){
                                                                                    case 'rename':
                                                                                        {
                                                                                            const newBranchTitle = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$a551a871839880f9), {
                                                                                                header: t('branches.rename_dialog.header'),
                                                                                                label: t('branches.rename_dialog.label'),
                                                                                                value: branch.title,
                                                                                                ok: t('branches.rename_dialog.ok')
                                                                                            });
                                                                                            if (!newBranchTitle) return;
                                                                                            await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                                await api.patchProjectsBranches({
                                                                                                    project: project.id,
                                                                                                    branch: branch.id,
                                                                                                    requestBody: {
                                                                                                        title: newBranchTitle
                                                                                                    }
                                                                                                });
                                                                                            });
                                                                                            refetchBranches();
                                                                                            break;
                                                                                        }
                                                                                    case 'delete':
                                                                                        if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                                                            header: t('branches.delete_dialog.header'),
                                                                                            message: t('branches.delete_dialog.message')((()=>{
                                                                                                var _el$68 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$68, ()=>branch.title);
                                                                                                return _el$68;
                                                                                            })()),
                                                                                            ok: t('branches.delete_dialog.ok'),
                                                                                            focus: 'cancel',
                                                                                            danger: true
                                                                                        })) return;
                                                                                        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                                                            await api.deleteProjectsBranches({
                                                                                                project: project.id,
                                                                                                branch: branch.id
                                                                                            });
                                                                                        });
                                                                                        refetchBranches();
                                                                                        navigate((0, $c900760615f37aa7$export$d9c91539b7b67f34)(project.id));
                                                                                        break;
                                                                                }
                                                                            };
                                                                            const CurrentVersionButtons = ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                    get when () {
                                                                                        return project.userPossibleActions.indexOf('publishVersion') >= 0;
                                                                                    },
                                                                                    get children () {
                                                                                        var _el$69 = $58b7e17de267e8d7$var$_tmpl$0();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$69, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$d5503927a7d116d), {
                                                                                            get actions () {
                                                                                                return [
                                                                                                    {
                                                                                                        title: t('branches.publish_version.new'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            solid: true,
                                                                                                            plus: true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        onAction: onPublishNewVersion
                                                                                                    },
                                                                                                    {
                                                                                                        title: t('branches.publish_version.existing'),
                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                            solid: true,
                                                                                                            retweet: true,
                                                                                                            inline: true,
                                                                                                            weak: true
                                                                                                        }),
                                                                                                        onAction: onPublishExistingVersion
                                                                                                    }
                                                                                                ];
                                                                                            }
                                                                                        }));
                                                                                        return _el$69;
                                                                                    }
                                                                                });
                                                                            return [
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                                                                    get title () {
                                                                                        return t('branches.header')(project.title, branch.title);
                                                                                    },
                                                                                    breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                                            get href () {
                                                                                                return (0, $c900760615f37aa7$export$5be20f864ea0a7)(project.id, branch.id);
                                                                                            },
                                                                                            get children () {
                                                                                                return branch.title;
                                                                                            }
                                                                                        }),
                                                                                    uiClass: "branch",
                                                                                    sidelinks: ()=>({
                                                                                            header: t('projects.branches'),
                                                                                            items: (branches() ?? []).map((otherBranch)=>({
                                                                                                    title: otherBranch.title,
                                                                                                    link: (0, $c900760615f37aa7$export$5be20f864ea0a7)(project.id, otherBranch.id),
                                                                                                    selected: otherBranch.id === branch.id
                                                                                                }))
                                                                                        })
                                                                                }),
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                                                                    routes: [
                                                                                        {
                                                                                            path: '',
                                                                                            component: ()=>[
                                                                                                    (()=>{
                                                                                                        var _el$70 = $58b7e17de267e8d7$var$_tmpl$10(), _el$71 = _el$70.firstChild, _el$73 = _el$71.nextSibling;
                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$71, ()=>t('branches.header')(project.title, branch.title));
                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$70, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                                            get when () {
                                                                                                                return project.userPossibleActions.indexOf('patchBranch') >= 0;
                                                                                                            },
                                                                                                            get children () {
                                                                                                                var _el$72 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$72, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                                                    light: true,
                                                                                                                    onClick: ()=>onBranchAction('rename'),
                                                                                                                    get children () {
                                                                                                                        return t('branches.rename');
                                                                                                                    }
                                                                                                                }));
                                                                                                                return _el$72;
                                                                                                            }
                                                                                                        }), _el$73);
                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$73, ()=>t('branches.header.hint'));
                                                                                                        return _el$70;
                                                                                                    })(),
                                                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                                        get when () {
                                                                                                            return branch.currentVersion;
                                                                                                        },
                                                                                                        get fallback () {
                                                                                                            return (()=>{
                                                                                                                var _el$78 = $58b7e17de267e8d7$var$_tmpl$11(), _el$79 = _el$78.firstChild;
                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$79, ()=>t('branches.no_current_version'));
                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$78, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(CurrentVersionButtons, {}), null);
                                                                                                                return _el$78;
                                                                                                            })();
                                                                                                        },
                                                                                                        children: (currentVersion)=>[
                                                                                                                (()=>{
                                                                                                                    var _el$80 = $58b7e17de267e8d7$var$_tmpl$11(), _el$81 = _el$80.firstChild;
                                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$81, ()=>t('branches.current_version')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                                                                            "class": "current_version",
                                                                                                                            get href () {
                                                                                                                                return (0, $c900760615f37aa7$export$18639e2046d399f4)({
                                                                                                                                    projectId: project.id,
                                                                                                                                    branchId: branch.id,
                                                                                                                                    versionId: currentVersion().version.id
                                                                                                                                });
                                                                                                                            },
                                                                                                                            get children () {
                                                                                                                                return currentVersion().version.title;
                                                                                                                            }
                                                                                                                        })));
                                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$80, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)(CurrentVersionButtons, {}), null);
                                                                                                                    return _el$80;
                                                                                                                })(),
                                                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c9ba532eab0ac5a8$export$d5163f1ce1e6a5f9), {
                                                                                                                    markdown: ()=>({
                                                                                                                            markdown: currentVersion().version.description,
                                                                                                                            lang: projectDescription()?.lang,
                                                                                                                            images: []
                                                                                                                        }),
                                                                                                                    level: 3,
                                                                                                                    ugc: true,
                                                                                                                    linkInNewTab: true
                                                                                                                }),
                                                                                                                (()=>{
                                                                                                                    var _el$82 = $58b7e17de267e8d7$var$_tmpl$27();
                                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$82, ()=>t('branches.current_version.packages'));
                                                                                                                    return _el$82;
                                                                                                                })(),
                                                                                                                (()=>{
                                                                                                                    var _el$83 = $58b7e17de267e8d7$var$_tmpl$13();
                                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$83, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                                                                        get each () {
                                                                                                                            return currentVersionPackages();
                                                                                                                        },
                                                                                                                        get fallback () {
                                                                                                                            return (()=>{
                                                                                                                                var _el$84 = $58b7e17de267e8d7$var$_tmpl$4();
                                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$84, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                                                                                    resource: currentVersionPackages
                                                                                                                                }));
                                                                                                                                return _el$84;
                                                                                                                            })();
                                                                                                                        },
                                                                                                                        children: (pkg)=>Package({
                                                                                                                                branch: branch,
                                                                                                                                version: currentVersion().version,
                                                                                                                                pkg: pkg
                                                                                                                            })
                                                                                                                    }));
                                                                                                                    return _el$83;
                                                                                                                })()
                                                                                                            ]
                                                                                                    }),
                                                                                                    (()=>{
                                                                                                        var _el$74 = $58b7e17de267e8d7$var$_tmpl$12();
                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$74, ()=>t('branches.version_history'));
                                                                                                        return _el$74;
                                                                                                    })(),
                                                                                                    (()=>{
                                                                                                        var _el$75 = $58b7e17de267e8d7$var$_tmpl$25();
                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$75, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                                                            get each () {
                                                                                                                return branchVersions();
                                                                                                            },
                                                                                                            get fallback () {
                                                                                                                return (()=>{
                                                                                                                    var _el$85 = $58b7e17de267e8d7$var$_tmpl$4();
                                                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$85, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                                                                        resource: branchVersions,
                                                                                                                        get empty () {
                                                                                                                            return (()=>{
                                                                                                                                var _el$86 = $58b7e17de267e8d7$var$_tmpl$16();
                                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$86, ()=>t('branches.version_history.empty'));
                                                                                                                                return _el$86;
                                                                                                                            })();
                                                                                                                        }
                                                                                                                    }));
                                                                                                                    return _el$85;
                                                                                                                })();
                                                                                                            },
                                                                                                            children: (branchVersion)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                                                                    get href () {
                                                                                                                        return (0, $c900760615f37aa7$export$18639e2046d399f4)({
                                                                                                                            projectId: project.id,
                                                                                                                            branchId: branch.id,
                                                                                                                            versionId: branchVersion.version.id
                                                                                                                        });
                                                                                                                    },
                                                                                                                    get children () {
                                                                                                                        return [
                                                                                                                            (()=>{
                                                                                                                                var _el$87 = $58b7e17de267e8d7$var$_tmpl$6();
                                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$87, ()=>branchVersion.version.title);
                                                                                                                                return _el$87;
                                                                                                                            })(),
                                                                                                                            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c9ba532eab0ac5a8$export$9a7d1eba5fa630bb), {
                                                                                                                                markdown: ()=>branchVersion.version.description,
                                                                                                                                lang: ()=>projectDescription()?.lang,
                                                                                                                                classList: {
                                                                                                                                    description: true
                                                                                                                                }
                                                                                                                            }),
                                                                                                                            (()=>{
                                                                                                                                var _el$88 = $58b7e17de267e8d7$var$_tmpl$15();
                                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$88, ()=>t(branchVersion.isCurrent ? 'versions.current' : 'versions.previous'));
                                                                                                                                return _el$88;
                                                                                                                            })(),
                                                                                                                            (()=>{
                                                                                                                                var _el$89 = $58b7e17de267e8d7$var$_tmpl$9();
                                                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$89, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                                                                                                                    get date () {
                                                                                                                                        return new Date(branchVersion.published);
                                                                                                                                    }
                                                                                                                                }));
                                                                                                                                return _el$89;
                                                                                                                            })()
                                                                                                                        ];
                                                                                                                    }
                                                                                                                })
                                                                                                        }));
                                                                                                        return _el$75;
                                                                                                    })(),
                                                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                                        get when () {
                                                                                                            return (branchVersions()?.length ?? 0) > 0;
                                                                                                        },
                                                                                                        get children () {
                                                                                                            var _el$76 = $58b7e17de267e8d7$var$_tmpl$26();
                                                                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$76, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                                solid: true,
                                                                                                                warning: true,
                                                                                                                inline: true
                                                                                                            }), null);
                                                                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$76, ()=>t('branches.version_history.note_removal')({
                                                                                                                    quotaCount: projectQuotas()?.branchVersionsCount,
                                                                                                                    quotaCountText: (()=>{
                                                                                                                        var _el$90 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$90, ()=>projectQuotas()?.branchVersionsCount);
                                                                                                                        return _el$90;
                                                                                                                    })(),
                                                                                                                    quotaNonCurrentTime: (()=>{
                                                                                                                        var _el$91 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$91, ()=>(0, $f3842ea939e9c33f$export$3b11bc38611c5941).fromObject({
                                                                                                                                seconds: projectQuotas()?.branchVersionsNonCurrentTime
                                                                                                                            }, {
                                                                                                                                locale: t('locale')
                                                                                                                            }).shiftTo('days').toHuman());
                                                                                                                        return _el$91;
                                                                                                                    })(),
                                                                                                                    quotaTime: projectQuotas()?.branchVersionsTime ? (()=>{
                                                                                                                        var _el$92 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$92, ()=>(0, $f3842ea939e9c33f$export$3b11bc38611c5941).fromObject({
                                                                                                                                seconds: projectQuotas()?.branchVersionsTime
                                                                                                                            }, {
                                                                                                                                locale: t('locale')
                                                                                                                            }).shiftTo('days').toHuman());
                                                                                                                        return _el$92;
                                                                                                                    })() : null
                                                                                                                }), null);
                                                                                                            return _el$76;
                                                                                                        }
                                                                                                    }),
                                                                                                    (()=>{
                                                                                                        var _el$77 = $58b7e17de267e8d7$var$_tmpl$3();
                                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$77, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$8e2513724899fb47), {
                                                                                                            project: project,
                                                                                                            get title () {
                                                                                                                return t('branches.manage');
                                                                                                            },
                                                                                                            get items () {
                                                                                                                return [
                                                                                                                    {
                                                                                                                        key: 'rename',
                                                                                                                        title: t('branches.rename'),
                                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                                            solid: true,
                                                                                                                            pen: true,
                                                                                                                            inline: true,
                                                                                                                            weak: true
                                                                                                                        }),
                                                                                                                        action: 'patchBranch'
                                                                                                                    },
                                                                                                                    {
                                                                                                                        key: 'delete',
                                                                                                                        title: t('branches.delete'),
                                                                                                                        icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                                            regular: true,
                                                                                                                            "trash-can": true,
                                                                                                                            inline: true,
                                                                                                                            weak: true
                                                                                                                        }),
                                                                                                                        danger: true,
                                                                                                                        action: 'deleteBranch'
                                                                                                                    }
                                                                                                                ];
                                                                                                            },
                                                                                                            onSelect: onBranchAction
                                                                                                        }));
                                                                                                        return _el$77;
                                                                                                    })()
                                                                                                ]
                                                                                        },
                                                                                        {
                                                                                            path: 'versions',
                                                                                            component: ()=>VersionsSubroute({
                                                                                                    branch: branch
                                                                                                })
                                                                                        }
                                                                                    ]
                                                                                })
                                                                            ];
                                                                        }
                                                                    });
                                                                }
                                                            }
                                                        ]
                                                    })
                                            },
                                            {
                                                path: 'versions',
                                                component: ()=>VersionsSubroute({})
                                            },
                                            {
                                                path: 'packages',
                                                component: ()=>PackagesSubroute({})
                                            },
                                            {
                                                path: 'manage',
                                                component: ()=>{
                                                    const [users, { refetch: refetchUsers }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                                        const users = await api.getProjectsUsers({
                                                            project: project.id
                                                        });
                                                        const collator = Intl.Collator(t('locale'));
                                                        return users.toSorted((a, b)=>{
                                                            if (a.isOwner > b.isOwner) return -1;
                                                            if (a.isOwner < b.isOwner) return 1;
                                                            const roleOrder = -(0, $06e3e498f7096fae$export$50229fa1babb4225)(a.role, b.role);
                                                            if (roleOrder != 0) return roleOrder;
                                                            return collator.compare(a.user.title, b.user.title);
                                                        });
                                                    });
                                                    const onSetProjectUser = (user, role)=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                            if (role == undefined) {
                                                                if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                                    header: t('projects.management.users.exile.dialog.header'),
                                                                    message: t('projects.management.users.exile.dialog.message')((()=>{
                                                                        var _el$93 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$93, ()=>project.title);
                                                                        return _el$93;
                                                                    })(), (()=>{
                                                                        var _el$94 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$94, ()=>user.title);
                                                                        return _el$94;
                                                                    })()),
                                                                    ok: t('projects.management.users.exile.dialog.ok'),
                                                                    danger: true
                                                                })) return;
                                                            }
                                                            await api.putProjectsUsers({
                                                                project: project.id,
                                                                requestBody: {
                                                                    user: user.id,
                                                                    role: role
                                                                }
                                                            });
                                                            refetchUsers();
                                                        });
                                                    const onOneTimeInvite = ()=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                            const { token: token } = await api.postProjectsInvites({
                                                                project: project.id,
                                                                requestBody: {
                                                                    approved: true,
                                                                    expires: new Date(Date.now() + 86400000).toISOString(),
                                                                    seats: 1
                                                                }
                                                            });
                                                            const inviteUrl = new URL((0, $c900760615f37aa7$export$f6efd19c9704d3b1)(token), window.location.origin).toString();
                                                            await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$84a13477b53beb51), {
                                                                header: t('projects.management.invites.one_time_invite.header'),
                                                                message: t('projects.management.invites.one_time_invite.message'),
                                                                text: inviteUrl,
                                                                note: t('projects.management.invites.one_time_invite.note')
                                                            });
                                                        });
                                                    const [deploySites, { refetch: refetchDeploySites }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                                        return await api.getProjectsDeploySites({
                                                            project: project.id
                                                        });
                                                    });
                                                    const onAddDeploySite = async ()=>{
                                                        const deploySiteId = await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $47e9739db5f31991$export$25a15dedccd726b7), {
                                                            project: project
                                                        });
                                                        if (deploySiteId) refetchDeploySites();
                                                    };
                                                    const onToggleProjectIsPublic = async ()=>{
                                                        const enable = !project.isPublic;
                                                        if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                            header: t(`projects.management.public_access.${enable ? 'enable' : 'disable'}_dialog.header`),
                                                            message: t(`projects.management.public_access.${enable ? 'enable' : 'disable'}_dialog.message`)((()=>{
                                                                var _el$95 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$95, ()=>project.title);
                                                                return _el$95;
                                                            })()),
                                                            focus: 'cancel',
                                                            ok: t(`projects.management.public_access.${enable ? 'enable' : 'disable'}_dialog.ok`),
                                                            danger: true
                                                        })) return;
                                                        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                            await api.patchProjects({
                                                                project: project.id,
                                                                requestBody: {
                                                                    isPublic: enable
                                                                }
                                                            });
                                                        });
                                                        refetchProjects();
                                                    };
                                                    const onDeleteDeploySite = async (deploySite)=>{
                                                        if (!await (0, $e19c4daa2d9c3184$export$7838a3ea3d544efa)((0, $50cc9f46f1065e3e$export$2cc85109a937009e), {
                                                            header: t('projects.management.deploy_sites.delete_dialog.header'),
                                                            message: t('projects.management.deploy_sites.delete_dialog.message')((()=>{
                                                                var _el$96 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$96, ()=>t(`deploy_credential_provider.${deploySite.provider}`));
                                                                return _el$96;
                                                            })(), (()=>{
                                                                var _el$97 = $58b7e17de267e8d7$var$_tmpl$8();
                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$97, ()=>deploySite.site);
                                                                return _el$97;
                                                            })()),
                                                            ok: t('projects.management.deploy_sites.delete_dialog.ok'),
                                                            danger: true,
                                                            focus: 'cancel'
                                                        })) return;
                                                        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                            await api.deleteProjectsDeploySites({
                                                                project: project.id,
                                                                deploySite: deploySite.id
                                                            });
                                                        });
                                                        refetchDeploySites();
                                                    };
                                                    const onBranchTogglePublicAccess = async (branchId, e)=>{
                                                        e.target.disabled = true;
                                                        await (0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                                                            await api.patchProjectsBranches({
                                                                project: project.id,
                                                                branch: branchId,
                                                                requestBody: {
                                                                    isPublic: e.target.checked
                                                                }
                                                            });
                                                        });
                                                        e.target.disabled = false;
                                                        refetchBranches();
                                                    };
                                                    return [
                                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                                            get title () {
                                                                return t('projects.management.title')(project.title);
                                                            },
                                                            breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                                    get href () {
                                                                        return (0, $c900760615f37aa7$export$84bf59898a10bb0e)(project.id);
                                                                    },
                                                                    get children () {
                                                                        return t('projects.management.breadcrumb');
                                                                    }
                                                                }),
                                                            uiClass: "project_management"
                                                        }),
                                                        (()=>{
                                                            var _el$98 = $58b7e17de267e8d7$var$_tmpl$10(), _el$99 = _el$98.firstChild, _el$100 = _el$99.nextSibling;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$99, ()=>project.title);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$100, ()=>t('projects.management.hint'));
                                                            return _el$98;
                                                        })(),
                                                        (()=>{
                                                            var _el$101 = $58b7e17de267e8d7$var$_tmpl$11(), _el$102 = _el$101.firstChild;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$102, ()=>t('projects.management.users'));
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$101, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return project.userPossibleActions.indexOf('createInvite') >= 0;
                                                                },
                                                                get children () {
                                                                    var _el$103 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$103, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                        onClick: onOneTimeInvite,
                                                                        get children () {
                                                                            return [
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                    solid: true,
                                                                                    link: true,
                                                                                    inline: true,
                                                                                    weak: true
                                                                                }),
                                                                                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('projects.management.invites.one_time_invite'))
                                                                            ];
                                                                        }
                                                                    }));
                                                                    return _el$103;
                                                                }
                                                            }), null);
                                                            return _el$101;
                                                        })(),
                                                        (()=>{
                                                            var _el$104 = $58b7e17de267e8d7$var$_tmpl$28();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$104, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                get each () {
                                                                    return users();
                                                                },
                                                                get fallback () {
                                                                    return (()=>{
                                                                        var _el$119 = $58b7e17de267e8d7$var$_tmpl$4();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$119, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                            resource: users,
                                                                            get empty () {
                                                                                return (()=>{
                                                                                    var _el$120 = $58b7e17de267e8d7$var$_tmpl$5();
                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$120, ()=>t('projects.management.users.empty'));
                                                                                    return _el$120;
                                                                                })();
                                                                            }
                                                                        }));
                                                                        return _el$119;
                                                                    })();
                                                                },
                                                                children: (user)=>(()=>{
                                                                        var _el$121 = $58b7e17de267e8d7$var$_tmpl$33(), _el$122 = _el$121.firstChild;
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$121, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                            solid: true,
                                                                            "fa-2xl": true,
                                                                            get user () {
                                                                                return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!!user.isOwner)() && user.role == 'tester';
                                                                            },
                                                                            get ["user-gear"] () {
                                                                                return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!!user.isOwner)() && user.role == 'developer';
                                                                            },
                                                                            get ["user-tie"] () {
                                                                                return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!!user.isOwner)() && user.role == 'admin';
                                                                            },
                                                                            get crown () {
                                                                                return user.isOwner;
                                                                            }
                                                                        }), _el$122);
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$122, ()=>user.user.title);
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$121, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                            get when () {
                                                                                return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!!user.isOwner)() && project.userPossibleActions.indexOf('setUser') >= 0;
                                                                            },
                                                                            get fallback () {
                                                                                return (()=>{
                                                                                    var _el$123 = $58b7e17de267e8d7$var$_tmpl$7();
                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$123, ()=>t(`projects.management.users.role.${user.isOwner ? 'owner' : user.role}`));
                                                                                    return _el$123;
                                                                                })();
                                                                            },
                                                                            get children () {
                                                                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                                                                                    classList: {
                                                                                        role: true
                                                                                    },
                                                                                    get title () {
                                                                                        return t(`projects.management.users.role.${user.role}`);
                                                                                    },
                                                                                    get items () {
                                                                                        return [
                                                                                            ...(0, $06e3e498f7096fae$export$d968b981b6cbd3b3).toReversed().map((role)=>({
                                                                                                    key: role,
                                                                                                    title: t(`projects.management.users.role.${role}`),
                                                                                                    icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                                        regular: true,
                                                                                                        get circle () {
                                                                                                            return user.role != role;
                                                                                                        },
                                                                                                        get ["circle-dot"] () {
                                                                                                            return user.role == role;
                                                                                                        },
                                                                                                        inline: true
                                                                                                    })
                                                                                                })),
                                                                                            {
                                                                                                key: undefined,
                                                                                                title: t('projects.management.users.exile'),
                                                                                                danger: true
                                                                                            }
                                                                                        ];
                                                                                    },
                                                                                    onSelect: (key)=>onSetProjectUser(user.user, key)
                                                                                });
                                                                            }
                                                                        }), null);
                                                                        return _el$121;
                                                                    })()
                                                            }));
                                                            return _el$104;
                                                        })(),
                                                        (()=>{
                                                            var _el$105 = $58b7e17de267e8d7$var$_tmpl$11(), _el$106 = _el$105.firstChild;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$106, ()=>t('projects.management.deploy_sites'));
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$105, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return project.userPossibleActions.indexOf('createDeploySite') >= 0;
                                                                },
                                                                get children () {
                                                                    var _el$107 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$107, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                        onClick: onAddDeploySite,
                                                                        get children () {
                                                                            return [
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                    solid: true,
                                                                                    plus: true,
                                                                                    inline: true,
                                                                                    weak: true
                                                                                }),
                                                                                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('projects.management.deploy_sites.add'))
                                                                            ];
                                                                        }
                                                                    }));
                                                                    return _el$107;
                                                                }
                                                            }), null);
                                                            return _el$105;
                                                        })(),
                                                        (()=>{
                                                            var _el$108 = $58b7e17de267e8d7$var$_tmpl$29();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$108, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                get each () {
                                                                    return deploySites();
                                                                },
                                                                get fallback () {
                                                                    return (()=>{
                                                                        var _el$124 = $58b7e17de267e8d7$var$_tmpl$4();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$124, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                                                            resource: deploySites,
                                                                            get empty () {
                                                                                return (()=>{
                                                                                    var _el$125 = $58b7e17de267e8d7$var$_tmpl$5();
                                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$125, ()=>t('projects.management.deploy_sites.empty'));
                                                                                    return _el$125;
                                                                                })();
                                                                            }
                                                                        }));
                                                                        return _el$124;
                                                                    })();
                                                                },
                                                                children: (deploySite)=>(()=>{
                                                                        var _el$126 = $58b7e17de267e8d7$var$_tmpl$34(), _el$127 = _el$126.firstChild, _el$129 = _el$127.nextSibling;
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$126, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$d3ea39a55c5c7a6e), {
                                                                            get provider () {
                                                                                return deploySite.provider;
                                                                            },
                                                                            big: true
                                                                        }), _el$127);
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$127, ()=>deploySite.site);
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$126, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                            get when () {
                                                                                return project.userPossibleActions.indexOf('deleteDeploySite') >= 0;
                                                                            },
                                                                            get children () {
                                                                                var _el$128 = $58b7e17de267e8d7$var$_tmpl$1();
                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$128, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                                    onClick: ()=>onDeleteDeploySite(deploySite),
                                                                                    danger: true,
                                                                                    get children () {
                                                                                        return t('projects.management.deploy_sites.delete');
                                                                                    }
                                                                                }));
                                                                                return _el$128;
                                                                            }
                                                                        }), _el$129);
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$129, ()=>t(`deploy_credential_provider.${deploySite.provider}`));
                                                                        return _el$126;
                                                                    })()
                                                            }));
                                                            return _el$108;
                                                        })(),
                                                        (()=>{
                                                            var _el$109 = $58b7e17de267e8d7$var$_tmpl$12();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$109, ()=>t('projects.management.public_access'));
                                                            return _el$109;
                                                        })(),
                                                        (()=>{
                                                            var _el$110 = $58b7e17de267e8d7$var$_tmpl$32(), _el$111 = _el$110.firstChild, _el$112 = _el$111.firstChild, _el$113 = _el$112.nextSibling;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$111, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)({
                                                                solid: true,
                                                                "fa-2xl": true
                                                            }, ()=>({
                                                                    lock: !project.isPublic,
                                                                    bullhorn: project.isPublic
                                                                }))), _el$112);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$112, ()=>t(`projects.management.public_access.${project.isPublic ? 'enabled' : 'disabled'}`));
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$113, ()=>t(`projects.management.public_access.${project.isPublic ? 'enabled' : 'disabled'}.note`));
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$111, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return project.isPublic;
                                                                },
                                                                get children () {
                                                                    return [
                                                                        (()=>{
                                                                            var _el$114 = $58b7e17de267e8d7$var$_tmpl$30();
                                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$114, ()=>t('projects.store_page'));
                                                                            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$114, "href", (0, $c900760615f37aa7$export$4934a533ea20858c)(project.id)));
                                                                            return _el$114;
                                                                        })(),
                                                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                            get when () {
                                                                                return project.userPossibleActions.indexOf('patchBranch') >= 0;
                                                                            },
                                                                            get children () {
                                                                                return [
                                                                                    (()=>{
                                                                                        var _el$115 = $58b7e17de267e8d7$var$_tmpl$27();
                                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$115, ()=>t('projects.management.public_access.branches'));
                                                                                        return _el$115;
                                                                                    })(),
                                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                                        get each () {
                                                                                            return branches();
                                                                                        },
                                                                                        children: (branch)=>(()=>{
                                                                                                var _el$130 = $58b7e17de267e8d7$var$_tmpl$35(), _el$131 = _el$130.firstChild;
                                                                                                _el$131.addEventListener("change", (e)=>onBranchTogglePublicAccess(branch.id, e));
                                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$130, ()=>branch.title, null);
                                                                                                (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>_el$131.checked = branch.isPublic);
                                                                                                return _el$130;
                                                                                            })()
                                                                                    })
                                                                                ];
                                                                            }
                                                                        })
                                                                    ];
                                                                }
                                                            }), null);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$111, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>project.userPossibleActions.indexOf('patchProject') >= 0)() && (project.isPublic || (session()?.userPrivileges ?? []).indexOf('store_publish') >= 0);
                                                                },
                                                                get children () {
                                                                    var _el$116 = $58b7e17de267e8d7$var$_tmpl$31(), _el$117 = _el$116.firstChild;
                                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$117, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                        danger: true,
                                                                        onClick: onToggleProjectIsPublic,
                                                                        get children () {
                                                                            return [
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)({
                                                                                    solid: true,
                                                                                    inline: true,
                                                                                    weak: true
                                                                                }, ()=>({
                                                                                        lock: project.isPublic,
                                                                                        bullhorn: !project.isPublic
                                                                                    }))),
                                                                                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t(`projects.management.public_access.${project.isPublic ? 'disable' : 'enable'}`))
                                                                            ];
                                                                        }
                                                                    }));
                                                                    return _el$116;
                                                                }
                                                            }), null);
                                                            return _el$110;
                                                        })(),
                                                        (()=>{
                                                            var _el$118 = $58b7e17de267e8d7$var$_tmpl$3();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$118, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$8e2513724899fb47), {
                                                                project: project,
                                                                get title () {
                                                                    return t('projects.management.manage');
                                                                },
                                                                get items () {
                                                                    return [
                                                                        {
                                                                            key: 'rename',
                                                                            title: t('projects.rename'),
                                                                            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                solid: true,
                                                                                pen: true,
                                                                                inline: true,
                                                                                weak: true
                                                                            }),
                                                                            action: 'patchProject'
                                                                        },
                                                                        {
                                                                            key: 'edit_description',
                                                                            title: t('projects.edit_description'),
                                                                            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                regular: true,
                                                                                "file-lines": true,
                                                                                inline: true,
                                                                                weak: true
                                                                            }),
                                                                            action: 'patchProject'
                                                                        },
                                                                        {
                                                                            key: 'leave',
                                                                            title: t('projects.leave'),
                                                                            danger: true,
                                                                            action: 'leaveProject'
                                                                        },
                                                                        {
                                                                            key: 'delete',
                                                                            title: t('projects.delete'),
                                                                            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                regular: true,
                                                                                "trash-can": true,
                                                                                inline: true,
                                                                                weak: true
                                                                            }),
                                                                            danger: true,
                                                                            action: 'deleteProject'
                                                                        }
                                                                    ];
                                                                },
                                                                onSelect: onProjectAction
                                                            }));
                                                            return _el$118;
                                                        })()
                                                    ];
                                                }
                                            },
                                            {
                                                component: (0, $06e3e498f7096fae$export$a65c2c055de52e1d)
                                            }
                                        ]
                                    })
                                ];
                            }
                        });
                    }
                }
            ]
        })
    ];
};
// reasonably calculate next version, i.e. 1.0.0 => 1.0.1
const $58b7e17de267e8d7$var$calculateNextVersionTitle = (versionTitle)=>{
    if (!versionTitle) return null;
    const pieces = versionTitle.split('.');
    if (pieces.length <= 0) return null;
    const lastPiece = pieces[pieces.length - 1];
    if (/^[0-9]+$/.exec(lastPiece)) return pieces.toSpliced(pieces.length - 1, 1, String(Number.parseInt(lastPiece) + 1)).join('.');
    return `${versionTitle}.1`;
};




var $9DGpR = parcelRequire("9DGpR");





var $3c1b08d4f80b521f$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1>`), $3c1b08d4f80b521f$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="highlight warning"><p>`), $3c1b08d4f80b521f$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer>`), $3c1b08d4f80b521f$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1><span class=user-selectable></span><div class=hint>`), $3c1b08d4f80b521f$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h2>`), $3c1b08d4f80b521f$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list owner"><div><div><div class=owner>`), $3c1b08d4f80b521f$var$_tmpl$7 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=description>`), $3c1b08d4f80b521f$var$_tmpl$8 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer><div class=buttons><div class=spacer>`), $3c1b08d4f80b521f$var$_tmpl$9 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a class=credential rel="ugc nofollow"target=_blank>`), $3c1b08d4f80b521f$var$_tmpl$0 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=credential>`), $3c1b08d4f80b521f$var$_tmpl$1 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h3 class=user-selectable>`), $3c1b08d4f80b521f$var$_tmpl$10 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="list packages">`), $3c1b08d4f80b521f$var$_tmpl$11 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p>`), $3c1b08d4f80b521f$var$_tmpl$12 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<strong>`), $3c1b08d4f80b521f$var$_tmpl$13 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div><div class="buttons group"></div><div class=title>`);
const $3c1b08d4f80b521f$export$cf376cbc7f8478ea = ()=>{
    const { status: authStatus, api: api, tokenlessApi: tokenlessApi } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            get title () {
                return t('store');
            },
            breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                    href: (0, $c900760615f37aa7$export$cb696d453077c584),
                    get children () {
                        return t('store');
                    }
                }),
            uiClass: "store"
        }),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
            routes: [
                {
                    path: '',
                    component: ()=>[
                            (()=>{
                                var _el$ = $3c1b08d4f80b521f$var$_tmpl$();
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t('store'));
                                return _el$;
                            })(),
                            (()=>{
                                var _el$2 = $3c1b08d4f80b521f$var$_tmpl$2(), _el$3 = _el$2.firstChild;
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$3, ()=>t('in_development'));
                                return _el$2;
                            })(),
                            $3c1b08d4f80b521f$var$_tmpl$3()
                        ]
                },
                {
                    component: (props)=>{
                        const [project] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                            try {
                                return await tokenlessApi.getStoreProjects({
                                    project: props.route
                                });
                            } catch (e) {
                                return undefined;
                            }
                        });
                        const branches = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>(0, $9DGpR.Map)(project()?.branches?.map?.((branch)=>[
                                    branch.id,
                                    branch
                                ])));
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                            get when () {
                                return project();
                            },
                            keyed: true,
                            get fallback () {
                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$5a4839590a83276), {
                                    resource: project,
                                    page: true
                                });
                            },
                            children: (project)=>[
                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                        get title () {
                                            return project.title;
                                        },
                                        breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                                get href () {
                                                    return (0, $c900760615f37aa7$export$4934a533ea20858c)(project.id);
                                                },
                                                get children () {
                                                    return project.title;
                                                }
                                            }),
                                        uiClass: "store_project"
                                    }),
                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                        routes: [
                                            {
                                                path: '',
                                                component: ()=>{
                                                    const [starred, { refetch: refetchStarred }] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(()=>authStatus() === 'authenticated' ? project : undefined, async (project)=>{
                                                        return await api.getProjectsStar({
                                                            project: project.id
                                                        });
                                                    });
                                                    const onProjectStar = async ()=>{
                                                        await api.putProjectsStar({
                                                            project: project.id,
                                                            requestBody: !starred()
                                                        });
                                                        refetchStarred();
                                                    };
                                                    return [
                                                        (()=>{
                                                            var _el$5 = $3c1b08d4f80b521f$var$_tmpl$4(), _el$6 = _el$5.firstChild, _el$7 = _el$6.nextSibling;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>project.title);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('store.project.hint'));
                                                            return _el$5;
                                                        })(),
                                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return project.owner.isThirdParty;
                                                            },
                                                            get children () {
                                                                var _el$8 = $3c1b08d4f80b521f$var$_tmpl$2(), _el$9 = _el$8.firstChild;
                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t('store.project.content.warning'));
                                                                return _el$8;
                                                            }
                                                        }),
                                                        (()=>{
                                                            var _el$0 = $3c1b08d4f80b521f$var$_tmpl$5();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, ()=>t('store.project.owner'));
                                                            return _el$0;
                                                        })(),
                                                        (()=>{
                                                            var _el$1 = $3c1b08d4f80b521f$var$_tmpl$6(), _el$10 = _el$1.firstChild, _el$11 = _el$10.firstChild, _el$12 = _el$11.firstChild;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, ()=>project.owner.title);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                get each () {
                                                                    return project.owner.credentials;
                                                                },
                                                                children: (credential)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                        get when () {
                                                                            return credential.profileUrl;
                                                                        },
                                                                        get fallback () {
                                                                            return (()=>{
                                                                                var _el$20 = $3c1b08d4f80b521f$var$_tmpl$0();
                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$20, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$b56300d3452a4bc6), {
                                                                                    get provider () {
                                                                                        return credential.provider;
                                                                                    }
                                                                                }));
                                                                                return _el$20;
                                                                            })();
                                                                        },
                                                                        get children () {
                                                                            var _el$19 = $3c1b08d4f80b521f$var$_tmpl$9();
                                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$19, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$b56300d3452a4bc6), {
                                                                                get provider () {
                                                                                    return credential.provider;
                                                                                }
                                                                            }));
                                                                            (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$19, "href", credential.profileUrl));
                                                                            return _el$19;
                                                                        }
                                                                    })
                                                            }), null);
                                                            return _el$1;
                                                        })(),
                                                        (()=>{
                                                            var _el$13 = $3c1b08d4f80b521f$var$_tmpl$5();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$13, ()=>t('store.project.description'));
                                                            return _el$13;
                                                        })(),
                                                        (()=>{
                                                            var _el$14 = $3c1b08d4f80b521f$var$_tmpl$7();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$14, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c9ba532eab0ac5a8$export$d5163f1ce1e6a5f9), {
                                                                markdown: ()=>project.description,
                                                                ugc: true,
                                                                level: 2,
                                                                linkInNewTab: true
                                                            }));
                                                            return _el$14;
                                                        })(),
                                                        (()=>{
                                                            var _el$15 = $3c1b08d4f80b521f$var$_tmpl$5();
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$15, ()=>t('store.project.content'));
                                                            return _el$15;
                                                        })(),
                                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                            get each () {
                                                                return project.branches;
                                                            },
                                                            children: (branch)=>[
                                                                    (()=>{
                                                                        var _el$21 = $3c1b08d4f80b521f$var$_tmpl$1();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$21, ()=>t('store.project.branch_version')((()=>{
                                                                                var _el$24 = $3c1b08d4f80b521f$var$_tmpl$12();
                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$24, ()=>branch.title);
                                                                                return _el$24;
                                                                            })(), (()=>{
                                                                                var _el$25 = $3c1b08d4f80b521f$var$_tmpl$12();
                                                                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$25, ()=>branch.versionTitle);
                                                                                return _el$25;
                                                                            })()));
                                                                        return _el$21;
                                                                    })(),
                                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c9ba532eab0ac5a8$export$d5163f1ce1e6a5f9), {
                                                                        markdown: ()=>({
                                                                                markdown: branch.versionDescription,
                                                                                lang: project.description.lang,
                                                                                images: []
                                                                            }),
                                                                        level: 3,
                                                                        ugc: true,
                                                                        linkInNewTab: true
                                                                    }),
                                                                    (()=>{
                                                                        var _el$22 = $3c1b08d4f80b521f$var$_tmpl$10();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$22, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
                                                                            get each () {
                                                                                return branch.packages;
                                                                            },
                                                                            children: (pkg)=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($3c1b08d4f80b521f$var$StorePackage, {
                                                                                    project: project,
                                                                                    branch: branch,
                                                                                    pkg: pkg
                                                                                })
                                                                        }));
                                                                        return _el$22;
                                                                    })(),
                                                                    (()=>{
                                                                        var _el$23 = $3c1b08d4f80b521f$var$_tmpl$11();
                                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$23, ()=>t('store.project.branch_version.published')((0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$68962dbd27cd2e36), {
                                                                                get date () {
                                                                                    return new Date(branch.branchVersionPublished);
                                                                                }
                                                                            })));
                                                                        return _el$23;
                                                                    })()
                                                                ]
                                                        }),
                                                        (()=>{
                                                            var _el$16 = $3c1b08d4f80b521f$var$_tmpl$8(), _el$17 = _el$16.firstChild, _el$18 = _el$17.firstChild;
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                get when () {
                                                                    return starred() != null;
                                                                },
                                                                get children () {
                                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$353f5b6fc5456de1), {
                                                                        light: true,
                                                                        onClick: onProjectStar,
                                                                        get children () {
                                                                            return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>!!starred())() ? [
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                    star: true,
                                                                                    solid: true,
                                                                                    inline: true,
                                                                                    weak: true
                                                                                }),
                                                                                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('store.project.starred'))
                                                                            ] : [
                                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                                    star: true,
                                                                                    regular: true,
                                                                                    inline: true,
                                                                                    weak: true
                                                                                }),
                                                                                (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('store.project.star'))
                                                                            ];
                                                                        }
                                                                    });
                                                                }
                                                            }), _el$18);
                                                            (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$17, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$922a44e43c7eb891), {
                                                                get title () {
                                                                    return [
                                                                        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                                            regular: true,
                                                                            flag: true,
                                                                            inline: true,
                                                                            weak: true
                                                                        }),
                                                                        (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('report_content'))
                                                                    ];
                                                                },
                                                                get subject () {
                                                                    return `Report store project ${project.id ?? ''}`;
                                                                },
                                                                get body () {
                                                                    return `Re: store project ${project.id ?? ''}
Link: ${window.location.href}
Title: ${project.title ?? ''}
`;
                                                                }
                                                            }), null);
                                                            return _el$16;
                                                        })()
                                                    ];
                                                }
                                            },
                                            {
                                                component: (props)=>{
                                                    const branch = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>branches().get(props.route));
                                                    const packages = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>(0, $9DGpR.Map)(branch()?.packages?.map?.((pkg)=>[
                                                                pkg.id,
                                                                pkg
                                                            ])));
                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return branch();
                                                        },
                                                        keyed: true,
                                                        children: (branch)=>[
                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                                                    get title () {
                                                                        return branch.title;
                                                                    },
                                                                    breadcrumb: ()=>branch.title,
                                                                    uiClass: "store_branch"
                                                                }),
                                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                                                    routes: [
                                                                        {
                                                                            component: (props)=>{
                                                                                const pkg = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>packages().get(props.route));
                                                                                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
                                                                                    get when () {
                                                                                        return pkg();
                                                                                    },
                                                                                    keyed: true,
                                                                                    children: (pkg)=>[
                                                                                            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
                                                                                                get title () {
                                                                                                    return pkg.title;
                                                                                                },
                                                                                                breadcrumb: ()=>pkg.title,
                                                                                                uiClass: "store_package"
                                                                                            }),
                                                                                            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                                                                                                routes: [
                                                                                                    {
                                                                                                        path: 'play',
                                                                                                        component: ()=>{
                                                                                                            const [spaceUrlResource] = (0, $1f5a16020b51a07b$export$edd172c6c83c39cc)(async ()=>{
                                                                                                                const spaceUrl = new URL(await tokenlessApi.getStoreProjectsBranchesPackagesSpace({
                                                                                                                    project: project.id,
                                                                                                                    branch: branch.id,
                                                                                                                    _package: pkg.id
                                                                                                                }));
                                                                                                                spaceUrl.pathname += pkg.entrypoint.join('/');
                                                                                                                return spaceUrl.toString();
                                                                                                            });
                                                                                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1024668015f4bbf6$export$f4545b84808b8529), {
                                                                                                                spaceUrlResource: spaceUrlResource
                                                                                                            });
                                                                                                        }
                                                                                                    }
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                });
                                                                            }
                                                                        }
                                                                    ]
                                                                })
                                                            ]
                                                    });
                                                }
                                            }
                                        ]
                                    })
                                ]
                        });
                    }
                }
            ]
        })
    ];
};
const $3c1b08d4f80b521f$var$StorePackage = (props)=>{
    const { tokenlessApi: tokenlessApi } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const navigate = (0, $bcd7d00b4653a471$export$2b3a76f83deeece4)();
    const tagsInfo = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const osTags = [];
        const info = {};
        for (const tag of props.pkg.tags){
            const [tagType, tagValue] = tag.split(':');
            switch(tagType){
                case 'os':
                    osTags.push(tagValue);
                    break;
            }
        }
        if (osTags.length == 1) info.os = osTags[0];
        return info;
    });
    const actions = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const actions = [];
        if (props.pkg.tags.indexOf('os:web') >= 0) actions.push({
            title: t('packages.play'),
            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                solid: true,
                play: true,
                weak: true,
                inline: true
            }),
            onAction: ()=>{
                navigate((0, $c900760615f37aa7$export$cc14ff07bdae6b09)({
                    projectId: props.project.id,
                    branchId: props.branch.id,
                    packageId: props.pkg.id
                }));
            }
        });
        actions.push({
            title: t('packages.download_zip'),
            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                solid: true,
                "file-zipper": true,
                weak: true,
                inline: true
            }),
            onAction: ()=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                    const url = new URL(await tokenlessApi.getStoreProjectsBranchesPackagesDownload({
                        project: props.project.id,
                        branch: props.branch.id,
                        _package: props.pkg.id
                    }), (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
                    url.searchParams.set('filter', 'zip');
                    const link = document.createElement('a');
                    link.href = url.toString();
                    link.download = `${props.project.title} ${props.pkg.title}.zip`;
                    link.click();
                })
        });
        if ((0, $1ded0b9f0137d849$export$2e2bcd8739ae039).supportTorrentDownloads) actions.push({
            title: t('packages.download_torrent'),
            icon: (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                solid: true,
                magnet: true,
                weak: true,
                inline: true
            }),
            onAction: ()=>(0, $50cc9f46f1065e3e$export$7bee16e1df2fc42f)(async ()=>{
                    const url = new URL(await tokenlessApi.getStoreProjectsBranchesPackagesTorrent({
                        project: props.project.id,
                        branch: props.branch.id,
                        _package: props.pkg.id
                    }), (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).storageBaseUrl);
                    const link = document.createElement('a');
                    link.href = url.toString();
                    link.download = `${props.project.title} ${props.pkg.title}.torrent`;
                    link.click();
                })
        });
        return actions;
    });
    return (()=>{
        var _el$26 = $3c1b08d4f80b521f$var$_tmpl$13(), _el$27 = _el$26.firstChild, _el$28 = _el$27.nextSibling;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$26, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return tagsInfo().os;
            },
            get children () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), (0, $1f5a16020b51a07b$export$9d1611c77c2fe928)({
                    "fa-2xl": true
                }, ()=>(0, $9cb6667deff6c421$export$d13993e02571356d).os.options[tagsInfo().os].icon));
            }
        }), _el$27);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$26, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $9cb6667deff6c421$export$b72686b556e29ca6), {
            get tags () {
                return (0, $9DGpR.Set)(props.pkg.tags);
            },
            showIcons: false
        }), _el$27);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$26, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $710e903ece6de316$export$3ea7cc26c4f45db8), {
            get size () {
                return props.pkg.size;
            }
        }), _el$27);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$27, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$d5503927a7d116d), {
            get actions () {
                return actions();
            }
        }));
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$28, ()=>props.pkg.title);
        return _el$26;
    })();
};


var $c52b5b8976f57a16$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<h1><div class=hint>`), $c52b5b8976f57a16$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer>`), $c52b5b8976f57a16$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=title>`), $c52b5b8976f57a16$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<span class=hint>`), $c52b5b8976f57a16$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=links>`), $c52b5b8976f57a16$var$_tmpl$6 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<p>`);
const $c52b5b8976f57a16$export$13bb4f7e832053db = ()=>{
    const { status: authStatus } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return [
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$e2e9b8b5e72b52f3), {
            get title () {
                return t('home');
            },
            breadcrumb: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                    href: (0, $c900760615f37aa7$export$77c015370703bac0),
                    get children () {
                        return t('app.name');
                    }
                }),
            uiClass: "home"
        }),
        (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
            routes: [
                {
                    path: '',
                    component: ()=>[
                            (()=>{
                                var _el$ = $c52b5b8976f57a16$var$_tmpl$(), _el$2 = _el$.firstChild;
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, ()=>t(`app.name`), _el$2);
                                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$2, ()=>t('home.header.hint'));
                                return _el$;
                            })(),
                            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>(0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>authStatus() == 'authenticated')() ? (()=>{
                                    var _el$4 = $c52b5b8976f57a16$var$_tmpl$5();
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                        href: (0, $c900760615f37aa7$export$d7c176430feb555b),
                                        get children () {
                                            return [
                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                    weak: true,
                                                    inline: true,
                                                    "fa-2xl": true,
                                                    solid: true,
                                                    briefcase: true
                                                }),
                                                (()=>{
                                                    var _el$5 = $c52b5b8976f57a16$var$_tmpl$3();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$5, ()=>t('projects'));
                                                    return _el$5;
                                                })(),
                                                (()=>{
                                                    var _el$6 = $c52b5b8976f57a16$var$_tmpl$4();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, ()=>t('projects.hint'));
                                                    return _el$6;
                                                })()
                                            ];
                                        }
                                    }), null);
                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$4, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                        href: (0, $c900760615f37aa7$export$eb19b69c8e69ef41),
                                        get children () {
                                            return [
                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                    weak: true,
                                                    inline: true,
                                                    "fa-2xl": true,
                                                    solid: true,
                                                    "id-card": true
                                                }),
                                                (()=>{
                                                    var _el$7 = $c52b5b8976f57a16$var$_tmpl$3();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, ()=>t('me'));
                                                    return _el$7;
                                                })(),
                                                (()=>{
                                                    var _el$8 = $c52b5b8976f57a16$var$_tmpl$4();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, ()=>t('me.hint'));
                                                    return _el$8;
                                                })()
                                            ];
                                        }
                                    }), null);
                                    return _el$4;
                                })() : [
                                    (()=>{
                                        var _el$9 = $c52b5b8976f57a16$var$_tmpl$6();
                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$9, ()=>t('home.description'));
                                        return _el$9;
                                    })(),
                                    (()=>{
                                        var _el$0 = $c52b5b8976f57a16$var$_tmpl$5();
                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                                            href: (0, $c900760615f37aa7$export$d7c176430feb555b),
                                            get children () {
                                                return [
                                                    (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                                        weak: true,
                                                        inline: true,
                                                        "fa-2xl": true,
                                                        solid: true,
                                                        "id-card": true
                                                    }),
                                                    (()=>{
                                                        var _el$1 = $c52b5b8976f57a16$var$_tmpl$3();
                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, ()=>t('home.auth'));
                                                        return _el$1;
                                                    })(),
                                                    (()=>{
                                                        var _el$10 = $c52b5b8976f57a16$var$_tmpl$4();
                                                        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$10, ()=>t('home.auth.hint'));
                                                        return _el$10;
                                                    })()
                                                ];
                                            }
                                        }));
                                        return _el$0;
                                    })()
                                ]),
                            $c52b5b8976f57a16$var$_tmpl$2()
                        ]
                },
                {
                    path: 'projects',
                    component: (0, $58b7e17de267e8d7$export$e281e188db3065f7)
                },
                {
                    path: 'store',
                    component: (0, $3c1b08d4f80b521f$export$cf376cbc7f8478ea)
                },
                {
                    path: 'me',
                    component: (0, $c5a8c0c33bb04031$export$36fd7346460dab4b)
                },
                {
                    path: 'invite',
                    component: (0, $bd526e86fe658bf8$export$5d496d0c210dc288)
                },
                {
                    path: 'local',
                    component: (0, $03b25ed780fb341f$export$48fa16f53f83b086)
                },
                {
                    // sha256 of 'admin'
                    path: '8c6976e5b5410415bde908bd4dee15dfb167a9c873fc4bb8a81f6f2ab448a918',
                    component: (0, $f76c1440e65621fa$export$28a9d9f228b717af)
                },
                {
                    path: 'experiment',
                    component: (0, $0d03c01d318066a5$export$817f10b3675cea1a)
                },
                {
                    component: (0, $06e3e498f7096fae$export$a65c2c055de52e1d)
                }
            ]
        })
    ];
};



var $cc9d09a6f2edbadb$var$_tmpl$ = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=main>`), $cc9d09a6f2edbadb$var$_tmpl$2 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="buttons session">`), $cc9d09a6f2edbadb$var$_tmpl$3 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class="sheet medium"><div class=logo></div><div class=ui><div class=header><div class=breadcrumbs-and-profile></div></div></div><div>`), $cc9d09a6f2edbadb$var$_tmpl$4 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<div class=footer_panel><div class="buttons group"></div><div class=social_links><div><a>`), $cc9d09a6f2edbadb$var$_tmpl$5 = /*#__PURE__*/ (0, $fb40d00dea10da1a$export$ce69bd05624d0c48)(`<a target=_blank>`);
const $cc9d09a6f2edbadb$var$App = ()=>{
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $14e578934f51f0ba$export$d8964aec282183a3), {
        defaultTheme: "system",
        themes: [
            'system',
            'light',
            'dark',
            'sakura'
        ],
        get children () {
            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c39c8727de0f5841$export$dc45bdc734ce6f1e), {
                dicts: $518d93d75c395371$exports,
                defaultLang: "en",
                get children () {
                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $77ea5bac57ec8af2$export$87091915187a1a85), {
                        get children () {
                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $30026173677b80c4$export$316129f71809f34b), {
                                get children () {
                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$55185c17a0fcbe46), {
                                        get children () {
                                            return [
                                                (()=>{
                                                    var _el$ = $cc9d09a6f2edbadb$var$_tmpl$();
                                                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($cc9d09a6f2edbadb$var$AppOauth, {
                                                        get children () {
                                                            return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($cc9d09a6f2edbadb$var$AppAuth, {
                                                                get children () {
                                                                    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($cc9d09a6f2edbadb$var$AppSheet, {});
                                                                }
                                                            });
                                                        }
                                                    }));
                                                    return _el$;
                                                })(),
                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($cc9d09a6f2edbadb$var$FooterPanel, {}),
                                                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$c55ecd8d9a40564), {})
                                            ];
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
    });
};
const $cc9d09a6f2edbadb$var$AppOauth = (props)=>{
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
        routes: [
            {
                path: 'oauth',
                component: ()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$3565eb3d00ca5a74), {
                        routes: [
                            {
                                component: (0, $6b2909ffdda1a1a0$export$c458c52872d01820)
                            }
                        ]
                    })
            }
        ],
        fallback: ()=>props.children
    });
};
const $cc9d09a6f2edbadb$var$AppAuth = (props)=>{
    const { status: authStatus, authRequired: authRequired } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$b5d5cf8927ab7262), {
        get children () {
            return [
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                    get when () {
                        return (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>authStatus() == 'not_authenticated')() && authRequired();
                    },
                    get children () {
                        return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $6b2909ffdda1a1a0$export$1ac09da1b8c1fc69), {});
                    }
                }),
                (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f421feb8fad20413), {
                    when: true,
                    get children () {
                        return props.children;
                    }
                })
            ];
        }
    });
};
const $cc9d09a6f2edbadb$var$AppSheet = ()=>{
    const { t: t } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    const { session: session, cancelAuth: cancelAuth } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $77ea5bac57ec8af2$export$a0fd8390cfe8ae69));
    const { connected: connected } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $30026173677b80c4$export$ecd60d42f6b10f45));
    const context = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $bcd7d00b4653a471$export$6211eac7eca08002));
    const currentPage = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>context.hierarchy().last());
    const navigate = (0, $bcd7d00b4653a471$export$2b3a76f83deeece4)();
    const breadcrumbs = (0, $1f5a16020b51a07b$export$c0c6c8b9c16bf6aa)(()=>{
        const breadcrumbs = context.hierarchy().toArray();
        let j = 0;
        for(let i = 0; i < breadcrumbs.length; ++i){
            const breadcrumb = breadcrumbs[i];
            if (breadcrumb.breadcrumb == undefined) continue;
            if (breadcrumb.breadcrumbRoot) j = 0;
            if (j < i) breadcrumbs[j] = breadcrumb;
            ++j;
        }
        return breadcrumbs.slice(0, j);
    });
    const onHeaderMenu = (key)=>{
        switch(key){
            case 'profile':
                navigate('/me');
                break;
            case 'logout':
                cancelAuth();
                break;
        }
    };
    let metaDescription;
    (0, $1f5a16020b51a07b$export$1e848a9e87980bd5)(()=>{
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.append(metaDescription);
    });
    (0, $1f5a16020b51a07b$export$b36e5eaa3e8c43ab)(()=>{
        metaDescription?.remove();
    });
    (0, $1f5a16020b51a07b$export$7ea7134f704deda4)(()=>{
        const pageTitle = currentPage()?.title();
        const appTitle = pageTitle ? t('app.title')(pageTitle) : t('app.name');
        document.querySelector('title').innerText = appTitle;
        metaDescription.content = appTitle;
    });
    return (()=>{
        var _el$2 = $cc9d09a6f2edbadb$var$_tmpl$3(), _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling, _el$5 = _el$4.firstChild, _el$6 = _el$5.firstChild, _el$8 = _el$4.nextSibling;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $06e3e498f7096fae$export$2dc68d50d56fbbd), {
            get breadcrumbs () {
                return breadcrumbs().map((info)=>info.breadcrumb).filter((breadcrumb)=>!!breadcrumb);
            }
        }), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return connected();
            },
            get children () {
                return (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $bcd7d00b4653a471$export$a6c7ac8248d6e38a), {
                    "class": "local_app",
                    href: (0, $c900760615f37aa7$export$da49eb7703ea1c9c),
                    get children () {
                        return [
                            (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$8b29a4b6778bf7f), {
                                regular: true,
                                "hard-drive": true,
                                inline: true,
                                weak: true
                            }),
                            (0, $fb40d00dea10da1a$export$7c73462e0d25e514)(()=>t('local_app.detected'))
                        ];
                    }
                });
            }
        }), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$6, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$f6a3d19be20f5819), {
            get when () {
                return session()?.userInfo;
            },
            get children () {
                var _el$7 = $cc9d09a6f2edbadb$var$_tmpl$2();
                (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$7, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $e19c4daa2d9c3184$export$931cbfb6bfb85fc), {
                    classList: {
                        align_end: true
                    },
                    get title () {
                        return session()?.userInfo?.title;
                    },
                    get items () {
                        return [
                            {
                                key: 'profile',
                                title: t('user.profile')
                            },
                            {
                                key: 'logout',
                                title: t('user.logout')
                            }
                        ];
                    },
                    onSelect: onHeaderMenu,
                    alignEnd: true
                }));
                return _el$7;
            }
        }), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$8, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c52b5b8976f57a16$export$13bb4f7e832053db), {}));
        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$2913c0c0b5623090)(_el$8, `ui ${currentPage()?.uiClass ?? ''}`));
        return _el$2;
    })();
};
const $cc9d09a6f2edbadb$var$FooterPanel = ()=>{
    const { t: t, lang: lang } = (0, $1f5a16020b51a07b$export$fae74005e78b1a27)((0, $c39c8727de0f5841$export$51216bcc3983e55d));
    return (()=>{
        var _el$9 = $cc9d09a6f2edbadb$var$_tmpl$4(), _el$0 = _el$9.firstChild, _el$1 = _el$0.nextSibling, _el$10 = _el$1.firstChild, _el$11 = _el$10.firstChild;
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $14e578934f51f0ba$export$17c20d206da56716), {}), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$0, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $c39c8727de0f5841$export$41d20194bebed95c), {}), null);
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$11, ()=>t('docs'));
        (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$1, (0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)((0, $1f5a16020b51a07b$export$bdf530073099ce9f), {
            get each () {
                return (0, $1ded0b9f0137d849$export$2e2bcd8739ae039).socialLinks;
            },
            children: (socialLink)=>(()=>{
                    var _el$12 = $cc9d09a6f2edbadb$var$_tmpl$5();
                    (0, $fb40d00dea10da1a$export$21a5ca8aa77d35ff)(_el$12, ()=>t(`social_links.${socialLink.title}`));
                    (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$12, "href", socialLink.link));
                    return _el$12;
                })()
        }), null);
        (0, $1f5a16020b51a07b$export$314dade334ae905d)(()=>(0, $fb40d00dea10da1a$export$9fec4d97f1922e0b)(_el$11, "href", (0, $c900760615f37aa7$export$71079348ad5e9a97)(lang())));
        return _el$9;
    })();
};
(0, $fb40d00dea10da1a$export$b3890eb0ae9dca99)(()=>(0, $1f5a16020b51a07b$export$60e54eaca7e7fb38)($cc9d09a6f2edbadb$var$App, {}), document.body);


//# sourceMappingURL=app.ecbb8ae0.js.map
